webpackJsonp([1],{

/***/ "++vR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("6oYg");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_96d5104c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__ = __webpack_require__("l9Ai");
function injectStyle (ssrContext) {
  __webpack_require__("W5fU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96d5104c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_96d5104c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "+/Rg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomFormTable_vue__ = __webpack_require__("+1ZY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fc4754_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomFormTable_vue__ = __webpack_require__("bU4Q");
function injectStyle (ssrContext) {
  __webpack_require__("xohN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17fc4754"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomFormTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17fc4754_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomFormTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("RpXe")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+1ZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CustomForm__ = __webpack_require__("g0qw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CustomFormTable',
    props: {
        initialData: {
            type: Object,
            default: function _default() {
                return {
                    items: [],
                    fields: []
                };
            }
        },
        routeParams: {
            type: Object,
            default: function _default() {
                return {
                    site_id: null,
                    form_type: null
                };
            }
        },
        isEditable: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    data: function data() {
        return {
            tempItem: {}, // Temporary object used for inserts
            formSchema: [],
            tableCols: [],
            tableData: [],
            emptyFields: [],
            fields: [], // table headers
            items: [], // includes some info to show on cells
            isLoaded: false, // Toggles page loading,
            municipalityDisabled: 0,
            recoveryDisabled: 0,
            wasteDescriptions: [],
            wasteTypes: [],
            wasteStorages: [],
            formData: {},
            insertMode: false,
            lastColumnWidth: '130px',
            name: null,
            tableId: __WEBPACK_IMPORTED_MODULE_0_uuid_v4___default()()
        };
    },

    components: {
        CustomForm: __WEBPACK_IMPORTED_MODULE_3__CustomForm__["a" /* default */]
    },
    methods: {
        setWasteDescriptions: function setWasteDescriptions(val, item) {
            item.description.editedValue = val;
            var id = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteDescriptions, function (o) {
                return o.value === val;
            }).id;
            // this switch sets all table values according to waste description.
            switch (id) {
                case 0:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 0;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 0;
                    }).value;
                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = null;
                    break;
                case 1:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 0;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 1;
                    }).value;

                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = null;
                    break;

                case 2:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 1;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 2;
                    }).value;

                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 1;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = '-';
                    break;
                case 3:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 2;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 3;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Belediye/ Sağlık Kuruluşu/ Lisanslı Bertaraf Firması';
                    break;
                case 4:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 3;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 4;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Lisanslı Bertaraf Firması';
                    break;
                case 5:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 3;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 5;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Üretici firma(HP) - Anel Doğa';
                    break;
                case 6:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 3;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 6;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Üretici Firma - TAP';
                    break;
                case 7:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 4;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 7;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Garanti Teknoloji / Lisanslı Geri Dönüşüm Firması';
                    break;
                case 8:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 3;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 8;
                    }).value;

                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Sözleşmeli bakım firmaları';
                    break;
                case 9:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 4;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 9;
                    }).value;
                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Sözleşmeli bakım firmaları';
                    break;
                case 10:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 4;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 10;
                    }).value;
                    this.municipalityDisabled = 1;
                    this.recoveryDisabled = 0;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = '-';
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = 'Sözleşmeli bakım firmaları';
                    break;
                case 11:
                    item.wasteType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteTypes, function (o) {
                        return o.id === 5;
                    }).value;

                    item.storageType[this.insertMode ? 'value' : 'editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.wasteStorages, function (o) {
                        return o.id === 11;
                    }).value;
                    this.municipalityDisabled = 0;
                    this.recoveryDisabled = 1;

                    item.municipality[this.insertMode ? 'value' : 'editedValue'] = null;
                    item.recovery[this.insertMode ? 'value' : 'editedValue'] = '-';
                    break;
            }
            if (this.insertMode) {
                this.tempItem = item;
            }
        },
        setWasteTypes: function setWasteTypes(val, item) {
            item.wasteType.value = val;
        },
        setWasteStorages: function setWasteStorages(val, item) {
            item.storageType.value = val;
        },
        onformChange: function onformChange(formData) {
            this.formData = formData;
        },

        // Revert any changes made on an item
        revertChanges: function revertChanges(item) {
            var _this = this;

            this.fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'date') {
                        item[field.key].editedValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item[field.key].value).toDate();
                        // TODO: Make this work for currencies other than Turkish
                        // Also put it in its own function
                    } else if (field.type === 'daterange') {
                        item[field.key].editedValue = [__WEBPACK_IMPORTED_MODULE_1_moment___default()(item[field.key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_1_moment___default()(item[field.key].value[1]).toDate()];
                    } else if (field.type === 'number') {
                        item[field.key].editedValue = item[field.key].value;
                    } else if (field.type === 'float' || field.type === 'number') {
                        item[field.key].editedValue = _this.convertToLocalizedFloat(item[field.key].value, _this.locale);
                    } else if (field.type === 'file') {
                        item[field.key].editedFileId = item[field.key].fileId;
                    } else {
                        item[field.key].editedValue = item[field.key].value;
                    }
                }
            });
            item.editMode = false;
        },
        insertRow: function insertRow() {
            this.insertMode = true;
            this.items.forEach(function (item) {
                item.editMode = false;
            });
            this.bindTempItemToView();
        },
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        makeRowEditable: function makeRowEditable(item) {
            this.items.forEach(this.revertChanges);
            this.insertMode = false;
            item.editMode = true;
        },
        bindTempItemToView: function bindTempItemToView() {
            var _this2 = this;

            this.tempItem = {};
            this.fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'file') {
                        _this2.$set(_this2.tempItem, field.key, {
                            filename: null,
                            fileUrl: null,
                            fileId: null
                        });
                    } else {
                        var defaultValue = null;
                        if (field.type === 'date' || field.type === 'daterange') {
                            defaultValue = _this2.setDefaultDateTypedValue(field.type, field.key);
                        } else if (field.type === 'select') {
                            defaultValue = _this2.setDefaultSelectTypedValue(field.key);
                        }
                        _this2.$set(_this2.tempItem, field.key, {
                            value: field.type === 'select' ? defaultValue : null,
                            defaultValue: defaultValue,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                            hasWarn: false,
                            required: field.required
                        });
                    }
                }
            });
        },

        // Insert new item
        createItem: function createItem(item) {
            var _this3 = this;

            if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(item.description.value) && !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(item.description.storageType) && !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNull(item.description.wasteType)) {
                this.$emit('insertItem', item, function (data) {
                    _this3.insertMode = false;
                    _this3.items.push(_this3.prepareItem(data));
                    _this3.bindTempItemToView();
                    _this3.calculateLastColumnWidth();
                });
            } else {
                this.showErrorNotification(this.$t('wasteDescriptionEmptyError'));
            }
        },
        updateItem: function updateItem(item, fields) {
            var _this4 = this;

            this.$emit('applyDataChanges', item, fields, function (data) {
                var updatedItem = _this4.prepareItem(data);
                for (var key in item) {
                    item[key] = updatedItem[key];
                }
                item.editMode = false;
            });
        },


        // Delete an item
        deleteItem: function deleteItem($event, id) {
            var _this5 = this;

            this.showWarnModal($event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this5.$emit('deleteItemById', id);
                _this5.items = _this5.items.filter(function (item) {
                    return item.id !== id;
                });
            });
        },

        // Prepare a dataType object to use in dom
        prepareItem: function prepareItem(row) {
            var generated = {};
            for (var key in row) {
                var foundField = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.fields, { key: key });
                if (foundField) {
                    generated[key] = {
                        value: row[key]
                    };
                    if (this.isEditable) {
                        if (foundField.type === 'daterange') {
                            generated[key].editedValue = [__WEBPACK_IMPORTED_MODULE_1_moment___default()(generated[key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_1_moment___default()(generated[key].value[1]).toDate()];
                            // TODO: Make this work for currencies other than Turkish
                            // Also put it in its own function
                        } else if (foundField.type === 'date') {
                            generated[key].editedValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(generated[key].value).toDate();
                        } else if (foundField.type === 'number') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'float' || foundField.type === 'number') {
                            generated[key].value = generated[key].value.toFixed(2);
                            generated[key].editedValue = this.convertToLocalizedFloat(generated[key].value, this.locale);
                        } else if (foundField.type === 'link') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'file') {
                            generated[key].fileId = row[key].fileId;
                            generated[key].editedFileId = generated[key].fileId;
                            generated[key].fileUrl = row[key].fileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl;
                            generated[key].filename = row[key].filename;
                            generated[key].editedFilename = generated[key].filename;
                        } else if (foundField.type === 'select') {
                            generated[key].editedValue = generated[key].value;
                        } else {
                            generated[key].editedValue = generated[key].value;
                        }

                        /*generated[key].classes = {
                            'form-control':
                                foundField.type !== 'date' && foundField.type !== 'daterange',
                            'is-invalid': false
                        };
                        generated[key].hasWarn = false;
                        generated[key].required = foundField.required;
                        */
                    }
                }
            }

            generated.editMode = false;
            generated.id = row.id;
            generated.path = row.path;

            return generated;
        },
        fetchDesign: function fetchDesign() {
            this.tableCols = this.initialData.fields;
            this.tableData = this.initialData.items;
            return this.initialData;
        },
        routeTo: function routeTo(item) {
            if (!this.isEditable) {
                this.$router.push({ path: item.path });
            }
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this6 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('waste-form-last-column');
                if (element) {
                    _this6.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init: function init() {
            var _this7 = this;

            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            this.fields = fields;
            this.items = items.map(this.prepareItem);
            this.isLoaded = false;
            var filteredData = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.initialData.fields, 'data');

            var _loop = function _loop(i) {
                var tempId = 0;
                filteredData[i].forEach(function (element) {
                    var tempObject = {};
                    if (i == 0) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        _this7.wasteDescriptions.push(tempObject);
                        tempId++;
                    } else if (i == 1) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        _this7.wasteTypes.push(tempObject);
                        tempId++;
                    } else if (i == 2) {
                        tempObject.id = tempId;
                        tempObject.value = element;
                        tempObject.text = element;
                        _this7.wasteStorages.push(tempObject);
                        tempId++;
                    }
                });
            };

            for (var i = 0; i < 3; i++) {
                _loop(i);
            }
            this.wasteDescriptions = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(this.wasteDescriptions, 'id');
            this.wasteTypes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(this.wasteTypes, 'id');
            this.wasteStorages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqBy(this.wasteStorages, 'id');
            this.fetchDesign();
            this.isLoaded = true;
        }
    },
    watch: {
        initialData: function initialData() {
            var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.init(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newVal.items), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newVal.fields));
        }
    },
    created: function created() {
        window.addEventListener('resize', this.calculateLastColumnWidth);
        this.init(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.initialData.items), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.initialData.fields));
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "+3a/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+9UU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICA8cGF0aCBpZD0iYWRkIiBkPSJNMTAuNSwwQTEwLjUsMTAuNSwwLDEsMCwyMSwxMC41LDEwLjUsMTAuNSwwLDAsMCwxMC41LDBabTYuMTI0LDExLjM3NGEuODcyLjg3MiwwLDAsMS0uODc0Ljg3NGgtMy41djMuNWEuODcyLjg3MiwwLDAsMS0uODc0Ljg3NEg5LjYyNmEuODc0Ljg3NCwwLDAsMS0uODc0LS44NzR2LTMuNUg1LjI1YS44NzQuODc0LDAsMCwxLS44NzQtLjg3NFY5LjYyNmEuODcyLjg3MiwwLDAsMSwuODc0LS44NzRoMy41VjUuMjVhLjg3Mi44NzIsMCwwLDEsLjg3NC0uODc0aDEuNzUxYS44NzQuODc0LDAsMCwxLC44NzQuODc0djMuNWgzLjVhLjg3NC44NzQsMCwwLDEsLjg3NC44NzR2MS43NTFaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+GQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',[_c('b-card',{attrs:{"id":"card"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-btn',{staticStyle:{"margin-right":"30px"},on:{"click":_vm.exportPDF}},[_c('i',{staticClass:"fas fa-file-pdf"})])],1),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('div',{staticStyle:{"font-weight":"bold","margin-top":"10px"}},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_vm._v(" "),_c('custom-form',{staticStyle:{"margin-top":"30px"},attrs:{"isEditable":false,"schema":_vm.formSchema,"data":_vm.formData}}),_vm._v(" "),_c('custom-table',{staticStyle:{"margin-top":"60px","margin-bottom":"60px"},attrs:{"isEditable":false,"initialData":{items: _vm.tableData, fields: _vm.tableCols}}})],1)],1)],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+LLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"background-color":"white"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"float-left mt-1",staticStyle:{"font-weight":"bold","text-align":"center","font-size":"1.2em"},attrs:{"cols":"3","sm":"3"}},[_c('div',{staticStyle:{"position":"relative","width":"70px"}},[_c('span',{staticClass:"float-left",staticStyle:{"font-size":"1.4em"}},[_vm._v(_vm._s(_vm.$t('sitesTitle')))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em","color":"#868e96","position":"absolute","margin":"10px 2px"}},[_vm._v("("+_vm._s(_vm.filteredItems.length)+")")])])]),_vm._v(" "),_c('b-col',[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',[_c('b-form-checkbox',{attrs:{"value":"1","unchecked-value":"0"},model:{value:(_vm.selectedNoAgent),callback:function ($$v) {_vm.selectedNoAgent=$$v},expression:"selectedNoAgent"}},[_c('b',[_vm._v(_vm._s(_vm.$t('sitesWithoutAgents')))])])],1),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticClass:"gray-select",attrs:{"options":_vm.regions,"text-field":"display_name","value-field":"id"},model:{value:(_vm.selectedRegionId),callback:function ($$v) {_vm.selectedRegionId=$$v},expression:"selectedRegionId"}})],1),_vm._v(" "),_c('b-col',{staticClass:"placeholder-color-white"},[_c('b-form-input',{staticClass:"gray-input",attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container-card table-responsive"},[_c('table',{staticClass:"table table-hover mt-2",staticStyle:{"table-layout":"fixed","font-size":"0.875em","margin-bottom":"0"}},[_c('tbody',_vm._l((_vm.filteredItems),function(filteredItem){return _c('tr',[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeTo(filteredItem)}}},[_vm._v(_vm._s(filteredItem.name))])])}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+c8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("Cyey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb30dfec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("WA6h");
function injectStyle (ssrContext) {
  __webpack_require__("sBVj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb30dfec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb30dfec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("mTBr")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+jyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__ = __webpack_require__("GH5M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99b4baa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__("2sK9");
function injectStyle (ssrContext) {
  __webpack_require__("zqMR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99b4baa8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99b4baa8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+ol3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Library_vue__ = __webpack_require__("smBy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ce13b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Library_vue__ = __webpack_require__("/zk0");
function injectStyle (ssrContext) {
  __webpack_require__("kz7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Library_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86ce13b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Library_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("fIEE")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+psP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"createAudit",attrs:{"id":"createAudit","size":"lg","top":"","title":_vm.postTitle},on:{"hide":_vm.onHide,"show":_vm.onShow}},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"4"}},[_vm._v("\n            "+_vm._s(this.$t('auditType'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticStyle:{"height":"35px"},model:{value:(_vm.audit.type),callback:function ($$v) {_vm.$set(_vm.audit, "type", $$v)},expression:"audit.type"}},_vm._l((_vm.getAuditTypes()),function(dataType){return _c('option',{key:dataType.type,domProps:{"value":dataType.type}},[_vm._v(_vm._s(dataType.displayName))])}),0)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"10px"},attrs:{"md":"4"}},[_vm._v("\n            "+_vm._s(this.$t('auditDate'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"date","format":"dd/MM/yyyy"},model:{value:(_vm.audit.date),callback:function ($$v) {_vm.$set(_vm.audit, "date", $$v)},expression:"audit.date"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"10px"}},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"4"}},[_vm._v("\n            "+_vm._s(this.$t('branch'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('multiselect',{class:{'is-invalid': _vm.errors.sites},attrs:{"disabled":this.$store.state.modal.payload.editType==='update'||this.$store.state.modal.payload.editType==='createDetail',"multiple":true,"options":_vm.$store.state.sites,"close-on-select":true,"showLabels":false,"placeholder":_vm.$t('choose'),"label":"name","track-by":"id"},nativeOn:{"focus":function($event){_vm.errors.branches = false}},model:{value:(_vm.audit.branches),callback:function ($$v) {_vm.$set(_vm.audit, "branches", $$v)},expression:"audit.branches"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"15px"}},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":this.gbId(this.$store.state.user.customerId) ? 4 : 2}},[_vm._v("\n            "+_vm._s(this.$t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{class:{'is-invalid': _vm.errors.text},staticStyle:{"height":"35px","margin-top":"-5px"},attrs:{"placeholder":this.$t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title'),"value":_vm.audit?_vm.audit.title:null},nativeOn:{"focus":function($event){_vm.errors.text = false}},model:{value:(_vm.audit.title),callback:function ($$v) {_vm.$set(_vm.audit, "title", $$v)},expression:"audit.title"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('additionalFiles')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{attrs:{"align-h":"start","no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"1","align-h":"start","no-gutters":""}},[_c('upload-regular',{attrs:{"fileCategory":"audit-record"},on:{"onupload":_vm.onupload}})],1),_vm._v(" "),(_vm.audit.files)?[_vm._l((_vm.audit.files),function(file,index){return [_c('b-col',{key:("upload-" + index),attrs:{"cols":"1"}},[_c('upload',{attrs:{"fileCategory":"audit-record","showUpload":false,"showDownload":false,"reactive-id":(_vm.reactiveId + "-" + (file.uuid) + "-" + index),"deleteFromDB":true,"dataId":file.id},on:{"onremove":function($event){return _vm.onRemove(file)}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v(_vm._s(_vm._f("textToShortText")(file.filename)))])],1)]})]:_vm._e()],2)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){_vm.type === 'update' ? _vm.update() : _vm.insert()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"Danger"},on:{"click":function($event){return _vm.closeModal(true)}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+s3s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BreedingRhombusSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 150
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'breeding-rhombus-spinner-animation-child',
      rhombusesNum: 8
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.size / 7.5 + 'px',
        width: this.size / 7.5 + 'px',
        animationDuration: this.animationDuration + 'ms',
        top: this.size / 2.3077 + 'px',
        left: this.size / 2.3077 + 'px',
        backgroundColor: this.color
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        rhombusesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * (i + 1) + 'ms'
        }, this.rhombusStyle));
      }

      return rhombusesStyles;
    },
    bigRhombusStyle: function bigRhombusStyle() {
      return {
        height: this.size / 3 + 'px',
        width: this.size / 3 + 'px',
        animationDuration: '' + this.animationDuration,
        top: this.size / 3 + 'px',
        left: this.size / 3 + 'px',
        backgroundColor: this.color
      };
    }
  }

});

/***/ }),

/***/ "+xba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'ADANA',
    code: '1'
}, {
    name: 'ADIYAMAN',
    code: '2'
}, {
    name: 'AFYON',
    code: '3'
}, {
    name: 'AĞRI',
    code: '4'
}, {
    name: 'AMASYA',
    code: '5'
}, {
    name: 'ANKARA',
    code: '6'
}, {
    name: 'ANTALYA',
    code: '7'
}, {
    name: 'ARTVİN',
    code: '8'
}, {
    name: 'AYDIN',
    code: '9'
}, {
    name: 'BALIKESİR',
    code: '10'
}, {
    name: 'BİLECİK',
    code: '11'
}, {
    name: 'BİNGÖL',
    code: '12'
}, {
    name: 'BİTLİS',
    code: '13'
}, {
    name: 'BOLU',
    code: '14'
}, {
    name: 'BURDUR',
    code: '15'
}, {
    name: 'BURSA',
    code: '16'
}, {
    name: 'ÇANAKKALE',
    code: '17'
}, {
    name: 'ÇANKIRI',
    code: '18'
}, {
    name: 'ÇORUM',
    code: '19'
}, {
    name: 'DENİZLİ',
    code: '20'
}, {
    name: 'DİYARBAKIR',
    code: '21'
}, {
    name: 'EDİRNE',
    code: '22'
}, {
    name: 'ELAZIĞ',
    code: '23'
}, {
    name: 'ERZİNCAN',
    code: '24'
}, {
    name: 'ERZURUM',
    code: '25'
}, {
    name: 'ESKİŞEHİR',
    code: '26'
}, {
    name: 'GAZİANTEP',
    code: '27'
}, {
    name: 'GİRESUN',
    code: '28'
}, {
    name: 'GÜMÜŞHANE',
    code: '29'
}, {
    name: 'HAKKARİ',
    code: '30'
}, {
    name: 'HATAY',
    code: '31'
}, {
    name: 'ISPARTA',
    code: '32'
}, {
    name: 'İÇEL',
    code: '33'
}, {
    name: 'İSTANBUL',
    code: '34'
}, {
    name: 'İZMİR',
    code: '35'
}, {
    name: 'KARS',
    code: '36'
}, {
    name: 'KASTAMONU',
    code: '37'
}, {
    name: 'KAYSERİ',
    code: '38'
}, {
    name: 'KIRKLARE',
    code: '39'
}, {
    name: 'KIRŞEHİR',
    code: '40'
}, {
    name: 'KOCAELİ',
    code: '41'
}, {
    name: 'K.MARAŞ',
    code: '46'
}, {
    name: 'KONYA',
    code: '42 '
}, {
    name: 'KÜTAHYA',
    code: '43'
}, {
    name: 'MALATYA',
    code: '44'
}, {
    name: 'MANİSA',
    code: '45'
}, {
    name: 'MARDİN',
    code: '47'
}, {
    name: 'MUĞLA',
    code: '48'
}, {
    name: 'MUŞ',
    code: '49'
}, {
    name: 'NEVŞEHİR',
    code: '50'
}, {
    name: 'NİĞDE',
    code: '51'
}, {
    name: 'ORDU',
    code: '52'
}, {
    name: 'RİZE',
    code: '53'
}, {
    name: 'SAKARYA',
    code: '54'
}, {
    name: 'SAMSUN',
    code: '55'
}, {
    name: 'SİİRT',
    code: '56'
}, {
    name: 'SİNOP',
    code: '57'
}, {
    name: 'SİVAS',
    code: '58'
}, {
    name: 'TEKİRDAĞ',
    code: '59'
}, {
    name: 'TOKAT',
    code: '60'
}, {
    name: 'TRABZON',
    code: '61'
}, {
    name: 'TUNCELİ',
    code: '62'
}, {
    name: 'ŞANLIURFA',
    code: '63'
}, {
    name: 'UŞAK',
    code: '64'
}, {
    name: 'VAN',
    code: '65'
}, {
    name: 'YOZGAT',
    code: '66'
}, {
    name: 'ZONGULDAK',
    code: '67'
}, {
    name: 'AKSARAY',
    code: '68'
}, {
    name: 'BAYBURT',
    code: '69'
}, {
    name: 'KARAMAN',
    code: '70'
}, {
    name: 'KIRIKKALE',
    code: '71'
}, {
    name: 'BATMAN',
    code: '72'
}, {
    name: 'ŞIRNAK',
    code: '73'
}, {
    name: 'BARTIN',
    code: '74'
}, {
    name: 'ARDAHAN',
    code: '75'
}, {
    name: 'IĞDIR',
    code: '76'
}, {
    name: 'YALOVA',
    code: '77'
}, {
    name: 'KARABÜK',
    code: '78'
}, {
    name: 'KİLİS',
    code: '79'
}, {
    name: 'OSMANİYE',
    code: '80'
}, {
    name: 'DÜZCE',
    code: '81'
}, {
    name: 'Abu Dhabi',
    code: 'Abu Dhabi'
}, {
    name: 'Al Ain',
    code: 'Al Ain'
}, {
    name: 'Adh Dhafrah',
    code: 'Adh Dhafrah'
}]);

/***/ }),

/***/ "/0vs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Cm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded && _vm.selectedSite)?_c('b-card',[_c('b-row',{staticStyle:{"text-align":"center"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"mb-4",staticStyle:{"display":"flex","justify-content":"flex-start","height":"40px"},attrs:{"cols":"6"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.selectedSite.id, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name)+" - "+_vm._s(_vm.$t('title')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{staticStyle:{"height":"40px"},attrs:{"align-h":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true},on:{"oninput":_vm.selectSiteId}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px"}},[_c('b-modal',{ref:"documentModal",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""},on:{"hide":_vm.onModalHide}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                    "+_vm._s(_vm.$t('folder'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[(_vm.isSupervisor)?_c('b-col',[_c('b-form-select',{attrs:{"cols":"6"},model:{value:(_vm.selectedFolderId),callback:function ($$v) {_vm.selectedFolderId=$$v},expression:"selectedFolderId"}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('new')))]),_vm._v(" "),_vm._l((_vm.folders),function(folder){return _c('option',{key:'agentOptions'+ folder.id,domProps:{"value":folder.id}},[_vm._v(_vm._s(folder.name))])})],2)],1):_c('b-col',[_c('b-form-select',{attrs:{"cols":"6"},model:{value:(_vm.selectedExistingFolderId),callback:function ($$v) {_vm.selectedExistingFolderId=$$v},expression:"selectedExistingFolderId"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v("Bir klasör seçin")]),_vm._v(" "),_vm._l((_vm.folders),function(folder){return _c('option',{key:'supervisorOptions'+ folder.id,domProps:{"value":folder.id}},[_vm._v(_vm._s(folder.name))])})],2)],1)],1),_vm._v(" "),(!_vm.selectedFolderId && _vm.isSupervisor)?_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                    "+_vm._s(_vm.$t('folderName'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.selectedFolderId && _vm.isSupervisor)?_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-input',{model:{value:(_vm.folderName),callback:function ($$v) {_vm.folderName=$$v},expression:"folderName"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[(_vm.uploadedFile)?_c('b-col',{staticStyle:{"text-align":"start"}},[_c('upload',{attrs:{"showUpload":false,"showDownload":false,"reactive-id":_vm.reactiveId,"deleteFromDB":true,"dataId":_vm.uploadedFile.id},on:{"onremove":_vm.handleRemoving}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm._f("textToShortText")(_vm.uploadedFile.filename)))])],1):_c('b-col',{staticStyle:{"text-align":"start"}},[_c('upload-regular',{on:{"onupload":_vm.onupload}})],1)],1),_vm._v(" "),(_vm.uploadedFile)?_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                    "+_vm._s(_vm.$t('documentDate'))+"\n                ")])],1):_vm._e(),_vm._v(" "),(_vm.uploadedFile)?_c('b-row',{staticClass:"mt-1"},[_c('b-col',[(this.gbId(this.$store.state.user.customerId))?[_c('el-date-picker',{attrs:{"type":"year","placeholder":_vm.$t('chooseDatePlaceholder')},model:{value:(_vm.fileDate),callback:function ($$v) {_vm.fileDate=$$v},expression:"fileDate"}})]:[_c('el-date-picker',{attrs:{"type":"month","placeholder":_vm.$t('chooseDatePlaceholder')},model:{value:(_vm.fileDate),callback:function ($$v) {_vm.fileDate=$$v},expression:"fileDate"}})]],2)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.createDoc()}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center","font-size":"22px"}},[_vm._v("\n                "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.user.permissions.canUploadDocuments),expression:"this.$store.state.user.permissions.canUploadDocuments"}],staticStyle:{"font-weight":"bold","text-align":"end"},attrs:{"cols":"2"}},[_c('b-btn',{on:{"click":function($event){return _vm.$refs.documentModal.show()}}},[_vm._v(_vm._s(_vm.$t('Upload File')))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"folderEdit",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.$t('newFolderName'))+"\n                    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-input',{attrs:{"state":_vm.folderNameState,"aria-describedby":"input-live-help input-live-feedback","trim":""},model:{value:(_vm.folderEditedName),callback:function ($$v) {_vm.folderEditedName=$$v},expression:"folderEditedName"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"15px"}},[(!_vm.folderNameState)?_c('p',{staticClass:"mt-1 mb-0",staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.$t('folderNameValidationFeedback')))]):_vm._e()])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.editFolder(_vm.folderEditedName)}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"confirmFolderDelete",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mt-3",staticStyle:{"margin-bottom":"10px"},attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.$t('confirm'))+"\n                    ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"2"}},[_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.deleteFolder(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.deleteFolder(false)}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)],1)],1)]),_vm._v(" "),_vm._l((_vm.otherDocs),function(doc,index){return _c('b-row',{key:index,staticStyle:{"margin-top":"5px"}},[_c('b-card-header',{staticClass:"p-1",staticStyle:{"width":"100%"},attrs:{"header-tag":"div"}},[_c('b-btn',{attrs:{"block":"","variant":"info"},on:{"click":function($event){_vm.$root.$emit('bv::toggle::collapse', String(doc.id));}}},[_vm._v(_vm._s(doc.name))])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":String(doc.id),"accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"edit-column"},[_c('b-row',[(_vm.isSupervisor)?_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.openFolderEditModal(doc.id)}}},[_c('i',{staticClass:"fas fa-edit"})]):_vm._e(),_vm._v(" "),(_vm.isSupervisor)?_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.openFolderDeleteModal(doc.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()],1)],1),_vm._v(" "),_c('b-card-body',[_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"col-3"},[_vm._v(_vm._s(_vm.$t('docColumn')))]),_vm._v(" "),_c('th',{staticClass:"col-3"},[_vm._v(_vm._s(_vm.$t('uploadingDate')))]),_vm._v(" "),_c('th',{staticClass:"col-3"},[_vm._v(_vm._s(_vm.$t('fileDate')))]),_vm._v(" "),_c('th',{staticClass:"col-3"},[_vm._v(_vm._s(_vm.$t('operation')))])])]),_vm._v(" "),_c('tbody',_vm._l((doc.documents),function(siteDocument){return _c('tr',[_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('span',{staticClass:"link-basic",on:{"click":function($event){return _vm.downloadFile(siteDocument.fileUrl)}}},[_vm._v(_vm._s(siteDocument.filename))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                                        "+_vm._s(_vm._f("formatDate")(siteDocument.createdAt,'YYYY-MM-DD'))+"\n                                    ")])]),_vm._v(" "),_c('td',[(siteDocument.fileDate)?_c('div',{staticClass:"tableBodyCell"},[(_vm.gbId(_vm.$store.state.user.customerId))?[_vm._v("\n                                            "+_vm._s(_vm._f("formatDate")(siteDocument.fileDate,'YYYY'))+"\n                                        ")]:[_vm._v("\n                                            "+_vm._s(_vm._f("formatDate")(siteDocument.fileDate,'MM/YYYY'))+"\n                                        ")]],2):_vm._e()]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"margin-right":"80px","margin-left":"80px"},attrs:{"size":"sm","title":_vm.$t('delete'),"variant":"danger"},on:{"click":function($event){return _vm.deleteDocument($event, siteDocument.uuid)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])])}),0)])])])],1)],1)})],2)],1):_c('div')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Lm+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/bm9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scaling-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/koR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateSource_vue__ = __webpack_require__("OqBS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb34270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateSource_vue__ = __webpack_require__("jv0m");
function injectStyle (ssrContext) {
  __webpack_require__("Sajy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fb34270"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateSource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb34270_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateSource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("pami")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/zk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-card',[_c('b-modal',{ref:"libraryDocument",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                    "+_vm._s(_vm.$t('folder'))+":\n                ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-select',{attrs:{"cols":"6"},model:{value:(_vm.selectedFolderId),callback:function ($$v) {_vm.selectedFolderId=$$v},expression:"selectedFolderId"}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('new')))]),_vm._v(" "),_vm._l((_vm.folders),function(folder){return _c('option',{domProps:{"value":folder.id}},[_vm._v(_vm._s(folder.name))])})],2)],1)],1),_vm._v(" "),(!_vm.selectedFolderId)?_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                    "+_vm._s(_vm.$t('folderName'))+":\n                ")])],1):_vm._e(),_vm._v(" "),(!_vm.selectedFolderId)?_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-input',{model:{value:(_vm.folderName),callback:function ($$v) {_vm.folderName=$$v},expression:"folderName"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[(_vm.uploadedFile)?_c('b-col',{staticStyle:{"text-align":"start"}},[_c('upload',{attrs:{"showUpload":false,"showDownload":false,"reactive-id":_vm.reactiveId},on:{"onremove":_vm.handleRemoving}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm._f("textToShortText")(_vm.uploadedFile.filename)))])],1):_c('b-col',{staticStyle:{"text-align":"start"}},[_c('upload-regular',{on:{"onupload":_vm.onupload}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":_vm.createLibraryDoc}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center","font-size":"22px"}},[_vm._v("\n                "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),(_vm.canEditLibraryDocument)?_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"end"},attrs:{"cols":"2"}},[_c('b-btn',{on:{"click":function($event){return _vm.$refs.libraryDocument.show()}}},[_vm._v(_vm._s(_vm.$t('Upload File')))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px"}},[_c('b-modal',{ref:"folderEdit",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mt-3",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.$t('newFolderName'))+"\n                    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-input',{model:{value:(_vm.folderEditedName),callback:function ($$v) {_vm.folderEditedName=$$v},expression:"folderEditedName"}})],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.editFolder(_vm.folderEditedName)}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"confirmFolderDelete",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mt-3",staticStyle:{"margin-bottom":"10px"},attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                        "+_vm._s(_vm.$t('confirm'))+"\n                    ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"2"}},[_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){return _vm.deleteFolder(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return _vm.deleteFolder(false)}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)],1)],1)]),_vm._v(" "),_vm._l((_vm.docs),function(doc,index){return _c('b-row',{key:index,staticStyle:{"margin-top":"5px"}},[_c('b-card-header',{staticClass:"p-1",staticStyle:{"width":"100%"},attrs:{"header-tag":"div"}},[_c('b-btn',{attrs:{"block":"","variant":"info"},on:{"click":function($event){_vm.$root.$emit('bv::toggle::collapse', String(doc.id));}}},[_vm._v(_vm._s(doc.name))])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":String(doc.id),"accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"edit-column"},[(_vm.canEditLibraryDocument)?_c('b-row',[_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.openFolderEditModal(doc.id)}}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('b-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"sm","variant":"info"},on:{"click":function($event){return _vm.openFolderDeleteModal(doc.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1):_vm._e()],1),_vm._v(" "),_c('b-card-body',[_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","margin-left":"calc(50% - 50vw)","margin-right":"calc(50% - 50vw)"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('docColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('uploadingDate')))]),_vm._v(" "),(_vm.canEditLibraryDocument)?_c('th',{staticStyle:{"width":"1em"}},[_vm._v(_vm._s(_vm.$t('operation')))]):_vm._e()])]),_vm._v(" "),_c('tbody',_vm._l((doc.documents),function(file){return _c('tr',[_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('a',{attrs:{"href":(_vm.apiURL + "/upload/" + (file.uuid)),"target":"_blank"}},[_vm._v(_vm._s(file.filename))])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                                        "+_vm._s(_vm._f("formatDate")(file.createdAt,'YYYY-MM-DD'))+"\n                                    ")])]),_vm._v(" "),(_vm.canEditLibraryDocument)?_c('td',[(_vm.canEditLibraryDocument)?_c('div',{staticClass:"tableBodyCell"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"size":"sm","title":_vm.$t('delete'),"variant":"danger"},on:{"click":function($event){return _vm.deleteDocument($event, file.uuid)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1):_vm._e()]):_vm._e()])}),0)])])])],1)],1)})],2)],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0KSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    name: 'bar-chart',
    props: ['chartData', 'options', 'chartId'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["e" /* mixins */].reactiveProp],
    data: function data() {
        return {
            isLoaded: false
        };
    },

    computed: {
        stepSize: function stepSize() {
            return this.options.scales.yAxes[0].ticks.stepSize;
        }
    },
    mounted: function mounted() {
        var _this = this;

        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
        this.$eventHub.$on(this.chartId, function () {
            if (_this.isLoaded) {
                _this.$data._chart.destroy();
                _this.renderChart(_this.chartData, _this.options);
            }
        });
        this.isLoaded = true;
    },

    watch: {
        stepSize: function stepSize() {
            this.$data._chart.options.scales.yAxes[0].ticks.stepSize = this.options.scales.yAxes[0].ticks.stepSize;
            this.$data._chart.update();
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.$eventHub.$off(this.chartId);
    }
});

/***/ }),

/***/ "0Xcj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SiteTypeSelect',
    data: function data() {
        return {
            selectedSiteTypeId: null
        };
    },

    methods: {
        onchange: function onchange(value) {
            this.$emit('onchange', value);
        }
    },
    created: function created() {
        var _this = this;

        this.$store.state.siteTypes.forEach(function (siteType) {
            siteType.name = _this.$t(siteType.name);
        });
    }
});

/***/ }),

/***/ "0YXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circles-to-rhombuses-spinner",style:(_vm.spinnertStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1/Sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'notification'
});

/***/ }),

/***/ "12Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Site',
    data: function data() {
        return {
            searchInput: '',
            regions: [],
            selectedRegionId: null,
            selectedNoAgent: null,
            filteredAllSites: [],
            filteredNoAgents: []
        };
    },

    methods: {
        routeTo: function routeTo(site) {
            this.$router.push({ name: 'admin-site-edit', params: { site_id: site.id } });
        }
    },
    computed: {
        // Start searching from the start if less than 4 characters are entered
        // Otherwise search from any position
        // If selected
        filteredItems: function filteredItems() {
            var _this = this;

            if (this.selectedNoAgent == 1) {
                this.filteredNoAgents = this.sites.filter(function (item) {
                    return _this.isAgentFound(item.agentIds, _this.selectedNoAgent);
                });
                if (this.searchInput.length <= 3) {
                    this.filteredAllSites = this.filteredNoAgents.filter(function (item) {
                        return _this.textStartsWith(item.code + item.name, _this.searchInput) && _this.isRegionFound(_this.selectedRegionId, item.siteGroupId);
                    });

                    if (this.filteredAllSites.length) {
                        return this.filteredAllSites;
                    }
                }
                return this.filteredNoAgents.filter(function (item) {
                    return _this.isSearchTextFound(item.code + item.name, _this.searchInput) && _this.isRegionFound(_this.selectedRegionId, item.siteGroupId);
                });
            } else {
                if (this.searchInput.length <= 3) {
                    this.filteredAllSites = this.sites.filter(function (item) {
                        return _this.textStartsWith(item.code + item.name, _this.searchInput) && _this.isRegionFound(_this.selectedRegionId, item.siteGroupId);
                    });

                    if (this.filteredAllSites.length) {
                        return this.filteredAllSites;
                    }
                }
                return this.sites.filter(function (item) {
                    return _this.isSearchTextFound(item.code + item.name, _this.searchInput) && _this.isRegionFound(_this.selectedRegionId, item.siteGroupId);
                });
            }
            //isAgentFound() filters by checking member of site related to sustainability.
        }
    },
    created: function created() {
        this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
    }
});

/***/ }),

/***/ "1Nbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1XQQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* HorizontalBar */],
    name: 'HorizontalBarChart',
    props: ['chartData', 'options', 'chartId'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["e" /* mixins */].reactiveProp],
    data: function data() {
        return {
            isLoaded: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
        this.$eventHub.$on(this.chartId, function () {
            if (_this.isLoaded) {
                _this.$data._chart.destroy();
                _this.renderChart(_this.chartData, _this.options);
            }
        });
        this.isLoaded = true;
    },
    beforeDestroy: function beforeDestroy() {
        this.$data._chart.destroy();
        this.$eventHub.$off(this.chartId);
    }
});

/***/ }),

/***/ "1ddj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'IntensityMeasurementsOfEmission',
    props: {
        initialIntensityReport: {
            type: Object,
            default: function _default() {
                return {
                    currentConsumptions: [],
                    currentEmissions: [],
                    currentStaffs: [],
                    pastConsumptions: [],
                    pastEmissions: [],
                    pastStaffs: []
                };
            }
        },
        initialEmissions: {
            default: function _default() {
                return {
                    current: [],
                    past: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        }
    },
    data: function data() {
        return {
            intensityReport: {
                pastConsumptionPerStaff: 0,
                currentConsumptionPerStaff: 0,
                pastEmissionPerStaff: 0,
                currentEmissionPerStaff: 0,
                pastStaffCount: 0,
                currentStaffCount: 0,
                pastConsumption: 0,
                currentConsumption: 0,
                pastEmission: 0,
                currentEmission: 0
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        aggregateIntensityReport: function aggregateIntensityReport(_ref) {
            var currentConsumptions = _ref.currentConsumptions,
                pastConsumptions = _ref.pastConsumptions,
                currentEmissions = _ref.currentEmissions,
                pastEmissions = _ref.pastEmissions,
                currentStaffs = _ref.currentStaffs,
                pastStaffs = _ref.pastStaffs;

            var currentEmission = Number(currentEmissions).toFixed(2);
            var pastEmission = Number(pastEmissions).toFixed(2);
            var currentConsumption = Number(currentConsumptions.toFixed(2));
            var pastConsumption = Number(pastConsumptions.toFixed(2));
            var currentStaffCount = Number(currentStaffs);
            var pastStaffCount = Number(pastStaffs);

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
                currentEmission: currentEmission,
                pastEmission: pastEmission,
                currentConsumption: currentConsumption,
                pastConsumption: pastConsumption,
                currentEmissionPerStaff: currentStaffCount ? Number((currentEmission / currentStaffCount).toFixed(2)) : 0,
                pastEmissionPerStaff: pastStaffCount ? Number((pastEmission / pastStaffCount).toFixed(2)) : 0,
                currentConsumptionPerStaff: currentStaffCount ? Number((currentConsumption / currentStaffCount).toFixed(2)) : 0,
                pastConsumptionPerStaff: pastStaffCount ? Number((pastConsumption / pastStaffCount).toFixed(2)) : 0,
                currentStaffCount: currentStaffCount,
                pastStaffCount: pastStaffCount
            });
        },
        processReport: function processReport(data) {
            var _this = this;

            this.aggregateIntensityReport(data).then(function (result) {
                _this.intensityReport = result;
            });
        }
    },
    watch: {
        initialIntensityReport: function initialIntensityReport(data) {
            this.processReport(data);
        },
        selectedSiteId: function selectedSiteId() {
            this.processReport(this.initialIntensityReport);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processReport(this.initialIntensityReport);
        }
    },
    mounted: function mounted() {
        this.processReport(this.initialIntensityReport);
    }
});

/***/ }),

/***/ "1fDW":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","userGroup":"User Group","activeUsers":"Active Users","permissions":"İzinler","groupName":"Grup Adı","dataPermissions":"Veri","targetPermissions":"Hedef","auditPermissions":"Denetim","documentPermissions":"Dokümanlar","generalPermissions":"Genel","reportPermissions":"Excel Raporu","canViewData":"Veri Görüntüleme","canEditData":"Veri Düzenleme","canAddDatatype":"Veri Tipi Ekleme","canCreateGlobalGoals":"Global Hedef Ekleme","canCreateGoals":"Hedef Ekleme","canEditGoals":"Hedef Düzenleme","canApproveGoals":"Hedef Onaylama","canStartAudits":"Düzenleyici ve Önleyici Faaliyet Oluşturma","canReplyToAudits":"Düzenleyici ve Önleyici Aksiyonlara Yanıt Verme","canCreateAudit":"Denetim Kaydı Oluşturma","canUploadDocuments":"Doküman Yükleme","canViewComparisons":"Kıyaslama Sayfasını Görüntüleme","canSeeAllLocations":"Tüm Lokasyonları Görüntüleme","canGetReport":"Rapor Al","isAdmin":"Admin Sayfasına Erişim","users":"Kullanıcılar","allUsers":"Tüm Kullanıcılar","selectedUsers":"Seçili Kullanıcılar","searchUsers":"Kullanıcı Ara","thisGroupCanNotBeEdit":"Bu grubun ismi ve izinleri değiştirilemez.","thereAreChanges":"Kaydetmediğiniz değişiklikler var, kaydetmeden çıkmak istediğinize emin misiniz ?","saveChanges":"Değişiklikleri Kaydet","leaveWithoutSaving":"Kaydetmeden Çık","willDeleteUserGroup":"Bu kullanıcı grubu kalıcı olarak silinecek, emin misiniz ?","ok":"Tamam","cancel":"İptal","warning":"Uyarı","leastOneUserAtAdmin":"En Az Bir Kullanıcı Yönetici Olmalı","leastOnePermission":"En Az Bir Kullanıcı İzni Tanımlanmalı","mustHaveGroupName":"Grup İsmi Girilmeli","cannotRemoveYourselfFromAdmin":"Kendinizi Yöneticiden Kaldıramazsınız","changesSaved":"Değişiklikler kaydedildi","changesCouldNotSaved":"Değişiklikler Kaydedilemedi","newUserGroupCreated":"Yeni Kullanıcı Grubu Oluşturuldu","userGroupCouldNotCreated":"Kullanıcı Grubu Oluşturulamadı","groupDeleted":"Grup Silindi","groupCouldNotDeleted":"Grup Silinemedi","dafeultGroupSystemTranslation":"Varsayılan Grup Sistemi Çevirisi"},"en":{"sitesTitle":"Sites","userGroup":"Kullanıcı Grubu","activeUsers":"Aktif Kullanıcılar","permissions":"Permissions","groupName":"Group Name","dataPermissions":"Data","targetPermissions":"Target","auditPermissions":"Audit","documentPermissions":"Document","generalPermissions":"General","reportPermissions":"Excel Report","canViewData":"View Data","canEditData":"Edit Data","canAddDatatype":"Add Data Types","canCreateGlobalGoals":"Create Global Targets","canCreateGoals":"Create Targets","canEditGoals":"Edit Targets","canApproveGoals":"Approve Targets","canStartAudits":"start preventive/corrective actions","canReplyToAudits":"reply to preventive/corrective actions","canCreateAudit":"Create Audit","canUploadDocuments":"Upload Documents","canViewComparisons":"View Benchmarking Page","canSeeAllLocations":"Viewing All Locations","canGetReport":"Get Reports","isAdmin":"View Admin Page","users":"Users","allUsers":"All Users","selectedUsers":"Selected Users","searchUsers":"Search Users","thisGroupCanNotBeEdit":"The name and permissions of this group cannot be changed.","thereAreChanges":"There are changes you did not save, are you sure you want to leave without saving ?","saveChanges":"Save Changes","leaveWithoutSaving":"Leave Without Saving","willDeleteUserGroup":"This user group will be permanently deleted, are you sure ?","ok":"Ok","cancel":"Cancel","warning":"Warning","leastOneUserAtAdmin":"At Least One User Must Be An Admin","leastOnePermission":"At least One User Permission Must Be Defined","mustHaveGroupName":"Group Name Must Be Entered","cannotRemoveYourselfFromAdmin":"Cannot Remove Yourself From Admin","changesSaved":"Changes Saved","changesCouldNotSaved":"Changes Could Not Saved","newUserGroupCreated":"New User Group Created","userGroupCouldNotCreated":"User Group Could Not Created","groupDeleted":"Group Deleted","groupCouldNotDeleted":"Group Could Not Deleted","dafeultGroupSystemTranslation":"Default Group System Translation"}}')
}


/***/ }),

/***/ "1pac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breeding-rhombus-spinner",style:(_vm.spinnerStyle)},[_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{key:index,staticClass:"rhombus",class:("child-" + (index + 1)),style:(rs)})}),_vm._v(" "),_c('div',{staticClass:"rhombus big",style:(_vm.bigRhombusStyle)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1q1S":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Başlık","auditType":"Denetim Tipi","auditDate":"Denetim Tarihi","document":"Doküman","searchRecord":"Denetim Arama"},"en":{"title":"Title","auditType":"Audit Type","auditDate":"Audit Date","document":"Document","searchRecord":"Search Audit"}}')
}


/***/ }),

/***/ "1uX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[(_vm.title)?_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"no-gutters":"","align-h":"center"}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('b-row',{staticStyle:{"min-height":"300px","margin-top":"30px"},attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12","sm":"8","md":"8","lg":"6"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"9em"}},[_vm._v(_vm._s(_vm.$t('emissionType')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right","width":"11em"}},[_vm._v(_vm._s(_vm.$t('consumption')))]),_vm._v(" "),_vm._l((_vm.dataTypes),function(dataType,i){return _c('th',{key:i,staticStyle:{"text-align":"right","width":"11em"}},[_vm._v(_vm._s(dataType))])})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.emissions),function(emission,key){return (key !== 'total' && key !== 'unit')?_c('tr',{key:("emission-" + key)},[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(key)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(emission.consumption,'float', _vm.locale),_vm.locale))+" "+_vm._s(emission.consumption !== 0? _vm.$t(emission.consumptionUnit) : null))]),_vm._v(" "),_vm._l((_vm.dataTypes),function(dataType,i){return _c('td',{key:i,staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("addUnit")(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(emission[dataType],'float', _vm.locale),_vm.locale),_vm.$t("ton"))))])})],2):_vm._e()}),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('total')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.dataTypes),function(dataType,i){return _c('th',{key:i,staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("addUnit")(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.emissions.total[dataType],'float', _vm.locale),_vm.locale),_vm.$t("ton"))))])})],2)],2)])])]),_vm._v(" "),(_vm.pieChartData.datasets[0].data.length)?_c('b-col',{attrs:{"cols":"12","sm":"4","md":"4","lg":"6"}},[_c('div',{staticStyle:{"width":"26em","height":"26em","margin":"auto"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.pieChartData,"options":_vm.pieChartOptions,"chart-id":_vm.pieChartId}})],1)]):_c('b-col',[_c('span',[_vm._v(_vm._s(_vm.$t('emissionError')))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1wOw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"emissionLibraryManagement":"Emisyon Kütüphanesi Yönetimi","addEmissionLibrary":"Emisyon Kütüphanesi Ekle","editEmissionLibrary":"Emisyon Kütüphanesi Düzenle","emissionLibraryName":"Emisyon Kütüphanesi Adı","sourceRelations":"Kaynak Etiket Bağlantıları","allSectors":"Bütün Sektörler","allCountries":"Bütün Ülkeler","autoGenerateRows":"Verileri Oluştur","showErrorsOnly":"Hatalı Satırları Göster","clearAllFilters":"Filtreleri kaldır","addNewContent":"Yeni Satır Ekle","scopeGroup":"Scope Group","sourceTypeGroup":"Source Type Group","sourceType":"Source Type","unit":"Birim"},"en":{"emissionLibraryManagement":"Emission Library Management","addEmissionLibrary":"Add Emission Library","editEmissionLibrary":"Edit Emission Library","sourceRelations":"Source Relations","allSectors":"All Sectors","allCountries":"All Countries","autoGenerateRows":"Auto Generate Rows","showErrorsOnly":"Show Errors Only","clearAllFilters":"Clear All Filters","addNewContent":"Add New Content","scopeGroup":"Scope Group","sourceTypeGroup":"Source Type Group","sourceType":"Source Type","unit":"Unit"}}')
}


/***/ }),

/***/ "23AY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "29vg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__ = __webpack_require__("XT6D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdbd0f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__ = __webpack_require__("zXdE");
function injectStyle (ssrContext) {
  __webpack_require__("gE46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bdbd0f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdbd0f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("QwfQ")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Bcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft: function circleMarginLeft() {
      return this.circleSize * 1.125;
    },
    spinnertStyle: function spinnertStyle() {
      return {
        height: this.circleSize + 'px',
        width: (this.circleSize + this.circleMarginLeft) * this.circlesNum + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        height: this.circleSize + 'px',
        width: this.circleSize + 'px',
        marginLeft: this.circleMarginLeft + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = 150;

      for (var i = 1; i <= this.circlesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.circleStyle);

        if (i === 1) {
          style.marginLeft = 0;
        }

        circlesStyles.push(style);
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "2UmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('b-col',[_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function ($event){_vm.selectedRegionId = ($event) ? ($event).id : null;_vm.getData(_vm.selectedRegionId,_vm.selectedTypeId)}}})],1),_vm._v(" "),_c('b-col',[_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSitesForSelect,"allowEmpty":true},on:{"oninput":_vm.selectSiteId}})],1)],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.$t('title'))+"\n                    ")])]),_vm._v(" "),_c('b-form-checkbox',{staticStyle:{"user-select":"none"},attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.twoYearBool),callback:function ($$v) {_vm.twoYearBool=$$v},expression:"twoYearBool"}},[_c('b',[_vm._v(_vm._s(_vm.$t('twoYearFilter').line1))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('twoYearFilter').line2))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{staticStyle:{"margin-right":"10px"},attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function ($event){_vm.selectedRegionId = ($event) ? ($event).id : null;_vm.getData(_vm.selectedRegionId,_vm.selectedTypeId)}}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSitesForSelect,"allowEmpty":true},on:{"oninput":_vm.selectSiteId}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3",staticStyle:{"margin-top":"15px"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[(this.$store.state.user.permissions.canCreateAudit)?_c('tr',{staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow($event.target,'create')}}},[_c('td',{attrs:{"colspan":5}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"position":"absolute","left":"0","top":"auto","right":"0","margin":"auto","z-index":"100px"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('branch')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t(this.getGroupName('agent'))))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('Outer Audit')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('Inner Audit')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('Control')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.twoYearBool?_vm.withTwoYearFilter:_vm.filteredSites),function(audit,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"color":"#007bff","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail(audit.id)}}},[_vm._v(_vm._s(audit.name))]),_vm._v(" "),_c('td',[(audit.agents)?_c('div',_vm._l((audit.agents),function(agent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: audit.agentIds[index]}}}},[_vm._v(_vm._s(agent ? agent : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                            -\n                        ")])]),_vm._v(" "),(_vm.Audits[audit.id]?_vm.Audits[audit.id]['last_external_audit_date']:null)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.Audits[audit.id]['last_external_audit_date'],'YYYY-MM-DD')))]):_c('td',[_vm._v("-")]),_vm._v(" "),(_vm.Audits[audit.id]?_vm.Audits[audit.id]['last_internal_audit_date']:null)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.Audits[audit.id]['last_internal_audit_date'],'YYYY-MM-DD')))]):_c('td',[_vm._v("-")]),_vm._v(" "),(_vm.Audits[audit.id]?_vm.Audits[audit.id]['last_control_audit_date']:null)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.Audits[audit.id]['last_control_audit_date'],'YYYY-MM-DD')))]):_c('td',[_vm._v("-")])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2gaT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2sK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('looping-rhombuses-spinner',{staticClass:"mx-auto",attrs:{"size":60,"color":"#007bff"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2u3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderWidth: this.size / 10 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circle1Style: function circle1Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderTopColor: this.color
      }, this.circleStyle);
    },
    circle2Style: function circle2Style() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
        borderBottomColor: this.color
      }, this.circleStyle);
    }
  }
});

/***/ }),

/***/ "3Alh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScalingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1250
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "3G/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__("dpCh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5908c087_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__("P/1l");
function injectStyle (ssrContext) {
  __webpack_require__("Oret")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5908c087"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5908c087_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("nixg")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3NLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sources_vue__ = __webpack_require__("noD0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fabc964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sources_vue__ = __webpack_require__("gSiq");
function injectStyle (ssrContext) {
  __webpack_require__("4PNw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fabc964"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fabc964_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sources_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("E+8u")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3VUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-progress-bar'),_vm._v(" "),_c(_vm.$store.state.modal.type,{tag:"component"}),_vm._v(" "),_c('notifications',{attrs:{"group":"info"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3YDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"font-size":"24px","text-align":"left","margin-bottom":"20px","font-weight":"bold"}},[_vm._v("\n        "+_vm._s(_vm.getDataTypeName(_vm.dataType.name))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('priceColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('startDateColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('endDateColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"9em"},attrs:{"id":"unitPrice-last-column"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.unitPrices),function(unitPrice){return _c('tr',{on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(unitPrice)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.bindItems(_vm.rawItems)}]}},[_c('td',[(!unitPrice.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getUnitPrice(unitPrice.price))+"\n                        ")])]:[_c('b-form-input',{attrs:{"type":"number","placeholder":_vm.$t('unitPricePlaceHolder'),"required":""},model:{value:(unitPrice.price.editedValue),callback:function ($$v) {_vm.$set(unitPrice.price, "editedValue", $$v)},expression:"unitPrice.price.editedValue"}})]],2),_vm._v(" "),_c('td',[(!unitPrice.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getYear(unitPrice.startDate))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedStartYear($event, _vm.tempItem)}},model:{value:(unitPrice.startDate.editedValue),callback:function ($$v) {_vm.$set(unitPrice.startDate, "editedValue", $$v)},expression:"unitPrice.startDate.editedValue"}})]],2),_vm._v(" "),_c('td',[(!unitPrice.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getYear(unitPrice.endDate))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, unitPrice)}},model:{value:(unitPrice.endDate.editedValue),callback:function ($$v) {_vm.$set(unitPrice.endDate, "editedValue", $$v)},expression:"unitPrice.endDate.editedValue"}})]],2),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[(!unitPrice.editMode)?_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(unitPrice.id)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(unitPrice)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.bindItems(_vm.rawItems)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete')},on:{"click":function($event){return _vm.deleteItem($event, unitPrice.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])])])}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_c('td',[_c('b-form-input',{attrs:{"type":"number","placeholder":_vm.$t('unitPricePlaceHolder'),"required":""},model:{value:(_vm.tempItem.price.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.price, "editedValue", $$v)},expression:"tempItem.price.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedStartYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.startDate.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.startDate, "editedValue", $$v)},expression:"tempItem.startDate.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.endDate.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.endDate, "editedValue", $$v)},expression:"tempItem.endDate.editedValue"}})],1),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.createItem()}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)])]):_vm._e()]),_vm._v(" "),(!_vm.insertMode && this.$store.state.user.permissions.isAdmin)?_c('tr',{staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{attrs:{"colspan":5}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"position":"absolute","bottom":"56px","left":"0","right":"0","margin":"auto"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]):_vm._e()],2)])])]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3YLQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"width":"100%"},attrs:{"id":_vm.componentId}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"cols":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('nonconformity'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.pageType==='list'&&_vm.auditType==='Action'? _vm.ticket.textInput: _vm.ticket.scope)+"\n        ")])],1),_vm._v(" "),(_vm.pageType==='list'&&_vm.auditType==='Action')?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.translate('action'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","white-space":"pre-line"},attrs:{"sm":"9"}},[_vm._v(_vm._s(_vm.ticket.scope?_vm.ticket.scope:'-'))])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('nonconformanceType'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.nonconformanceArticleText ? _vm.$t(_vm.nonconformanceArticleText) : "-")+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('revisedDocumentInfo'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.ticket.textInput ? _vm.ticket.textInput : "-")+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('urgentActionText'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.ticket.urgentActionInput ? _vm.ticket.urgentActionInput : "-")+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('reasonAnalysisText'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.ticket.reasonAnalysisInput ? _vm.ticket.reasonAnalysisInput : "-")+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('action'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.nonconformanceActionText  ? _vm.$t(_vm.nonconformanceActionText) : "-")+"\n        ")])],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('note'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n            "+_vm._s(_vm.ticket.note ? _vm.ticket.note : "-")+"\n        ")])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('auditDate'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":true,"format":"dd/MM/yyyy"},model:{value:(_vm.ticket.auditDate),callback:function ($$v) {_vm.$set(_vm.ticket, "auditDate", $$v)},expression:"ticket.auditDate"}})],1)],1),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{staticClass:"my-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('additionalFiles'))+":")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-row',{attrs:{"align-h":"start","no-gutters":""}},_vm._l((_vm.ticket.documents),function(file,index){return (_vm.ticket.documents.length)?_c('b-col',{key:index,staticStyle:{"cursor":"pointer","align-self":"center"},attrs:{"cols":"1"}},[_c('div',{staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.downloadFile(file.fileUrl)}}},[_c('i',{staticClass:"fas fa-file-alt fa-lg"})]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v(_vm._s(_vm._f("textToShortText")(file.filename)))])]):_vm._e()}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{staticStyle:{"font-weight":"bold","color":"#707070","font-size":"1rem","text-align":"right"},attrs:{"cols":"6"}},[_c('label',[_vm._v(_vm._s(_vm.$t('lastUpdatedAt'))+": "+_vm._s(_vm._f("formatDate")(_vm.ticket.updatedAt,'YYYY-MM-DD')))])])],1):_vm._e(),_vm._v(" "),(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit'))?_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{staticStyle:{"font-weight":"bold","color":"#707070","font-size":"1rem","text-align":"right"},attrs:{"cols":"6"}},[_c('label',[_vm._v(_vm._s(_vm.$t('extendedDate'))+": "+_vm._s(_vm.firstExtendedDate(_vm.ticket, _vm.pageType)))])])],1):_vm._e(),_vm._v(" "),_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin && !_vm.ticket.state && _vm.isPostsEmpty),expression:"isAdmin && !ticket.state && isPostsEmpty"}],staticStyle:{"float":"left"},on:{"click":function($event){return _vm.showUpdateTicketModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAgent && (_vm.ticket.posts)&&(_vm.pageType==='detail'||(_vm.pageType==='list'&&_vm.auditType==='Audit')) && _vm.isPostsEmpty),expression:"isAgent && (ticket.posts)&&(pageType==='detail'||(pageType==='list'&&auditType==='Audit')) && isPostsEmpty"}],staticStyle:{"float":"right"},on:{"click":function($event){new Date(_vm.ticket.expectedDate) < new Date() && _vm.$store.state.user.permissions.canStartAudits? _vm.showReplyModal($event.target, 'negative'):_vm.showReplyModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('reply')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3kmE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4DD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "4IaV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',_vm._l((_vm.schema),function(col,index){return _c('b-row',{key:index},[_c('b-col',[_c('b-row',{staticClass:"mt-1",attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4","sm":"3","md":"2","lg":"2","xl":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$t(col.header)))])]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v(":")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[(_vm.isEditable && col.editable)?_c('div',[(col.type === 'date')?[_c('el-date-picker',{staticStyle:{"width":"220px"},attrs:{"type":"date","readonly":!col.editable,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){_vm.errors[col.key] = false}},model:{value:(_vm.model[col.key].value),callback:function ($$v) {_vm.$set(_vm.model[col.key], "value", $$v)},expression:"model[col.key].value"}})]:[_c('b-form-input',{class:{'is-invalid': _vm.errors[col.key] },staticStyle:{"width":"220px"},nativeOn:{"focus":function($event){_vm.errors[col.key] = false}},model:{value:(_vm.model[col.key].value),callback:function ($$v) {_vm.$set(_vm.model[col.key], "value", $$v)},expression:"model[col.key].value"}})]],2):_c('div',[(col.type === 'date')?[_vm._v("\n                                        "+_vm._s(_vm._f("formatDate")(_vm.model[col.key].value,'DD-MM-YYYY'))+"\n                                    ")]:[_vm._v("\n                                        "+_vm._s(_vm.model[col.key].value)+"\n                                    ")]],2)])],1)],1)],1)],1)],1)}),1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4PNw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4bUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("tcEG");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_44939cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__ = __webpack_require__("Vi8F");
function injectStyle (ssrContext) {
  __webpack_require__("r2Ve")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44939cec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_44939cec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FulfillingBouncingCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "4eQ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5LP5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5NlZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Qkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5X9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UnitPrice',
    data: function data() {
        return {
            isLoaded: false,
            tags: [],
            dataTypes: [],
            dataTypesWithPrice: []
        };
    },

    methods: {
        getDataTypeName: function getDataTypeName(dataTypeName) {
            return this.$t(dataTypeName);
        },
        routeToUnitPriceDetail: function routeToUnitPriceDetail(dataType) {
            this.$router.push({
                name: 'admin-unit-price-detail',
                params: { type_id: dataType.id }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        getDataTypesWithPrice: function getDataTypesWithPrice() {
            var _this = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/dataTypes/withPrice').then(function (_ref) {
                var data = _ref.data;

                _this.dataTypes = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this.$store.state.dataTypes, function (o) {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(data, o.id);
                });
                _this.isLoaded = true;
                _this.$Progress.finish();
            });
        },
        init: function init() {
            this.getDataTypesWithPrice();
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "5tbt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.componentId}},[_c('div',{staticClass:"my-3"},[_c('button',{ref:_vm.buttonRef,staticStyle:{"border":"none","outline":"none","background":"transparent","cursor":"pointer"},attrs:{"id":_vm.reactiveId}},[_c('span',{style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('b-popover',{ref:_vm.popoverId,attrs:{"target":_vm.reactiveId,"triggers":"focus","show":_vm.popoverShow,"placement":"right","container":_vm.componentId},on:{"update:show":function($event){_vm.popoverShow=$event},"show":_vm.onShow,"shown":_vm.onShown,"hidden":_vm.onHidden}},[_c('template',{slot:"title"},[_c('div',{ref:_vm.focusRefId},[_vm._v("Şube Bilgileri")])]),_vm._v(" "),_c('b-container',{staticStyle:{"width":"300px"}},[_c('b-row',[_c('b-col',{staticStyle:{"font-weight":"bold"}},[_vm._v("Şehir:")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.cityCodeToDisplayName(_vm.foundSite.cityCode)))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"font-weight":"bold"}},[_vm._v("Bölge:")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.groupIdToDisplayName(_vm.foundSite.siteGroupId)))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"font-weight":"bold"}},[_vm._v("Şube Kodu:")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.foundSite.code))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('number of people'))+":")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.foundSite.staffCount)+" kişi")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"font-weight":"bold"}},[_vm._v("Alan:")]),_vm._v(" "),_c('b-col',[_vm._v(_vm._s(_vm.foundSite.area)+" m"),_c('sup',[_vm._v("2")])])],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5wAA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6/jI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audit_vue__ = __webpack_require__("FesY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59553f02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audit_vue__ = __webpack_require__("dzZG");
function injectStyle (ssrContext) {
  __webpack_require__("Yo+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59553f02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59553f02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("vvkX")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6295":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "695n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Users',
    data: function data() {
        return {
            tabs: {
                activeUsers: {
                    isActive: true,
                    users: [],
                    name: this.$t('activeUsers'),
                    allUsersSelected: false,
                    rows: 1,
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                disabledUsers: {
                    isActive: false,
                    users: [],
                    name: this.$t('disabledUsers'),
                    allUsersSelected: false,
                    rows: 1,
                    style: {
                        border: { 'border-bottom': '3px solid #022B49' },
                        tab: { 'color': '#022B49' },
                        badge: { 'background-color': '#022B49' }
                    }
                },
                pendingInvitations: {
                    isActive: false,
                    users: [],
                    name: this.$t('pendingInvitations'),
                    allUsersSelected: false,
                    rows: 1,
                    style: {
                        border: { 'border-bottom': '3px solid #D6AA46' },
                        tab: { 'color': '#D6AA46' },
                        badge: { 'background-color': '#D6AA46' }
                    }
                }
            },
            error: {
                emailValidation: false
            },
            emailErrorMessage: null,
            invalidEmails: null,
            activeTab: 'activeUsers',
            isInviteInputValid: null,
            emails: [],
            currentPage: 1,
            perPage: 50,
            translateGroup: ['agent', 'director', 'supervisor', 'admin', 'guest', 'subAgent', 'auditor']

        };
    },

    methods: {
        routeUserGroup: function routeUserGroup(groupId) {
            return this.$router.push({ name: 'edit-permissions', params: { id: groupId } });
        },
        translateUserGroup: function translateUserGroup(group) {
            var groupName = group.name;
            if (groupName == 'agent') {
                groupName = this.getGroupName('agent');
            }
            return group.type == null ? groupName : this.$t(groupName);
        },
        activate: function activate(key) {
            this.activeTab = key;
            this.currentPage = 1;
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.tabs, function (tab, tabKey) {
                tab.isActive = key == tabKey;
            });
        },
        routeToUser: function routeToUser(userId) {
            this.$router.push({ name: 'user-profile', params: { user_id: userId } });
        },
        checkFormValidity: function checkFormValidity() {
            var valid = this.$refs.form.checkValidity();
            this.isInviteInputValid = valid;
            return valid;
        },
        emailValidator: function emailValidator() {
            var invalidEmailList = [];
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(this.emails, function (email) {
                if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                    invalidEmailList.push(email);
                }
            });
            this.invalidEmails = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.join(invalidEmailList, ', ');
            this.error.emailValidation = !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(invalidEmailList);
            this.emailErrorMessage = 'nonEmailInput';
            if (!this.error.emailValidation) {
                this.error.emailValidation = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(this.emails);
                this.emailErrorMessage = 'emptyEmailInput';
            }
        },
        inviteUsers: function inviteUsers() {
            var _this = this;

            this.emailValidator();
            if (!this.checkFormValidity() || this.error.emailValidation) {
                return;
            }

            this.$Progress.start();
            this.axios.post('/user/invite', { emails: this.emails }).then(function (_ref) {
                var data = _ref.data;

                var rejectedEmails = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(data, 'response'), function (o) {
                    return o != null;
                });
                if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(rejectedEmails)) {
                    _this.$message({
                        type: 'success',
                        message: _this.$t('invitesSended')
                    });
                } else {
                    _this.$message({
                        type: 'warning',
                        message: _this.$t('rejectedWhileSendingInvite') + ": " + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.join(rejectedEmails, ', ')
                    });
                }

                _this.emails = [];
                _this.init();
                _this.$refs.inviteBox.hide();
                _this.$Progress.finish();
            }).catch(function () {
                _this.$message({
                    type: 'error',
                    message: _this.$t('errorOnSendInvite')
                });
                _this.$Progress.fail();
            });
        },
        closeInviteModal: function closeInviteModal() {
            this.emails = [];
            this.$refs.inviteBox.hide();
        },
        enableUsers: function enableUsers() {
            var _this2 = this;

            var userIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs.disabledUsers.users, function (user) {
                return user.selected == true;
            }), 'id');
            this.$Progress.start();
            this.axios.post('/enableUsers', { 'userIds': userIds }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this2.$store.state.users, function (user) {
                    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, user.id)) {
                        user.status = 'active';
                    }
                });
                _this2.configureUsers();
            });
        },
        disableUsers: function disableUsers() {
            var _this3 = this;

            var userIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs.activeUsers.users, function (user) {
                return user.selected == true && user.id != _this3.$store.state.user.id;
            }), 'id');
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, this.$store.state.user.id)) {
                this.$message({
                    type: 'error',
                    message: this.$t('cantDisableSelf')
                });
            } else {
                this.$Progress.start();
                this.axios.post('/disableUsers', { 'userIds': userIds }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this3.$store.state.users, function (user) {
                        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, user.id)) {
                            user.status = 'disabled';
                        }
                    });
                    _this3.configureUsers();
                });
            }
        },
        deleteUsers: function deleteUsers() {
            var _this4 = this;

            var userIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs[this.activeTab].users, function (user) {
                return user.selected == true && user.id != _this4.$store.state.user.id;
            }), 'id');
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, this.$store.state.user.id)) {
                this.$message({
                    type: 'error',
                    message: this.$t('cantDeleteSelf')
                });
            } else {
                this.$Progress.start();
                this.axios.post('/deleteUsers', { 'userIds': userIds }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this4.$store.state.users, function (user) {
                        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, user.id)) {
                            user.status = 'deleted';
                            user.disableDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
                        }
                    });
                    _this4.configureUsers();
                });
            }
        },
        reInvite: function reInvite() {
            var _this5 = this;

            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs.pendingInvitations.users, function (user) {
                return user.selected == true;
            });
            var maxTimeInvitedUsers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(selectedUsers, function (user) {
                return user.inviteCount >= 4;
            });
            if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(maxTimeInvitedUsers)) {
                var userIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(selectedUsers, 'id');
                this.$Progress.start();
                this.axios.post('/reInviteUsers', { 'userIds': userIds }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this5.$store.state.users, function (user) {
                        if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, user.id)) {
                            user.status = 'invited';
                            user.inviteDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
                            user.inviteCount = user.inviteCount + 1;
                        }
                    });
                    _this5.configureUsers();
                    _this5.$message({
                        type: 'success',
                        message: _this5.$t('invitesSended')
                    });
                });
            } else {
                var incompatibleUserEmails = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.join(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(maxTimeInvitedUsers, 'email'), ', ');
                this.$message({
                    type: 'warning',
                    message: this.$t('accessMaxInvitationLimit') + ": " + incompatibleUserEmails
                });
            }
        },
        cancelInvite: function cancelInvite() {
            var _this6 = this;

            var userIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs.pendingInvitations.users, function (user) {
                return user.selected == true;
            }), 'id');
            this.$Progress.start();
            this.axios.post('/cancelUserInvites', { 'userIds': userIds }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(_this6.$store.state.users, function (user) {
                    if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(userIds, user.id)) {
                        user.status = 'inviteCanceled';
                    }
                });
                _this6.configureUsers();
            });
        },
        getFormatedDate: function getFormatedDate(date) {
            if (date == null) {
                return '-';
            }
            if (__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()(date), 'month') > 1) {
                return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).lang(this.$store.state.locale).format("DD MMM YYYY");
            } else {
                return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).lang(this.$store.state.locale).fromNow();
            }
        },
        anyUserSelected: function anyUserSelected(tabName, userSelection) {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.tabs[tabName].users, function (nUser) {
                return nUser.selected;
            })) == userSelection && this.tabs[tabName].isActive == true;
        },
        selectAllUsers: function selectAllUsers(checked, usersGroup) {
            var tab = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(this.tabs[usersGroup]);
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(tab.users, function (user) {
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.set(user, 'selected', checked);
            });
            this.tabs[usersGroup] = tab;
        },
        selectUser: function selectUser(tab) {
            tab.allUsersSelected = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(tab.users, function (nUser) {
                return !nUser.selected;
            }));
        },
        itemsForList: function itemsForList(data) {
            return data.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
        },
        init: function init() {
            var _this7 = this;

            this.$Progress.start();
            this.$store.dispatch('getUsers').then(this.configureUsers).then(function () {
                _this7.$Progress.finish();
            });
        },
        configureUsers: function configureUsers() {
            var users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(this.$store.state.users);
            this.currentPage = 1;
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(users, function (user) {
                user.selected = false;
            });
            this.tabs.activeUsers.users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(users, function (user) {
                return user.status == 'active';
            });
            this.tabs.disabledUsers.users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(users, function (user) {
                return user.status == 'disabled';
            });
            this.tabs.pendingInvitations.users = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(users, function (user) {
                return user.status == 'invited';
            });
        }
    },
    watch: {
        emails: function emails() {
            this.emailValidator();
        }
    },
    created: function created() {
        var _this8 = this;

        this.$Progress.start();
        this.$store.dispatch('getUsers').then(this.configureUsers).then(function () {
            _this8.$Progress.finish();
        });
    }
});

/***/ }),

/***/ "6MXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px","margin-right":"15px"}},[_c('b-form-select',{class:this.variant == 'light' ? 'white-select' : 'gray-select',staticStyle:{"height":"41px !important"},attrs:{"value":_vm.$store.state.year,"options":_vm.yearOptions},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Ty/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('div',{staticClass:"instructions"},[_vm._v("\n           "+_vm._s(_vm.$t('choose-data-type'))+"\n       ")]),_vm._v(" "),_c('div',{staticStyle:{"cursor":"pointer","display":"flex","justify-content":"left","align-items":"left"}},[_c('b-dropdown',{staticClass:"data-type-dropdown",attrs:{"size":"sm","variant":"link","toggle-class":"text-decoration-none","no-caret":"","no-flip":""}},[_c('template',{slot:"button-content"},[_c('button',{staticClass:"btn btn-secondary dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                        "+_vm._s(_vm.$t('downloadTemplate'))+"\n                    ")])]),_vm._v(" "),_vm._l((_vm.dataTypes),function(dataType,index){return _c('b-dropdown-item',{key:index,on:{"click":function($event){_vm.downloadTemplate(_vm.$t(((dataType.typeName) + " (" + (dataType.unit) + ")")),("" + (dataType.typeName)), dataType.typeId)}}},[_vm._v(" \n                        "+_vm._s(_vm.$t(dataType.typeName))+" - "+_vm._s(_vm.$t(dataType.unit))+" \n                    ")])})],2)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"instructions"},[_vm._v("\n           "+_vm._s(_vm.$t('load-xlsx-for-data-entrance'))+"\n        ")]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"start","no-gutters":""}},[(_vm.xlsx)?_c('b-col',{attrs:{"cols":"1"}},[_c('upload',{attrs:{"showUpload":false,"showDownload":false,"reactive-id":_vm.reactiveId},on:{"onremove":function (){this$1.xlsx = null;}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v(_vm._s(_vm._f("textToShortText")(_vm.xlsx.filename)))])],1):_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"1"}},[_c('upload-regular',{attrs:{"uploadOnCloud":false,"acceptQuery":'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},on:{"onupload":_vm.onupload}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Y2D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_DoughnutChart__ = __webpack_require__("yDbN");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TotalCarbonEmissions',
    props: {
        initialEmissions: {
            type: Object,
            default: function _default() {
                return {
                    current: [],
                    past: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        },
        groupType: {
            default: function _default() {
                return 'type';
            }
        }
    },
    components: { DoughnutChart: __WEBPACK_IMPORTED_MODULE_6__components_charts_DoughnutChart__["a" /* default */] },
    data: function data() {
        var _this = this;

        return {
            isLoaded: false,
            pieChartId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            emissions: [],
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Karbon Emisyonu',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                responsive: false,
                maintainAspectRatio: false,
                /*
                  layout: {
                      padding: {
                          top: 0,
                          left: 10,
                          bottom: 0,
                          right: 0
                      }
                  },
                  */
                title: {
                    display: false,
                    text: 'Toplam Karbon Emisyonları',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function onComplete() {
                        /*
                        let chartInstance = this.chart;
                        let textCtx = chartInstance.ctx;
                        textCtx.textAlign = 'center';
                        textCtx.textBaseline = 'middle';
                        textCtx.font = '24px Avenir';
                        textCtx.fillStyle = '#676763';
                        textCtx.fillText("2017", 148, 260);
                        */
                    }
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                        /*
                        var index = legendItem.index;
                        var ci = this.chart;
                        var meta = ci.getDatasetMeta(0);
                        // See controller.isDatasetVisible comment
                        meta.data[index].hidden = !meta.data[index].hidden;
                        // We hid a dataset ... rerender the chart
                        ci.update();
                        */
                    }
                }
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonEmissionsDataSet: function prepareTotalCarbonEmissionsDataSet(emissions) {
            var _this2 = this;

            // Resets pieChartData
            this.pieChartData.datasets = [{
                labels: [],
                hoverBorderWidth: [],
                hoverBorderColor: [],
                backgroundColor: [],
                data: []
            }];
            this.pieChartData.labels = [];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(emissions.current, function (emission, index) {
                _this2.pieChartData.datasets[0].labels.push(_this2.$t(emission.emissionSource));
                _this2.pieChartData.labels.push(_this2.$t(emission.emissionSource));
                _this2.pieChartData.datasets[0].hoverBorderWidth.push(6);
                _this2.pieChartData.datasets[0].hoverBorderColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].backgroundColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].data.push(emission.emissionValue);
            });
            this.isLoaded = true;
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return emissions;
        },
        prepareTotalCarbonEmissionsTable: function prepareTotalCarbonEmissionsTable(emissions) {
            var _this3 = this;

            var current = emissions.current,
                past = emissions.past,
                emissionSources = emissions.emissionSources;

            var prepared = {
                total: {
                    displayName: this.$t('total'),
                    current: 0,
                    past: 0
                }
            };

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(emissionSources, function (source) {
                var currentEmission = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(current, { emissionSource: source });
                var pastEmission = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(past, { emissionSource: source });

                var currentValue = currentEmission ? currentEmission.emissionValue : 0;
                var pastValue = pastEmission ? pastEmission.emissionValue : 0;

                prepared[source] = {
                    displayName: _this3.$t(source),
                    current: currentValue,
                    past: pastValue
                };
                prepared.total.current += currentValue;
                prepared.total.past += pastValue;
            });

            this.emissions = prepared;
        },
        filterEmissions: function filterEmissions(emissions) {
            var _this4 = this;

            var current = emissions.current,
                past = emissions.past;

            if (this.selectedSiteGroupId) {
                var sitesOfRegion = this.sites.filter(function (site) {
                    return site.siteGroupId === _this4.selectedSiteGroupId;
                });
                if (this.selectedSiteId) {
                    current = current.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(sitesOfRegion, { id: emission.site_id }) && emission.site_id === _this4.selectedSiteId;
                    });
                    past = past.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(sitesOfRegion, { id: emission.site_id }) && emission.site_id === _this4.selectedSiteId;
                    });
                } else {
                    // calculateEmission filters sitesOfRegion.
                    var filteredSitesOfRegion = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(sitesOfRegion, { calculateEmission: 1 });
                    current = current.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(filteredSitesOfRegion, { id: emission.site_id });
                    });
                    past = past.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(filteredSitesOfRegion, { id: emission.site_id });
                    });
                }
            } else if (this.selectedSiteId) {
                current = current.filter(function (emission) {
                    return emission.site_id === _this4.selectedSiteId;
                });
                past = past.filter(function (emission) {
                    return emission.site_id === _this4.selectedSiteId;
                });
            } else {
                var totalEmissionIncludedSites = this.sites.filter(function (site) {
                    return site.calculateEmission === 1;
                });
                current = current.filter(function (emission) {
                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(totalEmissionIncludedSites, { id: emission.site_id });
                });
                past = past.filter(function (emission) {
                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(totalEmissionIncludedSites, { id: emission.site_id });
                });
            }

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve({ current: current, past: past });
        },
        aggregateEmissions: function aggregateEmissions(emissions) {
            var _this5 = this;

            var reducedCurrent = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(emissions.current, function (result, emission) {
                emission['CO2e'] = emission['CO2e'] ? emission['CO2e'] : 0;
                var foundEmission = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(result, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _this5.groupType, emission[_this5.groupType]));
                if (foundEmission) {
                    foundEmission['CO2e'] += emission['CO2e'];
                } else {
                    result.push(emission);
                }
                return result;
            }, []);

            var reducedPast = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(emissions.past, function (result, emission) {
                emission['CO2e'] = emission['CO2e'] ? emission['CO2e'] : 0;
                var foundEmission = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(result, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, _this5.groupType, emission[_this5.groupType]));
                if (foundEmission) {
                    foundEmission['CO2e'] += emission['CO2e'];
                } else {
                    result.push(emission);
                }
                return result;
            }, []);

            reducedCurrent = reducedCurrent.filter(function (data) {
                return data['CO2e'] !== 0;
            });
            reducedPast = reducedPast.filter(function (data) {
                return data['CO2e'] !== 0;
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve({ current: reducedCurrent, past: reducedPast });
        },
        processCarbonEmission: function processCarbonEmission(data) {
            this.prepareTotalCarbonEmissionsTable(data);
            this.prepareTotalCarbonEmissionsDataSet(data);
        }
    },
    computed: {
        hasAnyCarbonEmission: function hasAnyCarbonEmission() {
            return this.emissions && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.emissions).length;
        }
    },
    watch: {
        initialEmissions: function initialEmissions(data) {
            this.processCarbonEmission(data);
            this.isLoaded = true;
        },
        selectedSiteId: function selectedSiteId() {
            this.processCarbonEmission(this.initialEmissions);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processCarbonEmission(this.initialEmissions);
        }
    },
    mounted: function mounted() {
        this.processCarbonEmission(this.initialEmissions);
    }
});

/***/ }),

/***/ "6ZiH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6e9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trinity-rings-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle1",style:(_vm.ring1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle2",style:(_vm.ring2Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle3",style:(_vm.ring3Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6oYg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        backgroundColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "6oxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitPrice_vue__ = __webpack_require__("5X9m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a31eb14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitPrice_vue__ = __webpack_require__("7sQH");
function injectStyle (ssrContext) {
  __webpack_require__("x8FJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a31eb14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitPrice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a31eb14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitPrice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("sZ0I")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6rjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("DMkI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37191e92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("u3VH");
function injectStyle (ssrContext) {
  __webpack_require__("TV0X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37191e92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37191e92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("nQpw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6x7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Table__ = __webpack_require__("ABj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SiteMultiSelect__ = __webpack_require__("9aru");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_8__components_SiteMultiSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_7__components_YearSelect__["a" /* default */], VueTable: __WEBPACK_IMPORTED_MODULE_2__components_Table__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a },
    name: 'data-summary',
    props: {
        selectedTag: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            isLoaded: false,
            isLoading: true,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin,
            selectedSite: null,
            currentDataTypes: [],
            selectedItem: {
                isActive: true
            },
            // tableInfo: {
            //     fields: [],
            //     items: []
            // },
            tabs: {
                activeSources: {
                    isActive: true,
                    tableInfo: { fields: [], items: [] },
                    name: this.$t('activeSources'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                inactiveSources: {
                    isActive: false,
                    tableInfo: { fields: [], items: [] },
                    name: this.$t('inactiveSources'),
                    style: {
                        border: { 'border-bottom': '3px solid #022B49' },
                        tab: { 'color': '#022B49' },
                        badge: { 'background-color': '#022B49' }
                    }
                }
            }
        };
    },

    methods: {
        activate: function activate(key) {
            var _this = this;

            this.activeTab = key;
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(this.tabs, function (tab, tabKey) {
                _this.currentPage = 1;
                tab.isActive = key == tabKey;
            });
        },
        onYearChange: function onYearChange(newYear) {
            this.isLoaded = false;
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'site-data-types',
                params: { site_id: this.route.params.site_id },
                query: { year: this.year, tag: this.selectedTag }
            });
            this.init();
        },
        selectSiteId: function selectSiteId(site) {
            var _this2 = this;

            if (!site) {
                this.$router.push({ name: 'data-sites' });
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                var tags = site.tags;
                // if tags of selected site don't includes previously selected tag, route is changed and fetches new data on the same component
                if (tags.map(function (tag) {
                    return tag.key;
                }).indexOf(this.selectedTag) === -1) {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'site-data-types',
                        params: { site_id: site.id },
                        query: { year: this.year }
                    });
                    this.$nextTick(function () {
                        return _this2.listDataTypes(site.id).then(function () {
                            _this2.$emit('changetag', site.id);
                            _this2.isLaoding = false;
                            _this2.isLoaded = true;
                        });
                    });
                } else {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'site-data-types',
                        params: { site_id: site.id },
                        query: { year: this.year }
                    });
                    return this.listDataTypes(site.id).then(this.prepareTableInfo).then(function () {
                        _this2.$Progress.finish();
                        _this2.isLaoding = false;
                        _this2.isLoaded = true;
                        return true;
                    });
                }
            }
        },
        prepareTableInfo: function prepareTableInfo() {
            var _this3 = this;

            var tableHeaders = this.collection.meta[this.selectedTag];
            var activeItems = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.collection.data[this.selectedTag], function (item) {
                return !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(item, 'cols'), 'isInactive');
            });
            var inactiveItems = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.collection.data[this.selectedTag], function (item) {
                return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(item, 'cols'), 'isInactive');
            });
            __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(activeItems, function (item) {
                _this3.currentDataTypes.push(item.id);
            });
            this.currentDataTypes = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(this.currentDataTypes);
            this.tabs.activeSources.tableInfo = {
                fields: this.isbId(this.$store.state.user.customerId) ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(tableHeaders), function (o) {
                    return o.key !== 'cost';
                }) : tableHeaders,
                items: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(activeItems, function (item) {
                    item.path = '/data/' + _this3.route.params.site_id + '/types/' + item.id + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                        year: _this3.year,
                        locale: _this3.$store.state.locale
                    });
                    return item;
                })
            };
            this.tabs.inactiveSources.tableInfo = {
                fields: this.isbId(this.$store.state.user.customerId) ? __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(tableHeaders), function (o) {
                    return o.key !== 'cost';
                }) : tableHeaders,
                items: __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(inactiveItems, function (item) {
                    item.path = '/data/' + _this3.route.params.site_id + '/types/' + item.id + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                        year: _this3.year,
                        locale: _this3.$store.state.locale
                    });
                    return item;
                })
            };
            //duplicates excluded filtered data types array.
            //let filteredDataTypes = _.differenceWith(this.$store.state.dataTypes, items, (dataVal, itemVal) => dataVal.id === itemVal.id);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        },
        listDataTypes: function listDataTypes(siteId) {
            var _this4 = this;

            var site = siteId || this.route.params.site_id;
            this.$Progress.start();
            return this.axios.get('/data/' + site + '/summary?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({
                year: this.year
            })).then(function (_ref) {
                var data = _ref.data;

                _this4.$emit('changetag', site);
                _this4.collection = data;
                __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.collection.data), function (dataGroupKey) {
                    _this4.collection.data[dataGroupKey] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(_this4.collection.data, dataGroupKey), function (o) {
                        return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.toLower(_this4.$t(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(o, 'cols'), 'dataType'), 'value')));
                    });
                });
                _this4.isLoaded = true;
                _this4.$Progress.finish();
                return data;
            });
        },
        insertItem: function insertItem(item, callback, onWarnCallBack) {
            var _this5 = this;

            var insertedItem = {
                siteId: this.route.params.site_id,
                typeId: null
            };
            this.tabs.activeSources.tableInfo.fields.forEach(function (field) {
                if (field.key == 'dataType') {
                    insertedItem.typeId = item[field.key].id;
                }
            });
            if (insertedItem.typeId) {
                return this.axios.post('/data/' + this.route.params.site_id + '/types/' + this.route.query.year, insertedItem).then(function (data) {
                    _this5.init();
                    _this5.$router.go();
                    return callback(data);
                }).catch(function () {
                    _this5.$toasted.error(_this5.$t('duplicateDataType'));
                    return onWarnCallBack();
                });
            }
        },
        deleteItemById: function deleteItemById(id) {
            var _this6 = this;

            //this.showErrorNotification(this.$t('confirmDataTypeDeletion'))
            return this.axios.delete('/data/' + this.route.params.site_id + '/types/' + id + '/' + this.route.query.year).then(function () {
                var index = _this6.currentDataTypes.indexOf(id);
                _this6.currentDataTypes.splice(index, 1);
                _this6.$toasted.show(_this6.$t('confirmDataTypeDeletion'), { duration: 5000 });
                setTimeout(function () {
                    return _this6.$router.go();
                }, 5000);
            }).catch(function () {
                _this6.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
            });
        },
        deleteSource: function deleteSource(id, isActive) {
            if (isActive) {
                this.tabs.activeSources.tableInfo.items = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.tabs.activeSources.tableInfo.items, function (o) {
                    return o.id != id;
                });
            } else {
                this.tabs.inactiveSources.tableInfo.items = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(this.tabs.inactiveSources.tableInfo.items, function (o) {
                    return o.id != id;
                });
            }
        },
        setSelectedSource: function setSelectedSource(itemData) {
            var isActive = itemData.name == 'active sources' || itemData.name == 'active_data_summary';

            if (isActive) {
                this.selectedItem = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.tabs.activeSources.tableInfo.items, function (o) {
                    return o.id == itemData.id;
                });
            } else {
                this.selectedItem = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.tabs.inactiveSources.tableInfo.items, function (o) {
                    return o.id == itemData.id;
                });
            }
            this.selectedItem.isActive = isActive;
        },
        showCreateSourceModal: function showCreateSourceModal(target) {
            var _this7 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default()(),
                type: 'createSource',
                payload: {
                    page: 'sourceSummary',
                    title: "createSource",
                    selectedSource: {}
                }
            });
            this.$nextTick(function () {
                _this7.$root.$emit('bv::show::modal', 'createSource', target);
                _this7.$eventHub.$once(_this7.$store.state.modal.eventId, function (result) {
                    if (result.emitter == 'insert') {
                        _this7.init();
                    }
                });
            });
        },
        showEditSourceModal: function showEditSourceModal(itemData, event) {
            var _this8 = this;

            this.setSelectedSource(itemData);

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default()(),
                type: 'updateSource',
                payload: {
                    page: 'sourceSummary',
                    title: "updateSource",
                    selectedSource: {},
                    selectedItem: this.selectedItem
                }
            });
            this.$nextTick(function () {
                _this8.$root.$emit('bv::show::modal', 'createSource', event.target);
                _this8.$eventHub.$once(_this8.$store.state.modal.eventId, function (result) {
                    if (result.emitter === 'update') {
                        _this8.init();
                    } else if (result.emitter == 'delete') {
                        _this8.deleteSource(result.data.id, result.data.isActive);
                    }
                });
            });
        },
        init: function init() {
            var _this9 = this;

            this.isLoading = true;
            return this.listDataTypes(Number(this.route.params.site_id)).then(this.prepareTableInfo).then(function () {
                _this9.$Progress.finish();
                _this9.isLoading = false;
                _this9.isLoaded = true;
                return true;
            });
        }
    },
    watch: {
        selectedTag: function selectedTag() {
            this.prepareTableInfo();
        }
    },
    created: function created() {
        var _this10 = this;

        this.selectedSite = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
        if (this.selectedSite && this.selectedSite.tags.length) {
            this.selectedSite.tags.forEach(function (tag) {
                tag.key == _this10.route.query.tag ? tag.active = true : tag.active = false;
            });
        }
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.$store.state.year;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        return this.listDataTypes(Number(this.route.params.site_id)).then(this.prepareTableInfo).then(function () {
            _this10.$Progress.finish();
            _this10.isLoading = false;
            _this10.isLoaded = true;
            return true;
        });
    }
});

/***/ }),

/***/ "6z1y":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"carbonEmissionTitle":"Toplam Karbon Emisyonları","carbonConsumptionTitle":"Toplam Karbon Tüketimi","performanceComparison":"Performans Kıyaslaması","emissionDistrubition":"Emisyon Dağılımı","totalEmission":"Toplam Emisyon","carbonEmissionDensity":"Karbon Emisyon Yoğunluğu","monthly":"Aylık Rapor","yearly":"Yıllık Rapor","chooseExcel":"Lütfen bir rapor seçin","exportData":"Rapor Oluştur","Emissions Breakdown":"Emisyon Dağılımı","allLocations":"Tüm Lokasyonlar","regions":"Bölgeler","locationTypes":"Lokasyon Tipleri","startDate":"Başlangıç","endDate":"Bitiş","totalGHGReport":"Toplam GHG Emisyonu Raporu","totalConsumptionReport":"Toplam Tüketim Raporu","export":"Oluştur","chooseLocation":"Lütfen bir lokasyon grubu seçin"},"en":{"carbonEmissionTitle":"Total Carbon Emissions","carbonConsumptionTitle":"Total Carbon Consumption","performanceComparison":"Performance Comparison","emissionDistrubition":"Emissions Distribution","totalEmission":"Total Emissions","carbonEmissionDensity":"Carbon Emissions Density","monthly":"Monthly Report","yearly":"Yearly Report","chooseExcel":"Please choose a report","exportData":"Create Report","Emissions Breakdown":"Emissions Breakdown","allLocations":"All Locations","regions":"Regions","locationTypes":"Location Types","startDate":"Start Date","endDate":"End Date","totalGHGReport":"Total GHG Emissions Report","totalConsumptionReport":"Total Consumption Report","export":"Export","chooseLocation":"Please select a location group"}}')
}


/***/ }),

/***/ "7BEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","font-size":"20px"}},[_vm._v(_vm._s(_vm.$t('update location')))])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('site name')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.name },nativeOn:{"focus":function($event){_vm.errors.name = false}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('dataTypes')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{staticClass:"test",attrs:{"cols":"6"}},[_c('multiselect',{class:{'is-invalid': _vm.errors.dataTypes},attrs:{"multiple":true,"options":_vm.allDataTypes,"close-on-select":true,"showLabels":false,"placeholder":_vm.$t('choose'),"label":"name","track-by":"id"},nativeOn:{"focus":function($event){_vm.errors.dataTypes = false}},model:{value:(_vm.dataTypes),callback:function ($$v) {_vm.dataTypes=$$v},expression:"dataTypes"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('dataTypeForHeating')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.heatingDataTypeModel },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.heatingDataTypeModel = false}},model:{value:(_vm.heatingDataTypeModel),callback:function ($$v) {_vm.heatingDataTypeModel=$$v},expression:"heatingDataTypeModel"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.heatingDataTypes),function(heatingType){return _c('option',{key:heatingType.id,ref:'heating',refInFor:true,domProps:{"value":heatingType.id}},[_vm._v(_vm._s(_vm.$t(heatingType.name)))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('cityTitle')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.cityCode },nativeOn:{"focus":function($event){_vm.errors.cityCode = false}},model:{value:(_vm.cityCode),callback:function ($$v) {_vm.cityCode=$$v},expression:"cityCode"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.$store.state.cities),function(city){return _c('option',{domProps:{"value":city.code}},[_vm._v(_vm._s(city.name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('regionTitle')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.region },nativeOn:{"focus":function($event){_vm.errors.region = false}},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.siteGroups),function(group){return _c('option',{domProps:{"value":group.id}},[_vm._v(_vm._s(group.display_name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('siteCode')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.code },nativeOn:{"focus":function($event){_vm.errors.code = false}},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('areaTitle')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.area },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.area = false}},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t(this.getGroupName('agent'))))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.siteAgentModel },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.siteAgentModel = false}},model:{value:(_vm.siteAgentModel),callback:function ($$v) {_vm.siteAgentModel=$$v},expression:"siteAgentModel"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t("none")))]),_vm._v(" "),_vm._l((_vm.agentUsers),function(siteAgent){return _c('option',{key:siteAgent.id,domProps:{"value":siteAgent.id}},[_vm._v(_vm._s(siteAgent.first_name + " " + siteAgent.last_name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[(this.isbId(this.$store.state.user.customerId))?[_c('span',[_vm._v(_vm._s(_vm.$t('technician')))])]:[_c('span',[_vm._v(_vm._s(_vm.$t('sub-agent')))])]],2)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[(_vm.userList.length == 1)?_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.siteSubAgentModel },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.siteSubAgentModel = false}},model:{value:(_vm.siteSubAgentModel),callback:function ($$v) {_vm.siteSubAgentModel=$$v},expression:"siteSubAgentModel"}},[_c('option',{domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t("none")))])])],1):_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.siteSubAgentModel },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.siteSubAgentModel = false}},model:{value:(_vm.siteSubAgentModel),callback:function ($$v) {_vm.siteSubAgentModel=$$v},expression:"siteSubAgentModel"}},[_c('option',{domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t("none")))]),_vm._v(" "),_vm._l((_vm.subAgentUsers),function(subSiteAgent){return _c('option',{key:subSiteAgent.id,domProps:{"value":subSiteAgent.id}},[_vm._v(_vm._s(subSiteAgent.first_name + " " + subSiteAgent.last_name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t(this.getGroupName('supervisor'))))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.siteSupervisorModel },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.siteSupervisorModel = false}},model:{value:(_vm.siteSupervisorModel),callback:function ($$v) {_vm.siteSupervisorModel=$$v},expression:"siteSupervisorModel"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t("none")))]),_vm._v(" "),_vm._l((_vm.supervisorUsers),function(supervisor){return _c('option',{key:supervisor.id,domProps:{"value":supervisor.id}},[_vm._v(_vm._s(supervisor.first_name + " " + supervisor.last_name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('manager')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.directors },attrs:{"disabled":true},nativeOn:{"focus":function($event){_vm.errors.directors = false}},model:{value:(_vm.directors),callback:function ($$v) {_vm.directors=$$v},expression:"directors"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('includeInEmissionsCalculations')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"1"}},[_c('b-form-checkbox',{attrs:{"id":"emission_checkbox","name":"emission_checkbox","value":"1","unchecked-value":"0"},model:{value:(_vm.emissionModel),callback:function ($$v) {_vm.emissionModel=$$v},expression:"emissionModel"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('is open')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"1"}},[_c('b-form-checkbox',{attrs:{"id":"isOpen_checkbox","name":"isOpen_checkbox","value":"1","unchecked-value":"0"},model:{value:(_vm.isOpenModel),callback:function ($$v) {_vm.isOpenModel=$$v},expression:"isOpenModel"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('number of people')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.staffCount },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.staffCount = false}},model:{value:(_vm.staffCount),callback:function ($$v) {_vm.staffCount=$$v},expression:"staffCount"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('coordinates')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{attrs:{"placeholder":"lat","type":"number"},model:{value:(_vm.lat),callback:function ($$v) {_vm.lat=$$v},expression:"lat"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-input',{attrs:{"placeholder":"lng","type":"number"},model:{value:(_vm.lng),callback:function ($$v) {_vm.lng=$$v},expression:"lng"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"5","sm":"5","md":"5","lg":"4"}},[_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){return _vm.update()}}},[_vm._v(_vm._s(_vm.$t("update")))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7DyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-card',{staticStyle:{"border":"none"}},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('b-row',{staticStyle:{"background-color":"white"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"float-left mt-1",staticStyle:{"font-weight":"bold","text-align":"center","font-size":"1.2em"},attrs:{"cols":"3","sm":"3"}},[_c('div',{staticStyle:{"position":"relative","width":"70px"}},[_c('span',{staticClass:"float-left",staticStyle:{"font-size":"1.4em"}},[_vm._v(_vm._s(_vm.$t('sitesTitle')))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.8em","color":"#868e96","position":"absolute","margin":"10px 2px"}},[_vm._v("("+_vm._s(_vm.filteredItems.length)+")")])])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"9","lg":"9","xl":"9"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}}),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"container-card scroll-content",staticStyle:{"height":"740px"}},[_c('table',{staticClass:"table table-hover mt-2",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('tableSiteName')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('lastUpdatedAt')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredItems),function(filteredItem){return _c('tr',[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeTo(filteredItem)}}},[_vm._v(_vm._s(filteredItem.name))]),_vm._v(" "),(filteredItem.lastUpdatedAt)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(filteredItem.lastUpdatedAt,'DD/MM/YYYY')))]):_c('td',[_vm._v("-")])])}),0)])])]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Fw5":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"summaryOfCarbonEmission":"Karbon Emisyon Özeti"},"en":{"summaryOfCarbonEmission":"Summary of Carbon Emission"}}')
}


/***/ }),

/***/ "7G78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'createTicket',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_7__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_6__components_Upload__["a" /* default */] },
    data: function data() {
        return {
            eventId: null,
            compId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
            expectedDate: __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(new Date()).add(1, 'M').toDate(),
            expectedActionDate: new Date(),
            auditDate: new Date(),
            actionCheckList: [false, false, false, false, false, false, false, false, false, false, false, false],
            isCustomSelectOpen: false,
            postDocuments: [],
            revisedDocText: null,
            note: null,
            responseActionText: '',
            urgentActionText: null,
            reasonAnalysisText: null,
            scope: null,
            nonconformanceId: null,
            reactiveId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
            siteId: null,
            type: null,
            ticketId: null,
            customNonconformance: null,
            ticketType: null,
            errors: {
                scope: false,
                nonconformanceId: false,
                expectedDate: false,
                auditDate: false
            },
            actionErrors: {
                revisedDocText: false,
                actionCheckList: false,
                expectedActionDate: false
            }
        };
    },

    methods: {
        customSelectScroll: function customSelectScroll() {
            var options = document.querySelector('.custom-select-options-show');
            if (options) {
                options.scrollTop = 0;
            }
        },
        setActionCheckList: function setActionCheckList(index) {
            var _this = this;

            if (this.gbId(this.$store.state.user.customerId)) {
                this.actionCheckList = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionCheckList.slice(0, index - this.getNewNonconformanceId)), [!this.actionCheckList[index]], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionCheckList.slice(index - this.getNewNonconformanceId + 1)));
                this.responseActionText = '';
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(this.actionCheckList, function (actionCheck, actionIndex) {
                    if (actionCheck) {
                        _this.responseActionText += '→ ' + _this.$store.state.nonconformances[actionIndex + 13 - 1].action + '\n';
                    }
                });
            }
            if (!this.gbId(this.$store.state.user.customerId)) {
                this.actionCheckList = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionCheckList.slice(0, index)), [!this.actionCheckList[index]], __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.actionCheckList.slice(index + 1)));
                this.responseActionText = '';
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(this.actionCheckList, function (actionCheck, actionIndex) {
                    if (actionCheck) {
                        _this.responseActionText += '→ ' + _this.$t(_this.$store.state.nonconformances[actionIndex - 1].action) + '\n';
                    }
                });
            }
        },
        onBlurCustomSelect: function onBlurCustomSelect() {
            this.isCustomSelectOpen = false;
        },
        setpredictedDate: function setpredictedDate(event) {
            this.expectedDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(event).utc().add(1, 'M').toDate();
        },
        onupload: function onupload(event) {
            this.postDocuments.push({
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            });
        },
        handleRemoving: function handleRemoving(event, file) {
            this.postDocuments = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.remove(this.postDocuments, function (nFile) {
                return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(file, 'uuid') != __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(nFile, 'uuid') || __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(file, 'fileId') != __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(nFile, 'fileId');
            });
        },
        onHide: function onHide(event) {
            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(event, 'trigger') != null) {
                this.closeModal(true);
            }
        },
        closeModal: function closeModal() {
            var _this2 = this;

            var deleteFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (deleteFiles) {
                var fileIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.filter(this.postDocuments, function (docs) {
                    return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(docs), 'id');
                }), 'id');
                this.axios.post('/deleteFilesFromAWS', { files: fileIds }).then(function () {
                    _this2.$refs.createTicket.hide();
                    _this2.$refs.createAction.hide();
                });
            } else {
                this.$refs.createTicket.hide();
                this.$refs.createAction.hide();
            }
        },

        // Validate required fields and return boolean of audit and action type ticket.
        validateAudit: function validateAudit() {
            if (this.ticketType == 'Audit') {
                for (var key in this.errors) {
                    this.errors[key] = !this[key];
                }
                // checks true value count of erros object 
                return !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.errors).filter(function (value) {
                    return !!value;
                }).length;
            } else if (this.ticketType == 'Action') {
                this.actionErrors.actionCheckList = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.every(this.actionCheckList, function (o) {
                    return o === false;
                });
                this.actionErrors.revisedDocText = !this.revisedDocText;
                this.actionErrors.expectedActionDate = !this.expectedDate;
                var validation = true;
                for (var _key in this.actionErrors) {
                    validation &= !this.actionErrors[_key];
                }
                return validation;
            } else return true;
        },
        insert: function insert() {
            var _this3 = this;

            if (this.validateAudit()) {
                var newAudit = {
                    auditDate: this.createUTCDate(this.auditDate.getFullYear(), this.auditDate.getMonth(), this.auditDate.getDate()),
                    expectedDate: this.createUTCDate(this.expectedDate.getFullYear(), this.expectedDate.getMonth(), this.expectedDate.getDate()),
                    textInput: this.revisedDocText,
                    urgentActionInput: this.urgentActionText,
                    reasonAnalysisInput: this.reasonAnalysisText,
                    ticketType: this.ticketType,
                    note: this.note,
                    scope: this.responseActionText ? this.responseActionText : this.scope,
                    nonconformanceId: this.nonconformanceId,
                    customNonconformance: this.customNonconformance,
                    documentIds: this.postDocuments.map(function (document) {
                        return document.uuid;
                    })
                };
                if (this.ticketType === 'Action') {
                    newAudit.scope = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.actionCheckList);
                }
                return this.axios.post('/' + this.siteId + '/audits', newAudit).then(function (_ref) {
                    var data = _ref.data;

                    var actions = '';
                    try {
                        data.actionCheckList = data.scope;
                        __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(JSON.parse(data.scope), function (actionCheck, actionIndex) {
                            if (actionCheck) {
                                actions += '→ ' + _this3.$t(_this3.$store.state.nonconformances[actionIndex - 1].action) + '\n';
                            }
                        });
                        data.scope = actions;
                    } catch (error) {
                        console.error(error);
                    }
                    _this3.$eventHub.$emit(_this3.$store.state.modal.eventId, data);
                    _this3.closeModal(false);
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        update: function update() {
            var _this4 = this;

            if (this.validateAudit()) {
                var newExpectedDate = new Date(this.expectedDate);
                var auditToBeUpdated = {
                    auditDate: this.auditDate,
                    expectedDate: this.createUTCDate(newExpectedDate.getFullYear(), newExpectedDate.getMonth(), newExpectedDate.getDate()),
                    textInput: this.revisedDocText,
                    note: this.note,
                    urgentActionInput: this.urgentActionText,
                    reasonAnalysisInput: this.reasonAnalysisText,
                    ticketType: this.ticketType,
                    scope: this.scope ? this.scope : this.responseActionText,
                    nonconformanceId: this.nonconformanceId,
                    customNonconformance: this.customNonconformance,
                    documents: this.postDocuments
                };
                if (this.ticketType == 'Action') {
                    try {
                        auditToBeUpdated.scope = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.actionCheckList);
                    } catch (error) {
                        console.error(error);
                    }
                }
                return this.axios.put('/' + this.siteId + '/audits/' + this.ticketId, auditToBeUpdated).then(function (_ref2) {
                    var data = _ref2.data;

                    auditToBeUpdated.updatedAt = data.updatedAt;
                    _this4.$eventHub.$emit(_this4.$store.state.modal.eventId, auditToBeUpdated);
                    _this4.closeModal(false);
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        onShow: function onShow() {
            var _this5 = this;

            try {
                var modals = document.getElementsByClassName('modal-content');
                modals[1].addEventListener('click', function (event) {
                    if (!event.target.classList.value.includes('custom-select')) {
                        _this5.customSelectScroll();
                        _this5.isCustomSelectOpen = false;
                    }
                });
            } catch (error) {
                console.log(error);
            }
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.siteId = this.$store.state.modal.payload.siteId || this.$store.state.siteId;
            this.ticketType = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.$store.state.modal.payload, 'ticketType') || __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.ticket, 'ticketType');
            this.type = this.$store.state.modal.type;
            if (this.type === 'updateTicket') {
                var ticket = this.$store.state.modal.payload.ticket;
                this.ticketId = this.$store.state.modal.payload.ticketId;
                this.expectedDate = ticket.expectedDate;
                this.revisedDocText = ticket.textInput;
                this.note = ticket.note;
                this.urgentActionText = ticket.urgentActionInput;
                this.reasonAnalysisText = ticket.reasonAnalysisInput;
                this.ticketType = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(ticket, 'ticketType');
                this.auditDate = ticket.auditDate;
                this.scope = ticket.actionCheckList || ticket.scope;
                this.nonconformanceId = ticket.nonconformanceId;
                this.customNonconformance = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(this.$store.state.nonconformances, { id: this.nonconformanceId }), 'article');
                this.selectNonconformance(ticket.nonconformanceId);
                if (ticket.nonconformanceId === 13) {
                    this.customNonconformance = ticket.customNonconformance;
                }
                this.postDocuments = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(ticket.documents);
                try {
                    this.actionCheckList = JSON.parse(this.scope);
                    this.responseActionText = '';
                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(this.actionCheckList, function (actionCheck, actionIndex) {
                        if (actionCheck) {
                            _this5.responseActionText += '→ ' + _this5.$store.state.nonconformances[actionIndex - 1].action + '\n';
                        }
                    });
                } catch (error) {
                    this.responseActionText = this.scope;
                }
            }
        },
        selectNonconformance: function selectNonconformance(val) {
            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.get(this.$store.state.modal.payload, 'ticketType') == 'Audit' || this.ticketType == 'Audit') {
                if (val !== 13) {
                    this.customNonconformance = this.$t(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(this.$store.state.nonconformances, {
                        id: val
                    }).action);
                } else {
                    this.customNonconformance = null;
                }
            }
        },
        nonconformancesOptions: function nonconformancesOptions() {
            if (this.gbId(this.$store.state.user.customerId)) {
                return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.filter(this.$store.state.nonconformances, function (item) {
                    return item.id > 12;
                });
            }
            if (!this.gbId(this.$store.state.user.customerId)) {
                return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.filter(this.$store.state.nonconformances, function (item) {
                    return item.id < 14;
                });
            }
        }
    },
    computed: {
        getNewNonconformanceId: function getNewNonconformanceId() {
            var nonconformanceList = this.$store.state.nonconformances; //nonconformance list
            var digerID = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.findIndex(nonconformanceList, function (item) {
                return item.id == 13;
            }); //last element of old list
            var firstNewNonconformance = nonconformanceList[digerID + 1]; //first element of new list
            return firstNewNonconformance.id - 1;
        }
    }
});

/***/ }),

/***/ "7Pfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceComparing_vue__ = __webpack_require__("q3yw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f99c56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceComparing_vue__ = __webpack_require__("bexJ");
function injectStyle (ssrContext) {
  __webpack_require__("bZ3g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20f99c56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PerformanceComparing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f99c56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PerformanceComparing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("VhMr")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7WH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('dataTypeHasEmission')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTypes),function(dataType){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToEmissionDetail(dataType)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(_vm.getDataTypeName(dataType.name)))])])}),0)])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7cXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b',{staticStyle:{"display":"none","font-weight":"bold","font-size":"22px","line-height":"400%"},attrs:{"id":"printable"}},[_vm._v("ISO 14001:2015 ÇYS İç Denetim Raporu")]),_vm._v(" "),_c('b-modal',{ref:"ticketTypeRef",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-select',{attrs:{"cols":"6","options":this.gbId(this.$store.state.user.customerId) ? _vm.ticketTypesGaranti: _vm.ticketTypes},on:{"change":function($event){return _vm.showCreateTicketModal($event)}},model:{value:(_vm.ticketType),callback:function ($$v) {_vm.ticketType=$$v},expression:"ticketType"}})],1)],1)],1)]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.selectedSite.id, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name)+" - "+_vm._s(_vm.$t('headerTitle')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end"}},[(this.$store.state.user.permissions.canStartAudits)?_c('b-col',{staticClass:"mt-1"},[_c('td',{staticClass:"non-printable",staticStyle:{"cursor":"pointer"},attrs:{"colspan":"5"},on:{"click":function($event){return _vm.$refs.ticketTypeRef.show()}}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])]):_vm._e(),_vm._v(" "),_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true},on:{"oninput":_vm.selectSite}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"height":"125px","background-color":"white"},attrs:{"no-gutters":""}},[(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('isOpen'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s((_vm.selectedSite.isOpen == 1) ? _vm.$t('siteOpen') : _vm.$t('siteClosed'))+"\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('cityTitle'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.cityCodeToDisplayName)+"\n            ")])],1):_vm._e(),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('regionTitle'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.groupDisplayName)+"\n            ")])],1),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t(this.getGroupName('agent')))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.agents)?_c('div',_vm._l((_vm.selectedSite.agents),function(agent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.agentIds[index]}}}},[_vm._v(_vm._s(agent ? agent : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[(this.isbId(this.$store.state.user.customerId))?[_c('span',[_vm._v(_vm._s(_vm.$t('technician')))])]:[_c('span',[_vm._v(_vm._s(_vm.$t('sub-agent')))])]],2),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.subAgents)?_c('div',_vm._l((_vm.selectedSite.subAgents),function(subAgent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.subAgentIds[index]}}}},[_vm._v(_vm._s(subAgent ? subAgent : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t(this.getGroupName('supervisor')))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.supervisors)?_c('div',_vm._l((_vm.selectedSite.supervisors),function(supervisor,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.supervisorIds[index]}}}},[_vm._v(_vm._s(supervisor ? supervisor : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('manager'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.directors)?_c('div',_vm._l((_vm.selectedSite.directors),function(director,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.directorIds[index]}}}},[_vm._v(_vm._s(director ? director : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"table-responsive mt-5",staticStyle:{"margin-top":"15px","overflow-y":"hidden"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"1em"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(_vm.$t('nonconformity')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('auditDateColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('statusColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('ticketType')))])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"tbody"}},_vm._l((_vm.configureTicketList(_vm.tickets)),function(ticket){return _c('tr',{class:{ hide_detail: ticket.isDetail&&!_vm.openDetailList.includes(ticket.id), show_detail: _vm.openDetailList.includes(ticket.id) },attrs:{"id":("row_" + (ticket.id) + "_" + (ticket.isDetail))}},[(!ticket.isDetail)?_c('td',{class:{open_detail_arrow : _vm.openDetailList.includes(ticket.id), close_detail_arrow : !_vm.openDetailList.includes(ticket.id)},staticStyle:{"font-size":"40px","font-weight":"bold","width":"50px","cursor":"pointer"},on:{"click":function($event){return _vm.detailToggle(ticket)}}},[_vm._v("»")]):_vm._e(),_vm._v(" "),(!ticket.isDetail && ticket.ticketType == 'Audit')?_c('td',{staticClass:"titleOfRow",on:{"click":function($event){return _vm.routeToTicketDetail(ticket)}}},[_vm._v(" "+_vm._s((ticket.scope) ? ticket.scope : "-"))]):_vm._e(),_vm._v(" "),(!ticket.isDetail && ticket.ticketType == 'Action')?_c('td',{staticClass:"titleOfRow",on:{"click":function($event){return _vm.routeToTicketDetail(ticket)}}},[_vm._v(_vm._s((ticket.textInput) ? ticket.textInput : "-"))]):_vm._e(),_vm._v(" "),(!ticket.isDetail)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(ticket.auditDate,'YYYY-MM-DD')))]):_vm._e(),_vm._v(" "),(!ticket.isDetail)?_c('td',[_vm._v(_vm._s(_vm.retrieveTicketStatus(ticket.state)))]):_vm._e(),_vm._v(" "),(!ticket.isDetail)?_c('td',[_vm._v(" "+_vm._s((ticket.ticketType) ? _vm.$t(_vm.ticketTypeOptions(ticket.ticketType)) : "-")+" ")]):_c('td',{staticStyle:{"padding-left":"13.2%","text-align":"left"},attrs:{"colspan":"5"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('ticketType'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","right":"20px"},attrs:{"sm":"7"}},[_vm._v("\n                                            "+_vm._s(_vm.$t(_vm.ticketTypeOptions(ticket.ticketType)))+"\n                                        ")])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('predictedDate'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","right":"20px"},attrs:{"sm":"7"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":true,"format":"dd/MM/yyyy"},model:{value:(ticket.expectedDate),callback:function ($$v) {_vm.$set(ticket, "expectedDate", $$v)},expression:"ticket.expectedDate"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('status'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","right":"20px"},attrs:{"sm":"7"}},[_vm._v("\n                                            "+_vm._s(_vm.retrieveTicketStatus(ticket.state))+"\n                                        ")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},_vm._l((ticket.originalMembers),function(member,index){return _c('b-row',{key:index,staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center","text-indent":"20px"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t(member.type))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","text-indent":"-5px"},attrs:{"sm":"7"}},[_c('label',[_vm._v(_vm._s(((member.firstName) + " " + (member.lastName))))])])],1)}),1)],1),_vm._v(" "),(ticket)?_c('TicketDetailCard',{attrs:{"pageType":"list","auditType":ticket.ticketType,"selectedSiteId":_vm.selectedSite.id,"ticketId":ticket.id,"ticket":ticket,"isPostsEmpty":ticket.posts.length == 0,"updateFunction":_vm.retrieveTickets}}):_vm._e()],1)])}),0)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7g5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7q7y":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"carbonEmissionTitle":"Toplam Karbon Emisyonları","emissionType":"Emisyon Kaynakları","carbonEmissionChanging":"Değişim (%)","emissionError":"Emisyon verisi bulunamadı"},"en":{"carbonEmissionTitle":"Total Carbon Emissions","emissionType":"Sources of Emission","carbonEmissionChanging":"Change (%)","emissionError":"No emissions data"}}')
}


/***/ }),

/***/ "7sQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticClass:"table-responsive mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('dataTypeHasUnitPrice')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.dataTypes),function(dataType){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToUnitPriceDetail(dataType)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(_vm.getDataTypeName(dataType.name)))])])}),0)])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8/kq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "81SY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "86JG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('b-row',{staticStyle:{"margin-top":"30px","margin-bottom":"30px"},attrs:{"align-h":"center"}},[_c('b-col',[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('wasteTableTitle')))])])],1),_vm._v(" "),(_vm.isLoaded)?_c('b-row',[(_vm.pieChartData.datasets[0].data.length)?_c('b-col',{attrs:{"cols":"12","sm":"4","md":"12","lg":"6"}},[_c('div',{staticStyle:{"width":"26em","height":"26em","margin":"auto"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.pieChartData,"options":_vm.pieChartOptions,"chart-id":_vm.pieChartId}})],1)]):_c('b-col',[_c('span',[_vm._v(_vm._s(_vm.$t('emissionError')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"10","md":"12","lg":"6"}},[_c('div',{staticClass:"table-responsive"},[(_vm.hasAnyCarbonConsumption)?_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticClass:"borderless",staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"14em"}},[_vm._v(_vm._s(_vm.$t('emissionType')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year - 1))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('carbonEmissionChanging')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.waste),function(consumption,key){return (key !== 'total')?_c('tr',[(
                            _vm.$t(consumption.displayName) !== 'Cartridge' &&
                            _vm.$t(consumption.displayName) !== 'Kartuş' &&
                            _vm.$t(consumption.displayName) !== 'Toner' &&
                            _vm.$t(consumption.displayName) !== 'Fluorescence' &&
                            _vm.$t(consumption.displayName) !== 'Floresan' &&
                            _vm.$t(consumption.displayName) !== 'Tehlikeli Atık (diğer)' &&
                            _vm.$t(consumption.displayName) !== 'Dangerous Waste (other)')?_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(consumption.displayName))+" (kg)")]):(_vm.$t(consumption.displayName) === 'Dangerous Waste (other)')?_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(consumption.displayName))+" (-)")]):(_vm.$t(consumption.displayName) === 'Tehlikeli Atık (diğer)')?_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(consumption.displayName))+" (-)")]):_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(consumption.displayName))+" ("+_vm._s(_vm.$t("adet"))+")")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(consumption.past,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(consumption.current,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(_vm.calculateRatio(consumption.past, consumption.current) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(consumption.past, consumption.current) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                        "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(consumption.past, consumption.current)),'float', _vm.locale))+"\n                                    ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]):_vm._e()}),0)]):_vm._e()])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "87kg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "88zR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('treeselect',{staticClass:"site-multi-select",attrs:{"multiple":true,"clearable":true,"searchable":true,"max-height":300,"limit":3,"rtl":false,"options":_vm.siteOptions,"disabled":_vm.disabled,"placeholder":this.$t('selectLocation')},on:{"input":_vm.onInput},model:{value:(_vm.selectedSites),callback:function ($$v) {_vm.selectedSites=$$v},expression:"selectedSites"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Ck1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SiteCreate',
    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
    },
    data: function data() {
        return {
            name: null,
            code: null,
            area: null,
            staffCount: null,
            lat: null,
            lng: null,
            cityCode: null,
            region: null,
            dataTypes: [],
            allDataTypesOptions: [],
            errors: {
                name: false,
                code: false,
                area: false,
                staffCount: false,
                lat: false,
                lng: false,
                cityCode: false,
                region: false,
                dataTypes: false
            }
        };
    },

    methods: {
        validate: function validate() {
            for (var key in this.errors) {
                this.errors[key] = !this[key];
            }
            // checks true value count of erros object
            return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errors).filter(function (value) {
                return !!value;
            }).length;
        },
        update: function update() {
            var _this = this;

            if (this.validate()) {
                var site = {
                    name: this.name,
                    code: this.code,
                    area: this.area,
                    staffCount: this.staffCount,
                    lon: this.lng,
                    lat: this.lat,
                    city: this.cityCode,
                    site_group_id: this.region,
                    dataTypes: this.dataTypes.map(function (dataType) {
                        return dataType.id;
                    })
                };
                this.$Progress.start();
                return this.axios.post('/sites', site).then(function () {
                    var PromiseArr = [_this.$store.dispatch('init'), _this.$store.dispatch('getDocumentCounts', _this.year), _this.$store.dispatch('getGoalCounts', _this.year), _this.$store.dispatch('getAuditCounts', _this.year)];
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(PromiseArr).then(function () {
                        _this.$Progress.finish();
                        _this.$router.push({ name: 'admin-site' });
                    });
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        }
    },
    created: function created() {
        var _this2 = this;

        this.allDataTypesOptions = this.$store.state.dataTypes;
        this.allDataTypesOptions.forEach(function (dataType) {
            dataType.name = _this2.$t(dataType.name);
        });
    }
});

/***/ }),

/***/ "8IK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"inner-layout",style:(_vm.showScrollbar ? 'height: auto' : ''),attrs:{"no-body":""}},[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"background-color":"#eff3f6","border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag,i){return _c('li',{key:i,staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, 'active': tag.active},on:{"click":function($event){return _vm.routeTo(tag)}}},[_vm._v(_vm._s(tag.name))])])}),0),_vm._v(" "),_c('b-card-body',{staticClass:"border border-top-0",style:(_vm.showScrollbar ? 'min-height: auto !important' : '')},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Vs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadRegular_vue__ = __webpack_require__("isL4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd0691b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadRegular_vue__ = __webpack_require__("Lu1A");
function injectStyle (ssrContext) {
  __webpack_require__("r7+X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cd0691b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadRegular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd0691b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadRegular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8ovZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 9,
      containerPadding: 2
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        borderTopColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var ringBase = this.outerRingSize / this.ringsNum;
      var ringInc = ringBase;

      for (var i = 1; i <= this.ringsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * 50 + 'ms',
          height: ringBase + (i - 1) * ringInc + 'px',
          width: ringBase + (i - 1) * ringInc + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "8rsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RegionMultiSelect',
    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    },
    props: {
        regions: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        selectedRegionId: null
    },
    methods: {
        onInput: function onInput(value) {
            this.$emit('oninput', value);
        },
        selectAll: function selectAll() {
            this.onInput(null);
            document.getElementById('region-select').blur();
        }
    },
    computed: {
        selectedRegion: function selectedRegion() {
            var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.siteGroups, { id: this.selectedRegionId });
            if (found) {
                found = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(found));
                if (found.display_name.length > 16) {
                    found.display_name = found.display_name.substr(0, 16) + '...';
                }
            }
            return found;
        }
    }
});

/***/ }),

/***/ "8z31":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8zPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("6x7T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653e01a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("dZxH");
function injectStyle (ssrContext) {
  __webpack_require__("K7HU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-653e01a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653e01a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("cKtT")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "90m7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_diacritics__ = __webpack_require__("JmeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_diacritics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_diacritics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_cities__ = __webpack_require__("+xba");











var removeDiacritics = __WEBPACK_IMPORTED_MODULE_7_diacritics___default.a.remove;
var baseYear = 2015;
var currentYear = __WEBPACK_IMPORTED_MODULE_6_moment___default()().year();
var dynamicYearOptions = [];
// a for loop to fill yearOptions list with 2015 to current year dynamically.
for (var index = baseYear; index < currentYear + 2; index++) {
    var yearOption = {};
    yearOption.value = index;
    yearOption.text = index.toString();
    dynamicYearOptions.push(yearOption);
}
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            yearOptions: dynamicYearOptions,
            otherFolderTypes: ['document', 'bill', 'chemical', 'waste'],
            initialState: {
                user: {},
                modal: {
                    eventId: null,
                    type: null,
                    text: null
                },
                data: {
                    tags: [],
                    meta: {},
                    content: {}
                },
                uploadFiles: [],
                documents: [],
                goals: [],
                year: __WEBPACK_IMPORTED_MODULE_6_moment___default()().year(),
                audits: [],
                nonconformances: [],
                paymentMethods: [],
                siteId: null,
                sites: [],
                siteTypes: [],
                dataTypes: [],
                sourceTypes: [],
                dashboardDataTypes: [121, 124, 147],
                formTypes: [],
                units: [],
                maxUpdatedAtForDocuments: null,
                maxUpdatedAtForGoals: null,
                maxUpdatedAtForAudits: null,
                cities: __WEBPACK_IMPORTED_MODULE_9__store_cities__["a" /* default */],
                siteGroups: [],
                sitesWithGroups: [],
                users: [],
                isInitiated: false,
                isMobile: false,
                isTablet: false,
                //locale: 'tr',
                countryMap: {},
                regionMap: {},
                cityMap: {},
                sectorMap: {},
                locationMap: [],
                tagMap: [],
                scopeGroupMap: [],
                sourceTypeGroupMap: [],
                sourceTypeMap: [],
                unitMap: {},
                isExcludedForAws: false,
                // Need production ip address
                /*eslint-disable */
                /* apiURL:
                    process.env.NODE_ENV === 'development'
                        ? 'http://localhost:7788'
                        : 'http://35.205.187.92:7788', */
                token: 'Bearer ' + localStorage.getItem('token')
                /*eslint-enable */
            }
        };
    },

    methods: {
        // If the typed text length lower than 5
        //      --> First, search on item codes
        //      --> Second, If any sites isn't found then start searching from the start of the item name.
        // Otherwise search from any position
        searchOnSites: function searchOnSites(searchQuery, sites) {
            var _this = this;

            if (searchQuery.length <= 4) {
                var filteredSites = sites.filter(function (item) {
                    return _this.textStartsWith(String(item.code), searchQuery);
                });

                if (filteredSites.length) {
                    return filteredSites;
                } else {
                    filteredSites = sites.filter(function (item) {
                        return _this.textStartsWith(item.originalName, searchQuery);
                    });

                    if (filteredSites.length) {
                        return filteredSites;
                    }
                }
            }

            return sites.filter(function (item) {
                var match = _this.isSearchTextFound(item.originalName, searchQuery);
                return match && match.length;
            });
        },
        createGroupedSitesKeys: function createGroupedSitesKeys(siteIds) {
            var _this2 = this;

            var filteredSites = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.filter(this.sites, function (site) {
                return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.includes(siteIds, site.id);
            });
            var filteredSiteMap = [];
            var allSitesFlag = true;

            __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(this.sitesWithGroups, function (siteGroup) {
                var childs = [];

                var regionId = _this2.getSiteMapCoreId(siteGroup.id);

                var siteData = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.groupBy(filteredSites.filter(function (s) {
                    return s.siteGroupId === regionId;
                }), 'cityCode');

                var allCitiesFlag = true;

                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(siteData, function (sites, cityId) {
                    var citySites = [];
                    __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(sites, function (site) {
                        citySites.push("site-" + __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toString(site.id));
                    });

                    var cityKey = "city-" + regionId + "-" + cityId;
                    var city = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.filter(siteGroup.children, function (o) {
                        return o.id == cityKey;
                    }));
                    if (city === undefined) {
                        childs = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(childs, citySites);
                    } else {
                        if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.size(city.children) == __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.size(citySites)) {
                            childs.push(city.id);
                        } else {
                            childs = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(childs, citySites);
                            allSitesFlag = false;
                            allCitiesFlag = false;
                        }
                    }
                });

                if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.size(childs) == __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.size(siteGroup.children) && allCitiesFlag) {
                    filteredSiteMap.push(siteGroup.id);
                } else {
                    filteredSiteMap = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(filteredSiteMap, childs);
                    allSitesFlag = false;
                }
            });

            if (allSitesFlag) {
                filteredSiteMap = ['All'];
            }

            return filteredSiteMap;
        },
        getSiteIdsInGroupedSitesMap: function getSiteIdsInGroupedSitesMap(groupedSitesKeys) {
            var _this3 = this;

            var siteIds = [];

            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.includes(groupedSitesKeys, 'All')) {
                siteIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(this.sites, 'id');
            } else {
                __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.each(groupedSitesKeys, function (siteKey) {
                    var keyParts = siteKey.split('-');
                    if (keyParts[0] == "site") {
                        siteIds.push(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(keyParts[1]));
                    } else if (keyParts[0] == "city") {
                        siteIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(siteIds, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(_this3.sites.filter(function (s) {
                            return s.siteGroupId === __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(keyParts[1]) && __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(s.cityCode) === __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(keyParts[2]);
                        }), 'id'));
                    } else {
                        siteIds = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(siteIds, __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.map(_this3.sites.filter(function (s) {
                            return s.siteGroupId === __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(keyParts[1]);
                        }), 'id'));
                    }
                });
            }

            return siteIds;
        },
        getSiteMapCoreId: function getSiteMapCoreId(key) {
            var parts = key.split('-');
            return __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toNumber(parts[1]);
        },
        routeToDashboard: function routeToDashboard(selectedSiteId, year) {
            var query = {
                year: year
            };
            if (selectedSiteId) {
                query.site_id = selectedSiteId;
            }
            this.$router.push({ name: 'dashboard', query: query });
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve();
        },
        downloadFile: function downloadFile(url) {
            if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.includes(url, 'http')) {
                window.open(url, '_blank');
            } else {
                window.open(this.apiURL + '/' + url, '_blank');
            }
        },
        showWarnModal: function showWarnModal(target, text) {
            var _this4 = this;

            this.$store.commit('SET_MODAL', {
                eventId: String(+new Date()),
                type: 'warn',
                text: text ? text : 'Silmek istediğinize emin misiniz?'
            });
            this.$nextTick(function () {
                _this4.$root.$emit('bv::show::modal', 'warn', target);
            });
        },
        showNotificationModal: function showNotificationModal(text) {
            var _this5 = this;

            this.$store.commit('SET_MODAL', {
                eventId: String(+new Date()),
                type: 'notification',
                text: text ? text : 'Bu işlem biraz vakit alabilir lütfen bekleyiniz.'
            });
            this.$nextTick(function () {
                _this5.$root.$emit('bv::show::modal', 'notification');
            });
        },
        showErrorNotification: function showErrorNotification(text) {
            this.$notify({
                group: 'info',
                title: this.$t('went-wrong'),
                text: text,
                type: 'error'
            });
        },
        generateInRange: function generateInRange(start, end) {
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()({ length: end - start }, function (v, k) {
                return k + start;
            });
        },
        textStartsWith: function textStartsWith(target, input) {
            target = removeDiacritics(target.toLowerCase());
            input = removeDiacritics(input.toLowerCase());
            return target.startsWith(input);
        },
        isSearchTextFound: function isSearchTextFound(target, input) {
            target = removeDiacritics(target.toLowerCase());
            input = removeDiacritics(input.toLowerCase());
            return target.match(input);
        },
        isRegionFound: function isRegionFound(targetId, inputId) {
            return !targetId || targetId === inputId;
        },
        isAgentFound: function isAgentFound(target, inputId) {
            var agentId = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.nth(target, 0);
            if (inputId == 1 && agentId == null) {
                return true;
            } else {
                return false;
            }
        },
        convertToLocalizedFloat: function convertToLocalizedFloat(value, locale) {
            var digitCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

            if (locale === 'tr') {
                return Number(value).toFixed(digitCount).replace('.', ',');
            }
            return Number(value).toFixed(digitCount);
        },
        localizeValue: function localizeValue(value, locale) {
            if (locale === 'tr') {
                return value.replace(/\,/gi, '-').replace(/\./gi, ',').replace(/\-/gi, '.');
            }
            return value;
        },
        delocalizeValueForBN: function delocalizeValueForBN(value, locale) {
            if (locale === 'tr') {
                return value.replace(/\./gi, '-').replace(/\,/gi, '.').replace(/\-/gi, ',');
            }
            return value;
        },
        delocalizeValue: function delocalizeValue(value, locale) {
            if (locale === 'en') {
                return value.replace(/\./gi, '-').replace(/\,/gi, '.').replace(/\-/gi, ',');
            }
            return value;
        },
        convertToNumber: function convertToNumber(str) {
            return Number(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.toString(str).replace(/\./gi, '').replace(',', '.')) || 0;
        },

        // remove trailing zeors in float numbers
        removeZeros: function removeZeros(val) {
            val = val.replace(/\./gi, '').replace(',', '.').split('.');

            if (val[1]) {
                val[1] = val[1].replace(/0+$/g, '');
            }

            return val.join('.');
        },

        // get group names for different customers
        getGroupName: function getGroupName(groupName) {
            if (groupName == 'agent') {
                return this.isbId(this.$store.state.user.customerId) ? 'isb_agent' : 'agent';
            } else if (groupName == 'subAgent') {
                return this.isbId(this.$store.state.user.customerId) ? 'technician' : 'sub-agent';
            } else if (groupName == 'supervisor') {
                return this.isbId(this.$store.state.user.customerId) ? 'isb_supervisor' : 'supervisor';
            } else {
                return groupName;
            }
        },
        getLastFilledProperty: function getLastFilledProperty(site, type) {
            var property = null;
            var years = this.generateInRange(2015, this.year + 1).reverse();
            if (!site.yearlyProperties[this.year] || !site.yearlyProperties[this.year][type]) {
                years.forEach(function (year) {
                    if (!property && site.yearlyProperties[year] && site.yearlyProperties[year][type]) {
                        property = site.yearlyProperties[year];
                    }
                });
            } else {
                property = site.yearlyProperties[this.year];
            }
            return property;
        },
        deepClone: function deepClone(data) {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data));
        },
        getInitialState: function getInitialState(state) {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, this.initialState);
        },
        createUTCDate: function createUTCDate(year, month, day) {
            return new Date(Date.UTC(year, month, day));
        },
        isMaster: function isMaster(customerId) {
            return customerId == 23;
        },
        isbId: function isbId(customerId) {
            return customerId == -1; //3042;
        },
        gbId: function gbId(customerId) {
            return customerId == -1; //1;
        },
        downloadExcelBlob: function downloadExcelBlob(data, filename) {
            var blob = new Blob([data.data], { type: 'application/vnd.ms-excel' });
            var link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        },
        canGetReport: function canGetReport() {
            return this.$store.state.user.permissions.canGetReport;
        },
        toLocaleLowerCase: function toLocaleLowerCase(val) {
            var langMap = {
                en: 'en-US',
                tr: 'tr'
            };

            return val.toLocaleLowerCase(langMap[this.$store.state.user.language]);
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapState */])(['route', 'apiURL', 'token', 'sites', 'siteGroups', 'sitesWithGroups', 'year', 'uploadFiles', 'documents', 'locale', 'maxUpdatedAtForDocuments', 'maxUpdatedAtForGoals', 'audits', 'maxUpdatedAtForAudits', 'paymentMethods', 'formTypes', 'siteTypes', 'countryMap', 'regionMap', 'cityMap', 'sectorMap', 'locationMap', 'tagMap', 'scopeGroupMap', 'sourceTypeGroupMap', 'sourceTypeMap', 'unitMap', 'isExcludedForAws']), Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['maskOfNumber', 'maskOfEmission', 'maskOfCurrency']))
});

/***/ }),

/***/ "945v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__ = __webpack_require__("yDbN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EmissionDistribution',
    props: {
        initialEmissions: {
            type: Object,
            default: function _default() {
                return {
                    current: [],
                    emissionTypes: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        },
        groupType: {
            default: function _default() {
                return 'scopeGroup';
            }
        }
    },
    components: { DoughnutChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__["a" /* default */] },
    data: function data() {
        var _this = this;

        return {
            isLoaded: false,
            pieChartId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            emissions: [],
            types: [],
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Karbon Emisyonu',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                responsive: false,
                maintainAspectRatio: false,
                /*
                layout: {
                padding: {
                top: 0,
                left: 10,
                bottom: 0,
                right: 0
                }
                },
                */
                title: {
                    display: false,
                    text: 'Toplam Karbon Emisyonları',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function onComplete() {
                        /*
                        let chartInstance = this.chart;
                        let textCtx = chartInstance.ctx;
                        textCtx.textAlign = 'center';
                        textCtx.textBaseline = 'middle';
                        textCtx.font = '24px Avenir';
                        textCtx.fillStyle = '#676763';
                        textCtx.fillText("2017", 148, 260);
                        */
                    }
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                        /*
                        var index = legendItem.index;
                        var ci = this.chart;
                        var meta = ci.getDatasetMeta(0);
                        // See controller.isDatasetVisible comment
                        meta.data[index].hidden = !meta.data[index].hidden;
                        // We hid a dataset ... rerender the chart
                        ci.update();
                        */
                    }
                }
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonEmissionsDataSet: function prepareTotalCarbonEmissionsDataSet(emissions) {
            var _this2 = this;

            // Resets pieChartData
            this.pieChartData.datasets = [{
                labels: [],
                hoverBorderWidth: [],
                hoverBorderColor: [],
                backgroundColor: [],
                data: []
            }];
            this.pieChartData.labels = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(emissions, function (emission, index) {
                _this2.pieChartData.datasets[0].labels.push(_this2.$t(emission.source));
                _this2.pieChartData.labels.push(_this2.$t(emission.source));
                _this2.pieChartData.datasets[0].hoverBorderWidth.push(6);
                _this2.pieChartData.datasets[0].hoverBorderColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].backgroundColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].data.push(emission['CO2e'] ? emission['CO2e'] : 0);
            });
            this.isLoaded = true;
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return emissions;
        },
        prepareTotalCarbonEmissionsTable: function prepareTotalCarbonEmissionsTable(emissions) {
            this.emissions = emissions;
        },
        filterEmissions: function filterEmissions(emissions) {
            var _this3 = this;

            var current = emissions.current;

            if (this.selectedSiteGroupId) {
                var sitesOfRegion = this.sites.filter(function (site) {
                    return site.siteGroupId === _this3.selectedSiteGroupId;
                });
                if (this.selectedSiteId) {
                    current = current.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: emission.site_id }) && emission.site_id === _this3.selectedSiteId;
                    });
                } else {
                    current = current.filter(function (emission) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: emission.site_id });
                    });
                }
            } else if (this.selectedSiteId) {
                current = current.filter(function (emission) {
                    return emission.site_id === _this3.selectedSiteId;
                });
            }

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(current);
        },
        aggregateEmissions: function aggregateEmissions(emissions) {
            var _this4 = this;

            var reducedCurrent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(emissions, function (result, emission) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(result, { scopeGroup: emission.scopeGroup });
                if (foundEmission) {
                    _this4.types.forEach(function (type) {
                        emission[type] = emission[type] ? emission[type] : 0;
                        foundEmission[type] = foundEmission[type] ? foundEmission[type] : 0;
                        foundEmission[type] += emission[type];
                    });
                } else {
                    _this4.types.forEach(function (type) {
                        emission[type] = emission[type] ? emission[type] : 0;
                    });
                    result.push(emission);
                }
                return result;
            }, []);

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(reducedCurrent);
        },
        processCarbonEmission: function processCarbonEmission(_ref) {
            var emissionTypes = _ref.emissionTypes,
                distributions = _ref.distributions;

            this.types = emissionTypes;
            this.emissions = distributions;
            this.prepareTotalCarbonEmissionsDataSet(distributions);
        }
    },
    computed: {
        hasAnyCarbonEmission: function hasAnyCarbonEmission() {
            return this.emissions && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.emissions).length;
        }
    },
    watch: {
        initialEmissions: function initialEmissions(data) {
            this.processCarbonEmission(data);
        },
        selectedSiteId: function selectedSiteId() {
            this.processCarbonEmission(this.initialEmissions);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processCarbonEmission(this.initialEmissions);
        }
    },
    mounted: function mounted() {
        this.processCarbonEmission(this.initialEmissions);
    }
});

/***/ }),

/***/ "9AED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrbitSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 50
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__ = __webpack_require__("nJYp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041cde12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__ = __webpack_require__("A2CD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041cde12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("Prus")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9aru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteMultiSelect_vue__ = __webpack_require__("ALfH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227306a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteMultiSelect_vue__ = __webpack_require__("VX4M");
function injectStyle (ssrContext) {
  __webpack_require__("YRlB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-227306a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227306a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9aty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticStyle:{"position":"fixed","top":"0","bottom":"0","right":"0","left":"0","overflow":"auto"},attrs:{"md":"12"}},[(!_vm.hideCarousel)?_c('b-col',{staticClass:"carousel-side d-flex justify-content-center align-items-center",staticStyle:{"background-color":"#4129A8"},attrs:{"md":"5"}},[_c('carousel')],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"form-side d-flex",staticStyle:{"background-color":"#fff"},attrs:{"md":_vm.hideCarousel ? 12 : 7}},[_c('b-card',{staticStyle:{"width":"25%","min-width":"30rem","margin":"auto","border":"none","color":"#022B49"},attrs:{"img-src":_vm.showLogo ? _vm.logoImg : '',"img-alt":"Image","img-top":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login(_vm.email, _vm.pass, _vm.captchaInput)}}},[_c('b-row',{staticStyle:{"position":"relative"}},[_c('b-col',[_c('b-alert',{staticClass:"alert-info-cl",staticStyle:{"width":"100%","position":"relative","right":"0","left":"0","margin":"auto","margin-top":"10% z-index:3","color":"#2D8B61"},attrs:{"show":_vm.forgotPasswordActivationInfo,"dismissible":""},on:{"dismissed":function($event){_vm.forgotPasswordActivationInfo = 0},"dismiss-count-down":function($event){return _vm.countDownChanged(_vm.forgotPasswordActivationInfo)}}},[_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(_vm.$t('forgot-password-info')))])]),_vm._v(" "),_c('b-alert',{staticClass:"alert-danger-cl",staticStyle:{"width":"100%","position":"relative","right":"0","left":"0","margin":"auto","margin-top":"10% z-index:3"},attrs:{"show":_vm.showInvalidUserAlert,"dismissible":"","variant":"danger"},on:{"dismissed":function($event){_vm.showInvalidUserAlert = 0},"dismiss-count-down":function($event){return _vm.countDownChanged(_vm.showInvalidUserAlert)}}},[_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(_vm.$t('alert')))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(_vm.$t('tryAgain')))])]),_vm._v(" "),_c('b-alert',{staticClass:"alert-danger-cl",staticStyle:{"width":"100%","position":"relative","right":"0","left":"0","margin":"auto","margin-top":"10% z-index:3"},attrs:{"show":_vm.showInviteCanceledAlert,"dismissible":"","variant":"danger"},on:{"dismissed":function($event){_vm.showInviteCanceledAlert = 0},"dismiss-count-down":function($event){return _vm.countDownChanged(_vm.showInviteCanceledAlert)}}},[_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(_vm.$t('inviteCanceled')))])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3",staticStyle:{"font-weight":"bold","margin-bottom":"10px","font-size":"1.75em"}},[_c('b-col',[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('login')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("PkBM")}})]),_vm._v(" "),_c('b-form-input',{staticClass:"input-field",class:['input-field', {'is-invalid': _vm.emailError}],attrs:{"placeholder":_vm.$t('emailPlaceholder'),"type":"text","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailError),expression:"emailError"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('emptyEmail')))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("KGkw")}})]),_vm._v(" "),_c('b-form-input',{class:['input-field', {'is-invalid': _vm.passwordError}],attrs:{"placeholder":_vm.$t('passwordPlaceholder'),"type":"password","id":"password","required":""},model:{value:(_vm.pass),callback:function ($$v) {_vm.pass=$$v},expression:"pass"}}),_vm._v(" "),_c('b-input-group-append',{attrs:{"is-text":""}},[(_vm.showPassword)?_c('span',{key:"password-visible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"showPass",attrs:{"src":__webpack_require__("AuRY")}}),_c('img')]):_c('span',{key:"password-invisible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"hidePass",attrs:{"src":__webpack_require__("gfGe")}}),_c('img')])])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordError),expression:"passwordError"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('emptyPassword')))])],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.captchaRequired),expression:"captchaRequired"}],attrs:{"align-h":"center"}},[_c('b-col',{staticClass:"mb-3",attrs:{"md":"auto"}},[_c('b-row',[_c('b-col',[_c('b-img',{staticStyle:{"margin-bottom":"10px"},attrs:{"center":"","src":_vm.captchaImg,"width":"220px;"}})],1),_vm._v(" "),_c('b-col',{staticClass:"button-column"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"mt-5",staticStyle:{"border-radius":"8px"},attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.getCaptcha()}}},[_c('i',{staticClass:"fas fa-sync-alt"})])],1)],1),_vm._v(" "),_c('b-row',[_c('b-form-input',{class:['input-field', {'is-invalid': _vm.captchaError}],staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('inputPlaceholderCaptcha'),"type":"text","id":"captcha","required":_vm.captchaRequired},model:{value:(_vm.captchaInput),callback:function ($$v) {_vm.captchaInput=$$v},expression:"captchaInput"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('b-overlay',{staticClass:"d-inline-block",attrs:{"show":_vm.isLoginButtonDisabled,"rounded":"","opacity":"0.6","spinner-small":"","spinner-variant":"primary"}},[_c('b-button',{staticClass:"px-5 light-green",attrs:{"disabled":_vm.isLoginButtonDisabled},on:{"click":function($event){return _vm.login(_vm.email, _vm.pass, _vm.captchaInput)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('loginButton'))+" \n                        ")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2"},[_c('span',[_c('router-link',{staticClass:"link",attrs:{"to":{name: 'forgot-password'}}},[_vm._v(_vm._s(_vm.$t('forgotPassword')))])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9g35":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9laN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9p+P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A1rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.circlesStyles),function(cs,index){return _c('div',{key:index,staticClass:"circle",style:(cs)},[_c('div',{staticClass:"circle-inner-container",style:(_vm.circleInnerContainerStyle)},[_c('div',{staticClass:"circle-inner",style:(_vm.circleInnerStyle)})])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A2CD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"custom-navbar",attrs:{"toggleable":"md","type":"dark"}},[_c('b-navbar-toggle',{staticClass:"ml-auto my-2",attrs:{"target":"nav-collapse","link-classes":"custom-navbar__link"}}),_vm._v(" "),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('summary')}},[_c('span',{staticClass:"fas fa-tachometer-alt"}),_vm._v(" "+_vm._s(_vm.$t('summary'))+"\n                ")]),_vm._v(" "),(this.$store.state.user.permissions.canViewData)?_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('data')}},[_c('span',{staticClass:"fas fa-database"}),_vm._v(" "+_vm._s(_vm.$t('data'))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('report')}},[_c('span',{staticClass:"fas fa-chart-bar"}),_vm._v(" "+_vm._s(_vm.$t('report'))+"\n\t\t\t\t")]),_vm._v(" "),_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('goals')}},[_c('span',{staticClass:"fas fa-tasks"}),_vm._v(" "+_vm._s(_vm.$t('goals'))+"\n\t\t\t\t")]),_vm._v(" "),_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('documents')}},[_c('span',{staticClass:"fas fa-copy"}),_vm._v(" "+_vm._s(_vm.$t('documents'))+"\n\t\t\t\t")]),_vm._v(" "),_c('b-nav-item',{attrs:{"link-classes":"custom-navbar__link","active-class":"custom-navbar__link--active","to":_vm.assignRoute('audit')}},[_c('span',{staticClass:"fas fa-calendar-check"}),_vm._v(" "+_vm._s(_vm.$t('audit'))+"\n\t\t\t\t")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item-dropdown',{attrs:{"menu-class":"custom-navbar__dropdown","no-flip":"","offset":"-10","right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('span',{staticClass:"text-white"},[_vm._v(_vm._s(this.$store.state.user.name))]),_vm._v(" "),_c('b-avatar',{attrs:{"src":this.$store.state.user.profilePic}})],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"link-class":"custom-navbar__dropdown-item","to":{name: 'user-profile', params: {user_id: this.$store.state.user.id}}}},[_c('span',[_c('i',{staticClass:"fas fa-user mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text"},[_vm._v(_vm._s(_vm.$t('My Account')))])])]),_vm._v(" "),(this.$store.state.user.permissions.isAdmin)?_c('b-dropdown-item',{attrs:{"to":{name: 'admin-general'},"link-class":"custom-navbar__dropdown-item"}},[_c('span',[_c('i',{staticClass:"fas fa-user-cog mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text"},[_vm._v(_vm._s(_vm.$t('Admin Panel')))])])]):_vm._e(),_vm._v(" "),(this.$store.state.user.permissions.isAdmin && this.isMaster(this.$store.state.user.customerId))?_c('b-dropdown-item',{attrs:{"to":{name: 'emission-library'},"link-class":"custom-navbar__dropdown-item"}},[_c('span',[_c('i',{staticClass:"fas fa-user-shield mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text"},[_vm._v(_vm._s(_vm.$t('Master Panel')))])])]):_vm._e(),_vm._v(" "),(this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId))?_c('b-dropdown-item',{attrs:{"to":{name: 'library'},"link-class":"custom-navbar__dropdown-item"}},[_c('span',[_c('i',{staticClass:"fas fa-info-circle mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text"},[_vm._v(_vm._s(_vm.$t('Library')))])])]):_vm._e(),_vm._v(" "),(this.gbId(this.$store.state.user.customerId))?_c('b-dropdown-item',{attrs:{"href":'mailto:Verimlilik@garantibbva.com.tr',"link-class":"custom-navbar__dropdown-item"}},[_c('span',[_c('i',{staticClass:"fas fa-envelope mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text"},[_vm._v(_vm._s(_vm.$t('contact us')))])])]):_vm._e(),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{name: 'login'},"link-class":"custom-navbar__dropdown-item"},nativeOn:{"click":function($event){return _vm.logout.apply(null, arguments)}}},[_c('span',[_c('i',{staticClass:"fas fa-sign-out-alt mr-2"}),_vm._v(" "),_c('span',{staticClass:"nav-dropdown-text",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('logout')))])])])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A9iV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "AB+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TotalCarbonEmissions__ = __webpack_require__("dSCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TotalCarbonConsumptions__ = __webpack_require__("NYoC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PerformanceComparing__ = __webpack_require__("7Pfz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_EmissionDistribution__ = __webpack_require__("t3cv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IntensityMeasurementsOfEmission__ = __webpack_require__("tL2b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ScopeComparison__ = __webpack_require__("uQJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TotalWasteProduced__ = __webpack_require__("WLJa");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        ScopeComparison: __WEBPACK_IMPORTED_MODULE_12__components_ScopeComparison__["a" /* default */],
        IntensityMeasurementsOfEmission: __WEBPACK_IMPORTED_MODULE_11__components_IntensityMeasurementsOfEmission__["a" /* default */],
        EmissionDistribution: __WEBPACK_IMPORTED_MODULE_10__components_EmissionDistribution__["a" /* default */],
        PerformanceComparing: __WEBPACK_IMPORTED_MODULE_9__components_PerformanceComparing__["a" /* default */],
        TotalCarbonConsumptions: __WEBPACK_IMPORTED_MODULE_8__components_TotalCarbonConsumptions__["a" /* default */],
        TotalWasteProduced: __WEBPACK_IMPORTED_MODULE_13__components_TotalWasteProduced__["a" /* default */],
        SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_6__components_SiteTypeSelect__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__["a" /* default */],
        RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a,
        TotalCarbonEmissions: __WEBPACK_IMPORTED_MODULE_7__components_TotalCarbonEmissions__["a" /* default */]
    },
    name: 'analysis',
    data: function data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            selectedExcel: {
                type: null,
                startYear: '',
                endYear: '',
                location: null
            },
            startYearOption: {},
            endYearOption: {},
            comparingData: [],
            emissions: {
                current: [],
                past: [],
                emissionTypes: []
            },
            consumptions: {
                currentConsumptions: [],
                pastConsumptions: []
            },
            waste: {
                currentWaste: [],
                pastWaste: []
            },
            intensityReport: {
                currentConsumptions: [],
                currentEmissions: [],
                currentStaffs: [],
                pastConsumptions: [],
                pastEmissions: [],
                pastStaffs: []
            },
            scopeReport: {
                current: [],
                past: [],
                tags: []
            },
            excelTypes: [{
                value: null,
                text: this.$t('chooseExcel'),
                disabled: true
            }, {
                value: 1,
                text: this.$t('totalGHGReport')
            }, {
                value: 2,
                text: this.$t('totalConsumptionReport')
            }],
            locationTypes: [{
                value: null,
                text: this.$t('chooseLocation'),
                disabled: true
            }, {
                value: 1,
                text: this.$t('allLocations')
            }, {
                value: 2,
                text: this.$t('regions')
            }, {
                value: 3,
                text: this.$t('locationTypes')
            }],
            activeTabs: {
                firstBox: 'carbon',
                lastBox: 'emission'
            },
            excelData: null
        };
    },


    methods: {
        exportExcel: function exportExcel() {
            this.$refs.excelTypes.hide();

            if (this.selectedExcel.location == null) {
                this.selectedExcel.location = 1;
            }
            if (this.selectedExcel.startYear == null && this.selectedExcel.endYear != null) {
                this.selectedExcel.startYear = this.selectedExcel.endYear;
            }
            if (this.selectedExcel.startYear != null && this.selectedExcel.endYear == null) {
                this.selectedExcel.endYear = this.selectedExcel.startYear;
            }

            if (this.selectedExcel.startYear == null || this.selectedExcel.endYear == null || this.selectedExcel.type == null) {
                return;
            }

            if (this.selectedExcel.type == 1) {
                window.open(this.apiURL + '/totalGHGReportExport?startYear=' + this.selectedExcel.startYear + '&endYear=' + this.selectedExcel.endYear + '&locations=' + this.selectedExcel.location + '&locale=' + this.$store.state.locale + '&token=' + this.downloadToken);
            } else if (this.selectedExcel.type == 2) {
                window.open(this.apiURL + '/totalConsumptionReportExport?startYear=' + this.selectedExcel.startYear + '&endYear=' + this.selectedExcel.endYear + '&locations=' + this.selectedExcel.location + '&locale=' + this.$store.state.locale + '&token=' + this.downloadToken);
            }
        },
        selectStartYear: function selectStartYear() {
            var start = new Date(this.selectedExcel.startYear, 0);

            this.endYearOption = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < start;
                }
            };
            if (this.selectedExcel.endYear != '') {
                var end = new Date(this.selectedExcel.endYear, 0);

                if (start > end) {
                    this.selectedExcel.endYear = this.selectedExcel.startYear;
                }
            }
        },
        selectEndYear: function selectEndYear() {
            var end = new Date(this.selectedExcel.endYear, 0);

            this.startYearOption = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() > end;
                }
            };

            if (this.selectedExcel.startYear != '') {
                var start = new Date(this.selectedExcel.startYear, 0);

                if (start > end) {
                    this.selectedExcel.startYear = this.selectedExcel.endYear;
                }
            }
        },
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedSiteId = null;
            this.selectedSiteGroupId = null;
            if (siteTypeId) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.typeId === siteTypeId;
                });
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        multiselectSearch: function multiselectSearch(searchQuery) {
            this.filteredSites = this.searchOnSites(searchQuery, this.sites);
        },
        retrieveEmissions: function retrieveEmissions() {
            var _this = this;

            return this.axios.get('/report/emission?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId
            })).then(function (_ref) {
                var data = _ref.data;

                _this.emissions = data;
                return data;
            });
        },
        retrieveEmissionConsumptions: function retrieveEmissionConsumptions() {
            var _this2 = this;

            return this.axios.get('/report/consumption?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId
            })).then(function (_ref2) {
                var data = _ref2.data;

                _this2.consumptions = data;
                return data;
            });
        },
        retrieveWasteReport: function retrieveWasteReport() {
            var _this3 = this;

            return this.axios.get('/report/waste?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId
            })).then(function (_ref3) {
                var data = _ref3.data;

                _this3.waste = data;
                return data;
            });
        },
        retrieveIntensityReport: function retrieveIntensityReport() {
            var _this4 = this;

            return this.axios.get('/report/intensity?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId
            })).then(function (_ref4) {
                var data = _ref4.data;

                _this4.intensityReport = data;
                _this4.scopeReport.current = data.currentScope;
                _this4.scopeReport.past = data.pastScope;
                _this4.scopeReport.scopeTags = data.scopeTags;
                return data;
            });
        },
        selectSiteId: function selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.fetchAllData();
        },
        selectSiteGroupId: function selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        fetchAllData: function fetchAllData() {
            var _this5 = this;

            this.$Progress.start();
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.retrieveEmissions(), this.retrieveEmissionConsumptions(), this.retrieveWasteReport(), this.retrieveIntensityReport()]).then(function () {
                _this5.specifyComparingData(_this5.activeTabs.lastBox);
                _this5.isLoaded = true;
                _this5.$Progress.finish();
            });
        },
        onYearChange: function onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({ name: 'general-analysis', query: { year: this.year } });
            this.fetchAllData();
        },
        specifyComparingData: function specifyComparingData(type) {
            if (type === 'consumption') {
                this.comparingData = this.consumptions.performance;
            } else if (type === 'emission') {
                this.comparingData = this.emissions.performance;
            } else if (type === 'intensity') {
                this.comparingData = [this.intensityReport.performanceComparingEmissionIntensity, this.intensityReport.currentStaffData];
            } else {
                this.comparingData = [];
            }
        }
    },

    watch: {
        'activeTabs.lastBox': function activeTabsLastBox(type) {
            this.specifyComparingData(type);
        },
        selectedSiteId: function selectedSiteId() {
            this.fetchAllData();
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.fetchAllData();
        }
    },

    created: function created() {
        this.selectedSiteId = this.route.params.site_id ? Number(this.route.params.site_id) : this.selectedSiteId;
        this.filteredSites = this.sites;
        this.downloadToken = this.token.substr(7);
        this.fetchAllData();
    }
});

/***/ }),

/***/ "ABj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("sYoA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef8d14f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("nx2s");
function injectStyle (ssrContext) {
  __webpack_require__("KlSZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ef8d14f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef8d14f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("cLQJ")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AF+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner"},[_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-line",style:(_vm.lineStyle)}),_vm._v(" "),_c('div',{staticClass:"spinner-circle",style:(_vm.circleStyle)},[_vm._v("\n      ●\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ALfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SiteMultiSelect',
    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    },
    props: {
        givenSites: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        allowEmpty: {
            type: Boolean,
            default: function _default() {
                return true;
            }
        },
        variant: {
            type: String,
            default: function _default() {
                return null;
            }
        },
        selectedSiteId: null,
        selectedRegionId: null
    },
    data: function data() {
        return {
            filteredSites: []
        };
    },

    methods: {
        onInput: function onInput(value) {
            this.$emit('oninput', value);
        },
        multiselectSearch: function multiselectSearch(searchQuery) {
            this.filteredSites = this.searchOnSites(searchQuery, this.givenSites);
        },
        selectAll: function selectAll() {
            this.onInput(null);
            document.getElementById('site-select').blur();
        }
    },
    computed: {
        selectedSite: function selectedSite() {
            var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: this.selectedSiteId });
            if (found) {
                found = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(found));
                if (found.name.length > 16) {
                    found.name = found.name.substr(0, 16) + '...';
                }
            }
            return found;
        }
    },
    watch: {
        givenSites: function givenSites(newVal) {
            this.filteredSites = newVal;
        }
    },
    created: function created() {
        this.filteredSites = this.givenSites;
    }
});

/***/ }),

/***/ "AO3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__ = __webpack_require__("9AED");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_325a6afe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__ = __webpack_require__("aewY");
function injectStyle (ssrContext) {
  __webpack_require__("lOB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-325a6afe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OrbitSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_325a6afe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_OrbitSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "APWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var componentID = __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()();
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'upload',
    props: {
        reactiveId: {
            default: function _default() {
                return null;
            }
        },
        showUpload: {
            default: function _default() {
                return true;
            }
        },
        showDownload: {
            default: function _default() {
                return true;
            }
        },
        showDelete: {
            default: function _default() {
                return true;
            }
        },
        showPopover: {
            default: function _default() {
                return true;
            }
        },
        uploadOnCloud: {
            type: Boolean,
            default: function _default() {
                return null;
            }
        },
        fileCategory: {
            type: String,
            default: function _default() {
                return 'other';
            }
        },
        deleteFromDB: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        dataId: {
            default: function _default() {
                return null;
            }
        }
    },
    data: function data() {
        return {
            componentId: 'a_' + __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
            popoverId: componentID + '_popover',
            buttonRef: componentID + '_button',
            focusRefId: componentID + '_focus',
            newFiles: [],
            action: null,
            popoverShow: false,
            onCloud: false
        };
    },

    methods: {
        inputFile: function inputFile(newFile, oldFile) {
            var _this = this;

            if (this.deleteFromDB && this.dataId && this.onCloud) {
                this.axios.delete('/deleteFromAws/' + this.dataId);
            }
            if (this.onCloud) {
                var file = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(this.newFiles) && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(this.newFiles).file;
                if (file) {
                    var FR = new FileReader();
                    FR.readAsDataURL(file);
                    FR.onload = function (event) {
                        return _this.axios.post('/uploadToAws', {
                            data: event.target.result,
                            type: _this.fileCategory,
                            mimeType: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'type'),
                            size: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'size'),
                            originalFileName: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'name'),
                            userIdOverWrite: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.$store.state.user, 'id')
                        }).then(function (_ref) {
                            var data = _ref.data;

                            _this.$emit('onupload', {
                                id: data.id,
                                fileUrl: data.url,
                                filename: data.filename,
                                fileId: data.fileId,
                                status: 'success',
                                onCloud: _this.onCloud
                            });
                        });
                    };
                }
            } else {
                // Upload file immediately
                if (newFile && !newFile.active && !oldFile) {
                    newFile.active = true; // when set true, upload progress will be start.
                }
                // Get response data
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    this.$emit('onupload', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newFile.response, { onCloud: this.onCloud }));
                    this.popoverShow = false;
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status);
                    }
                }
            }
        },
        inputFilter: function inputFilter(newFile) {
            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }
        },
        onRemove: function onRemove() {
            var _this2 = this;

            if (this.deleteFromDB && this.dataId && this.onCloud) {
                return this.axios.delete('/deleteFromAws/' + this.dataId).then(function () {
                    _this2.$emit('onremove');
                    _this2.popoverShow = false;
                });
            } else {
                this.$emit('onremove');
                this.popoverShow = false;
            }
        },
        onClose: function onClose() {
            this.popoverShow = false;
        },
        onHide: function onHide() {
            this.popoverShow = false;
        },
        onShow: function onShow() {
            /* This is called just before the popover is shown */
            /* Reset our popover "form" variables */
        },
        onShown: function onShown() {
            /* Called just after the popover has been shown */
            /* Transfer focus to the first input */
            this.focusRef(this.$refs[this.focusRefId]);
        },
        onHidden: function onHidden() {
            /* Called just after the popover has finished hiding */
            /* Bring focus back to the button */
            //this.focusRef(this.$refs[this.buttonRef]);
        },
        focusRef: function focusRef(ref) {
            var _this3 = this;

            /* Some references may be a component, functional component, or plain element */
            /* This handles that check before focusing, assuming a focus() method exists */
            /* We do this in a double nextTick to ensure components have updated & popover positioned first */
            this.$nextTick(function () {
                _this3.$nextTick(function () {
                    (ref.$el || ref).focus();
                });
            });
        }
    },
    watch: {
        newFiles: function newFiles(newVal) {
            this.$store.state.uploadFiles = newVal;
        }
    },
    created: function created() {
        this.action = this.apiURL + '/upload';
        this.onCloud = this.uploadOnCloud != null ? this.uploadOnCloud : !(this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId));
    }
});

/***/ }),

/***/ "AbZI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ag4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDetail_vue__ = __webpack_require__("Q239");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c7a160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDetail_vue__ = __webpack_require__("BGkH");
function injectStyle (ssrContext) {
  __webpack_require__("MJgP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49c7a160"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49c7a160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("Q8WP")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AkXk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AuRY":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxMy4yMjkiIHZpZXdCb3g9IjAgMCAxOSAxMy4yMjkiPgogIDxnIGlkPSJieC1zaG93IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi45MTkgLTcuNSkiPgogICAgPHBhdGggaWQ9IlBhdGhfMTEyNSIgZGF0YS1uYW1lPSJQYXRoIDExMjUiIGQ9Ik0xNi4zMzUsMTMuNWEyLjgzNSwyLjgzNSwwLDEsMCwyLjgzNSwyLjgzNUEyLjg1NCwyLjg1NCwwLDAsMCwxNi4zMzUsMTMuNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjkxNiAtMi4yMikiIGZpbGw9IiM3YzdjN2MiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExMjYiIGRhdGEtbmFtZT0iUGF0aCAxMTI2IiBkPSJNMTIuNDE5LDcuNWE5LjkwOSw5LjkwOSwwLDAsMC05LjQsNi4zMTZsLS4xLjMuMS4zYTkuOTEsOS45MSwwLDAsMCw5LjQsNi4zMTYsOS45MDksOS45MDksMCwwLDAsOS40LTYuMzE2bC4xLS4zLS4xLS4zQTkuOTEsOS45MSwwLDAsMCwxMi40MTksNy41Wm0wLDExLjMzOUE3Ljg4Nyw3Ljg4NywwLDAsMSw0LjkzLDE0LjExNCw3Ljg4OCw3Ljg4OCwwLDAsMSwxMi40MTksOS4zOWE3Ljg4Nyw3Ljg4NywwLDAsMSw3LjQ4OSw0LjcyNEE3Ljg4OCw3Ljg4OCwwLDAsMSwxMi40MTksMTguODM5WiIgZmlsbD0iIzdjN2M3YyIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "AyHC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__ = __webpack_require__("8ovZ");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f115833a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__ = __webpack_require__("gIxy");
function injectStyle (ssrContext) {
  __webpack_require__("BWRY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f115833a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FingerprintSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f115833a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FingerprintSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "B4Dv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SiteCard__ = __webpack_require__("vyRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Upload__ = __webpack_require__("jd+X");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        YearSelect: __WEBPACK_IMPORTED_MODULE_8__components_YearSelect__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_7__components_SiteMultiSelect__["a" /* default */],
        UploadRegular: __WEBPACK_IMPORTED_MODULE_6__components_UploadRegular__["a" /* default */],
        SiteCard: __WEBPACK_IMPORTED_MODULE_5__components_SiteCard__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
        Upload: __WEBPACK_IMPORTED_MODULE_10__components_Upload__["a" /* default */]
    },
    name: 'FileDetail',
    data: function data() {
        return {
            isLoaded: false,
            selectedSite: null,
            selectedFolderId: null,
            selectedExistingFolderId: null,
            siteDocuments: [],
            filteredSites: [],
            folderName: null,
            selectedFolderIdToEdit: null,
            folderEditedName: "",
            docs: [],
            otherDocs: [],
            folders: [],
            uploadedFile: null,
            reactiveId: __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default()(),
            fileDate: null
        };
    },

    methods: {
        resetDoc: function resetDoc() {
            this.uploadedFile = null;
            this.folderName = null;
            this.selectedFolderId = null;
        },
        createDoc: function createDoc() {
            var _this = this;

            var payload = {
                file: this.uploadedFile,
                folderName: this.folderName,
                folderId: this.selectedFolderId ? this.selectedFolderId : this.selectedExistingFolderId,
                siteId: this.selectedSite.id,
                documentDate: this.fileDate,
                type: 'other'
            };
            if (!payload.file && payload.folderId) {
                this.$toasted.error(this.$t('missingDocument'));
            } else if (!payload.documentDate && payload.file || !payload.folderName && !payload.folderId) {
                this.$toasted.error(this.$t('missingError'));
            } else {
                this.$Progress.start();
                return this.axios.post('/folders', payload).then(function (_ref) {
                    var data = _ref.data;

                    _this.$Progress.finish();
                    if (_this.selectedFolderId) {
                        _this.otherDocs.forEach(function (doc, index) {
                            if (doc.id === _this.selectedFolderId) {
                                data.document.siteId == _this.selectedSite.id ? _this.otherDocs[index].documents.push(data.document) : _this.$Progress.finish();
                            }
                        });
                    }
                    if (data.document) {
                        _this.folders.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.folder)));
                        data.folder.documents = [data.document];
                        _this.otherDocs.push(data.folder);
                    } else {
                        var newFolder = {};
                        newFolder.id = data.id;
                        newFolder.name = data.name;
                        _this.folders.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newFolder)));
                    }
                    _this.$refs.documentModal.hide();
                    _this.getSiteDocs();
                    _this.resetDoc();
                }).catch(function (err) {
                    _this.$toasted.error(_this.$t(err.response.data.message));
                    _this.$Progress.finish();
                    _this.resetDoc();
                });
            }
        },
        routeTo: function routeTo(site) {
            this.$router.push({
                name: 'site-files',
                params: { site_id: site ? site.id : this.route.params.site_id },
                query: { year: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        init: function init() {
            var _this2 = this;

            var promiseArr = [this.getSiteDocs(), this.getFolders()];
            this.$Progress.start();
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr).then(function () {
                _this2.isLoaded = true;
                _this2.$Progress.finish();
            });
        },
        deleteDocument: function deleteDocument(event, id) {
            var _this3 = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this3.axios.delete('/documents/' + id).then(function () {
                    _this3.siteDocuments = _this3.siteDocuments.filter(function (item) {
                        return item.uuid !== id;
                    });
                    _this3.getSiteDocs();
                }).catch(function () {
                    _this3.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
            });
        },
        openFolderEditModal: function openFolderEditModal(id) {
            this.selectedFolderIdToEdit = id;
            this.folderEditedName = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.folders, function (o) {
                return o.id === id;
            }).name;
            this.$refs.folderEdit.show();
        },
        openFolderDeleteModal: function openFolderDeleteModal(id) {
            this.selectedFolderIdToEdit = id;
            this.$refs.confirmFolderDelete.show();
        },
        editFolder: function editFolder(folderName) {
            var _this4 = this;

            if (this.folderEditedName !== "") {
                var folderId = this.selectedFolderIdToEdit;
                this.$refs.folderEdit.show();
                var payload = {
                    id: folderId,
                    folderName: folderName
                };
                this.$Progress.start();
                return this.axios.put('/folders', payload).then(function () {
                    _this4.$Progress.finish();
                    _this4.init().then(function () {
                        _this4.$refs.folderEdit.hide();
                        _this4.folderEditedName = null;
                    });
                });
            }
        },
        deleteFolder: function deleteFolder(bool) {
            var _this5 = this;

            var folderId = this.selectedFolderIdToEdit;
            if (bool) {
                var currentFolderDocs = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.otherDocs, function (o) {
                    return o.id === folderId;
                }).allDocuments;
                if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(currentFolderDocs)) {
                    this.$Progress.start();
                    return this.axios.delete('/folders/' + folderId).then(function () {
                        _this5.$Progress.finish();
                        _this5.init();
                        _this5.$refs.confirmFolderDelete.hide();
                    }).catch(function () {
                        _this5.$Progress.finish();
                        _this5.$refs.confirmFolderDelete.hide();
                        _this5.$notify({
                            group: 'info',
                            title: _this5.$t('went-wrong'),
                            text: _this5.$t('document-exist'),
                            type: 'error'
                        });
                    });
                } else {
                    this.$toasted.error(this.$t('folderDeletionError'));
                    this.$refs.confirmFolderDelete.hide();
                }
            } else {
                this.$refs.confirmFolderDelete.hide();
            }
        },
        handleRemoving: function handleRemoving() {
            this.uploadedFile = null;
        },
        selectSiteId: function selectSiteId(site) {
            if (!site) {
                this.$router.push({ name: 'doc', query: { year: this.year } });
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                return this.routeTo(site);
                //return this.getSiteDocs();
            }
        },
        onYearChange: function onYearChange(newYear) {
            this.$store.state.year = newYear;
            return this.getSiteDocs().then(this.routeTo);
        },
        getSiteDocs: function getSiteDocs() {
            var _this6 = this;

            this.$Progress.start();
            return this.axios.get(this.route.params.site_id + '/files/others?' + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
                start_date: this.year
            })).then(function (_ref2) {
                var data = _ref2.data;

                // hid folders with empty name
                _this6.otherDocs = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data, function (folder) {
                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(folder, 'name') != null;
                });
                _this6.$Progress.finish();
            });
        },
        getFolders: function getFolders() {
            var _this7 = this;

            return this.axios.get('/folders', {
                params: {
                    folder_type: this.otherFolderTypes
                }
            }).then(function (_ref3) {
                var data = _ref3.data;

                // hid folders with empty name
                _this7.folders = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data, function (folder) {
                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(folder, 'name') != null;
                });
            });
        },
        onupload: function onupload(event) {
            this.uploadedFile = {
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl,
                onCloud: event.onCloud
            };
        },
        onModalHide: function onModalHide(event) {
            var _this8 = this;

            if (this.uploadedFile && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(event, 'trigger') == 'backdrop' && this.uploadedFile.onCloud) {
                this.axios.delete('/deleteFromAws/' + this.uploadedFile.id).then(function () {
                    _this8.uploadedFile = null;
                });
            }
        }
    },
    watch: {
        'route.query': {
            handler: 'init',
            immediate: true
        }
    },
    computed: {
        isSupervisor: function isSupervisor() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        folderNameState: function folderNameState() {
            if (this.folderEditedName) {
                return this.folderEditedName.length > 0 && this.folderEditedName !== " " ? true : false;
            }
            return null;
        }
    },
    created: function created() {
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.selectedSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
        this.filteredSites = this.sites;
        this.isLoaded = false;
    }
});

/***/ }),

/***/ "B8Qm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BAp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__ = __webpack_require__("mfOW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Carousel: __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__["a" /* default */] },
    name: 'ForgotPassword',
    data: function data() {
        return {
            email: null,
            err: null,
            emailError: false,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            showInvalidUserAlert: false,
            hideCarousel: false
        };
    },

    methods: {
        isValid: function isValid() {
            this.emailError = !this.email;
            return !this.emailError;
        },
        forgotPassword: function forgotPassword(email) {
            var _this = this;

            if (this.isValid()) {
                this.$Progress.start();
                return this.axios.post('/forgotPassword', { email: email }).then(function () {
                    _this.$router.push({ path: '/login', query: { passwordResetInfo: true } });
                    _this.$Progress.finish();
                    return true;
                }).catch(function (err) {
                    _this.showInvalidUserAlert = true;
                    _this.err = err;
                    _this.$Progress.finish();
                });
            }
        },
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created: function created() {
        this.onResize();
    },
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
});

/***/ }),

/***/ "BGkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticket)?_c('b-card',[_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"6"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.selectedSiteId, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('predictedDate'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"7"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":true,"format":"dd/MM/yyyy"},model:{value:(_vm.ticket.expectedDate),callback:function ($$v) {_vm.$set(_vm.ticket, "expectedDate", $$v)},expression:"ticket.expectedDate"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('itemType'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"7"}},[_vm._v("\n                        "+_vm._s(_vm.$t(_vm.ticketTypeOptions(_vm.ticket.ticketType)))+"\n                    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t('status'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"7"}},[_vm._v("\n                        "+_vm._s(_vm.retrieveTicketStatus(_vm.ticket.state))+"\n                    ")])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"right","top":"53px"},attrs:{"sm":"5"}},_vm._l((_vm.ticket.originalMembers),function(member,index){return _c('b-row',{key:index,staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center","text-indent":"20px"},attrs:{"sm":"5"}},[_c('label',[_vm._v(_vm._s(_vm.$t(member.type))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","text-indent":"-10px"},attrs:{"sm":"7"}},[_c('label',[_vm._v(_vm._s(((member.firstName) + " " + (member.lastName))))])])],1)}),1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{staticStyle:{"text-align":"right"}},[(_vm.ticket.isErasable)?_c('b-btn',{attrs:{"variant":"danger"},on:{"click":_vm.deleteItem}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.ticket && _vm.ticket.ticketType && (_vm.ticket.ticketType == 'Audit' || _vm.ticket.ticketType == null))?_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"start"}},[_c('TicketDetailCard',{attrs:{"ticket":_vm.ticket,"selectedSiteId":_vm.selectedSiteId,"isPostsEmpty":_vm.ticket.posts.length == 0,"ticketId":_vm.ticketId,"updateFunction":_vm.retrieveTicket,"pageType":"detail"}})],1):_vm._e(),_vm._v(" "),(_vm.ticket && _vm.ticket.ticketType && _vm.ticket.ticketType == 'Action')?_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"start"}},[_c('b-card',{staticStyle:{"width":"100%"}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('nonconformity'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n                        "+_vm._s(_vm.ticket.textInput ? _vm.ticket.textInput : "-")+"\n                    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"cols":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('actionTitle'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","white-space":"pre-line"},attrs:{"sm":"9"}},[_vm._v(_vm._s(_vm.ticket.scope?_vm.$t(_vm.ticket.scope):"-"))])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('note'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_vm._v("\n                        "+_vm._s(_vm.ticket.note ? _vm.ticket.note : "-")+"\n                    ")])],1),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","align-self":"center"},attrs:{"sm":"3"}},[_c('label',[_vm._v(_vm._s(_vm.$t('auditDate'))+":")])]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"sm":"9"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":true,"format":"dd/MM/yyyy"},model:{value:(_vm.ticket.auditDate),callback:function ($$v) {_vm.$set(_vm.ticket, "auditDate", $$v)},expression:"ticket.auditDate"}})],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"start"}},[_c('b-col',[(_vm.$store.state.user.permissions.canStartAudits)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin && !_vm.ticket.state && _vm.ticket.posts.length == 0),expression:"isAdmin && !ticket.state && ticket.posts.length == 0"}],staticStyle:{"float":"left"},on:{"click":function($event){return _vm.showUpdateTicketModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('edit')))]):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAgent && _vm.ticket.posts.length == 0),expression:"isAgent && ticket.posts.length == 0"}],staticStyle:{"float":"right"},on:{"click":function($event){return _vm.showReplyModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('reply')))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-col',_vm._l((_vm.ticket.posts),function(post,index){return _c('b-card',{key:index,style:({'margin-top': '15px', cursor: 'pointer', 'background-color': index%2 === 0 ? '#f7ebca' : ''})},[(!_vm.isAdmin && index%2===0 && index === _vm.ticket.posts.length-1 && !_vm.ticket.state)?_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"}},[_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.deletePost($event, post.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)],1):(_vm.isAdmin && index%2 ===1 && index === _vm.ticket.posts.length-1 && !_vm.ticket.state)?_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"}},[_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.deletePost($event, post.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)],1):_vm._e(),_vm._v(" "),(_vm.isAgent)?_c('b-row',{staticClass:"mt-4",attrs:{"no-gutters":""}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('response'))+":")]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"}},[_vm._v("\n                        "+_vm._s(post.answerText)+"\n                    ")])],1):_vm._e(),_vm._v(" "),(post.documents.length)?_c('b-row',{staticClass:"mt-4",attrs:{"align-h":"start","no-gutters":""}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Documents'))+":")]),_vm._v(" "),_vm._l((post.documents),function(file,index){return _c('b-col',{key:index,staticStyle:{"align-self":"center","cursor":"pointer"},attrs:{"cols":"1"}},[_c('div',{staticStyle:{"text-align":"center"},on:{"click":function($event){return _vm.downloadFile(file.fileUrl)}}},[_c('i',{staticClass:"fas fa-file-alt fa-lg"})]),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v(_vm._s(_vm._f("textToShortText")(file.filename)))])])})],2):_vm._e(),_vm._v(" "),(index%2===0 && index === _vm.ticket.posts.length-1 && !_vm.ticket.state)?_c('b-row',{staticClass:"mt-4",attrs:{"align-h":"end","no-gutters":""}},[(_vm.isAdmin)?_c('b-col',{staticStyle:{"cursor":"pointer"},attrs:{"cols":"2","lg":"1"},on:{"click":function($event){return _vm.showReplyModal($event.target, 'negative')}}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',[_c('i',{staticClass:"fas fa-times-circle fa-lg"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('negativeControl')))])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{staticStyle:{"cursor":"pointer"},attrs:{"cols":"1","lg":"1"},on:{"click":function($event){return _vm.closePost($event)}}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('i',{staticClass:"fas fa-check fa-lg"}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('close')))])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isAgent && post.userId === _vm.$store.state.user.id)?_c('b-col',{staticStyle:{"cursor":"pointer"},attrs:{"cols":"1","lg":"1"}},[_c('b-button',{on:{"click":function($event){_vm.$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? _vm.showUpdatePostModal($event.target, post, 'negative'): _vm.showUpdatePostModal($event.target, post)}}},[_vm._v(_vm._s(_vm.$t('edit')))])],1):_vm._e()],1):(index === _vm.ticket.posts.length-1 && !_vm.ticket.state)?_c('b-row',{staticClass:"mt-4",attrs:{"align-h":"end","no-gutters":""}},[_c('b-col',{attrs:{"cols":"1"}},[(_vm.isAgent)?_c('b-button',{on:{"click":function($event){return _vm.showReplyModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('reply')))]):_vm._e()],1),_vm._v(" "),(_vm.isAgent && post.userId === _vm.$store.state.user.id )?_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{on:{"click":function($event){_vm.$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? _vm.showUpdatePostModal($event.target, post, 'negative'): _vm.showUpdatePostModal($event.target, post)}}},[_vm._v(_vm._s(_vm.$t('edit')))])],1):(_vm.isAdmin && post.userId === _vm.$store.state.user.id )?_c('b-col',{attrs:{"cols":"1"}},[_c('b-button',{on:{"click":function($event){_vm.$store.state.user.permissions.canStartAudits&&post.extendedDate!==null? _vm.showUpdatePostModal($event.target, post, 'negative'): _vm.showUpdatePostModal($event.target, post)}}},[_vm._v(_vm._s(_vm.$t('edit')))])],1):_vm._e()],1):_vm._e()],1)}),1)],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BKK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("r8Mc");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2543d096_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__ = __webpack_require__("QRRz");
function injectStyle (ssrContext) {
  __webpack_require__("xRxJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2543d096"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2543d096_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SelfBuildingSquareSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "BWRY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bbb7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"120px"}},[_c('b-form-select',{staticClass:"gray-select",staticStyle:{"height":"41px !important"},on:{"change":_vm.onchange},model:{value:(_vm.selectedSiteTypeId),callback:function ($$v) {_vm.selectedSiteTypeId=$$v},expression:"selectedSiteTypeId"}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('all')))]),_vm._v(" "),_vm._l((_vm.siteTypes),function(siteType){return _c('option',{domProps:{"value":siteType.id}},[_vm._v(_vm._s(siteType.name))])})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BeMH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BkkN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BmdX":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"postTitle":"HEDEFLER","dataTypeColumn":"Veri Tipi","startYearColumn":"Baz Yıl","endYearColumn":"Hedef Yıl","goalTypeColumn":"Hedef Tipi","goalRatioColumn":"Hedeflenen (%)","currentSituation":"Mevcut Durumu Koruma","decrease":"Azaltma","raise":"Arttırma","longProcessNotification":"Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.","choose-data-type":"Veri tipi seç","deletion-failed":"Silme işlemi gerçekleştirilemedi, tekrar deneyin.","yes":"Evet","no":"Hayır","goal-deletion-warn":"Seçili global hedefi kalıcı olarak silmek istediğinizden emin misiniz?","createGlobalGoal":"Global Hedef Oluştur","updateGlobalGoal":"Global Hedefi Güncelle"},"en":{"postTitle":"GOALS","dataTypeColumn":"Data Type","startYearColumn":"Base Year","endYearColumn":"Target Year","goalTypeColumn":"Goal Type","goalRatioColumn":"Targeted (%)","currentSituation":"No Change","decrease":"Decrease","raise":"Raise","longProcessNotification":"This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.","choose-data-type":"Choose data type","deletion-failed":"Deletion failed, try again.","yes":"Yes","no":"No","goal-deletion-warn":"Are you sure you want to permanently delete the selected global target?","createGlobalGoal":"Create Global Goal","updateGlobalGoal":"Update Global Goal"}}')
}


/***/ }),

/***/ "CJp2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CU6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect_vue__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect_vue__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart_vue__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid_v4__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







//import moment from 'moment';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect_vue__["a" /* default */], RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect_vue__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_6__components_charts_BarChart_vue__["a" /* default */] },
    name: 'Compare',
    data: function data() {
        return {
            isLoaded: false,
            reportDateRange: [],
            compareDateRange: null,
            selectedDataType: null,
            comparableDateRanges: [],
            normalizationType: 0,
            selectedTypeId: null,
            selectedRegionId: null,
            selectedSiteId: null,
            allSiteTypes: [],
            regions: [],
            filteredSites: [],
            isFiltering: false,
            pickerOptions: {
                shortcuts: [{
                    text: 'This month',
                    onClick: function onClick(picker) {
                        var date = new Date();
                        var start = new Date(date.getFullYear(), date.getMonth(), 1);
                        picker.$emit('pick', [start, start]);
                    }
                }, {
                    text: 'This year',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Last 6 months',
                    onClick: function onClick(picker) {
                        var end = new Date();
                        var start = new Date();
                        start.setMonth(start.getMonth() - 6);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            normalizationTypes: [{ id: 0, name: this.$t("-") }, { id: 1, name: this.$t("areaTitle") }, { id: 2, name: this.$t("person") }],
            dataType1Title: "",
            dataType1TitlePart2: "",
            dataType2Title: "",
            dataType2TitlePart2: "",
            rawItems: [],
            lastFilter: null,
            items: [],
            barChartId: __WEBPACK_IMPORTED_MODULE_7_uuid_v4___default()(),
            isDownloading: false,
            barChartUnit: "",
            barChartData: {
                labels: [],
                datasets: []
            },
            colourPalette: ['rgba(168,188,208,1)', 'rgba(66,73,89,1)'],
            barChartOptions: {
                legend: {
                    position: 'bottom'
                },
                title: {
                    display: false,
                    fontColor: '#555', //text: this.$t('comparingScope'),
                    fontSize: 16,
                    padding: 15
                },
                barValueSpacing: 20,
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            min: 0
                        }
                    }]
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        label: function label(tooltipItems) {
                            return tooltipItems.yLabel.toFixed(2);
                        }
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            },
            tableLastSort: null,
            tableSortDir: 'asc'
        };
    },


    filters: {
        toRatio: function toRatio(dividend, divider) {
            divider = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(divider);
            dividend = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(dividend);
            return divider && dividend !== Infinity ? (100 * ((dividend - divider) / divider)).toFixed(0) : '-';
        }
    },

    methods: {
        sortedClass: function sortedClass(key) {
            return this.tableLastSort === key ? 'sorted ' + (this.tableSortDir == 'asc' ? 'asc' : 'desc') : '';
        },
        sortBy: function sortBy() {
            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (key != null) {
                if (key != this.tableLastSort) {
                    this.tableLastSort = key;
                    this.tableSortDir = 'desc';
                } else {
                    this.tableSortDir = this.tableSortDir == 'asc' ? 'desc' : 'asc';
                }
            } else {
                key = this.tableLastSort;
            }

            switch (key) {
                case 'location':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, ['name'], [this.tableSortDir == 'asc' ? 'desc' : 'asc']);
                    break;
                case 'site-type':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, ['type'], [this.tableSortDir == 'asc' ? 'desc' : 'asc']);
                    break;
                case 'region':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, ['region'], [this.tableSortDir == 'asc' ? 'desc' : 'asc']);
                    break;
                case 'area':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.reportingData.properties.area;
                    }, [this.tableSortDir]);
                    break;
                case 'numberOfStaff':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.reportingData.properties.staff;
                    }, [this.tableSortDir]);
                    break;
                case 'dt1':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.reportingData.total.consumption;
                    }, [this.tableSortDir]);
                    break;
                case 'dt2':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.comparingData.total.consumption;
                    }, [this.tableSortDir]);
                    break;
                case 'diffrence':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.change.consumptionChange && o.reportingData.total.consumption && o.comparingData.total.consumption ? o.change.consumptionChange : 0;
                    }, [this.tableSortDir]);
                    break;
                case 'diffrenceRatio':
                    this.items = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(this.items, function (o) {
                        return o.change.consumptionRationChange && o.reportingData.total.consumption && o.comparingData.total.consumption ? o.change.consumptionRationChange : 0;
                    }, [this.tableSortDir]);
                    break;
                default:
                    break;
            }
        },
        getDataTypes: function getDataTypes() {
            var _this = this;

            var filteredOptions = [];
            var units = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.$store.state.dataTypes, function (dataType) {
                var unit = [];
                filteredOptions.push(dataType);
                unit.name = ' (' + _this.$t(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.$store.state.units, { id: dataType.unit_id_1 }).name) + ')';
                unit.id = dataType.id;
                units.push(unit);
            });
            filteredOptions.forEach(function (dataType) {
                dataType.name = _this.$t(dataType.name);
                dataType.unit = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(units, { id: dataType.id }).name;
            });
            return filteredOptions;
        },
        downloadExcel: function downloadExcel() {
            var _this2 = this;

            if (!this.isDownloading) {
                this.isDownloading = true;

                var excelData = {
                    locale: this.$store.state.locale,
                    headers: [this.$t('Location'), this.$t('site-type'), this.$t('regionTitle'), this.$t('areaTitle'), this.$t('numberOfStaff'), this.dataType1Title + " " + this.dataType1TitlePart2, this.dataType2Title + " " + this.dataType2TitlePart2, this.$t('diffrence'), this.$t('diffrence')],
                    data: [[], [], [], [], [], [], [], [], []]
                };

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.items, function (item) {
                    excelData.data[0].push(item.name);
                    excelData.data[1].push(_this2.$t(item.type));
                    excelData.data[2].push(item.region);
                    excelData.data[3].push(item.reportingData.properties.area);
                    excelData.data[4].push(item.reportingData.properties.staff);
                    excelData.data[5].push(item.reportingData.total.consumption ? item.reportingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit : "-");
                    excelData.data[6].push(item.comparingData.total.consumption ? item.comparingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit : "-");
                    excelData.data[7].push(item.change.consumptionChange && item.reportingData.total.consumption && item.comparingData.total.consumption ? item.change.consumptionChange.toFixed(2) + ' ' + item.normalizedUnit : "-");
                    excelData.data[8].push(item.change.consumptionRationChange && item.reportingData.total.consumption && item.comparingData.total.consumption ? item.change.consumptionRationChange.toFixed(0) + "%" : "-");
                });

                this.$Progress.start();
                return this.axios.post('/exportExcel', excelData, { responseType: 'blob', headers: { 'Accept': 'application/vnd.ms-excel' } }).then(function (data) {
                    _this2.downloadExcelBlob(data, "comparison.xlsx");
                    /*
                    var blob = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', "test.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    */
                    _this2.isDownloading = false;
                    return _this2.$Progress.finish();
                });
            }
        },
        isFilterable: function isFilterable() {
            return !(this.selectedDataType == null || this.reportDateRange == null || this.reportDateRange == [] || this.compareDateRange == null || this.filteredSites.length <= 0 || this.isFiltering);
        },
        getFilteredData: function getFilteredData() {
            var _this3 = this;

            if (this.isFilterable()) {
                var filterOptions = {
                    dataTypeId: this.selectedDataType,
                    reportingPeriod: {
                        startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.reportDateRange[0]).format("YYYY-MM-DD"),
                        endDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.reportDateRange[1]).add(1, 'M').format("YYYY-MM-DD")
                    },
                    comparingPeriod: {
                        startDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.reportDateRange[0]).add(this.compareDateRange, 'y').format("YYYY-MM-DD"),
                        endDate: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.reportDateRange[1]).add(this.compareDateRange, 'y').add(1, 'M').format("YYYY-MM-DD")
                    },
                    normalizationType: this.normalizationType,
                    siteTypeId: this.selectedTypeId,
                    regionId: this.selectedRegionId,
                    siteId: this.selectedSiteId,
                    locale: this.$store.state.locale
                };

                this.isFiltering = true;
                return this.axios.post('/getComparisonData', filterOptions).then(function (_ref) {
                    var data = _ref.data;

                    _this3.rawItems = data;
                    _this3.lastFilter = filterOptions;
                    _this3.prepareData(data, filterOptions);
                    _this3.isFiltering = false;
                });
            }
        },
        rePrepareData: function rePrepareData() {
            this.prepareData(this.rawItems, this.lastFilter);
        },
        prepareData: function prepareData(data, filterOptions) {
            var _this4 = this;

            var normalizationType = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.normalizationTypes, function (nt) {
                return nt.id == filterOptions.normalizationType;
            }));
            var dataType = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.dataTypes, function (dt) {
                return dt.id == filterOptions.dataTypeId;
            }));
            var dataUnit = this.$t(dataType.unit.replace(/[()]+/g, ''));

            this.dataType1Title = this.$t(dataType.name);
            this.dataType1TitlePart2 = "(" + __WEBPACK_IMPORTED_MODULE_3_moment___default()(filterOptions.reportingPeriod.startDate).lang(this.$store.state.locale).format("MMM YYYY") + " - " + __WEBPACK_IMPORTED_MODULE_3_moment___default()(filterOptions.reportingPeriod.endDate).add(-1, 'M').lang(this.$store.state.locale).format("MMM YYYY") + ")";
            this.dataType2Title = this.$t(dataType.name);
            this.dataType2TitlePart2 = "(" + __WEBPACK_IMPORTED_MODULE_3_moment___default()(filterOptions.comparingPeriod.startDate).lang(this.$store.state.locale).format("MMM YYYY") + " - " + __WEBPACK_IMPORTED_MODULE_3_moment___default()(filterOptions.comparingPeriod.endDate).add(-1, 'M').lang(this.$store.state.locale).format("MMM YYYY") + ")";

            this.barChartData = {
                labels: [],
                datasets: []
            };

            var barChardKeysForComparation = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(data).comparingData.data);
            var barChardKeysForReporting = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(data).reportingData.data);
            this.barChartData.labels = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(data).comparingData.data, function (o) {
                return o.month;
            });

            var comparationDataArray = Array(barChardKeysForComparation.length).fill(0);
            var reportingDataArray = Array(barChardKeysForComparation.length).fill(0);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(data, function (d) {
                var comparingTotal = { consumption: 0, cost: 0 };
                var reportTotal = { consumption: 0, cost: 0 };

                if (normalizationType.id == 1) {
                    d.normalizedUnit = dataUnit + '/m2';
                    d.comparingData.normalizationValue = d.comparingData.properties.area;
                    d.reportingData.normalizationValue = d.reportingData.properties.area;
                } else if (normalizationType.id == 2) {
                    d.normalizedUnit = dataUnit + '/' + _this4.$t('person');
                    d.comparingData.normalizationValue = d.comparingData.properties.staff;
                    d.reportingData.normalizationValue = d.reportingData.properties.staff;
                } else {
                    d.normalizedUnit = dataUnit;
                    d.comparingData.normalizationValue = 1;
                    d.reportingData.normalizationValue = 1;
                }

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(d.comparingData.data, function (cData) {
                    cData.normalizedConsumption = cData.consumption && d.comparingData.normalizationValue ? cData.consumption / d.comparingData.normalizationValue : 0;
                    cData.normalizedCost = cData.cost && d.comparingData.normalizationValue ? cData.cost / d.comparingData.normalizationValue : 0;

                    comparingTotal.consumption += cData.normalizedConsumption ? cData.normalizedConsumption : 0;
                    comparingTotal.cost += cData.normalizedCost ? cData.normalizedCost : 0;
                });
                d.comparingData.total = comparingTotal;
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(d.reportingData.data, function (rData) {
                    rData.normalizedConsumption = rData.consumption && d.reportingData.normalizationValue ? rData.consumption / d.reportingData.normalizationValue : 0;
                    rData.normalizedCost = rData.cost && d.reportingData.normalizationValue ? rData.cost / d.reportingData.normalizationValue : 0;

                    reportTotal.consumption += rData.normalizedConsumption ? rData.normalizedConsumption : 0;
                    reportTotal.cost += rData.normalizedCost ? rData.normalizedCost : 0;
                });

                d.reportingData.total = reportTotal;

                d.change = {
                    consumptionChange: reportTotal.consumption - comparingTotal.consumption,
                    consumptionRationChange: (reportTotal.consumption - comparingTotal.consumption) / comparingTotal.consumption * 100,
                    costChange: reportTotal.cost - comparingTotal.cost,
                    costRationChange: (reportTotal.cost - comparingTotal.cost) / comparingTotal.cost * 100
                };
                d.style = "";

                if (d.change.consumptionRationChange < -30 || d.change.consumptionRationChange > 30) {
                    d.style = "color:#DC143C;";
                } else {
                    d.style = "color:#000;";
                }

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(barChardKeysForComparation, function (key, index) {
                    comparationDataArray[index] += __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(d.comparingData.data, key).normalizedConsumption;
                    reportingDataArray[index] += __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(d.reportingData.data, barChardKeysForReporting[index]).normalizedConsumption;
                });
            });

            /*
            this.barChartUnit = _.head(data).normalizedUnit;
            this.barChartOptions.tooltips.callbacks.label = function(tooltipItems) {
                                                                return tooltipItems.yLabel.toFixed(2)+" "+this.barChartUnit;
                                                            }
            */

            this.barChartData.datasets.push({
                label: this.$t('reporting-period'),
                backgroundColor: this.colourPalette[1],
                data: reportingDataArray
            });
            this.barChartData.datasets.push({
                label: this.$t('comparing-period'),
                backgroundColor: this.colourPalette[0],
                data: comparationDataArray
            });

            this.items = data;
            this.sortBy();
        },
        retriveData: function retriveData() {
            //this.barChartData.height = 500;
            this.allSiteTypes = [{ id: null, name: this.$t('all') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteTypes));
            this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
            this.setFilteredSiteList();

            this.pickerOptions.shortcuts[0].text = this.$t("this-month");
            this.pickerOptions.shortcuts[1].text = this.$t("this-year");
            this.pickerOptions.shortcuts[2].text = this.$t("last-6-months");
            this.isLoaded = true;
        },
        setFilteredSiteList: function setFilteredSiteList() {
            var _this5 = this;

            this.selectedSiteId = null;
            this.filteredSites = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.sites, function (site) {
                if (_this5.selectedTypeId == null && _this5.selectedRegionId == null) {
                    return true;
                } else if (_this5.selectedRegionId == null) {
                    return site.typeId == _this5.selectedTypeId;
                } else if (_this5.selectedTypeId == null) {
                    return site.siteGroupId == _this5.selectedRegionId;
                } else {
                    return site.siteGroupId == _this5.selectedRegionId && site.typeId == _this5.selectedTypeId;
                }
            });
        }
    },
    watch: {
        selectedTypeId: function selectedTypeId() {
            this.selectedSiteId = null;
            this.setFilteredSiteList();
        },
        selectedRegionId: function selectedRegionId() {
            this.selectedSiteId = null;
            this.setFilteredSiteList();
        },
        reportDateRange: function reportDateRange(val) {
            if (val[0] && val[1]) {
                this.comparableDateRanges = [];
                for (var i = -5; i < 0; i++) {
                    if (i == 0) {
                        continue;
                    }
                    this.comparableDateRanges.push({
                        'id': i,
                        'name': Math.abs(i) + " " + (i > 0 ? this.$t('next-year') : this.$t('previous-year')) + " (" + __WEBPACK_IMPORTED_MODULE_3_moment___default()(val[0]).add(i, 'y').lang(this.$store.state.locale).format('MMM YYYY') + " - " + __WEBPACK_IMPORTED_MODULE_3_moment___default()(val[1]).add(i, 'y').lang(this.$store.state.locale).format('MMM YYYY') + ")"
                    });
                }
                this.compareDateRange = -1;
            }
        },
        normalizationType: function normalizationType(val) {
            this.lastFilter.normalizationType = val;
            this.rePrepareData();
        }
    },

    created: function created() {
        this.retriveData();
    }
});

/***/ }),

/***/ "CXlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('region-multi-select',{staticStyle:{"margin-right":"10px"},attrs:{"selectedRegionId":_vm.selectedSiteGroupId,"regions":_vm.siteGroups},on:{"oninput":_vm.selectSiteGroupId}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSites},on:{"oninput":_vm.selectSiteId}})],1)],1),_vm._v(" "),_c('div',{staticClass:"scroll-content"},[_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.distributions, consumptions: _vm.initialEmissions.consumption, isSummary: true},"title":_vm.$t('summaryOfCarbonEmission'),"group-type":'scopeGroup'}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds? _vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'stationaryCombustion'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('stationaryCombustion')}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds? _vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'refrigerants'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('refrigerants')}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds? _vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'companyVehicles'; }) : null,
                    consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('companyVehicles')}})],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CYan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope1_vue__ = __webpack_require__("IC/m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_871051a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope1_vue__ = __webpack_require__("CXlR");
function injectStyle (ssrContext) {
  __webpack_require__("ty9o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-871051a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_871051a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7Fw5")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ClgQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cyey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart__ = __webpack_require__("fKQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixin__ = __webpack_require__("rKvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_charts_BarChart__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Analysis_Tabs_components_TotalCarbonEmissions__ = __webpack_require__("dSCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Analysis_Tabs_components_TotalCarbonConsumptions__ = __webpack_require__("NYoC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jquery__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var $ = __WEBPACK_IMPORTED_MODULE_17_jquery___default.a;

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TotalCarbonConsumptions: __WEBPACK_IMPORTED_MODULE_16__Analysis_Tabs_components_TotalCarbonConsumptions__["a" /* default */],
        TotalCarbonEmissions: __WEBPACK_IMPORTED_MODULE_15__Analysis_Tabs_components_TotalCarbonEmissions__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_14__components_YearSelect__["a" /* default */],
        SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_13__components_SiteTypeSelect__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_12__components_SiteMultiSelect__["a" /* default */],
        RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_11__components_RegionMultiSelect__["a" /* default */],
        BarChart: __WEBPACK_IMPORTED_MODULE_10__components_charts_BarChart__["a" /* default */],
        PieChart: __WEBPACK_IMPORTED_MODULE_8__components_charts_PieChart__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_9__mixin__["a" /* default */]],
    name: 'Dashboard',
    data: function data() {
        return {
            activeTabs: {
                firstBox: 'carbon'
            },
            isLoaded: false,
            selectedSiteId: null,
            selectedExcelType: null,
            selectedSiteGroupId: null,
            selectedSiteSubAgent: null,
            selectedSiteSupervisor: null,
            filteredSites: [],
            pieChartId: __WEBPACK_IMPORTED_MODULE_7_uuid_v4___default()(),
            initialEmissions: {
                current: [],
                past: [],
                emissionTypes: []
            },
            initialConsumptions: {
                currentConsumptions: [],
                pastConsumptions: []
            },
            dataHealths: [],
            emissions: null,
            selectedSiteTypeId: null,
            chartDataTypes: this.$store.state.dashboardDataTypes,
            selectedChartDataTypes: [],
            excelTypes: [{
                value: null,
                text: this.$t('chooseExcel'),
                disabled: true
            }, {
                value: 1,
                text: this.$t('monthly')
            }, {
                value: 2,
                text: this.$t('yearly')
            }, {
                value: 3,
                text: this.$t('auditDateReport')
            }, {
                value: 4,
                text: this.$t('goalTracking')
            }, {
                value: 5,
                text: this.$t('auditItemTracking')
            }, {
                value: 6,
                text: this.$t('dataQualityAlerts')
            }]
        };
    },

    methods: {
        exportExcel: function exportExcel(value) {
            var _this = this;

            this.selectedExcelType = undefined;
            this.$refs.excelTypes.hide();
            // if value of dropdown item equals 1 , it is monthly. Otherwise it is yearly export.

            this.axios.post('/canRequestReport', {}).then(function (_ref) {
                var data = _ref.data;

                if (data == "Sending report") {

                    if (value == 1) {
                        window.open(_this.apiURL + '/dataExport?year=' + _this.year + '&locale=' + _this.$store.state.locale + '&token=' + _this.downloadToken);
                    } else if (value == 2) {
                        window.open(_this.apiURL + '/yearlyDataExport?locale=' + _this.$store.state.locale + '&token=' + _this.downloadToken);
                    } else if (value == 3) {
                        window.open(_this.apiURL + '/auditDateReportExport?locale=' + _this.$store.state.locale + '&year=' + _this.year + '&token=' + _this.downloadToken);
                    } else if (value == 4) {
                        /*
                        window.open(
                            `${this.apiURL}/goalTrackingExport?locale=${this.$store.state.locale}&year=${
                                this.year
                            }&token=${this.downloadToken}`
                        );
                        */
                        var insertedItem = {
                            year: _this.$store.state.year,
                            locale: _this.$store.state.locale
                        };
                        _this.$Progress.start();
                        return _this.axios.post('/goalTrackingMail', insertedItem).then(function (_ref2) {
                            var data = _ref2.data;

                            if (data == "Sending goal report mail") {
                                _this.showNotificationModal(_this.$t('Goal-report-notification'));
                            } else {
                                _this.showErrorNotification(_this.$t('Goal-report-already-requested'));
                            }
                            return _this.$Progress.finish();
                        });
                    } else if (value == 5) {
                        window.open(_this.apiURL + '/auditItemTrackingExport?locale=' + _this.$store.state.locale + '&year=' + _this.year + '&token=' + _this.downloadToken);
                    } else if (value == 6) {
                        /* Download report
                        window.open(
                            `${this.apiURL}/dataQualityAlertsExport?locale=${this.$store.state.locale}&year=${
                                this.year
                            }&token=${this.downloadToken}`
                        );
                        */
                        // Send report mail
                        var _insertedItem = {
                            year: _this.$store.state.year,
                            locale: _this.$store.state.locale
                        };
                        _this.$Progress.start();
                        return _this.axios.post('/dataQualityAlertsMail', _insertedItem).then(function (_ref3) {
                            var data = _ref3.data;

                            if (data == "Sending quality alert report mail") {
                                _this.showNotificationModal(_this.$t('Quality-alert-report-notification'));
                            } else {
                                _this.showErrorNotification(_this.$t('Quality-alert-report-already-requested'));
                            }
                            return _this.$Progress.finish();
                        });
                    }
                } else {
                    _this.showErrorNotification(_this.$t('Already-requested'));
                }
                return _this.$Progress.finish();
            }).catch(function () {
                _this.showErrorNotification(_this.$t('Unknown error'));
            });
        },
        showFormDropDown: function showFormDropDown() {
            $(document).ready(function () {
                $('.dropdown').addClass('open');
            });
        },
        filterConsumptions: function filterConsumptions(consumptions) {
            consumptions.currentConsumptions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(consumptions.currentConsumptions, function (o) {
                return o.type !== 'atm';
            });
            consumptions.pastConsumptions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(consumptions.pastConsumptions, function (o) {
                return o.type !== 'atm';
            });
        },
        selectSiteGroupId: function selectSiteGroupId(value) {
            if (value) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.selectSiteId(null);
        },
        selectSiteId: function selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.routeToDashboard(this.selectedSiteId, this.year);
            this.init();
        },
        routeToDocumentDetail: function routeToDocumentDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'site-files',
                    params: { site_id: this.selectedSiteId },
                    query: { year: this.year }
                });
            } else {
                this.$router.push({
                    name: 'doc',
                    query: { year: this.year }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeToData: function routeToData() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'site-data-types',
                    params: { site_id: this.selectedSiteId },
                    query: {
                        type: 'consumption',
                        year: this.year
                    }
                });
            } else {
                this.$router.push({ name: 'data-sites' });
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeToGoalDetail: function routeToGoalDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'goal-detail',
                    params: { site_id: this.selectedSiteId }
                });
            } else {
                this.$router.push({
                    name: 'goal',
                    query: { year: this.year }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeToFormCreate: function routeToFormCreate(id) {
            if (this.selectedSiteId) {
                if (id && this.$store.state.user.permissions.canEditData) {
                    this.$router.push({
                        name: 'form-create',
                        params: { site_id: this.selectedSiteId, form_type: id }
                    });
                } else {
                    this.$router.push({
                        name: 'site-forms',
                        params: { site_id: this.selectedSiteId }
                    });
                }
            } else {
                this.$router.push({
                    name: 'forms'
                });
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeToAuditDetail: function routeToAuditDetail() {
            if (this.selectedSiteId) {
                this.$router.push({
                    name: 'ticket-list',
                    params: { site_id: this.selectedSiteId },
                    query: { start_date: this.year }
                });
            } else {
                this.$router.push({
                    name: 'audit',
                    query: { year: this.year }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeToLibrary: function routeToLibrary() {
            this.$router.push({
                name: 'library'
            });
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
        },
        retrieveEmissions: function retrieveEmissions() {
            var _this2 = this;

            var query = {
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1
            };

            if (this.selectedSiteId) {
                query['siteId'] = this.selectedSiteId;
            } else if (this.selectedSiteGroupId) {
                query['groupId'] = this.selectedSiteGroupId;
            }

            return this.axios.get('/report/emission?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(query)).then(function (_ref4) {
                var data = _ref4.data;

                _this2.initialEmissions = data;
                return data;
            });
        },
        retrieveConsumptions: function retrieveConsumptions(year, site_id, site_group_id, source_types) {
            return this.axios.get('/report/consumptions?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify({
                year: year,
                site_id: site_id,
                site_group_id: site_group_id,
                source_types: source_types
            }, {
                skipNulls: true
            })).then(function (_ref5) {
                var data = _ref5.data;

                return data;
            });
        },
        retrieveEmissionConsumptions: function retrieveEmissionConsumptions() {
            var _this3 = this;

            var query = {
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1
            };
            if (this.selectedSiteId) {
                query['siteId'] = this.selectedSiteId;
            } else if (this.selectedSiteGroupId) {
                query['groupId'] = this.selectedSiteGroupId;
            }
            return this.axios.get('/report/consumption?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify(query)).then(function (_ref6) {
                var data = _ref6.data;

                _this3.initialConsumptions = data;
                _this3.filterConsumptions(_this3.initialConsumptions);
                return data;
            });
        },
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        onYearChange: function onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.routeToDashboard(this.selectedSiteId, this.year);
            this.init();
        },
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedSiteId = null;
            this.selectedSiteGroupId = null;
            if (siteTypeId) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.typeId === siteTypeId;
                });
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
        },
        retrieveDataHealths: function retrieveDataHealths() {
            var _this4 = this;

            return this.axios.get('/health?' + __WEBPACK_IMPORTED_MODULE_6_qs___default.a.stringify({
                year: this.year
            })).then(function (_ref7) {
                var data = _ref7.data;

                _this4.dataHealths = data;
                return data;
            });
        },
        init: function init() {
            var _this5 = this;

            this.$Progress.start();
            if (this.selectedSiteId) {
                /*
                let site_id = this.selectedSiteId;
                let subAgent_id = _.first(this.selectedSite.subAgentIds);
                this.selectedSiteSubAgent = _.first(_.filter(this.$store.state.agentList, function(o){
                    return o.site_id == site_id && o.id == subAgent_id;
                }));
                // @todo: like supervisor other user types should use first and last names
                // In order to use them backend send supervisorList and directorList,
                let agent_id = _.first(this.selectedSite.agentList);
                let director_id = _.first(this.selectedSite.directorIds);
                let supervisor_id = _.first(this.selectedSite.supervisorIds);                
                this.selectedSiteAgent = _.first(_.filter(this.$store.state.agentList, function(o){
                    return o.site_id == site_id && o.id == _.first(this.selectedSite.agentIds);
                }));
                this.selectedSupervisor = _.first(_.filter(this.$store.state.supervisorList, function(o){
                    return o.site_id == site_id && o.id == _.first(this.selectedSite.supervisorIds);
                }));
                this.selectedDirector = _.first(_.filter(this.$store.state.directorList, function(o){
                    return o.site_id == site_id && o.id == director_id;
                }));
                */
            }
            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([this.retrieveEmissions(), this.retrieveEmissionConsumptions(), this.fetchAndConfigureConsumptions(), this.$store.dispatch('getDocumentCounts', this.year), this.$store.dispatch('getGoalCounts', this.year), this.$store.dispatch('getAuditCounts', this.year), this.retrieveDataHealths()]).then(function () {
                _this5.$Progress.finish();
            });
        },
        prepareConsumptionChartData: function prepareConsumptionChartData() {
            var _this6 = this;

            var _consumptions = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.consumptions);
            this.chartDataTypes.forEach(function (typeId) {
                _consumptions[typeId].barChartData.datasets[0].data = _consumptions[typeId].barChartData.datasets[0].data.map(function () {
                    return 0;
                });
                _consumptions[typeId].barChartData.datasets[1].data = _consumptions[typeId].barChartData.datasets[1].data.map(function () {
                    return 0;
                });
                _consumptions[typeId].current.forEach(function (consumption) {
                    _consumptions[typeId].barChartData.datasets[1].data[Number(consumption.date) - 1] += Number(consumption.value.toFixed(2));
                });
                _consumptions[typeId].previous.forEach(function (consumption) {
                    _consumptions[typeId].barChartData.datasets[0].data[Number(consumption.date) - 1] += Number(consumption.value.toFixed(2));
                });
                var max = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.max([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_consumptions[typeId].barChartData.datasets[1].data), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_consumptions[typeId].barChartData.datasets[0].data)));
                var digitLength = max.toString().split('.')[0].length;
                var maxVal = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.round(max, -1 * (digitLength - 1)) + Number('1' + '0'.repeat(digitLength - 1));

                _consumptions[typeId].barChartOptions.scales.yAxes[0].ticks.stepSize = maxVal / 10;
            });
            this.consumptions = _consumptions;
            this.chartDataTypes.forEach(function (typeId) {
                _this6.$eventHub.$emit(_this6.consumptions[typeId].chartId);
            });
        },
        fetchAndConfigureConsumptions: function fetchAndConfigureConsumptions() {
            var _this7 = this;

            this.isLoaded = false;
            return this.retrieveConsumptions(this.year, this.selectedSiteId, this.selectedSiteGroupId, this.chartDataTypes).then(function (current) {
                _this7.selectedChartDataTypes = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(_this7.chartDataTypes);
                return _this7.retrieveConsumptions(_this7.year - 1, _this7.selectedSiteId, _this7.selectedSiteGroupId, _this7.chartDataTypes).then(function (previous) {
                    _this7.chartDataTypes.forEach(function (typeId) {
                        _this7.consumptions[typeId].current = current.filter(function (consumption) {
                            return consumption.dataType === typeId;
                        });
                        _this7.consumptions[typeId].previous = previous.filter(function (consumption) {
                            return consumption.dataType === typeId;
                        });
                    });
                    return { current: current, previous: previous };
                });
            }).then(function () {
                _this7.prepareConsumptionChartData();
                _this7.isLoaded = true;
            });
        },
        setReportTypes: function setReportTypes() {
            if (this.gbId(this.$store.state.user.customerId)) {
                this.excelTypes = [{
                    value: null,
                    text: this.$t('chooseExcel'),
                    disabled: true
                }, {
                    value: 1,
                    text: this.$t('monthly')
                }, {
                    value: 2,
                    text: this.$t('yearly')
                }, {
                    value: 3,
                    text: this.$t('auditDateReport')
                }, {
                    value: 4,
                    text: this.$t('goalTracking')
                }, {
                    value: 5,
                    text: this.$t('auditItemTracking')
                }];
            }
        }
    },
    computed: {
        selectedSiteGroup: function selectedSiteGroup() {
            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.siteGroups, { id: this.selectedSiteGroupId });
            if (found) {
                found = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(found));
                found.display_name = found.display_name.substr(0, 8) + '...';
            }
            return found;
        },
        totalOpenedTicketCount: function totalOpenedTicketCount() {
            var _this8 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.audits, { siteId: this.selectedSiteId });
            if (found) {
                return found.openedAuditCount;
            } else {
                var total = 0;
                this.audits.forEach(function (audit) {
                    if (_this8.selectedSiteGroupId) {
                        var _found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this8.sites, { id: audit.siteId });
                        if (_found.siteGroupId === _this8.selectedSiteGroupId) {
                            total += audit.openedAuditCount;
                        }
                    } else {
                        total += audit.openedAuditCount;
                    }
                });
                return total;
            }
        },
        totalTicketCount: function totalTicketCount() {
            var _this9 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.audits, { siteId: this.selectedSiteId });
            if (found) {
                return found.totalAuditCount;
            } else {
                var total = 0;
                this.audits.forEach(function (audit) {
                    if (_this9.selectedSiteGroupId) {
                        var _found2 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this9.sites, { id: audit.siteId });
                        if (_found2.siteGroupId === _this9.selectedSiteGroupId) {
                            total += audit.totalAuditCount;
                        }
                    } else {
                        total += audit.totalAuditCount;
                    }
                });
                return total;
            }
        },
        totalDocCount: function totalDocCount() {
            var _this10 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.documents, { site_id: this.selectedSiteId });
            if (found) {
                return found.count;
            } else {
                var total = 0;
                this.documents.forEach(function (document) {
                    if (_this10.selectedSiteGroupId) {
                        var _found3 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this10.sites, { id: document.site_id });
                        if (_found3.siteGroupId === _this10.selectedSiteGroupId) {
                            total += document.count;
                        }
                    } else {
                        total += document.count;
                    }
                });
                return total;
            }
        },
        totalApprovedGoalCount: function totalApprovedGoalCount() {
            var _this11 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.goals, { site_id: this.selectedSiteId });
            if (found) {
                return found.approved_count;
            } else {
                var total = 0;
                this.$store.state.goals.forEach(function (goal) {
                    if (_this11.selectedSiteGroupId) {
                        var _found4 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this11.sites, { id: goal.site_id });
                        if (_found4.siteGroupId === _this11.selectedSiteGroupId) {
                            total += goal.approved_count;
                        }
                    } else {
                        total += goal.approved_count;
                    }
                });
                return total;
            }
        },
        totalDataHealthRatio: function totalDataHealthRatio() {
            var _this12 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.dataHealths, { siteId: this.selectedSiteId });
            if (found) {
                return found.health;
            } else {
                var total = 0;
                var count = 0;
                this.dataHealths.forEach(function (site) {
                    if (_this12.selectedSiteGroupId) {
                        var _found5 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this12.sites, { id: site.siteId });
                        if (_found5.siteGroupId === _this12.selectedSiteGroupId) {
                            total += site.health;
                            count++;
                        }
                    } else {
                        total += site.health;
                        count++;
                    }
                });
                return count ? Number((total / count).toFixed(2)) : 0;
            }
        },
        totalGoalCount: function totalGoalCount() {
            var _this13 = this;

            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.goals, { site_id: this.selectedSiteId });
            if (found) {
                return found.count;
            } else {
                var total = 0;
                this.$store.state.goals.forEach(function (goal) {
                    if (_this13.selectedSiteGroupId) {
                        var _found6 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this13.sites, { id: goal.site_id });
                        if (_found6.siteGroupId === _this13.selectedSiteGroupId) {
                            total += goal.count;
                        }
                    } else {
                        total += goal.count;
                    }
                });
                return total;
            }
        },
        cityCodeToDisplayName: function cityCodeToDisplayName() {
            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.cities, { code: this.selectedSite.cityCode });
            if (found) {
                return found.name;
            } else {
                return '-';
            }
        },
        groupDisplayName: function groupDisplayName() {
            if (this.selectedSite) {
                var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.siteGroups, {
                    id: this.selectedSite.siteGroupId
                });
                return found.display_name;
            } else if (this.selectedSiteGroupId) {
                var _found7 = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.$store.state.siteGroups, {
                    id: this.selectedSiteGroupId
                });
                return _found7.display_name;
            } else {
                return this.$t('allRegions');
            }
        },
        totalStaffCount: function totalStaffCount() {
            var _this14 = this;

            if (this.selectedSiteId) {
                var property = this.getLastFilledProperty(this.selectedSite, 'staffCount');
                return property && property.staffCount ? property.staffCount : '-';
            } else {
                var total = 0;
                this.filteredSites.forEach(function (site) {
                    if (site.yearlyProperties[_this14.year] && site.yearlyProperties[_this14.year].staffCount) {
                        total += site.yearlyProperties[_this14.year].staffCount;
                    } else {
                        var _property = _this14.getLastFilledProperty(site, 'staffCount');
                        var count = _property && _property.staffCount ? _property.staffCount : 0;
                        total += count;
                    }
                });

                return total;
            }
        },
        totalArea: function totalArea() {
            var _this15 = this;

            if (this.selectedSiteId) {
                var property = this.getLastFilledProperty(this.selectedSite, 'area');
                return property && property.area ? property.area : '-';
            } else {
                var total = 0;
                this.filteredSites.forEach(function (site) {
                    if (site.yearlyProperties[_this15.year] && site.yearlyProperties[_this15.year].area) {
                        total += site.yearlyProperties[_this15.year].area;
                    } else {
                        var _property2 = _this15.getLastFilledProperty(site, 'area');
                        total += _property2 && _property2.area ? _property2.area : 0;
                    }
                });
                return total.toFixed(0);
            }
        },
        selectedSite: function selectedSite() {
            var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(this.sites, { id: this.selectedSiteId });
            if (found) {
                found = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(found));
                found.name = found.name.substr(0, 8) + '...';
            }
            return found;
        },
        hasAnyCarbonEmission: function hasAnyCarbonEmission() {
            return this.emissions && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.emissions).length;
        }
    },
    watch: {
        'route.query.site_id': function routeQuerySite_id() {
            this.fetchAndConfigureConsumptions();
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.retrieveEmissions();
            this.retrieveEmissionConsumptions();
            this.fetchAndConfigureConsumptions();
        },

        year: function year() {
            // Update date in chart
            for (var attributename in this.consumptions) {
                this.consumptions[attributename].barChartData.datasets[0].label = this.year - 1;
                this.consumptions[attributename].barChartData.datasets[1].label = this.year;
            }
        }
    },
    created: function created() {
        var siteId = Number(this.route.query.site_id);
        this.downloadToken = this.token.substr(7);
        this.selectedSiteId = siteId ? siteId : null;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        // if an agent logged in, since there is one site, both state.siteId and selectedSite will be that site.
        __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.size(this.filteredSites) == 1 && (this.selectedSiteId = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(this.filteredSites).id) && (this.$store.state.siteId = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(this.filteredSites).id);
        this.generateBarChartOptions();
        this.setReportTypes();
        this.init();
    }
});

/***/ }),

/***/ "DC4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Carousel',
    data: function data() {
        return {
            carouselItems: [{
                id: 1,
                image: '../../static/carousel_images/ConsolidateSustainabilityData_illustration.svg',
                title: 'ConsolidateSustainabilityDataTitle',
                text: 'ConsolidateSustainabilityDataText'
            }, {
                id: 2,
                image: '../../static/carousel_images/StreamlineGHGEmissionsReporting_illustration.svg',
                title: 'StreamlineGHGEmissionsReportingTitle',
                text: 'StreamlineGHGEmissionsReportingText'
            }, {
                id: 3,
                image: '../../static/carousel_images/TrackNetZeroGoals_illustration.svg',
                title: 'TrackNetZeroGoalsTitle',
                text: 'TrackNetZeroGoalsText'
            }, {
                id: 4,
                image: '../../static/carousel_images/manageAudits_illustration.svg',
                title: 'ManageAuditsTitle',
                text: 'ManageAuditsText'
            }, {
                id: 5,
                image: '../../static/carousel_images/CreateSustainabilityRepository_illustration.svg',
                title: 'CreateSustainabilityRepositoryTitle',
                text: 'CreateSustainabilityRepositoryText'
            }],
            slide: 0,
            sliding: null
        };
    },

    methods: {
        onSlideStart: function onSlideStart() {
            this.sliding = true;
        },
        onSlideEnd: function onSlideEnd() {
            this.sliding = false;
        }
    }
});

/***/ }),

/***/ "DDy4":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"tags":"Etiket Yönetimi","locationsManagement":"Lokasyon ve Sektör Yönetimi","emissionLibraryManagement":"Emisyon Kütüphanesi Yönetimi"},"en":{"tags":"Tag Management","locationsManagement":"Location & Sector Management","emissionLibraryManagement":"Emission Library Management"}}')
}


/***/ }),

/***/ "DFUc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHNU":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"userTitle":"Hesap","personalInformationSubTitle":"Kişisel Bilgiler","firstName":"Ad","lastName":"Soyad","email":"E-posta","department":"Departman","jobTitle":"Ünvan","languagePreference":"Dil Seçimi","permissionsTitle":"İzinler","turkish":"Türkçe","english":"İngilizce","firstNamePlaceholder":"Ör: Ayşe","lastNamePlaceholder":"Ör: Yılmaz","emailPlaceholder":"Ör: ayse.yilmaz@mail.com","departmentPlaceholder":"Ör: IT","jobTitlePlaceholder":"Ör: Bilgisayar Mühendisi","rolesGroups":"Roller/Gruplar","locations":"Lokasyonlar","selectRolesGroups":"Rol(ler) Seçin","selectLocations":"Lokasyon(lar) Seçin","selectAll":"Hepsini Seç","firstNameValidationError":"Lütfen adınızı girin","lastNameValidationError":"Lütfen soyadınızı girin","emailValidationError":"Lütfen geçerli bir e-posta girin","editPhoto":"Fotoğrafı Düzenle","youCantRemoveAdminFromYourSelf":"Kendinizden admin yetkisini silemessiniz","adminGroupError":"Admin grubundan kullanıcı çıkarma işlemi \\"Kullanıcı İzinleri\\" sayfasından yapılabilir","mailInUseError":"Bu e-posta adresi başka bir kullanıcı tarafından kullanılıyor. Farklı bir e-posta adresi girin.","UserUpdatedSuccessfully":"Güncelleme başarıyla tamamlandı","profilePhotoUploadSuccesfully":"Profil Fotoğrafı Başarıyla Yüklendi"},"en":{"userTitle":"Account","personalInformationSubTitle":"Personal Information","firstName":"First Name","lastName":"Last Name","email":"Email","department":"Department","jobTitle":"Title","languagePreference":"Language Preference","permissionsTitle":"Permissions","turkish":"Turkish","english":"English","firstNamePlaceholder":"Ex: John","lastNamePlaceholder":"Ex: Doe","emailPlaceholder":"Ex: john.doe@mail.com","departmentPlaceholder":"Ex: IT","jobTitlePlaceholder":"Ex: Software Engineer","rolesGroups":"Roles/Groups","locations":"Locations","selectRolesGroups":"Select Role(s)","selectLocations":"Select Location(s)","selectAll":"Select All","firstNameValidationError":"Please enter your first name","lastNameValidationError":"Please enter your last name","emailValidationError":"Please enter valid email.","editPhoto":"Edit Photo","youCantRemoveAdminFromYourSelf":"You can\u0027t delete admin from yourself","adminGroupError":"Removing users from the Admin group can be done on the \\"Permissions\\" page.","mailInUseError":"This email address is already used by another user. Enter a different email address.","UserUpdatedSuccessfully":"Update completed successfully","profilePhotoUploadSuccesfully":"Profile Photo Upload Successfully"}}')
}


/***/ }),

/***/ "DMkI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Table_vue__ = __webpack_require__("ABj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_YearSelect__ = __webpack_require__("TIN3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'data-detail',
    components: { YearSelect: __WEBPACK_IMPORTED_MODULE_6__components_YearSelect__["a" /* default */], SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__["a" /* default */], VueTable: __WEBPACK_IMPORTED_MODULE_3__components_Table_vue__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a },
    props: {
        selectedTag: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            isLoaded: false,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            selectedSite: null,
            selectedUnit: null,
            tableInfo: {
                fields: [],
                items: []
            },
            maxDigitCount: 9
        };
    },

    methods: {
        onYearChange: function onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'data-detail',
                params: { site_id: this.route.params.site_id, type_id: this.route.params.type_id },
                query: { year: this.year }
            });
            this.listDataDetails();
        },
        selectSiteId: function selectSiteId(site) {
            if (!site) {
                this.$router.push({ name: 'data-sites' });
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                var tags = site.tags;
                // if tags of selected site don't includes previously selected tag, route is changed to summary page (top page).
                if (tags.map(function (tag) {
                    return tag.key;
                }).indexOf(this.selectedTag) === -1) {
                    this.$emit('changetag', site.id);
                    this.$router.push({
                        name: 'site-data-types',
                        params: { site_id: site.id },
                        query: { year: this.year }
                    });
                } else {
                    this.isLoaded = false;
                    this.$router.push({
                        name: 'data-detail',
                        params: { site_id: site.id, type_id: this.route.params.type_id },
                        query: { year: this.year }
                    });
                    this.listDataDetails();
                }
            }
        },
        isOutOfMaxDigitLength: function isOutOfMaxDigitLength(val) {
            if (this.delocalizeValue(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toString(val), this.locale).split(',')[0].replaceAll('.', '').length > this.maxDigitCount) {
                return true;
            }
            return false;
        },
        applyDataChanges: function applyDataChanges(item, fields, callback, onWarnCallBack) {
            var _this = this;

            var updatedItem = {
                id: item.id,
                siteId: this.route.params.site_id,
                typeId: this.route.params.type_id,
                year: this.$store.state.year
            };

            if ('cost' in item && this.isOutOfMaxDigitLength(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "cost").editedValue)) {
                this.$toasted.error(this.$t("cost-out-range"));
                return onWarnCallBack();
            }
            if ('value1' in item && this.isOutOfMaxDigitLength(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "value1").editedValue)) {
                this.$toasted.error(this.$t("value-out-range"));
                return onWarnCallBack();
            }

            fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'date') {
                        updatedItem[field.key] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item[field.key].editedValue).toDate();
                    } else if (field.type === 'daterange' || field.type === 'text') {
                        updatedItem[field.key] = item[field.key].editedValue;
                    } else if (field.type === 'number' || field.type === 'float') {
                        updatedItem[field.key] = _this.delocalizeValue(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toString(item[field.key].editedValue), _this.locale);
                    } else if (field.type === 'file') {
                        updatedItem[field.key] = item[field.key].editedFileId;
                    } else {
                        updatedItem[field.key] = item[field.key].editedValue;
                    }
                }
            });
            // UTC conversion of dates in order to prevent data loss due to UTC time zone difference.

            updatedItem.date[0] = this.createUTCDate(updatedItem.date[0].getFullYear(), updatedItem.date[0].getMonth(), updatedItem.date[0].getDate());
            updatedItem.date[1] = this.createUTCDate(updatedItem.date[1].getFullYear(), updatedItem.date[1].getMonth(), updatedItem.date[1].getDate());
            updatedItem.locale = this.$store.state.locale;
            return this.axios.put('/data', updatedItem).then(function (response) {
                _this.listDataDetails();
                return callback(response.data);
            }).catch(function (err) {
                _this.$toasted.error(_this.$t(err.response.data.message));
                return onWarnCallBack();
            });
        },
        insertItem: function insertItem(item, callback, onWarnCallBack) {
            var _this2 = this;

            var insertedItem = {
                siteId: this.route.params.site_id,
                typeId: this.route.params.type_id,
                year: this.$store.state.year,
                locale: this.$store.state.locale
            };

            if ('cost' in item && this.isOutOfMaxDigitLength(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "cost").value)) {
                this.$toasted.error(this.$t("cost-out-range"));
                return onWarnCallBack();
            }
            if ('value1' in item && this.isOutOfMaxDigitLength(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, "value1").value)) {
                this.$toasted.error(this.$t("value-out-range"));
                return onWarnCallBack();
            }

            this.tableInfo.fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'date') {
                        insertedItem[field.key] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item[field.key].value).toDate();
                    } else if (field.type === 'daterange' || field.type === 'text') {
                        insertedItem[field.key] = item[field.key].value;
                    } else if (field.type === 'number' || field.type === 'float') {
                        if (field.key == 'cost') {
                            // @todo: currency is given as hardcoded here. There is something to do this automaticaly.
                            // But the goal is sending insertedItem.currency with a currency symbol to /data post request.
                            insertedItem.currency = _this2.$store.state.user.customerId == 2041 ? 'AED' : 'tl';
                        }
                        item[field.key].value = item[field.key].value == null ? '0' : item[field.key].value;
                        insertedItem[field.key] = _this2.delocalizeValue(item[field.key].value, _this2.locale);
                    } else if (field.type === 'file') {
                        insertedItem[field.key] = item[field.key].fileId;
                    } else {
                        insertedItem[field.key] = item[field.key].value;
                    }
                }
            });
            // UTC conversion of dates in order to prevent data loss due to UTC time zone difference.
            insertedItem.date[0] = this.createUTCDate(insertedItem.date[0].getFullYear(), insertedItem.date[0].getMonth(), insertedItem.date[0].getDate());
            insertedItem.date[1] = this.createUTCDate(insertedItem.date[1].getFullYear(), insertedItem.date[1].getMonth(), insertedItem.date[1].getDate());

            return this.axios.post('/data', insertedItem).then(function (response) {
                _this2.listDataDetails();
                return callback(response.data);
            }).catch(function (err) {
                _this2.$toasted.error(_this2.$t(err.response.data.message));
                return onWarnCallBack();
            });
        },
        deleteItemById: function deleteItemById(id) {
            var _this3 = this;

            return this.axios.delete(this.route.params.site_id + '/data/' + id).catch(function () {
                _this3.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                _this3.init();
            });
        },
        listDataDetails: function listDataDetails() {
            var _this4 = this;

            this.$Progress.start();
            return this.axios.get('/data/' + this.selectedSite.id + '/types/' + this.route.params.type_id + '?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({ year: this.year }) + '&locale=' + this.$store.state.locale).then(function (response) {
                _this4.tableInfo = {
                    fields: response.data.meta[_this4.route.params.type_id] ? response.data.meta[_this4.route.params.type_id].table : [],
                    info: response.data.meta[_this4.route.params.type_id] ? response.data.meta[_this4.route.params.type_id].info : {},
                    items: response.data.data[_this4.route.params.type_id] ? response.data.data[_this4.route.params.type_id] : [],
                    unitPrice: response.data.unitPrice
                };
                _this4.tableInfo.fields = _this4.isbId(_this4.$store.state.user.customerId) ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(_this4.tableInfo.fields), function (o) {
                    return o.key !== 'cost';
                }) : _this4.tableInfo.fields;
                _this4.isLoaded = true;
                _this4.$Progress.finish();
                return _this4.tableInfo;
            });
        },
        init: function init() {
            var dataTypeId = this.route.params.type_id;
            var currentDataType = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.dataTypes, function (o) {
                return o.id == dataTypeId;
            });
            this.selectedUnit = ' (' + this.$t(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.units, { id: currentDataType.unit_id_1 }).name) + ')';
            this.listDataDetails();
        }
    },
    created: function created() {
        this.selectedSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.$store.state.year;
        this.init();
    }
});

/***/ }),

/***/ "DPH8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DTQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDetail_vue__ = __webpack_require__("QFoE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a0b038_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDetail_vue__ = __webpack_require__("+GQV");
function injectStyle (ssrContext) {
  __webpack_require__("6295")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5a0b038"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5a0b038_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DmJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DsNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditMain_vue__ = __webpack_require__("MF1D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b93e848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditMain_vue__ = __webpack_require__("ls93");
function injectStyle (ssrContext) {
  __webpack_require__("KDUX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b93e848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b93e848_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DtB1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteCard__ = __webpack_require__("vyRp");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SiteCard: __WEBPACK_IMPORTED_MODULE_2__components_SiteCard__["a" /* default */]
    },
    name: 'data-main',
    data: function data() {
        return {
            tags: []
        };
    },

    methods: {
        routeByTag: function routeByTag(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;
            localStorage.setItem('tags', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tags));
            this.$router.push({ name: 'site-data-types', query: { year: this.year, tag: tag.key } });
        },
        init: function init(siteId) {
            siteId = siteId ? siteId : Number(this.route.params.site_id);
            var selectedSite = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.sites, { id: siteId });
            var tagsFromStorage = localStorage.getItem('tags');
            if (!tagsFromStorage || selectedSite) {
                if (selectedSite && selectedSite.tags.length) {
                    this.tags = this.deepClone(selectedSite.tags);

                    if (this.gbId(this.$store.state.user.customerId)) {
                        this.tags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tags, function (o) {
                            return o.key !== 'waste';
                        });
                    }
                    /* if(this.$store.state.user.customerId == 1){
                        this.tags = _.filter(this.tags, function(o){
                            return o.key !== 'waste';
                        })
                    } */

                    var activeTagFromStorage = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(JSON.parse(tagsFromStorage), function (o) {
                        return o.active == true;
                    }));
                    if (activeTagFromStorage !== undefined) {
                        this.tags.forEach(function (tag) {
                            tag.active = tag.key == activeTagFromStorage.key;
                        });
                    }

                    var activeTags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tags, function (o) {
                        return o.active == true;
                    });
                    // if any tag is not chosen, set defaul selected tag as first tag(consumption)
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(activeTags)) {
                        this.tags[0].active = true;
                    }
                } else {
                    this.$router.push('/');
                }
            } else {
                this.tags = JSON.parse(tagsFromStorage);
                if (this.gbId(this.$store.state.user.customerId)) {
                    this.tags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tags, function (o) {
                        return o.key !== 'waste';
                    });
                }
            }
        },
        onTagChange: function onTagChange(siteId) {
            this.init(siteId);
        }
    },
    computed: {
        selectedTag: function selectedTag() {
            var found = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.tags, { active: true });
            return found ? found.key : null;
        }
    },

    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "DxK9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('b-col',[_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}})],1),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"300px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)])],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.$t('title'))+"\n                    ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('year-select',{staticStyle:{"margin-right":"15px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}}),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('site')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('formCountColumn')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredForms),function(formSite){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToFormDetail(formSite)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(formSite.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(formSite.count)+" / "+_vm._s(_vm.formTypes.length))])])}),0)])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E+8u":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sourceLoading":"Kaynak Listesi Yükleniyor...","sourceManagement":"Kaynak Yönetimi","addSource":"Kaynak Ekle","searchSource":"Kaynak Arama","activeSources":"Aktif Kaynaklar","inactiveSources":"Pasif Kaynaklar"},"en":{"sourceLoading":"Loading Source List...","sourceManagement":"Source Management","addSource":"Add Source","searchSource":"Search Source","activeSources":"Active Sources","inactiveSources":"Inactive Sources"}}')
}


/***/ }),

/***/ "EOUR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"background-color":"#eff3f6","border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag){return _c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, 'active': tag.active},on:{"click":function($event){return _vm.routeByTag(tag)}}},[_vm._v(_vm._s(_vm.$t(tag.key)))])])}),0),_vm._v(" "),_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[(_vm.selectedTag)?_c('router-view',{attrs:{"selectedTag":_vm.selectedTag},on:{"changetag":_vm.onTagChange}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EYpU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYu7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.$t('errorText')))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ei+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticStyle:{"min-height":"300px"},attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12","sm":"7","md":"7","lg":"6"}},[_c('div',{staticClass:"table-responsive"},[(_vm.hasAnyCarbonEmission)?_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"8em"}},[_vm._v(_vm._s(_vm.$t('emissionType')))]),_vm._v(" "),_vm._l((_vm.types),function(type,i){return _c('th',{key:i,staticStyle:{"text-align":"left","width":"7em"}},[_vm._v(_vm._s(type))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.emissions),function(emission,key){return (key !== 'total')?_c('tr',{key:("emission-" + key)},[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(emission.source))+" ("+_vm._s(_vm.$t('ton'))+")")]),_vm._v(" "),_vm._l((_vm.types),function(type,i){return _c('td',{key:i,staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(emission[type],'float', _vm.locale),_vm.locale)))])})],2):_vm._e()}),0)]):_vm._e()])]),_vm._v(" "),(_vm.pieChartData.datasets[0].data.length)?_c('b-col',{attrs:{"cols":"12","sm":"5","md":"5","lg":"6"}},[_c('div',{staticStyle:{"width":"26em","height":"26em","margin":"auto"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.pieChartData,"options":_vm.pieChartOptions,"chart-id":_vm.pieChartId}})],1)]):_c('b-col',[_c('span',[_vm._v(_vm._s(_vm.$t('emissionError')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EsvG":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataTypeName":"Veri tipi","priceColumn":"Birim Fiyatı","unitPricePlaceHolder":"Birim fiyatı","startDateColumn":"Başlangıç Yılı","endDateColumn":"Bitiş Yılı"},"en":{"dataTypeName":"Data type","priceColumn":"Unit Price","unitPricePlaceHolder":"Unit price","startDateColumn":"Start Year","endDateColumn":"End Year"}}')
}


/***/ }),

/***/ "F+xA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionLibrary_vue__ = __webpack_require__("bMBW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5bf894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionLibrary_vue__ = __webpack_require__("RFaC");
function injectStyle (ssrContext) {
  __webpack_require__("ab7G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c5bf894"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionLibrary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5bf894_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionLibrary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("1wOw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F2z3":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMS41IiBoZWlnaHQ9IjI3IiB2aWV3Qm94PSIwIDAgMzEuNSAyNyI+CiAgPGcgaWQ9Im1haWwtYWxsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4yNSAtNi42MjUpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzc3NyIgZGF0YS1uYW1lPSJQYXRoIDc3NyIgZD0iTTE4LjY2NCwyMi45NjEsMjIuNjkxLDI3bC00LjAzOSw0LjAzOSwxLjYsMS41ODZMMjUuODc1LDI3LDIwLjI1LDIxLjM3NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzc3OCIgZGF0YS1uYW1lPSJQYXRoIDc3OCIgZD0iTTI2LjUzOSwyMi45NjEsMzAuNTY2LDI3bC00LjAzOSw0LjAzOSwxLjYsMS41ODZMMzMuNzUsMjdsLTUuNjI1LTUuNjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSAxKSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfNzc5IiBkYXRhLW5hbWU9IlBhdGggNzc5IiBkPSJNMTUuNzUsMjUuODc1SDQuNVY4LjlsMTIuODU5LDguOWExLjEyNSwxLjEyNSwwLDAsMCwxLjI4MiwwTDMxLjUsOC45VjE5LjEyNWgyLjI1VjcuODc1YTIuMjUsMi4yNSwwLDAsMC0yLjI1LTIuMjVINC41YTIuMjUsMi4yNSwwLDAsMC0yLjI1LDIuMjV2MThhMi4yNSwyLjI1LDAsMCwwLDIuMjUsMi4yNUgxNS43NVptMTMuMjc1LTE4TDE4LDE1LjUsNi45NzUsNy44NzVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIiBmaWxsPSIjZmZmIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "FAQm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("Zd84");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bcbd2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("HzV+");
function injectStyle (ssrContext) {
  __webpack_require__("b8/g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bcbd2d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("cGBr")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FY1r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spring-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spring-spinner-part top",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})]),_vm._v(" "),_c('div',{staticClass:"spring-spinner-part bottom",style:(_vm.spinnerPartStyle)},[_c('div',{staticClass:"spring-spinner-rotator",style:(_vm.rotatorStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FesY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect__ = __webpack_require__("NyJr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Audit',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__["a" /* default */] },
    data: function data() {
        return {
            searchInput: '',
            tempAudits: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null
        };
    },

    methods: {
        getTitle: function getTitle() {
            if (this.gbId(this.$store.state.user.customerId)) {
                return this.$t('garantiTitle');
            } else {
                return this.$t('title');
            }
        },
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToDocumentDetail: function routeToDocumentDetail(audit) {
            this.$store.state.siteId = audit ? audit.siteId : null;
            /*
            let routeData = this.$router.resolve({
                name: 'ticket-list',
                params: {site_id: audit.siteId},
                query: {start_date: this.year}
            });
            
            if (this.$store.state.user.customerId == 1) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'ticket-list',
                    params: {site_id: audit.siteId},
                    query: {start_date: this.year}
                });
            }
            */
            this.$router.push({
                name: 'ticket-list',
                params: { site_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(audit, 'siteId') },
                query: { start_date: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureAudit: function configureAudit() {
            var _this = this;

            this.tempAudits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.audits, function (audit) {
                var foundItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.sites, { id: audit.siteId });
                if (foundItem) {
                    return {
                        openedCount: audit.openedAuditCount,
                        totalCount: audit.totalAuditCount,
                        siteId: audit.siteId,
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name,
                        updatedAt: audit.updatedAt
                    };
                } else {
                    return audit;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(true);
        },
        onYearChange: function onYearChange(newYear) {
            var _this2 = this;

            this.$store.state.year = newYear;
            this.$router.push({
                name: 'audit',
                query: { year: this.year }
            });
            this.$Progress.start();
            this.$store.dispatch('getAuditCounts', this.year).then(this.configureAudit).then(function () {
                _this2.$Progress.finish();
            });
        }
    },
    computed: {
        filteredAudits: function filteredAudits() {
            var _this3 = this;

            if (this.searchInput.length <= 3) {
                var filteredSites = this.tempAudits.filter(function (item) {
                    var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.sites, { id: item.siteId });
                    return _this3.textStartsWith(item.code + item.name, _this3.searchInput) && _this3.isRegionFound(_this3.selectedRegionId, item.siteGroupId) && (!_this3.selectedTypeId || found.typeId === _this3.selectedTypeId);
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            } else {
                return this.tempAudits.filter(function (item) {
                    var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.sites, { id: item.siteId });
                    return _this3.isSearchTextFound(item.code + item.name, _this3.searchInput) && _this3.isRegionFound(_this3.selectedRegionId, item.siteGroupId) && (!_this3.selectedTypeId || found.typeId === _this3.selectedTypeId);
                });
            }
        }
    },
    created: function created() {
        var _this4 = this;

        this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
        if (this.$store.state.siteId && this.$store.state.redirection) {
            this.$router.push({
                name: 'ticket-list',
                params: { site_id: this.$store.state.siteId },
                query: { start_date: this.year }
            });
        }
        this.$store.state.redirection = false;
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.$Progress.start();
        this.$store.dispatch('getAuditCounts', this.year).then(this.configureAudit).then(function () {
            _this4.$Progress.finish();
        });
    }
});

/***/ }),

/***/ "FhOq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FkS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var componentID = __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()();
/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        title: {
            default: function _default() {
                return '';
            }
        },
        textStyle: {
            default: function _default() {
                return null;
            }
        },
        siteId: {
            default: function _default() {
                return null;
            }
        }
    },
    data: function data() {
        return {
            componentId: 'a_' + __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
            reactiveId: componentID + '_reactive',
            popoverId: componentID + '_popover',
            buttonRef: componentID + '_button',
            focusRefId: componentID + '_focus',
            popoverShow: false,
            text: null
        };
    },

    watch: {
        title: function title(newVal) {
            this.text = newVal;
        }
    },
    methods: {
        cityCodeToDisplayName: function cityCodeToDisplayName(val) {
            var found = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.$store.state.cities, { code: val });
            if (found) {
                return found.name;
            } else {
                return null;
            }
        },
        groupIdToDisplayName: function groupIdToDisplayName(val) {
            var found = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.$store.state.siteGroups, { id: val });
            if (found) {
                return found.display_name;
            } else {
                return null;
            }
        },
        onShow: function onShow() {
            /* This is called just before the popover is shown */
            /* Reset our popover "form" variables */
            this.text = this.title;
        },
        onShown: function onShown() {
            /* Called just after the popover has been shown */
            /* Transfer focus to the first input */
            /*this.focusRef(this.$refs.input1);*/
        },
        onHidden: function onHidden() {
            /* Called just after the popover has finished hiding */
            /* Bring focus back to the button */
            this.focusRef(this.$refs[this.focusRefId]);
        },
        focusRef: function focusRef(ref) {
            var _this = this;

            /* Some references may be a component, functional component, or plain element */
            /* This handles that check before focusing, assuming a focus() method exists */
            /* We do this in a double nextTick to ensure components have updated & popover positioned first */
            this.$nextTick(function () {
                _this.$nextTick(function () {
                    (ref.$el || ref).focus();
                });
            });
        }
    },
    computed: {
        foundSite: function foundSite() {
            return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.sites, { id: Number(this.siteId) });
        }
    }
});

/***/ }),

/***/ "FpSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('div',{staticClass:"instructions"},[_vm._v("\n        "+_vm._s(_vm.$t('choose-analysis-unit'))+"\n    ")]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-select',{on:{"change":_vm.changeAnalysisUnit},model:{value:(_vm.selectedAnalysisUnit),callback:function ($$v) {_vm.selectedAnalysisUnit=$$v},expression:"selectedAnalysisUnit"}},[_c('option',{domProps:{"value":'GJ'}},[_vm._v("GJ")]),_vm._v(" "),_c('option',{domProps:{"value":'MWh'}},[_vm._v("MWh")])])],1),_vm._v(" "),(this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId))?_c('b-col',{attrs:{"cols":"4"}},[_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"dataExport",attrs:{"size":"sm"},on:{"click":function($event){return _vm.$refs.dataLists.show()}}},[_c('i',{staticClass:"fab fa-dochub"})])],1)],1),_vm._v(" "),_c('b-modal',{ref:"dataLists",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('b-form-select',{attrs:{"cols":"6","options":_vm.dataLists},on:{"change":function($event){return _vm.getData($event)}},model:{value:(_vm.selectedDataList),callback:function ($$v) {_vm.selectedDataList=$$v},expression:"selectedDataList"}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ft5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticStyle:{"position":"fixed","top":"0","bottom":"0","right":"0","left":"0","overflow":"auto"},attrs:{"md":"12"}},[(!_vm.hideCarousel)?_c('b-col',{staticClass:"carousel-side d-flex justify-content-center align-items-center hidden-md-down",staticStyle:{"background-color":"#4129A8"},attrs:{"md":"5"}},[_c('carousel')],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"form-side d-flex",staticStyle:{"background-color":"#fff"},attrs:{"md":_vm.hideCarousel ? 12 : 7}},[_c('b-card',{staticStyle:{"width":"25%","min-width":"30rem","margin":"auto","border":"none","color":"#022B49"},attrs:{"img-src":_vm.showLogo ? _vm.logoImg : '',"img-alt":"Image","img-top":""}},[_c('b-row',{staticClass:"m-3",staticStyle:{"font-weight":"bold","margin-bottom":"3px","font-size":"1.75em"}},[_c('b-col',[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('resetPassword')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("KGkw")}})]),_vm._v(" "),_c('div',{staticClass:"placeholder-wrap"},[_c('b-form-input',{class:['input-field', {'is-invalid': _vm.passwordError }],attrs:{"type":"password","id":"password","required":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('span',{staticClass:"placeholder"},[_vm._v("\n                                "+_vm._s(_vm.$t('passwordPlaceholder'))+" "),_c('span',{staticClass:"password-info"},[_vm._v("("+_vm._s(_vm.$t('passwordInfo'))+")")])])],1),_vm._v(" "),_c('b-input-group-append',{attrs:{"is-text":""}},[(_vm.showPassword)?_c('span',{key:"password-visible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"showConfirmPass",attrs:{"src":__webpack_require__("AuRY")}}),_c('img')]):_c('span',{key:"password-invisible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"hideConfirmPass",attrs:{"src":__webpack_require__("gfGe")}}),_c('img')])])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordError),expression:"passwordError"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t(_vm.passwordErrorType)))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("KGkw")}})]),_vm._v(" "),_c('b-form-input',{class:['input-field', {'is-invalid': _vm.passwordError }],attrs:{"placeholder":_vm.$t('confirmPasswordPlaceholder'),"type":"password","id":"passwordConfirmation","required":""},model:{value:(_vm.user.passwordConfirmation),callback:function ($$v) {_vm.$set(_vm.user, "passwordConfirmation", $$v)},expression:"user.passwordConfirmation"}}),_vm._v(" "),_c('b-input-group-append',{attrs:{"is-text":""}},[(_vm.showPasswordConfirmation)?_c('span',{key:"password-confirmation-visible",on:{"click":function($event){return _vm.switchPasswordVisibility('passwordConfirmation')}}},[_c('img',{key:"showConfirmPass",attrs:{"src":__webpack_require__("AuRY")}}),_c('img')]):_c('span',{key:"password-confirmation-invisible",on:{"click":function($event){return _vm.switchPasswordVisibility('passwordConfirmation')}}},[_c('img',{key:"hideConfirmPass",attrs:{"src":__webpack_require__("gfGe")}}),_c('img')])])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.passwordError && _vm.passwordErrorType == 'passwordsDoNotMatch'),expression:"passwordError && passwordErrorType == 'passwordsDoNotMatch'"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t(_vm.passwordErrorType)))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('b-button',{staticClass:"w-50 light-green",on:{"click":function($event){return _vm.resetPassword()}}},[_vm._v(_vm._s(_vm.$t('resetPasswordButton')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FvlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"200px"}},[_c('multiselect',{attrs:{"value":_vm.selectedRegion,"options":_vm.regions,"close-on-select":true,"showLabels":false,"placeholder":_vm.$t('allRegions'),"label":"display_name","track-by":"id","id":"region-select"},on:{"input":_vm.onInput}},[_c('template',{slot:"beforeList"},[_c('div',{staticClass:"buttonOutside"},[_c('button',{staticClass:"allSitesButton",on:{"click":function($event){return _vm.selectAll()}}},[_vm._v(_vm._s(_vm.$t('allRegions')))])])]),_vm._v(" "),_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('regionError')))])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fwsu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/F+":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"general-analysis":"Genel","scope-1":"scope1","scope-2":"scope2","scope-3":"scope3","compare":"Karşılaştırma"},"en":{"general-analysis":"General","scope-1":"scope1","scope-2":"scope2","scope-3":"scope3","compare":"Compare"}}')
}


/***/ }),

/***/ "G8uj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G8wk":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"domestic-waste":"Atık"},"en":{"domestic-waste":"Waste"}}')
}


/***/ }),

/***/ "GH5M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_epic_spinners__ = __webpack_require__("pyJd");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'spinner',
    components: {
        LoopingRhombusesSpinner: __WEBPACK_IMPORTED_MODULE_0_epic_spinners__["a" /* LoopingRhombusesSpinner */]
    }
});

/***/ }),

/***/ "GP/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import moment from 'moment';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Locations',
    data: function data() {
        return {
            tabs: {
                countries: {
                    isActive: true,
                    data: {
                        tableColumns: [{
                            label: '#',
                            key: 'index',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('country'),
                            key: 'name',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('edit'),
                            key: 'edit',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }],
                        tableItems: []
                    },
                    name: this.$t('countries'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                regions: {
                    isActive: false,
                    data: {
                        tableColumns: [{
                            label: '#',
                            key: 'index',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('region'),
                            key: 'name',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('country'),
                            key: 'countryName',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('edit'),
                            key: 'edit',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }],
                        tableItems: []
                    },
                    name: this.$t('regions'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                cities: {
                    isActive: false,
                    data: {
                        tableColumns: [{
                            label: '#',
                            key: 'index',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('city'),
                            key: 'name',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('region'),
                            key: 'regionName',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('country'),
                            key: 'countryName',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('edit'),
                            key: 'edit',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }],
                        tableItems: []
                    },
                    name: this.$t('cities'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                sectors: {
                    isActive: false,
                    data: {
                        tableColumns: [{
                            label: '#',
                            key: 'index',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('sector'),
                            key: 'name',
                            sortable: true,
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }, {
                            label: this.$t('edit'),
                            key: 'edit',
                            thClass: 'table-point-th',
                            stickyColumn: true
                        }],
                        tableItems: []
                    },
                    name: this.$t('sectors'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                }
            },
            activeTab: 'countries',
            currentPage: 1,
            perPage: 10,
            countryOptions: [],
            editedItem: {
                id: null
            },
            modalType: null,
            searchInput: '',
            totalRows: 0

        };
    },

    methods: {

        // arranges the region dropdown and filters it based on country
        arrangeOptions: function arrangeOptions(countryId) {
            var _this = this;

            var selectData = void 0;
            selectData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tabs.regions.data.tableItems, function (item) {
                return item.countryId == countryId;
            });
            var options = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(selectData, function (selectItem) {
                return selectItem = { value: selectItem.id, text: _this.$t(selectItem.name), disabled: false };
            });
            return [{ value: null, text: this.$t('choose'), disabled: true }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(options));
        },

        // gets modal title based on selected tab
        getModalTitle: function getModalTitle() {
            return this.$t(this.activeTab);
        },
        closeAddEditModal: function closeAddEditModal() {
            this.$refs.addEditItem.hide();
        },
        activate: function activate(key) {
            this.activeTab = key;
            this.currentPage = 1;
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.tabs, function (tab, tabKey) {
                tab.isActive = key == tabKey;
            });
        },
        filterData: function filterData() {
            this.currentPage = 1;
            this.$forceUpdate();
        },
        itemsForList: function itemsForList(data) {
            var searchedData = this.searchData(data);
            this.totalRows = searchedData.length;
            return searchedData.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
        },
        searchData: function searchData(data) {
            var _this2 = this;

            if (this.searchInput.length < 1) {
                return data;
            } else {
                switch (this.activeTab) {
                    case 'countries':
                    case 'sectors':
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.name), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput));
                        });
                    case 'regions':
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.name), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.countryName), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput));
                        });
                    case 'cities':
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.name), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.countryName), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(o.regionName), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this2.searchInput));
                        });
                    default:
                        return data;
                }
            }
        },
        openInsertItemModal: function openInsertItemModal() {
            if (this.activeTab == 'countries') {
                this.editedItem = { countries: [] };
            } else if (this.activeTab == 'regions') {
                this.editedItem = { regions: [], countryId: null };
            } else if (this.activeTab == 'cities') {
                this.editedItem = { cities: [], regionId: null };
            } else {
                this.editedItem = { name: '', description: '' };
            }

            this.modalType = 'insert';
            this.$refs.addEditItem.show();
        },
        openEditItemModal: function openEditItemModal(selectedItem) {
            if (this.activeTab == 'countries') {
                this.editedItem = { countries: selectedItem.name };
            } else if (this.activeTab == 'regions') {
                this.editedItem = { regions: selectedItem.name, countryId: selectedItem.countryId };
            } else if (this.activeTab == 'cities') {
                this.editedItem = { cities: selectedItem.name, regionId: selectedItem.regionId, countryId: selectedItem.countryId };
            } else {
                this.editedItem = { name: selectedItem.name, description: selectedItem.description };
            }

            this.editedItem.id = selectedItem.id;
            this.modalType = 'edit';
            this.$refs.addEditItem.show();
        },
        saveItem: function saveItem() {
            if (this.modalType == 'edit') {
                this.editItem();
            } else {
                this.insertItem();
            }
        },
        insertItem: function insertItem() {
            var _this3 = this;

            this.$Progress.start();
            switch (this.activeTab) {
                case 'countries':
                    return this.axios.post('/countries', this.editedItem).then(function () {
                        _this3.$Progress.finish();
                        _this3.$refs.addEditItem.hide();
                        _this3.init();
                    });
                case 'regions':
                    return this.axios.post('/regions', this.editedItem).then(function () {
                        _this3.$Progress.finish();
                        _this3.$refs.addEditItem.hide();
                        _this3.init();
                    });
                case 'cities':
                    return this.axios.post('/cities', this.editedItem).then(function () {
                        _this3.$Progress.finish();
                        _this3.$refs.addEditItem.hide();
                        _this3.init();
                    });
                case 'sectors':
                    return this.axios.post('/sector', this.editedItem).then(function () {
                        _this3.$Progress.finish();
                        _this3.$refs.addEditItem.hide();
                        _this3.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }
        },
        editItem: function editItem() {
            var _this4 = this;

            this.$Progress.start();
            switch (this.activeTab) {
                case 'countries':
                    return this.axios.put('/country', { id: this.editedItem.id, name: this.editedItem.countries }).then(function () {
                        _this4.$Progress.finish();
                        _this4.$refs.addEditItem.hide();
                        _this4.init();
                    });
                case 'regions':
                    return this.axios.put('/region', { id: this.editedItem.id, name: this.editedItem.regions, countryId: this.editedItem.countryId }).then(function () {
                        _this4.$Progress.finish();
                        _this4.$refs.addEditItem.hide();
                        _this4.init();
                    });
                case 'cities':
                    return this.axios.put('/city', { id: this.editedItem.id, name: this.editedItem.cities, regionId: this.editedItem.regionId }).then(function () {
                        _this4.$Progress.finish();
                        _this4.$refs.addEditItem.hide();
                        _this4.init();
                    });
                case 'sectors':
                    return this.axios.put('/sector', this.editedItem).then(function () {
                        _this4.$Progress.finish();
                        _this4.$refs.addEditItem.hide();
                        _this4.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }
        },

        // checks if country has any regions or region has any cities under them
        // if there is no connection delete process starts
        deleteItem: function deleteItem(id) {
            var _this5 = this;

            this.$Progress.start();

            switch (this.activeTab) {
                case 'countries':
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tabs.regions.data.tableItems, function (item) {
                        return item.countryId == id;
                    })) == 0) {
                        return this.axios.delete('/country/' + id).then(function () {
                            _this5.$Progress.finish();
                            _this5.$refs.addEditItem.hide();
                            _this5.init();
                        });
                    } else {
                        this.$Progress.finish();
                        return this.$message({
                            type: 'error',
                            message: this.$t('countryDeleteError')
                        });
                    }
                case 'regions':
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.tabs.cities.data.tableItems, function (item) {
                        return item.regionId == id;
                    })) == 0) {
                        return this.axios.delete('/region/' + id).then(function () {
                            _this5.$Progress.finish();
                            _this5.$refs.addEditItem.hide();
                            _this5.init();
                        });
                    } else {
                        this.$Progress.finish();
                        return this.$message({
                            type: 'error',
                            message: this.$t('regionDeleteError')
                        });
                    }
                case 'cities':
                    return this.axios.delete('/city/' + id).then(function () {
                        _this5.$Progress.finish();
                        _this5.$refs.addEditItem.hide();
                        _this5.init();
                    });
                case 'sectors':
                    return this.axios.delete('/sector/' + id).then(function () {
                        _this5.$Progress.finish();
                        _this5.$refs.addEditItem.hide();
                        _this5.init();
                    });
                default:
                    this.$Progress.finish();
                    this.$refs.addEditItem.hide();
                    break;
            }

            /*
            
            */
        },
        prepareData: function prepareData(data) {
            this.tabs.countries.data.tableItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data, 'countries');
            this.tabs.regions.data.tableItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data, 'regions');
            this.tabs.cities.data.tableItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data, 'cities');
            this.tabs.sectors.data.tableItems = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data, 'sectors');

            var cOptions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(data, 'countries'), function (country) {
                return country = { value: country.id, text: country.name, disabled: false };
            });
            this.countryOptions = [{ value: null, text: this.$t('choose'), disabled: true }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(cOptions));
        },
        init: function init() {
            var _this6 = this;

            this.$Progress.start();
            return this.axios.get('/getAllLocationsAndSectors').then(function (_ref) {
                var data = _ref.data;

                _this6.prepareData(data);
                _this6.$Progress.finish();
            });
        }
    },
    watch: {},
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GrXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"border":"none"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"}},[_c('h3',[_vm._v(_vm._s(this.$t('locationManagement')))])]),_vm._v(" "),_c('b-row',{staticStyle:{"justify-content":"space-between"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{key:tabKey,staticClass:"nav-item p-2",staticStyle:{"cursor":"pointer"},style:(tab.isActive ? tab.style.border : '')},[_c('div',{class:{'nav-link': true, 'active': tab.isActive},style:(tab.isActive ? tab.style.tab : ''),on:{"click":function($event){return _vm.activate(tabKey)}}},[_vm._v(_vm._s(tab.name)+"  "),_c('b-badge',{style:(tab.isActive ? tab.style.badge : ''),attrs:{"pill":""}},[_vm._v(_vm._s(tab.data.tableItems.length))])],1)])}),0)]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[(_vm.tabs.countries.isActive)?[_c('b-button',{key:"addCountry",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addCountry')))])]:(_vm.tabs.regions.isActive)?[_c('b-button',{key:"addRegion",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addRegion')))])]:(_vm.tabs.cities.isActive)?[_c('b-button',{key:"addCity",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addCity')))])]:(_vm.tabs.sectors.isActive)?[_c('b-button',{key:"addSector",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addSector')))])]:_vm._e()],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-3",attrs:{"md":"2"}},[_c('b-form-input',{staticStyle:{"padding":"5px 10px"},attrs:{"placeholder":_vm.$t('search')},on:{"input":_vm.filterData},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1),_vm._v(" "),_c('b-table',{attrs:{"hover":"","items":_vm.itemsForList(_vm.tabs[_vm.activeTab].data.tableItems),"fields":_vm.tabs[_vm.activeTab].data.tableColumns},scopedSlots:_vm._u([{key:"cell(index)",fn:function(data){return [_c('span',[_vm._v(_vm._s(data.index+1))])]}},{key:"cell(edit)",fn:function(data){return [_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.openEditItemModal(data.item)}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})])]}}])}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"aria-controls":"itemList","align":"center"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('b-modal',{ref:"addEditItem",attrs:{"title":_vm.getModalTitle(),"size":"lg","hide-footer":"","centered":""}},[_c('b-container',{staticClass:"my-4",attrs:{"fluid":""}},[(this.tabs.countries.isActive)?[_c('form',{ref:"form"},[(_vm.modalType == 'insert')?_c('b-form-group',{attrs:{"label":_vm.$t('country'),"label-for":"country-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-tags',{attrs:{"id":"country-input","separator":",;","placeholder":_vm.$t('countryTagsExample'),"tag-class":"tag-country","addButtonVariant":"outline-light","addButtonText":"","size":"lg","input-type":"text","duplicate-tag-text":_vm.$t('alreadyEnteredCountry'),"disabledAddButton":"","tag-pills":"","no-outer-focus":"","remove-on-delete":"","required":""},model:{value:(_vm.editedItem.countries),callback:function ($$v) {_vm.$set(_vm.editedItem, "countries", $$v)},expression:"editedItem.countries"}})],1):_c('b-form-group',{attrs:{"label":_vm.$t('country'),"label-for":"country-text-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-input',{attrs:{"id":"country-text-input","placeholder":_vm.$t('country')},model:{value:(_vm.editedItem.countries),callback:function ($$v) {_vm.$set(_vm.editedItem, "countries", $$v)},expression:"editedItem.countries"}})],1)],1)]:(this.tabs.regions.isActive)?[_c('form',{ref:"form"},[_c('b-form-group',{attrs:{"label":_vm.$t('country'),"label-for":"region-country-select","label-class":"font-weight-bold pt-0"}},[_c('b-form-select',{attrs:{"id":"region-country-select","options":_vm.countryOptions},model:{value:(_vm.editedItem.countryId),callback:function ($$v) {_vm.$set(_vm.editedItem, "countryId", $$v)},expression:"editedItem.countryId"}})],1),_vm._v(" "),(_vm.modalType == 'insert')?_c('b-form-group',{attrs:{"label":_vm.$t('regions'),"label-for":"region-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-tags',{attrs:{"id":"region-input","separator":",;","placeholder":_vm.$t('regionTagsExample'),"tag-class":"tag-region","addButtonVariant":"outline-light","addButtonText":"","size":"lg","input-type":"text","duplicate-tag-text":_vm.$t('alreadyEnteredRegion'),"disabledAddButton":"","tag-pills":"","no-outer-focus":"","remove-on-delete":"","required":""},model:{value:(_vm.editedItem.regions),callback:function ($$v) {_vm.$set(_vm.editedItem, "regions", $$v)},expression:"editedItem.regions"}})],1):_c('b-form-group',{attrs:{"label":_vm.$t('region'),"label-for":"region-text-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-input',{attrs:{"id":"region-text-input","placeholder":_vm.$t('region')},model:{value:(_vm.editedItem.regions),callback:function ($$v) {_vm.$set(_vm.editedItem, "regions", $$v)},expression:"editedItem.regions"}})],1)],1)]:(this.tabs.cities.isActive)?[_c('form',{ref:"form"},[_c('b-form-group',{attrs:{"label":_vm.$t('country'),"label-for":"city-country-select","label-class":"font-weight-bold pt-0"}},[_c('b-form-select',{attrs:{"id":"city-country-select","options":_vm.countryOptions},model:{value:(_vm.editedItem.countryId),callback:function ($$v) {_vm.$set(_vm.editedItem, "countryId", $$v)},expression:"editedItem.countryId"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('region'),"label-for":"city-region-select","label-class":"font-weight-bold pt-0"}},[_c('b-form-select',{attrs:{"disabled":!_vm.editedItem.countryId,"options":_vm.editedItem.countryId == null ?
                            []: _vm.arrangeOptions(_vm.editedItem.countryId)},model:{value:(_vm.editedItem.regionId),callback:function ($$v) {_vm.$set(_vm.editedItem, "regionId", $$v)},expression:"editedItem.regionId"}})],1),_vm._v(" "),(_vm.modalType == 'insert')?_c('b-form-group',{attrs:{"label":_vm.$t('cities'),"label-for":"city-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-tags',{attrs:{"id":"city-input","separator":",;","placeholder":_vm.$t('cityTagsExample'),"tag-class":"tag-city","addButtonVariant":"outline-light","addButtonText":"","size":"lg","input-type":"text","duplicate-tag-text":_vm.$t('alreadyEnteredCity'),"disabledAddButton":"","tag-pills":"","no-outer-focus":"","remove-on-delete":"","required":""},model:{value:(_vm.editedItem.cities),callback:function ($$v) {_vm.$set(_vm.editedItem, "cities", $$v)},expression:"editedItem.cities"}})],1):_c('b-form-group',{attrs:{"label":_vm.$t('city'),"label-for":"city-text-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-input',{attrs:{"id":"city-text-input","placeholder":_vm.$t('city')},model:{value:(_vm.editedItem.cities),callback:function ($$v) {_vm.$set(_vm.editedItem, "cities", $$v)},expression:"editedItem.cities"}})],1)],1)]:(this.tabs.sectors.isActive)?[_c('form',{ref:"form"},[_c('b-form-group',{attrs:{"label":_vm.$t('sectorName'),"label-for":"sector-name-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-input',{attrs:{"id":"sector-name-input","required":""},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),(_vm.modalType == 'insert')?_c('b-form-group',{attrs:{"label":_vm.$t('sectorDescription'),"label-for":"sector-description-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-input',{attrs:{"id":"sector-description-input","required":""},model:{value:(_vm.editedItem.description),callback:function ($$v) {_vm.$set(_vm.editedItem, "description", $$v)},expression:"editedItem.description"}})],1):_vm._e()],1)]:_vm._e()],2),_vm._v(" "),_c('hr',{staticStyle:{"padding-top":"5px"}}),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"md","variant":"outline-success","block":""},on:{"click":function($event){return _vm.closeAddEditModal()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[(_vm.modalType == 'edit')?_c('b-btn',{staticClass:"mt-3",attrs:{"size":"md","variant":"danger","block":""},on:{"click":function($event){return _vm.deleteItem(_vm.editedItem.id)}}},[_vm._v(_vm._s(_vm.$t('delete')))]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-btn',{staticClass:"mt-3",staticStyle:{"background-color":"#41B884"},attrs:{"size":"md","block":""},on:{"click":function($event){return _vm.saveItem()}}},[_vm._v(_vm._s(this.modalType == 'edit' ? _vm.$t('update'):_vm.$t('add')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GuHc":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi45MjkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMi45MjkgMTgiPgogIDxnIGlkPSJHcm91cF8yNzQ3IiBkYXRhLW5hbWU9Ikdyb3VwIDI3NDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTU4OC40NjQgNzcuNzI4KSI+CiAgICA8ZyBpZD0iR3JvdXBfMjc0NSIgZGF0YS1uYW1lPSJHcm91cCAyNzQ1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTU4OC40NjUgLTc3LjcyOCkiPgogICAgICA8cGF0aCBpZD0iU3VidHJhY3Rpb25fMyIgZGF0YS1uYW1lPSJTdWJ0cmFjdGlvbiAzIiBkPSJNMS4zMjgsMThhMS4zMjQsMS4zMjQsMCwwLDEtMS0uNDQ4LDEuMzc1LDEuMzc1LDAsMCwxLS4zLTEuMTcsNi44NzcsNi44NzcsMCwwLDEsMy4yLTQuNTcsMTAuMzc2LDEwLjM3NiwwLDAsMSw1LjUxNS0xLjUyNiwxMS4xMjMsMTEuMTIzLDAsMCwxLDIuMTQyLjIwOCw1LjkzNSw1LjkzNSwwLDAsMCw1LjQxMSw3LjVjLS4wNTYuMDA1LS4xLjAwNy0uMTM4LjAwN0gxLjMyOFpNOC43NDQsOUE0LjY3NCw0LjY3NCwwLDAsMSw0LjM4NSw0LjU0Nyw0LjEzNyw0LjEzNywwLDAsMSw1LjUxNSwxLjMsNC40MzksNC40MzksMCwwLDEsOC43NDQsMGE0LjQyOCw0LjQyOCwwLDAsMSwzLjIyMSwxLjMwOUE0LjEyMiw0LjEyMiwwLDAsMSwxMy4xLDQuNTQ4LDQuNjc4LDQuNjc4LDAsMCwxLDguNzQ0LDlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjZmZmIi8+CiAgICAgIDxwYXRoIGlkPSJjaGVjayIgZD0iTTYuNjYxLDIuNjY5YS4zNjUuMzY1LDAsMCwxLS4xMS4yNjhMMy43LDUuNzg4bC0uNTM1LjUzNWEuMzguMzgsMCwwLDEtLjUzNSwwTDIuMSw1Ljc4OC42NzIsNC4zNjJhLjM4LjM4LDAsMCwxLDAtLjUzNWwuNTM1LS41MzVhLjM4LjM4LDAsMCwxLC41MzUsMEwyLjksNC40NTMsNS40ODEsMS44NjZhLjM4LjM4LDAsMCwxLC41MzUsMGwuNTM1LjUzNWEuMzY1LjM2NSwwLDAsMSwuMTEuMjY4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuNzggNy45MikiIGZpbGw9IiNmZmYiLz4KICAgIDwvZz4KICAgIDxnIGlkPSJFbGxpcHNlXzcxIiBkYXRhLW5hbWU9IkVsbGlwc2UgNzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjAwLjMyNCAtNzEuNjE4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICA8Y2lyY2xlIGN4PSI1LjUzNCIgY3k9IjUuNTM0IiByPSI1LjUzNCIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxjaXJjbGUgY3g9IjUuNTM0IiBjeT0iNS41MzQiIHI9IjQuNTM0IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "H65f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RadarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 110
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      circlesNum: 4
    };
  },


  computed: {
    borderWidth: function borderWidth() {
      return this.size * 5 / 110;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleInnerContainerStyle: function circleInnerContainerStyle() {
      return {
        borderWidth: this.borderWidth + 'px'
      };
    },
    circleInnerStyle: function circleInnerStyle() {
      return {
        borderLeftColor: this.color,
        borderRightColor: this.color,
        borderWidth: this.borderWidth + 'px'
      };
    },
    circlesStyles: function circlesStyles() {
      var circlesStyles = [];
      var delay = this.animationDuration * 0.15;

      for (var i = 0; i < this.circlesNum; i++) {
        circlesStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          padding: this.borderWidth * 2 * i + 'px',
          animationDelay: (i === this.circlesNum - 1 ? 0 : delay) + 'ms'
        }, this.circleStyle));
      }

      return circlesStyles;
    }
  }
});

/***/ }),

/***/ "H6Kz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Transfer_vue__ = __webpack_require__("qKCi");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PermissionEdit',
    components: { Transfer: __WEBPACK_IMPORTED_MODULE_4__components_Transfer_vue__["a" /* default */] },
    data: function data() {
        return {
            groupId: null,
            groupName: '',
            originalName: '',
            permissions: {
                dataPermissions: {
                    canViewData: { value: false, disabled: false },
                    canEditData: { value: false, disabled: false },
                    canAddDatatype: { value: false, disabled: false }
                },
                targetPermissions: {
                    canCreateGlobalGoals: { value: false, disabled: false },
                    canCreateGoals: { value: false, disabled: false },
                    canEditGoals: { value: false, disabled: false },
                    canApproveGoals: { value: false, disabled: false }
                },
                auditPermissions: {
                    canStartAudits: { value: false, disabled: false },
                    canReplyToAudits: { value: false, disabled: false },
                    canCreateAudit: { value: false, disabled: false }
                },
                documentPermissions: {
                    canUploadDocuments: { value: false, disabled: false }
                },
                reportPermissions: {
                    canGetReport: { value: false, disabled: false }
                },
                generalPermissions: {
                    canViewComparisons: { value: false, disabled: false },
                    canSeeAllLocations: { value: false, disabled: false },
                    isAdmin: { value: false, disabled: false }
                }
            },
            allPermissions: {
                dataPermissions: { value: false, disabled: false },
                targetPermissions: { value: false, disabled: false },
                auditPermissions: { value: false, disabled: false },
                documentPermissions: { value: false, disabled: false },
                generalPermissions: { value: false, disabled: false },
                reportPermissions: { value: false, disabled: false }
            },
            selectedUsers: [],
            isAddPage: false,
            isChanged: false,
            groupType: null,
            isEditPage: false,
            isLoaded: false
        };
    },

    methods: {
        setSelectedUsers: function setSelectedUsers(val) {
            this.selectedUsers = val;
        },
        deleteGroup: function deleteGroup() {
            var _this = this;

            this.$confirm(this.$t('willDeleteUserGroup'), this.$t('warning'), {
                confirmButtonText: this.$t('ok'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning',
                center: true
            }).then(function () {
                return _this.axios.delete('/permission-group/' + _this.groupId).then(function () {
                    _this.$message({
                        type: 'success',
                        message: _this.$t('groupDeleted')
                    });
                    _this.$router.push({ name: 'permissions' });
                }).catch(function (err) {
                    _this.$message({
                        type: 'error',
                        message: _this.$t('groupCouldNotDeleted')
                    });
                    console.log(err);
                });
            });
        },
        save: function save() {
            var _this2 = this;

            var body = {};
            var haveAtleastOnePerm = false;
            if (this.groupType != null) {
                this.groupName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.originalName);
            }
            body.groupName = this.groupName;
            body.permissions = {};
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.permissions), function (group) {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(_this2.permissions, group)), function (permissionKey) {
                    body.permissions[permissionKey] = !!_this2.permissions[group][permissionKey].value;
                    haveAtleastOnePerm = haveAtleastOnePerm || !!_this2.permissions[group][permissionKey].value;
                });
            });
            body.users = this.selectedUsers;
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.trim(body.groupName, ' ') == '') {
                this.$message({
                    type: 'error',
                    message: this.$t('mustHaveGroupName')
                });
            } else if (!haveAtleastOnePerm) {
                this.$message({
                    type: 'error',
                    message: this.$t('leastOnePermission')
                });
            } else if (this.groupType === 'admin' && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.selectedUsers)) {
                this.$message({
                    type: 'error',
                    message: this.$t('leastOneUserAtAdmin')
                });
            } else if (this.groupType === 'admin' && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(this.selectedUsers, this.$store.state.user.id)) {
                this.$message({
                    type: 'error',
                    message: this.$t('cannotRemoveYourselfFromAdmin')
                });
            } else {
                return this.isEditPage ? this.updateGroup(body) : this.createGroup(body);
            }
        },
        updateGroup: function updateGroup(body) {
            var _this3 = this;

            return this.axios.put('/permission-group/' + this.groupId, body).then(function (_ref) {
                var data = _ref.data;

                _this3.$message({
                    type: 'success',
                    message: _this3.$t('changesSaved')
                });
                _this3.isChanged = false;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data).then(function () {
                    return _this3.$router.push({ name: 'permissions' });
                });
            }).catch(function (err) {
                _this3.$message({
                    type: 'error',
                    message: _this3.$t('changesCouldNotSaved')
                });
                console.log(err);
            });
        },
        createGroup: function createGroup(body) {
            var _this4 = this;

            return this.axios.post('/permission-group', body).then(function () {
                //{data}
                _this4.$message({
                    type: 'success',
                    message: _this4.$t('newUserGroupCreated')
                });
                _this4.isChanged = false;
                _this4.$router.push({ name: 'permissions' });
                //this.$router.push({name: 'edit-permissions', params: {id: _.get(data,"results")}});
            }).catch(function (err) {
                _this4.$message({
                    type: 'error',
                    message: _this4.$t('userGroupCouldNotCreated')
                });
                console.log(err);
            });
        },
        permissionGroupSelected: function permissionGroupSelected(checked, group) {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.permissions, group)), function (permissionKey) {
                _this5.permissions[group][permissionKey].value = checked;
            });
        },
        permissionSelected: function permissionSelected(checked, group) {
            var inGroupOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.permissions, group));
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(inGroupOptions, function (option) {
                return !option.value;
            }))) {
                // all values are true
                this.allPermissions[group].value = true;
            } else {
                this.allPermissions[group].value = false;
            }
        },
        getPermissionConfig: function getPermissionConfig() {
            return this.axios.get('/permission-group/' + this.groupId).then(function (_ref2) {
                var data = _ref2.data;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data);
            }).catch(function (err) {
                console.log(err);
            });
        },
        init: function init() {
            var _this6 = this;

            this.isEditPage = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.$store.state.route, 'name') === 'edit-permissions';
            if (this.isEditPage) {
                this.groupId = this.$store.state.route.params.id;
                this.getPermissionConfig().then(function (permissionConfig) {
                    _this6.groupType = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(permissionConfig, 'type');
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this6.permissions), function (group) {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this6.permissions[group]), function (permission) {
                            _this6.permissions[group][permission].value = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(permissionConfig, permission);
                        });
                    });
                    _this6.selectedUsers = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(permissionConfig, 'users');
                    setTimeout(function () {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(document.getElementsByClassName('el-checkbox el-transfer-panel__item'), function (el) {
                            el.setAttribute('title', el.innerText);
                        });
                        _this6.groupName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(permissionConfig, 'name');
                        _this6.originalName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(_this6.groupName);
                    });
                }, 1000);
            }
            this.isLoaded = true;
        }
    },
    created: function created() {
        this.init();
    },

    watch: {
        'permissions.dataPermissions.canEditData.value': function permissionsDataPermissionsCanEditDataValue(val) {
            this.permissions.dataPermissions.canViewData.value = this.permissions.dataPermissions.canViewData.value || val;
            this.permissions.dataPermissions.canViewData.disabled = val;
        },
        'permissions.dataPermissions.canAddDatatype.value': function permissionsDataPermissionsCanAddDatatypeValue(val) {
            this.permissions.dataPermissions.canViewData.value = this.permissions.dataPermissions.canViewData.value || val;
            this.permissions.dataPermissions.canViewData.disabled = val;
        },
        'permissions.auditPermissions.canStartAudits.value': function permissionsAuditPermissionsCanStartAuditsValue(val) {
            this.permissions.auditPermissions.canReplyToAudits.value = this.permissions.auditPermissions.canReplyToAudits.value || val;
            this.permissions.auditPermissions.canReplyToAudits.disabled = val;
        },
        'permissions.targetPermissions.canCreateGlobalGoals.value': function permissionsTargetPermissionsCanCreateGlobalGoalsValue(val) {
            this.permissions.generalPermissions.isAdmin.value = this.permissions.generalPermissions.isAdmin.value || val;
            this.permissions.generalPermissions.isAdmin.disabled = val;
        },
        '$route.path': function $routePath() {
            this.init();
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var _this7 = this;

        if (this.isChanged) {
            this.$confirm(this.$t('thereAreChanges'), this.$t('warning'), {
                confirmButtonText: this.$t('saveChanges'),
                cancelButtonText: this.$t('leaveWithoutSaving'),
                type: 'warning',
                center: true
            }).then(function () {
                return _this7.save();
            }).catch(function () {
                return next();
            });
        } else {
            next();
        }
    },

    computed: {
        allUsers: function allUsers() {
            var users = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.$store.state.users, function (user) {
                return user.status == 'active';
            }));
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(users, function (user) {
                user.label = user.name + ' ' + (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(user.userGroups) ? '|' : '') + ' ' + __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.join(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(user.userGroups, 'name'), ', ');
            });
            return users;
        }
    }
});

/***/ }),

/***/ "H9Pn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("DtB1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2982f7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("EOUR");
function injectStyle (ssrContext) {
  __webpack_require__("HR+L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2982f7e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("UdiJ")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HAYC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HR+L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HdSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"background-color":"#eff3f6","border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag){return _c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, 'active': tag.active},attrs:{"id":("clickme_" + (tag.name))},on:{"click":function($event){return _vm.routeTo(tag)}}},[_vm._v(_vm._s(tag.name))])])}),0),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hwfi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__("1/Sl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0f564f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__("dsTA");
function injectStyle (ssrContext) {
  __webpack_require__("Ocvz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b0f564f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0f564f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HxfB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hyzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDetailCard_vue__ = __webpack_require__("y7ls");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186798e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDetailCard_vue__ = __webpack_require__("3YLQ");
function injectStyle (ssrContext) {
  __webpack_require__("5LP5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186798e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketDetailCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186798e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketDetailCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("nbOB")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('b-col',[_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}})],1),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"300px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)])],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.$t('title'))+"\n                    ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('year-select',{staticStyle:{"margin-right":"15px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}}),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('site')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('docCountColumn')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredDocuments),function(documentSite){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail(documentSite)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(documentSite.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(documentSite.count))])])}),0)])]),_vm._v(" "),_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IByG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitPriceDetail_vue__ = __webpack_require__("UShn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f02ee6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitPriceDetail_vue__ = __webpack_require__("3YDj");
function injectStyle (ssrContext) {
  __webpack_require__("8/kq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c9f02ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnitPriceDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f02ee6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnitPriceDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("EsvG")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IC+a":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"all":"Hepsi","allSites":"Tüm Lokasyonlar","allRegions":"Tüm Bölgeler","regionError":"Bölge bulunamadı","siteError":"Lokasyon bulunamadı","siteSearchPlaceholder":"Lokasyon Arama","cityTitle":"Şehir","regionTitle":"Bölge","total":"Toplam","ton":"ton","site":"Lokasyon","other":"Diğer","choose":"Seçin","none":"Yok","current-agent":"Seçilmiş temsilci: ","cancel":"İptal","save":"Kaydet","delete":"Sil","confirm":"Onayla","upload":"Yükle","download":"İndir","update":"Güncelle","yes":"Evet","no":"Hayır","ok":"Tamam","chooseDatePlaceholder":"Bir Tarih Seç","edit":"Düzenle","response":"Yanıt","reply":"Yanıtla","lastUpdatedAt":"Son Güncellenme Tarihi","close":"Kapat","electricity":"Elektrik","non-eligible-consumer-electricity":"Serbest Tüketici Olmayan - Elektrik","eligible-consumer-electricity":"Serbest Tüketici - Elektrik","electric":"Elektrik","gas":"Doğalgaz","diesel":"Mazot - Isınma","Dizel":"Mazot - Isınma","flightsTitle":"İş Seyahatleri","personel-cars":"Çalışan Ulaşımı","employeeCommuteTitle":"Çalışan Ulaşımı","domestic-waste":"Atık","accomodation":"Konaklama","paper":"Kağıt Atık","Purchased Goods and Services":"Satın Alınan Ürün ve Servisler","coal":"Kömür","fueloil":"Fuel Oil - Isınma","water":"Su","blue-water":"Mavi Su","heating":"Durağan Yakma Emisyonları","coolant-gas":"Kaçak emisyonlar","domesticwaste":"Evsel Atık","generator":"Jeneratör (Mazot)","Jeneratör":"Jeneratör (Mazot)","geothermal":"Jeotermal","recyclablewaste":"Geri Dönüştürülebilir Atık","required":"Bu alanı doldurmalısınız","create":"Oluştur","updated":"Güncellendi","missingError":"Eksik alanları doldurmalısınız","missingFile":"Veri kaydı için doküman yüklemeyi unutmayın","missingTableRow":"Lütfen en az bir atık girişi yapınız","conflictEmissionYear":"Lütfen aynı emisyon tipi için farklı yıl girin","conflictUnitPriceYear":"Lütfen aynı veri tipinin birim fiyatı için farklı yıl girin","confirmDataTypeDeletion":"Sildiğiniz veri tipi bu yıl için listelenmeyecektir fakat veri tipine ait olan veriler silinmeyecektir. Verileri silmek için tekrardan veri tipini ekleyip veri detayından silmelisiniz.","duplicateStartEndYear":"Lütfen başlangıç ve bitiş yıllarını farklı girin.","missingDataType":"Lütfen veri tipi giriniz","missingDocument":"Lütfen dosya yüklemesi yapınız","newFolderName":"Yeni Klasör Adı","folder":"Klasör","folderName":"Klasör Adı","duplicateAgents":"Lütfen as ve yedek temsilciyi farklı seçin","missingBillUpload":"Lütfen fatura yükleyin","folderDeletionError":"Silmek istediğiniz klasöre ait dosya(lar) olduğundan silme işlemi gerçekleştirilemedi","duplicateDataType":"Lütfen daha önce girilmemiş bir veri tipi seçin","unitPriceError":"Lütfen belirlenen birim fiyatın %30 üstü ile %30 altı arasında bir değere denk gelen tüketim miktarı ve tutar girin.","address":"Adres","phone":"Telefon","Date conflict":"Girmiş olduğunuz tarih aralığında sistemde mevcut fatura bulunmaktadır.","Single day conflict":"Başlangıç ve bitiş tarihleri aynı olamaz!","Multiple year parse conflict":"Birden fazla yıla dağılan veriler için bitiş tarihi yılın ilk günü, bitiş tarihi ise yılın son günü olamaz.","Duplicate data entry":"Yinelenen veri girişi.","consumption":"Tüketim","carbonEmission":"Karbon Emisyon","carbonConsumption":"Tüketim","fleet":"Mobil yakma emisyonları","sirket-arac-diesel":"Filo (Mazot)","sirket-arac-benzin":"Filo (Benzin)","ATM (dış)":"Şube Dışı ATM","electricityConsumption":"Satın Alınan Enerji","personel-araç-dizel":"Otomobil - Dizel (Çalışan Ulaşımı)","personel-araç-benzin":"Otomobil - Benzin (Çalışan Ulaşımı)","konaklama-yurtiçi":"Konaklama (Yurt içi)","konaklama-yurtdışı":"Konaklama (Yurt dışı)","uncoated-freesheet":"A4 Kağıt","uncoated-groundwood":"Dekont","uncoated-freesheet(package)":"A4 Kağıt","uncoated-groundwood(block)":"Dekont","coated-freesheet":"Kuse Kapli Kagit","coated-groundwood":"Kuşe Kaplı 3. Hamur Kağıt","supercalendered":"Süperkalenderden Geçirilmiş Kağıt","lignite":"Linyit","uçuşlar-orta-mesafe":"Orta Mesafe Uçuş","uçuşlar-kısa-mesafe":"Kısa Mesafe Uçuş","uçuşlar-uzun-mesafe":"Uzun Mesafe Uçuş","vehicle-fuel":"Araç Yakıt Tüketimleri","Toner":"Toner","cartridge":"Kartuş","glass waste":"Cam","waste battery":"Atık pil","medical waste":"Tıbbi Atık","R-22":"HFC-22","R-134A":"HFC-134a","R-404A":"R-404A","R-407A":"R-407A","R-410":"R-410A","digitization rate":"Dijitalleşme Oranı","some special type":"Özel veri tipi","branch":"Şube","sub branch":"Bağlı Şube","private banking":"Özel Bankacılık Şubesi","corporate":"Kurumsal Şube","investment branch":"Yatırım Bankacılığı Şubesi","free area":"Serbest Bölge","commercial":"Ticari Şube","special branch":"Özel Bankacılık Şubesi","main branch":"Merkez Şube","tons":"ton","tons/days":"ton/gün","tons/kg":"ton/kg","tons/km":"ton/km","tons/kWh":"ton/kWh","tons/liters":"ton/litre","tons/m3":"ton/m3","tons/tons":"ton/ton","number of people":"Kişi Sayısı","litre":"litre","adet":"adet","piece":"adet","gün":"gün","day":"gün","paket":"paket","package":"paket","block":"blok","Elektrik":"Elektrik","Su":"Su","Evsel Atık":"Evsel Atık","Documents":"Belgeler","Forms":"Formlar","Audit":"Denetim","Impropriety":"Düzeltici ve Önleyici Aksiyon Takibi","garantiImpropriety":"Uygunsuzluk ve Aksiyon Planı","Outer Audit":"Dış Denetim","Inner Audit":"İç Denetim","Control":"Kontrol","Upload File":"Dosya Oluştur","cardboard":"Mukavva","plastic":"Plastik Atık","metal":"Metal Atık","electronicwaste":"Elektronik Atık","areaTitle":"Alan","agent":"Sürdürülebilirlik Temsilcisi","sub-agent":"Yedek Sürdürülebilirlik Temsilcisi","supervisor":"ÇYS Sorumlusu","isb_supervisor":"Sürdürülebilirlik Temsilcisi","isb_agent":"Çevre Sorumlusu","manager":"Müdür","new":"Yeni","externalAudit":"Dış Denetim","internalAudit":"İç Denetim","control":"Kontrol","title":"Başlık","nonconformanceType":"Uygunsuzluk Tipi","predictedDate":"Öngörülen Gerçekleşme Tarihi","extendedDate":"Uzatılmış Gerçekleşme Tarihi","dangerouswaste":"Tehlikeli Atık (diğer)","otherEvaluations":"Diğer Değerlendirmeler","nonconformity":"Aksiyon Planı","auditDate":"Denetim Tarihi","status":"Düzeltici Faaliyet Durumu","futureDateBill":"Gelecek tarihli fatura girilemez!","note":"Not","director":"Müdür","isOpen":"Durumu","siteOpen":"Açık","siteClosed":"Kapalı","Silmek istediğinize emin misiniz?":"Silmek istediğinize emin misiniz?","went-wrong":"Bir Hata Oluştu","document-exist":"Klasöre kayıtlı dosya olduğundan bu işlem gerçekleştirilemedi.","lpg":"LPG (Yakıt)","gasoline":"Benzin","diesel-generator":"Benzin (Jeneratör)","paper-usage":"Kağıt Kullanımı","16-passenger-bus":"16 Kişilik Servis Aracı (Çalışan Ulaşım)","27-passenger-bus":"27 Kişilik Servis Aracı (Çalışan Ulaşım)","45-passenger-bus":"45 Kişilik Servis Aracı (Çalışan Ulaşım)","car-batteries":"Araba Aküsü","toner":"Toner","electronic-waste":"Elektronik Atık","green-water":"Yeşil Su","grey-water":"Gri Su","HFC-23":"HFC-23","HFC-227ea":"HFC-227ea","R-407C":"R-407C","ton/piece":"ton/adet","technician":"Tekniker","ATIK TESLIM FORMU":"SIFIR ATIK ÇİZELGESİ","ATIK TAKIP FORMU":"ATIK TAKIP FORMU","KIMYASAL MALZEME FORMU":"KIMYASAL MALZEME FORMU","Sube/Bina":"Şube/Bina","Location":"Lokasyon","Locations":"Lokasyonlar","locations":"Lokasyonlar","Sube Kodu":"Şube Kodu","Sube Personel Sayisi":"Şube Personal Sayısı","Ilgili Belediye":"İlgili Belediye","Belediyenin Yetkilendirdigi Firma":"Belediyenin Yetkilendirdiği Firma","Olusturulma Tarihi":"Oluşturma Tarihi","Atik Cinsi":"Atık Cinsi","Atik Miktari":"Atık Miktarı","Teslim Eden Sube Personeli ve Ünvani":"Teslim Eden Şube Personeli ve Ünvanı","Teslim Alan Belediye/Firma Yetkilisi":"Teslim Alan Belediye/Firma Yetkilisi","Araç Plaka":"Araç plaka","Atik Teslim Tutanaklari":"Atık teslim tutanakları","Tarih":"Tarih","ay":"ay","admin":"Yönetici","guest":"Misafir","subAgent":"Yedek Sürdürülebilirlik Temsilcisi","Sürdürülebilirlik Temsilcisi ve şube personelinde farkındalığının yeterli düzeyde olmaması":"Sürdürülebilirlik Temsilcisi ve şube personelinde farkındalığının yeterli düzeyde olmaması","Çevre Yönetim Sistemi Dosyasında bulunması gereken dökümanların eksik olması":"Çevre Yönetim Sistemi Dosyasında bulunması gereken dökümanların eksik olması","ÇYS Tablo ve Formları’nın Sürdürülebilirlik Temsilcisi tarafından doldurulmamış veya tamamlanmamış olması":"ÇYS Tablo ve Formları’nın Sürdürülebilirlik Temsilcisi tarafından doldurulmamış veya tamamlanmamış olması","Şubede kullanılan kimyasal ürünlere ait MSDS’lerin (Malzeme Güvenlik Bilgi Formu) olmaması veya kısmen eksik olması.Temizlik alt yüklenici firmasının kalite sertifikalarının bulunmaması":"Şubede kullanılan kimyasal ürünlere ait MSDS’lerin (Malzeme Güvenlik Bilgi Formu) olmaması veya kısmen eksik olması.Temizlik alt yüklenici firmasının kalite sertifikalarının bulunmaması","Acil Eylem Durum Dosyası’nın eksik olması , gerekli görevlendirmelerin yapılmamış olması , İlkyardım sertifikasına sahip personelin sertifikasının bir örneğinin dosyada bulunmaması":"Acil Eylem Durum Dosyası’nın eksik olması , gerekli görevlendirmelerin yapılmamış olması , İlkyardım sertifikasına sahip personelin sertifikasının bir örneğinin dosyada bulunmaması","Şubede atık ayrıştırmasının çevre yönetim sistemimize uygun olarak yapılmaması":"Şubede atık ayrıştırmasının çevre yönetim sistemimize uygun olarak yapılmaması","Kimyasal malzeme depolamasının uygun şekilde yapılmaması":"Kimyasal malzeme depolamasının uygun şekilde yapılmaması","İlkyardım çantasında son kullanma tarihi geçmiş malzemelerin bulunması":"İlkyardım çantasında son kullanma tarihi geçmiş malzemelerin bulunması","Sistem Odasının düzensiz olması ve depolama yapılması":"Sistem Odasının düzensiz olması ve depolama yapılması","Jeneratör Odası’ndaki düzensizlikler ve risk oluşturabilecek unsurların olması ":"Jeneratör Odası’ndaki düzensizlikler ve risk oluşturabilecek unsurların olması","Bakım dosyalarının düzenli olarak tutulması ve takibinin yapılmaması":"Bakım dosyalarının düzenli olarak tutulması ve takibinin yapılmaması","HP atık toner kutusunun talep edilmemesi ve buna bağlı olarak boş kartuş tonerlerinin uygunsuz depolanması":"HP atık toner kutusunun talep edilmemesi ve buna bağlı olarak boş kartuş tonerlerinin uygunsuz depolanması","Şube personelinin Çevre Yönetim Sistemi ile ilgili farkındalığının arttırılmasına yönelik toplantılar düzenlenmeli , mailler atılmalı ve tüm personelin yönetim sistemi ile ilgili sorumluluklarının , hedef (elektrik,su,doğalgaz,A4 kağıt,yazıcı toner,dekont tasarrufu vb.) ve amaçlarının kavraması sağlanmalı.":"Şube personelinin Çevre Yönetim Sistemi ile ilgili farkındalığının arttırılmasına yönelik toplantılar düzenlenmeli , mailler atılmalı ve tüm personelin yönetim sistemi ile ilgili sorumluluklarının , hedef (elektrik,su,doğalgaz,A4 kağıt,yazıcı toner,dekont tasarrufu vb.) ve amaçlarının kavraması sağlanmalı.","Çevre Yönetim Sistemine ilişkin gerekli tüm prosedür, politika ve bilgilendirmelerin dokümantasyona eklenmesi sağlanarak, tüm personelin bilgilendirilmesi sağlanmalıdır.":"Çevre Yönetim Sistemine ilişkin gerekli tüm prosedür, politika ve bilgilendirmelerin dokümantasyona eklenmesi sağlanarak, tüm personelin bilgilendirilmesi sağlanmalıdır.","Tabloların (Çevre Boyutları Değerlendirme Tablosu,Kimyasal Malzeme Formu,Atık Takip Formu) detaylandırılarak revize edilmesine ve Verimlilik Sorumlusuna gönderilmesi.":"Tabloların (Çevre Boyutları Değerlendirme Tablosu,Kimyasal Malzeme Formu,Atık Takip Formu) detaylandırılarak revize edilmesine ve Verimlilik Sorumlusuna gönderilmesi.","Şubede kullanılan kimyasalların Malzeme Güvenlik Bilgi Formları eksiksiz olarak temin edilmeli ve dosyalanmalıdır.Bu konuda şubenin çalıştığı temizlik firmasından destek alabilirsiniz. Firmadan tüm kalite belgeleri istenmelidir.":"Şubede kullanılan kimyasalların Malzeme Güvenlik Bilgi Formları eksiksiz olarak temin edilmeli ve dosyalanmalıdır.Bu konuda şubenin çalıştığı temizlik firmasından destek alabilirsiniz. Firmadan tüm kalite belgeleri istenmelidir.","Acil Durum Eylem Planı ve oluşturulacak Acil Durum Eylem Takımı Yapısı’nın hazırlanarak dosyalanması.Şubede kaza ve acil durumlara maruz kalma ihtimalinde yapılması gerekenlerin şube personeliyle paylaşılması":"Acil Durum Eylem Planı ve oluşturulacak Acil Durum Eylem Takımı Yapısı’nın hazırlanarak dosyalanması.Şubede kaza ve acil durumlara maruz kalma ihtimalinde yapılması gerekenlerin şube personeliyle paylaşılması","Atık ayrıştırmasının Bankamız atık kontrolü prosedürüne uygun olarak yapılması gerekmekte olup, tüm personelin aynı bilinçle hareket etmesi sağlanmalıdır. Atık ayrıştırma kutularının yeterli sayıda ve uygun yerlerde olması gerekmektedir.":"Atık ayrıştırmasının Bankamız atık kontrolü prosedürüne uygun olarak yapılması gerekmekte olup, tüm personelin aynı bilinçle hareket etmesi sağlanmalıdır. Atık ayrıştırma kutularının yeterli sayıda ve uygun yerlerde olması gerekmektedir.","Şubede kullanılan ve depolanan tüm kimyasallar için ‘’Kimyasal Malzeme Alanı’’ oluşturulmalı , oluşabilecek herhangi bir sızıntıya karşı altlarına taşma tavalarının yerleştirilmesi ve alıcı ortamla bağlantısının kesilmesi sağlanmalıdır.":"Şubede kullanılan ve depolanan tüm kimyasallar için ‘’Kimyasal Malzeme Alanı’’ oluşturulmalı , oluşabilecek herhangi bir sızıntıya karşı altlarına taşma tavalarının yerleştirilmesi ve alıcı ortamla bağlantısının kesilmesi sağlanmalıdır.","İlkyardım Çantasında tarihi geçmiş malzemelerin yerel eczanelerden temin edilerek güncel tarihli malzemelerle tutanakla değiştirilmesi gerekmektedir.Ödemeleri şubenize ait Sağlık Yardımları Bütçesi’nden karşılayabilirsiniz.":"İlkyardım Çantasında tarihi geçmiş malzemelerin yerel eczanelerden temin edilerek güncel tarihli malzemelerle tutanakla değiştirilmesi gerekmektedir.Ödemeleri şubenize ait Sağlık Yardımları Bütçesi’nden karşılayabilirsiniz.","Dağınık durumda olan Sistem Odası’nın düzenlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.":"Dağınık durumda olan Sistem Odası’nın düzenlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.","Dağınık ve bakımsız durumda olan Jeneratör Odası’nın temizlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.":"Dağınık ve bakımsız durumda olan Jeneratör Odası’nın temizlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.","Bakım formlarının tek bir dosyada tutulması ve güncel olarak takibinin yapılması sağlanmalıdır.":"Bakım formlarının tek bir dosyada tutulması ve güncel olarak takibinin yapılması sağlanmalıdır.","Atık toner kartuş kutusu için HP’nin anlaşmalı olduğu Anel Doğa firması ile irtibata geçilmeli kutu istenmeli , depolamanın uygun şekilde yapılması sağlanmalıdır.":"Atık toner kartuş kutusu için HP’nin anlaşmalı olduğu Anel Doğa firması ile irtibata geçilmeli kutu istenmeli , depolamanın uygun şekilde yapılması sağlanmalıdır.","Diğer":"Diğer","Kartus":"Kartuş","Atik Pil":"Atık Pil","Tibbi Atik":"Tıbbi Atık","Evsel Atik":"Evsel Atık","Geri Dönüsebilir Atik":"Geri Dönüşebilir Atık","Arac Filosu - Benzin":"Araç Filosu - Benzin","Arac Filosu - Dizel":"Araç Filosu - Dizel","passanger_km":"Yolcu km","vehicle_km":"Araç km","foodAndDrinkWaste":"Yiyecek ve İçecek Atıkları","mixedOrganics":"Karışık Organik Atık","mixedElectronics":"Karışık Elektronik Atık","batteries":"Pil/Batarya","aluminiumCansAndFoil":"Alüminyum Kutu/Konserve ve Folyo","mixedCans":"Karışık Kutu/Konserve","averagePlastics":"Karışık Plastik Atık","medicalWaste":"Tıbbi Atık","householdResidualWaste":"Evsel Atık","magazines_thirdClassMail":"Dergi, Broşür","glass":"Cam","fluorescent":"Floresan ampul","mixedRecyclables":"Karışık Geri Dönüştürülebilir Atık","dieselFuel":"Dizel Yakıt/Mazot","mixedPaper_general":"Karışık Kağıt (Genel Kullanım)","mixedPaper_primaryResidential":"Karışık Kağıt (Evsel Kullanım)","mixedPaper_primaryFromOffice":"Karışık Kağıt (Ofislerde Kullanım)","mixedPaper_primaryFromOffices":"Karışık Kağıt (Ofislerde Kullanım)","newspaper":"Gazete","textbooks":"Ders Kitabı","default":"Varsayılan","bituminousCoal":"Bitümlü Kömür","corrugatedContainers":"Oluklu Karton","motorGasoline_MobileCombustion":"Motor Benzini","diesel_MobileCombustion":"Dizel Yakıt/Mazot","biodiesel_mobileCombustion":"Biyodizel","Ethanol_mobileCombustion":"Ethanol","CNG_mobileCombustion":"CNG (Sıkıştırılmış Doğal Gaz)","r134a":"R-134a","motorGasoline":"Motor Benzini","blueWater":"Mavi Su (Yüzey, Yeraltı Suyu)","greyWater":"Gri Su (Kirli Su)","greenWater":"Yeşil Su (Yağmur Suyu)","districtHeating":"Bölgesel Isıtma","r404a":"R-404A","steam":"Buhar","districtCooling":"Bölgesel Soğutma","r410a":"R-410A","fuelOil":"Fuel Oil","shortHaul_AveragePassenger":"Kısa Mesafe - Ortalama Yolcu","longHaul_averagePassenger":"Uzun Mesafe - Ortalama Yolcu","mediumHaul_averagePassenger":"Orta Mesafe - Ortalama Yolcu","r407a":"R-407A","r407c":"R-407C","hfc227ea":"HFC-227ea","hcfc22":"HCFC-22","hfc23":"HFC-23","hfc32":"HFC-32","carBatteries":"Araba Aküsü","mixedPaper_PurchasedGood":"Karışık Kağıt (Genel Kullanım)","bus_coach":"Yolcu Otobüsü","localBus":"Şehir İçi Otobüs","taxi":"Taksi","liquefiedPetroleumGases":"Sıvılaştırılmış Petrol Gazı (LPG)","lpg_mobileCombustion":"Sıvılaştırılmış Petrol Gazı (LPG)","naturalGas":"Doğalgaz","transitRail":"Hafif Raylı Ulaşım (Metro, Tramvay)","internationalRail":"Uluslararası Raylı Ulaşım","anthracite":"Antrasit","cokingCoal":"Kok Kömürü","footPassenger":"Ayakta Yolcu","carPassenger":"Arabalı Yolcu","average_ferry":"Ortalama Yolcu","hotelStay":"Konaklama","other_Waste":"Diğer Atıklar","passangerCar":"Yolcu Arabası","lightDutyVehciles":"Hafif Ticari Araç","heavyDutyVehicle_Buses":"Ağır Hizmet Aracı ve Otobüs","recycled":"Geri Kazanım","hydrofluorocarbons":"Hidroflorokarbon (HFC)","hydrochlorofluorocarbons":"Hidrokloroflorokarbon","refrigerantBlend":"Soğutucu Karışım","landfilled":"Atık Depolama","combusted":"Yakma","composted":"Kompostlama","boilers_furnaces":"Kazan/Fırın","internalCombustionEngines":"İçten Yanmalı Motorlar","turbines":"Türbinler","flares":"Yakıcı","processHeaters_ovens":"Proses Isıtıcı/Fırın","incinerators":"Atık Yakma Fırını","coolingSystem":"Soğutma Sistemi","flights":"Uçuşlar","bus":"Otobüs","ferry":"Feribot","airTravel":"Uçak Seyahati","railTravel":"Demiryolu Seyahati","busTravel":"Otobüs Seyahati","automobileTravel":"Otomobil Seyahati","otherModesOfTravel":"Diğer Seyahat Yöntemleri","accommodation":"Konaklama","companyVehicles":"Şirket Araçları","employeeCommuting":"Personel Ulaşımı","purchasedEnergy":"Satınalınan Enerji","wasteGeneratedInOperations":"Operasyonlar Sonucu Meydana Gelen Atıklar","stationaryCombustion":"Sabit Yakma","refrigerants":"Soğutucu Gazlar","purchasedGoodsAndServices":"Ürün/hizmet kullanımı","businessTravel":"İş Seyahatleri","waterUsage":"Su Tüketimi","Vehicle":"Araç","Usage For":"Kullanım Amacı","Disposal Method":"Bertaraf Yöntemi","Travel Mode":"Ulaşım Türü","Refrigerant":"Soğutucu Akışkan","next":"İleri","back":"Geri","add":"Ekle","Any":"Herhangi","Default":"Varsayılan","country":"Ülke","region":"Bölge","city":"Şehir","sector":"Sektör","countries":"Ülkeler","regions":"Bölgeler","cities":"Şehirler","sectors":"Sektörler","search":"Arama"},"en":{"all":"All","allSites":"All Sites","allRegions":"All Regions","regionError":"Region not found","siteError":"Site not found","siteSearchPlaceholder":"Search Sites","cityTitle":"City","regionTitle":"Region","total":"Total","site":"Site","other":"Other","choose":"Choose","none":"None","current-agent":"Selected agent: ","cancel":"Cancel","save":"Save","delete":"Delete","confirm":"Confirm","upload":"Upload","download":"Download","update":"Update","yes":"Yes","no":"No","ok":"Okay","chooseDatePlaceholder":"Choose a Date","confirmDataTypeDeletion":"When you delete this data type, data of that data type will not be deleted. Just data type is removed from the list for selected year. If you would like to delete data, you should add that deleted data type and go details of it, then delete each data entry.","edit":"Edit","response":"Response","reply":"Reply","lastUpdatedAt":"Last Update","close":"Close","electricity":"Electricity","non-eligible-consumer-electricity":"Non-eligible Consumer Electricity","eligible-consumer-electricity":"Eligible Consumer Electricity","electric":"Electricity","gas":"Natural Gas","Doğalgaz":"Natural Gas","diesel":"Diesel - Heating","Dizel":"Diesel - Heating","heating":"Stationary Combustion","coolant-gas":"Fugitive Emissions","paper":"Paper Waste","Purchased Goods and Services":"Purchased Goods and Services","flightsTitle":"Business Travels","personel-cars":"Employee Commuting","employeeCommuteTitle":"Employee Commuting","domestic-waste":"Waste","accomodation":"Accomodation","coal":"Coal","Kömür":"Coal","fueloil":"Fuel Oil - Heating","water":"Water","blue-water":"Blue Water","domesticwaste":"Domestic Waste","generator":"Generator (Diesel)","Jeneratör":"Generator (Diesel)","geothermal":"Geothermal","Jeotermal":"Geothermal","recyclablewaste":"Recyclable Waste","required":"Required","create":"Create","updated":"Updated","missingError":"Fill in the missing areas","missingFile":"Don\u0027t forget to upload bill for data entry","missingTableRow":"Please add at least one row into table","conflictEmissionYear":"Please choose a different year for each emission type","conflictUnitPriceYear":"Please choose a different year for each unit price of a data type","duplicateStartEndYear":"Please choose different start and end years.","missingDataType":"Please fill the data types section","missingDocument":"Please upload a document","newFolderName":"New Folder Name","folder":"Folder","folderName":"Folder Name","duplicateAgents":"Please do not choose agent and sub agent as same person.","missingBillUpload":"Please upload a related bill","folderDeletionError":"Selected folder cannot be removed since there some files in it.","duplicateDataType":"Please select a data type different than existent data types.","unitPriceError":"Please insert amount and cost that satisfy a unit price ratio which is between 70% and 130% of the specified unit price","address":"Address","phone":"Phone","Date conflict":"The date range you have selected conflicts with another bill\u0027s date range.","Single day conflict":"Start and end dates cannot be the same!","Multiple year parse conflict":"For data distributed over more than one year, the end date cannot be the first day of the year and the end date cannot be the last day of the year.","Duplicate data entry":"Duplicate data entry.","consumption":"Consumption","carbonEmission":"Carbon Emission","carbonConsumption":"Consumption","fleet":"Mobile Combustion Emissions","sirket-arac-diesel":"Fleet (Diesel)","sirket-arac-benzin":"Fleet (Gasoline)","ATM (dış)":"Stand Alone ATM","electricityConsumption":"Purchased Energy","personel-araç-dizel":"Car - Diesel (Employee Commuting)","personel-araç-benzin":"Car - Gasoline (Employee Commuting)","konaklama-yurtiçi":"Accomodation (Domestic)","konaklama-yurtdışı":"Accomodation (International)","uncoated-freesheet":"Uncoated Freesheet","uncoated-groundwood":"Uncoated Groundwood","uncoated-freesheet(package)":"Uncoated Freesheet","uncoated-groundwood(block)":"Uncoated Groundwood","coated-freesheet":"Coated Freesheet","coated-groundwood":"Coated Groundwood","supercalendered":"Supercalendered","lignite":"Lignite","uçuşlar-orta-mesafe":"Medium-haul Distance","uçuşlar-kısa-mesafe":"Short-haul Flights","uçuşlar-uzun-mesafe":"Long-haul Flights","vehicle-fuel":"Mobile Combustion Emissions","Toner":"Toner","cartridge":"Cartridge","glass waste":"Glass","waste battery":"Waste batteries","medical waste":"Medical Waste","R-22":"HFC-22","R-134A":"HFC-134a","R-404A":"R-404A","R-407A":"R-407A","R-410":"R-410A","digitization rate":"Digitization Rate","some special type":"Special data type","branch":"Branch","sub branch":"Sub Branch","private banking":"Private Banking Branch","corporate":"Corporate Branch","investment branch":"Investment Banking Branch","free area":"Free Area","commercial":"Commercial Branch","special branch":"Special Banking Branch","main branch":"Main Branch","number of people":"People","litre":"liters","adet":"pieces","piece":"pieces","gün":"days","day":"day","paket":"packages","package":"packages","block":"blocks","blok":"blocks","Elektrik":"Electricity","Su":"Water","Evsel Atık":"Waste","Documents":"Documents","Forms":"Forms","Audit":"Audit","Impropriety":"Corrective and Preventive Action Tracking","garantiImpropriety":"Corrective and Preventive Action Tracking","Outer Audit":"External Audit","Inner Audit":"Internal Audit","Control":"Control","Upload File":"Upload File","cardboard":"Cardboard","plastic":"Plastic Waste","metal":"Metal Waste","electronicwaste":"Electronic Waste","Fatura":"Bill","E-Fatura":"E-Bill","Ödeme Makbuzu":"Payment Receipt","Abone (ATM\u0027ler için)":"Subscription (for ATMs)","Merkezi Sistem":"Central System Fee","Aidat":"Membership Fee","areaTitle":"Area","agent":"Sustainability Agent","sub-agent":"Substitute Sustainability Agent","supervisor":"Supervisor","isb_supervisor":"Supervisor","isb_agent":"Environmental Officer","manager":"Manager","new":"New","externalAudit":"External Audit","internalAudit":"Internal Audit","control":"Control","title":"Title","nonconformanceType":"Nonconformance Type","predictedDate":"Predicted Execution Date","extendedDate":"Extended Date","dangerouswaste":"Dangerous Waste (other)","otherEvaluations":"Other Evaluations","nonconformity":"Action","auditDate":"Audit Date","status":"Corrective Action Status","futureDateBill":"Bill has future date is not allowed!","note":"Note","director":"Director","isOpen":"Site status","siteOpen":"Open","siteClosed":"Closed","Silmek istediğinize emin misiniz?":"Are you sure you want to delete it?","went-wrong":"Something went wrong","document-exist":"This operation could not be performed because there is a file registered in the folder.","Serbest Tüketici Olmayan - Elektrik (kWh)":"Non-eligible Consumer Electricity (kWh)","eligible-consumer-electricity (kWh)":"Eligible Consumer Electricity (kWh)","Elektrik Tüketimi (kWh)":"Electricity Consumption (kWh)","Su Tüketimi (m³)":"Water Consumption (m³)","Mavi Su Tüketimi (m³)":"Blue Water Consumption (m³)","Jeneratör Tüketimi (Mazot) (lt)":"Generator Consumption (Disesel) (lt)","Kömür Tüketimi (ton)":"Coal Consumption (tone)","Doğalgaz Tüketimi (m³)":"Natural Gas Consumption (m³)","Fuel Oil - Isınma Tüketimi (lt)":"Fuel Oil - Heating Consumption (lt)","Jeotermal Tüketimi (kWh)":"Geothermal Consumption (kWh)","Mazot - Isınma Tüketimi (lt)":"Diesel - Heating Consumption (lt)","lpg":"LPG (Combustion Fuel)","gasoline":"Gasoline","diesel-generator":"Gasoline (Generator)","paper-usage":"Paper Usage","16-passenger-bus":"16 Passanger Bus (Employee Commuting)","27-passenger-bus":"27 Passanger Bus (Employee Commuting)","45-passenger-bus":"45 Passanger Bus (Employee Commuting)","car-batteries":"Car Batteries","electronic-waste":"Electronic waste","green-water":"Green Water","grey-water":"Grey Water","HFC-23":"HFC-23","HFC-227ea":"HFC-227ea","R-407C":"R-407C","ton/piece":"ton/piece","technician":"Technician","ATIK TESLIM FORMU":"ZERO WASTE TABLE","ATIK TAKIP FORMU":"WASTE TRACKING FORM","KIMYASAL MALZEME FORMU":"CHEMICAL MATERIAL FORM","Sube/Bina":"Location","Location":"Location","Locations":"Locations","locations":"Locations","Sube Kodu":"Location code","Sube Personel Sayisi":"Number of Employee","Ilgili Belediye":"Municipality","Belediyenin Yetkilendirdigi Firma":"Company Name (Authorized by the municipality)","Olusturulma Tarihi":"Date","Atik Cinsi":"Type of Waste","Atik Miktari":"Quantity","Teslim Eden Sube Personeli ve Ünvani":"Employee Informations","Teslim Alan Belediye/Firma Yetkilisi":"Delivery accepted by","Araç Plaka":"Vehicle registration plate","Atik Teslim Tutanaklari":"Waste delivery receipts","Tarih":"date of delivery","ay":"month","admin":"Admin","guest":"Guest","subAgent":"Sub Agent","Sürdürülebilirlik Temsilcisi ve şube personelinde farkındalığının yeterli düzeyde olmaması":"Low awareness level of the location employees.","Çevre Yönetim Sistemi Dosyasında bulunması gereken dökümanların eksik olması":"Missing documents in the Environmental Management System File.","ÇYS Tablo ve Formları’nın Sürdürülebilirlik Temsilcisi tarafından doldurulmamış veya tamamlanmamış olması":"Not filled or completed EMS Tables and Forms.","Şubede kullanılan kimyasal ürünlere ait MSDS’lerin (Malzeme Güvenlik Bilgi Formu) olmaması veya kısmen eksik olması.Temizlik alt yüklenici firmasının kalite sertifikalarının bulunmaması":"Missing MSDS (Material Safety Data Sheet) of the chemical products used in the location. The lack of quality certificates of the cleaning subcontractor company.","Acil Eylem Durum Dosyası’nın eksik olması , gerekli görevlendirmelerin yapılmamış olması , İlkyardım sertifikasına sahip personelin sertifikasının bir örneğinin dosyada bulunmaması":"Missing emergency action plan document, Missing first aid certificate of the trained employees.","Şubede atık ayrıştırmasının çevre yönetim sistemimize uygun olarak yapılmaması":"Improper waste segregation according to the EMS.","Kimyasal malzeme depolamasının uygun şekilde yapılmaması":"Improper storage of chemical materials.","İlkyardım çantasında son kullanma tarihi geçmiş malzemelerin bulunması":"Detecting expired materials in the first ait kit.","Sistem Odasının düzensiz olması ve depolama yapılması":"Untidy system room and to be founding improper material storage.","Jeneratör Odası’ndaki düzensizlikler ve risk oluşturabilecek unsurların olması ":"Untidy generator room and to be founding improper elements in the room.","Bakım dosyalarının düzenli olarak tutulması ve takibinin yapılmaması":"Failure to keep and track maintenance files regularly.","HP atık toner kutusunun talep edilmemesi ve buna bağlı olarak boş kartuş tonerlerinin uygunsuz depolanması":"Failure to claim waste toner box and accordingly improper storage of empty cartridge toners.","Şube personelinin Çevre Yönetim Sistemi ile ilgili farkındalığının arttırılmasına yönelik toplantılar düzenlenmeli , mailler atılmalı ve tüm personelin yönetim sistemi ile ilgili sorumluluklarının , hedef (elektrik,su,doğalgaz,A4 kağıt,yazıcı toner,dekont tasarrufu vb.) ve amaçlarının kavraması sağlanmalı.":"Meetings should be organized to increase the awareness of the employees about the Environmental Management System, and it should be ensured that all employees understand the responsibilities of the management system, their targets (electricity, water, natural gas, paper etc.).","Çevre Yönetim Sistemine ilişkin gerekli tüm prosedür, politika ve bilgilendirmelerin dokümantasyona eklenmesi sağlanarak, tüm personelin bilgilendirilmesi sağlanmalıdır.":"All employees should be informed by ensuring that all necessary procedures, policies and information regarding the Environmental Management System are included in the documentation.","Tabloların (Çevre Boyutları Değerlendirme Tablosu,Kimyasal Malzeme Formu,Atık Takip Formu) detaylandırılarak revize edilmesine ve Verimlilik Sorumlusuna gönderilmesi.":"EMS tables must be filled and sent to the responsible employee.","Şubede kullanılan kimyasalların Malzeme Güvenlik Bilgi Formları eksiksiz olarak temin edilmeli ve dosyalanmalıdır.Bu konuda şubenin çalıştığı temizlik firmasından destek alabilirsiniz. Firmadan tüm kalite belgeleri istenmelidir.":"The Material Safety Data Sheets of the chemicals used in the location must be obtained. All quality documents should be requested from the cleaning company (You can get support from the cleaning company that the location works with).","Acil Durum Eylem Planı ve oluşturulacak Acil Durum Eylem Takımı Yapısı’nın hazırlanarak dosyalanması.Şubede kaza ve acil durumlara maruz kalma ihtimalinde yapılması gerekenlerin şube personeliyle paylaşılması":"Emergency Action Plan must be established and the Emergency Response Team Members must be identified. Sharing with the employees what should be done in case of exposure to accidents and emergencies in the location. Employees should be informed about what to do in case of exposure to accidents and emergencies in the location.","Atık ayrıştırmasının Bankamız atık kontrolü prosedürüne uygun olarak yapılması gerekmekte olup, tüm personelin aynı bilinçle hareket etmesi sağlanmalıdır. Atık ayrıştırma kutularının yeterli sayıda ve uygun yerlerde olması gerekmektedir.":"Waste segregation must be done accordance to the EMS. Waste separation boxes should be in sufficient numbers and in suitable places.","Şubede kullanılan ve depolanan tüm kimyasallar için ‘’Kimyasal Malzeme Alanı’’ oluşturulmalı , oluşabilecek herhangi bir sızıntıya karşı altlarına taşma tavalarının yerleştirilmesi ve alıcı ortamla bağlantısının kesilmesi sağlanmalıdır.":"\\"Chemical Material Area\\" should be created for all chemicals used and stored in the location. It should be ensured that overflow pans are placed under chemical material area against any leakage that may occur.","İlkyardım Çantasında tarihi geçmiş malzemelerin yerel eczanelerden temin edilerek güncel tarihli malzemelerle tutanakla değiştirilmesi gerekmektedir.Ödemeleri şubenize ait Sağlık Yardımları Bütçesi’nden karşılayabilirsiniz.":"Expired materials should be replaced with new ones from local pharmacies.","Dağınık durumda olan Sistem Odası’nın düzenlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.":"System room must be organized and eliminate the elements that may create a risk.","Dağınık ve bakımsız durumda olan Jeneratör Odası’nın temizlenmesi ve risk oluşturabilecek unsurların ortadan kaldırılması gerekmektedir.":"Generator room must be organized and eliminate the elements that may create a risk.","Bakım formlarının tek bir dosyada tutulması ve güncel olarak takibinin yapılması sağlanmalıdır.":"It should be ensured that the maintenance forms are kept in the file and followed up-to-date.","Atık toner kartuş kutusu için HP’nin anlaşmalı olduğu Anel Doğa firması ile irtibata geçilmeli kutu istenmeli , depolamanın uygun şekilde yapılması sağlanmalıdır.":"Waste toner cartridge box should be requested from responsible company, and proper storage should be ensured for waste toners.","Diğer":"Others","Geri Dönüşebilir Atık":"Recyclable Waste","Fuel Oil (litre)":"Fuel Oil (liter)","Filo (Mazot) (litre)":"Fleet (Diesel) (liter)","Filo (Benzin) (litre)":"Fleet (Gasoline) (liter)","Konaklama Yurt İçi":"Accomodation (Domestic)","Konaklama Yurt Dışı":"Accomodation (International)","Çalışan Seyahatleri - Dizel":"Car - Diesel (Employee Commuting)","Çalışan Seyahatleri - Benzin":"Car - Gasoline (Employee Commuting)","Uçuşlar - Uzun Mesafe":"Long-haul Flights","Uçuşlar - Kısa Mesafe":"Short-haul Flights","Uçuşlar - Orta Mesafe":"Medium-haul Distance","Kartus":"Cartridge","Cam":"Glass Waste","Atik Pil":"Waste Battery","Floresan":"Fluorescent","Tibbi Atik":"Medical Waste","Geri Dönüsebilir Atik":"Recyclable Waste","Arac Filosu - Benzin":"Fleet (Gasoline)","Arac Filosu - Dizel":"Fleet (Diesel)","Personel Araç - Dizel":"Car - Diesel (Employee Commuting)","Personel Araç - Benzin":"Car - Gasoline (Employee Commuting)","Evsel Atik":"Domestic Waste","Benzin":"Gasoline","ton":"mt","passanger_km":"Passanger-km","vehicle_km":"Vehicle-km","foodAndDrinkWaste":"Food and Drink Waste","mixedOrganics":"Mixed Organics","mixedElectronics":"Mixed Electronics","batteries":"Batteries","aluminiumCansAndFoil":"Aluminium Cans and Foil","mixedCans":"Mixed Cans","averagePlastics":"Average Plastics","medicalWaste":"Medical Waste","householdResidualWaste":"Household Residual Waste","magazines_thirdClassMail":"Magazines, Third-Class Mail","glass":"Glass","fluorescent":"Fluorescent bulb","toner":"Toner","mixedRecyclables":"Mixed Recyclables","dieselFuel":"Diesel Fuel","mixedPaper_general":"Mixed Paper (General)","mixedPaper_primaryResidential":"Mixed Paper (Primary Residential)","mixedPaper_primaryFromOffice":"Mixed Paper (Primary From Office)","mixedPaper_primaryFromOffices":"Mixed Paper (Primary From Office)","newspaper":"Newspaper","textbooks":"Textbooks","default":"Default","bituminousCoal":"Bituminous Coal","corrugatedContainers":"Corrugated Containers","motorGasoline_MobileCombustion":"Motor Gasoline","diesel_MobileCombustion":"Diesel Fuel","biodiesel_mobileCombustion":"Biodiesel","Ethanol_mobileCombustion":"Ethanol","CNG_mobileCombustion":"CNG (Comparessed Natural Gas)","r134a":"R-134a","motorGasoline":"Motor Gasoline","blueWater":"Blue Water","greyWater":"Grey Water","greenWater":"Green Water","districtHeating":"District Heating","r404a":"R-404A","steam":"Steam","districtCooling":"District Cooling","r410a":"R-410A","fuelOil":"Fuel Oil","shortHaul_AveragePassenger":"Short-haul - Average passenger","longHaul_averagePassenger":"Long-haul - Average passenger","mediumHaul_averagePassenger":"Medium-haul - Average passenger","r407a":"R-407A","r407c":"R-407C","hfc227ea":"HFC-227ea","hcfc22":"HCFC-22","hfc23":"HFC-23","hfc32":"HFC-32","carBatteries":"Car Batteries","mixedPaper_PurchasedGood":"Mixed Paper (General)","bus_coach":"Coach","localBus":"Local Bus","taxi":"Taxi","liquefiedPetroleumGases":"Liquefied Petroleum Gases (LPG)","lpg_mobileCombustion":"Liquefied Petroleum Gases (LPG)","naturalGas":"Natural Gas","transitRail":"Transit Rail (i.e. Subway, Tram)","internationalRail":"International Rail","anthracite":"Anthracite","cokingCoal":"Coking coal","footPassenger":"Foot passenger","carPassenger":"Car passenger","average_ferry":"Average (all passenger)","hotelStay":"Hotel Stay","other_Waste":"Other","passangerCar":"Passenger Car","lightDutyVehciles":"Light-Duty Vehicles","heavyDutyVehicle_Buses":"Heavy-Duty Vehicle and Buses","recycled":"Recycled","hydrofluorocarbons":"Hydrofluorocarbons (HFCs)","hydrochlorofluorocarbons":"Hydrochlorofluorocarbons","refrigerantBlend":"Refrigerant Blend","landfilled":"Landfilled","combusted":"Combusted","composted":"Composted","boilers_furnaces":"Boilers/furnaces","internalCombustionEngines":"Internal Combustion Engines","turbines":"Turbines","flares":"Flares","processHeaters_ovens":"Process heaters/ovens","incinerators":"Incinerators","coolingSystem":"Cooling System","flights":"Flights","bus":"Bus","ferry":"Ferry","airTravel":"Air travel","railTravel":"Rail travel","busTravel":"Bus travel","automobileTravel":"Automobile Travel","otherModesOfTravel":"Other Modes of Travel","accommodation":"Accommodation","companyVehicles":"Company Vehicles","employeeCommuting":"Employee Commuting","purchasedEnergy":"Purchased Energy","wasteGeneratedInOperations":"Waste Generated in Operations","stationaryCombustion":"Stationary Combustion","refrigerants":"Refrigerants","purchasedGoodsAndServices":"Purchased Goods and Services","businessTravel":"Business Travels","waterUsage":"Water Usage","Vehicle":"Vehicle","Usage For":"Usage For","Disposal Method":"Disposal Method","Travel Mode":"Travel Method","Refrigerant":"Refrigerant","next":"Next","back":"Back","add":"Add","Any":"Any","country":"Country","region":"Region","city":"City","sector":"Sector","countries":"Countries","regions":"Regions","cities":"Cities","sectors":"Sectors","Default":"Default","search":"Search"}}')
}


/***/ }),

/***/ "IC/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__ = __webpack_require__("IaV/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TableAndChart: __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__["a" /* default */],
        RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    },
    name: 'ScopeOne',
    data: function data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            initialEmissions: [],
            consumptions: []
        };
    },


    methods: {
        retrieveEmissions: function retrieveEmissions() {
            var _this = this;

            this.$Progress.start();
            this.axios.get('/report/emission?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId,
                scope: 'Scope-1'
            })).then(function (_ref) {
                var data = _ref.data;

                _this.initialEmissions = data;
                _this.isLoaded = true;
            });
            this.isLoaded = true;
        },
        selectSiteId: function selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.retrieveEmissions();
        },
        selectSiteGroupId: function selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.retrieveEmissions();
        },
        onYearChange: function onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({ name: 'scope-1', query: { year: this.year } });
            this.retrieveEmissions();
        }
    },

    created: function created() {
        this.selectedSiteId = this.route.params.site_id ? Number(this.route.params.site_id) : this.selectedSiteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        this.retrieveEmissions();
    }
});

/***/ }),

/***/ "INsQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"main-layout",class:_vm.showScrollbar || _vm.isMenuVisible ? 'main-layout--with-scrollbar' : '',attrs:{"no-body":""}},[_c('TheNavbar',{on:{"change":function (visible) { return _vm.isMenuVisible = visible; }}}),_vm._v(" "),_c('b-card-body',{staticStyle:{"line-height":"18px"}},[_c('router-view',{attrs:{"show-scrollbar":_vm.showScrollbar}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IZka":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"date-error":"Önceki verinin tarihinden eski tarih girilemez!","unexpectedError":"Beklenmeyen bir hata oluştu!","formCreateMsg":"Form oluşturuluyor. Lütfen bekleyin.","saveForm":"Formu kaydetmek için \u0027Oluştur\u0027 butonuna tıklayın"},"en":{"date-error":"Entering an older date than previous dates is not allowed!","unexpectedError":"An unexpected error ocurred!","formCreateMsg":"Form is being created. Please wait.","saveForm":"Click the \u0027Create\u0027 button to save the form"}}')
}


/***/ }),

/***/ "IaV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableAndChart_vue__ = __webpack_require__("lDa5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0342be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableAndChart_vue__ = __webpack_require__("1uX5");
function injectStyle (ssrContext) {
  __webpack_require__("ztEm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b0342be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableAndChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b0342be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableAndChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cities__ = __webpack_require__("+xba");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
    user: {},
    modal: {
        eventId: null,
        type: null,
        text: null
    },
    data: {
        tags: [],
        meta: {},
        content: {}
    },
    uploadFiles: [],
    documents: [],
    goals: [],
    year: __WEBPACK_IMPORTED_MODULE_2_moment___default()().year(),
    audits: [],
    nonconformances: [],
    paymentMethods: [],
    siteId: null,
    sites: [],
    siteTypes: [],
    dataTypes: [],
    countryMap: {},
    regionMap: {},
    cityMap: {},
    sectorMap: {},
    locationMap: [],
    tagMap: [],
    scopeGroupMap: [],
    sourceTypeGroupMap: [],
    sourceTypeMap: [],
    unitMap: {},
    dashboardDataTypes: [121, 124, 147],
    formTypes: [],
    units: [],
    maxUpdatedAtForDocuments: null,
    maxUpdatedAtForGoals: null,
    maxUpdatedAtForAudits: null,
    cities: __WEBPACK_IMPORTED_MODULE_6__cities__["a" /* default */],
    siteGroups: [],
    isInitiated: false,
    isMobile: false,
    isTablet: false,
    locale: 'tr',
    // Need production ip address
    /*eslint-disable */
    apiURL:  false ? 'http://localhost:7788' : '/backend',
    token: 'Bearer ' + localStorage.getItem('token')
    /*eslint-enable */
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
    actions: Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_vue__["default"])
}));

/***/ }),

/***/ "Ihp2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.rhombusesStyles),function(rs,index){return _c('div',{staticClass:"rhombus",style:(rs),attrs:{"ikey":index}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Io1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',[(this.gbId(this.$store.state.user.customerId) && this.route.params.form_type == 1)?_c('b-card',[_c('div',{staticStyle:{"font-weight":"bold","margin-top":"0px"}},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_vm._v(" "),_c('custom-form',{staticStyle:{"margin-top":"30px"},attrs:{"isEditable":true,"schema":_vm.formSchema,"data":_vm.formData},on:{"formChange":_vm.onformChange}}),_vm._v(" "),_c('custom-form-table',{staticStyle:{"margin-top":"60px","margin-bottom":"60px"},attrs:{"isEditable":true,"initialData":{items: _vm.tableData, fields: _vm.tableCols}},on:{"applyDataChanges":_vm.applyDataChanges,"insertItem":_vm.insertItem,"deleteItemById":_vm.deleteItemById}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[_c('div',{staticClass:"p-2"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('saveForm')))]),_vm._v(" "),_c('b-btn',{staticClass:"btn-success",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.createForm()}}},[_vm._v(_vm._s(_vm.$t('create')))])],1)])],1):_c('b-card',[_c('div',{staticStyle:{"font-weight":"bold","margin-top":"0px"}},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),_vm._v(" "),_c('custom-form',{staticStyle:{"margin-top":"30px"},attrs:{"isEditable":true,"schema":_vm.formSchema,"data":_vm.formData},on:{"formChange":_vm.onformChange}}),_vm._v(" "),_c('custom-table',{staticStyle:{"margin-top":"60px","margin-bottom":"60px"},attrs:{"isEditable":true,"initialData":{items: _vm.tableData, fields: _vm.tableCols}},on:{"applyDataChanges":_vm.applyDataChanges,"insertItem":_vm.insertItem,"deleteItemById":_vm.deleteItemById}}),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end"},[_c('div',{staticClass:"p-2"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('saveForm')))]),_vm._v(" "),_c('b-btn',{staticClass:"btn-success",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.createForm()}}},[_vm._v(_vm._s(_vm.$t('create')))])],1)])],1)],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JT6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("2Bcf");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_91571d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__ = __webpack_require__("0YXF");
function injectStyle (ssrContext) {
  __webpack_require__("+3a/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-91571d3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_91571d3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CirclesToRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Jh3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","font-size":"20px"}},[_vm._v("\n            ŞUBE OLUŞTURMA\n        ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Şube Adı")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.name },nativeOn:{"focus":function($event){_vm.errors.name = false}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Veri Tipleri")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('multiselect',{class:{'is-invalid': _vm.errors.dataTypes},attrs:{"multiple":true,"options":_vm.allDataTypesOptions,"close-on-select":true,"showLabels":false,"placeholder":_vm.$t('choose'),"label":"name","track-by":"id"},nativeOn:{"focus":function($event){_vm.errors.dataTypes = false}},model:{value:(_vm.dataTypes),callback:function ($$v) {_vm.dataTypes=$$v},expression:"dataTypes"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Şehir")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.cityCode },nativeOn:{"focus":function($event){_vm.errors.cityCode = false}},model:{value:(_vm.cityCode),callback:function ($$v) {_vm.cityCode=$$v},expression:"cityCode"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.$store.state.cities),function(city){return _c('option',{domProps:{"value":city.code}},[_vm._v(_vm._s(city.name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Bölge")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-select',{class:{'is-invalid': _vm.errors.region },nativeOn:{"focus":function($event){_vm.errors.region = false}},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.siteGroups),function(group){return _c('option',{domProps:{"value":group.id}},[_vm._v(_vm._s(group.display_name))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Kod")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.code },nativeOn:{"focus":function($event){_vm.errors.code = false}},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Alan")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.area },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.area = false}},model:{value:(_vm.area),callback:function ($$v) {_vm.area=$$v},expression:"area"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('number of people')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.staffCount },attrs:{"type":"number"},nativeOn:{"focus":function($event){_vm.errors.staffCount = false}},model:{value:(_vm.staffCount),callback:function ($$v) {_vm.staffCount=$$v},expression:"staffCount"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v("Koordinat")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6","md":"3","lg":"1"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.lat },attrs:{"placeholder":"lat","type":"number"},nativeOn:{"focus":function($event){_vm.errors.lat = false}},model:{value:(_vm.lat),callback:function ($$v) {_vm.lat=$$v},expression:"lat"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","md":"3","lg":"1"}},[_c('b-form-input',{class:{'is-invalid': _vm.errors.lng },attrs:{"placeholder":"lng","type":"number"},nativeOn:{"focus":function($event){_vm.errors.lng = false}},model:{value:(_vm.lng),callback:function ($$v) {_vm.lng=$$v},expression:"lng"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"12","md":"8","lg":"8"}},[_c('button',{staticClass:"btn btn-lg btn-primary btn-block",on:{"click":function($event){return _vm.update()}}},[_vm._v(_vm._s(_vm.$t("create")))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K7HU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KB7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KC6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',[_c('b-card',{staticStyle:{"border":"none"}},[_c('b-container',[_c('b-row',{staticClass:"mt-4",attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('h5',{staticStyle:{"display":"inline"}},[_vm._v(_vm._s(_vm.$t('groupName')))]),_vm._v(" "),(_vm.groupType != null)?[_c('b-form-input',{attrs:{"disabled":true,"id":"username","placeholder":_vm.$t(this.getGroupName(_vm.groupName))},on:{"change":function($event){_vm.isChanged = true}}})]:[_c('b-form-input',{attrs:{"disabled":_vm.groupType === 'admin',"id":"username","placeholder":_vm.$t('groupName')},on:{"change":function($event){_vm.isChanged = true}},model:{value:(_vm.groupName),callback:function ($$v) {_vm.groupName=$$v},expression:"groupName"}})]],2),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[(_vm.groupType === 'admin')?_c('span',{staticStyle:{"top":"50%","position":"absolute"}},[_c('b',[_vm._v("("+_vm._s(_vm.$t('thisGroupCanNotBeEdit'))+")")])]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"4"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),(_vm.isEditPage && _vm.groupType !== 'admin')?_c('b-button',{staticClass:"ml-3",attrs:{"variant":"danger"},on:{"click":function($event){return _vm.deleteGroup()}}},[_vm._v(_vm._s(_vm.$t('delete')))]):_vm._e()],1)],1),_vm._v(" "),_c('h2',{staticClass:"mt-4",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('permissions')))]),_vm._v(" "),_c('b-row',[_c('br'),_vm._v(" "),_c('b-col',_vm._l((Object.keys(_vm.permissions)),function(group){return _c('b-card',{key:group,staticStyle:{"border":"none"},attrs:{"border-variant":"secondary"}},[_c('div',[_c('div',{staticStyle:{"text-align":"left"}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.groupType === 'admin' || _vm.allPermissions[group].disabled,"name":"checkbox-1","value":true,"unchecked-value":false},on:{"change":function($event){_vm.permissionGroupSelected($event, group);
                                    _vm.isChanged = true;}},model:{value:(_vm.allPermissions[group].value),callback:function ($$v) {_vm.$set(_vm.allPermissions[group], "value", $$v)},expression:"allPermissions[group].value"}},[_c('b',[_vm._v(_vm._s(_vm.$t(("" + group))))])])],1),_vm._v(" "),_c('b-row',{staticClass:"ml-4 mt-2 mb-3"},_vm._l((Object.keys(_vm.permissions[group])),function(permission){return _c('b-col',{key:permission,staticClass:"text-left",attrs:{"cols":"4"}},[_c('b-form-checkbox',{attrs:{"disabled":_vm.groupType === 'admin' || _vm.permissions[group][permission].disabled,"name":"checkbox-1","value":true,"unchecked-value":false},on:{"input":function($event){return _vm.permissionSelected($event, group)},"change":function($event){_vm.isChanged = true}},model:{value:(_vm.permissions[group][permission].value),callback:function ($$v) {_vm.$set(_vm.permissions[group][permission], "value", $$v)},expression:"permissions[group][permission].value"}},[_vm._v("\n                                        "+_vm._s(_vm.$t(("" + permission)))+"\n                                    ")])],1)}),1)],1)])}),1)],1),_vm._v(" "),_c('h2',{staticClass:"mt-4",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('users')))]),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"width":"100%"}},[_c('b-card',{staticStyle:{"border":"none"},attrs:{"border-variant":"info"}},[_c('transfer',{attrs:{"options":_vm.allUsers,"selected":_vm.selectedUsers,"sourceTitle":_vm.$t('allUsers'),"targetTitle":_vm.$t('selectedUsers'),"searchPlaceholder":_vm.$t('searchUsers')},on:{"onChange":_vm.setSelectedUsers}})],1)],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KDUX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGkw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE5IDE5Ij4KICA8ZyBpZD0ia2V5aG9sZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMgLTMpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzk2MSIgZGF0YS1uYW1lPSJQYXRoIDk2MSIgZD0iTTE3LjMsMTYuMDM4YTIuODUxLDIuODUxLDAsMSwwLTEuOSwwdjMuMDExYS45NS45NSwwLDEsMCwxLjksMFYxNi4wMzhabS0xLjktMi42ODlhLjk1Ljk1LDAsMSwwLC45NS0uOTVBLjk1Ljk1LDAsMCwwLDE1LjQsMTMuMzQ5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuODQ5IC0yLjc0OSkiIGZpbGw9IiM3YzdjN2MiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTYyIiBkYXRhLW5hbWU9IlBhdGggOTYyIiBkPSJNMTIuNSwzQTkuNSw5LjUsMCwxLDAsMjIsMTIuNSw5LjUsOS41LDAsMCwwLDEyLjUsM1pNNC45LDEyLjVhNy42LDcuNiwwLDEsMCw3LjYtNy42LDcuNiw3LjYsMCwwLDAtNy42LDcuNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiM3YzdjN2MiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "KPhV":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"startDate":"Başlangıç","endDate":"Bitiş","health":"Veri Kontrolü","file":"Fatura","lastUpdatedAt":"Son Değişiklik","date":"Tarih Aralığı","cost":"Tutar","paymentMethod":"Ödeme Tipi","dataType":"Veri Tipi","value":"Tüketim Miktarı"},"en":{"startDate":"Start Date","endDate":"End Date","health":"Data Health","date":"Date Range","file":"Bill","lastUpdatedAt":"Last Update","cost":"Cost","paymentMethod":"Payment Method","dataType":"Data Type","value":"Amount"}}')
}


/***/ }),

/***/ "Kco9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DocMain',
    data: function data() {
        var tabs = {
            email: null,
            selectedLocale: null,
            formRoutes: ['forms', 'site-forms', 'form-detail', 'form-create'],
            tags: [{
                name: this.$t('Documents'),
                path: 'files',
                active: true
            }]
        };

        if (this.gbId(this.$store.state.user.customerId)) {
            tabs.tags.push({
                name: this.$t('Forms'),
                path: 'forms',
                active: false
            });
        }

        return tabs;
    },

    methods: {
        routeTo: function routeTo(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;
            this.$router.push({ name: tag.path, query: { year: this.year } });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },

        // Toggle active tags
        setTags: function setTags() {
            // 'doc' is for the current component. by default 'doc' routed forced to 'files'.
            // When a user click back button, page should not route to 'doc' because it does not belongs to any tag.
            // To solve the problem above, 'doc' route replaced with tag's route.
            if (this.route.name === 'doc') {
                this.tags[0].active = true;
                //this.tags[1].active = false;
                this.$router.replace({ name: this.tags[0].path, query: { year: this.year } });
            } else if (this.formRoutes.indexOf(this.route.name) !== -1) {
                // if route belongs the formRoute, form tag will be activated.
                this.tags[0].active = false;
                this.tags[1].active = true;
            } else {
                this.tags[0].active = true;
                this.tags[1].active = false;
            }
        }
    },
    created: function created() {
        this.setTags();
    },

    // After Main component is loaded, needs handling of route changes to specify active tag;
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        next();
        this.setTags();
    }
});

/***/ }),

/***/ "KlSZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kukl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteTypeSelect_vue__ = __webpack_require__("0Xcj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f6e974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteTypeSelect_vue__ = __webpack_require__("Bbb7");
function injectStyle (ssrContext) {
  __webpack_require__("7g5X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44f6e974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteTypeSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44f6e974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteTypeSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kv4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Admin',
    props: {
        showScrollbar: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            email: null,
            selectedLocale: null,
            activeTagIndex: 0,
            tags: [{
                name: this.$t('general'),
                path: 'admin-general',
                active: true
            }, {
                name: this.$t('sites'),
                path: 'admin-site',
                active: false
            }, {
                name: this.$t('sourceManagement'),
                path: 'sources',
                active: false
            }, {
                name: this.$t('permissions'),
                path: 'permissions',
                active: false
            }, {
                name: this.$t('users'),
                path: 'users',
                active: false
            }, {
                name: this.$t('globalGoals'),
                path: 'admin-goal',
                active: false
                /*
                {
                    name: this.$t('emissionFactors'),
                    path: 'admin-emission',
                    active: false
                }
                */
            }]
        };
    },


    methods: {
        routeTo: function routeTo(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;

            this.$router.push({ name: tag.path });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
    },
    created: function created() {
        var _this = this;

        /*
        if(this.gbId(this.$store.state.user.customerId)){
            this.tags = this.tags.concat([
                {
                    name: this.$t('batchDataEntry'),
                    path: 'load-data-via-excel',
                    active: false
                }
            ]);
        }
        else{
            this.tags = this.tags.concat([
                {
                    name: this.$t('unitPrices'),
                    path: 'admin-unit-price',
                    active: false
                },
                {
                    name: this.$t('batchDataEntry'),
                    path: 'load-data-via-excel',
                    active: false
                }
            ]);
        }
        */
        this.tags = this.tags.concat([{
            name: this.$t('batchDataEntry'),
            path: 'load-data-via-excel',
            active: false
        }]);

        this.activeTagIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.tags, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.tags, function (o) {
            return o.path == _this.route.name;
        }));
        this.activeTagIndex = this.activeTagIndex < 0 ? 0 : this.activeTagIndex;
        this.routeTo(this.tags[this.activeTagIndex]);
    }
});

/***/ }),

/***/ "Kvn9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicket_vue__ = __webpack_require__("7G78");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e30841_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicket_vue__ = __webpack_require__("Nfn5");
function injectStyle (ssrContext) {
  __webpack_require__("DPH8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10e30841"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateTicket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10e30841_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateTicket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("xB4Z")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L98+":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"HEDEFLER","dataTypeColumn":"Veri Tipi","startYearColumn":"Baz Yıl","endYearColumn":"Hedef Yıl","goalTypeColumn":"Hedef Tipi","goalRatioColumn":"Hedeflenen (%)","goalColumn":"Hedeflenen Tüketim","actualColumn":"Gerçekleşen Tüketim","descriptionColumn":"Açıklama","confirmationColumn":"Onay Durumu","currentSituation":"Mevcut Durumu Koruma","decrease":"Azaltma","raise":"Arttırma","noConfirm":"Beklemeye Al","actualColumnRatio":"Gerçekleşen (%)","perPerson":"/kişi","perM2Person":"/m2.kişi","Şube alanında artış":"Şube alanında artış","Şube alanında azalış":"Şube alanında azalış","Çalışan sayısında artış":"Çalışan sayısında artış","Çalışan sayısında azalış":"Çalışan sayısında azalış","Enerji tüketen ekipmanlarda artış (Ör: ATM, klima)":"Enerji tüketen ekipmanlarda artış (Örn: ATM, klima)","Enerji tüketen ekipmanlarda azalış (Ör: ATM, klima)":"Enerji tüketen ekipmanlarda azalış (Örn: ATM, klima)","Hava sıcaklığında bir önceki yıla kıyasla artış":"Hava sıcaklığında bir önceki yıla kıyasla artış","Hava sıcaklığında bir önceki yıla kıyasla azalış":"Hava sıcaklığında bir önceki yıla kıyasla azalış","Şube personel farkındalığının düşük olması":"Şube personel farkındalığının düşük olması","Şube iş hacminin artması":"Şube iş hacminin artması","Şube iş hacminin azalması":"Şube iş hacminin azalması"},"en":{"title":"GOALS","dataTypeColumn":"Data Type","startYearColumn":"Base Year","endYearColumn":"Target Year","goalTypeColumn":"Target Type","goalRatioColumn":"Targeted (%)","goalColumn":"Targeted","actualColumn":"Actual","descriptionColumn":"Description","confirmationColumn":"Confirmation Status","currentSituation":"No Change","decrease":"Decrease","raise":"Increase","noConfirm":"No Confirm","actualColumnRatio":"Actual %","perPerson":"/person","perM2Person":"/m2.kişi","Şube alanında artış":"Increasing in the location area","Şube alanında azalış":"Decreasing in the location area","Çalışan sayısında artış":"Increasing in the number of employees","Çalışan sayısında azalış":"Decreasing in the number of employees","Enerji tüketen ekipmanlarda artış (Ör: ATM, klima)":"Increasing in energy consuming equipment (Ex: ATM, air conditioner)","Enerji tüketen ekipmanlarda azalış (Ör: ATM, klima)":"Decreasing in energy consuming equipment (Ex: ATM, air conditioner)","Hava sıcaklığında bir önceki yıla kıyasla artış":"Increasing in air temperature compared to the previous year","Hava sıcaklığında bir önceki yıla kıyasla azalış":"Decreasing in air temperature compared to the previous year","Şube personel farkındalığının düşük olması":"Low awareness of location employees","Şube iş hacminin artması":"Increasing location business volume","Şube iş hacminin azalması":"Decreasing location business volume"}}')
}


/***/ }),

/***/ "LnqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'warn',
    methods: {
        triggerEvent: function triggerEvent() {
            this.$eventHub.$emit(this.$store.state.modal.eventId, 1);
            this.$refs.warnModal.hide();
        }
    }
});

/***/ }),

/***/ "Lu1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.onCloud)?_c('file-upload',{ref:_vm.component_id,staticClass:"btn",staticStyle:{"margin-bottom":"0"},attrs:{"input-id":_vm.component_id + 'popover_upload'},on:{"input-file":_vm.inputFile},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('i',{staticClass:"fas fa-upload fa-lg"})]):_c('file-upload',{ref:_vm.component_id,staticClass:"btn",staticStyle:{"margin-bottom":"0"},attrs:{"chunk-enabled":"","accept":_vm.acceptQuery,"chunk":{
            headers: {Authorization: _vm.token},
            action: _vm.action,
            minSize: 0,
            maxActive: 3,
            maxRetries: 5,
            startBody: {
                filename: _vm.files.length ? _vm.files[0].name : null
            }
         }},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('i',{staticClass:"fas fa-upload fa-lg"})]),_vm._v(" "),_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.files.length ? _vm.files[0].active : false),expression:"files.length ? files[0].active : false"}],attrs:{"value":_vm.files.length ? Number(_vm.files[0].progress) : 100,"variant":"secondary","height":"0.3em"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M5Z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope3_vue__ = __webpack_require__("txH+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761bca7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope3_vue__ = __webpack_require__("tDRm");
function injectStyle (ssrContext) {
  __webpack_require__("ziQl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-761bca7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761bca7f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("G8wk")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c755c2a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("3VUd");
function injectStyle (ssrContext) {
  __webpack_require__("jFsX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c755c2a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MF1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AuditMain',
    data: function data() {
        var tabs = {
            email: null,
            selectedLocale: null,
            formRoutes: ['Detail'],
            activeIndex: 0,
            tags: [{
                name: this.$t(this.getImproprietyName()),
                path: 'audit'
            }]
        };
        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.$store.state.user.assignedSites, 'length') > 0) {
            tabs.tags = [{
                name: this.$t('Audit'),
                path: 'Detail'
            }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(tabs.tags));
        }
        return tabs;
    },

    methods: {
        routeTo: function routeTo(tag, index) {
            this.activeIndex = index;
            if (this.activeIndex == 1 || this.$store.state.siteId) {
                this.$router.push({
                    name: tag.path,
                    query: { year: this.year // this.activeIndex === 0 ? {} : 
                    } });
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
            } else {
                this.$router.push({
                    name: this.$t('Summary'),
                    query: { year: this.year }
                });
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
            }
        },

        // Toggle active tags
        setTags: function setTags() {
            // 'doc' is for the current component. by default 'doc' routed forced to 'files'.
            // When a user click back button, page should not route to 'doc' because it does not belongs to any tag.
            // To solve the problem above, 'doc' route replaced with tag's route.
            if (this.route.name === 'auditMain') {
                this.tags[0].active = true;
                //this.tags[1].active = false;
                this.$router.replace({ name: this.tags[0].path, query: { year: this.year } });
            } else if (this.formRoutes.indexOf(this.route.name) !== -1) {
                // if route belongs the formRoute, form tag will be activated.
                this.tags[0].active = false;
                //this.tags[1].active = true;
            } else {
                this.tags[0].active = true;
                //this.tags[1].active = false;
            }
        },
        getImproprietyName: function getImproprietyName() {
            return this.gbId(this.$store.state.user.customerId) ? 'garantiImpropriety' : 'Impropriety';
        },
        setActiveIndex: function setActiveIndex() {
            this.activeIndex = this.route.name === 'audit' || this.route.name === 'ticket-list' ? 1 : 0;
        }
    },
    created: function created() {
        this.setTags();
        this.setActiveIndex();
    },

    // After Main component is loaded, needs handling of route changes to specify active tag;
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        next();
        this.setTags();
    }
});

/***/ }),

/***/ "MJgP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MQqr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MXkr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MbT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive",attrs:{"id":_vm.tableId}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_vm._l((_vm.fields),function(field){return _c('th',{staticStyle:{"width":"10em"}},[_vm._v("\n                    "+_vm._s(_vm.$t(field.header))+"\n                ")])}),_vm._v(" "),(_vm.isEditable)?_c('th',{staticStyle:{"width":"9em"},attrs:{"id":"lastColumn"}}):_vm._e()],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index,class:_vm.cursorType,on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(item, _vm.fields)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.revertChanges(item)}],"click":function($event){return _vm.routeTo(item)}}},[_vm._l((_vm.fields),function(field,index){return _c('td',{key:index+'field'},[_c('div',{staticClass:"tableBodyCell"},[(field.type === 'number' || field.type === 'float')?[(field.editable && item.editMode && _vm.isEditable)?[_c('masked-input',{class:Object.assign(item[field.key].classes, {'masked-input-custom': true}),attrs:{"keepCharPositions":false,"type":"text","mask":field.type === 'number' ? _vm.maskOfNumber : _vm.maskOfCurrency,"placeholder":_vm.$t(field.key)},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(!_vm.isNil(item[field.key].value))?[_vm._v("\n                                "+_vm._s(item[field.key].value)+"\n                            ")]:[_vm._v("\n                                "+_vm._s(item[field.key].defaultValue)+"\n                            ")]]:(field.type === 'dropdown')?[(field.editable && item.editMode && _vm.isEditable)?[_c('b-form-select',{class:Object.assign(item[field.key].classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},nativeOn:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((field.data),function(element){return _c('option',{domProps:{"value":element}},[_vm._v(_vm._s((element.name) ? element.name : element))])})],2)]:[_vm._v("\n                                "+_vm._s((item[field.key].value && item[field.key].value.name) ? item[field.key].value.name : item[field.key].value)+"\n                            ")]]:(field.type === 'date')?[(field.editable && item.editMode && _vm.isEditable)?[_c('el-date-picker',{class:item[field.key].classes,staticStyle:{"width":"100%"},attrs:{"type":"date","format":"dd/MM/yyyy","readonly":!field.editable,"placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(!_vm.isNil(item[field.key].value))?[_vm._v("\n                                "+_vm._s(_vm._f("formatDate")(item[field.key].value,'DD/MM/YYYY'))+"\n                            ")]:[_vm._v("\n                                "+_vm._s(item[field.key].defaultValue)+"\n                            ")]]:(field.type === 'daterange')?[(field.editable && item.editMode && _vm.isEditable)?[_c('el-date-picker',{class:item[field.key].classes,staticStyle:{"width":"100%"},attrs:{"type":"daterange","readonly":!field.editable,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(!_vm.isNil(item[field.key].value))?[_vm._v("\n                                "+_vm._s(_vm._f("formatDate")(item[field.key].value[0],'DD/MM/YYYY'))+" - "+_vm._s(_vm._f("formatDate")(item[field.key].value[1],'DD/MM/YYYY'))+"\n                            ")]:[_vm._v("\n                                "+_vm._s(item[field.key].defaultValue)+"\n                            ")]]:(field.type === 'link')?[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.$t(item[field.key].value)))])]:(field.type === 'file')?[(field.editable && item.editMode && _vm.isEditable)?[(item[field.key] && item[field.key].editedFileId)?_c('div',{on:{"click":function($event){return _vm.triggerPopover(item)}}},[_c('upload',{attrs:{"reactiveId":("a_" + _vm.reactiveId + "_" + (item.id))},on:{"ondownload":function($event){return _vm.downloadFile(item[field.key].editedFileUrl||item[field.key].fileUrl)},"onremove":function($event){return _vm.handleRemoving($event, item[field.key])},"onupload":function($event){return _vm.handleUploading($event, item[field.key] = {})}}}),_vm._v(" "),_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadFiles.length ? _vm.uploadFiles[0].active : false),expression:"uploadFiles.length ? uploadFiles[0].active : false"}],attrs:{"value":_vm.uploadFiles.length ? Number(_vm.uploadFiles[0].progress) : 100,"variant":"secondary","height":"0.3em"}})],1):_c('upload-regular',{on:{"onupload":function($event){return _vm.handleUploading($event, item[field.key] = {})}}})]:[(item[field.key] && (item[field.key].editedFileId))?_c('div',{staticClass:"file",on:{"click":function($event){return _vm.downloadFile(item[field.key].fileUrl)}}},[_vm._m(0,true)]):_c('div',{staticClass:"file"},[_c('span',[_vm._v("-")])])]]:(field.type === 'icon')?[(item[field.key].value === 'health-ok')?_c('span',[_c('i',{staticClass:"fas fa-check",staticStyle:{"color":"#1c7430"}})]):_c('span',[_c('i',{staticClass:"fas fa-times",staticStyle:{"color":"red"}})])]:[(field.editable && item.editMode && _vm.isEditable)?[_c('b-form-input',{class:Object.assign(item[field.key].classes, {'masked-input-custom': true}),attrs:{"placeholder":field.header},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:[_vm._v("\n                                "+_vm._s(item[field.key].value)+"\n                            ")]]],2)])}),_vm._v(" "),(_vm.isEditable)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth, 'margin-right': '4px'})},[_c('div',{staticClass:"tableBodyCell"},[(!item.editMode)?_c('div',{key:'editspan',staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(item)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group table-cell"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(item, _vm.fields)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.revertChanges(item)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete'),"variant":"danger"},on:{"click":function($event){return _vm.deleteItem($event, item.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])]):_vm._e()],2)}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem(_vm.tempItem)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_vm._l((_vm.fields),function(field){return _c('td',[(field.editable)?_c('div',[(field.type === 'number' || field.type === 'float')?[_c('masked-input',{class:Object.assign(_vm.tempItem[field.key].classes, {'masked-input-custom': true}),attrs:{"keepCharPositions":false,"mask":field.type === 'number' ? _vm.maskOfNumber : _vm.maskOfCurrency,"placeholder":field.header,"type":"text"},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'dropdown')?[_c('b-form-select',{class:Object.assign(_vm.tempItem[field.key].classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((field.data),function(element){return _c('option',{domProps:{"value":element}},[_vm._v(_vm._s((element.name) ? element.name : element))])})],2)]:(field.type === 'date')?[_c('el-date-picker',{class:_vm.tempItem[field.key].classes,staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"date","format":"dd/MM/yyyy"},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'daterange')?[_c('el-date-picker',{class:_vm.tempItem[field.key].classes,staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"format":"dd/MM/yyyy","type":"daterange"},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'file')?[(_vm.tempItem[field.key] && _vm.tempItem[field.key].fileId)?_c('div',[_c('upload',{attrs:{"reactiveId":("a_" + _vm.reactiveId)},on:{"ondownload":function($event){return _vm.downloadFile(_vm.tempItem[field.key].fileUrl)},"onremove":function($event){return _vm.handleTempRemoving($event, _vm.tempItem[field.key])},"onupload":function($event){return _vm.handleTempUploading($event, _vm.tempItem[field.key])}}}),_vm._v(" "),_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadFiles.length ? _vm.uploadFiles[0].active : false),expression:"uploadFiles.length ? uploadFiles[0].active : false"}],attrs:{"value":_vm.uploadFiles.length ? Number(_vm.uploadFiles[0].progress) : 100,"variant":"secondary","height":"0.3em"}})],1):_c('upload-regular',{on:{"onupload":function($event){return _vm.handleTempUploading($event, _vm.tempItem[field.key])}}})]:[_c('b-form-input',{class:Object.assign(_vm.tempItem[field.key].classes, {'masked-input-custom': true}),attrs:{"placeholder":field.header},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]],2):_vm._e()])}),_vm._v(" "),(_vm.isEditable)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth, 'margin-right': '4px'})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.createItem(_vm.tempItem)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)]):_vm._e()],2):_vm._e()]),_vm._v(" "),(!_vm.insertMode && _vm.isEditable)?_c('tr',{staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{attrs:{"colspan":this.fields.length + 1}},[_vm._m(1)])]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-alt fa-lg"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableBodyCell"},[_c('div',[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Men5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"auditFiles",attrs:{"id":"auditFiles","size":"sm","ok-only":"","title":_vm.$t('Documents')},on:{"show":_vm.onShow}},[(_vm.files.length)?_vm._l((_vm.files),function(file){return _c('b-row',{key:file.document_id,attrs:{"align-h":"start","no-gutters":""}},[_c('span',{staticClass:"fileUpload",on:{"click":function($event){return _vm.downloadFile(file.fileUrl)}}},[_vm._v(_vm._s(file.filename))]),_vm._v(" "),_c('hr')])}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MfOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'createPost',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_5__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_4__components_Upload__["a" /* default */] },
    data: function data() {
        return {
            eventId: null,
            compId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            text: null,
            reactiveId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            siteId: null,
            type: null,
            ticket: null,
            ticketId: null,
            postId: null,
            postDocuments: [],
            replyType: null,
            ticketType: null,
            extendedDate: new Date(),
            extendedDateCheck: null,
            errors: {
                text: false,
                extendedDate: false
            },
            extendedDateOptions: {}
        };
    },

    methods: {
        onupload: function onupload(event) {
            this.postDocuments.push({
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            });
        },
        handleRemoving: function handleRemoving(event, file) {
            this.postDocuments = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.remove(this.postDocuments, function (nFile) {
                return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(file, 'uuid') != __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(nFile, 'uuid') || __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(file, 'fileId') != __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(nFile, 'fileId');
            });
        },
        onHide: function onHide(event) {
            if (__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.get(event, 'trigger') != null) {
                this.closeModal(true);
            }
        },
        closeModal: function closeModal() {
            var _this = this;

            var deleteFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (deleteFiles) {
                var fileIds = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(this.postDocuments, function (docs) {
                    return __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(docs), 'id');
                }), 'id');
                this.axios.post('/deleteFilesFromAWS', { files: fileIds }).then(function () {
                    _this.$refs.createPost.hide();
                });
            } else {
                this.$refs.createPost.hide();
            }
        },
        insert: function insert() {
            var _this2 = this;

            if (this.isValidInsertion()) {
                var post = {
                    answerText: this.text,
                    documentIds: this.postDocuments.map(function (document) {
                        return document.uuid;
                    })
                };
                if (this.replyType === 'negative') {
                    post.extendedDate = this.createUTCDate(this.extendedDate.getFullYear(), this.extendedDate.getMonth(), this.extendedDate.getDate());
                } else {
                    var extendedDates = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.ticket.posts, 'extendedDate');
                    post.extendedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1];
                }
                return this.axios.post('/' + this.siteId + '/audits/' + this.ticketId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, post, {
                    ticketType: this.ticket.ticketType,
                    title: this.ticketType == 'Action' ? this.ticket.textInput : this.ticket.scope,
                    isExtendedDateChanged: this.extendedDate === this.extendedDateCheck ? false : true
                })).then(function (_ref) {
                    var data = _ref.data;

                    _this2.postId = data.id;
                    _this2.$eventHub.$emit(_this2.$store.state.modal.eventId, data);
                    _this2.closeModal(false);
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        isValidInsertion: function isValidInsertion() {
            this.errors.text = !(this.text && this.text.length);
            if (this.replyType === 'negative') {
                this.errors.extendedDate = !this.extendedDate;
            }
            var validation = true;
            for (var key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        update: function update() {
            var _this3 = this;

            var post = {
                answerText: this.text,
                documents: this.postDocuments
            };
            if (this.replyType === 'negative') {
                post.extendedDate = this.createUTCDate(this.extendedDate.getFullYear(), this.extendedDate.getMonth(), this.extendedDate.getDate());
            } else {
                var extendedDates = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.ticket.posts, 'extendedDate');
                post.extendedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1];
            }
            this.postId = this.$store.state.modal.payload.post.id;
            return this.axios.put('/' + this.siteId + '/audits/' + this.ticketId + '/post/' + this.postId, post).then(function (_ref2) {
                var data = _ref2.data;

                _this3.$eventHub.$emit(_this3.$store.state.modal.eventId, data);
                _this3.closeModal(false);
            });
        },
        onShow: function onShow() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.siteId = this.$store.state.modal.payload.siteId;
            this.ticketId = this.$store.state.modal.payload.ticketId;
            this.ticket = this.$store.state.modal.payload.ticket;
            this.type = this.$store.state.modal.type;
            this.replyType = this.$store.state.modal.payload.replyType;
            this.ticketType = this.$store.state.modal.payload.ticket.ticketType;
            var extendedDates = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.map(this.ticket.posts, 'extendedDate');
            this.extendedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1] ? extendedDates[__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1] : this.ticket.expectedDate;
            this.extendedDateCheck = this.extendedDate;
            if (this.type === 'updatePost') {
                var post = this.$store.state.modal.payload.post;
                this.text = post.answerText;
                this.extendedDate = post.extendedDate ? post.extendedDate.split('T')[0] : null;
                this.postDocuments = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.cloneDeep(post.documents);
                this.postId = post.id;
            }
            this.extendedDateOptions = {
                disabledDate: function disabledDate(time) {
                    return time.getTime() < new Date(_this4.ticket.expectedDate);
                }
            };
        }
    },
    computed: {
        postTitle: function postTitle() {
            if (this.replyType === 'negative') {
                return this.type === 'updatePost' ? this.$t('updateNegativeControl') : this.$t('createNegativeControl');
            } else {
                return this.type === 'updatePost' ? this.$t('updateResponse') : this.$t('createResponse');
            }
        }
    }
});

/***/ }),

/***/ "MkyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__ = __webpack_require__("NyJr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'site-selector',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_2__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_1__components_YearSelect__["a" /* default */] },
    data: function data() {
        return {
            searchInput: '',
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            isLoaded: false
        };
    },

    methods: {
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeTo: function routeTo(site) {
            /* this.$router.push({
                name: 'site-data-types',
                params: {site_id: site.id},
                query: {
                    year: this.year
                }
            }); */
            var routeData = this.$router.resolve({
                name: 'site-data-types',
                params: { site_id: site.id },
                query: {
                    year: this.year
                }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'site-data-types',
                    params: { site_id: site.id },
                    query: {
                        year: this.year
                    }
                });
            }
        },
        retrieveSites: function retrieveSites() {
            var _this = this;

            this.$Progress.start();
            this.isLoaded = false;
            return this.axios.get('/sites').then(function (_ref) {
                var data = _ref.data;

                _this.$store.commit('SET_SITES', data.sites);
                _this.$Progress.finish();
                _this.isLoaded = true;
            });
        }
    },

    computed: {
        filteredItems: function filteredItems() {
            var _this2 = this;

            return this.sites.filter(function (item) {
                return _this2.isSearchTextFound(item.name, _this2.searchInput) && _this2.isRegionFound(_this2.selectedRegionId, item.siteGroupId) && (!_this2.selectedTypeId || item.typeId === _this2.selectedTypeId);
            });
        }
    },

    created: function created() {
        this.retrieveSites();
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
    }
});

/***/ }),

/***/ "N6Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FlowerSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      smallerDotAnimationBaseName: 'flower-spinner-smaller-dot-animation',
      biggerDotAnimationBaseName: 'flower-spinner-bigger-dot-animation',
      currentSmallerDotAnimationBaseName: '',
      currentBiggerDotAnimationBaseName: ''
    };
  },


  computed: {
    dotSize: function dotSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    dotsContainerStyle: function dotsContainerStyle() {
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px'
      };
    },
    smallerDotStyle: function smallerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentSmallerDotAnimationBaseName
      };
    },
    biggerDotStyle: function biggerDotStyle() {
      return {
        background: this.color,
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentBiggerDotAnimationBaseName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentSmallerDotAnimationBaseName, this.generateSmallerDotKeyframes());
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentBiggerDotAnimationBaseName, this.generateBiggerDotKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentSmallerDotAnimationBaseName = this.smallerDotAnimationBaseName + '-' + Date.now();
      this.currentBiggerDotAnimationBaseName = this.biggerDotAnimationBaseName + '-' + Date.now();
    },
    generateSmallerDotKeyframes: function generateSmallerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 1.4 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 1.4 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              ' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px -' + this.dotSize + 'px 0 ' + this.color + ',\n                              -' + this.dotSize + 'px ' + this.dotSize + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    },
    generateBiggerDotKeyframes: function generateBiggerDotKeyframes() {
      return '0%, 100% {\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }\n                50% {\n                  transform: rotate(180deg);\n                }\n                25%, 75% {\n                  box-shadow: ' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              -' + this.dotSize * 2.6 + 'px 0 0 ' + this.color + ',\n                              0 ' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              0 -' + this.dotSize * 2.6 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              ' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px -' + this.dotSize * 1.9 + 'px 0 ' + this.color + ',\n                              -' + this.dotSize * 1.9 + 'px ' + this.dotSize * 1.9 + 'px 0 ' + this.color + ';\n\n                }\n                100% {\n                  transform: rotate(360deg);\n                  box-shadow: 0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ',\n                              0 0 0 ' + this.color + ';\n                }';
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__("oq7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__ = __webpack_require__("+TD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_message_css__ = __webpack_require__("cwe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_message__ = __webpack_require__("2X9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_popover_css__ = __webpack_require__("8z31");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_popover_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_popover_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_popover__ = __webpack_require__("SXzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_steps_css__ = __webpack_require__("Z1wW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_steps__ = __webpack_require__("raHz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_step_css__ = __webpack_require__("EYpU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_step_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_step_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_step__ = __webpack_require__("9Y4M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_checkbox_group_css__ = __webpack_require__("TFIm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_checkbox_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_checkbox_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox_group__ = __webpack_require__("s3ue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_pagination_css__ = __webpack_require__("ylrw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_pagination__ = __webpack_require__("6oiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css__ = __webpack_require__("dmRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox__ = __webpack_require__("EKTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_transfer_css__ = __webpack_require__("9g35");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_transfer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_transfer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_transfer__ = __webpack_require__("eDZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_transfer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_transfer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__mixin__ = __webpack_require__("90m7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__EventBus__ = __webpack_require__("4DD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuex_router_sync__ = __webpack_require__("9JMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_vue_text_mask__ = __webpack_require__("yekR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale_lang_tr_TR__ = __webpack_require__("uc8M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale_lang_tr_TR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale_lang_tr_TR__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_vue_upload_component__ = __webpack_require__("1Wvq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_vue_upload_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_vue_upload_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_vue_progressbar__ = __webpack_require__("zYko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_vue_notification__ = __webpack_require__("CLX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__("tLvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__assets_scss_main_scss__ = __webpack_require__("MXkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__assets_scss_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__assets_scss_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Table__ = __webpack_require__("ABj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Spinner__ = __webpack_require__("+jyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale__);













































// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





























// Custom styling






__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_58_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_42_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_44_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_38__api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_50_vue_notification___default.a);

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43_vue_toasted___default.a, {
    position: 'top-center',
    duration: 3000,
    theme: 'outline'
});



// language locale item configuration should be generic for all languages.

if (!localStorage.getItem('locale')) {
    /* let userLang = navigator.language || navigator.userLanguage;
    let userLocale = userLang === 'tr-TR' ? 'tr' : 'en';
    let userLocale = 'tr'; */
    var userLang = navigator.language || navigator.userLanguage;
    var userLocale = userLang === 'tr-TR' ? 'tr' : 'en';
    console.log('userLang', userLang);
    console.log('userLocale', userLocale);
    //let userLocale = 'en';
    localStorage.setItem('locale', userLocale);
}
__WEBPACK_IMPORTED_MODULE_34__store__["a" /* default */].state.locale = localStorage.getItem('locale');

if (__WEBPACK_IMPORTED_MODULE_34__store__["a" /* default */].state.locale === 'tr') {
    __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale_lang_tr_TR___default.a);
} else {
    __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_47_element_ui_lib_locale_lang_en___default.a);
}
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_date_picker___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_select___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_option___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_transfer___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_checkbox___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_pagination___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_button___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_checkbox_group___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_input___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_loading___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_step___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_steps___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_popover___default.a, { locale: __WEBPACK_IMPORTED_MODULE_59_element_ui_lib_locale___default.a });

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_message___default.a;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message_box___default.a.confirm;
for (var key in __WEBPACK_IMPORTED_MODULE_35__filters__["a" /* default */]) {
    __WEBPACK_IMPORTED_MODULE_39_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_35__filters__["a" /* default */][key]);
}

var i18n = new __WEBPACK_IMPORTED_MODULE_42_vue_i18n__["a" /* default */]({
    locale: __WEBPACK_IMPORTED_MODULE_34__store__["a" /* default */].state.locale,
    messages: {
        tr: {}
    }
});

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_49_vue_progressbar___default.a, {
    color: '#007bff',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '0.3s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top'
});

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].component('masked-input', __WEBPACK_IMPORTED_MODULE_45_vue_text_mask___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].component('file-upload', __WEBPACK_IMPORTED_MODULE_48_vue_upload_component___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].component('vue-table', __WEBPACK_IMPORTED_MODULE_56__components_Table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].component('spinner', __WEBPACK_IMPORTED_MODULE_57__components_Spinner__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].config.productionTip = false;

Object(__WEBPACK_IMPORTED_MODULE_40_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_34__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_33__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_36__mixin__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$eventHub = __WEBPACK_IMPORTED_MODULE_37__EventBus__["a" /* EventBus */];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_39_vue__["default"]({
    i18n: i18n,
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_34__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_33__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_32__App__["a" /* default */] }
});

/***/ }),

/***/ "NPbT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("3Alh");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_43f67b6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__ = __webpack_require__("/bm9");
function injectStyle (ssrContext) {
  __webpack_require__("CJp2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43f67b6f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_43f67b6f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScalingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "NTv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Master_vue__ = __webpack_require__("PMx7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1728d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Master_vue__ = __webpack_require__("8IK7");
function injectStyle (ssrContext) {
  __webpack_require__("OhQc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c1728d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Master_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c1728d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Master_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("DDy4")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NUM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NYoC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalCarbonConsumptions_vue__ = __webpack_require__("kM+x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a610043e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalCarbonConsumptions_vue__ = __webpack_require__("lybT");
function injectStyle (ssrContext) {
  __webpack_require__("wEdX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a610043e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalCarbonConsumptions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a610043e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalCarbonConsumptions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nfn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"createTicket",attrs:{"id":"createTicket","size":"lg","top":"","title":_vm.type === 'updateTicket' ? _vm.$t('updateNonconformityTicketTitle'): _vm.$t('createNonconformityTicketTitle')},on:{"hide":_vm.onHide,"show":_vm.onShow}},[_c('b-row',{staticClass:"mt-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('nonconformity')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-input',{class:{'is-invalid': _vm.errors.scope },nativeOn:{"focus":function($event){_vm.errors.scope = false}},model:{value:(_vm.scope),callback:function ($$v) {_vm.scope=$$v},expression:"scope"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('nonconformanceType')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-select',{class:{'is-invalid': _vm.errors.nonconformanceId },on:{"change":_vm.selectNonconformance},nativeOn:{"focus":function($event){_vm.errors.nonconformanceId = false}},model:{value:(_vm.nonconformanceId),callback:function ($$v) {_vm.nonconformanceId=$$v},expression:"nonconformanceId"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.nonconformancesOptions()),function(item){return _c('option',{domProps:{"value":item.id}},[_vm._v("\n                        "+_vm._s(_vm.$t(item.article))+"\n                    ")])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('urgentActionText')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":2,"max-rows":6},model:{value:(_vm.urgentActionText),callback:function ($$v) {_vm.urgentActionText=$$v},expression:"urgentActionText"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('reasonAnalysisText')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":3,"max-rows":6},model:{value:(_vm.reasonAnalysisText),callback:function ($$v) {_vm.reasonAnalysisText=$$v},expression:"reasonAnalysisText"}})],1)],1),_vm._v(" "),(_vm.nonconformanceId)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('action')))])])],1):_vm._e(),_vm._v(" "),(_vm.nonconformanceId)?_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"rows":"4","readonly":_vm.nonconformanceId !== 13},model:{value:(_vm.customNonconformance),callback:function ($$v) {_vm.customNonconformance=$$v},expression:"customNonconformance"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('revisedDocumentInfo')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":5,"max-rows":6},model:{value:(_vm.revisedDocText),callback:function ($$v) {_vm.revisedDocText=$$v},expression:"revisedDocText"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('auditDate')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_c('el-date-picker',{class:{'is-invalid': _vm.errors.auditDate },staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":false,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"change":function($event){return _vm.setpredictedDate($event)},"focus":function($event){_vm.errors.auditDate = false}},model:{value:(_vm.auditDate),callback:function ($$v) {_vm.auditDate=$$v},expression:"auditDate"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',{staticStyle:{"align-self":"center"}},[_vm._v(_vm._s(_vm.$t('predictedDate')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_c('el-date-picker',{class:{'is-invalid': _vm.errors.expectedDate },staticStyle:{"width":"100%","align-self":"center"},attrs:{"type":"date","readonly":false,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){_vm.errors.expectedDate = false}},model:{value:(_vm.expectedDate),callback:function ($$v) {_vm.expectedDate=$$v},expression:"expectedDate"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('note'))+":")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":5,"max-rows":6},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('additionalFiles'))+":")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{attrs:{"align-h":"start","no-gutters":""}},[(_vm.postDocuments.length)?[_vm._l((_vm.postDocuments),function(file,index){return [_c('b-col',{key:("upload-" + index),staticStyle:{"text-align":"center"},attrs:{"cols":"1"}},[_c('upload',{attrs:{"fileCategory":"audit-report","showUpload":false,"showDownload":false,"reactive-id":(_vm.reactiveId + "-" + (file.uuid) + "-" + index),"deleteFromDB":true,"dataId":file.id},on:{"onremove":function($event){return _vm.handleRemoving($event, file)}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm._f("textToShortText")(file.filename)))])],1)]})]:_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"1"}},[_c('upload-regular',{attrs:{"fileCategory":"audit-report"},on:{"onupload":_vm.onupload}})],1)],2)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.type === 'updateTicket')?_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.update()}}},[_vm._v(_vm._s(_vm.$t('update')))]):_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.insert()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"Danger"},on:{"click":function($event){return _vm.closeModal(true)}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"createAction",attrs:{"id":"createAction","size":"lg","top":"","title":_vm.type === 'updeteTicket' ? _vm.$t('updateActionTicketTitle'): _vm.$t('createActionTicketTitle')},on:{"show":_vm.onShow}},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('nonconformity')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{class:{'is-invalid': _vm.actionErrors.revisedDocText },attrs:{"placeholder":"","rows":1,"max-rows":6},model:{value:(_vm.revisedDocText),callback:function ($$v) {_vm.revisedDocText=$$v},expression:"revisedDocText"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('futureAction')))])])],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding-bottom":"20px"},on:{"blur":function (){this$1.isCustomSelectOpen=false;}}},[_c('b-col',[_c('div',{staticClass:"custom-select-choose",class:{'is-invalid': _vm.actionErrors.actionCheckList },on:{"click":function (){_vm.customSelectScroll();this$1.isCustomSelectOpen=!this$1.isCustomSelectOpen}}},[_vm._v(_vm._s(_vm.$t('choose'))),_c('div',{staticClass:"arrow-up"}),_c('div',{staticClass:"arrow-down"})]),_vm._v(" "),_c('div',{class:_vm.isCustomSelectOpen?'custom-select-options-show':'custom-select-options-hide',attrs:{"id":"custom-select-options"}},_vm._l((_vm.nonconformancesOptions()),function(item){return ((item.id!=13))?_c('div',{attrs:{"value":item.id}},[_c('b-row',{staticClass:"custom-select-row",on:{"click":function($event){return _vm.setActionCheckList(item.id)}}},[(_vm.gbId(_vm.$store.state.user.customerId))?_c('b-col',{staticClass:"custom-select-checkbox-col",attrs:{"sm":"1"}},[_c('input',{staticClass:"custom-select-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.actionCheckList[(item.id-_vm.getNewNonconformanceId)]}})]):_vm._e(),_vm._v(" "),(!_vm.gbId(_vm.$store.state.user.customerId))?_c('b-col',{staticClass:"custom-select-checkbox-col",attrs:{"sm":"1"}},[_c('input',{staticClass:"custom-select-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":_vm.actionCheckList[(item.id)]}})]):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"custom-select-action-text",attrs:{"sm":"11"}},[_vm._v("\n                                "+_vm._s(_vm.$t(item.action))+"\n                            ")])],1)],1):_vm._e()}),0)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":8,"readonly":""},model:{value:(_vm.responseActionText),callback:function ($$v) {_vm.responseActionText=$$v},expression:"responseActionText"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('note'))+":")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"","rows":5,"max-rows":6},model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('span',{staticStyle:{"align-self":"center"}},[_vm._v(_vm._s(_vm.$t('predictedDate')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{staticStyle:{"text-align":"left"}},[_c('el-date-picker',{class:{'is-invalid': _vm.actionErrors.expectedActionDate },staticStyle:{"width":"100%","align-self":"center"},attrs:{"type":"date","readonly":false,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},model:{value:(_vm.expectedDate),callback:function ($$v) {_vm.expectedDate=$$v},expression:"expectedDate"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.type === 'updateTicket')?_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.update()}}},[_vm._v(_vm._s(_vm.$t('update')))]):_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.insert()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"Danger"},on:{"click":function($event){return _vm.$refs.createAction.hide()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NkhH":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"intensityTableTitle":"Emisyon Yoğunluk Ölçümleri","measurement":"Ölçüm","changingColumn":"Değişim (%)","IntensityTotalEmissions":"Toplam Emisyon (tonCO2e)","IntensityTotalConsumption":"Toplam Tüketim","IntensityTotalEmployeeCount":"Toplam Kişi Sayısı","emissionValuePerEmployee":"Kişi Başına Emisyon (tonCO2e/kişi)","consumptionValuePerEmployee":"Kişi Başına Tüketim","person":"kişi"},"en":{"intensityTableTitle":"Intensity Measurements of Emission","measurement":"Measurement","changingColumn":"Change (%)","IntensityTotalEmissions":"Total Emissions (mtCO2e)","IntensityTotalConsumption":"Total Consumption","IntensityTotalEmployeeCount":"Number of People","emissionValuePerEmployee":"Emissions per Person (mtCO2e/person)","consumptionValuePerEmployee":"Consumption per Person","person":"person"}}')
}


/***/ }),

/***/ "NpL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SemipolarSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      ringsNum: 5
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    ringStyle: function ringStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderTopColor: this.color,
        borderLeftColor: this.color
      };
    },
    ringsStyles: function ringsStyles() {
      var ringsStyles = [];
      var delayModifier = 0.1;
      var ringWidth = this.size * 0.05;
      var positionIncrement = ringWidth * 2;
      var sizeDecrement = this.size * 0.2;

      for (var i = 0; i < this.ringsNum; i++) {
        var computedSize = this.size - sizeDecrement * i + 'px';
        var computedPosition = positionIncrement * i + 'px';
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: this.animationDuration * delayModifier * (this.ringsNum - i - 1) + 'ms',
          height: computedSize,
          width: computedSize,
          left: computedPosition,
          top: computedPosition,
          borderWidth: ringWidth + 'px'
        }, this.ringStyle);
        ringsStyles.push(style);
      }

      return ringsStyles;
    }
  }
});

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Carousel: __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__["a" /* default */] },
    name: 'login',
    data: function data() {
        return {
            email: null,
            pass: null,
            captchaInput: null,
            captchaImg: null,
            captchaId: null,
            captchaRequired: false,
            captchaError: false,
            showPassword: false,
            err: null,
            dismissSecs: 10,
            passwordError: false,
            emailError: false,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            showInvalidUserAlert: 0,
            forgotPasswordActivationInfo: 0,
            showInviteCanceledAlert: 0,
            hideCarousel: false,
            isLoginButtonDisabled: false
        };
    },

    methods: {
        switchPasswordVisibility: function switchPasswordVisibility(id) {
            this.showPassword = !this.showPassword;
            var passwordField = document.querySelector('#' + id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text');else passwordField.setAttribute('type', 'password');
        },
        isValid: function isValid() {
            var captchaValid = this.captchaRequired ? this.captchaInput : true;
            this.passwordError = !this.pass;
            this.emailError = !this.email;
            return !(this.passwordError || this.emailError) && captchaValid;
        },
        login: function login(email, pass, captchaInput) {
            var _this = this;

            if (this.isValid()) {
                captchaInput = this.captchaRequired ? captchaInput : 'a';
                this.isLoginButtonDisabled = true;
                this.$Progress.start();
                return this.axios.post('/login', {
                    email: email,
                    password: pass,
                    captchaToken: captchaInput,
                    captchaId: this.captchaId
                }).then(function (response) {
                    if (response.data.token) {
                        localStorage.setItem('token', response.data.token);
                        document.cookie = 'Authorization=Bearer ' + response.data.token;
                        _this.$store.state.token = 'Bearer ' + response.data.token;
                        _this.axios.defaults.headers.Authorization = response.data.token ? 'Bearer ' + response.data.token : 'Bearer ';
                        _this.$store.dispatch('init').then(function () {
                            _this.$router.push({ name: 'dashboard' });
                            _this.$root.$i18n.locale = _this.$store.state.locale;
                        });
                    } else {
                        _this.isLoginButtonDisabled = false;
                    }
                    _this.$Progress.finish();

                    return true;
                }).catch(function (err) {
                    _this.showInvalidUserAlert = _this.dismissSecs;
                    _this.err = err;
                    _this.getCaptcha();
                    _this.isLoginButtonDisabled = false;
                    _this.$Progress.finish();
                });
            }
        },
        getCaptcha: function getCaptcha() {
            var _this2 = this;

            return this.axios.post('/captcha').then(function (response) {
                _this2.captchaId = response.data.id, (_this2.captchaImg = response.data.imgSrc)(_this2.captchaRequired = response.data.required);
            }).catch(function (err) {
                _this2.err = err;
                _this2.$Progress.finish();
            });
        },
        countDownChanged: function countDownChanged(dismissCountDown) {
            return dismissCountDown = dismissCountDown - 1;
        },
        init: function init() {
            this.forgotPasswordActivationInfo = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.route.query, 'passwordResetInfo') != undefined && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.route.query, 'passwordResetInfo') ? this.dismissSecs : 0;
            this.showInviteCanceledAlert = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.route.query, 'inviteCanceled') != undefined && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(this.route.query, 'inviteCanceled') ? this.dismissSecs : 0;
        },
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created: function created() {
        this.onResize();
        this.init();
    },
    beforeMount: function beforeMount() {
        this.getCaptcha();
    },
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
});

/***/ }),

/***/ "NyJr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegionMultiSelect_vue__ = __webpack_require__("8rsv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd55dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegionMultiSelect_vue__ = __webpack_require__("FvlQ");
function injectStyle (ssrContext) {
  __webpack_require__("w+0S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0dd55dc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegionMultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dd55dc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegionMultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O4/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UploadRegular__ = __webpack_require__("8Vs0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LoadDataViaExcel',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_3__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_2__components_Upload__["a" /* default */] },
    data: function data() {
        return {
            dataTypes: [],
            reactiveId: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
            xlsx: null
        };
    },

    methods: {
        onupload: function onupload(event) {
            var _this = this;

            this.xlsx = {
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
            return this.axios.post('/data/read-from-excel', {
                uuid: this.xlsx.uuid,
                locale: this.$store.state.locale
            }, { responseType: 'blob' }) //, headers: { 'Accept': 'application/vnd.ms-excel' }
            .then(function (response) {
                var headerLine = response.headers['content-disposition'];
                var filename = decodeURI(headerLine.substring(headerLine.indexOf('"') + 1, headerLine.lastIndexOf('"')));
                _this.downloadExcelBlob(response, filename);
                return _this.$Progress.finish();
            });

            /*    
            window.open(
                `${this.apiURL}/data/read-from-excel/${this.xlsx.uuid}/${this.$store.state.locale}?token=${this.downloadToken}`
            );
            */
        },
        downloadTemplate: function downloadTemplate(name, type, id) {
            window.open(this.apiURL + '/data/excel-template/' + id + '/' + type + '/' + name + '/' + this.$store.state.locale + '?token=' + this.downloadToken);
        },
        init: function init() {
            var _this2 = this;

            this.$Progress.start();
            return this.axios.get('/batchEntry').then(function (_ref) {
                var data = _ref.data;

                _this2.dataTypes = data;
                _this2.dataTypes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(_this2.dataTypes, function (dataType) {
                    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toLower(_this2.$t(dataType.typeName));
                });
                _this2.$Progress.finish();
            });
        }
    },
    created: function created() {
        this.downloadToken = this.token.substr(7);
        this.init();
    }
});

/***/ }),

/***/ "OBCB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeGeneral_vue__ = __webpack_require__("AB+m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cc1f50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeGeneral_vue__ = __webpack_require__("XEq1");
function injectStyle (ssrContext) {
  __webpack_require__("eys3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63cc1f50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeGeneral_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63cc1f50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeGeneral_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("6z1y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OUu5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OZT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'createAudit',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_4__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_3__components_Upload__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a },
    data: function data() {
        return {
            filesInWait: [],
            audit: {
                title: null,
                type: 'E',
                date: null,
                branches: [],
                files: []
            },
            reload: function reload() {},
            selectedSiteId: null,
            selectedYear: null,
            editType: null,
            filteredSites: [],
            reactiveId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
            siteId: null,
            type: null,
            postId: null,
            postDocuments: [],
            onCloud: false,
            errors: {
                title: false,
                type: false,
                date: false,
                branches: false,
                files: false
            }
        };
    },

    methods: {
        onupload: function onupload(event) {
            var fileToAdd = {
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
            __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.audit, 'files')) ? this.audit.files = [fileToAdd] : this.audit.files.push(fileToAdd);
            this.onCloud = event.onCloud;
            this.filesInWait.push(event.id);
        },
        getAuditTypes: function getAuditTypes() {
            var auditTypes = [{ type: 'E', displayName: this.$t('externalAudit') }, { type: 'I', displayName: this.$t('internalAudit') }, { type: 'C', displayName: this.$t('control') }];
            return auditTypes;
        },
        onHide: function onHide(event) {
            if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(event, 'trigger') != null) {
                this.closeModal(true);
            }
        },
        closeModal: function closeModal() {
            var _this = this;

            var deleteFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.filesInWait) && deleteFiles && this.onCloud) {
                this.axios.post('/deleteFilesFromAWS', { files: this.filesInWait }).then(function () {
                    _this.filesInWait = [];
                    _this.$refs.createAudit.hide();
                });
            } else {
                this.filesInWait = [];
                this.$refs.createAudit.hide();
            }
        },
        insert: function insert() {
            var _this2 = this;

            if (this.isValidInsertion()) {
                var auditDate = new Date(this.audit.date);
                auditDate = new Date(Date.UTC(auditDate.getFullYear(), auditDate.getMonth(), auditDate.getDate()));
                return this.axios.post('/audits/create', this.configureAuditBeforeSending(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.audit, { date: auditDate }))).then(function () {
                    _this2.closeModal();
                }).then(function () {
                    if (_this2.editType === 'createDetail') {
                        _this2.reload(_this2.selectedYear, _this2.siteId, _this2.selectedType);
                    } else {
                        _this2.reload(_this2.selectedRegionId, _this2.selectedTypeId);
                    }
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        isValidInsertion: function isValidInsertion() {
            this.errors.title = !this.audit.title;
            this.errors.type = !this.audit.type;
            this.errors.date = !this.audit.date;
            this.errors.branches = !this.audit.branches.length == 0 ? false : true;
            // this.errors.file = !(this.audit.file);
            var validation = true;
            for (var key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        update: function update() {
            var _this3 = this;

            if (this.isValidInsertion()) {
                return this.axios.post('/audit/update', this.configureAuditBeforeSending(this.audit)).then(function () {
                    _this3.closeModal();
                }).then(function () {
                    _this3.reload(_this3.selectedYear, _this3.siteId, _this3.selectedType);
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        onRemove: function onRemove(file) {
            if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(file), 'id')) {
                this.filesInWait = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.remove(this.filesInWait, file.id);
            }
            this.audit.files = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.remove(this.audit.files, function (nFile) {
                return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(file, 'uuid') != __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(nFile, 'uuid');
            });
            if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.isEmpty(this.audit.files)) {
                this.audit.files = [];
            }
        },
        configureAuditBeforeSending: function configureAuditBeforeSending(audit) {
            var configuredAudit = {};
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(configuredAudit, audit);
            if (configuredAudit.branches && configuredAudit.branches.length > 0) {
                configuredAudit.branches = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.reduce(configuredAudit.branches, function (newBranches, branch) {
                    newBranches.push(branch.id);
                    return newBranches;
                }, []);
            }
            return configuredAudit;
        },
        onShow: function onShow() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
            this.filesInWait = [];
            var payload = this.$store.state.modal.payload;
            this.editType = payload.editType;
            this.reload = payload.reloadFunction;
            this.selectedRegionId = payload.selectedRegionId;
            this.selectedType = payload.selectedType; // this is for audit type
            this.selectedYear = payload.selectedYear;
            this.selectedTypeId = payload.selectedTypeId; // This is for get sites (site types)
            if (payload && (payload.editType === 'update' || payload.editType === 'createDetail')) {
                var post = payload.post;
                this.type = payload.editType;
                this.siteId = payload.siteId;
                if (post) {
                    this.audit.title = post.title;
                    this.audit.type = post.type;
                    this.audit.date = post.audit_date;
                    this.audit.record_id = post.record_id;
                    this.audit.document_id = post.document_id;
                    this.audit.audit_record_document_id = post.audit_record_document_id;
                    if (post.files) {
                        this.audit.files = post.files;
                    }
                }
                var foundSite = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.$store.state.sites, { id: Number(payload.siteId) });
                if (foundSite) {
                    this.audit.branches.push(foundSite);
                }
            }
        }
    },
    computed: {
        postTitle: function postTitle() {
            return this.type === 'updatePost' ? this.$t('updateAudit') : this.$t('createAudit');
        }
    }
});

/***/ }),

/***/ "OZsc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ocvz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OhQc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OqBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteMultiSelectTree_vue__ = __webpack_require__("oE/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bignumber_js__ = __webpack_require__("uotZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bignumber_js__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateSource',
    components: {
        SiteMultiSelectTree: __WEBPACK_IMPORTED_MODULE_2__components_SiteMultiSelectTree_vue__["a" /* default */]
    },
    data: function data() {
        return {
            pageSource: '',
            duplicateSourceModal: false,
            convertUnitsModal: false,
            inactivateSourceModal: false,
            sourceTabs: null,
            activeStep: 0,
            showModal: false,
            modalType: null,
            allSites: [],
            scopeGroups: null,
            selectedItem: {},
            steps: [],
            rawSteps: [{
                stepTitle: 'selectActivity',
                editStepTitle: 'activity',
                stepSubTitle: 'selectActivityTitle',
                editStepSubTitle: 'selectActivityTitle'
            }, {
                stepTitle: 'defineSources',
                editStepTitle: 'source',
                stepSubTitle: 'defineSourcesTitle',
                editStepSubTitle: 'source'
            }, {
                stepTitle: 'assignLocations',
                editStepTitle: 'locations',
                stepSubTitle: 'assignLocations',
                editStepSubTitle: 'locations'
            }, {
                stepTitle: 'emissionFactors',
                editStepTitle: 'emissionFactors',
                stepSubTitle: 'emissionFactorsTitle',
                editStepSubTitle: 'emissionFactorsTitle'
            }],
            editedItem: {
                emissionFactors: {},
                locations: []
            },
            editedItemRaw: {},
            normalizationTypes: ["-", "area", "person"],
            unitList: [],
            unitMap: {},
            unitTypeMap: { id: {}, name: {} },
            newEmissionModel: {},
            emissionUpdateTableFields: [{ "key": "type", "header": "greenhouseGas", "type": "list" }, { "key": "dateRange", "header": "start", "type": "list" }, { "key": "emission", "header": "emissionFactor", "type": "text" }, { "key": "source", "header": "source", "type": "text" }],
            headerWidths: {
                emissionFactor: '12em',
                start: '11em'
            },
            emisssionCustomInsertMode: false,
            emissionTypes: null,
            inProgress: false,
            errors: {
                1: {
                    sourceName: false,
                    sourceType: false,
                    sourceTypeGroup: false,
                    unit: false,
                    validFrom: false
                },
                2: {
                    locations: false
                },
                3: {
                    emissionFactor: false
                }
            },
            rawDesign: [{
                key: "value1",
                active: true,
                header: "Miktar",
                "type": "float",
                editable: true,
                required: true
            }, {
                key: "cost",
                active: true,
                header: "Maliyet",
                "type": "float",
                editable: true,
                required: true
            }, {
                key: "paymentMethod",
                active: true,
                header: "Ödeme Yöntemi",
                "type": "select",
                editable: true,
                required: false
            }, {
                key: "date",
                active: true,
                header: "Tarih Aralığı",
                "type": "daterange",
                editable: true,
                required: true
            }, {
                key: "health",
                active: true,
                header: "Veri Sağlığı",
                "type": "icon",
                editable: false,
                required: false
            }, {
                key: "file",
                active: true,
                header: "Fatura",
                "type": "file",
                editable: true,
                required: false
            }, {
                key: "description",
                active: true,
                header: "description",
                "type": "text",
                editable: true,
                required: false
            }, {
                key: "lastUpdatedAt",
                active: true,
                header: "Son Değişiklik Tarihi",
                "type": "date",
                editable: false,
                required: false
            }, {
                key: "lastModifier",
                active: true,
                header: "Son Düzenleyen",
                "type": "identity",
                editable: false,
                required: false
            }],
            rawDesignIsb: [{
                key: "value1",
                active: true,
                header: "Miktar",
                "type": "float",
                editable: true,
                required: true
            }, {
                key: "cost",
                active: true,
                header: "Maliyet",
                "type": "float",
                editable: true,
                required: true
            }, {
                key: "paymentMethod",
                active: false,
                header: "Ödeme Yöntemi",
                "type": "select",
                editable: true,
                required: false
            }, {
                key: "date",
                active: true,
                header: "Tarih Aralığı",
                "type": "daterange",
                editable: true,
                required: true
            }, {
                key: "health",
                active: true,
                header: "Veri Sağlığı",
                "type": "icon",
                editable: false,
                required: false
            }, {
                key: "file",
                active: true,
                header: "Fatura",
                "type": "file",
                editable: true,
                required: true
            }, {
                key: "description",
                active: true,
                header: "description",
                "type": "text",
                editable: true,
                required: false
            }, {
                key: "lastUpdatedAt",
                active: true,
                header: "Son Değişiklik Tarihi",
                "type": "date",
                editable: false,
                required: false
            }, {
                key: "lastModifier",
                active: true,
                header: "Son Düzenleyen",
                "type": "identity",
                editable: false,
                required: false
            }],
            isLoaded: false,
            isEmissionsLoaded: false,
            emissionLibraries: [],
            relatedSites: [],
            emissionLibraryExample: {},
            emissionLibraryContents: {},
            emissionLocationInfo: null,
            emissionLibraryDataFields: [{
                label: this.$t('greenhouseGas'),
                key: 'name',
                thClass: 'emission-th',
                tdClass: 'emission-td',
                stickyColumn: true
            }, {
                label: this.$t('start'),
                key: 'start',
                thClass: 'emission-th',
                tdClass: 'emission-td',
                stickyColumn: true
            }, {
                label: this.$t('emissionFactor'),
                key: 'emissionFactor',
                thClass: 'emission-th',
                tdClass: 'emission-td',
                stickyColumn: true
            }],
            emissionLibraryData: []
        };
    },

    methods: {
        forceUpdate: function forceUpdate() {
            this.$forceUpdate();
        },
        onShowModal: function onShowModal() {
            var _this = this;

            this.init().then(function () {
                if (_this.route.params.site_id) {
                    _this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this.rawSteps, function (step) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(step, 'stepTitle') !== 'assignLocations';
                    });
                }

                _this.activeStep = 0;
                _this.showModal = true;
                _this.allSites = _this.sitesWithGroups;

                _this.eventId = _this.$store.state.modal.eventId;
                _this.type = _this.$store.state.modal.type;
                _this.pageSource = _this.$store.state.modal.payload.page;

                if (_this.type === 'createSource') {
                    _this.modalType = 'insert';
                    _this.prepareCreateModalData();
                } else {
                    _this.modalType = 'update';
                    _this.selectedItem = _this.$store.state.modal.payload.selectedItem;
                    _this.prepareUpdateModalData(_this.selectedItem);
                }
            });
        },
        onHideModal: function onHideModal() {
            this.activeStep = 0;
            this.editedItem = {};
            this.showModal = false;
            this.modalType = null;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.scopeGroups, function (o) {
                o.isSelected = false;
            });

            this.scopeGroups = null;

            // Revert steps to its original state
            this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.rawSteps);
        },
        prepareCreateModalData: function prepareCreateModalData() {
            this.activeStep = 0;
            this.modalType = 'insert';
            this.editedItem = {
                name: null,
                scopeGroup: null,
                sourceTypeGroup: null,
                sourceType: null,
                unit: null,
                normalizationType: '-',
                validFrom: null,
                until: null,
                isActive: true,
                hazardous: null,
                locations: [],
                emissionSource: null,
                emissionSourceName: '',
                emissionFactors: {},
                sourceFactors: {},
                design: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.isbId(this.$store.state.user.customerId) ? this.rawDesignIsb : this.rawDesign),
                exampleSiteId: null
            };
            if (this.route.params.site_id) {
                this.editedItem.locations.push(this.route.params.site_id);
            }
        },
        prepareUpdateModalData: function prepareUpdateModalData(selectedItem) {
            var _this2 = this;

            var scopeGroupKey = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.indexOf(this.scopeGroups, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.scopeGroups, function (o) {
                return o.id == __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'scopeGroup');
            }));

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(['water', 'water usage'], __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.lowerCase(this.scopeGroups[scopeGroupKey].name))) {
                this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.steps), function (o) {
                    return o.stepTitle != 'emissionFactors';
                });
            }

            this.activeStep = 0;
            this.modalType = 'update';
            var emissions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'emissions'), function (emission) {
                return {
                    id: emission.id,
                    editMode: false,
                    value: {
                        type: emission.type,
                        start: emission.startDate,
                        end: emission.endDate,
                        factor: _this2.localizeValue(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(emission.factor).toFixed(), _this2.locale),
                        source: emission.source,
                        unit: 'ton/' + _this2.unitMap[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'unit')]
                    },
                    editedValue: {
                        type: emission.type,
                        start: emission.startDate,
                        end: emission.endDate,
                        factor: _this2.localizeValue(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(emission.factor).toFixed(), _this2.locale),
                        source: emission.source,
                        unit: 'ton/' + _this2.unitMap[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'unit')]
                    }
                };
            });
            emissions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(emissions, function (o) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.start).year();
            }, 'desc');
            var sourceFactors = {};
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'sourceFactors'), function (sourceFactor) {
                var toType = _this2.unitTypeMap.id[sourceFactor.to];
                var fromType = _this2.unitTypeMap.id[sourceFactor.from];
                sourceFactors[toType] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, sourceFactor, {
                    from_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this2.unitList, function (o) {
                        return fromType == _this2.unitTypeMap.id[o.id];
                    }),
                    to_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this2.unitList, function (o) {
                        return toType == _this2.unitTypeMap.id[o.id];
                    })
                });
            });

            var innerDesign = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'design'));
            var controlDesign = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.isbId(this.$store.state.user.customerId) ? this.rawDesignIsb : this.rawDesign);
            var design = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(controlDesign, function (design) {
                var nDesign = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(innerDesign, function (o) {
                    return o.key == design.key;
                });
                if (nDesign) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nDesign, { active: true });
                } else {
                    design['active'] = false;
                    return design;
                }
            });
            this.editedItem = {
                id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'id'),
                name: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'cols'), 'name'), 'value') || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'cols'), 'dataType'), 'value'),
                scopeGroup: scopeGroupKey,
                sourceTypeGroup: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'sourceTypeGroup'),
                sourceType: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'sourceType'),
                unit: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'unit'),
                normalizationType: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'normalizationType'),
                validFrom: null,
                until: null,
                isActive: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'isActive'),
                hazardous: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'hazardous') == undefined ? false : true,
                locations: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'locations'),
                emissionSource: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'emissionSource'),
                emissionSourceName: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedItem, 'emissionSourceName'),
                emissionFactors: emissions,
                sourceFactors: sourceFactors,
                design: design,
                exampleSiteId: null
            };
            this.scopeGroups[this.editedItem.scopeGroup].isSelected = true;
            /*
            _.each(this.scopeGroups, o=> {
                if(o.id == _.get(item, 'scopeGroup')){
                    o.isSelected = true;
                }
            });
            */

            this.editedItemRaw = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(this.editedItem);

            // this.$refs.itemEditModal.show();
        },
        selectScopeGroup: function selectScopeGroup(scopeGroup, key) {
            if (this.modalType == 'insert') {
                var selectedScopeGroup = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.scopeGroups, function (o) {
                    return o.isSelected == true;
                });
                if (selectedScopeGroup) {
                    if (scopeGroup.isSelected) {
                        scopeGroup.isSelected = false;
                        this.editedItem.scopeGroup = null;
                    } else {
                        selectedScopeGroup.isSelected = false;
                        scopeGroup.isSelected = true;
                        this.editedItem.scopeGroup = key;
                    }
                } else {
                    scopeGroup.isSelected = true;
                    this.editedItem.scopeGroup = key;
                }
                this.resetFieldValues(1);

                // If scope group is water related, disable emission factor step
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(['water', 'water usage'], __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.lowerCase(this.scopeGroups[key].name))) {
                    this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.steps), function (o) {
                        return o.stepTitle != 'emissionFactors';
                    });
                }
                // If scope group is not water related revert steps back to its original steps according to location filter
                else {
                        if (this.route.params.site_id) {
                            this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.rawSteps, function (step) {
                                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(step, 'stepTitle') !== 'assignLocations';
                            });
                        } else {
                            this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.rawSteps);
                        }
                    }
            }
        },
        resetFieldValues: function resetFieldValues(step) {
            if (step == 1) {
                this.editedItem.name = null;
                this.editedItem.sourceTypeGroup = null;
                this.editedItem.sourceType = null;
                this.editedItem.unit = null;
                this.editedItem.validFrom = null;
                this.editedItem.until = null;
                this.editedItem.hazardous = false;
            } else if (step == 2) {
                this.editedItem.locations = [];
            } else if (step == 3) {
                this.editedItem.emissionSource = null;
                this.editedItem.emissionFactors = {};
            }
        },
        isSourceTypeGroupAvailable: function isSourceTypeGroupAvailable() {
            var sourceTypeGroups = this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups;
            if (sourceTypeGroups.length == 1) {
                this.editedItem.sourceTypeGroup = sourceTypeGroups[0].id;
            }
            return sourceTypeGroups.length > 1;
        },
        getSelectedSiteIds: function getSelectedSiteIds() {
            return this.createGroupedSitesKeys(this.editedItem.locations);
        },
        selectSite: function selectSite(value) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.set(this.editedItem, 'locations', this.getSiteIdsInGroupedSitesMap(value));
        },
        arrangeOptions: function arrangeOptions(selectData) {
            var _this3 = this;

            var sourceTypeSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var options = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(selectData, function (selectItem) {
                if (sourceTypeSelect) {
                    selectItem = { value: selectItem, text: _this3.$t(_this3.sourceTypes[selectItem].name), disabled: false };
                } else {
                    selectItem = { value: selectItem.id, text: _this3.$t(selectItem.label), disabled: false };
                }
                return selectItem;
            });
            return [{ value: null, text: this.$t('choose'), disabled: true }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(options));
        },
        getExampleConversion: function getExampleConversion(from, to, value) {
            if (from && to && value != null) {
                var val = 1 * __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(value);
                return '1 ' + this.unitMap[from] + ' = ' + val + ' ' + this.unitMap[to];
            }
        },
        addNewEmissionFactors: function addNewEmissionFactors() {
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(this.editedItem.emissionSource)) {
                this.newEmissionModel = {
                    id: null,
                    editMode: false,
                    value: {
                        type: null,
                        start: null,
                        end: null,
                        factor: null,
                        source: null,
                        unit: 'ton/' + this.unitMap[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.editedItem, 'unit')]
                    },
                    editedValue: {
                        type: null,
                        start: null,
                        end: null,
                        factor: null,
                        source: null,
                        unit: 'ton/' + this.unitMap[__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.editedItem, 'unit')]
                    }
                };
                this.emisssionCustomInsertMode = true;
            }
            this.forceUpdate();
        },
        cancelNewCustomEmissionFactors: function cancelNewCustomEmissionFactors() {
            this.emisssionCustomInsertMode = false;
        },
        addNewCustomEmissionFactors: function addNewCustomEmissionFactors(factors) {
            factors.value = {
                type: factors.editedValue.type,
                start: __WEBPACK_IMPORTED_MODULE_4_moment___default()(factors.editedValue.start).startOf('year'),
                end: __WEBPACK_IMPORTED_MODULE_4_moment___default()(factors.editedValue.start).add(10, 'year').endOf('year'),
                factor: factors.editedValue.factor,
                source: factors.editedValue.source,
                unit: factors.editedValue.unit
            };
            factors.editedValue = factors.value;
            this.editedItem.emissionFactors.push(factors);
            this.emisssionCustomInsertMode = false;
            this.formatDatesOfEmissions(factors.value.type);
            this.recalculateCO2eForGivenYears(factors.value.start, factors.value.end);
            this.editedItem.emissionFactors = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(this.editedItem.emissionFactors, function (o) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.start).year();
            }, 'asc');
            this.forceUpdate();
        },
        formatDatesOfEmissions: function formatDatesOfEmissions(emissionTypeId) {
            //let selectedEmissionGroup = _.filter(this.editedItem.emissionFactors, o=> o.value.type == emissionTypeId);
            var selectedEmissionGroup = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flow(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.partialRight(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter, function (o) {
                return o.value.type == emissionTypeId;
            }), __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.partialRight(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy, function (o) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.start).year();
            }))(this.editedItem.emissionFactors);
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(selectedEmissionGroup, function (emission, index) {
                if (index < __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(selectedEmissionGroup) - 1) {
                    emission.editedValue.end = __WEBPACK_IMPORTED_MODULE_4_moment___default()(selectedEmissionGroup[index + 1].editedValue.start).subtract(1, 'year').endOf('year');
                    emission.value = emission.editedValue;
                }
            });
        },
        recalculateCO2eForGivenYears: function recalculateCO2eForGivenYears(startDate, endDate) {
            var N2OId = this.getEmissionId('N2O'),
                CH4Id = this.getEmissionId('CH4'),
                CO2Id = this.getEmissionId('CO2'),
                CO2eId = this.getEmissionId('CO2e');
            var relatedEmissionValues = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.editedItem.emissionFactors, function (o) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.start).isSame(startDate, 'year') && __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.end).isSame(endDate, 'year');
            });
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.intersection(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(relatedEmissionValues, 'value'), 'type'), [N2OId, CH4Id, CO2Id])) == 3) {
                var n2o = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(relatedEmissionValues, function (o) {
                    return o.value.type == N2OId;
                });
                var ch4 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(relatedEmissionValues, function (o) {
                    return o.value.type == CH4Id;
                });
                var co2 = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(relatedEmissionValues, function (o) {
                    return o.value.type == CO2Id;
                });
                var co2e = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(relatedEmissionValues, function (o) {
                    return o.value.type == CO2eId;
                });
                var newCO2eFactor = this.localizeValue(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(co2.value.factor, this.locale)).plus(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(ch4.value.factor, this.locale)).multipliedBy(28)).plus(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(n2o.value.factor, this.locale)).multipliedBy(265)).toFixed(), this.locale);
                if (co2e) {
                    co2e.editedValue.factor = newCO2eFactor;
                    co2e.value = co2e.editedValue;
                } else {
                    var factor = {
                        id: null,
                        editMode: false,
                        value: {
                            type: CO2eId,
                            start: n2o.value.start,
                            end: n2o.value.end,
                            factor: newCO2eFactor,
                            source: n2o.value.source,
                            unit: n2o.value.unit
                        },
                        editedValue: {
                            type: CO2eId,
                            start: n2o.value.start,
                            end: n2o.value.end,
                            factor: newCO2eFactor,
                            source: n2o.value.source,
                            unit: n2o.value.unit
                        }
                    };
                    this.editedItem.emissionFactors.push(factor);
                }
                this.formatDatesOfEmissions(CO2eId);
            }
        },
        recalculateCO2e: function recalculateCO2e() {
            var filteredDataKeys = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.flow(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.partialRight(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map, function (value, key) {
                return {
                    key: key,
                    value: value
                };
            }), __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.partialRight(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter, function (o) {
                return o.value != '' && o.value != 'NaN' && !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNaN(o.value);
            }), __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.partialRight(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map, 'key'))(this.editedItem.emissionFactors);
            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.intersection(filteredDataKeys, ['N2O', 'CH4', 'CO2'])) == 3) {
                var co2eVal = this.localizeValue(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(this.editedItem.emissionFactors['CO2'], this.locale)).plus(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(this.editedItem.emissionFactors['CH4'], this.locale)).multipliedBy(28)).plus(new __WEBPACK_IMPORTED_MODULE_5_bignumber_js___default.a(this.delocalizeValueForBN(this.editedItem.emissionFactors['N2O'], this.locale)).multipliedBy(265)).toFixed(), this.locale);

                if (this.editedItem.emissionFactors['CO2e'] != undefined) {
                    if (this.editedItem.emissionFactors['CO2e'] != co2eVal) {
                        this.editedItem.emissionFactors['CO2e'] = co2eVal;
                    }
                } else {
                    this.editedItem.emissionFactors['CO2e'] = co2eVal;
                }

                //(CO2.factor*1+CH4.factor*28+N2O.factor*265)
            }

            this.forceUpdate();
        },
        saveEmissionType: function saveEmissionType(emissionType) {
            emissionType.value = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(emissionType.editedValue);
            emissionType.editMode = false;
            this.formatDatesOfEmissions(emissionType.value.type);
            if (emissionType.value.type != this.getEmissionId('CO2e')) {
                this.recalculateCO2eForGivenYears(emissionType.value.start, emissionType.value.end);
            }
            this.editedItem.emissionFactors = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(this.editedItem.emissionFactors, function (o) {
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(o.value.start).year();
            }, 'asc');
            this.forceUpdate();
        },
        revertEmissionType: function revertEmissionType(emissionType) {
            emissionType.editedValue = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(emissionType.value);
            emissionType.editMode = false;
        },
        removeEmissionType: function removeEmissionType(emissionType) {
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(this.editedItem.emissionFactors, emissionType);
            this.forceUpdate();
        },
        getEmissionId: function getEmissionId(name) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionTypes, function (o) {
                return o.name == name;
            }).id;
        },
        getEmissionType: function getEmissionType(id) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionTypes, function (o) {
                return o.id == id;
            }).name;
        },
        saveSource: function saveSource() {
            if (this.modalType == 'update') {
                this.updateSource();
            } else {
                this.insertSource();
            }
        },

        // Updates source by given cirscumtances
        updateSource: function updateSource() {
            var _this4 = this;

            // If page is source management
            if (this.pageSource === 'sourceManagement') {

                if (this.editedItem.unit === this.editedItemRaw.unit) {
                    this.updateSourceManagement(false);
                } else {
                    this.convertUnitsModal = true;
                }
                // If page is data summary
            } else if (this.pageSource === 'sourceSummary') {

                var action = this.getUpdatedType();

                switch (action) {
                    // If source type definitions or emission factors are changed, calls duplicateSourceModal
                    case 'duplicate':
                        this.duplicateSourceModal = true;
                        break;

                    // If only active/passive state is changed, update site's activation state
                    case 'activationUpdate':
                        this.inProgress = true;
                        this.$Progress.start();

                        this.axios.put('/siteSourceActivationUpdate', {
                            sourceId: this.editedItem.id,
                            isActive: this.editedItem.isActive,
                            siteId: this.route.params.site_id,
                            year: this.$store.state.year
                        }).then(function () {
                            _this4.$Progress.finish();
                            _this4.$refs.createSource.hide();
                            _this4.inProgress = false;
                            _this4.$eventHub.$emit(_this4.$store.state.modal.eventId, { emitter: 'update' });
                        });
                        break;

                    default:
                        this.$refs.createSource.hide();
                        break;
                }
            }
        },

        // Determines required action for updating source
        getUpdatedType: function getUpdatedType() {
            // If emission data type definitions or emission factors are changed
            if (this.editedItemRaw.name !== this.editedItem.name || this.editedItemRaw.sourceTypeGroup !== this.editedItem.sourceTypeGroup || this.editedItemRaw.sourceType !== this.editedItem.sourceType || this.editedItemRaw.unit !== this.editedItem.unit || this.editedItemRaw.normalizationType !== this.editedItem.normalizationType || this.editedItemRaw.hazardous !== this.editedItem.hazardous || !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.editedItemRaw.emissionFactors, this.editedItem.emissionFactors) || !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.editedItemRaw.sourceFactors, this.editedItem.sourceFactors) || !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(this.editedItemRaw.design, this.editedItem.design)) {
                return 'duplicate';
                // If only active/passive state is changed
            } else if (this.editedItemRaw.isActive !== this.editedItem.isActive) {
                return 'activationUpdate';
            } else {
                return 'none';
            }
        },

        // If source is active opens inactivateSourceModal, else creates new duplication
        duplicateSource: function duplicateSource() {
            if (this.editedItemRaw.isActive) {
                this.inactivateSourceModal = true;
            } else {
                this.changeDuplicatedSourceActivation(false);
            }
        },

        // If source definitions are changes but unit is not changed, changes source by creating new duplication
        // else opens convertUnitsModal modal
        convertExistingSource: function convertExistingSource() {
            if (this.editedItem.unit === this.editedItemRaw.unit) {
                this.changeExistingSource(false);
            } else {
                this.convertUnitsModal = true;
            }
        },

        // Updates sources for all locations
        updateSourceManagement: function updateSourceManagement(changeUnits) {
            var _this5 = this;

            var newItem = this.generateNewItem(true);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();

            this.axios.put('/sources', {
                item: newItem,
                editingLocationActivations: this.editedItemRaw.isActive,
                changeUnits: changeUnits,
                oldUnitId: this.editedItemRaw.unit
            }).then(function () {
                _this5.$store.dispatch("getDataTypes");
                _this5.$store.dispatch("getSites");
                _this5.$Progress.finish();
                _this5.$refs.createSource.hide();
                _this5.inProgress = false;
                _this5.$eventHub.$emit(_this5.$store.state.modal.eventId, { emitter: 'update' });
            });
        },

        // Changes source by creating new duplication
        changeExistingSource: function changeExistingSource(convertUnits) {
            var _this6 = this;

            var newItem = this.generateNewItem(true);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();

            this.axios.post('/changeExistingSource', {
                item: newItem,
                convertUnits: convertUnits,
                year: this.$store.state.year,
                siteId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toNumber(this.route.params.site_id),
                oldUnit: this.editedItemRaw.unit
            }).then(function () {
                _this6.$store.dispatch("getDataTypes");
                _this6.$store.dispatch("getSites");
                _this6.$Progress.finish();
                _this6.$refs.createSource.hide();
                _this6.inProgress = false;
                _this6.$eventHub.$emit(_this6.$store.state.modal.eventId, { emitter: 'update' });
            }).catch(function (err) {
                if (err.response.data.code === "InvalidContent") {
                    _this6.$Progress.finish();
                    _this6.inProgress = false;

                    _this6.$confirm(_this6.$t('invalidUnits'), _this6.$t('warning'), {
                        cancelButtonText: _this6.$t('back'),
                        type: 'warning',
                        center: true,
                        showConfirmButton: false
                    });

                    // this.$confirm(this.$t('invalidUnits'), this.$t('warning'), {
                    //     confirmButtonText: this.$t('saveWithoutConvert'),
                    //     cancelButtonText: this.$t('cancel'),
                    //     type: 'warning',
                    //     center: true
                    // })
                    //     .then(() => this.changeExistingSource(false))
                    //     .catch(() => {});
                }
            });
        },


        // Creates new source group by duplication and changes its active/passive state
        changeDuplicatedSourceActivation: function changeDuplicatedSourceActivation(inactiveExistDataType) {
            var _this7 = this;

            var newItem = this.generateNewItem(true);
            // _.set(newItem, 'locations', [_.toNumber(this.route.params.site_id)]);
            this.inProgress = true;
            this.$Progress.start();
            this.closeUpdateConfirmationDialogs();

            this.axios.post('/duplicateSourceGroup', {
                item: newItem,
                inactivate: inactiveExistDataType,
                year: this.$store.state.year
            }).then(function () {
                _this7.$store.dispatch("getDataTypes");
                _this7.$store.dispatch("getSites");
                _this7.$Progress.finish();
                _this7.$refs.createSource.hide();
                _this7.inProgress = false;
                _this7.$eventHub.$emit(_this7.$store.state.modal.eventId, { emitter: 'update' });
            });
        },

        // changeExistSourceByDuplication(convertUnits) {
        //     let newItem = this.generateNewItem(true);
        //     this.inProgress = true;
        //     this.$Progress.start();

        //     this.axios.post('/changeExistSourceByDuplication', {
        //         item: newItem,
        //         convertUnits
        //     })
        //     .then(() => {
        //         this.$Progress.finish();
        //         this.$refs.createSource.hide();
        //         this.inProgress = false;
        //         this.$eventHub.$emit(this.$store.state.modal.eventId, {emitter: 'update'});
        //     });
        // },

        insertSource: function insertSource() {
            var _this8 = this;

            this.inProgress = true;
            this.$Progress.start();
            var newItem = this.generateNewItem(false);

            return this.axios.post('/sources', newItem).then(function () {
                _this8.$store.dispatch("getDataTypes");
                _this8.$store.dispatch("getSites");
                _this8.$Progress.finish();
                _this8.$refs.createSource.hide();
                _this8.inProgress = false;
                _this8.$eventHub.$emit(_this8.$store.state.modal.eventId, { emitter: 'insert' });
            });
        },
        deleteSource: function deleteSource(id, isActive) {
            var _this9 = this;

            this.inProgress = true;
            this.$Progress.start();
            this.closeDeleteModal();
            return this.axios.delete('/sources/' + id + '/' + this.route.params.site_id).then(function () {
                _this9.$Progress.finish();
                _this9.$refs.createSource.hide();
                _this9.inProgress = false;
                _this9.forceUpdate();
                _this9.$eventHub.$emit(_this9.$store.state.modal.eventId, {
                    emitter: 'delete',
                    data: {
                        id: id,
                        isActive: isActive
                    }
                });
            });
        },
        generateNewItem: function generateNewItem(getId) {
            var _this10 = this;

            var selectedScopeGroup = this.scopeGroups[this.editedItem.scopeGroup];
            var tags = [selectedScopeGroup.id, this.editedItem.sourceTypeGroup, this.editedItem.sourceType];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(selectedScopeGroup.parentData, function (o) {
                if (_this10.editedItem.hazardous) {
                    tags.push(o.rel_id);
                } else {
                    if (o.type != 'hazardous') {
                        tags.push(o.rel_id);
                    }
                }
            });
            var design = {
                table: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.editedItem.design, function (o) {
                    return o.active;
                }), function (k) {
                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.omit(k, 'active');
                }),
                info: { tableName: this.editedItem.name }
            };
            var emissions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.editedItem.emissionFactors, function (value, key) {
                if (getId) {
                    return {
                        id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value, 'id'),
                        emission_id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'type'),
                        value: _this10.removeZeros(_this10.delocalizeValue(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'factor'), _this10.locale)),
                        source: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'source'),
                        unit: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'unit'),
                        start_date: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'start'),
                        end_date: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(value.value, 'end')
                    };
                } else {
                    return {
                        emission_id: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this10.emissionTypes, function (o) {
                            return o.name == key;
                        })), 'id'),
                        value: _this10.removeZeros(_this10.delocalizeValue(value, _this10.locale)),
                        source: _this10.editedItem.emissionSourceName,
                        unit: 'ton/' + _this10.unitMap[_this10.editedItem.unit],
                        start_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('year'),
                        end_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(10, 'year').endOf('year')
                    };
                }
            });
            emissions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(emissions, function (emission) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(emission, 'value') != '';
            });
            var emissionLibrarySource = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraries, function (o) {
                return o.value == _this10.editedItem.emissionSource;
            });
            return {
                id: getId ? this.editedItem.id : null,
                isActive: this.editedItem.isActive,
                name: this.editedItem.name,
                locations: this.editedItem.locations == null ? [] : this.editedItem.locations,
                unit: this.editedItem.unit,
                normalizationType: this.editedItem.normalizationType,
                tags: tags,
                user_source_factors: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.editedItem.sourceFactors, function (k) {
                    return !(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(k.from) && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(k.to) && __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(k.value));
                }), function (o) {
                    return { from: o.from, to: o.to, value: o.value };
                }),
                emission_factors: emissions,
                emissionSource: this.editedItem.emissionSource,
                emissionSourceName: emissionLibrarySource != undefined ? 'self_' + emissionLibrarySource.text : null,
                design: design,
                has_emission: !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(emissions)

            };
        },
        updateSourceFactorOptions: function updateSourceFactorOptions() {
            var _this11 = this;

            var selectedSourceType = this.sourceTypes[this.editedItem.sourceType];
            var possibleTypes = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(selectedSourceType.units, function (o) {
                return _this11.unitTypeMap.id[o.id];
            }));
            var selectedUnitType = this.unitTypeMap.id[this.editedItem.unit];
            this.editedItem['sourceFactors'] = {};
            if (selectedUnitType != 'other') {
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(possibleTypes, function (unitType) {
                    if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes([selectedUnitType, 'other'], unitType)) {
                        var existData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(selectedSourceType['source_factors'], selectedUnitType), unitType);
                        if (existData == undefined) {
                            _this11.editedItem['sourceFactors'][unitType] = {
                                from: null,
                                to: null,
                                value: null,
                                from_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this11.unitList, function (o) {
                                    return selectedUnitType == _this11.unitTypeMap.id[o.id];
                                }), //_.filter(this.sourceTypes[this.editedItem.sourceType].units, o=> (unitType == this.unitTypeMap.id[o.id])),
                                to_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this11.unitList, function (o) {
                                    return unitType == _this11.unitTypeMap.id[o.id];
                                }) //_.filter(this.sourceTypes[this.editedItem.sourceType].units, o=> (selectedType == this.unitTypeMap.id[o.id]))
                            };
                        } else {
                            _this11.editedItem['sourceFactors'][unitType] = {
                                from: existData.from,
                                to: existData.to,
                                value: existData.value,
                                from_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this11.unitList, function (o) {
                                    return selectedUnitType == _this11.unitTypeMap.id[o.id];
                                }),
                                to_options: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this11.unitList, function (o) {
                                    return unitType == _this11.unitTypeMap.id[o.id];
                                })
                            };
                        }
                    }
                });
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(['water', 'water usage'], __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.lowerCase(this.scopeGroups[this.editedItem.scopeGroup].name))) {
                    this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.steps), function (o) {
                        return o.stepTitle != 'emissionFactors';
                    });
                    // this.steps = _.filter(_.clone(this.rawSteps), o => o.stepTitle != 'emissionFactors');
                }
                // else{
                //     this.steps = _.clone(this.rawSteps);
                // }
            } else {
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(['water', 'water usage'], __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.lowerCase(this.scopeGroups[this.editedItem.scopeGroup].name))) {
                    this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.steps), function (o) {
                        return !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(['emissionFactors', 'sourceFactors'], o.stepTitle);
                    });
                    // this.steps = _.filter(_.clone(this.rawSteps), o => !_.includes(['emissionFactors','sourceFactors'], o.stepTitle));
                } else {
                    this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.steps, function (o) {
                        return o.stepTitle != 'sourceFactors';
                    });
                    // this.steps = _.filter(this.rawSteps, o => o.stepTitle != 'sourceFactors');
                }
            }
        },
        selectUnit: function selectUnit() {
            this.updateSourceFactorOptions();
            this.forceUpdate();
        },
        getDateRange: function getDateRange(startDate, endDate) {
            var startYear = __WEBPACK_IMPORTED_MODULE_4_moment___default()(startDate).year();
            var endYear = __WEBPACK_IMPORTED_MODULE_4_moment___default()(endDate).year();
            if (__WEBPACK_IMPORTED_MODULE_4_moment___default()().isBetween(startDate, endDate)) {
                endYear = this.$t('ongoing');
            }
            return startYear + ' - ' + endYear;
        },
        nextStep: function nextStep() {
            if (this.activeStep++ > this.steps.length - 2) this.activeStep = 0;
            if (this.steps[this.activeStep].stepTitle == 'emissionFactors') {
                this.getEmissionLibraries();
            }
        },
        getEmissionLibraries: function getEmissionLibraries() {
            var _this12 = this;

            this.isEmissionsLoaded = false;
            this.$Progress.start();
            var item = {
                locations: this.editedItem.locations,
                scopeGroupId: this.scopeGroups[this.editedItem.scopeGroup].id,
                sourceTypeGroupId: this.editedItem.sourceTypeGroup,
                sourceTypeId: this.editedItem.sourceType,
                unitId: this.editedItem.unit
            };
            return this.axios.post('/getRelatedEmissionLibraries', item).then(function (_ref) {
                var data = _ref.data;

                _this12.emissionLibraries = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(data, 'emissionLibraryContent'), function (o) {
                    return { value: o.emission_library_id, text: _this12.$t(o.name) };
                }), 'value');
                _this12.emissionLibraryContents = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(data, 'emissionLibraryContent');
                _this12.emissionLibraries = [{ value: null, text: _this12.$t('Custom') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this12.emissionLibraries));
                _this12.relatedSites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(data.locationInfo, 'siteName');
                _this12.editedItem.exampleSiteId = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.first(_this12.relatedSites), 'siteId');
                _this12.setExampleLibrary();
                _this12.$Progress.finish();
                _this12.isEmissionsLoaded = true;
            });
        },
        setExampleLibrary: function setExampleLibrary() {
            var _this13 = this;

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(this.editedItem.exampleSiteId)) {
                this.editedItem.exampleSiteId = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.first(this.relatedSites), 'siteId');
            }
            var selectedSite = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.relatedSites, function (o) {
                return o.siteId == _this13.editedItem.exampleSiteId;
            });
            this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                return o.emission_library_id == _this13.editedItem.emissionSource && o.region_id == selectedSite.regionId && o.sector_id == selectedSite.sectorId && o.unit_id == _this13.editedItem.unit;
            });
            if (this.emissionLibraryExample == undefined) {
                this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                    return o.emission_library_id == _this13.editedItem.emissionSource && o.region_id == null && o.country_id == selectedSite.countryId && o.sector_id == selectedSite.sectorId && o.unit_id == _this13.editedItem.unit;
                });
            }
            if (this.emissionLibraryExample == undefined) {
                this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                    return o.emission_library_id == _this13.editedItem.emissionSource && o.country_id == null && o.sector_id == selectedSite.sectorId && o.unit_id == _this13.editedItem.unit;
                });
            }
            if (this.emissionLibraryExample == undefined) {
                this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                    return o.emission_library_id == _this13.editedItem.emissionSource && o.region_id == null && o.country_id == selectedSite.countryId && o.sector_id == null && o.unit_id == _this13.editedItem.unit;
                });
            }
            if (this.emissionLibraryExample == undefined) {
                this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                    return o.emission_library_id == _this13.editedItem.emissionSource && o.region_id == selectedSite.regionId && o.sector_id == null && o.unit_id == _this13.editedItem.unit;
                });
            }
            if (this.emissionLibraryExample == undefined) {
                this.emissionLibraryExample = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.emissionLibraryContents, function (o) {
                    return o.emission_library_id == _this13.editedItem.emissionSource && o.country_id == null && o.sector_id == null && o.unit_id == _this13.editedItem.unit;
                });
            }
            this.emissionLibraryData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.emissionTypes, function (emissionKey) {
                return { name: emissionKey.name, start: _this13.$t('ongoing'), emissionFactor: _this13.emissionLibraryExample[emissionKey.name] };
            });
            this.emissionLocationInfo = this.regionMap[this.emissionLibraryExample.region_id];
        },
        selectEmissionLibrary: function selectEmissionLibrary() {
            if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNull(this.editedItem.emissionSource)) {
                this.setExampleLibrary();
            }
            this.forceUpdate();
        },
        prevStep: function prevStep() {
            if (this.activeStep != 0) this.activeStep--;
        },
        isLastStep: function isLastStep() {
            return this.activeStep < this.steps.length - 1;
        },
        checkIfButtonDisabled: function checkIfButtonDisabled() {
            if (this.activeStep == 0) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.scopeGroups, function (o) {
                    return o.isSelected == true;
                }));
            } else {
                return this.isValid(this.activeStep);
            }
        },
        isValid: function isValid(step) {
            if (this.steps[step].stepTitle == 'defineSources') {
                this.errors[step].sourceName = !this.editedItem.name;
                this.errors[step].sourceType = !this.editedItem.sourceType;
                this.errors[step].unit = !this.editedItem.unit;
                //this.errors[step].validFrom = !this.editedItem.validFrom;
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups)) {
                    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.remove(this.errors[step], 'sourceTypeGroup');
                } else {
                    this.errors[step].sourceTypeGroup = !this.editedItem.sourceTypeGroup;
                }

                var validation = true;
                for (var key in this.errors[step]) {
                    validation &= !this.errors[step][key];
                }
                return validation == 0 ? true : false;
            } else if (this.steps[step].stepTitle == 'assignLocations') {
                this.errors[step].locations = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEmpty(this.editedItem.locations);
                return this.errors[step].locations;
            } else if (this.steps[step].stepTitle == 'emissionFactors') {
                //return _.isEmpty(_.filter(this.editedItem.emissionFactors, o => o != ''));
                return false;
            } else {
                return false;
            }
        },
        closeUpdateConfirmationDialogs: function closeUpdateConfirmationDialogs() {
            this.duplicateSourceModal = false;
            this.convertUnitsModal = false;
            this.inactivateSourceModal = false;
        },
        openSourceDeleteModal: function openSourceDeleteModal() {
            this.$refs.confirmSourceDelete.show();
        },
        closeDeleteModal: function closeDeleteModal() {
            this.$refs.confirmSourceDelete.hide();
        },
        prepareData: function prepareData(data) {
            var _this14 = this;

            this.unitMap = {};

            this.unitList = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(data, 'units'), function (nData) {
                _this14.unitMap[nData.id] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(nData, 'name');
                _this14.unitTypeMap.name[_this14.unitMap[nData.id]] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(nData, 'cols'), 'type');
                _this14.unitTypeMap.id[nData.id] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(nData, 'cols'), 'type');
                return {
                    id: nData.id,
                    label: _this14.unitMap[nData.id]
                };
            });

            this.scopeGroups = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(data.scopeGroups, function (scopeGroup) {
                var sourceGroupRel = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(scopeGroup.sourceTypeMap, function (o) {
                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(o, 'rel_type') == 'source-group';
                });
                var sources = {};
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.groupBy(sourceGroupRel, 'tag_2'), function (rel, relId) {
                    sources[relId] = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(rel, 'rel_id');
                });
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, scopeGroup, { isSelected: false, sourceTypes: sources });
            });

            this.sourceTypes = data.sourceTypes;
            this.emissionTypes = data.emissionTypes;
            this.emissionLocationInfo = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.first(this.regionMap);
        },
        init: function init() {
            var _this15 = this;

            this.isLoaded = false;
            this.$Progress.start();

            return this.axios.get('/sources').then(function (_ref2) {
                var data = _ref2.data;

                _this15.prepareData(data);
                _this15.$Progress.finish();
                _this15.isLoaded = true;
            });
        }
    },
    created: function created() {
        if (this.isMaster(this.$store.state.user.customerId)) {
            this.rawSteps.push({
                stepTitle: 'sourceDesign',
                editStepTitle: 'editSourceDesign',
                stepSubTitle: 'sourceDesign',
                editStepSubTitle: 'editSourceDesign'
            });
        }

        this.steps = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.clone(this.rawSteps);
    }
});

/***/ }),

/***/ "Oret":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OsVA":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","tableSiteName":"Lokasyon Adı","tableDataHealth":"Veri Sağlığı"},"en":{"sitesTitle":"Sites","tableSiteName":"Site","tableDataHealth":"Data Health"}}')
}


/***/ }),

/***/ "Ov54":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"errorText":"Sayfa bulunamadı"},"en":{"errorText":"Page is not found"}}')
}


/***/ }),

/***/ "P/1l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('form',{staticClass:"form-signup",on:{"submit":function($event){$event.preventDefault();return _vm.signup()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstname),expression:"firstname"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('firstnamePlaceholder'),"required":"","autofocus":""},domProps:{"value":(_vm.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstname=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastname),expression:"lastname"}],staticClass:"form-control",staticStyle:{"margin-top":"10px"},attrs:{"type":"text","placeholder":_vm.$t('lastnamePlaceholder'),"required":""},domProps:{"value":(_vm.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastname=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",staticStyle:{"margin-top":"10px"},attrs:{"type":"email","placeholder":_vm.$t('emailPlaceholder'),"required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",staticStyle:{"margin-top":"10px"},attrs:{"type":"password","placeholder":_vm.$t('passwordPlaceholder'),"required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('signupButton')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P3rI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticStyle:{"position":"fixed","top":"0","bottom":"0","right":"0","left":"0","overflow":"auto"},attrs:{"md":"12"}},[(!_vm.hideCarousel)?_c('b-col',{staticClass:"carousel-side d-flex justify-content-center align-items-center hidden-md-down",staticStyle:{"background-color":"#4129A8"},attrs:{"md":"5"}},[_c('carousel')],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"form-side d-flex",staticStyle:{"background-color":"#fff"},attrs:{"md":_vm.hideCarousel ? 12 : 7}},[_c('b-card',{staticStyle:{"width":"25%","min-width":"30rem","margin":"auto","border":"none","color":"#022B49"},attrs:{"img-src":_vm.showLogo ? _vm.logoImg : '',"img-alt":"Image","img-top":""}},[_c('b-row',{staticStyle:{"position":"relative"}},[_c('b-col',[_c('b-alert',{staticClass:"alert-danger-cl",staticStyle:{"width":"100%","position":"relative","right":"0","left":"0","margin":"auto","margin-top":"10% z-index:3"},attrs:{"show":_vm.showInvalidUserAlert,"dismissible":"","variant":"danger"}},[_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(_vm.$t('alert')))])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3",staticStyle:{"font-weight":"bold","margin-bottom":"3px","font-size":"1.75em"}},[_c('b-col',[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('forgotPassword')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-3",staticStyle:{"font-weight":"bold","margin-bottom":"10px","font-size":"0.75em","color":"#8E8E8E"}},[_c('b-col',[_vm._v("\n                    "+_vm._s(_vm.$t('explanation'))+"\n                ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3 mt-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("PkBM")}})]),_vm._v(" "),_c('b-form-input',{staticClass:"input-field",class:['input-field', {'is-invalid': _vm.emailError}],attrs:{"placeholder":_vm.$t('emailPlaceholder'),"type":"text","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailError),expression:"emailError"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('emptyEmail')))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('b-button',{staticClass:"w-50 light-green",on:{"click":function($event){return _vm.forgotPassword(_vm.email)}}},[_vm._v(_vm._s(_vm.$t('sendInstructions')))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('span',[_c('router-link',{staticClass:"link",attrs:{"to":{name: 'login'}}},[_vm._v(_vm._s(_vm.$t('backToLogin')))])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PJHr":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"invite":"Davet Et","general":"Genel","sites":"Lokasyonlar","globalGoals":"Global Hedefler","emissionFactors":"Emisyon Faktörleri","unitPrices":"Birim Fiyatlar","batchDataEntry":"Toplu Veri Girişi","permissions":"Kullanıcı İzinleri","users":"Kullanıcılar","sourceManagement":"Kaynak Yönetimi","tags":"Etiket Yönetimi","locationsManagement":"Lokasyon ve Sektör Yönetimi","emissionLibraryManagement":"Emisyon Kütüphanesi Yönetimi"},"en":{"invite":"Invite","general":"General","sites":"Sites","globalGoals":"Global Targets","emissionFactors":"Emission Factors","unitPrices":"Unit Prices","batchDataEntry":"Batch Data Entry","permissions":"Permissions","users":"Users","sourceManagement":"Source Management","tags":"Tag Management","locationsManagement":"Location & Sector Management","emissionLibraryManagement":"Emission Library Management"}}')
}


/***/ }),

/***/ "PMx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Master',
    props: {
        showScrollbar: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            activeTagIndex: 0,
            tags: [{
                name: this.$t('emissionLibraryManagement'),
                path: 'emission-library',
                active: false
            }, {
                name: this.$t('locationsManagement'),
                path: 'locations',
                active: false
            }, {
                name: this.$t('tags'),
                path: 'tags',
                active: false
            }]
        };
    },


    methods: {
        routeTo: function routeTo(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;

            this.$router.push({ name: tag.path });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        }
    },
    created: function created() {
        var _this = this;

        this.activeTagIndex = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.indexOf(this.tags, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.tags, function (o) {
            return o.path == _this.route.name;
        }));
        this.activeTagIndex = this.activeTagIndex < 0 ? 0 : this.activeTagIndex;
        this.routeTo(this.tags[this.activeTagIndex]);
    }
});

/***/ }),

/***/ "POGD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PPPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_RegionMultiSelect__ = __webpack_require__("NyJr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FormSummary',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_7__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_6__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_5__components_YearSelect__["a" /* default */] },
    data: function data() {
        return {
            isLoaded: false,
            tempSites: [],
            formSites: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            searchInput: ''
        };
    },

    methods: {
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToFormDetail: function routeToFormDetail(site) {
            this.$store.state.siteId = site ? site.id : null;
            var routeData = this.$router.resolve({
                name: 'site-forms',
                params: { site_id: site.id },
                query: { year: this.year }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'site-forms',
                    params: { site_id: site.id },
                    query: { year: this.year }
                });
            }
            /* this.$router.push({
                name: 'site-forms',
                params: {site_id: site.id},
                query: {year: this.year}
            }); */
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeTo: function routeTo() {
            this.$router.push({
                name: 'forms',
                query: { year: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureForms: function configureForms(forms) {
            var _this = this;

            this.formSites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(forms, function (formSite) {
                var foundItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.tempSites, { id: formSite.id });
                if (foundItem) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, formSite, {
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name
                    });
                } else {
                    return formSite;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
        },
        fetchFormSites: function fetchFormSites() {
            var _this2 = this;

            return this.axios.get('/form-count?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({ year: this.year })).then(function (_ref) {
                var data = _ref.data;

                _this2.formSites = data;
                return data;
            });
        },
        init: function init() {
            var _this3 = this;

            this.isLoaded = false;
            if (this.route.query.year) {
                this.$store.state.year = this.route.query.year;
            }
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.fetchFormSites().then(this.configureForms).then(function () {
                _this3.isLoaded = true;
            });
        },
        onYearChange: function onYearChange(newYear) {
            this.$store.state.year = newYear;
            return this.routeTo().then(this.init);
        }
    },
    computed: {
        filteredForms: function filteredForms() {
            var _this4 = this;

            if (this.searchInput.length <= 3) {
                var filteredSites = this.formSites.filter(function (item) {
                    var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this4.sites, { id: item.id });
                    return _this4.textStartsWith(item.code + item.name, _this4.searchInput) && _this4.isRegionFound(_this4.selectedRegionId, item.siteGroupId) && (!_this4.selectedTypeId || found.typeId === _this4.selectedTypeId);
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            }
            return this.formSites.filter(function (item) {
                var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this4.sites, { id: item.id });
                return _this4.isSearchTextFound(item.code + item.name, _this4.searchInput) && _this4.isRegionFound(_this4.selectedRegionId, item.siteGroupId) && (!_this4.selectedTypeId || found.typeId === _this4.selectedTypeId);
            });
        }
    },
    created: function created() {
        this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
        this.tempSites = this.sites;
        this.init();
    }
});

/***/ }),

/***/ "PZ+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("695n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c13a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("c4GZ");
function injectStyle (ssrContext) {
  __webpack_require__("Ihp2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7c13a06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7c13a06_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("r/kn")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pbpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swapping-squares-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:("square-" + (index + 1)),style:(ss)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PcT9":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","tableSiteName":"Lokasyon Adı","tableDataHealth":"Veri Sağlığı","sitesWithoutAgents":"Sürdürülebilirlik Temsilcisi Olmayanlar"},"en":{"sitesTitle":"Sites","tableSiteName":"Site","tableDataHealth":"Data Health","sitesWithoutAgents":"Sites without agents"}}')
}


/***/ }),

/***/ "Phlw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"HEDEFLER","locations":"Lokasyonlar","dataTypeColumn":"Veri Tipi","startYearColumn":"Baz Yıl","endYearColumn":"Hedef Yıl","goalTypeColumn":"Hedef Tipi","goalRatioColumn":"Hedeflenen (%)","currentSituation":"Mevcut Durumu Koruma","decrease":"Azaltma","raise":"Arttırma","AllLocations":"Tüm Lokasyonlar","more":"daha","and":" ve ","longProcessNotification":"Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir."},"en":{"title":"GOALS","locations":"Locations","dataTypeColumn":"Data Type","startYearColumn":"Base Year","endYearColumn":"Target Year","goalTypeColumn":"Goal Type","goalRatioColumn":"Targeted (%)","currentSituation":"No Change","decrease":"Decrease","raise":"Raise","AllLocations":"All Locations","more":"more","and":" and ","longProcessNotification":"This process may take some time, please wait. When the process is complete, the table will be refreshed automatically."}}')
}


/***/ }),

/***/ "PkBM":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC4wOTMiIGhlaWdodD0iMTUuODAyIiB2aWV3Qm94PSIwIDAgMjAuMDkzIDE1LjgwMiI+CiAgPGcgaWQ9Im1haWwtb3V0bGluZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuNjI1IC02KSI+CiAgICA8cGF0aCBpZD0iUGF0aF85NTMiIGRhdGEtbmFtZT0iUGF0aCA5NTMiIGQ9Ik01LjE2Myw2Ljc1SDIwLjE4YTEuNzg4LDEuNzg4LDAsMCwxLDEuNzg3LDEuNzg4VjE5LjI2NWExLjc4OCwxLjc4OCwwLDAsMS0xLjc4NywxLjc4N0g1LjE2M2ExLjc4OCwxLjc4OCwwLDAsMS0xLjc4OC0xLjc4N1Y4LjUzOEExLjc4OCwxLjc4OCwwLDAsMSw1LjE2Myw2Ljc1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85NTQiIGRhdGEtbmFtZT0iUGF0aCA5NTQiIGQ9Ik03Ljg3NSwxMS4yNWw2LjQzNiw1LjAwNiw2LjQzNi01LjAwNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNjQgLTEuNjQpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3YzdjN2MiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "Prus":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"summary":"Özet","data":"Veri","report":"Analiz","goals":"Hedefler","documents":"Dokümanlar","audit":"Denetim","My Account":"Hesabım","Admin Panel":"Admin Paneli","Settings":"Ayarlar","Library":"Kütüphane","contact us":"Bize ulaşın","logout":"Çıkış"},"en":{"summary":"Summary","data":"Data","report":"Analysis","goals":"Targets","documents":"Documents","audit":"Audits","My Account":"My Account","Admin Panel":"Admin Panel","Settings":"Settings","Library":"Library","contact us":"Contact us","logout":"Log out"}}')
}


/***/ }),

/***/ "Q239":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TicketDetailCard__ = __webpack_require__("Hyzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DofDetail',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_2__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_1__components_Upload__["a" /* default */], TicketDetailCard: __WEBPACK_IMPORTED_MODULE_3__components_TicketDetailCard__["a" /* default */] },
    data: function data() {
        return {
            ticket: null,
            isIndexedActions: false,
            actions: [false, false, false, false, false, false, false, false, false, false, false, false],
            ticketId: null,
            ticketType: null,
            selectedSiteId: null,
            isErasable: null,
            extendedDate: new Date()
        };
    },

    methods: {
        firstExtendedDate: function firstExtendedDate(ticket) {
            var extendedDates = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            var selectedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1] ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(extendedDates[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1]).format('YYYY-MM-DD') : '-';
            return selectedDate;
        },
        deletePost: function deletePost(event, postId) {
            var _this = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this.axios.delete('/audits/post/' + postId + '/').then(function () {
                    _this.ticket.posts = _this.ticket.posts.filter(function (post) {
                        return post.id !== postId;
                    });
                    if (_this.ticket.posts.length) {
                        _this.ticket.posts[_this.ticket.posts.length - 1].isErasable = true;
                    } else {
                        _this.ticket.isErasable = true;
                    }
                }).catch(function () {
                    _this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
            });
        },
        deleteItem: function deleteItem(event) {
            var _this2 = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this2.axios.delete('/audits/' + _this2.route.params.ticket_id).then(function () {
                    _this2.$router.push({
                        name: 'ticket-list',
                        params: { site_id: _this2.route.params.site_id },
                        query: { start_date: _this2.year }
                    });
                }).catch(function () {
                    _this2.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
            });
        },
        closePost: function closePost(event) {
            var _this3 = this;

            var text = 'Madde kapatılacaktır, emin misiniz?';
            this.showWarnModal(event.target, text);
            this.$eventHub.$once(this.$store.state.modal.eventId, function () {
                _this3.axios.put('/' + _this3.selectedSiteId + '/audits/' + _this3.ticketId + '/close').then(function () {
                    _this3.ticket.state = 1;
                });
            });
        },
        showUpdateTicketModal: function showUpdateTicketModal(target) {
            var _this4 = this;

            if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.ticket, 'ticketType') == 'Action') {
                if (this.isIndexedActions) {
                    this.ticket.actionCheckList = this.actions;
                }
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticketId,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(function () {
                    _this4.$root.$emit('bv::show::modal', 'createAction', target);
                    _this4.$eventHub.$once(_this4.$store.state.modal.eventId, function (updatedTicket) {
                        for (var key in updatedTicket) {
                            _this4.ticket[key] = updatedTicket[key];
                        }
                        _this4.retrieveTicket();
                    });
                });
            } else {
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticketId,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(function () {
                    _this4.$root.$emit('bv::show::modal', 'createTicket', target);
                    _this4.$eventHub.$once(_this4.$store.state.modal.eventId, function (updatedTicket) {
                        for (var key in updatedTicket) {
                            _this4.ticket[key] = updatedTicket[key];
                        }
                        _this4.retrieveTicket();
                    });
                });
            }
        },
        showUpdatePostModal: function showUpdatePostModal(target, post) {
            var _this5 = this;

            var replyType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'updatePost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    post: post,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(function () {
                _this5.$root.$emit('bv::show::modal', 'createPost', target);
                _this5.$eventHub.$once(_this5.$store.state.modal.eventId, function (createdPost) {
                    for (var key in post) {
                        post[key] = createdPost[key];
                    }
                });
            });
        },
        handleRemoving: function handleRemoving(event, fileId) {
            this.ticket.documents = this.ticket.documents.filter(function (document) {
                return document.id !== fileId;
            });
        },
        retrieveTicket: function retrieveTicket() {
            var _this6 = this;

            return this.axios.get('/' + this.selectedSiteId + '/audits/' + this.ticketId).then(function (_ref) {
                var data = _ref.data;

                _this6.ticket = data;
                var actions = '';
                try {
                    __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(JSON.parse(_this6.ticket.scope), function (actionCheck, actionIndex) {
                        if (actionCheck) {
                            actions += '→ ' + _this6.$t(_this6.$store.state.nonconformances[actionIndex - 1].action) + '\n';
                        }
                    });
                    _this6.isIndexedActions = true;
                    _this6.actions = _this6.ticket.scope;
                    _this6.ticket.scope = actions;
                } catch (error) {
                    console.error(error);
                }
                _this6.ticketType = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'ticketType');
            });
        },
        retrieveTicketStatus: function retrieveTicketStatus(state) {
            var status = state == 0 ? this.$t('openTicket') : this.$t('closedTicket');
            return status;
        },
        showReplyModal: function showReplyModal(target, replyType) {
            var _this7 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'createPost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(function () {
                _this7.$root.$emit('bv::show::modal', 'createPost', target);
                _this7.$eventHub.$once(_this7.$store.state.modal.eventId, function (createdPost) {
                    _this7.ticket.posts.push(createdPost);
                    _this7.ticket.isErasable = false;
                });
            });
        },
        ticketTypeOptions: function ticketTypeOptions(type) {
            var returnType = null;
            if (this.gbId(this.$store.state.user.customerId)) {
                type === 'Audit' ? returnType = 'AuditGaranti' : returnType = 'ActionGaranti';
                return returnType;
            };
            if (!this.gbId(this.$store.state.user.customerId)) {
                return type;
            };
        }
    },
    computed: {
        selectedSite: function selectedSite() {
            return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.sites, { id: this.selectedSiteId });
        },
        nonconformanceArticleText: function nonconformanceArticleText() {
            if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.ticket, 'ticketType') == 'Audit') {
                return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.$store.state.nonconformances, { id: this.ticket.nonconformanceId }).article;
            }
        },
        nonconformanceActionText: function nonconformanceActionText() {
            if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(this.ticket, 'ticketType') == 'Audit') {
                if (this.ticket.nonconformanceId !== 13) {
                    return __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.$store.state.nonconformances, {
                        id: this.ticket.nonconformanceId
                    }).action;
                } else {
                    return this.ticket.customNonconformance;
                }
            }
        },
        isAdmin: function isAdmin() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        isAgent: function isAgent() {
            return this.$store.state.user.permissions.canReplyToAudits;
        }
    },
    created: function created() {
        this.ticketId = this.route.params.ticket_id ? Number(this.route.params.ticket_id) : this.ticketId;
        this.selectedSiteId = this.route.params.site_id ? Number(this.route.params.site_id) : this.selectedSiteId;
        this.retrieveTicket();
    }
});

/***/ }),

/***/ "Q8WP":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"actionTitle":"Alınacak Aksiyon","files":"Dosyalar","negativeControl":"Olumsuz Kontrol","itemType":"Madde türü","openTicket":"Açık","closedTicket":"Kapalı","Audit":"Düzeltici Faaliyet","AuditGaranti":"Uygunsuzluk Maddesi","Action":"Önleyici Faaliyet","ActionGaranti":"Aksiyon Planı"},"en":{"actionTitle":"Action","files":"Files","negativeControl":"Negative Control","itemType":"Type","openTicket":"Open","closedTicket":"Closed","Audit":"Corrective Action","Action":"Preventive Action","AuditGaranti":"Corrective Action","ActionGaranti":"Action plan"}}')
}


/***/ }),

/***/ "QFoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CustomForm__ = __webpack_require__("g0qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CustomTable__ = __webpack_require__("tpSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CustomFormTable__ = __webpack_require__("+/Rg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__("l9mu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FormDetail',
    data: function data() {
        return {
            isLoaded: false,
            formSchema: [],
            tableCols: [],
            tableData: [],
            formData: {},
            isErasable: null,
            name: null
        };
    },

    components: {
        CustomTable: __WEBPACK_IMPORTED_MODULE_1__components_CustomTable__["a" /* default */],
        CustomForm: __WEBPACK_IMPORTED_MODULE_0__components_CustomForm__["a" /* default */],
        CustomFormTable: __WEBPACK_IMPORTED_MODULE_2__components_CustomFormTable__["a" /* default */]
    },
    methods: {
        exportPDF: function exportPDF() {
            /*
                if we use "content" as element id, pdf and delete button will not be seen if we use
                "card" id, buttons will be seen.
            */
            var w = document.getElementById('content').offsetWidth;
            var h = document.getElementById('content').offsetHeight;
            var site = this.formData.site;
            var no = this.formData.no;
            __WEBPACK_IMPORTED_MODULE_4_html2canvas___default()(document.getElementById('content'), {
                dpi: 300,
                scale: 3
            }).then(function (canvas) {
                var img = canvas.toDataURL('image/jpeg', 1);
                var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('L', 'pt', [w, h]);
                doc.addImage(img, 'JPEG', 0, 0, w, h);
                doc.save(site + ' - ' + no);
            });
        },
        deleteItem: function deleteItem(event) {
            var _this = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this.axios.delete(_this.route.params.site_id + '/form/' + _this.route.params.form_id).then(function () {
                    _this.$router.push({
                        name: 'site-forms',
                        params: { site_id: _this.route.params.site_id },
                        query: { year: _this.year }
                    });
                }).catch(function () {
                    _this.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
            });
        },
        fetchDesign: function fetchDesign() {
            var _this2 = this;

            return this.axios.get('/' + this.route.params.site_id + '/form/' + this.route.params.form_id).then(function (_ref) {
                var data = _ref.data;

                _this2.formSchema = data.formCols;
                _this2.formData = data.formData;
                if (_this2.formData.date) {
                    _this2.formData.date = _this2.formData.date.split('T')[0];
                }
                _this2.tableCols = data.tableCols;
                _this2.tableData = data.tableData;
                _this2.name = data.tableName;
                _this2.isErasable = data.isErasable;
                return data;
            });
        },
        init: function init() {
            var _this3 = this;

            this.isLoaded = false;
            this.fetchDesign().then(function () {
                _this3.isLoaded = true;
            });
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "QI4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QRRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-building-square-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.squaresStyles),function(ss,index){return _c('div',{key:index,staticClass:"square",class:{'clear': index && index % 3 === 0},style:(ss)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QTOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AdminGoal',
    data: function data() {
        return {
            selectedSite: null,
            canEditGoals: this.$store.state.user.permissions.canCreateGlobalGoals,
            isLoaded: false, // Toggles page loading
            goals: [],
            filteredGoals: [],
            err: null,
            rawItems: [], // Original goal object array
            units: [],
            dataTypes: [1, 2],
            tempItem: {}, // Temporary object used for inserts
            yearSelection: '' + new Date().getFullYear(),
            goalTypes: [{
                value: 0,
                text: this.$t('currentSituation')
            }, {
                value: -1,
                text: this.$t('decrease')
            }, {
                value: 1,
                text: this.$t('raise')
            }],
            yearChoices: [{
                value: '' + (new Date().getFullYear() - 5),
                text: '' + (new Date().getFullYear() - 5)
            }, {
                value: '' + (new Date().getFullYear() - 4),
                text: '' + (new Date().getFullYear() - 4)
            }, {
                value: '' + (new Date().getFullYear() - 3),
                text: '' + (new Date().getFullYear() - 3)
            }, {
                value: '' + (new Date().getFullYear() - 2),
                text: '' + (new Date().getFullYear() - 2)
            }, {
                value: '' + (new Date().getFullYear() - 1),
                text: '' + (new Date().getFullYear() - 1)
            }, {
                value: '' + new Date().getFullYear(),
                text: '' + new Date().getFullYear()
            }, {
                value: '' + (new Date().getFullYear() + 1),
                text: '' + (new Date().getFullYear() + 1)
            }, {
                value: '' + (new Date().getFullYear() + 2),
                text: '' + (new Date().getFullYear() + 2)
            }, {
                value: '' + (new Date().getFullYear() + 3),
                text: '' + (new Date().getFullYear() + 3)
            }, {
                value: '' + (new Date().getFullYear() + 4),
                text: '' + (new Date().getFullYear() + 4)
            }, {
                value: '' + (new Date().getFullYear() + 5),
                text: '' + (new Date().getFullYear() + 5)
            }],
            insertMode: false,
            inProgress: false,
            lastColumnWidth: '140px'
        };
    },


    methods: {
        directionValueToText: function directionValueToText(val) {
            if (val === 0) {
                return this.$t('currentSituation');
            } else if (val === -1) {
                return this.$t('decrease');
            } else {
                return this.$t('raise');
            }
        },
        getTopNLocation: function getTopNLocation(goal) {
            var _this = this;

            var allIds = goal.goalSites.editedValue;
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(allIds, 'All')) {
                return this.$t('AllLocations');
            } else {
                var regionIds = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(allIds, function (o) {
                    return o.split('-')[0] == 'region';
                });
                var cityIds = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(allIds, function (o) {
                    return o.split('-')[0] == 'city';
                });
                var siteIds = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.difference(allIds, regionIds);
                siteIds = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.difference(siteIds, cityIds);
                var locationNames = [];

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(regionIds.slice(0, 3), function (region) {
                    var regionId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(region.split('-')[1]);
                    locationNames.push(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.siteGroups, function (o) {
                        return o.id == regionId;
                    })).name);
                });
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(cityIds.slice(0, 3 - locationNames.length), function (city) {
                    var cityId = city.split('-')[2];
                    locationNames.push(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.$store.state.cities, function (o) {
                        return o.code == cityId;
                    })).name);
                });
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(siteIds.slice(0, 3 - locationNames.length), function (site) {
                    var siteId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(site.split('-')[1]);
                    locationNames.push(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.sites, function (o) {
                        return o.id == siteId;
                    })).originalName);
                });

                if (siteIds.length + regionIds.length > 3) {
                    return locationNames.join(", ") + this.$t('and') + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toString(regionIds.length + siteIds.length - 3) + " " + this.$t('more');
                } else {
                    return locationNames.join(", ");
                }
            }
        },
        allDataTypes: function allDataTypes() {
            var _this2 = this;

            var filteredOptions = [];
            this.dataTypes.forEach(function (dataType) {
                filteredOptions.push({
                    value: dataType.id,
                    text: _this2.$t(dataType.name) + (' (' + _this2.$t(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.$store.state.units, { id: dataType.unit_id_1 }), 'name') || '') + ')')
                });
            });
            return filteredOptions;
        },


        // Configures the goal object when data type is changed
        configureItemOnDataTypeChange: function configureItemOnDataTypeChange(val, item, isTempItem) {
            if (isTempItem) {
                this.bindTempItemToView();
            }
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        reflectProcess: function reflectProcess(data) {
            var processType = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'process');
            data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.omit(data, 'process');

            if (processType == 'update') {
                var rawItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.rawItems, { id: data.id });
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(rawItem, data);
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            } else if (processType == 'create') {
                this.rawItems.push(data);
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            } else if (processType == 'delete') {
                this.rawItems = this.rawItems.filter(function (item) {
                    return item.id !== data.id;
                });
                this.bindItems(this.rawItems);
                this.listSiteGoals();
            } else if (processType == 'reset') {
                this.bindItems(this.rawItems);
            } else {
                this.listSiteGoals();
            }
        },
        insertRow: function insertRow(target) {
            var _this3 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'createGoal',
                payload: {
                    title: "createGlobalGoal",
                    selectedGoal: {},
                    allSites: this.sitesWithGroups,
                    allDataTypes: this.allDataTypes()
                }
            });
            this.$nextTick(function () {
                _this3.$root.$emit('bv::show::modal', 'createGoal', target);
                _this3.$eventHub.$once(_this3.$store.state.modal.eventId, function (process) {
                    return _this3.reflectProcess(process);
                });
            });
        },
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        makeRowEditable: function makeRowEditable(target, goalId) {
            var _this4 = this;

            var goal = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.goals, { id: goalId });

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'updateGoal',
                payload: {
                    title: "updateGlobalGoal",
                    selectedGoal: goal,
                    allSites: this.sitesWithGroups,
                    allDataTypes: this.allDataTypes()
                }
            });
            this.$nextTick(function () {
                _this4.$root.$emit('bv::show::modal', 'createGoal', target);
                _this4.$eventHub.$once(_this4.$store.state.modal.eventId, function (process) {
                    return _this4.reflectProcess(process);
                });
            });
        },
        resetWarning: function resetWarning(item, key) {
            item[key].classes['is-invalid'] = false;
            item[key].hasWarn = false;
        },
        bindTempItemToView: function bindTempItemToView() {
            var tempItem = {
                startYear: { editedValue: 0 },
                endYear: { editedValue: 0 },
                direction: { editedValue: 0 },
                dataTypeId: { editedValue: null },
                valueR: { editedValue: '0' },
                unitName: ''
            };

            for (var key in tempItem) {
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(tempItem[key]) === 'object') {
                    tempItem[key].required = true;
                    tempItem[key].hasWarn = false; // toggles warning message
                    tempItem[key].lockR = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Ratio field is locked for calculation.
                    tempItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    tempItem[key].warnMessage = this.$t('required');
                }
            }

            this.tempItem = tempItem;
        },


        // Prepare a goal object to use in dom
        prepareItem: function prepareItem(item) {
            var configuredItem = {};
            var startDateInit;
            var endDateInit;
            startDateInit = item.start_date != null ? item.start_date.substr(0, item.start_date.indexOf('-')) : '-';
            endDateInit = item.end_date != null ? item.end_date.substr(0, item.end_date.indexOf('-')) : '-';

            configuredItem.editMode = false;
            configuredItem.lockR = false;

            configuredItem.id = item.id;
            configuredItem.parentSiteId = item.site_id;

            var siteKeys = this.createGroupedSitesKeys(item.sites);
            configuredItem.goalSites = {
                value: item.sites,
                editedValue: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(siteKeys)
            };
            configuredItem.direction = { value: item.direction, editedValue: item.direction };

            var _$find = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.dataTypes, { id: item.data_type_id }),
                name = _$find.name,
                unit_id_1 = _$find.unit_id_1;

            configuredItem.dataTypeId = {
                value: item.data_type_id,
                editedValue: item.data_type_id,
                name: name
            };
            configuredItem.unit = {
                id: unit_id_1,
                name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.$store.state.units, { id: unit_id_1 }), 'name')
            };
            var valueR = item.value_r ? item.value_r : '0';
            configuredItem.valueR = {
                value: __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(valueR, 'float', this.locale),
                editedValue: __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(valueR, 'float', this.locale)
            };
            configuredItem.startYear = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endYear = {
                value: endDateInit,
                editedValue: endDateInit
            };

            for (var key in configuredItem) {
                // If a field editable it has to includes controller fields
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(configuredItem[key]) === 'object' && configuredItem[key].hasOwnProperty('value')) {
                    configuredItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    configuredItem[key].hasWarn = false;
                    configuredItem[key].warnMessage = this.$t('required');
                }
            }

            return configuredItem;
        },


        // Bind goals object array to use in dom
        bindItems: function bindItems(goals) {
            var _this5 = this;

            this.goals = goals.filter(function (goal) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this5.dataTypes, { id: goal.data_type_id });
            }).map(this.prepareItem);
            return this.calculateLastColumnWidth();
        },
        listSiteGoals: function listSiteGoals() {
            var _this6 = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/globalGoals/').then(function (_ref) {
                var data = _ref.data;

                _this6.units = data.unit;
                _this6.rawItems = data;
                _this6.bindItems(_this6.rawItems);
                _this6.isLoaded = true;
                return _this6.$Progress.finish();
            });
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this7 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('goal-last-column');
                if (element) {
                    _this7.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        setFilteredGoals: function setFilteredGoals() {
            var _this8 = this;

            this.filteredGoals = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.goals, function (o) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(o.endYear.editedValue) >= _this8.yearSelection && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(o.startYear.editedValue) <= _this8.yearSelection;
            });
        },
        init: function init() {
            // @TODO: both for customer_id = 1 and 3 , we used hardcoded site id
            // in order to add global goal. This should be fixed by writing a backend service that will be called at init and will send main site of logged in customer.
            this.selectedSite = this.$store.state.user.customerId == 3 ? 1883 : this.gbId(this.$store.state.user.customerId) ? 1882 : null;
            this.dataTypes = this.$store.state.dataTypes;
            this.listSiteGoals();
        }
    },
    watch: {
        goals: function goals() {
            this.setFilteredGoals();
        },
        yearSelection: function yearSelection() {
            this.setFilteredGoals();
        }
    },

    created: function created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "QwfQ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"tagManagement":"Etiket Yönetimi","couldBeHazardous":"Bu kapsam grubuna sahip veri türleri tehlikeli olarak ayarlanabilir","code":"Kod","displayName":"Görünen Ad","description":"Açıklama","units":"Birimler","scope":"Scope","top":"Top","sourceType":"Kaynak Tipi","sourceTypes":"Kaynak Tipleri","sourceTypeGroup":"Kaynak Tipi Grubu","sourceTypeGroups":"Kaynak Tipi Grubu (Kullanım amacı)","scopeGroup":"Scope Grubu","allUnits":"Bütün Birimler","selectedUnits":"Seçili Birimler","searchUnit":"Birim Ara","allSourceTypes":"Bütün Kaynak Tipleri","selectedSourceTypes":"Seçili Kaynak Tipleri","searchSourceType":"Kaynak Tipi Ara","allSourceTypeGroups":"Bütün Kaynak Tipi Grupları","selectedSourceTypeGroups":"Seçili Kaynak Tipi Grupları","searchSourceTypeGroup":"Kaynak Tipi Grubu Ara","hazardous":"Tehlikeli","addUnitBtn":"Birim Ekle","addSourceTypeBtn":"Kaynak Tipi Ekle","addSourceTypeGroupBtn":"Kaynak Tipi Grubu Ekle","addScopeBtn":"Scope Ekle","deletion-warn":"Seçili hedefi kalıcı olarak silmek istediğinizden emin misiniz?","longProcessNotification":"Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.","targetInUse":"Seçili hedef bir veya daha fazla yerde kullanılmakta olduğu için silinemedi.","mass":"Ağırlık","volume":"Hacim","energy":"Enerji","othet":"Diğer","type":"Tür","base":"Kaynak","target":"Hedef","anchor":"Çarpan","exapmle":"Örnek","sourceTypeGroupHeader":"Kaynak Tipi Grubu Başlığı","scopeIcon":"Scope Grubu İkonu","tagsLoading":"Etiket Listesi Yükleniyor..."},"en":{"tagManagement":"Tag Management","couldBeHazardous":"Data types with this scope group can be set as hazardous","code":"Code","displayName":"Display Name","description":"Description","units":"Units","scope":"Scope","top":"Top","sourceType":"Source Type","sourceTypes":"Source Types","sourceTypeGroup":"Source Type Group","sourceTypeGroups":"Source Type Group (Usage For)","scopeGroup":"Scope Group","allUnits":"All Units","selectedUnits":"Selected Units","searchUnit":"Search Unit","allSourceTypes":"All Source Types","selectedSourceTypes":"Selected Source Types","searchSourceType":"Search Source Type","allSourceTypeGroups":"All Source Type Groups","selectedSourceTypeGroups":"Selected Source Type Groups","searchSourceTypeGroup":"Search Source Type Group","hazardous":"Hazardous","addUnitBtn":"Add Unit","addSourceTypeBtn":"Add Source Type","addSourceTypeGroupBtn":"Add Source Type Group","addScopeBtn":"Add Scope","deletion-warn":"Are you sure you want to permanently delete the selected target?","longProcessNotification":"This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.","targetInUse":"The selected target could not be deleted because it is used in one or more places.","mass":"Mass","volume":"Volume","energy":"Energy","othet":"Other","type":"Type","base":"Base","target":"Target","anchor":"Anchor","exapmle":"Example","sourceTypeGroupHeader":"Source Type Group Header","scopeIcon":"Scope Group Icon","tagsLoading":"Loading Tag List..."}}')
}


/***/ }),

/***/ "R0+D":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0idXNlci1saW5lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4yNyIgaGVpZ2h0PSIyMi42ODMiIHZpZXdCb3g9IjAgMCAyMS4yNyAyMi42ODMiPgogIDxwYXRoIGlkPSJQYXRoXzk1MSIgZGF0YS1uYW1lPSJQYXRoIDk1MSIgZD0iTTE2LjcyNywxMy41ODVhNS41MjIsNS41MjIsMCwwLDAsNS43MjctNS4yOTNBNS41MjIsNS41MjIsMCwwLDAsMTYuNzI3LDMsNS41MjIsNS41MjIsMCwwLDAsMTEsOC4yOTMsNS41MjIsNS41MjIsMCwwLDAsMTYuNzI3LDEzLjU4NVptMC05LjA3M2EzLjk0NSwzLjk0NSwwLDAsMSw0LjA5LDMuNzgxLDMuOTQ1LDMuOTQ1LDAsMCwxLTQuMDksMy43ODEsMy45NDUsMy45NDUsMCwwLDEtNC4wOS0zLjc4MUEzLjk0NSwzLjk0NSwwLDAsMSwxNi43MjcsNC41MTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi4wOTIgLTMpIiBmaWxsPSIjN2M3YzdjIi8+CiAgPHBhdGggaWQ9IlBhdGhfOTUyIiBkYXRhLW5hbWU9IlBhdGggOTUyIiBkPSJNMjUuODM3LDIzLjA2MUExNC42MDgsMTQuNjA4LDAsMCwwLDE1LjYzOSwxOWExNC42MDgsMTQuNjA4LDAsMCwwLTEwLjIsNC4wNThBMS40NTIsMS40NTIsMCwwLDAsNSwyNC4xdjMuOTc3YTEuNTc4LDEuNTc4LDAsMCwwLDEuNjM2LDEuNTEyaDE4YTEuNTc4LDEuNTc4LDAsMCwwLDEuNjM2LTEuNTEyVjI0LjFhMS40NSwxLjQ1LDAsMCwwLS40MzQtMS4wMzZabS0xLjIsNS4wMTNoLTE4VjI0LjA4OWExMi45MTYsMTIuOTE2LDAsMCwxLDktMy41NzEsMTIuOTE2LDEyLjkxNiwwLDAsMSw5LDMuNTcxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUgLTYuOTAzKSIgZmlsbD0iIzdjN2M3YyIvPgo8L3N2Zz4K"

/***/ }),

/***/ "RE0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_BarChart__ = __webpack_require__("gxv5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ScopeComparison',
    components: { BarChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_BarChart__["a" /* default */] },
    props: {
        initialScopeReport: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        initialEmissions: {
            default: function _default() {
                return {
                    current: [],
                    past: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        }
    },
    data: function data() {
        var _this = this;

        return {
            barChartId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            barChartData: {
                labels: [],
                datasets: []
            },
            barChartOptions: {
                legend: {
                    position: 'bottom'
                },
                title: {
                    display: false,
                    fontColor: '#555',
                    text: this.$t('comparingScope'),
                    fontSize: 16,
                    padding: 15
                },
                barValueSpacing: 20,
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            min: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {
                                label += ': ';
                            }

                            return label + __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2)), 'float', _this.locale) + ' tCO2';
                        }
                    }
                }
            },
            scopeReport: {
                current: [],
                past: [],
                scopeTags: []
            },
            scopeTags: []
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareScopeReportDataSet: function prepareScopeReportDataSet(report) {
            var _this2 = this;

            // Resets barChartData
            this.barChartData = {
                labels: [],
                datasets: []
            };
            this.barChartData.labels = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.scopeTags.map(function (tag) {
                return tag.displayName;
            })));
            // Iterates for all report type ('current' and 'past')

            var _loop = function _loop(key) {
                var data = [];
                // Prepares scope 1, 2, 3 ...
                _this2.scopeTags.forEach(function (tag) {
                    data.push(report[key][tag.id]);
                });

                _this2.barChartData.datasets.push({
                    label: _this2.year - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(report).length - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(report).indexOf(key) + 1)), // Sets label display order
                    backgroundColor: _this2.colourPalette[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(report).indexOf(key) % 10],
                    data: data
                });
            };

            for (var key in report) {
                _loop(key);
            }
            // Rerenders piechart
            this.$eventHub.$emit(this.barChartId);
        },
        hasAnyValueToRenderBarChart: function hasAnyValueToRenderBarChart() {
            var total = 0;
            for (var keyScope in this.scopeReport) {
                for (var key in this.scopeReport[keyScope]) {
                    total += this.scopeReport[keyScope][key];
                }
            }
            return total;
        },
        processScopeReport: function processScopeReport(data) {
            this.scopeTags = data.scopeTags;
            this.scopeReport = {
                past: data.past,
                current: data.current
            };
            this.prepareScopeReportDataSet(this.scopeReport);
        }
    },
    watch: {
        initialScopeReport: function initialScopeReport(data) {
            this.processScopeReport(data);
        },
        selectedSiteId: function selectedSiteId() {
            this.processScopeReport(this.initialScopeReport);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processScopeReport(this.initialScopeReport);
        }
    },
    mounted: function mounted() {
        this.processScopeReport(this.initialScopeReport);
    }
});

/***/ }),

/***/ "RFaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isLoaded),expression:"!isLoaded"}],staticStyle:{"border":"none"},attrs:{"element-loading-text":_vm.$t('emissionLibraryLoading')}},[(!_vm.editMode)?_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em","justify-content":"space-between"}},[_c('b-col',{staticStyle:{"float":"left","text-align":"left"},attrs:{"cols":"8"}},[_c('h3',[_vm._v(_vm._s(this.$t('emissionLibraryManagement')))])]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[_c('b-button',{key:"addEmissionLibrary",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addEmissionLibrary')))])],1)],1),_vm._v(" "),_c('b-table',{attrs:{"hover":"","responsive":"","items":_vm.data,"fields":_vm.dataFields},scopedSlots:_vm._u([{key:"cell(edit)",fn:function(data){return [_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.openEditItemModal(data.item)}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})])]}}],null,false,2423147115)})],1):_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","justify-content":"space-between"}},[_c('b-col',{staticStyle:{"float":"left","text-align":"left"},attrs:{"cols":"8"}},[_c('h3',[_vm._v(_vm._s(this.$t('editEmissionLibrary')))]),_vm._v(" "),_c('h5',{staticStyle:{"color":"#808080"}},[_vm._v("  "+_vm._s(_vm.editedItem.name))])]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[_c('b-button',{key:"returnToEmissionLibrary",staticClass:"pb-2",attrs:{"variant":"warning","lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.returnToEmissionLibrary()}}},[_vm._v(_vm._s(_vm.$t('back')))]),_vm._v(" "),_c('b-button',{key:"saveEmissionLibrary",staticClass:"pb-2",attrs:{"variant":"primary","lg":"2","disabled":_vm.inProgress || _vm.partialContentSaved},on:{"click":function($event){return _vm.saveEmissionLibrary()}}},[_vm._v(" "+_vm._s(_vm.$t('save')))]),_vm._v(" "),(_vm.editAction=='edit')?_c('b-button',{key:"deleteEmissionLibrary",staticClass:"pb-2",attrs:{"variant":"danger","lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.deleteEmissionLibrary()}}},[_vm._v(" "+_vm._s(_vm.$t('delete')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"}},[_c('b-col',{staticClass:"mb-2",attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('emissionLibraryName'),"label-for":"library-name-input","label-class":"font-weight-bold mt-3 text-left"}},[_c('div',[_c('b-form-input',{attrs:{"id":"library-name-input","placeholder":_vm.$t('name')},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1)])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em","text-align":"left"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"label":_vm.$t('sourceRelations'),"label-for":"source-relations","label-class":"font-weight-bold text-left"}},[_c('treeselect',{attrs:{"id":"source-relations","multiple":true,"clearable":true,"searchable":true,"max-height":500,"limit":3,"rtl":false,"options":_vm.tagMap,"disabled":false,"placeholder":this.$t('selectTags')},model:{value:(_vm.easyAdd.tags),callback:function ($$v) {_vm.$set(_vm.easyAdd, "tags", $$v)},expression:"easyAdd.tags"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-checkbox',{model:{value:(_vm.easyAdd.generateForAllSectors),callback:function ($$v) {_vm.$set(_vm.easyAdd, "generateForAllSectors", $$v)},expression:"easyAdd.generateForAllSectors"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('allSectors'))+" ")])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-checkbox',{model:{value:(_vm.easyAdd.generateForAllCountries),callback:function ($$v) {_vm.$set(_vm.easyAdd, "generateForAllCountries", $$v)},expression:"easyAdd.generateForAllCountries"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('allCountries')))])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('country'),"label-for":"country-select","label-class":"font-weight-bold text-left"}},[_c('b-form-select',{attrs:{"id":"country-select","disabled":_vm.easyAdd.generateForAllCountries},model:{value:(_vm.easyAdd.country),callback:function ($$v) {_vm.$set(_vm.easyAdd, "country", $$v)},expression:"easyAdd.country"}},[_c('option',{key:"empty-country-1",domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('Any')))]),_vm._v(" "),_vm._l((_vm.countryMap),function(element){return _c('option',{key:((element.id) + "-" + (element.name)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])})],2)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"3"}},[_c('b-button',{key:"autoGenerateRows",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.autoGenerateRows()}}},[_c('i',{staticClass:"fas fa-plus-circle"}),_vm._v(" "+_vm._s(_vm.$t('autoGenerateRows')))])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"},attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"mb-3",staticStyle:{"float":"left"},attrs:{"cols":"2"}},[_c('b-form-checkbox',{model:{value:(_vm.errorFilter),callback:function ($$v) {_vm.errorFilter=$$v},expression:"errorFilter"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('showErrorsOnly')))])])],1),_vm._v(" "),_c('b-col',{staticClass:"mb-3",attrs:{"cols":"2"}},[_c('b-button',{key:"clearAllFilters",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.clearAllFilters()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('clearAllFilters')))])],1),_vm._v(" "),_c('b-col',{staticClass:"mb-3",attrs:{"cols":"2"}},[_c('b-button',{key:"addNewContent",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.addNewContent()}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('addNewContent')))])],1),_vm._v(" "),(_vm.editAction=='edit')?_c('b-col',{staticClass:"mb-3 border",attrs:{"cols":"6"}},[_c('el-select',{attrs:{"filterable":""},on:{"change":function($event){return _vm.updateData(_vm.contentRetriveFilters, {'sourceTypeGroupId':null,'sourceTypeId':null})}},model:{value:(_vm.contentRetriveFilters.scopeGroupId),callback:function ($$v) {_vm.$set(_vm.contentRetriveFilters, "scopeGroupId", $$v)},expression:"contentRetriveFilters.scopeGroupId"}},_vm._l((_vm.scopeGroupMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filterContentRetrive"),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('el-select',{attrs:{"filterable":""},on:{"change":function($event){return _vm.updateData(_vm.contentRetriveFilters, {'sourceTypeId':null})}},model:{value:(_vm.contentRetriveFilters.sourceTypeGroupId),callback:function ($$v) {_vm.$set(_vm.contentRetriveFilters, "sourceTypeGroupId", $$v)},expression:"contentRetriveFilters.sourceTypeGroupId"}},_vm._l((_vm.setFilterOptionsByParentSingle(_vm.contentRetriveFilters, _vm.sourceTypeGroupMap, ['scopeGroupId'])),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filterContentRetrive-" + (element.scopeGroupId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('el-select',{attrs:{"filterable":""},model:{value:(_vm.contentRetriveFilters.sourceTypeId),callback:function ($$v) {_vm.$set(_vm.contentRetriveFilters, "sourceTypeId", $$v)},expression:"contentRetriveFilters.sourceTypeId"}},_vm._l((_vm.setFilterOptionsByParentSingle(_vm.contentRetriveFilters, _vm.sourceTypeMap, ['scopeGroupId','sourceTypeGroupId'])),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filterContentRetrive-" + (element.scopeGroupId) + "-" + (element.sourceTypeGroupId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('b-button',{key:"getEmissionLibraryContentByFilter",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2","disabled":_vm.inProgress},on:{"click":function($event){return _vm.getEmissionLibraryContentByFilter()}}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "+_vm._s(_vm.$t('getContent')))])],1):_vm._e()],1),_vm._v(" "),_c('b-table',{attrs:{"hover":"","responsive":"","items":_vm.getFilteredData(_vm.editedItem.content),"fields":_vm.contentFields,"tbody-tr-class":_vm.rowClass},scopedSlots:_vm._u([{key:"head(scopeGroupId)",fn:function(head){return [_c('div',[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},on:{"change":function($event){return _vm.updateData(_vm.filters, {'sourceTypeGroupId':[],'sourceTypeId':[]})}},model:{value:(_vm.filters.scopeGroupId),callback:function ($$v) {_vm.$set(_vm.filters, "scopeGroupId", $$v)},expression:"filters.scopeGroupId"}},_vm._l((_vm.scopeGroupMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter"),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)],1)]}},{key:"head(sourceTypeGroupId)",fn:function(head){return [_c('div',[(_vm.filters.scopeGroupId.length == 0)?[_c('span',[_vm._v(_vm._s(head.label))])]:[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},on:{"change":function($event){return _vm.updateData(_vm.filters, {'sourceTypeId':[]})}},model:{value:(_vm.filters.sourceTypeGroupId),callback:function ($$v) {_vm.$set(_vm.filters, "sourceTypeGroupId", $$v)},expression:"filters.sourceTypeGroupId"}},_vm._l((_vm.setFilterOptionsByParent(_vm.filters, _vm.sourceTypeGroupMap, ['scopeGroupId'])),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter-" + (element.scopeGroupId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)]],2)]}},{key:"head(sourceTypeId)",fn:function(head){return [_c('div',[(_vm.filters.sourceTypeGroupId.length == 0)?[_c('span',[_vm._v(_vm._s(head.label))])]:[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},model:{value:(_vm.filters.sourceTypeId),callback:function ($$v) {_vm.$set(_vm.filters, "sourceTypeId", $$v)},expression:"filters.sourceTypeId"}},_vm._l((_vm.setFilterOptionsByParent(_vm.filters, _vm.sourceTypeMap, ['scopeGroupId','sourceTypeGroupId'])),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter-" + (element.scopeGroupId) + "-" + (element.sourceTypeGroupId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)]],2)]}},{key:"head(countryId)",fn:function(head){return [_c('div',[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},on:{"change":function($event){return _vm.updateData(_vm.filters, {'region':[]})}},model:{value:(_vm.filters.countryId),callback:function ($$v) {_vm.$set(_vm.filters, "countryId", $$v)},expression:"filters.countryId"}},_vm._l((_vm.countryMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter"),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)],1)]}},{key:"head(regionId)",fn:function(head){return [_c('div',[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},model:{value:(_vm.filters.regionId),callback:function ($$v) {_vm.$set(_vm.filters, "regionId", $$v)},expression:"filters.regionId"}},_vm._l((_vm.regionMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter-" + (element.countryId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)],1)]}},{key:"head(sectorId)",fn:function(head){return [_c('div',[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},model:{value:(_vm.filters.sectorId),callback:function ($$v) {_vm.$set(_vm.filters, "sectorId", $$v)},expression:"filters.sectorId"}},_vm._l((_vm.sectorMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter"),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)],1)]}},{key:"head(unitId)",fn:function(head){return [_c('div',[[_c('el-popover',{attrs:{"placement":"bottom","trigger":"click"}},[_c('el-select',{attrs:{"multiple":"","filterable":"","collapse-tags":""},model:{value:(_vm.filters.unitId),callback:function ($$v) {_vm.$set(_vm.filters, "unitId", $$v)},expression:"filters.unitId"}},_vm._l((_vm.unitMap),function(element){return _c('el-option',{key:((element.id) + "-" + (element.name) + "-filter-" + (element.sourceTypeId)),attrs:{"value":element.id,"label":_vm.$t(element.name)}})}),1),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(head.label))])],1)]],2)]}},(_vm.editAction == 'edit')?{key:"head(edit)",fn:function(head){return [_c('span',{on:{"click":function($event){return _vm.getEmissionLibraryContentByFilter()}}},[_c('i',{staticClass:"fas fa-redo"})])]}}:null,{key:"cell(scopeGroupId)",fn:function(data){return [_c('b-form-select',{on:{"change":function($event){return _vm.updateData(data.item,{'sourceTypeGroupId':null,'sourceTypeId':null})}},model:{value:(data.item['scopeGroupId']),callback:function ($$v) {_vm.$set(data.item, 'scopeGroupId', $$v)},expression:"data.item['scopeGroupId']"}},_vm._l((_vm.scopeGroupMap),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])}),0)]}},{key:"cell(sourceTypeGroupId)",fn:function(data){return [(data.item['scopeGroupId'])?_c('b-form-select',{on:{"change":function($event){return _vm.updateData(data.item,{'sourceTypeId':null})}},model:{value:(data.item['sourceTypeGroupId']),callback:function ($$v) {_vm.$set(data.item, 'sourceTypeGroupId', $$v)},expression:"data.item['sourceTypeGroupId']"}},_vm._l((_vm.filterByParent(_vm.sourceTypeGroupMap, [{value:data.item.scopeGroupId, key:'scopeGroupId'}])),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])}),0):_vm._e()]}},{key:"cell(sourceTypeId)",fn:function(data){return [(data.item['sourceTypeGroupId'])?_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(data.item['sourceTypeId']),callback:function ($$v) {_vm.$set(data.item, 'sourceTypeId', $$v)},expression:"data.item['sourceTypeId']"}},_vm._l((_vm.filterByParent(_vm.sourceTypeMap, [{value:data.item.sourceTypeGroupId, key:'sourceTypeGroupId'},{value:data.item.scopeGroupId, key:'scopeGroupId'}])),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])}),0):_vm._e()]}},{key:"cell(countryId)",fn:function(data){return [_c('b-form-select',{on:{"change":function($event){return _vm.updateData(data.item,{'regionId':null})}},model:{value:(data.item['countryId']),callback:function ($$v) {_vm.$set(data.item, 'countryId', $$v)},expression:"data.item['countryId']"}},[_c('option',{key:"empty-country-2",domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.countryMap),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])})],2)]}},{key:"cell(regionId)",fn:function(data){return [(data.item['countryId'])?_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(data.item['regionId']),callback:function ($$v) {_vm.$set(data.item, 'regionId', $$v)},expression:"data.item['regionId']"}},[_c('option',{key:"empty-region",domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.filterByParent(_vm.regionMap, [{value:data.item.countryId, key:'countryId'}])),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])})],2):_vm._e()]}},{key:"cell(sectorId)",fn:function(data){return [_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(data.item['sectorId']),callback:function ($$v) {_vm.$set(data.item, 'sectorId', $$v)},expression:"data.item['sectorId']"}},[_c('option',{key:"empty-sector",domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.sectorMap),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])})],2)]}},{key:"cell(unitId)",fn:function(data){return [(data.item['sourceTypeId'])?_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(data.item['unitId']),callback:function ($$v) {_vm.$set(data.item, 'unitId', $$v)},expression:"data.item['unitId']"}},_vm._l((_vm.getUnitMap(data.item)),function(element){return _c('option',{key:((element.id) + "-" + (element.name) + "-nid-" + (data.item.id)),domProps:{"value":element.id}},[_vm._v(_vm._s(_vm.$t(element.name)))])}),0):_vm._e()]}},{key:"cell(CH4)",fn:function(data){return [_c('b-form-input',{on:{"change":_vm.forceUpdate},model:{value:(data.item['CH4']),callback:function ($$v) {_vm.$set(data.item, 'CH4', $$v)},expression:"data.item['CH4']"}})]}},{key:"cell(N2O)",fn:function(data){return [_c('b-form-input',{on:{"change":_vm.forceUpdate},model:{value:(data.item['N2O']),callback:function ($$v) {_vm.$set(data.item, 'N2O', $$v)},expression:"data.item['N2O']"}})]}},{key:"cell(CO2)",fn:function(data){return [_c('b-form-input',{on:{"change":_vm.forceUpdate},model:{value:(data.item['CO2']),callback:function ($$v) {_vm.$set(data.item, 'CO2', $$v)},expression:"data.item['CO2']"}})]}},{key:"cell(CO2e)",fn:function(data){return [_c('b-form-input',{on:{"change":_vm.forceUpdate},model:{value:(data.item['CO2e']),callback:function ($$v) {_vm.$set(data.item, 'CO2e', $$v)},expression:"data.item['CO2e']"}})]}},{key:"cell(edit)",fn:function(data){return [_c('div',{staticClass:"tableAction"},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"color":"#8888","cursor":"pointer","float":"left"},attrs:{"title":_vm.$t('duplicateItem')},on:{"click":function($event){return _vm.duplicateContent(data.item)}}},[_c('i',{staticClass:"fas fa-clone fa-lg"})]),_vm._v(" "),(_vm.showSplitRegionsButton(data.item))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"color":"#4F8EC1","cursor":"pointer","float":"center"},attrs:{"title":_vm.$t('splitCountryToRegions')},on:{"click":function($event){return _vm.contentSplitCountryToRegions(data.item)}}},[_c('i',{staticClass:"fas fa-globe fa-lg"})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"color":"#d04d4d","cursor":"pointer","float":"right"},attrs:{"title":_vm.$t('delete')},on:{"click":function($event){return _vm.deleteContent(data.item)}}},[_c('i',{staticClass:"fas fa-trash-alt fa-lg"})])])]}}],null,true)})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RLg3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__ = __webpack_require__("VLQC");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_59f49670_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__ = __webpack_require__("AF+i");
function injectStyle (ssrContext) {
  __webpack_require__("ycnV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59f49670"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_AtomSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_59f49670_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_AtomSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Rccw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"choose-data-type":"Örnek şablonu indirmek için veri tipini seçiniz","data-type":"Veri Tipi","load-xlsx-for-data-entrance":"Veri girişi için bir xlsx dosyası yükleyiniz","downloadTemplate":"Excel Şablonu İndir","excel-error":"x. satırda y bulundu!","conflict":"tarih uyuşmazlığı","code":"kod - lokasyon uyuşmazlığı","missing-information":"veri eksikliği","not-found":"Dosya gönderilemedi","unexpected-error":"Beklenmedik bir hata oluştu"},"en":{"choose-data-type":"Choose data type to download sample template","data-type":"Data Type","load-xlsx-for-data-entrance":"Upload a file xlsx file for data entrance","downloadTemplate":"Download Template Excel","excel-error":"There is an y error at line x ","conflict":"date conflict","code":"code - location disagreement","missing-information":"missing infromation","not-found":"The file couldn\u0027t upload","unexpected-error":"Unexpected error"}}')
}


/***/ }),

/***/ "Rf5t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionEdit_vue__ = __webpack_require__("H6Kz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a61525_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionEdit_vue__ = __webpack_require__("KC6V");
function injectStyle (ssrContext) {
  __webpack_require__("drnr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43a61525"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a61525_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("1fDW")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RliP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('div',{staticClass:"table-responsive",staticStyle:{"margin":"0 5px"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticClass:"borderless",staticStyle:{"text-align":"center"}},[_c('th',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.$t('intensityTableTitle')))])]),_vm._v(" "),_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"20em"}},[_vm._v(_vm._s(_vm.$t('measurement')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year - 1))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('changingColumn')))])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('IntensityTotalEmissions')))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.pastEmission,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.currentEmission,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.intensityReport.pastEmission, _vm.intensityReport.currentEmission) !== '0.0')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.intensityReport.pastEmission, _vm.intensityReport.currentEmission) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.intensityReport.pastEmission, _vm.intensityReport.currentEmission)),'float', _vm.locale))+"\n                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('IntensityTotalConsumption'))+" ("+_vm._s(_vm.$store.state.analysis_unit)+")")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.pastConsumption,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.currentConsumption,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.intensityReport.pastConsumption, _vm.intensityReport.currentConsumption) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.intensityReport.pastConsumption, _vm.intensityReport.currentConsumption ) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.intensityReport.pastConsumption, _vm.intensityReport.currentConsumption)),'float', _vm.locale))+"\n                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('IntensityTotalEmployeeCount')))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.pastStaffCount,'number', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.currentStaffCount,'number', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.intensityReport.pastStaffCount, _vm.intensityReport.currentStaffCount) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.intensityReport.pastStaffCount, _vm.intensityReport.currentStaffCount) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.intensityReport.pastStaffCount, _vm.intensityReport.currentStaffCount)),'float', _vm.locale))+"\n                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('emissionValuePerEmployee')))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.pastEmissionPerStaff,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.currentEmissionPerStaff,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.intensityReport.pastEmissionPerStaff, _vm.intensityReport.currentEmissionPerStaff) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.intensityReport.pastEmissionPerStaff, _vm.intensityReport.currentEmissionPerStaff) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.intensityReport.pastEmissionPerStaff, _vm.intensityReport.currentEmissionPerStaff)),'float', _vm.locale))+"\n                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('consumptionValuePerEmployee'))+" ("+_vm._s(_vm.$store.state.analysis_unit)+"/"+_vm._s(_vm.$t('person'))+")")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.pastConsumptionPerStaff,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.intensityReport.currentConsumptionPerStaff,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.intensityReport.pastConsumptionPerStaff, _vm.intensityReport.currentConsumptionPerStaff) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.intensityReport.pastConsumptionPerStaff, _vm.intensityReport.currentConsumptionPerStaff) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.intensityReport.pastConsumptionPerStaff, _vm.intensityReport.currentConsumptionPerStaff)),'float', _vm.locale))+"\n                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RpXe":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"wasteDescription":"Atık Tanımı","wasteType":"Atığın Tipi/Cinsi","storage":"Depolama Şekli/Yeri","municipality":"İlgili Belediye","recovery":"Geri Dönüşüm","wasteDescriptionEmptyError":"Atık tanımı boş bırakılamaz."},"en":{"wasteDescription":"Waste Description","wasteType":"Waste Type","storage":"Storage","municipality":"Municipality","recovery":"Recovery","wasteDescriptionEmptyError":"Atık tanımı can\u0027t be emtpy."}}')
}


/***/ }),

/***/ "SKnS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionDetail_vue__ = __webpack_require__("UzgI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7413328f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionDetail_vue__ = __webpack_require__("bnY1");
function injectStyle (ssrContext) {
  __webpack_require__("nKzh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7413328f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7413328f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("pJEE")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SLDS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SLWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["d" /* Pie */],
    name: 'pie-chart',
    props: ['chartData', 'options', 'chartId'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["e" /* mixins */].reactiveProp],
    data: function data() {
        return {
            isLoaded: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
        this.$eventHub.$on(this.chartId, function () {
            if (_this.isLoaded) {
                _this.$data._chart.update();
            }
        });
        this.isLoaded = true;
    },
    beforeDestroy: function beforeDestroy() {
        this.$eventHub.$off(this.chartId);
    }
});

/***/ }),

/***/ "Sajy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SetW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SjFc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Szm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warn_vue__ = __webpack_require__("LnqG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37907b25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warn_vue__ = __webpack_require__("upVU");
function injectStyle (ssrContext) {
  __webpack_require__("aU5X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37907b25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37907b25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1Ap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__ = __webpack_require__("iGLV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e1086b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__ = __webpack_require__("sVtB");
function injectStyle (ssrContext) {
  __webpack_require__("FhOq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78e1086b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78e1086b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("DHNU")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T7Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("+s3s");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c827517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__ = __webpack_require__("1pac");
function injectStyle (ssrContext) {
  __webpack_require__("HxfB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c827517"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c827517_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_BreedingRhombusSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "T7j2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Upload_vue__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UploadRegular_vue__ = __webpack_require__("8Vs0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Upload: __WEBPACK_IMPORTED_MODULE_4__components_Upload_vue__["a" /* default */], UploadRegular: __WEBPACK_IMPORTED_MODULE_5__components_UploadRegular_vue__["a" /* default */] },
    name: 'CustomTable',
    props: {
        initialData: {
            type: Object,
            default: function _default() {
                return {
                    items: [],
                    fields: []
                };
            }
        },
        isEditable: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    data: function data() {
        return {
            insertMode: false, // toggles insert mode
            fields: [], // table headers
            items: [], // includes some info to show on cells
            tempItem: {}, // stores data entered by user
            lastColumnWidth: '140px', // 'em' typed width value to specify action column width
            tableFontSize: 0.875,
            tableId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            reactiveId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()()
        };
    },

    filters: {
        idToPaymentMethod: function idToPaymentMethod(val, paymentMethods) {
            var found = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(paymentMethods, { value: val });
            return found ? this.$t(found.text) : '';
        }
    },

    methods: {
        isNil: function isNil(value) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(value);
        },

        // Hide warning message
        resetWarning: function resetWarning(item) {
            item.classes['is-invalid'] = false;
            item.hasWarn = false;
        },


        // Make a row editable
        makeRowEditable: function makeRowEditable(item) {
            this.items.forEach(this.revertChanges);
            this.insertMode = false;
            item.editMode = true;

            // Focus on first item in row
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-input-custom');
                elements[0].focus();
                return true;
            });
        },


        // Insert a new table row
        insertRow: function insertRow() {
            this.insertMode = true;
            this.items.forEach(function (item) {
                item.editMode = false;
            });
            this.bindTempItemToView();

            // Focus on first item in row
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-input-custom');
                elements[0].focus();
                return true;
            });
        },


        // Cancel newly inserted row
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },


        // Insert new item
        createItem: function createItem(item) {
            var _this = this;

            if (this.isInsertValid(item)) {
                this.$emit('insertItem', item, function (data) {
                    _this.insertMode = false;
                    _this.items.push(_this.prepareItem(data));
                    _this.bindTempItemToView();
                    _this.calculateLastColumnWidth();
                });
            }
        },


        // Update existing item
        updateItem: function updateItem(item, fields) {
            var _this2 = this;

            if (this.isUpdateValid(item, fields)) {
                this.$emit('applyDataChanges', item, fields, function (data) {
                    var updatedItem = _this2.prepareItem(data);
                    for (var key in item) {
                        item[key] = updatedItem[key];
                    }
                    item.editMode = false;
                });
            }
        },


        // Delete an item
        deleteItem: function deleteItem($event, id) {
            var _this3 = this;

            this.showWarnModal($event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this3.$emit('deleteItemById', id);
                _this3.items = _this3.items.filter(function (item) {
                    return item.id !== id;
                });
            });
        },
        setPaymentMethod: function setPaymentMethod(id, item) {
            item.editedValue = id;
        },
        handleUploading: function handleUploading(event, item) {
            item.editedFilename = event.filename;
            item.editedFileId = event.fileId;
            item.editedFileUrl = event.fileUrl;
            this.$store.state.uploadFiles = [];
            this.$forceUpdate();
        },
        handleTempUploading: function handleTempUploading(event, item) {
            item.filename = event.filename;
            item.fileId = event.fileId;
            item.fileUrl = event.fileUrl;
        },
        handleRemoving: function handleRemoving(event, item) {
            item.editedFileId = null;
            this.$forceUpdate();
        },
        handleTempRemoving: function handleTempRemoving(event, item) {
            item.fileId = null;
        },


        // Revert any changes made on an item
        revertChanges: function revertChanges(item) {
            var _this4 = this;

            this.fields.forEach(function (field) {
                if (field.editable && item[field.key]) {
                    if (field.type === 'date') {
                        item[field.key].editedValue = __WEBPACK_IMPORTED_MODULE_2_moment___default()(item[field.key].value).toDate();
                        // TODO: Make this work for currencies other than Turkish
                        // Also put it in its own function
                    } else if (field.type === 'daterange') {
                        item[field.key].editedValue = [__WEBPACK_IMPORTED_MODULE_2_moment___default()(item[field.key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()(item[field.key].value[1]).toDate()];
                    } else if (field.type === 'float' || field.type === 'number') {
                        item[field.key].editedValue = _this4.convertToLocalizedFloat(item[field.key].value, _this4.locale);
                    } else if (field.type === 'file' && (item[field.key].editedFileId || !item[field.key].editedFileUrl)) {
                        item[field.key].editedFileId = item[field.key].fileId;
                    }
                    item[field.key].classes['is-invalid'] = false;
                    item[field.key].hasWarn = false;
                }
            });
            item.editMode = false;
        },


        // Validate newly entered data
        isInsertValid: function isInsertValid(item) {
            var isValid = true;
            for (var key in item) {
                if (item[key].required && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(item[key].value) && item[key].hasOwnProperty('value')) {
                    item[key].classes['is-invalid'] = true;
                    item[key].hasWarn = true;
                    isValid = false;
                }
            }
            if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            }
            return isValid;
        },


        // Validate updates to existing data
        isUpdateValid: function isUpdateValid(item, fields) {
            var isValid = true;
            fields.forEach(function (field) {
                if (field.required && field.editable && field.type !== 'file') {
                    if (!item[field.key].editedValue) {
                        item[field.key].classes['is-invalid'] = true;
                        item[field.key].hasWarn = true;
                        isValid = false;
                    }
                }
            });
            if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            }
            return isValid;
        },


        // Prepare items in the correct format
        // The property editValue is used to store data entered by user
        prepareItem: function prepareItem(row) {
            var generated = {};
            for (var key in row) {
                var foundField = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.fields, { key: key });
                if (foundField) {
                    generated[key] = {
                        value: row[key]
                    };
                    if (this.isEditable) {
                        if (foundField.type === 'daterange') {
                            generated[key].editedValue = [__WEBPACK_IMPORTED_MODULE_2_moment___default()(generated[key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_2_moment___default()(generated[key].value[1]).toDate()];
                            // TODO: Make this work for currencies other than Turkish
                            // Also put it in its own function
                        } else if (foundField.type === 'date') {
                            generated[key].editedValue = __WEBPACK_IMPORTED_MODULE_2_moment___default()(generated[key].value).toDate();
                        } else if (foundField.type === 'float' || foundField.type === 'number') {
                            if (foundField.type === 'number') {
                                generated[key].value = Number(this.delocalizeValue(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toString(generated[key].value)).replaceAll('.', '').replaceAll(',', '.'));
                            }
                            generated[key].value = generated[key].value.toFixed(2);
                            generated[key].editedValue = this.convertToLocalizedFloat(generated[key].value, this.locale);
                        } else if (foundField.type === 'link') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'file' && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(row[key])) {
                            generated[key].fileId = row[key].fileId ? row[key].fileId : row[key];
                            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(generated[key].fileId) === 'object') {
                                generated[key].fileId = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(generated[key].fileId, 'editedFileId');
                            }
                            if (row[key].editedFileId || !row[key].editedFileUrl) {
                                generated[key].editedFileId = generated[key].fileId;
                            }
                            generated[key].fileUrl = row[key].fileUrl || row[key].editedFileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl || row[key].editedFileUrl;
                            generated[key].filename = row[key].filename || row[key].editedFilename;
                            generated[key].editedFilename = generated[key].filename || row[key].editedFilename;
                        } else if (foundField.type === 'select') {
                            generated[key].editedValue = generated[key].value;
                        } else {
                            generated[key].editedValue = generated[key].value;
                        }

                        generated[key].classes = {
                            'form-control': foundField.type !== 'date' && foundField.type !== 'daterange',
                            'is-invalid': false
                        };
                        generated[key].hasWarn = false;
                        generated[key].required = foundField.required;
                    } else {
                        if (foundField.type === 'file' && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(row[key])) {
                            generated[key].fileId = row[key].fileId;
                            generated[key].editedFileId = generated[key].fileId;
                            generated[key].fileUrl = row[key].fileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl;
                            generated[key].filename = row[key].filename;
                            generated[key].editedFilename = generated[key].filename;
                        }
                    }
                }
            }

            generated.editMode = false;
            generated.id = row.id;
            generated.path = row.path;

            return generated;
        },
        setDefaultDateTypedValue: function setDefaultDateTypedValue(type, key) {
            var defaultVal = null;
            if (this.items.length) {
                if (type === 'date') {
                    var lastItem = this.items[this.items.length - 1];
                    defaultVal = lastItem[key].value;
                } else if (type === 'daterange') {
                    var _lastItem = this.items[this.items.length - 1];
                    defaultVal = _lastItem[key].value;
                }
            } else {
                if (type === 'date') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                } else if (type === 'daterange') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                }
            }
            return defaultVal;
        },
        setDefaultSelectTypedValue: function setDefaultSelectTypedValue(key) {
            var defaultVal = null;
            if (this.items.length) {
                var lastItem = this.items[this.items.length - 1];
                defaultVal = lastItem[key].value;
            }
            return defaultVal;
        },


        // Bind temporary item storage to view
        bindTempItemToView: function bindTempItemToView() {
            var _this5 = this;

            this.tempItem = {};
            this.fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'file') {
                        _this5.$set(_this5.tempItem, field.key, {
                            filename: null,
                            fileUrl: null,
                            fileId: null
                        });
                    } else {
                        var defaultValue = null;
                        if (field.type === 'date' || field.type === 'daterange') {
                            defaultValue = _this5.setDefaultDateTypedValue(field.type, field.key);
                        } else if (field.type === 'select') {
                            defaultValue = _this5.setDefaultSelectTypedValue(field.key);
                        }
                        _this5.$set(_this5.tempItem, field.key, {
                            value: field.type === 'select' ? defaultValue : null,
                            defaultValue: defaultValue,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                            hasWarn: false,
                            required: field.required
                        });
                    }
                }
            });
        },


        // Called on initial render and every data update
        init: function init() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            this.fields = fields;
            this.fields = this.fields.filter(function (field) {
                return !field.header.includes('Imza');
            });
            this.items = items.map(this.prepareItem);
            if (this.isEditable) {
                this.bindTempItemToView();
            }
            this.calculateLastColumnWidth();
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this6 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('lastColumn');
                if (element) {
                    _this6.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        routeTo: function routeTo(item) {
            if (!this.isEditable) {
                this.$router.push({ path: item.path });
            }
        },
        triggerPopover: function triggerPopover(item) {
            document.getElementById('a_' + this.reactiveId + '_' + item.id).focus();
        }
    },

    computed: {
        cursorType: function cursorType() {
            var cursorClass = 'cursor-isEditable';
            if (!this.isEditable) {
                cursorClass = 'cursor-nonEditable';
            }
            return cursorClass;
        }
    },

    watch: {
        initialData: function initialData() {
            var newVal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.init(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(newVal.items), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(newVal.fields));
        }
    },

    created: function created() {
        window.addEventListener('resize', this.calculateLastColumnWidth);
        this.init(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.initialData.items), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.initialData.fields));
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "TFIm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGAJ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"selectAll":"Hepsini Seç","selectLocation":"Lokasyon Seçin"},"en":{"selectAll":"Select All","selectLocation":"Select Location"}}')
}


/***/ }),

/***/ "TIN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearSelect_vue__ = __webpack_require__("pLbQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c225f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearSelect_vue__ = __webpack_require__("6MXH");
function injectStyle (ssrContext) {
  __webpack_require__("NUM4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c225f8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c225f8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TMvF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope2_vue__ = __webpack_require__("bNqp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e995f7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope2_vue__ = __webpack_require__("bwtq");
function injectStyle (ssrContext) {
  __webpack_require__("23AY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e995f7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scope2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e995f7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scope2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TV0X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TqEe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IntersectingCirclesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    circleSize: function circleSize() {
      return this.size / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerBlockStyle: function spinnerBlockStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.circleSize + 'px',
        height: this.circleSize + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        borderColor: this.color
      };
    },
    circleStyles: function circleStyles() {
      var _this = this;

      var circlesPositions = [{ top: 0, left: 0 }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: this.circleSize * -0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: 0, top: this.circleSize * -0.36 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * -0.2 + 'px' }, { left: this.circleSize * 0.36 + 'px', top: this.circleSize * 0.2 + 'px' }, { left: 0, top: this.circleSize * 0.36 + 'px' }];

      return circlesPositions.map(function (cp) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(cp, _this.circleStyle);
      });
    }
  }
});

/***/ }),

/***/ "UShn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'admin-unit-price-detail',

    data: function data() {
        return {
            isLoaded: false, // Toggles page loading,
            dataTypes: this.$store.state.dataTypes,
            rawItems: [], // Original dataType object array,
            unitPrices: [],
            siteId: null,
            tempItem: {}, // Temporary object used for inserts
            yearChoices: [{
                value: '2015',
                text: '2015'
            }, {
                value: '2016',
                text: '2016'
            }, {
                value: '2017',
                text: '2017'
            }, {
                value: '2018',
                text: '2018'
            }, {
                value: '2019',
                text: '2019'
            }, {
                value: '2020',
                text: '2020'
            }, {
                value: '2021',
                text: '2021'
            }],
            insertMode: false,
            lastColumnWidth: '140px'
        };
    },


    methods: {
        routeByTag: function routeByTag(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;
        },
        getDataTypeName: function getDataTypeName(name) {
            return this.$t(name);
        },
        getYear: function getYear(date) {
            if (!date.editedValue) {
                return date.substr(0, date.indexOf('-'));
            } else {
                return date.editedValue;
            }
        },
        getUnitPrice: function getUnitPrice(unitPrice) {
            if (!unitPrice.editedValue) {
                return unitPrice;
            } else {
                return unitPrice.editedValue;
            }
        },
        setSelectedStartYear: function setSelectedStartYear(val, item) {
            item.startDate.editedValue = val;
        },
        setSelectedEndYear: function setSelectedEndYear(val, item) {
            item.endDate.editedValue = val;
        },
        insertRow: function insertRow() {
            this.insertMode = true;
            this.bindTempItemToView();
            this.bindItems(this.rawItems);
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        makeRowEditable: function makeRowEditable(unitPriceId) {
            this.cancelNewRow();
            this.bindItems(this.rawItems);
            var unitPrice = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.unitPrices, { id: unitPriceId });
            unitPrice.editMode = true;
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        bindTempItemToView: function bindTempItemToView() {
            var tempItem = {
                dataType: { editedValue: 0 },
                startDate: { editedValue: 0 },
                endDate: { editedValue: 0 },
                price: { editedValue: null }
            };
            this.tempItem = tempItem;
        },
        isUnitPriceValid: function isUnitPriceValid(item) {
            var isValid = true;
            if (!item.price.editedValue || !item.startDate.editedValue || !item.endDate.editedValue) {
                this.$toasted.error(this.$t('missingError'));
                isValid = false;
                return isValid;
            }
            if (item.startDate.editedValue >= item.endDate.editedValue) {
                this.$toasted.error(this.$t('duplicateStartEndYear'));
                isValid = false;
                return isValid;
            }
            var duplicateItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.unitPrices, function (o) {
                return o.startDate.value == item.startDate.editedValue && o.id != item.id;
            });
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(duplicateItem)) {
                isValid = false;
                this.$toasted.error(this.$t('conflictUnitPriceYear'));
                return isValid;
            }
            return isValid;
        },
        createItem: function createItem() {
            var _this = this;

            if (this.isUnitPriceValid(this.tempItem)) {
                var arrangedItem = {
                    dataType: this.dataType.id,
                    price: Number(this.tempItem.price.editedValue),
                    startYear: Number(this.tempItem.startDate.editedValue),
                    endYear: Number(this.tempItem.endDate.editedValue)
                };
                this.$Progress.start();
                return this.axios.post('/unitPrice', arrangedItem).then(function (_ref) {
                    var data = _ref.data;

                    var result = data;
                    _this.rawItems.push(result);
                    _this.bindItems(_this.rawItems);
                    _this.cancelNewRow();
                    return _this.$Progress.finish();
                });
            }
        },
        updateItem: function updateItem(unitPrice) {
            var _this2 = this;

            if (this.isUnitPriceValid(unitPrice)) {
                var arrangedItem = {
                    dataType: this.dataType.id,
                    price: unitPrice.price.editedValue,
                    startYear: Number(unitPrice.startDate.editedValue),
                    endYear: Number(unitPrice.endDate.editedValue)
                };
                this.$Progress.start();
                return this.axios.put('/unitPrice/' + unitPrice.id, arrangedItem).then(function (_ref2) {
                    var data = _ref2.data;

                    var result = data;
                    var rawItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this2.rawItems, { id: unitPrice.id });
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rawItem, result);
                    _this2.bindItems(_this2.rawItems);
                    _this2.cancelNewRow();
                    return _this2.$Progress.finish();
                });
            }
        },
        deleteItem: function deleteItem(event, id) {
            var _this3 = this;

            var currentDataType = this.dataType.id;
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this3.axios.delete('/unitPrice/' + id).catch(function () {
                    _this3.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                    _this3.listDataTypes(currentDataType);
                });
                _this3.rawItems = _this3.rawItems.filter(function (item) {
                    return item.id !== id;
                });
                _this3.bindItems(_this3.rawItems);
            });
        },


        // Prepare a dataType object to use in dom
        prepareItem: function prepareItem(item) {
            var configuredItem = {};
            var startDateInit, endDateInit;
            startDateInit = item.startDate ? item.startDate.substr(0, item.startDate.indexOf('-')) : '-';
            endDateInit = item.endDate ? item.endDate.substr(0, item.endDate.indexOf('-')) : '-';

            configuredItem.editMode = false;

            configuredItem.id = item.id;
            var name = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.dataTypes, { id: item.dataType }).name;
            configuredItem.dataTypeId = {
                value: item.dataType,
                editedValue: item.dataType,
                name: name
            };
            configuredItem.startDate = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endDate = {
                value: endDateInit,
                editedValue: endDateInit
            };
            configuredItem.price = {
                value: item.price,
                editedValue: item.price
            };
            return configuredItem;
        },


        // Bind dataTypes object array to use in dom
        bindItems: function bindItems(unitPrices) {
            var _this4 = this;

            //unitPrices.editMode = true;
            this.unitPrices = unitPrices.filter(function (unitPrice) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this4.dataTypes, { id: unitPrice.dataType });
            }).map(this.prepareItem);
            return this.calculateLastColumnWidth();
        },
        listDataTypes: function listDataTypes(dataTypeId) {
            var _this5 = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/unitPrice/' + dataTypeId).then(function (_ref3) {
                var data = _ref3.data;

                _this5.rawItems = data;
                _this5.bindItems(_this5.rawItems);
                _this5.unitPrices = data;
                _this5.isLoaded = true;
                return _this5.$Progress.finish();
            });
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this6 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('unitPrice-last-column');
                if (element) {
                    _this6.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init: function init() {
            this.dataType = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.dataTypes, { id: this.route.params.type_id });
            this.listDataTypes(this.dataType.id);
        }
    },
    created: function created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "UW5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__ = __webpack_require__("H65f");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ca7cfc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__ = __webpack_require__("A1rk");
function injectStyle (ssrContext) {
  __webpack_require__("DFUc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ca7cfc9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ca7cfc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "UdiJ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"waste":"Atık","energy":"Enerji","water":"Su","other":"Diğer","consumption":"Enerji","supplychain":"Diğer"},"en":{"waste":"Waste","energy":"Energy","water":"Water","other":"Other","consumption":"Energy","supplychain":"Other"}}')
}


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userId", function() { return userId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskOfNumber", function() { return maskOfNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskOfCurrency", function() { return maskOfCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskOfEmission", function() { return maskOfEmission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask__ = __webpack_require__("cfoZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask__);


var userId = function userId(state) {
    return state.userId;
};

var maskOfNumber = function maskOfNumber(state) {
    return __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({
        prefix: '',
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 2
    });
};
var maskOfCurrency = function maskOfCurrency(state) {
    return __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({
        prefix: '',
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 2
    });
};

// Masks emission values and adds unit type suffix
var maskOfEmission = function maskOfEmission(state) {
    //(suffix) => {
    return __WEBPACK_IMPORTED_MODULE_0_text_mask_addons_dist_createNumberMask___default()({
        prefix: '',
        //suffix: ` ${suffix}`,
        thousandsSeparatorSymbol: state.locale === 'tr' ? '.' : ',',
        allowDecimal: true,
        decimalSymbol: state.locale === 'tr' ? ',' : '.',
        decimalLimit: 16,
        integerLimit: 3
    });
};

/***/ }),

/***/ "UvP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar_vue__ = __webpack_require__("9TRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TheNavbar: __WEBPACK_IMPORTED_MODULE_0__components_TheNavbar_vue__["a" /* default */]
    },
    data: function data() {
        return {
            isMenuVisible: null,
            path: null,
            // Name of the routes to show the scrollbar
            viewsWithScrollbar: ['dashboard', 'site-files', 'ticket-list', 'ticket-detail', 'user-profile', 'admin-site', 'admin-site-edit', 'permissions', 'edit-permissions', 'add-permission', 'emission-library', 'locations', 'register', 'compare'
            // 'users',
            // 'tags',
            ]
        };
    },

    computed: {
        // Returns true if page is supposed to have scrollbar
        showScrollbar: function showScrollbar() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(this.viewsWithScrollbar, this.$route.name);
        }
    },
    methods: {
        routeTo: function routeTo(path) {
            this.$router.push(path);
        }
    },
    created: function created() {
        this.$store.state.siteId = this.route.query.site_id ? Number(this.route.query.site_id) : this.$store.state.siteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        if (this.route.name === 'main') {
            this.routeTo({ name: 'dashboard' });
        }
    }
});

/***/ }),

/***/ "UzgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'admin-emission-detail',

    data: function data() {
        return {
            selectedSite: this.gbId(this.$store.state.user.customerId) ? '1882' : null,
            isLoaded: false, // Toggles page loading,
            dataTypes: this.$store.state.dataTypes,
            rawItems: [], // Original dataType object array,
            selectedEmission: [],
            emissions: [],
            emissionTypes: [],
            emissionTypeNames: [],
            co2eData: null,
            emissionUnits: [{
                value: 'ton',
                text: this.$t('tons')
            }, {
                value: 'ton/day',
                text: this.$t('ton/day')
            }, {
                value: 'ton/kg',
                text: this.$t('ton/kg')
            }, {
                value: 'ton/km',
                text: this.$t('ton/km')
            }, {
                value: 'ton/kWh',
                text: this.$t('ton/kWh')
            }, {
                value: 'ton/lt',
                text: this.$t('ton/lt')
            }, {
                value: 'ton/m3',
                text: this.$t('ton/m3')
            }, {
                value: 'ton/tons',
                text: this.$t('ton/ton')
            }, {
                value: 'ton/piece',
                text: this.$t('ton/piece')
            }],
            siteId: null,
            tempItem: {}, // Temporary object used for inserts
            yearChoices: [{
                value: '2015',
                text: '2015'
            }, {
                value: '2016',
                text: '2016'
            }, {
                value: '2017',
                text: '2017'
            }, {
                value: '2018',
                text: '2018'
            }, {
                value: '2019',
                text: '2019'
            }, {
                value: '2020',
                text: '2020'
            }, {
                value: '2021',
                text: '2021'
            }, {
                value: '2022',
                text: '2022'
            }],
            insertMode: false,
            lastColumnWidth: '140px'
        };
    },


    methods: {
        routeByTag: function routeByTag(tag) {
            this.tags.forEach(function (tag) {
                tag.active = false;
            });
            tag.active = true;

            //this.$router.push({name: 'site-data-types', query: {year: this.year}});
        },
        getDataTypeName: function getDataTypeName(name) {
            return this.$t(name);
        },
        getEmissionTypeName: function getEmissionTypeName(type) {
            if (!type.editedValue) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissionTypes, { id: type }).name;
            } else {
                return type.editedValue;
            }
        },
        getYear: function getYear(date) {
            if (!date.editedValue) {
                return date.substr(0, date.indexOf('-'));
            } else {
                return date.editedValue;
            }
        },
        getFactor: function getFactor(factor) {
            if (!factor.editedValue) {
                return factor;
            } else {
                return factor.editedValue;
            }
        },
        getUnit: function getUnit(unit) {
            if (!unit.editedValue) {
                return this.$t(unit);
            } else {
                return this.$t(unit.editedValue);
            }
        },
        setSelectedStartYear: function setSelectedStartYear(val, item) {
            item.startDate.editedValue = val;
        },
        setSelectedEndYear: function setSelectedEndYear(val, item) {
            item.endDate.editedValue = val;
        },
        setEmissionType: function setEmissionType(val, item) {
            item.type.editedValue = val;
        },
        setEmissionUnit: function setEmissionUnit(val, item) {
            item.unit.editedValue = val;
        },
        insertRow: function insertRow() {
            this.insertMode = true;
            this.bindTempItemToView();
            this.bindItems(this.rawItems);
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        makeRowEditable: function makeRowEditable(emissionId) {
            this.cancelNewRow();
            this.bindItems(this.rawItems);
            var emission = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissions, { id: emissionId });
            emission.editMode = true;
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        bindTempItemToView: function bindTempItemToView() {
            var tempItem = {
                dataType: { editedValue: 0 },
                startDate: { editedValue: 0 },
                endDate: { editedValue: 0 },
                factor: { editedValue: null },
                type: { editedValue: 0 },
                unit: { editedValue: '' }
            };
            this.tempItem = tempItem;
        },
        isEmissionValid: function isEmissionValid(item) {
            var isValid = true;
            if (!item.factor.editedValue || !item.type.editedValue || !item.unit.editedValue || !item.startDate.editedValue || !item.endDate.editedValue) {
                this.$toasted.error(this.$t('missingError'));
                isValid = false;
                return isValid;
            }
            /* converts name of type to id of type.
            let selectedTypeId = _.find(this.emissionTypes, function(o){
                    return o.name == item.type.editedValue;
                }).id;
            */
            if (item.startDate.editedValue >= item.endDate.editedValue) {
                this.$toasted.error(this.$t('duplicateStartEndYear'));
                isValid = false;
                return isValid;
            }
            var duplicateItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissions, function (o) {
                return o.type.value == item.type.editedValue && o.startDate.value == item.startDate.editedValue && o.id != item.id;
            });
            if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNil(duplicateItem)) {
                isValid = false;
                this.$toasted.error(this.$t('conflictEmissionYear'));
                return isValid;
            }
            return isValid;
        },
        processData: function processData(result) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(result, function (o) {
                if (o != null) {
                    switch (o.process) {
                        case "create":
                            {
                                _this.rawItems.push(o.data);
                                break;
                            }
                        case "update":
                            {
                                var rawItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this.rawItems, { id: o.data.id });
                                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rawItem, o.data);
                                break;
                            }
                        case "delete":
                            {
                                _this.rawItems = _this.rawItems.filter(function (item) {
                                    return item.id !== o.data.id;
                                });
                                break;
                            }
                        default:
                            {
                                break;
                            }
                    }
                }
            });
            this.bindItems(this.rawItems);
        },
        createItem: function createItem() {
            var _this2 = this;

            if (this.isEmissionValid(this.tempItem)) {
                // converts name of type to id of type.
                var tempType = this.tempItem.type.editedValue;
                var selectedTypeId = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissionTypes, function (o) {
                    return o.name == tempType;
                }).id;

                var arrangedItem = {
                    dataType: this.dataType.id,
                    type: selectedTypeId,
                    factor: Number(this.tempItem.factor.editedValue),
                    startYear: Number(this.tempItem.startDate.editedValue),
                    endYear: Number(this.tempItem.endDate.editedValue),
                    unit: this.tempItem.unit.editedValue
                };

                this.$Progress.start();
                return this.axios.post('/dataEmission', arrangedItem).then(function (_ref) {
                    var data = _ref.data;

                    var result = data;
                    _this2.processData(result);
                    _this2.cancelNewRow();
                    return _this2.$Progress.finish();
                });
            }
        },
        updateItem: function updateItem(emission) {
            var _this3 = this;

            if (this.isEmissionValid(emission)) {
                // converts name of type to id of type.
                var tempType = emission.type.editedValue;
                var selectedTypeId = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissionTypes, function (o) {
                    return o.name == tempType;
                }).id;

                var arrangedItem = {
                    dataType: this.dataType.id,
                    type: selectedTypeId,
                    factor: Number(emission.factor.editedValue),
                    startYear: Number(emission.startDate.editedValue),
                    endYear: Number(emission.endDate.editedValue),
                    unit: emission.unit.editedValue
                };
                this.$Progress.start();
                return this.axios.put('/dataEmission/' + emission.id, arrangedItem).then(function (_ref2) {
                    var data = _ref2.data;

                    var result = data;
                    _this3.processData(result);
                    _this3.cancelNewRow();
                    return _this3.$Progress.finish();
                });
            }
        },
        deleteItem: function deleteItem(event, id) {
            var _this4 = this;

            var currentDataType = this.dataType.id;
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this4.bindItems(_this4.rawItems);
                _this4.axios.delete('/dataEmission/' + id).then(function (_ref3) {
                    var data = _ref3.data;

                    var result = data.success;
                    _this4.processData(result);
                }).catch(function () {
                    _this4.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                    _this4.listDataTypes(currentDataType);
                });
            });
        },


        // Prepare a dataType object to use in dom
        prepareItem: function prepareItem(item) {
            var configuredItem = {};
            var startDateInit, endDateInit;
            startDateInit = item.startDate ? item.startDate.substr(0, item.startDate.indexOf('-')) : '-';
            endDateInit = item.endDate ? item.endDate.substr(0, item.endDate.indexOf('-')) : '-';

            var tempType = item.type;
            var selectedTypeName = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.emissionTypes, function (o) {
                return o.id == tempType;
            }).name;

            configuredItem.editMode = false;

            configuredItem.id = item.id;
            var name = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.dataTypes, { id: item.dataType }).name;
            configuredItem.dataTypeId = {
                value: item.dataType,
                editedValue: item.dataType,
                name: name
            };
            configuredItem.startDate = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endDate = {
                value: endDateInit,
                editedValue: endDateInit
            };
            configuredItem.factor = {
                value: item.factor,
                editedValue: item.factor
            };
            configuredItem.type = {
                value: selectedTypeName,
                editedValue: selectedTypeName
            };
            configuredItem.unit = {
                value: item.unit,
                editedValue: item.unit
            };
            return configuredItem;
        },


        // Bind dataTypes object array to use in dom
        bindItems: function bindItems(emissions) {
            var _this5 = this;

            //emissions.emissionDetail.editMode = true;
            this.emissions = emissions.filter(function (emission) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(_this5.dataTypes, { id: emission.dataType });
            }).map(this.prepareItem);
            return this.calculateLastColumnWidth();
        },
        listDataTypes: function listDataTypes(dataTypeId) {
            var _this6 = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/dataEmission/' + dataTypeId).then(function (_ref4) {
                var data = _ref4.data;

                _this6.emissionTypes = data.emissionTypes;
                _this6.co2eData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this6.emissionTypes, function (o) {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(['CO2e'], o.name);
                }));
                //let emissionTypesDropDownData = _.filter(this.emissionTypes, o=> !_.includes(['CO2e'], o.name));
                _this6.emissionTypeNames.text = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this6.emissionTypes, 'name');
                _this6.emissionTypeNames.value = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(_this6.emissionTypes, 'id');
                _this6.rawItems = data.emissionDetail;
                _this6.bindItems(_this6.rawItems);
                _this6.emissions = data.emissionDetail;
                _this6.isLoaded = true;
                return _this6.$Progress.finish();
            });
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this7 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('emission-last-column');
                if (element) {
                    _this7.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init: function init() {
            this.dataType = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.dataTypes, { id: this.route.params.type_id });
            this.listDataTypes(this.dataType.id);
        }
    },
    created: function created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "V0D7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateAudit_vue__ = __webpack_require__("OZT1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc5a690_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateAudit_vue__ = __webpack_require__("+psP");
function injectStyle (ssrContext) {
  __webpack_require__("3kmE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bc5a690"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateAudit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc5a690_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateAudit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("pbXn")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V0gH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SiteCard__ = __webpack_require__("vyRp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_TicketDetailCard__ = __webpack_require__("Hyzh");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TicketList',
    components: {
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_10__components_SiteMultiSelect__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_9__components_YearSelect__["a" /* default */],
        SiteCard: __WEBPACK_IMPORTED_MODULE_8__components_SiteCard__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a,
        TicketDetailCard: __WEBPACK_IMPORTED_MODULE_11__components_TicketDetailCard__["a" /* default */]
    },
    data: function data() {
        return {
            tickets: [],
            ticket: null,
            openDetailList: [],
            ticketTypes: [{
                value: null,
                text: this.$t('auditTitle'),
                disabled: true
            }, {
                value: 1,
                text: this.$t('auditType')
            }, {
                value: 2,
                text: this.$t('actionType')
            }],
            ticketTypesGaranti: [{
                value: null,
                text: this.$t('auditTitle'),
                disabled: true
            }, {
                value: 1,
                text: this.$t('auditTypeGaranti')
            }, {
                value: 2,
                text: this.$t('actionTypeGaranti')
            }],
            ticketType: null,
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            backdoor: 0
        };
    },

    methods: {
        configureTicketList: function configureTicketList(tickets) {
            return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.reduce(tickets, function (result, element) {
                result = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(result), [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, element, { isDetail: false }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, element, { isDetail: true })]);
                return result;
            }, []);
        },
        firstExtendedDate: function firstExtendedDate(ticket) {
            var extendedDates = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            var selectedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1] ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(extendedDates[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1]).format('YYYY-MM-DD') : '-';
            return selectedDate;
        },
        routeToTicketDetail: function routeToTicketDetail(ticket) {
            this.$router.push({
                name: 'ticket-detail',
                params: { site_id: this.selectedSite.id, ticket_id: ticket.id }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        detailToggle: function detailToggle(ticket) {
            this.ticket = ticket;
            if (this.openDetailList.includes(ticket.id)) {
                this.openDetailList = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.openDetailList, function (e) {
                    return e !== ticket.id;
                });
            } else {
                this.openDetailList.push(ticket.id);
            }
        },
        retrieveTicketStatus: function retrieveTicketStatus(state) {
            var status = state == 0 ? this.$t('openTicket') : this.$t('closedTicket');
            return status;
        },
        showCreateTicketModal: function showCreateTicketModal(target) {
            var _this = this;

            // if value of dropdown item(target) equals 1 , it is audit ticket. Otherwise it is action ticket.
            if (target == 1) {
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                    type: 'createTicket',
                    payload: {
                        siteId: this.selectedSite.id,
                        ticketType: 'Audit'
                    }
                });
                this.$nextTick(function () {
                    _this.ticketType = null;
                    _this.$root.$emit('bv::show::modal', 'createTicket', target);
                    _this.$eventHub.$once(_this.$store.state.modal.eventId, function (newTicket) {
                        if (_this.year === __WEBPACK_IMPORTED_MODULE_4_moment___default()().year()) {
                            _this.tickets.push(newTicket);
                        }
                    });
                });
            } else if (target == 2) {
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                    type: 'createTicket',
                    payload: {
                        siteId: this.selectedSite.id,
                        ticketType: 'Action'
                    }
                });
                this.$nextTick(function () {
                    _this.ticketType = null;
                    _this.$root.$emit('bv::show::modal', 'createAction', target);
                    _this.$eventHub.$once(_this.$store.state.modal.eventId, function (newTicket) {
                        if (_this.year === __WEBPACK_IMPORTED_MODULE_4_moment___default()().year()) {
                            _this.tickets.push(newTicket);
                        }
                    });
                });
            }
            this.$refs.ticketTypeRef.hide();
        },

        // Callback for site selector
        selectSite: function selectSite(site) {
            this.selectedSite = site;
            this.$store.state.siteId = site ? __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(site, "id") : null;
            if (site) {
                this.$router.push({
                    name: 'ticket-list',
                    params: { site_id: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(this.selectedSite, "id") },
                    query: { start_date: this.year }
                });
            } else {
                this.selectedSite = null;
                this.$router.push({ name: 'audit', query: { year: this.year } });
            }
            this.backdoor++;
            this.retrieveTickets();
        },
        retrieveTickets: function retrieveTickets() {
            var _this2 = this;

            this.$Progress.start();
            return this.axios.get('/' + this.selectedSite.id + '/audits?start_date=' + this.year).then(function (_ref) {
                var data = _ref.data;

                _this2.tickets = data;
                __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.each(_this2.tickets, function (ticket) {
                    ticket.actionCheckList = ticket.scope;
                    var actions = '';
                    try {
                        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.each(JSON.parse(ticket.scope), function (actionCheck, actionIndex) {
                            if (actionCheck) {
                                actions += '→ ' + _this2.$t(_this2.$store.state.nonconformances[actionIndex - 1].action) + '\n';
                            }
                        });
                        ticket.scope = actions;
                    } catch (error) {
                        console.error(error);
                    }
                });
                _this2.$Progress.finish();
            });
        },
        onYearChange: function onYearChange(newYear) {
            var _this3 = this;

            this.$store.state.year = newYear;
            this.$Progress.start();
            this.$router.push({
                name: 'ticket-list',
                params: { site_id: this.selectedSite.id },
                query: { start_date: this.year }
            });
            this.retrieveTickets().then(function () {
                _this3.$Progress.finish();
            });
        },
        ticketTypeOptions: function ticketTypeOptions(type) {
            var returnType = null;
            if (this.gbId(this.$store.state.user.customerId)) {
                type === 'Audit' ? returnType = 'AuditGaranti' : returnType = 'ActionGaranti';
                return returnType;
            };
            if (!this.gbId(this.$store.state.user.customerId)) {
                return type;
            };
        }
    },
    computed: {
        nonconformanceArticleText: function nonconformanceArticleText() {
            if (this.ticket.ticketType == 'Audit') {
                return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.$store.state.nonconformances, { id: this.ticket.nonconformanceId }), 'article');
            }
        },
        cityCodeToDisplayName: function cityCodeToDisplayName() {
            this.backdoor;
            var found = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.$store.state.cities, { code: this.selectedSite.cityCode });
            if (found) {
                return found.name;
            } else {
                return '-';
            }
        },
        groupDisplayName: function groupDisplayName() {
            this.backdoor;
            if (this.selectedSite) {
                var found = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.$store.state.siteGroups, {
                    id: this.selectedSite.siteGroupId
                });
                return found.display_name;
            } else if (this.selectedSiteGroupId) {
                var _found = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.$store.state.siteGroups, {
                    id: this.selectedSiteGroupId
                });
                return _found.display_name;
            } else {
                return this.$t('all');
            }
        }
    },
    created: function created() {
        this.selectedSite = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
        this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
        this.retrieveTickets();
    }
});

/***/ }),

/***/ "VF5Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteCreate_vue__ = __webpack_require__("8Ck1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9cc248_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteCreate_vue__ = __webpack_require__("Jh3+");
function injectStyle (ssrContext) {
  __webpack_require__("5NlZ")
  __webpack_require__("87kg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a9cc248"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9cc248_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VLQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AtomSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: 'red'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    circleStyle: function circleStyle() {
      return {
        color: this.color,
        fontSize: this.size * 0.24 + 'px'
      };
    },
    lineStyle: function lineStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        borderLeftWidth: this.size / 25 + 'px',
        borderTopWidth: this.size / 25 + 'px',
        borderLeftColor: this.color
      };
    }
  }
});

/***/ }),

/***/ "VX4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"200px"}},[_c('multiselect',{staticStyle:{"border-bottom":"none !important","display":"inline-block"},attrs:{"value":_vm.selectedSite,"internal-search":false,"options":_vm.filteredSites,"close-on-select":true,"showLabels":false,"placeholder":_vm.$t('allSites'),"allow-empty":_vm.allowEmpty,"label":"name","track-by":"id","id":"site-select"},on:{"search-change":_vm.multiselectSearch,"input":_vm.onInput}},[_c('template',{slot:"beforeList"},[_c('div',{staticClass:"buttonOutside"},[_c('button',{staticClass:"allSitesButton",on:{"click":function($event){return _vm.selectAll()}}},[_vm._v(_vm._s(_vm.$t('allSites')))])])]),_vm._v(" "),_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v(_vm._s(_vm.$t('siteError')))])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VZFw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataType":"Veri Tipi","emissionType":"Emisyon Tipi","date":"Son değişme tarihi","dataTypeHasEmission":"Emisyon Faktörü Olan Veri Tipleri"},"en":{"dataType":"Data Type","emissionType":"Emission Type","date":"Last Updated Date","dataTypeHasEmission":"Data Types Have an Emission Factor"}}')
}


/***/ }),

/***/ "VZrM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("UvP+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb67ea5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("INsQ");
function injectStyle (ssrContext) {
  __webpack_require__("G8uj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb67ea5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb67ea5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VbVf":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"createNegativeControl":"Olumsuz Kontrol Oluştur","updateNegativeControl":"Olumsuz Kontrol Düzenle","createResponse":"Yanıt Oluştur","updateResponse":"Yanıt Güncelle","additionalFiles":"Ek Dosyalar","extendedDate":"Uzatılmış Gerçekleştirme Tarihi","auditResponseText":"Alınan Aksiyon","actionResponseText":"Tamamlanan doküman bilgisi ve gerekçe","auditTicket":"Denetim","actionTicket":"Aksiyon"},"en":{"createNegativeControl":"Create Negative Control","updateNegativeControl":"Update Negative Control","createResponse":"Add Response","updateResponse":"Update Response","additionalFiles":"Additional Files","extendedDate":"Extended Completion Date","auditResponseText":"Action taken","actionResponseText":"Complited document and reason","auditTicket":"Audit","actionTicket":"Action"}}')
}


/***/ }),

/***/ "VhMr":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"tonssquaremeter":"tonCO2e / m²","tons":"tonCO2e","mwh":"MWh","TJ-convert":"Since the values were too large, the analysis unit was changed to TJ.","PJ-convert":"Since the values were too large, the analysis unit was changed to PJ.","GWh-convert":"Since the values were too large, the analysis unit was changed to GWh.","TWh-convert":"Since the values were too large, the analysis unit was changed to TWh."},"en":{"tonssquaremeter":"mtCO2e / m²","tons":"mtCO2e","mwh":"MWh","TJ-convert":"Değerler çok büyük olduğundan analiz birimi TJ olarak değiştirilmiştir.","PJ-convert":"Değerler çok büyük olduğundan analiz birimi PJ olarak değiştirilmiştir.","GWh-convert":"Değerler çok büyük olduğundan analiz birimi GWh olarak değiştirilmiştir.","TWh-convert":"Değerler çok büyük olduğundan analiz birimi TWh olarak değiştirilmiştir."}}')
}


/***/ }),

/***/ "Vi8F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-bouncing-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle",style:(_vm.circleStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vw2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreatePost_vue__ = __webpack_require__("MfOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f9f7f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreatePost_vue__ = __webpack_require__("gNB7");
function injectStyle (ssrContext) {
  __webpack_require__("/Lm+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46f9f7f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreatePost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f9f7f8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreatePost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("VbVf")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W5fU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W9Vi":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Reengen Sürdürülebilirlik Platformu","titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)","alert":"Kullanıcı adı veya şifre hatalı","tryAgain":"Lütfen tekrar deneyin.","inviteCanceled":"Bu davet artık geçerli değil","inputPlaceholderUsername":"Kullanıcı Adı","inputPlaceholderPassword":"Şifre","inputPlaceholderCaptcha":"Resimdeki metni girin","loginButton":"Giriş Yap","login":"Giriş Yap","forgotPassword":"Şifremi Unuttum","emptyPassword":"Lütfen şifre girin","emptyEmail":"Lütfen e-posta adresinizi girin","forgot-password-info":"Size şifre sıfırlama talimatları gönderdik. Lütfen emailinizi kontrol edin.","emailPlaceholder":"E-posta","passwordPlaceholder":"Şifre"},"en":{"title":"Reengen Sustainability Platform","titleGaranti":"Environmental Management System Software (EMS)","alert":"Your email or password is incorrect.","tryAgain":"Please try again.","inviteCanceled":"This invitation no longer available","inputPlaceholderUsername":"Username","inputPlaceholderPassword":"Password","inputPlaceholderCaptcha":"Enter image text","loginButton":"Login","login":"Sign In","forgotPassword":"Forgot Password?","emptyPassword":"Please enter your password","emptyEmail":"Please enter your email","forgot-password-info":"We sent password instructions to your email. Please check your email.","emailPlaceholder":"Email","passwordPlaceholder":"Password"}}')
}


/***/ }),

/***/ "WA6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"mt-2 mb-4 mx-3",attrs:{"align-h":_vm.canGetReport() ? 'between' : 'end'}},[(_vm.canGetReport())?_c('b-row',[_c('b-col',{staticClass:"info-row-ie-30"},[_c('b-row',[_c('b-button',{attrs:{"size":"lg"},on:{"click":function($event){return _vm.$refs.excelTypes.show()}}},[_c('i',{staticClass:"far fa-file-excel"})])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-left":"10px","margin-top":"15px"}},[_vm._v(" "+_vm._s(_vm.$t('exportData'))+" ")]),_vm._v(" "),_c('b-modal',{ref:"excelTypes",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('b-form-select',{attrs:{"cols":"6","options":_vm.excelTypes},on:{"change":function($event){return _vm.exportExcel($event)}},model:{value:(_vm.selectedExcelType),callback:function ($$v) {_vm.selectedExcelType=$$v},expression:"selectedExcelType"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('year-select',{staticStyle:{"margin-right":"15px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length && this.$store.state.user.permissions.isAdmin)?_c('site-type-select',{staticStyle:{"margin-right":"25px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),(this.$store.state.user.permissions.isAdmin)?_c('region-multi-select',{staticStyle:{"margin-right":"15px"},attrs:{"selectedRegionId":_vm.selectedSiteGroupId,"regions":_vm.siteGroups},on:{"oninput":_vm.selectSiteGroupId}}):_vm._e(),_vm._v(" "),(this.$store.state.user.permissions.isAdmin || this.$store.state.user.permissions.canEditGoals || this.$store.state.user.assignedSites.length > 1)?_c('site-multi-select',{staticStyle:{"margin-right":"15px"},attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSites},on:{"oninput":_vm.selectSiteId}}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"height":"125px","background-color":"white"},attrs:{"no-gutters":""}},[(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('siteName'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","margin-left":"1px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.selectedSite.code)+" - "+_vm._s(_vm.selectedSite.originalName)+"\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('isOpen'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s((_vm.selectedSite.isOpen == 1) ? _vm.$t('siteOpen') : _vm.$t('siteClosed'))+"\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('cityTitle'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.cityCodeToDisplayName)+"\n            ")])],1):_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('siteCount'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.filteredSites.length)+"\n            ")])],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('regionTitle'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_vm._v("\n                "+_vm._s(_vm.groupDisplayName)+"\n            ")])],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('number of people'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[_c('div',[_vm._v(_vm._s(_vm._f("parseNumber")(_vm.totalStaffCount,'number', _vm.locale)))])])],1),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('areaTitle'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite && _vm.selectedSite.yearlyProperties[this.year])?_c('div',[_vm._v("\n                    "+_vm._s(_vm._f("parseNumber")(_vm.selectedSite.yearlyProperties[this.year].area,'number', _vm.locale))+"\n                    m"),_c('sup',[_vm._v("2")])]):_c('div',[_vm._v("-")])])],1),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t(this.getGroupName('agent')))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.agents)?_c('div',_vm._l((_vm.selectedSite.agents),function(agent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.agentIds[index]}}}},[_vm._v(_vm._s(agent ? agent : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[(this.isbId(this.$store.state.user.customerId))?[_c('span',[_vm._v(_vm._s(_vm.$t('technician')))])]:[_c('span',[_vm._v(_vm._s(_vm.$t('sub-agent')))])]],2),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.subAgents)?_c('div',_vm._l((_vm.selectedSite.subAgents),function(subAgent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.subAgentIds[index]}}}},[_vm._v(_vm._s(subAgent ? subAgent : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t(this.getGroupName('supervisor')))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.supervisors)?_c('div',_vm._l((_vm.selectedSite.supervisors),function(supervisor,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.supervisorIds[index]}}}},[_vm._v(_vm._s(supervisor ? supervisor : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e(),_vm._v(" "),(_vm.selectedSite)?_c('b-col',[_c('b-row',{staticClass:"info-card-site"},[_vm._v("\n                "+_vm._s(_vm.$t('manager'))+"\n            ")]),_vm._v(" "),_c('b-row',{staticClass:"bottom-card-site",staticStyle:{"color":"#707070","margin-top":"10px","font-size":"1rem"},attrs:{"align-h":"center"}},[(_vm.selectedSite.directors)?_c('div',_vm._l((_vm.selectedSite.directors),function(director,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.directorIds[index]}}}},[_vm._v(_vm._s(director ? director : '-')+" ")])],1)}),0):_c('div',[_vm._v("\n                    -\n                ")])])],1):_vm._e()],1),_vm._v(" "),(_vm.selectedSite)?_c('b-row',{staticStyle:{"height":"80px","background-color":"white"},attrs:{"align-h":"center","no-gutters":""}},[_c('b-col',{staticClass:"mt-3",staticStyle:{"text-align":"center"}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('address'))+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedSite.address ? _vm.selectedSite.address : '-'))]),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t('phone'))+":")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedSite.phone ? _vm.selectedSite.phone : '-'))])])],1):_vm._e(),_vm._v(" "),(!this.gbId(this.$store.state.user.customerId))?_c('div',[_c('b-row',{staticStyle:{"margin-top":"1.25rem"},attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"info-card",attrs:{"cols":"3"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#decf3f"},attrs:{"cols":"11"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToData()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-database",staticStyle:{"color":"#decf3f"}})])]),_vm._v(" "),_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"5px"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('dataTitle'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",attrs:{"cols":"3"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#6fd088"},attrs:{"cols":"11"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-tasks",staticStyle:{"color":"#6fd088"}})])]),_vm._v(" "),_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"5px"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('goalsTitle'))+"\n                                ")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToGoalDetail()}}},[_c('b-row',{staticStyle:{"color":"white","margin-top":"10px","font-size":"0.9rem","font-weight":"bold"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('approvedTitle'))+"\n                                ")]),_vm._v(" "),_c('b-row',{staticClass:"info-card-value",attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.totalApprovedGoalCount)+"\n                                ")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToGoalDetail()}}},[_c('b-row',{staticStyle:{"color":"white","margin-top":"10px","font-size":"0.9rem","font-weight":"bold"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('total'))+"\n                                ")]),_vm._v(" "),_c('b-row',{staticClass:"info-card-value",attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.totalGoalCount)+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",attrs:{"cols":"3"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#48b1b4"},attrs:{"cols":"11"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-copy",staticStyle:{"color":"#48b1b4"}})])]),_vm._v(" "),_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"5px"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('documentsTitle'))+"\n                                ")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{staticStyle:{"color":"white","margin-top":"10px","font-size":"0.9rem","font-weight":"bold"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('total'))+"\n                                ")]),_vm._v(" "),_c('b-row',{staticClass:"info-card-value",attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.totalDocCount)+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",attrs:{"cols":"3"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#ba93a5"},attrs:{"cols":"11"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-calendar-check",staticStyle:{"color":"#ba93a5"}})])]),_vm._v(" "),_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"5px"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('auditTitle'))+"\n                                ")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{staticStyle:{"color":"white","margin-top":"10px","font-size":"0.9rem","font-weight":"bold"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('openedTitle'))+"\n                                ")]),_vm._v(" "),_c('b-row',{staticClass:"info-card-value",attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.totalOpenedTicketCount)+"\n                                ")])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{staticStyle:{"color":"white","margin-top":"10px","font-size":"0.9rem","font-weight":"bold"},attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('total'))+"\n                                ")]),_vm._v(" "),_c('b-row',{staticClass:"info-card-value",attrs:{"align-h":"center"}},[_vm._v("\n                                    "+_vm._s(_vm.totalTicketCount)+"\n                                ")])],1)],1)],1)],1)],1)],1)],1):_c('div',[_c('b-row',{staticStyle:{"margin-top":"1.25rem"},attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#DECE3E"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToGoalDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-tasks",staticStyle:{"color":"#DECE3E"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToGoalDetail()}}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"10px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('goalsAndGoalTrackingTitle'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#6FD087"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon",staticStyle:{"margin-right":"30px"}},[_c('i',{staticClass:"fas fa-copy",staticStyle:{"color":"#6FD087"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-right":"20px","height":"2em"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('emergencySituationForms'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#6FD087"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-dropdown',{ref:"ddownWasteRef",staticStyle:{"cursor":"pointer","margin-right":"20px"},attrs:{"data-toggle":"dropdown","id":"ddownWaste","size":"sm","variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('b-row',{staticClass:"info-row-ie-30"},[_c('b-col',{staticClass:"info-card-icon-dropdown"},[_c('i',{staticClass:"fas fa-copy",staticStyle:{"color":"#6FD087"}})]),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer","margin-top":"10px","margin-left":"50px"}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white"}},[_vm._v("\n                                                    "+_vm._s(_vm.$t('wasteManagement'))+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToFormCreate(1)}}},[_vm._v(" "+_vm._s(_vm.$t('wasteTrackingForm'))+" ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToFormCreate(2)}}},[_vm._v(" "+_vm._s(_vm.$t('wasteDeliveryForm'))+" ")])],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#48B1B4"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-list-alt",staticStyle:{"color":"#48B1B4"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"40px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('correctiveActionReport'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#BA92A5"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-file",staticStyle:{"color":"#BA92A5"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{staticStyle:{"font-size":"0.8rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"10px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('meetingNotesAndInformationMails'))+"\n                                ")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"1.25rem"},attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#faa43a"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToData()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-database",staticStyle:{"color":"#faa43a"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToData()}}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"10px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('sourceDataTitle'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#6FD087"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-dropdown',{ref:"ddownChemicalRef",staticStyle:{"cursor":"pointer"},attrs:{"id":"ddownChemical","size":"sm","variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('b-row',{staticClass:"info-row-ie-150"},[_c('b-col',{staticClass:"info-card-icon-dropdown"},[_c('i',{staticClass:"fas fa-copy",staticStyle:{"color":"#6FD087"}})]),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"}},[_c('b-row',{staticStyle:{"font-size":"0.8rem","font-weight":"bold","color":"white","margin-top":"10px","margin-left":"10px"}},[_vm._v("\n                                                    "+_vm._s(_vm.$t('chemicalMaterialUsage'))+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToFormCreate(3)}}},[_vm._v(" "+_vm._s(_vm.$t('chemicalMaterialForm'))+" ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_vm._v(" "+_vm._s(_vm.$t('chemicalMaterialSdsForm'))+" ")])],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#DB7093"}},[_c('b-row',{staticStyle:{"margin":"20px 0"},attrs:{"no-gutters":""}},[_c('b-col',[_c('b-dropdown',{ref:"ddownEducationRef",staticStyle:{"cursor":"pointer"},attrs:{"id":"ddownEducation","size":"sm","variant":"link","toggle-class":"text-decoration-none","no-caret":""}},[_c('template',{slot:"button-content"},[_c('b-row',{staticClass:"info-row-ie-100"},[_c('b-col',{staticClass:"info-card-icon-dropdown"},[_c('i',{staticClass:"fas fa-file-powerpoint",staticStyle:{"color":"#DB7093"}})]),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"10px","margin-left":"30px"}},[_vm._v("\n                                                    "+_vm._s(_vm.$t('educationPresentations'))+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_vm._v(" "+_vm._s(_vm.$t('onlineCoursePresentation'))+" ")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_vm._v(" "+_vm._s(_vm.$t('intraclassCoursePresentation'))+" ")])],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#48B1B4"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-list-alt",staticStyle:{"color":"#48B1B4"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToAuditDetail()}}},[_c('b-row',{staticStyle:{"font-size":"1.0rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"10px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('actionPlan'))+"\n                                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"info-card",staticStyle:{"padding-right":"10px"}},[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"background-color":"#BA92A5"}},[_c('b-row',{staticStyle:{"margin":"25px 0"},attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail()}}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"info-card-icon"},[_c('i',{staticClass:"fas fa-file",staticStyle:{"color":"#BA92A5"}})])])],1),_vm._v(" "),_c('b-col',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToLibrary()}}},[_c('b-row',{staticStyle:{"font-size":"0.9rem","font-weight":"bold","color":"white","margin-top":"10px","margin-right":"10px"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('usageGuide'))+"\n                                ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"1.25rem"},attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"total-carbon-emission-card",attrs:{"cols":"12","xl":"12","lg":"12","md":"12"}},[_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('div',{staticStyle:{"margin":"15px"}},[_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.firstBox === 'carbon' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.firstBox = 'carbon'}}},[_vm._v("\n                    "+_vm._s(_vm.$t('carbonEmission'))+"\n                ")]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 5px","color":"#1c7430"}},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.firstBox === 'consumption' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.firstBox = 'consumption'}}},[_vm._v("\n                    "+_vm._s(_vm.$t('carbonConsumption'))+"\n                ")])])]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"center"}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('carbonEmissionTitle')))])]),_vm._v(" "),(_vm.activeTabs.firstBox === 'carbon')?_c('total-carbon-emissions',{staticStyle:{"margin-top":"30px","min-height":"300px"},attrs:{"initial-emissions":JSON.parse(JSON.stringify(_vm.initialEmissions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"group-type":'scopeGroup'}}):_c('total-carbon-consumptions',{staticStyle:{"margin-top":"30px","min-height":"300px"},attrs:{"initial-consumptions":JSON.parse(JSON.stringify(_vm.initialConsumptions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}})],1)])],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"30px","background-color":"white"},attrs:{"no-gutters":"","align-h":"center"}},_vm._l((_vm.selectedChartDataTypes),function(typeId,index){return _c('b-col',{key:index,attrs:{"cols":"4"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{staticStyle:{"margin":"20px auto"},attrs:{"cols":"12"}},[(_vm.isLoaded)?_c('bar-chart',{staticStyle:{"position":"relative","height":"300px","width":"95%"},attrs:{"chart-data":_vm.consumptions[typeId].barChartData,"options":_vm.consumptions[typeId].barChartOptions,"chart-id":_vm.consumptions[typeId].chartId}}):_vm._e()],1),_vm._v(" "),_c('b-col',{staticStyle:{"font-size":"1em","text-align":"center","margin-top":"-20px","padding-bottom":"20px"},attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.consumptions[typeId].title))]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',{staticStyle:{"font-size":"12px"},attrs:{"no-gutters":"","align-h":"center"}},[_c('table',[_c('thead',[_c('td',[_c('span',{style:({'background-color': _vm.consumptions[typeId].barChartData.datasets[0].backgroundColor, 'font-weight': 'bold', padding: '2px'})},[_vm._v(_vm._s(_vm.year - 1))])]),_vm._v(" "),_c('td',[_c('span',{style:({'background-color': _vm.consumptions[typeId].barChartData.datasets[1].backgroundColor, 'font-weight': 'bold', padding: '2px'})},[_vm._v(_vm._s(_vm.year))])]),_vm._v(" "),_c('td',[_c('b-col',{staticStyle:{"text-align":"center","font-weight":"bold"}},[_c('span',[_vm._v(_vm._s(_vm.$t('changingColumn')))])])],1)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('div',{staticStyle:{"padding":"4px"}},[_c('span',[_vm._v("\n                                                "+_vm._s(_vm._f("parseNumber")(_vm.consumptions[typeId].barChartData.datasets[0].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; }),'float', _vm.locale))+"\n                                            ")]),_vm._v(" "),_c('span',[_vm._v("\n                                                "+_vm._s(_vm.consumptions[typeId].barChartData.datasets[0].unit)+"\n                                            ")])])]),_vm._v(" "),_c('td',[_c('div',{staticStyle:{"padding":"4px"}},[_c('span',[_vm._v("\n                                                "+_vm._s(_vm._f("parseNumber")(_vm.consumptions[typeId].barChartData.datasets[1].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; }),'float', _vm.locale))+"\n                                            ")]),_vm._v(" "),_c('span',[_vm._v("\n                                                "+_vm._s(_vm.consumptions[typeId].barChartData.datasets[1].unit)+"\n                                            ")])])]),_vm._v(" "),_c('td',[_c('b-row',{attrs:{"no-gutters":"","align-h":"around"}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"5"}},[(_vm.calculateRatio(_vm.consumptions[typeId].barChartData.datasets[0].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; }), _vm.consumptions[typeId].barChartData.datasets[1].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; })) < 0)?_c('img',{attrs:{"width":"12px","height":"12px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"12px","height":"12px","src":__webpack_require__("ib3Y")}})]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","align-self":"center"},attrs:{"cols":"5"}},[_vm._v("\n                                                "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.consumptions[typeId].barChartData.datasets[0].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; }), _vm.consumptions[typeId].barChartData.datasets[1].data.reduce(function (accumulator, currentValue) { return accumulator + currentValue; }))),'float', _vm.locale))+"\n                                            ")])],1)],1)])])])])],1)],1)],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WHn1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SiteMultiSelect__ = __webpack_require__("9aru");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'goal-detail',
    components: { SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_8__components_SiteMultiSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_7__components_YearSelect__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_6_vue_multiselect___default.a },
    data: function data() {
        return {
            canEditGoals: this.$store.state.user.permissions.canEditGoals,
            canCreateGoals: this.$store.state.user.permissions.canCreateGoals,
            canApproveGoals: this.$store.state.user.permissions.canApproveGoals,
            descriptionIdTemp: null, // Temporary descriptionId is used in Modal actions
            descriptionOtherTemp: null, // Temporary descriotionOther is used in Modal actions
            isLoaded: false, // Toggles page loading
            filteredSites: this.$store.state.sites, // Workaround for multi-select plugin
            goals: [],
            baseYear: 2015,
            currentYear: new Date().getFullYear(),
            rollbackRow: [],

            allTotals: [],
            rawItems: [], // Original goal object array
            descriptions: [],
            units: [],
            dataTypes: [],
            dataTypesDropdown: [],
            siteProperties: [], // current site properties to identify site details (area,number of workers etc.)
            tempItem: {}, // Temporary object used for inserts
            goalTypes: [{
                value: 0,
                text: this.$t('currentSituation')
            }, {
                value: -1,
                text: this.$t('decrease')
            }, {
                value: 1,
                text: this.$t('raise')
            }],
            approvalTypes: [{
                value: 0,
                text: this.$t('noConfirm')
            }, {
                value: 1,
                text: this.$t('confirm')
            }],
            yearChoices: {
                startYearChoices: [{
                    value: '' + (new Date().getFullYear() - 5),
                    text: '' + (new Date().getFullYear() - 5)
                }, {
                    value: '' + (new Date().getFullYear() - 4),
                    text: '' + (new Date().getFullYear() - 4)
                }, {
                    value: '' + (new Date().getFullYear() - 3),
                    text: '' + (new Date().getFullYear() - 3)
                }, {
                    value: '' + (new Date().getFullYear() - 2),
                    text: '' + (new Date().getFullYear() - 2)
                }, {
                    value: '' + (new Date().getFullYear() - 1),
                    text: '' + (new Date().getFullYear() - 1)
                }],
                endYearChoices: [{
                    value: '' + new Date().getFullYear(),
                    text: '' + new Date().getFullYear()
                }, {
                    value: '' + (new Date().getFullYear() + 1),
                    text: '' + (new Date().getFullYear() + 1)
                }, {
                    value: '' + (new Date().getFullYear() + 2),
                    text: '' + (new Date().getFullYear() + 2)
                }, {
                    value: '' + (new Date().getFullYear() + 3),
                    text: '' + (new Date().getFullYear() + 3)
                }, {
                    value: '' + (new Date().getFullYear() + 4),
                    text: '' + (new Date().getFullYear() + 4)
                }, {
                    value: '' + (new Date().getFullYear() + 5),
                    text: '' + (new Date().getFullYear() + 5)
                }]
            },
            insertMode: false,
            lastColumnWidth: '140px'
        };
    },


    filters: {
        toRatio: function toRatio(dividend, divider) {
            divider = Number(divider.replace('.', '').replace(',', '.'));
            dividend = Number(String(dividend).replace('.', '').replace(',', '.'));
            return divider && dividend !== Infinity ? (100 * ((dividend - divider) / divider)).toFixed(0) : '-';
        },
        descriptionValueToText: function descriptionValueToText(val, descriptions) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(descriptions, { id: val }), 'description_text');
        },
        textToShortText: function textToShortText(val) {
            if (val && val.length > 25) {
                return val.slice(0, 25) + '...';
            } else {
                return val;
            }
        }
    },

    methods: {
        onYearChange: function onYearChange(newYear) {
            this.isLoaded = false;
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'goal-detail',
                params: { site_id: this.route.params.site_id },
                query: { year: this.year }
            });
            this.init();
        },
        setSelectedBaseYear: function setSelectedBaseYear(val, item) {
            var isTempItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            item.startYear.editedValue = val;
            this.setTotalsByDataType(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, 'dataTypeId.editedValue'), item, isTempItem);
        },
        setSelectedEndYear: function setSelectedEndYear(val, item) {
            var isTempItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            item.endYear.editedValue = val;
            this.setTotalsByDataType(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, 'dataTypeId.editedValue'), item, isTempItem);
        },
        selectSite: function selectSite(site) {
            var _this = this;

            if (!site) {
                this.$router.push({ name: 'goal', query: { year: this.year } });
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                this.$router.push({
                    name: 'goal-detail',
                    params: { site_id: site.id },
                    query: {
                        year: this.year
                    }
                });
                this.dataTypes = this.$store.state.dataTypes.filter(function (dataType) {
                    return _this.selectedSite.dataTypes.indexOf(dataType.id) > -1;
                });
                this.listSiteGoals();
            }
        },
        directionValueToText: function directionValueToText(val) {
            if (val === 0) {
                return this.$t('currentSituation');
            } else if (val === -1) {
                return this.$t('decrease');
            } else {
                return this.$t('raise');
            }
        },

        // Sets temporary description value to origin goal object after modal is applied.
        setDescription: function setDescription(goal, descriptionIdTemp, descriptionOtherTemp) {
            if (descriptionIdTemp === -1) {
                goal.descriptionOther.editedValue = descriptionOtherTemp;
                goal.descriptionId.editedValue = null;
            } else {
                goal.descriptionId.editedValue = descriptionIdTemp;
                goal.descriptionOther.editedValue = null;
            }

            if (goal.id) {
                this.$refs['descriptionText' + goal.id][0].hide();
            } else {
                this.$refs.descriptionTextTemp.hide();
            }
        },
        pipeNumber: function pipeNumber(item) {
            var _this2 = this;

            return function (conformedValue) {
                if (item.direction.editedValue === -1) {
                    var unlocalizedConformedValue = Number(_this2.delocalizeValue(item.valueR.editedValue, _this2.locale));
                    return unlocalizedConformedValue > 100 ? '100' : conformedValue;
                } else {
                    return conformedValue;
                }
            };
        },
        calculateRatio: function calculateRatio(item) {
            if (!item.lockN && item.baseYearValue > 0) {
                var delocalizedNumber = Number(this.delocalizeValue(item.valueN.editedValue, this.locale).replace('.', '').replace(',', '.'));
                var calculatedRatio = Number((delocalizedNumber / item.baseYearValue * 100).toFixed(2));
                if (calculatedRatio > 100) {
                    item.valueR.editedValue = this.convertToLocalizedFloat(calculatedRatio - 100, this.locale);
                    item.direction.editedValue = +1;
                } else if (calculatedRatio < 100) {
                    item.valueR.editedValue = this.convertToLocalizedFloat(100 - calculatedRatio, this.locale);
                    item.direction.editedValue = -1;
                } else {
                    item.valueR.editedValue = '0';
                    item.direction.editedValue = 0;
                }
            }
        },
        filterDeletedDataTypes: function filterDeletedDataTypes(siteId) {
            var _this3 = this;

            this.$Progress.start();
            return this.axios.get('/data/' + siteId + '/deleted_data/?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({ year: this.year })).then(function (_ref) {
                var data = _ref.data;

                _this3.dataTypesDropdown = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this3.dataTypesDropdown, function (dataType) {
                    return !__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(data, dataType.value);
                });
                return _this3.$Progress.finish();
            });
        },
        calculateNumber: function calculateNumber(item) {
            if (!item.lockR && item.baseYearValue > 0) {
                var deLocalizedRatio = Number(this.delocalizeValue(item.valueR.editedValue, this.locale).replace('.', '').replace(',', '.'));
                if (item.direction.editedValue === -1) {
                    deLocalizedRatio = deLocalizedRatio > 100 ? 100 : deLocalizedRatio;
                }
                var calculated = (item.baseYearValue + item.direction.editedValue * (item.baseYearValue * (deLocalizedRatio / 100))).toFixed(2);
                item.valueN.editedValue = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(calculated, 'float', this.locale);
            }
        },
        calculateGlobalValueN: function calculateGlobalValueN(item) {
            var deLocalizedRatio = Number(this.delocalizeValue(item.valueR.editedValue, this.locale).replace('.', '').replace(',', '.'));
            if (item.direction.editedValue === -1) {
                deLocalizedRatio = deLocalizedRatio > 100 ? 100 : deLocalizedRatio;
            }

            if (item.baseYearValue > 0) {
                var calculated = (item.baseYearValue + item.direction.editedValue * (item.baseYearValue * (deLocalizedRatio / 100))).toFixed(2);
                item.valueN.editedValue = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(calculated, 'float', this.locale);
            }

            return item.valueN.editedValue;
        },

        //Normalize current and last year values by dividing total values by area and/or staff count.
        normalizeTotals: function normalizeTotals(item, val, baseArea, baseStaffCount, currentArea, currentStaffCount) {
            var dataTypeId = item.dataTypeId.editedValue;
            var dataType = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.$store.state.dataTypes, { id: dataTypeId });
            var dataTypeName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(dataType, 'name');
            var normalizationType = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(dataType, 'normalizationType');
            switch (normalizationType) {
                case 'area':
                    item.baseYearValue = item.baseConsumption / baseArea;
                    item.currentTotals = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.currentConsumption / currentArea || 0, 'float', this.locale);
                    item.unitName = this.$t(item.unitName) + '/m²';
                    break;
                case 'person':
                    item.baseYearValue = item.baseConsumption / baseStaffCount;
                    item.currentTotals = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.currentConsumption / currentStaffCount || 0, 'float', this.locale);
                    item.unitName = this.$t(item.unitName) + this.$t('perPerson');
                    break;
                default:
                    item.baseYearValue = item.baseConsumption ? item.baseConsumption : 0;
                    item.currentTotals = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.currentConsumption || 0, 'float', this.locale);
                    if (dataTypeName === 'uncoated-groundwood' || dataTypeName === 'uncoated-groundwood(block)' || dataTypeName === 'uncoated-freesheet' || dataTypeName === 'uncoated-freesheet(package)') {
                        item.unitName = this.$t(item.unitName) + '/' + this.$t('ay');
                    }
                    break;
            }
            if (item.baseYearValue > 0) {
                item.valueN.value = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.valueR.value && item.direction.value ? item.baseYearValue + Number(item.valueR.value.includes(',') ? item.valueR.value.replace('.', '').replace(',', '.') : item.valueR.value) * item.baseYearValue / 100 * item.direction.value : item.baseYearValue, 'float', this.locale);
                item.valueN.editedValue = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.valueR.value && item.direction.value ? item.baseYearValue + Number(item.valueR.value.includes(',') ? item.valueR.value.replace('.', '').replace(',', '.') : item.valueR.value) * item.baseYearValue / 100 * item.direction.value : item.baseYearValue, 'float', this.locale);
            } else {
                item.valueN.editedValue = item.valueN.value;
            }
        },


        // Set current and last year totals
        setTotalsByDataType: function setTotalsByDataType(val, item, isTempItem) {
            var itemCurrentYear = Number(item.endYear.editedValue);
            var currentYear = new Date().getFullYear();
            currentYear = currentYear < itemCurrentYear ? currentYear : itemCurrentYear;
            var baseYear = Number(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, 'startYear.editedValue')) || 2015;
            var baseYearData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.allTotals, { year: Number(item.startYear.editedValue) });
            var currentYearData = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.allTotals, { year: currentYear });
            var baseConsumption = Number(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(baseYearData, 'values'), { type_id: val }), 'sum_1'));
            item.baseConsumption = baseConsumption || 0;
            var currentConsumption = Number(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(currentYearData, 'values'), { type_id: val }), 'sum_1'));
            item.currentConsumption = currentConsumption || 0;

            var currentArea = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                year: currentYear || new Date().getFullYear()
            }), 'area') || 0;
            var tempCurrentYear = currentYear;
            while (tempCurrentYear >= 2015 && (!currentArea || currentArea === 0)) {
                currentArea = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                    year: tempCurrentYear || new Date().getFullYear()
                }), 'area');
                --tempCurrentYear;
            }
            var currentStaffCount = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                year: currentYear || new Date().getFullYear()
            }), 'staff_count') || 0;
            var baseArea = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                year: baseYear
            }), 'area') || 0;
            var tempBaseYear = baseYear;
            while (tempBaseYear >= 2015 && (!baseArea || baseArea === 0)) {
                baseArea = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                    year: tempBaseYear || 2015
                }), 'area');
                --tempBaseYear;
            }
            var baseStaffCount = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.siteProperties, {
                year: baseYear
            }), 'staff_count') || 0;
            var foundUnitId = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.dataTypes, { id: val }), 'unit_id_1');
            item.unitName = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.units, { id: foundUnitId }), 'name');
            this.normalizeTotals(item, val, baseArea, baseStaffCount, currentArea, currentStaffCount);
            if (isTempItem) {
                this.tempItem = item;
            }
        },


        // Configures the goal object when data type is changed
        configureItemOnDataTypeChange: function configureItemOnDataTypeChange(val, item, isTempItem) {
            if (isTempItem) {
                this.bindTempItemToView();
            }
            item.dataTypeId.editedValue = val;
            this.setTotalsByDataType(val, item, isTempItem);
            this.calculatesGoalValueByDirectionOnChange(item.direction.editedValue, item);
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },


        // Calculates goal value when direction is changed
        calculatesGoalValueByDirectionOnChange: function calculatesGoalValueByDirectionOnChange(val, item) {
            item.direction.editedValue = val;
            if (val === 0) {
                item.valueN.editedValue = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber(item.baseYearValue.toFixed(2), 'float', this.locale);
            } else {
                var deLocalizedRatio = this.convertToNumber(item.valueR.editedValue);
                item.valueN.editedValue = __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].parseNumber((item.baseYearValue + val * (item.baseYearValue * (deLocalizedRatio / 100))).toFixed(2), 'float', this.locale);
            }
        },
        insertRow: function insertRow() {
            this.insertMode = true;
            this.bindTempItemToView();
            this.bindItems(this.rawItems);
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        cancelNewRow: function cancelNewRow() {
            this.insertMode = false;
            this.bindTempItemToView();
        },
        cancelRow: function cancelRow() {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.allTotals, this.rollbackRow);
            this.bindItems(this.rawItems);
            this.goals = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.goals, function (goal) {
                goal.editMode = false;
                goal.editStatusOnly = false;
                return goal;
            });
        },
        makeRowEditable: function makeRowEditable(goalId) {
            this.cancelNewRow();
            this.bindItems(this.rawItems);
            var goal = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.goals, { id: goalId });
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.rollbackRow, this.allTotals);
            if (this.canEditGoals) {
                goal.editMode = true;
            } else if (this.canApproveGoals) {
                goal.editStatusOnly = true;
            }
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        resetWarning: function resetWarning(item, key) {
            item[key].classes['is-invalid'] = false;
            item[key].hasWarn = false;
        },
        bindTempItemToView: function bindTempItemToView() {
            var tempItem = {
                descriptionId: { editedValue: null },
                descriptionOther: { editedValue: null },
                baseYearValue: 0,
                startYear: { editedValue: 0 },
                endYear: { editedValue: 0 },
                currentYearValue: 0,
                direction: { editedValue: 0 },
                dataTypeId: { editedValue: null },
                valueN: { editedValue: '0' },
                valueR: { editedValue: '0' },
                isApproved: { editedValue: 0 },
                unitName: ''
            };

            for (var key in tempItem) {
                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(tempItem[key]) === 'object') {
                    tempItem[key].required = true;
                    tempItem[key].hasWarn = false; // toggles warning message
                    tempItem[key].lockN = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Number field is locked for calculation.
                    tempItem[key].lockR = false; // Number Field and Ratio Field calculates one another and it causes infinite loop. If value is true then Ratio field is locked for calculation.
                    tempItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    tempItem[key].warnMessage = this.$t('required');
                }
            }

            this.tempItem = tempItem;
        },
        isItemValid: function isItemValid(item) {
            var isValid = true;

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(item.valueN.editedValue)) {
                item.valueN.classes['is-invalid'] = true;
                item.valueN.hasWarn = true;
                isValid = false;
            }

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(item.dataTypeId.editedValue)) {
                item.dataTypeId.classes['is-invalid'] = true;
                item.dataTypeId.hasWarn = true;
                isValid = false;
            }

            return isValid;
        },

        // @mehmetcalim: with new design(base-start-end years etc.) create-update-delete-prepare functions will be changed.
        createItem: function createItem() {
            var _this4 = this;

            if (this.isItemValid(this.tempItem)) {
                var arrangedItem = {
                    startYear: this.tempItem.startYear.editedValue,
                    endYear: this.tempItem.endYear.editedValue,
                    siteId: Number(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.route.params, 'site_id')),
                    dataTypeId: this.tempItem.dataTypeId.editedValue,
                    descriptionId: this.tempItem.descriptionId.editedValue,
                    descriptionOther: this.tempItem.descriptionOther.editedValue,
                    direction: this.tempItem.direction.editedValue,
                    isApproved: this.tempItem.isApproved.editedValue,
                    valueN: Number(this.delocalizeValue(this.tempItem.valueN.editedValue, this.locale).replaceAll('.', '').replaceAll(',', '.')),
                    valueR: Number(this.delocalizeValue(this.tempItem.valueR.editedValue, this.locale).replace('.', '').replace(',', '.')),
                    typeUnitId: 1
                };

                this.$Progress.start();
                return this.axios.post('/goals', arrangedItem).then(function (_ref2) {
                    var data = _ref2.data;

                    var result = data;
                    _this4.rawItems.push(result);
                    _this4.bindItems(_this4.rawItems);
                    _this4.cancelNewRow();
                    _this4.init();
                    return _this4.$Progress.finish();
                });
            }
        },
        updateItem: function updateItem(goal) {
            var _this5 = this;

            if (this.isItemValid(goal)) {
                var arrangedItem = {
                    startYear: goal.startYear.editedValue,
                    endYear: goal.endYear.editedValue,
                    dataTypeId: goal.dataTypeId.editedValue,
                    direction: goal.direction.editedValue,
                    valueN: Number(this.delocalizeValue(goal.valueN.editedValue, this.locale).replaceAll('.', '').replaceAll(',', '.')),
                    valueR: Number(this.delocalizeValue(goal.valueR.editedValue, this.locale).replace('.', '').replace(',', '.')),
                    descriptionId: goal.descriptionId.editedValue,
                    descriptionOther: goal.descriptionOther.editedValue,
                    isApproved: goal.isApproved.editedValue,
                    typeUnitId: 1
                };

                this.$Progress.start();
                return this.axios.put('/goals/' + goal.id, arrangedItem).then(function (_ref3) {
                    var data = _ref3.data;

                    var result = data;
                    var rawItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this5.rawItems, { id: goal.id });
                    goal.editMode = false;
                    goal.editStatusOnly = false;
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(rawItem, result);
                    _this5.bindItems(_this5.rawItems);
                    return _this5.$Progress.finish();
                });
            }
        },
        deleteItem: function deleteItem(event, id) {
            var _this6 = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this6.axios.delete('/goals/' + id).catch(function () {
                    _this6.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                    _this6.listSiteGoals();
                });
                _this6.rawItems = _this6.rawItems.filter(function (item) {
                    return item.id !== id;
                });
                _this6.bindItems(_this6.rawItems);
            });
        },


        // Prepare a goal object to use in dom
        prepareItem: function prepareItem(item) {
            if (this.allTotals && new Date(item.start_date).getFullYear() === this.allTotals.year) {
                item.value_n = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.allTotals.values, { type_id: item.data_type_id });
            }
            var configuredItem = {
                currentTotals: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(item, 'currentTotals.sum_1')
            };
            var startDateInit;
            var endDateInit;
            startDateInit = item.start_date != null ? item.start_date.substr(0, item.start_date.indexOf('-')) : '-';
            endDateInit = item.end_date != null ? item.end_date.substr(0, item.end_date.indexOf('-')) : '-';

            configuredItem.editMode = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.goals, { id: item.id }), 'editMode') || false;
            configuredItem.lockN = false;
            configuredItem.lockR = false;

            configuredItem.id = item.id;
            configuredItem.direction = { value: item.direction, editedValue: item.direction };
            var name = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.dataTypes, { id: item.data_type_id }).name;
            configuredItem.dataTypeId = {
                value: item.data_type_id,
                editedValue: item.data_type_id,
                name: name
            };
            var valueR = item.value_r ? item.value_r : 0;
            configuredItem.valueR = {
                value: this.convertToLocalizedFloat(valueR, this.locale),
                editedValue: this.convertToLocalizedFloat(valueR, this.locale)
            };
            var valueN = item.value_n ? item.value_n : 0;
            configuredItem.valueN = {
                value: this.convertToLocalizedFloat(valueN, this.locale),
                editedValue: this.convertToLocalizedFloat(valueN, this.locale)
            };
            configuredItem.descriptionOther = {
                value: item.description_other,
                editedValue: item.description_other
            };
            configuredItem.descriptionId = {
                value: item.description_id,
                editedValue: item.description_id
            };
            configuredItem.startYear = {
                value: startDateInit,
                editedValue: startDateInit
            };
            configuredItem.endYear = {
                value: endDateInit,
                editedValue: endDateInit
            };
            configuredItem.approvedBy = { value: item.approved_by, editedValue: item.approved_by };
            configuredItem.isApproved = { value: item.is_approved, editedValue: item.is_approved };

            for (var key in configuredItem) {
                // If a field editable it has to includes controller fields
                if (configuredItem[key] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(configuredItem[key]) === 'object' && configuredItem[key].hasOwnProperty('value')) {
                    configuredItem[key].classes = {
                        'is-invalid': false,
                        'form-control': true
                    };
                    configuredItem[key].hasWarn = false;
                    configuredItem[key].warnMessage = this.$t('required');
                }
            }

            return configuredItem;
        },


        // Bind goals object array to use in dom
        bindItems: function bindItems(goals) {
            var _this7 = this;

            this.goals = goals.filter(function (goal) {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this7.dataTypes, { id: goal.data_type_id });
            }).map(this.prepareItem);
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.goals, function (goal) {
                _this7.setTotalsByDataType(goal.dataTypeId.editedValue, goal, false);
            });
            return this.calculateLastColumnWidth();
        },
        listSiteGoals: function listSiteGoals() {
            var _this8 = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/goals/' + this.selectedSite.id + '?' + __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify({ year: this.year })).then(function (_ref4) {
                var data = _ref4.data;

                _this8.descriptions = [{ description_text: '-', id: null, disabled: true }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.descriptions));
                __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(_this8.descriptions, function (description) {
                    description.description_text = _this8.$t(description.description_text);
                });
                _this8.siteProperties = data.siteProperties;
                _this8.units = data.units;
                _this8.rawItems = data.goals;
                _this8.allTotals = data.allTotals;
                _this8.bindItems(_this8.rawItems);
                _this8.isLoaded = true;
                return _this8.$Progress.finish();
            });
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this9 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('goal-last-column');
                if (element) {
                    _this9.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        init: function init() {
            var _this10 = this;

            this.selectedSite = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.sites, {
                id: Number(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.route.params, 'site_id'))
            });
            this.$store.state.siteId = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.route.params, 'site_id') ? __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.route.params, 'site_id') : null;
            this.dataTypes = this.$store.state.dataTypes.filter(function (dataType) {
                return _this10.selectedSite.dataTypes.indexOf(dataType.id) > -1;
            });
            this.dataTypesDropdown = [];
            this.dataTypes.forEach(function (dataType) {
                _this10.dataTypesDropdown.push({ value: dataType.id, text: _this10.$t(dataType.name) });
            });
            this.filterDeletedDataTypes(this.selectedSite.id);
            this.listSiteGoals();
        }
    },
    created: function created() {
        this.init();
        window.addEventListener('resize', this.calculateLastColumnWidth);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.calculateLastColumnWidth);
    }
});

/***/ }),

/***/ "WLJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalWasteProduced_vue__ = __webpack_require__("suR7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e6f49d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalWasteProduced_vue__ = __webpack_require__("86JG");
function injectStyle (ssrContext) {
  __webpack_require__("tnBN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e6f49d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalWasteProduced_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e6f49d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalWasteProduced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("nzIB")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wf1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('div',{staticClass:"table-responsive scroll-content"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{attrs:{"colspan":6}},[(!_vm.insertMode && _vm.canEditGoals)?_c('div',{staticClass:"tableBodyCell insert-row",staticStyle:{"align":"center","left":"0","right":"0","margin":"auto","border-bottom":"0px"},on:{"click":function($event){return _vm.insertRow($event.target)}}},[_c('span',[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])]):_vm._e()]),_vm._v(" "),_c('th',{attrs:{"colspan":1}},[_c('div',{staticStyle:{"width":"100px","float":"right"}},[_c('b-form-select',{staticClass:"gray-select",staticStyle:{"height":"41px !important"},attrs:{"options":_vm.yearChoices},model:{value:(_vm.yearSelection),callback:function ($$v) {_vm.yearSelection=$$v},expression:"yearSelection"}})],1)])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('dataTypeColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('locations')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('startYearColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('endYearColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('goalTypeColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('goalRatioColumn')))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.canEditGoals),expression:"canEditGoals"}],staticStyle:{"width":"9em"},attrs:{"id":"goal-last-column"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredGoals),function(goal){return _c('tr',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.bindItems(_vm.rawItems)}}},[_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('div',{attrs:{"title":_vm.$t(goal.dataTypeId.name)}},[_vm._v("\n                            "+_vm._s(_vm.$t(goal.dataTypeId.name))+" ("+_vm._s(_vm.$t(goal.unit.name))+")\n                        ")])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('div',{attrs:{"title":_vm.$t(goal.dataTypeId.name)}},[_vm._v("\n                            "+_vm._s(_vm.getTopNLocation(goal))+"\n                        ")])])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                        "+_vm._s((goal.startYear.editedValue ? goal.startYear.editedValue : '-'))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                        "+_vm._s((goal.endYear.editedValue ? goal.endYear.editedValue : '-'))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                        "+_vm._s(_vm.directionValueToText(goal.direction.value))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(goal.direction.editedValue === 0)?[_vm._v("\n                            -\n                        ")]:[_vm._v("\n                            "+_vm._s(goal.valueR.value)+"\n                        ")]],2)]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.canEditGoals),expression:"canEditGoals"}],staticClass:"edit-column",staticStyle:{"position":"static"},style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable($event.target,goal.id)}}},[_c('i',{staticClass:"fas fa-edit"})])])])])}),0)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wzot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__ = __webpack_require__("N6Uh");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7b1ad6b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__ = __webpack_require__("YNIm");
function injectStyle (ssrContext) {
  __webpack_require__("OZsc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b1ad6b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FlowerSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7b1ad6b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FlowerSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XEq1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',[_c('b-card',[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('b-row',{attrs:{"align-h":"end"}},[(!this.gbId(this.$store.state.user.customerId) && _vm.canGetReport())?_c('b-row',{staticStyle:{"margin-right":"50%"}},[_c('b-col',[_c('b-row',[_c('b-button',{attrs:{"size":"lg"},on:{"click":function($event){return _vm.$refs.excelTypes.show()}}},[_c('i',{staticClass:"far fa-file-excel"})])],1)],1),_vm._v(" "),_c('b-row',{staticStyle:{"margin-left":"10px","margin-top":"15px"}},[_vm._v(" "+_vm._s(_vm.$t('exportData'))+" ")]),_vm._v(" "),_c('b-modal',{ref:"excelTypes",attrs:{"size":"m","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_vm._v("\n                                    "+_vm._s(_vm.$t('folder'))+"\n                                ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1"},[_c('b-col',[_c('b-form-select',{attrs:{"cols":"6","options":_vm.excelTypes},model:{value:(_vm.selectedExcel.type),callback:function ($$v) {_vm.$set(_vm.selectedExcel, "type", $$v)},expression:"selectedExcel.type"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('div',{staticStyle:{"float":"left"}},[_c('span',[_c('el-date-picker',{attrs:{"type":"year","format":"yyyy","value-format":"yyyy","picker-options":_vm.startYearOption},on:{"change":_vm.selectStartYear},model:{value:(_vm.selectedExcel.startYear),callback:function ($$v) {_vm.$set(_vm.selectedExcel, "startYear", $$v)},expression:"selectedExcel.startYear"}})],1),_vm._v(" "),_c('span',[_vm._v("-")]),_vm._v(" "),_c('span',[_c('el-date-picker',{attrs:{"type":"year","format":"yyyy","value-format":"yyyy","picker-options":_vm.endYearOption},on:{"change":_vm.selectEndYear},model:{value:(_vm.selectedExcel.endYear),callback:function ($$v) {_vm.$set(_vm.selectedExcel, "endYear", $$v)},expression:"selectedExcel.endYear"}})],1)])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"left"}},[_c('b-form-select',{attrs:{"cols":"6","options":_vm.locationTypes},model:{value:(_vm.selectedExcel.location),callback:function ($$v) {_vm.$set(_vm.selectedExcel, "location", $$v)},expression:"selectedExcel.location"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.exportExcel()}}},[_vm._v(_vm._s(_vm.$t('export')))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('year-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('region-multi-select',{staticStyle:{"margin-right":"10px"},attrs:{"selectedRegionId":_vm.selectedSiteGroupId,"regions":_vm.siteGroups},on:{"oninput":_vm.selectSiteGroupId}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSites},on:{"oninput":_vm.selectSiteId}})],1)],1),_vm._v(" "),_c('div',{staticClass:"scroll-content",staticStyle:{"overflow-x":"hidden"}},[_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('div',{staticStyle:{"margin":"15px"}},[_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.firstBox === 'carbon' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.firstBox = 'carbon'}}},[_vm._v("\n                        "+_vm._s(_vm.$t('carbonEmission'))+"\n                    ")]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 5px","color":"#1c7430"}},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.firstBox === 'consumption' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.firstBox = 'consumption'}}},[_vm._v("\n                        "+_vm._s(_vm.$t('carbonConsumption'))+"\n                    ")])])]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"center"}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.activeTabs.firstBox === 'carbon' ? _vm.$t('carbonEmissionTitle') : _vm.$t('carbonConsumptionTitle')))])]),_vm._v(" "),(_vm.activeTabs.firstBox === 'carbon')?_c('total-carbon-emissions',{staticStyle:{"margin-top":"30px","min-height":"300px"},attrs:{"initial-emissions":JSON.parse(JSON.stringify(_vm.emissions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"group-type":'scopeGroup'}}):_c('total-carbon-consumptions',{staticStyle:{"margin-top":"30px","min-height":"300px"},attrs:{"initial-consumptions":JSON.parse(JSON.stringify(_vm.consumptions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}})],1),_vm._v(" "),_c('total-waste-produced',{staticStyle:{"margin-top":"30px"},attrs:{"initial-waste":JSON.parse(JSON.stringify(_vm.waste)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}}),_vm._v(" "),_c('intensity-measurements-of-emission',{staticStyle:{"margin-top":"30px"},attrs:{"initial-intensity-report":JSON.parse(JSON.stringify(_vm.intensityReport)),"initial-emissions":JSON.parse(JSON.stringify(_vm.emissions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}}),_vm._v(" "),_c('scope-comparison',{attrs:{"initial-scope-report":JSON.parse(JSON.stringify(_vm.scopeReport)),"initial-emissions":JSON.parse(JSON.stringify(_vm.emissions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}}),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"30px"}},[_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"center","no-gutters":""}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('Emissions Breakdown')))])]),_vm._v(" "),_c('emission-distribution',{staticStyle:{"margin-top":"30px"},attrs:{"initial-emissions":JSON.parse(JSON.stringify(_vm.emissions)),"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId}})],1),_vm._v(" "),(this.$store.state.user.permissions.canViewComparisons)?[(!_vm.selectedSiteId)?_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"30px"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('div',{staticStyle:{"margin":"15px"}},[_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.lastBox === 'emission' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.lastBox = 'emission'}}},[_vm._v("\n                            "+_vm._s(_vm.$t('totalEmission'))+"\n                        ")]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 5px","color":"#1c7430"}},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.lastBox === 'intensity' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.lastBox = 'intensity'}}},[_vm._v("\n                            "+_vm._s(_vm.$t('carbonEmissionDensity'))+"\n                        ")]),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 5px","color":"#1c7430"}},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"card-nav",style:({color: _vm.activeTabs.lastBox === 'consumption' ? '#1c7430' : ''}),on:{"click":function($event){_vm.activeTabs.lastBox = 'consumption'}}},[_vm._v("\n                            "+_vm._s(_vm.$t('carbonConsumption'))+"\n                        ")])])]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"30px"},attrs:{"align-h":"center","no-gutters":""}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('performanceComparison')))])]),_vm._v(" "),(!_vm.selectedSiteId)?_c('performance-comparing',{staticStyle:{"margin-top":"30px"},attrs:{"comparing-data":JSON.parse(JSON.stringify(_vm.comparingData || null)),"type":_vm.activeTabs.lastBox,"selected-site-group-id":_vm.selectedSiteGroupId}}):_vm._e()],1):_vm._e()]:void 0],2)])],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XQs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocMain_vue__ = __webpack_require__("Kco9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3692e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocMain_vue__ = __webpack_require__("HdSg");
function injectStyle (ssrContext) {
  __webpack_require__("2gaT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e3692e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3692e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XT6D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table__ = __webpack_require__("ABj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import moment from 'moment';

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { VueTable: __WEBPACK_IMPORTED_MODULE_1__components_Table__["a" /* default */] },
    name: 'Tags',
    data: function data() {
        var _this = this;

        return {
            tabs: {
                units: {
                    isActive: true,
                    data: [],
                    fields: [
                    // {"key":"name","header":"code","type":"text"},
                    // {"key":"description","header":"description","type":"long-text"},
                    // {"key":"type","header":"type","type":"select"}
                    {
                        key: 'cols.name.value',
                        label: this.$t(this.$t('code')),
                        type: "text"
                    }, {
                        key: 'cols.description.value',
                        label: this.$t('description'),
                        class: 'truncate',
                        type: 'long-text'
                    }, {
                        key: 'cols.type.value',
                        label: this.$t('type'),
                        type: 'select'
                    }, {
                        key: 'edit',
                        label: this.$t('edit')
                    }],
                    name: this.$t('units'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    },
                    actions: {
                        insert: '/unit',
                        update: '/unit',
                        delete: '/unit'
                    },
                    type: 'unit'
                },
                sourceType: {
                    isActive: false,
                    data: [],
                    fields: [
                    // {"key":"name","header":"code","type":"text"},
                    // {"key":"display_name","header":"displayName","type":"text"},
                    // {"key":"description","header":"description","type":"long-text"},
                    // {"key":"units","header":"units","type":"list"}
                    {
                        key: 'cols.name.value',
                        label: this.$t('code'),
                        type: 'text'
                    }, {
                        key: 'cols.display_name.value',
                        label: this.$t('displayName'),
                        type: 'text'
                    }, {
                        key: 'cols.description.value',
                        label: this.$t('description'),
                        class: 'truncate',
                        type: 'long-text'
                    }, {
                        key: 'cols.units.value',
                        label: this.$t('units'),
                        formatter: function formatter(unit) {
                            return _this.shortenList(unit, 3);
                        },
                        type: 'list'
                    }, {
                        key: 'edit',
                        label: this.$t('edit')
                    }],
                    name: this.$t('sourceType'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    },
                    actions: {
                        insert: '/sourceType',
                        update: '/sourceType',
                        delete: '/tag'
                    },
                    type: 'source-type'
                },
                sourceTypeGroup: {
                    isActive: false,
                    data: [],
                    fields: [
                    // {"key":"name","header":"code","type":"text"},
                    // {"key":"display_name","header":"displayName","type":"text"},
                    // {"key":"description","header":"description","type":"long-text"}
                    {
                        key: 'cols.name.value',
                        label: this.$t('code'),
                        type: 'text'
                    }, {
                        key: 'cols.display_name.value',
                        label: this.$t('displayName'),
                        type: 'text'
                    }, {
                        key: 'cols.description.value',
                        label: this.$t('description'),
                        class: 'truncate',
                        type: 'long-text'
                    }, {
                        key: 'edit',
                        label: this.$t('edit')
                    }],
                    name: this.$t('sourceTypeGroup'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    },
                    actions: {
                        insert: '/tag',
                        update: '/tag',
                        delete: '/tag'
                    },
                    type: 'source-type-group'
                },
                scopeGroup: {
                    isActive: false,
                    data: [],
                    fields: [
                    // {"key":"icon","header":"Icon","type":"icon"},
                    // {"key":"name","header":"code","type":"text"},
                    // {"key":"display_name","header":"displayName","type":"text"},
                    // {"key":"description","header":"description","type":"long-text"},
                    // {"key":"scope","header":"scope","type":"relation"},
                    // {"key":"top","header":"top","type":"relation"},
                    // {"key":"sourceTypeGroups","header":"sourceTypeGroups","type":"list"},
                    // {"key":"sourceTypes","header":"sourceTypes","type":"list"},
                    // {"key":"hazardous","header":"hazardous","type":"boolean"}
                    {
                        key: 'cols.icon.value',
                        label: this.$t('Icon'),
                        formatter: function formatter(icon) {
                            return '<i class="' + icon + ' fa-2x"></i>';
                        },
                        type: 'icon'
                    }, {
                        key: 'cols.name.value',
                        label: this.$t('code'),
                        type: 'text'
                    }, {
                        key: 'cols.display_name.value',
                        label: this.$t('displayName'),
                        type: 'text'
                    }, {
                        key: 'cols.description.value',
                        label: this.$t('description'),
                        class: 'truncate',
                        type: 'long-text'
                    }, {
                        key: 'cols.scope.value',
                        label: this.$t('scope'),
                        formatter: function formatter(scope) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(scope, 'name') || '-';
                        },
                        type: 'relation'
                    }, {
                        key: 'cols.top.value',
                        label: this.$t('top'),
                        formatter: function formatter(top) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(top, 'name') || '-';
                        },
                        type: 'relation'
                    }, {
                        key: 'cols.sourceTypeGroups.value',
                        label: this.$t('sourceTypeGroups'),
                        formatter: function formatter(sourceTypeGroup) {
                            return _this.shortenList(sourceTypeGroup, 3);
                        },
                        type: 'list'
                    }, {
                        key: 'cols.sourceTypes.value',
                        label: this.$t('sourceTypes'),
                        formatter: function formatter(sourceType) {
                            return _this.shortenList(sourceType, 3);
                        },
                        type: 'list'
                    }, {
                        key: 'cols.hazardous.value',
                        label: this.$t('hazardous'),
                        formatter: function formatter(isHazardous) {
                            return '<i class="fas fa-lg ' + (isHazardous ? 'fa-check text-success' : 'fa-times text-danger') + '"></i>';
                        },
                        type: 'boolean'
                    }, {
                        key: 'edit',
                        label: this.$t('edit')
                    }],
                    name: this.$t('scopeGroup'),
                    style: {
                        border: { 'border-bottom': '3px solid #022B49' },
                        tab: { 'color': '#022B49' },
                        badge: { 'background-color': '#022B49' }
                    },
                    actions: {
                        insert: '/scopeGroup',
                        update: '/scopeGroup',
                        delete: '/tag'
                    },
                    type: 'scope-group'
                }
            },
            error: {},
            activeTab: 'units',
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            isLoaded: false,
            scopes: [],
            tops: [],
            modalType: null,
            editedItem: null,
            removingProcess: false,
            inProgress: false,
            searchInput: '',
            showModal: false,
            sourceTypeList: [],
            sourceTypeGroupList: [],
            sourceTypeMap: {},
            sourceTypeGroupMap: {},
            isChanged: false,
            hazardous: {},
            unitList: [],
            unitMap: {},
            unitTypes: ['mass', 'volume', 'energy', 'other'],
            unitFilter: {
                'mass': [],
                'volume': [],
                'energy': [],
                'other': []
            },
            unitTypeMap: { id: {}, name: {} }
        };
    },

    methods: {
        getIconCode: function getIconCode() {
            return this.editedItem.cols['icon'].editedValue + ' fa-2x';
        },
        getExampleConversion: function getExampleConversion(from, to, value) {
            if (from && to && value != null) {
                var val = 1 * __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(value);
                return '1 ' + this.unitMap[from] + ' = ' + val + ' ' + this.unitMap[to];
            }
        },
        forceUpdate: function forceUpdate() {
            this.isChanged = true;
            this.$forceUpdate();
        },
        activate: function activate(key) {
            var _this2 = this;

            this.activeTab = key;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.tabs, function (tab, tabKey) {
                _this2.currentPage = 1;
                tab.isActive = key == tabKey;
            });
        },
        filterData: function filterData() {
            this.currentPage = 1;
            this.forceUpdate();
        },
        itemsForList: function itemsForList(data) {
            var searchedDataItems = this.searchData(data);
            this.totalRows = searchedDataItems.length;
            return searchedDataItems;
            // return searchedDataItems.slice(
            //             (this.currentPage - 1) * this.perPage,
            //             this.currentPage * this.perPage,
            //         );
        },
        searchData: function searchData(dataItems) {
            var _this3 = this;

            if (this.searchInput.length < 1) {
                return dataItems;
            } else {
                switch (this.activeTab) {
                    case 'units':
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataItems, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.name.value), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.description.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.type.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput));
                        });
                    case 'sourceType':
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataItems, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.name.value), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.display_name.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.description.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(o.cols.units.value, 'label'), ' ')), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput));
                        });
                    case 'sourceTypeGroup':
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataItems, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.name.value), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.display_name.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.description.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput));
                        });
                    case 'scopeGroup':
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataItems, function (o) {
                            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.name.value), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.display_name.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.$t(o.cols.description.value)), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.scope.value.name), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(o.cols.top.value.name), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput)) || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(o.cols.sourceTypeGroups.value, 'label'), ' ')), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toLower(_this3.searchInput));
                        });
                    default:
                        return dataItems;
                }
            }
        },
        shortenList: function shortenList(dataList, maxLength) {
            if (dataList == undefined || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(dataList)) {
                return "-";
            }
            var nameList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(dataList, 'label');
            if (dataList.length > maxLength) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(nameList.slice(0, maxLength), ", ") + " " + this.$t('and') + " " + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toString(nameList.length - maxLength) + " " + this.$t('more');
            } else {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(nameList, ", ");
            }
        },
        updateTypeGroupUnitFactorOptions: function updateTypeGroupUnitFactorOptions(selectedData) {
            var _this4 = this;

            var selectedTypes = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(selectedData, function (o) {
                if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(selectedTypes, _this4.unitTypeMap.id[o]) && _this4.unitTypeMap.id[o] != 'other') {
                    selectedTypes.push(_this4.unitTypeMap.id[o]);
                }
            });
            this.editedItem.cols['source_factors'].editedValue = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(this.editedItem.cols['source_factors'].editedValue, selectedTypes);
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(selectedTypes, function (selectedType) {
                if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.editedItem.cols['source_factors'].editedValue), selectedType)) {
                    _this4.editedItem.cols['source_factors'].editedValue[selectedType] = {};
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this4.unitTypes, function (unitType) {
                        if (!(unitType == selectedType || unitType == 'other')) {
                            _this4.editedItem.cols['source_factors'].editedValue[selectedType][unitType] = {
                                from: null,
                                to: null,
                                value: null
                            };
                        }
                    });
                }
            });
            this.forceUpdate();
        },
        checkSourceTypeGroups: function checkSourceTypeGroups(selectedData, action) {
            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(this.editedItem.sourceTypeGroups.editedValue)) {
                this.editedItem.selectedSourceTypeGroup = null;
            } else if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(this.editedItem.sourceTypeGroups.editedValue, this.editedItem.selectedSourceTypeGroup)) {
                this.editedItem.selectedSourceTypeGroup = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(this.editedItem.sourceTypeGroups.editedValue);
            }

            if (action == 'left') {
                var newSourceTypes = {};
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.editedItem.sourceTypes.editedValue, function (val, key) {
                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(selectedData, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(key))) {
                        newSourceTypes[key] = val;
                    }
                });
                this.editedItem.sourceTypes.editedValue = newSourceTypes;
            }

            this.forceUpdate();
        },
        showModalSourceTypeSelect: function showModalSourceTypeSelect() {
            return this.editedItem.selectedSourceTypeGroup != null;
        },
        generateNewItem: function generateNewItem() {
            var getId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var item = {
                name: this.editedItem.cols.name.editedValue,
                description: this.editedItem.cols.description.editedValue
            };
            if (this.modalType == 'update') {
                item['id'] = getId ? this.editedItem.id : null;
            }
            if (this.activeTab != 'units') {
                item['display_name'] = this.editedItem.cols.display_name.editedValue;
                item['type'] = this.editedItem.type;
            } else {
                item['type'] = this.editedItem.cols.type.editedValue;
            }
            if (this.activeTab == 'sourceType') {
                item['original_units'] = this.editedItem.units.value;
                item['units'] = this.editedItem.units.editedValue;
                item['source_factors'] = [];
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.editedItem.cols['source_factors'].editedValue, function (unitType) {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(unitType, function (unitValue) {
                        if (unitValue.from && unitValue.to && unitValue.value != null) {
                            item['source_factors'].push({
                                'current_unit_id': unitValue.from,
                                'target_unit_id': unitValue.to,
                                'value': __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toNumber(unitValue.value)
                            });
                        }
                    });
                });
            } else if (this.activeTab == 'scopeGroup') {
                item['scope'] = this.editedItem.scope.editedValue;
                item['top'] = this.editedItem.top.editedValue;

                item['sourceTypeGroups'] = this.editedItem.sourceTypeGroups.editedValue;
                item['sourceTypes'] = this.editedItem.sourceTypes.editedValue;
                item['hazardous'] = this.editedItem.hazardous.editedValue;

                item['original_sourceTypeGroups'] = this.editedItem.sourceTypeGroups.value;
                item['original_sourceTypes'] = this.editedItem.sourceTypes.value;
                item['original_hazardous'] = this.editedItem.hazardous.value;

                item['hazardous_id'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.hazardous, 'id');

                item['sourceTypeGroupsHeader'] = this.editedItem.cols.sourceTypeGroupsHeader.editedValue;
                item['icon'] = this.editedItem.cols.icon.editedValue;
            }
            return item;
        },
        deleteItem: function deleteItem() {
            var _this5 = this;

            this.inProgress = true;
            var id = this.editedItem.id;
            return this.axios.delete(this.tabs[this.activeTab].actions.delete + '/' + id).then(function (_ref) {
                var data = _ref.data;

                if (data.result) {
                    _this5.$refs.itemEditModal.hide();
                    _this5.init();
                } else {
                    _this5.removingProcess = false;
                    _this5.inProgress = false;
                    return _this5.$message({
                        type: 'error',
                        message: _this5.$t('targetInUse')
                    });
                }
            });
        },
        insertItem: function insertItem() {
            var _this6 = this;

            this.inProgress = true;
            var newItem = this.generateNewItem(false);
            return this.axios.post(this.tabs[this.activeTab].actions.insert, newItem).then(function () {
                _this6.$refs.itemEditModal.hide();
                _this6.init();
            });
        },
        updateItem: function updateItem() {
            var _this7 = this;

            this.inProgress = true;
            var newItem = this.generateNewItem(true);
            return this.axios.put(this.tabs[this.activeTab].actions.update, newItem).then(function () {
                _this7.$refs.itemEditModal.hide();
                _this7.init();
            });
        },
        cancelItem: function cancelItem() {
            this.$refs.itemEditModal.hide();
        },
        openInsertItemModal: function openInsertItemModal(key) {

            this.modalType = 'insert';

            this.editedItem = { cols: {} };
            this.editedItem.cols['name'] = { value: '', editedValue: '' };
            this.editedItem.cols['description'] = { value: '', editedValue: '' };

            if (key != 'unit') {
                this.editedItem.cols['display_name'] = { value: '', editedValue: '' };
                this.editedItem['type'] = key;
            } else {
                this.editedItem.cols['type'] = { value: 'other', editedValue: 'other' };
            }

            if (key == 'source-type') {
                this.editedItem['units'] = { value: [], editedValue: [] };
                this.editedItem.cols['source_factors'] = { value: {}, editedValue: {} };
            } else if (key == 'scope-group') {
                this.editedItem['scope'] = { value: {}, editedValue: {} };
                this.editedItem['top'] = { value: {}, editedValue: {} };
                this.editedItem['sourceTypeGroups'] = { value: [], editedValue: [] };
                this.editedItem['sourceTypes'] = { value: {}, editedValue: {} };
                this.editedItem['hazardous'] = { value: false, editedValue: false };
                this.editedItem.cols['sourceTypeGroupsHeader'] = { value: "Usage For", editedValue: "Usage For" };
                this.editedItem.cols['icon'] = { value: "far fa-question-circle", editedValue: "far fa-question-circle" };
            }
            this.$refs.itemEditModal.show();
        },
        openEditModal: function openEditModal(item) {
            this.modalType = 'update';
            this.editedItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(item);
            this.editedItem['type'] = this.tabs[this.activeTab].type;
            this.$refs.itemEditModal.show();
        },
        onShowModal: function onShowModal() {
            this.showModal = true;
        },
        onHideModal: function onHideModal() {
            if (this.modalType == 'insert') {
                this.editedItem = null;
            } else {
                this.revertItem(this.editedItem);
            }
            //this.inProgress = false;
            this.removingProcess = false;
            this.showModal = false;
            this.modalType = null;
        },
        revertItem: function revertItem(item) {
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(item.cols, function (col) {
                col['editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(col, 'value');
            });
            if (this.activeTab == 'sourceType') {
                item.units['editedValue'] = item.units['value'];
            }
            if (this.activeTab == 'scopeGroup') {
                item.sourceTypeGroups['editedValue'] = item.sourceTypeGroups['value'];
                item['selectedSourceTypeGroup'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, 'sourceTypeGroups'), 'editedValue') == undefined ? null : __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(item, 'sourceTypeGroups'), 'editedValue'));

                item.sourceTypes['editedValue'] = item.sourceTypes['value'];
                /*
                let sourceGroupRel =  _.filter(item.rawData.relations, o=> _.get(o, 'rel_type') == 'source-group')
                _.each(_.groupBy(sourceGroupRel, 'tag_2'), (rel,relId)=>{
                    item.sourceTypes.editedValue[relId] = item.sourceTypes.value[relId];
                });
                */

                item.scope['editedValue'] = item.scope['value'];
                item.top['editedValue'] = item.top['value'];
                item.hazardous['editedValue'] = item.hazardous['value'];
            }
        },
        prepareData: function prepareData() {
            var _this8 = this;

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.tabs.sourceType.data, function (data) {
                data['units'] = {};
                data.units['value'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.rawData.units, 'id');
                data.units['editedValue'] = data.units['value'];

                var selectedTypes = [];
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(data.units.value, function (o) {
                    if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(selectedTypes, _this8.unitTypeMap.id[o]) && _this8.unitTypeMap.id[o] != 'other') {
                        selectedTypes.push(_this8.unitTypeMap.id[o]);
                    }
                });
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(selectedTypes, function (selectedType) {
                    if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.cols['source_factors'].value), selectedType)) {
                        data.cols['source_factors'].value[selectedType] = {};
                    }
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(_this8.unitTypes, function (unitType) {
                        if (!(unitType == selectedType || unitType == 'other') && !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.cols['source_factors'].value[selectedType]), unitType)) {
                            data.cols['source_factors'].value[selectedType][unitType] = {
                                from: null,
                                to: null,
                                value: null
                            };
                        }
                    });
                });
            });

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.tabs, function (tab) {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(tab.data, function (data) {
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(data.cols, function (col) {
                        col['editedValue'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(col, 'value');
                    });
                });
            });

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(this.tabs.scopeGroup.data, function (data) {
                var sourceGroupRel = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(data.rawData.relations, function (o) {
                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(o, 'rel_type') == 'source-group';
                });

                data['sourceTypeGroups'] = {};
                data.sourceTypeGroups['value'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(sourceGroupRel, 'tag_2'));
                data.sourceTypeGroups['editedValue'] = data.sourceTypeGroups['value'];

                data['selectedSourceTypeGroup'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceTypeGroups'), 'editedValue') == undefined ? null : __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceTypeGroups'), 'editedValue'));

                data['sourceTypes'] = { value: {}, editedValue: {} };
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.groupBy(sourceGroupRel, 'tag_2'), function (rel, relId) {
                    data.sourceTypes.value[relId] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(rel, 'rel_id');
                    data.sourceTypes.editedValue[relId] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.clone(data.sourceTypes.value[relId]);
                });

                data['scope'] = {};
                data.scope['value'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'rawData'), 'scope');
                data.scope['editedValue'] = data.scope['value'];

                data['top'] = {};
                data.top['value'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'rawData'), 'top');
                data.top['editedValue'] = data.top['value'];

                data['hazardous'] = {};
                data.hazardous['value'] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'rawData'), 'hazardous') != undefined;
                data.hazardous['editedValue'] = data.hazardous['value'];
            });
        },
        init: function init() {
            var _this9 = this;

            this.isLoaded = true;
            this.$Progress.start();
            return this.axios.get('/getTagManagement').then(function (_ref2) {
                var data = _ref2.data;

                // TODO: extract cols and remove editedValue from data 
                _this9.tabs.units.data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'units');
                _this9.tabs.sourceType.data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceType');
                _this9.tabs.sourceTypeGroup.data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceTypeGroup'); //sou
                _this9.tabs.scopeGroup.data = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'scopeGroup');
                _this9.scopes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'scopes');
                _this9.tops = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'tops');
                _this9.hazardous = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'hazardous');

                _this9.unitMap = {};
                _this9.sourceTypeMap = {};
                _this9.sourceTypeGroupMap = {};

                _this9.unitList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'units'), function (nData) {
                    _this9.unitMap[nData.id] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nData, 'cols'), 'name'), 'value');
                    _this9.unitTypeMap.name[_this9.unitMap[nData.id]] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nData, 'cols'), 'type'), 'value');
                    _this9.unitTypeMap.id[nData.id] = _this9.unitTypeMap.name[_this9.unitMap[nData.id]];
                    // nData.cols.type.value != null 
                    //     ? this.unitFilter[nData.cols.type.value].push({id:nData.cols.id.value, name:nData.cols.name.value})
                    //     : '';
                    if (_this9.unitFilter[nData.cols.type.value]) {
                        _this9.unitFilter[nData.cols.type.value].push({ id: nData.cols.id.value, name: nData.cols.name.value });
                    }
                    return {
                        id: nData.id,
                        label: _this9.unitMap[nData.id]
                    };
                });
                _this9.sourceTypeList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceType'), function (nData) {
                    _this9.sourceTypeMap[nData.id] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nData, 'cols'), 'name'), 'value');
                    return {
                        id: nData.id,
                        label: _this9.sourceTypeMap[nData.id]
                    };
                });
                _this9.sourceTypeGroupList = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(data, 'sourceTypeGroup'), function (nData) {
                    _this9.sourceTypeGroupMap[nData.id] = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(nData, 'cols'), 'name'), 'value');
                    return {
                        id: nData.id,
                        label: _this9.sourceTypeGroupMap[nData.id]
                    };
                });
            }).then(function () {
                _this9.prepareData();
                _this9.isLoaded = false;
                _this9.inProgress = false;
                return _this9.$Progress.finish();
            });
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "XeEE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y02O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__("Kv4T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237a9331_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__("tsuK");
function injectStyle (ssrContext) {
  __webpack_require__("HAYC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-237a9331"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_237a9331_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("PJHr")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YHML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__ = __webpack_require__("2u3K");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31ad46aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__ = __webpack_require__("sCjN");
function injectStyle (ssrContext) {
  __webpack_require__("9laN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31ad46aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31ad46aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HalfCircleSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "YNIm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flower-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"dots-container",style:(_vm.dotsContainerStyle)},[_c('div',{staticClass:"bigger-dot",style:(_vm.biggerDotStyle)},[_c('div',{staticClass:"smaller-dot",style:(_vm.smallerDotStyle)})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YRlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YUx5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("zkRI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0458ce94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__ = __webpack_require__("IkwQ");
function injectStyle (ssrContext) {
  __webpack_require__("6ZiH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0458ce94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0458ce94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoopingRhombusesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Dashboard_Dashboard__ = __webpack_require__("+c8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Data_Detail__ = __webpack_require__("6rjG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Data_Main__ = __webpack_require__("H9Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Data_Summary__ = __webpack_require__("8zPf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Data_SiteSelector__ = __webpack_require__("fK5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Login__ = __webpack_require__("lmfZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_ForgotPassword__ = __webpack_require__("eRj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_ResetPassword__ = __webpack_require__("oisi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Error__ = __webpack_require__("xLdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_Signup__ = __webpack_require__("3G/k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Main__ = __webpack_require__("VZrM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Analysis_AnalyzeMain__ = __webpack_require__("uVGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Analysis_Tabs_AnalyzeGeneral__ = __webpack_require__("OBCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Analysis_Tabs_Scope1__ = __webpack_require__("CYan");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_Analysis_Tabs_Scope2__ = __webpack_require__("TMvF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_Analysis_Tabs_Scope3__ = __webpack_require__("M5Z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_Analysis_Tabs_Compare__ = __webpack_require__("owG+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_Goal_Summary__ = __webpack_require__("osav");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_Goal_Detail__ = __webpack_require__("lpBm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_Doc_Files_Summary__ = __webpack_require__("FAQm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_Doc_Forms_FormSummary__ = __webpack_require__("tIMn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_Doc_Forms_FormCreate__ = __webpack_require__("eUUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_Doc_Forms_FormDetail__ = __webpack_require__("DTQR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Doc_Forms_SiteForms__ = __webpack_require__("wwh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_Doc_Files_Detail__ = __webpack_require__("xxx0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_Doc_DocMain__ = __webpack_require__("XQs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_Audit_AuditMain__ = __webpack_require__("DsNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_Audit_Audits_Audit__ = __webpack_require__("6/jI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_Audit_AuditRecords_Summary__ = __webpack_require__("wMmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_Audit_AuditRecords_Detail__ = __webpack_require__("kAfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_Audit_Audits_TicketDetail__ = __webpack_require__("Ag4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_Audit_Audits_TicketList__ = __webpack_require__("dC+q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_Setting_Admin__ = __webpack_require__("Y02O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_Setting_Master__ = __webpack_require__("NTv0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_Setting_General__ = __webpack_require__("moi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_Setting_Site__ = __webpack_require__("qi7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_Setting_SiteEdit__ = __webpack_require__("ZFP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_Setting_SiteCreate__ = __webpack_require__("VF5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_Setting_Permissions__ = __webpack_require__("eI+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_Setting_PermissionEdit__ = __webpack_require__("Rf5t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_Setting_Users__ = __webpack_require__("PZ+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_Setting_UserProfile__ = __webpack_require__("T1Ap");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_Setting_Sources__ = __webpack_require__("3NLE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_Setting_Tags__ = __webpack_require__("29vg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_Setting_EmissionLibrary__ = __webpack_require__("F+xA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_Setting_Locations__ = __webpack_require__("u5OB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_Setting_AdminGoal__ = __webpack_require__("jQra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_Setting_EmissionTable__ = __webpack_require__("tSFd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_Setting_EmissionDetail__ = __webpack_require__("SKnS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_Setting_UnitPrice__ = __webpack_require__("6oxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_Setting_UnitPriceDetail__ = __webpack_require__("IByG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_Setting_LoadDataViaExcel__ = __webpack_require__("dyab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_Register_Register__ = __webpack_require__("dQWc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_Library_Library__ = __webpack_require__("+ol3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_mobile_detect__ = __webpack_require__("UMwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_mobile_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_mobile_detect__);




























































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var md = new __WEBPACK_IMPORTED_MODULE_58_mobile_detect___default.a(window.navigator.userAgent);
var isMobile = false;
if (md.isPhoneSized()) {
    isMobile = true;
}

__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.isMobile = isMobile;
__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.isTablet = md.tablet();

var routes = [{ name: 'error', path: '*', component: __WEBPACK_IMPORTED_MODULE_12__views_Error__["a" /* default */] }, {
    name: 'main',
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_14__views_Main__["a" /* default */],
    children: [{
        name: 'data-sites',
        path: '/data',
        component: __WEBPACK_IMPORTED_MODULE_8__views_Data_SiteSelector__["a" /* default */]
    }, {
        name: 'data-main',
        path: '/data/:site_id/types',
        component: __WEBPACK_IMPORTED_MODULE_6__views_Data_Main__["a" /* default */],
        children: [{
            name: 'site-data-types',
            path: '/data/:site_id/types',
            component: __WEBPACK_IMPORTED_MODULE_7__views_Data_Summary__["a" /* default */]
        }, {
            name: 'data-detail',
            path: ':type_id',
            component: __WEBPACK_IMPORTED_MODULE_5__views_Data_Detail__["a" /* default */]
        }]
    }, {
        name: 'analysis',
        path: '/analysis',
        component: __WEBPACK_IMPORTED_MODULE_15__views_Analysis_AnalyzeMain__["a" /* default */],
        children: [{
            name: 'general-analysis',
            path: 'general',
            component: __WEBPACK_IMPORTED_MODULE_16__views_Analysis_Tabs_AnalyzeGeneral__["a" /* default */]
        }, {
            name: 'scope-1',
            path: 'scope1',
            component: __WEBPACK_IMPORTED_MODULE_17__views_Analysis_Tabs_Scope1__["a" /* default */]
        }, {
            name: 'scope-2',
            path: 'scope2',
            component: __WEBPACK_IMPORTED_MODULE_18__views_Analysis_Tabs_Scope2__["a" /* default */]
        }, {
            name: 'scope-3',
            path: 'scope3',
            component: __WEBPACK_IMPORTED_MODULE_19__views_Analysis_Tabs_Scope3__["a" /* default */]
        }, {
            name: 'compare',
            path: 'Compare',
            component: __WEBPACK_IMPORTED_MODULE_20__views_Analysis_Tabs_Compare__["a" /* default */]
        }]
    }, {
        name: 'goal',
        path: '/goals',
        component: __WEBPACK_IMPORTED_MODULE_21__views_Goal_Summary__["a" /* default */]
    }, {
        name: 'goal-detail',
        path: '/goals/:site_id',
        component: __WEBPACK_IMPORTED_MODULE_22__views_Goal_Detail__["a" /* default */]
    }, {
        name: 'doc',
        path: '/docs',
        component: __WEBPACK_IMPORTED_MODULE_29__views_Doc_DocMain__["a" /* default */],
        children: [{
            name: 'site-files',
            path: ':site_id/files',
            component: __WEBPACK_IMPORTED_MODULE_28__views_Doc_Files_Detail__["a" /* default */]
        }, {
            name: 'files',
            path: 'files',
            component: __WEBPACK_IMPORTED_MODULE_23__views_Doc_Files_Summary__["a" /* default */]
        }, {
            name: 'forms',
            path: 'forms',
            component: __WEBPACK_IMPORTED_MODULE_24__views_Doc_Forms_FormSummary__["a" /* default */]
        }, {
            name: 'site-forms',
            path: ':site_id/forms',
            component: __WEBPACK_IMPORTED_MODULE_27__views_Doc_Forms_SiteForms__["a" /* default */]
        }, {
            name: 'form-detail',
            path: ':site_id/forms/:form_id',
            component: __WEBPACK_IMPORTED_MODULE_26__views_Doc_Forms_FormDetail__["a" /* default */]
        }, {
            name: 'form-create',
            path: ':site_id/forms/create/:form_type',
            component: __WEBPACK_IMPORTED_MODULE_25__views_Doc_Forms_FormCreate__["a" /* default */]
        }]
    }, {
        name: 'auditMain',
        path: '/audits',
        component: __WEBPACK_IMPORTED_MODULE_30__views_Audit_AuditMain__["a" /* default */],
        children: [{
            name: 'Summary',
            path: 'records',
            component: __WEBPACK_IMPORTED_MODULE_32__views_Audit_AuditRecords_Summary__["a" /* default */]
        }, {
            name: 'Detail',
            path: 'records/:site_id',
            component: __WEBPACK_IMPORTED_MODULE_33__views_Audit_AuditRecords_Detail__["a" /* default */]
        }, {
            name: 'ticket-list',
            path: 'audits/:site_id',
            component: __WEBPACK_IMPORTED_MODULE_35__views_Audit_Audits_TicketList__["a" /* default */]
        }, {
            name: 'audit',
            path: 'audits',
            component: __WEBPACK_IMPORTED_MODULE_31__views_Audit_Audits_Audit__["a" /* default */]
        }]
    }, {
        name: 'ticket-detail',
        path: 'audits/:site_id/:ticket_id',
        component: __WEBPACK_IMPORTED_MODULE_34__views_Audit_Audits_TicketDetail__["a" /* default */]
    }, {
        name: 'dashboard',
        path: '/dashboard',
        component: __WEBPACK_IMPORTED_MODULE_4__views_Dashboard_Dashboard__["a" /* default */]
    }, {
        name: 'admin',
        path: '/admin',
        component: __WEBPACK_IMPORTED_MODULE_36__views_Setting_Admin__["a" /* default */],
        children: [{
            name: 'admin-general',
            path: 'general',
            component: __WEBPACK_IMPORTED_MODULE_38__views_Setting_General__["a" /* default */]
        }, {
            name: 'admin-site',
            path: 'sites',
            component: __WEBPACK_IMPORTED_MODULE_39__views_Setting_Site__["a" /* default */]
        }, {
            name: 'admin-site-create',
            path: 'sites/create',
            component: __WEBPACK_IMPORTED_MODULE_41__views_Setting_SiteCreate__["a" /* default */]
        }, {
            name: 'admin-site-edit',
            path: 'sites/:site_id',
            component: __WEBPACK_IMPORTED_MODULE_40__views_Setting_SiteEdit__["a" /* default */]
        }, {
            name: 'permissions',
            path: 'permissions',
            component: __WEBPACK_IMPORTED_MODULE_42__views_Setting_Permissions__["a" /* default */]
        }, {
            path: 'permissions/edit/:id',
            name: 'edit-permissions',
            component: __WEBPACK_IMPORTED_MODULE_43__views_Setting_PermissionEdit__["a" /* default */]
        }, {
            path: 'permissions/add',
            name: 'add-permission',
            component: __WEBPACK_IMPORTED_MODULE_43__views_Setting_PermissionEdit__["a" /* default */]
        }, {
            name: 'users',
            path: 'users',
            component: __WEBPACK_IMPORTED_MODULE_44__views_Setting_Users__["a" /* default */]
        }, {
            name: 'sources',
            path: 'sources',
            component: __WEBPACK_IMPORTED_MODULE_46__views_Setting_Sources__["a" /* default */]
        }, {
            name: 'admin-goal',
            path: 'goal',
            component: __WEBPACK_IMPORTED_MODULE_50__views_Setting_AdminGoal__["a" /* default */]
        }, {
            name: 'admin-emission',
            path: 'emission',
            component: __WEBPACK_IMPORTED_MODULE_51__views_Setting_EmissionTable__["a" /* default */]
        }, {
            name: 'admin-emission-detail',
            path: 'emission/:type_id',
            component: __WEBPACK_IMPORTED_MODULE_52__views_Setting_EmissionDetail__["a" /* default */]
        }, {
            name: 'admin-unit-price',
            path: 'unit',
            component: __WEBPACK_IMPORTED_MODULE_53__views_Setting_UnitPrice__["a" /* default */]
        }, {
            name: 'admin-unit-price-detail',
            path: 'unit/:type_id',
            component: __WEBPACK_IMPORTED_MODULE_54__views_Setting_UnitPriceDetail__["a" /* default */]
        }, {
            name: 'load-data-via-excel',
            path: 'load-data-via-excel',
            component: __WEBPACK_IMPORTED_MODULE_55__views_Setting_LoadDataViaExcel__["a" /* default */]
        }]
    }, {
        name: 'master',
        path: '/master',
        component: __WEBPACK_IMPORTED_MODULE_37__views_Setting_Master__["a" /* default */],
        children: [{
            name: 'tags',
            path: 'tags',
            component: __WEBPACK_IMPORTED_MODULE_47__views_Setting_Tags__["a" /* default */]
        }, {
            name: 'locations',
            path: 'locations',
            component: __WEBPACK_IMPORTED_MODULE_49__views_Setting_Locations__["a" /* default */]
        }, {
            name: 'emission-library',
            path: 'emission-library',
            component: __WEBPACK_IMPORTED_MODULE_48__views_Setting_EmissionLibrary__["a" /* default */]
        }]
    }, {
        name: 'user-profile',
        path: '/user-profile:user_id',
        component: __WEBPACK_IMPORTED_MODULE_45__views_Setting_UserProfile__["a" /* default */]
    }, {
        name: 'library',
        path: '/library',
        component: __WEBPACK_IMPORTED_MODULE_57__views_Library_Library__["a" /* default */]
    }]
}, { name: 'login', path: '/login', component: __WEBPACK_IMPORTED_MODULE_9__views_Login__["a" /* default */] }, { name: 'signup', path: '/signup', component: __WEBPACK_IMPORTED_MODULE_13__views_Signup__["a" /* default */] }, { name: 'register', path: '/register', component: __WEBPACK_IMPORTED_MODULE_56__views_Register_Register__["a" /* default */] }, { name: 'forgot-password', path: '/forgot-password', component: __WEBPACK_IMPORTED_MODULE_10__views_ForgotPassword__["a" /* default */] }, { name: 'reset-password', path: '/reset-password', component: __WEBPACK_IMPORTED_MODULE_11__views_ResetPassword__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: routes
});

router.beforeEach(function (to, from, next) {
    var token = localStorage.getItem('token');
    // Unauthenticated users can only access the login page.
    if (to.path !== '/login' && to.path !== '/register' && to.path !== '/signup' && to.path !== '/forgot-password' && to.path !== '/reset-password') {
        if (!token) {
            return next('/login');
        } else {
            return fetchInitialData(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]).then(function () {
                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.isInitiated = true;
                return next();
            }).catch(function () {
                return next('/login');
            });
        }
    } else {
        return next();
    }
});

// Fetch initial data and store to use in components
function fetchInitialData(store) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (store.state.isInitiated) {
            resolve();
        } else {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([store.dispatch('init')]).then(resolve).catch(reject);
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YeH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("l92n");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65918846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__ = __webpack_require__("6e9u");
function injectStyle (ssrContext) {
  __webpack_require__("iyxz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65918846"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65918846_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TrinityRingsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "Yo+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yru4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yxz6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Permissions',
    data: function data() {
        return {
            tableColumns: [{
                label: this.$t('userGroup'),
                key: 'groupName',
                sortable: true,
                thClass: 'table-point-th',
                stickyColumn: true
            }, {
                label: this.$t('activeUsers'),
                key: 'activeUsers',
                sortable: true,
                thClass: 'table-point-th',
                stickyColumn: true
            }],
            tableItems: [],
            userGroups: [],
            tableId: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()()
        };
    },

    methods: {
        addUserGroup: function addUserGroup() {
            this.$router.push({ name: 'add-permission' });
        },
        rowClicked: function rowClicked(item) {
            this.$router.push({ name: 'edit-permissions', params: { id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(item, 'id') } });
        },
        getPermissionGroups: function getPermissionGroups() {
            return this.axios.get('/permission-groups').then(function (_ref) {
                var data = _ref.data;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
            }).catch(function (err) {
                console.log(err);
            });
        }
    },
    created: function created() {
        var _this = this;

        this.getPermissionGroups().then(function (userGroups) {
            _this.userGroups = userGroups;
            _this.tableItems = [];
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(userGroups, function (userGroup) {
                _this.tableItems.push({
                    groupName: _this.$t(_this.getGroupName(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(userGroup, 'name'))),
                    activeUsers: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(userGroup, 'users').length,
                    id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(userGroup, 'id')
                });
            });
        });
    }
});

/***/ }),

/***/ "Z1wW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZFP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteEdit_vue__ = __webpack_require__("dLF+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d64a50b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteEdit_vue__ = __webpack_require__("7BEe");
function injectStyle (ssrContext) {
  __webpack_require__("qMXs")
  __webpack_require__("hm2b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d64a50b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d64a50b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("bnVc")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZT9M":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOTgiIGhlaWdodD0iMjk4IiB2aWV3Qm94PSIwIDAgMjk4IDI5OCI+CiAgPGcgaWQ9Ikdyb3VwXzI4MjQiIGRhdGEtbmFtZT0iR3JvdXAgMjgyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgxMSAtNDAyKSI+CiAgICA8ZyBpZD0iR3JvdXBfMjc0MCIgZGF0YS1uYW1lPSJHcm91cCAyNzQwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTE5NSAtOTkyLjA3OCkiPgogICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzUzIiBkYXRhLW5hbWU9IkVsbGlwc2UgNTMiIGN4PSIxNDkiIGN5PSIxNDkiIHI9IjE0OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjAwNiAxMzk0LjA3OCkiIGZpbGw9IiNmMGYwZjAiLz4KICAgIDwvZz4KICAgIDxwYXRoIGlkPSJlbWFpbC1vcGVuIiBkPSJNMTc3LjYsNjAuMjcybC40MTUsODQuOTk1YTE2LjIwOSwxNi4yMDksMCwwLDEtNS4yMTMsMTIuMTcyLDE3LjY4MiwxNy42ODIsMCwwLDEtMTIuNzEyLDQuOTg1SDE3LjkyNWExNy43LDE3LjcsMCwwLDEtMTIuNzE3LTQuOTlBMTYuMTg3LDE2LjE4NywwLDAsMSwwLDE0NS4yNjdWNjAuMjcyUTAsNTAuNyw4LjM0LDQ1LjUxTDg4LjguNDE3bDgwLjQ2LDQ1LjA5M1ExNzcuNiw1MC43LDE3Ny42LDYwLjI3MlptLTg4LjgsNDIuMyw3My43OTEtNDMuOUw4OC44LDE3LjU3NGwtNzMuMzc2LDQxLjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NzAuOTkyIDQ2MS41NzYpIiBmaWxsPSIjYTBhMGEwIi8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "Zd84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_RegionMultiSelect__ = __webpack_require__("NyJr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'doc-summary',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_6__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_5__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_4__components_YearSelect__["a" /* default */] },
    data: function data() {
        return {
            isLoaded: false,
            tempSites: [],
            documentSites: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            searchInput: '',
            initialRoute: 'doc',
            tags: [{ key: 'belgeler', label: 'Belgeler', active: true }, { key: 'atikTakipFormu', label: 'Atık Takip Formu', active: false }, { key: 'atikTeslimFormu', label: 'Atık Teslim Formu', active: false }, { key: 'kimyasalMalzemeFormu', label: 'Kimyasal Malzeme Formu', active: false }]
        };
    },

    methods: {
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToDocumentDetail: function routeToDocumentDetail(site) {
            this.$store.state.siteId = site ? site.site_id : null;
            var routeData = this.$router.resolve({
                name: 'site-files',
                params: { site_id: site.site_id },
                query: { year: this.year }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'site-files',
                    params: { site_id: site.site_id },
                    query: { year: this.year }
                });
            }
            /* this.$router.push({
                name: 'site-files',
                params: {site_id: site.site_id},
                query: {year: this.year}
            }); */
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeTo: function routeTo() {
            this.$router.push({
                name: 'files',
                query: { year: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureDocuments: function configureDocuments() {
            var _this = this;

            this.documentSites = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.map(this.documents, function (documentSite) {
                var foundItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this.tempSites, { id: documentSite.site_id });
                if (foundItem) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, documentSite, {
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name
                    });
                } else {
                    return documentSite;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(true);
        },
        init: function init() {
            var _this2 = this;

            this.isLoaded = false;
            this.$Progress.start();
            this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
            this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.tempSites = this.sites;
            this.$store.dispatch('getDocumentCounts', this.year).then(this.configureDocuments).then(function () {
                _this2.$Progress.finish();
                _this2.isLoaded = true;
            });
        },
        onYearChange: function onYearChange(newYear) {
            var _this3 = this;

            this.$store.state.year = newYear;
            this.$store.dispatch('getDocumentCounts', this.year).then(this.configureDocuments).then(this.routeTo).then(function () {
                _this3.isLoaded = true;
            });
        }
    },
    computed: {
        filteredDocuments: function filteredDocuments() {
            var _this4 = this;

            if (this.searchInput.length <= 3) {
                var filteredSites = this.documentSites.filter(function (item) {
                    var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this4.sites, { id: item.site_id });
                    return _this4.textStartsWith(item.code + item.name, _this4.searchInput) && _this4.isRegionFound(_this4.selectedRegionId, item.siteGroupId) && (!_this4.selectedTypeId || found.typeId === _this4.selectedTypeId);
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            }
            return this.documentSites.filter(function (item) {
                var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this4.sites, { id: item.site_id });
                return _this4.isSearchTextFound(item.code + item.name, _this4.searchInput) && _this4.isRegionFound(_this4.selectedRegionId, item.siteGroupId) && (!_this4.selectedTypeId || found.typeId === _this4.selectedTypeId);
            });
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "ZgWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect__ = __webpack_require__("0XjM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__("DmJO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__riophae_vue_treeselect_dist_vue_treeselect_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




//import _ from 'lodash';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SiteMultiSelectTree',
    components: {
        Treeselect: __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect___default.a
    },
    props: {
        givenSites: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        classes: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        givenSelectedSites: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        }
    },
    data: function data() {
        return {
            siteOptions: [],
            selectedSites: []
        };
    },

    methods: {
        onInput: function onInput(value) {

            this.selectedSites = value;
            this.$emit('oninput', value);
        },
        selectAll: function selectAll() {}
    },
    computed: {},
    watch: {
        givenSelectedSites: function givenSelectedSites(newVal) {
            this.selectedSites = newVal;
        }
    },
    created: function created() {
        this.siteOptions = [{ id: "All", label: this.$t('selectAll'), children: this.givenSites, isDefaultExpanded: true }];
        this.selectedSites = this.givenSelectedSites;
    }
});

/***/ }),

/***/ "ZoX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PixelSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'pixel-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    pixelSize: function pixelSize() {
      return this.size / 7;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      };
    },
    spinnerInnerStyle: function spinnerInnerStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName,
        width: this.pixelSize + 'px',
        height: this.pixelSize + 'px',
        backgroundColor: this.color,
        color: this.color,
        boxShadow: '\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px ' + this.pixelSize * -1.5 + 'px 0 0,\n                      ' + this.pixelSize * -1.5 + 'px ' + this.pixelSize * 1.5 + 'px 0 0,\n                      0 ' + this.pixelSize * 1.5 + 'px 0 0,\n                      ' + this.pixelSize * 1.5 + 'px 0 0 0,\n                      ' + this.pixelSize * -1.5 + 'px 0 0 0,\n                      0 ' + this.pixelSize * -1.5 + 'px 0 0\n                    '
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n      50% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n\n      75% {\n        box-shadow:  ' + this.pixelSize * 2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * 2 + 'px ' + this.pixelSize * -2 + 'px 0 0,\n                     ' + this.pixelSize * -2 + 'px ' + this.pixelSize * 2 + 'px 0 0,\n                     0 ' + this.pixelSize + 'px 0 0,\n                     ' + this.pixelSize + 'px 0 0 0,\n                     ' + this.pixelSize * -1 + 'px 0 0 0,\n                     0 ' + this.pixelSize * -1 + 'px 0 0;\n      }\n\n      100% {\n        transform: rotate(360deg);\n      }';
    }
  }
});

/***/ }),

/***/ "aCZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"semipolar-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"ring",style:(rs)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aRhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EmissionTable',
    data: function data() {
        return {
            isLoaded: false,
            tags: [],
            dataTypes: []
        };
    },

    methods: {
        getDataTypeName: function getDataTypeName(dataTypeName) {
            return this.$t(dataTypeName);
        },
        routeToEmissionDetail: function routeToEmissionDetail(dataType) {
            this.$router.push({
                name: 'admin-emission-detail',
                params: { type_id: dataType.id }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        init: function init() {
            this.isLoaded = false;
            this.$Progress.start();
            this.dataTypes = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.$store.state.dataTypes, { has_emission: true });
            this.isLoaded = true;
            this.$Progress.finish();
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "aU5X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ab7G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aewY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orbit-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"orbit one",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit two",style:(_vm.orbitStyle)}),_vm._v(" "),_c('div',{staticClass:"orbit three",style:(_vm.orbitStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "atSU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b8/g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bGbP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utils__ = __webpack_require__("Ht5Q");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SpringSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 3000
    },
    size: {
      type: Number,
      default: 70
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'spring-spinner-animation',
      currentAnimationName: ''
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    spinnerPartStyle: function spinnerPartStyle() {
      return {
        height: this.size / 2 + 'px',
        width: this.size + 'px'
      };
    },
    rotatorStyle: function rotatorStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderRightColor: this.color,
        borderTopColor: this.color,
        borderWidth: this.size / 7 + 'px',
        animationDuration: this.animationDuration + 'ms',
        animationName: this.currentAnimationName
      };
    }
  },

  watch: {
    '$props': {
      handler: function handler() {
        this.updateAnimation();
      },

      deep: true
    }
  },

  mounted: function mounted() {
    this.updateAnimation();
  },


  methods: {
    updateAnimation: function updateAnimation() {
      this.updateAnimationName();
      __WEBPACK_IMPORTED_MODULE_0__services_utils__["a" /* default */].appendKeyframes(this.currentAnimationName, this.generateKeyframes());
    },
    updateAnimationName: function updateAnimationName() {
      this.currentAnimationName = this.animationBaseName + '-' + Date.now();
    },
    generateKeyframes: function generateKeyframes() {
      return '\n        0% {\n          border-width: ' + this.size / 7 + 'px;\n        }\n        25% {\n          border-width: ' + this.size / 23.33 + 'px;\n        }\n        50% {\n          transform: rotate(115deg);\n          border-width: ' + this.size / 7 + 'px;\n        }\n        75% {\n          border-width: ' + this.size / 23.33 + 'px;\n         }\n        100% {\n         border-width: ' + this.size / 7 + 'px;\n        }';
    }
  }
});

/***/ }),

/***/ "bMBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__ = __webpack_require__("0XjM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__ = __webpack_require__("DmJO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect_dist_vue_treeselect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import moment from 'moment';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EmissionLibrary',
    components: {
        Treeselect: __WEBPACK_IMPORTED_MODULE_2__riophae_vue_treeselect___default.a
    },
    data: function data() {
        return {
            dataFields: [{
                label: this.$t('name'),
                key: 'name',
                thClass: 'table-point-th',
                sortable: true,
                stickyColumn: true
            }, {
                label: this.$t('edit'),
                key: 'edit',
                thClass: 'table-point-th',
                stickyColumn: true
            }],
            contentFields: [{
                label: this.$t('scopeGroup'),
                key: 'scopeGroupId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-tag-group',
                stickyColumn: true
            }, {
                label: this.$t('sourceTypeGroup'),
                key: 'sourceTypeGroupId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-tag-group',
                stickyColumn: true
            }, {
                label: this.$t('sourceType'),
                key: 'sourceTypeId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-tag-group',
                stickyColumn: true
            }, {
                label: this.$t('country'),
                key: 'countryId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-location-group',
                stickyColumn: true
            }, {
                label: this.$t('region'),
                key: 'regionId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-location-group',
                stickyColumn: true
            }, {
                label: this.$t('sector'),
                key: 'sectorId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-location-group',
                stickyColumn: true
            }, {
                label: this.$t('unit'),
                key: 'unitId',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-unit-group',
                stickyColumn: true
            }, {
                label: this.$t('CH4'),
                key: 'CH4',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-emission-group',
                stickyColumn: true
            }, {
                label: this.$t('N2O'),
                key: 'N2O',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-emission-group',
                stickyColumn: true
            }, {
                label: this.$t('CO2'),
                key: 'CO2',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-emission-group',
                stickyColumn: true
            }, {
                label: this.$t('CO2e'),
                key: 'CO2e',
                sortable: true,
                thClass: 'table-point-th',
                tdClass: 'table-emission-group',
                stickyColumn: true
            }, {
                label: '',
                key: 'edit',
                thClass: 'table-point-th',
                tdClass: 'table-emission-group',
                stickyColumn: true
            }],
            data: [],
            editedItem: {},
            editMode: false,
            isLoaded: false,
            easyAdd: {
                tags: [],
                generateForAllSectors: false,
                generateForAllCountries: false,
                country: null
            },
            errorFilter: false,
            filters: {
                scopeGroupId: [],
                sourceTypeGroupId: [],
                sourceTypeId: [],
                countryId: [],
                regionId: [],
                sectorId: [],
                unitId: []
            },
            editAction: null,
            inProgress: false,
            contentRetriveFilters: {
                libraryId: null,
                sourceTypeId: null,
                sourceTypeGroupId: null,
                scopeGroupId: null
            },
            tableContent: {},
            partialContentSaved: true
        };
    },

    methods: {
        forceUpdate: function forceUpdate() {
            this.$forceUpdate();
        },
        saveEmissionLibrary: function saveEmissionLibrary() {
            var _this = this;

            this.inProgress = true;
            switch (this.editAction) {
                case 'edit':
                    return this.axios.put('/emissionLibrary', { emissionLibrary: this.editedItem, tableContent: this.tableContent }).then(function () {
                        /*
                        this.editedItem.content = _.map(data.result, o=>{
                            return {
                                id: uuidV4(),
                                countryId: _.get(o, 'country_id'),
                                regionId: _.get(o, 'region_id'),
                                scopeGroupId: _.get(o, 'scope_group_id'),
                                sectorId: _.get(o, 'sector_id'),
                                sourceTypeGroupId: _.get(o, 'source_type_group_id'),
                                sourceTypeId: _.get(o, 'source_type_id'),
                                unitId: _.get(o, 'unit_id'),
                                CH4: _.get(o, 'CH4'),
                                CO2: _.get(o, 'CO2'),
                                CO2e: _.get(o, 'CO2e'),
                                N2O: _.get(o, 'N2O')
                            }
                        });
                        let currentEmissionLibraryId = _.findIndex(this.data, o=>o.id==this.editedItem.id);
                        this.data[currentEmissionLibraryId] = _.cloneDeep(this.editedItem);
                        this.returnToEmissionLibrary();
                        */
                        _this.partialContentSaved = true;
                        _this.inProgress = false;
                        //this.retriveEmissionLibraries();
                    });
                case 'insert':
                    return this.axios.post('/emissionLibrary', this.editedItem).then(function () {
                        _this.inProgress = false;
                        _this.retriveEmissionLibraries();
                    });
                case 'delete':
                    return this.deleteEmissionLibrary();
            }
        },
        deleteEmissionLibrary: function deleteEmissionLibrary() {
            var _this2 = this;

            return this.axios.delete('/emissionLibrary/' + this.editedItem.id).then(function () {
                _this2.data = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this2.data, function (o) {
                    return o.id != _this2.editedItem.id;
                });
                _this2.returnToEmissionLibrary();
            }).catch(function () {
                _this2.showErrorNotification('deletion-failed');
            });
        },
        clearAllFilters: function clearAllFilters() {
            this.filters = {
                scopeGroupId: [],
                sourceTypeGroupId: [],
                sourceTypeId: [],
                countryId: [],
                regionId: [],
                sectorId: [],
                unitId: []
            };
        },
        clearUserInputs: function clearUserInputs() {
            this.editAction = null;
            this.easyAdd = {
                tags: [],
                generateForAllSectors: false,
                generateForAllCountries: false,
                country: null
            };
            this.errorFilter = false;
            this.clearAllFilters();
        },
        setFilterOptionsByParent: function setFilterOptionsByParent(filters, data, filterKeys) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                var filterFlag = true;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(filterKeys, function (filterKey) {
                    var selectedFilter = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(filters, filterKey), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toString);
                    if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(selectedFilter)) {
                        if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(selectedFilter, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toString(o[filterKey]))) {
                            filterFlag = false;
                        }
                    }
                });
                return filterFlag;
            });
        },
        setFilterOptionsByParentSingle: function setFilterOptionsByParentSingle(filters, data, filterKeys) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                var filterFlag = true;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(filterKeys, function (filterKey) {
                    var selectedFilter = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(filters, filterKey);
                    if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(selectedFilter)) {
                        if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toString(selectedFilter) != __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toString(o[filterKey])) {
                            filterFlag = false;
                        }
                    }
                });
                return filterFlag;
            });
        },
        filterByParent: function filterByParent(itemMap, filters) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqBy(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(itemMap, function (o) {
                var filterFlag = true;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(filters, function (filter) {
                    if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o[filter.key]) != __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(filter.value)) {
                        filterFlag = false;
                    }
                });
                return filterFlag;
            }), 'name');
        },
        getFilteredData: function getFilteredData(data) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(data, function (o) {
                var filterFlag = true;
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this3.filters, function (filterValues, filterKey) {
                    if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(filterValues)) {
                        if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(filterValues, o[filterKey])) {
                            filterFlag = false;
                        }
                    }
                });
                if (_this3.errorFilter) {
                    if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(['warning', 'danger'], __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(o, '_rowVariant'))) {
                        filterFlag = false;
                    }
                }
                return filterFlag;
            });
        },
        updateData: function updateData(data, updatedObjs) {
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(updatedObjs, function (value, key) {
                data[key] = value;
            });
            this.forceUpdate();
        },
        getUnitMap: function getUnitMap(sourceTypeId) {
            var sourceType = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.sourceTypeMap, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o.id) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(sourceTypeId.sourceTypeId);
            });
            return sourceType.units;
        },
        duplicateContent: function duplicateContent(item) {
            var newItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item);
            newItem.id = null;
            this.editedItem.content.push(newItem);
        },
        contentSplitCountryToRegions: function contentSplitCountryToRegions(item) {
            var _this4 = this;

            var countryId = item.countryId;
            var regions = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.regionMap, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o['countryId']) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(countryId);
            });
            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(regions, function (region) {
                var newItem = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item);
                newItem.id = null;
                newItem.regionId = region.id;
                _this4.editedItem.content.push(newItem);
            });
            this.deleteContent(item);
        },
        autoGenerateRows: function autoGenerateRows() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(this.easyAdd.tags, function (tagString) {

                var keys = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.split(tagString, '-');
                var relatedTags = [];
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(keys) == 3) {
                    relatedTags.push({
                        scopeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[0]),
                        sourceTypeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[1]),
                        id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[2])
                    });
                } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(keys) == 2) {
                    relatedTags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this5.sourceTypeMap, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o.scopeGroupId) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[0]) && __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o.sourceTypeGroupId) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[1]);
                    });
                } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(keys) == 1) {
                    relatedTags = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(_this5.sourceTypeMap, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(o.scopeGroupId) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(keys[0]);
                    });
                }
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(relatedTags, function (relatedTagGroup) {
                    if (_this5.easyAdd.generateForAllCountries) {
                        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this5.countryMap, function (country) {
                            if (_this5.easyAdd.generateForAllSectors) {
                                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this5.sectorMap, function (sector) {
                                    _this5.editedItem.content.push({
                                        id: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                                        scopeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(relatedTagGroup.scopeGroupId),
                                        sourceTypeGroupId: relatedTagGroup.sourceTypeGroupId,
                                        sourceTypeId: relatedTagGroup.id,
                                        countryId: country.id,
                                        regionId: null,
                                        sectorId: sector.id,
                                        unitId: null,
                                        CH4: null,
                                        N2O: null,
                                        CO2: null,
                                        CO2e: null
                                    });
                                });
                            } else {
                                _this5.editedItem.content.push({
                                    id: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                                    scopeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(relatedTagGroup.scopeGroupId),
                                    sourceTypeGroupId: relatedTagGroup.sourceTypeGroupId,
                                    sourceTypeId: relatedTagGroup.id,
                                    countryId: country.id,
                                    regionId: null,
                                    sectorId: null,
                                    unitId: null,
                                    CH4: null,
                                    N2O: null,
                                    CO2: null,
                                    CO2e: null
                                });
                            }
                        });
                    } else {
                        if (_this5.easyAdd.generateForAllSectors) {
                            __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(_this5.sectorMap, function (sector) {
                                _this5.editedItem.content.push({
                                    id: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                                    scopeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(relatedTagGroup.scopeGroupId),
                                    sourceTypeGroupId: relatedTagGroup.sourceTypeGroupId,
                                    sourceTypeId: relatedTagGroup.id,
                                    countryId: _this5.easyAdd.country,
                                    regionId: null,
                                    sectorId: sector.id,
                                    unitId: null,
                                    CH4: null,
                                    N2O: null,
                                    CO2: null,
                                    CO2e: null
                                });
                            });
                        } else {
                            _this5.editedItem.content.push({
                                id: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                                scopeGroupId: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toNumber(relatedTagGroup.scopeGroupId),
                                sourceTypeGroupId: relatedTagGroup.sourceTypeGroupId,
                                sourceTypeId: relatedTagGroup.id,
                                countryId: _this5.easyAdd.country,
                                regionId: null,
                                sectorId: null,
                                unitId: null,
                                CH4: null,
                                N2O: null,
                                CO2: null,
                                CO2e: null
                            });
                        }
                    }
                });
            });
        },
        addNewContent: function addNewContent() {
            this.editedItem.content.push({
                id: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                scopeGroupId: null,
                sourceTypeGroupId: null,
                sourceTypeId: null,
                countryId: null,
                regionId: null,
                sectorId: null,
                unitId: null,
                CH4: null,
                N2O: null,
                CO2: null,
                CO2e: null
            });
        },
        deleteContent: function deleteContent(item) {
            this.editedItem.content = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.editedItem.content, function (o) {
                return o != item;
            });
        },
        rowClass: function rowClass(item, type) {
            if (!item || type !== 'row') return;else {
                if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.scopeGroupId) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.sourceTypeGroupId) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.sourceTypeId) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.unitId) || (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.CH4) || item.CH4 == '') && (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.N2O) || item.N2O == '') && (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.CO2) || item.CO2 == '') && (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isNull(item.CO2e) || item.CO2e == '')) {
                    item._rowVariant = 'warning';
                } else if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.editedItem.content, function (o) {
                    return o.scopeGroupId == item.scopeGroupId && o.sourceTypeGroupId == item.sourceTypeGroupId && o.sourceTypeId == item.sourceTypeId && o.countryId == item.countryId && o.regionId == item.regionId && o.sectorId == item.sectorId && o.unitId == item.unitId;
                })) > 1) {
                    item._rowVariant = 'danger';
                    return 'table-danger';
                } else {
                    item._rowVariant = 'light';
                }
            }
        },
        showSplitRegionsButton: function showSplitRegionsButton(item) {
            //let regions = _.find(this.editedItem.content, o=> o.countryId==countryId && o.regionId != null)
            //return regions == undefined;
            return (item.regionId == undefined || item.regionId == null) && item.countryId != null;
        },
        openEditItemModal: function openEditItemModal(item) {
            this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(item), { content: [] });
            this.contentRetriveFilters.libraryId = item.id;
            /*
            _.each(this.editedItem.content, content=>{
                content['scopeGroup']= this.$t(this.scopeGroupMap[content.scopeGroupId].name)
                content['sourceTypeGroup']= this.$t(this.sourceTypeGroupMap[content.sourceTypeGroupId].name)
                content['sourceType']= this.$t(this.sourceTypeMap[content.sourceTypeId].name)
                content['country']= this.$t(this.countryMap[content.countryId].name)
                content['region']= this.$t(this.regionMap[content.regionId].name)
                content['sector']= this.$t(this.sectorMap[content.sectorId].name)
                content['unit']= this.$t(this.unitMap[content.unitId].name)
            });
            */
            this.clearUserInputs();
            this.editMode = true;
            this.editAction = 'edit';
            this.partialContentSaved = true;
            this.forceUpdate();
        },
        openInsertItemModal: function openInsertItemModal() {
            this.editedItem = {
                name: '',
                content: []
            };
            this.tableContent = {};
            this.clearUserInputs();
            this.editAction = 'insert';
            this.partialContentSaved = true;
            this.editMode = true;
        },
        returnToEmissionLibrary: function returnToEmissionLibrary() {
            var _this6 = this;

            if (this.editAction == 'edit' && !this.partialContentSaved) {
                this.$confirm(this.$t('thereAreChanges'), this.$t('warning'), {
                    confirmButtonText: this.$t('saveChanges'),
                    cancelButtonText: this.$t('leaveWithoutSaving'),
                    type: 'warning',
                    center: true
                }).then(function () {
                    return _this6.saveEmissionLibrary().then(function () {
                        return _this6.retriveEmissionLibraries();
                    });
                }).catch(function () {
                    return _this6.returnToParent();
                });
            } else {
                this.returnToParent();
            }
        },
        returnToParent: function returnToParent() {
            this.tableContent = {};
            this.editedItem = {};
            this.clearUserInputs();
            this.editMode = false;
        },
        preprocess: function preprocess(rawData) {
            this.data = rawData;
        },
        contentProcess: function contentProcess(rawData) {
            this.editedItem.content = rawData;
        },
        getEmissionLibraryContent: function getEmissionLibraryContent() {
            var _this7 = this;

            this.$Progress.start();
            this.isLoaded = false;
            return this.axios.post('/emissionLibraryContent', this.contentRetriveFilters).then(function (_ref) {
                var data = _ref.data;
                return _this7.contentProcess(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(data.result));
            }).then(function () {
                _this7.tableContent = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.clone(_this7.contentRetriveFilters);
                _this7.partialContentSaved = true;
                _this7.$Progress.finish();
                _this7.isLoaded = true;
            });
        },
        getEmissionLibraryContentByFilter: function getEmissionLibraryContentByFilter() {
            var _this8 = this;

            if (this.editAction == 'edit' && !this.partialContentSaved) {
                this.$confirm(this.$t('thereAreChanges'), this.$t('warning'), {
                    confirmButtonText: this.$t('saveChanges'),
                    cancelButtonText: this.$t('contiuneWithoutSaving'),
                    type: 'warning',
                    center: true
                }).then(function () {
                    return _this8.saveEmissionLibrary().then(function () {
                        return _this8.getEmissionLibraryContent();
                    });
                }).catch(function () {
                    return _this8.getEmissionLibraryContent();
                });
            } else {
                this.getEmissionLibraryContent();
            }
        },
        retriveEmissionLibraries: function retriveEmissionLibraries() {
            var _this9 = this;

            this.$Progress.start();
            this.isLoaded = false;
            return this.axios.get('/emissionLibrary').then(function (_ref2) {
                var data = _ref2.data;
                return _this9.preprocess(data);
            }).then(function () {
                _this9.$Progress.finish();
                _this9.returnToEmissionLibrary();
                _this9.isLoaded = true;
            });
        },
        init: function init() {
            var _this10 = this;

            this.$Progress.start();
            return this.axios.get('/emissionLibrary').then(function (_ref3) {
                var data = _ref3.data;
                return _this10.preprocess(data);
            }).then(function () {
                _this10.$Progress.finish();
                _this10.returnToEmissionLibrary();
                _this10.isLoaded = true;
            });
        }
    },
    watch: {
        editedItem: {
            handler: function handler(newItem, oldItem) {
                if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(oldItem)) {
                    this.partialContentSaved = false;
                } else if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(newItem)) {
                    this.partialContentSaved = true;
                }
            },
            deep: true
        },
        contentRetriveFilters: {
            handler: function handler() {
                this.forceUpdate();
            },
            deep: true
        }
    },
    created: function created() {
        this.init();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        var _this11 = this;

        if (this.editAction == 'edit' && !this.partialContentSaved) {
            this.$confirm(this.$t('thereAreChanges'), this.$t('warning'), {
                confirmButtonText: this.$t('saveChanges'),
                cancelButtonText: this.$t('leaveWithoutSaving'),
                type: 'warning',
                center: true
            }).then(function () {
                return _this11.saveEmissionLibrary();
            }).catch(function () {
                return next();
            });
        } else {
            next();
        }
    }
});

/***/ }),

/***/ "bNqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__ = __webpack_require__("IaV/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TableAndChart: __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__["a" /* default */],
        RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    },
    name: 'ScopeTwo',
    data: function data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            initialEmissions: {
                current: []
            }
        };
    },


    methods: {
        retrieveEmissions: function retrieveEmissions() {
            var _this = this;

            this.$Progress.start();
            return this.axios.get('/report/emission?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId,
                scope: 'Scope-2'
            })).then(function (_ref) {
                var data = _ref.data;

                _this.initialEmissions = data;
                _this.isLoaded = true;
                _this.$Progress.finish();
                return data;
            });
        },
        selectSiteId: function selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.retrieveEmissions();
        },
        selectSiteGroupId: function selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.retrieveEmissions();
        },
        onYearChange: function onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({ name: 'scope-2', query: { year: this.year } });
            this.retrieveEmissions();
        }
    },

    created: function created() {
        this.selectedSiteId = this.route.params.site_id ? Number(this.route.params.site_id) : this.selectedSiteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        this.retrieveEmissions();
    }
});

/***/ }),

/***/ "bU4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive",attrs:{"id":_vm.tableId}},[(_vm.isLoaded)?_c('div',[_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('wasteDescription')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('wasteType')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('storage')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('municipality')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('recovery')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"9em"},attrs:{"id":"waste-form-last-column"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.items),function(item){return _c('tr',{on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(item)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.revertChanges(item)}],"click":function($event){return _vm.routeTo(item)}}},[_c('td',[(!item.editMode)?[_c('div',[_vm._v("\n                                    "+_vm._s(item.description.value)+"\n                                ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteDescriptions},on:{"change":function($event){return _vm.setWasteDescriptions($event, item)}},model:{value:(item.description.editedValue),callback:function ($$v) {_vm.$set(item.description, "editedValue", $$v)},expression:"item.description.editedValue"}})]],2),_vm._v(" "),_c('td',[(!item.editMode)?[_c('div',[_vm._v("\n                                    "+_vm._s(item.wasteType.value)+"\n                                ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteTypes},on:{"change":function($event){return _vm.setWasteTypes($event, item)}},model:{value:(item.wasteType.editedValue),callback:function ($$v) {_vm.$set(item.wasteType, "editedValue", $$v)},expression:"item.wasteType.editedValue"}})]],2),_vm._v(" "),_c('td',[(!item.editMode)?[_c('div',[_vm._v("\n                                    "+_vm._s(item.storageType.value)+"\n                                ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteStorages},on:{"change":function($event){return _vm.setWasteStorage($event, item)}},model:{value:(item.storageType.editedValue),callback:function ($$v) {_vm.$set(item.storageType, "editedValue", $$v)},expression:"item.storageType.editedValue"}})]],2),_vm._v(" "),_c('td',[(!item.editMode)?[_c('div',[_vm._v("\n                                    "+_vm._s(item.municipality.value)+"\n                                ")])]:[_c('b-form-input',{staticStyle:{"text-align":"center"},attrs:{"required":""},model:{value:(item.municipality.editedValue),callback:function ($$v) {_vm.$set(item.municipality, "editedValue", $$v)},expression:"item.municipality.editedValue"}})]],2),_vm._v(" "),_c('td',[(!item.editMode)?[_c('div',[_vm._v("\n                                    "+_vm._s(item.recovery.value)+"\n                                ")])]:[_c('b-form-input',{staticStyle:{"text-align":"center"},attrs:{"required":""},model:{value:(item.recovery.editedValue),callback:function ($$v) {_vm.$set(item.recovery, "editedValue", $$v)},expression:"item.recovery.editedValue"}})]],2),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[(!item.editMode)?_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(item)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(item, _vm.fields)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.revertChanges(item)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete')},on:{"click":function($event){return _vm.deleteItem($event, item.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])])])}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem(_vm.tempItem)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteDescriptions},on:{"change":function($event){return _vm.setWasteDescriptions($event, _vm.tempItem)}},model:{value:(_vm.tempItem.description.value),callback:function ($$v) {_vm.$set(_vm.tempItem.description, "value", $$v)},expression:"tempItem.description.value"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteTypes},on:{"change":function($event){return _vm.setWasteTypes($event, _vm.tempItem)}},model:{value:(_vm.tempItem.wasteType.value),callback:function ($$v) {_vm.$set(_vm.tempItem.wasteType, "value", $$v)},expression:"tempItem.wasteType.value"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.wasteStorages},on:{"change":function($event){return _vm.setWasteStorages($event, _vm.tempItem)}},model:{value:(_vm.tempItem.storageType.value),callback:function ($$v) {_vm.$set(_vm.tempItem.storageType, "value", $$v)},expression:"tempItem.storageType.value"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{staticStyle:{"text-align":"center"},attrs:{"disabled":_vm.municipalityDisabled == 1 ? true : false},model:{value:(_vm.tempItem.municipality.value),callback:function ($$v) {_vm.$set(_vm.tempItem.municipality, "value", $$v)},expression:"tempItem.municipality.value"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{staticStyle:{"text-align":"center"},attrs:{"disabled":_vm.recoveryDisabled == 1 ? true : false},model:{value:(_vm.tempItem.recovery.value),callback:function ($$v) {_vm.$set(_vm.tempItem.recovery, "value", $$v)},expression:"tempItem.recovery.value"}})],1),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.createItem(_vm.tempItem)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)])]):_vm._e()]),_vm._v(" "),(!_vm.insertMode && this.$store.state.user.permissions.canEditGoals)?_c('tr',{staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{attrs:{"colspan":_vm.tableCols.length + 1}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]):_vm._e()],2)])])])],1):_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bZ3g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bexJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[(_vm.multipleChart)?_c('b-col',{staticStyle:{"margin-left":"10px"},attrs:{"cols":"5"}},[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.weakestDataUnit != null),expression:"weakestDataUnit != null"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.$t(_vm.weakestDataUnit+"-convert"))+" ")]),_vm._v(" "),_c('horizontal-bar-chart',{attrs:{"chart-data":_vm.barChartWeakest.data,"options":_vm.barChartWeakest.options,"chart-id":_vm.barChartWeakest.id}})],1):_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"margin-right":"10px"},attrs:{"cols":_vm.multipleChart ? 5 : 11}},[_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.bestDataUnit != null),expression:"bestDataUnit != null"}],staticClass:"text-danger"},[_vm._v("  "+_vm._s(_vm.$t(_vm.bestDataUnit+"-convert"))+" ")]),_vm._v(" "),_c('horizontal-bar-chart',{attrs:{"chart-data":_vm.barChartBest.data,"options":_vm.barChartBest.options,"chart-id":_vm.barChartBest.id}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bgxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded && _vm.selectedSite)?_c('b-card',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                      "+_vm._s(_vm.$t('title'))+"\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{staticStyle:{"padding-right":"0.65rem"},attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-select',{staticClass:"gray-select",model:{value:(_vm.selectedForm),callback:function ($$v) {_vm.selectedForm=$$v},expression:"selectedForm"}},[_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('all')))]),_vm._v(" "),_vm._l((_vm.formTypes),function(formType){return _c('option',{domProps:{"value":formType.id}},[_vm._v(_vm._s(formType.name))])})],2)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-form-select',{staticClass:"gray-select",attrs:{"options":_vm.yearOptions},on:{"change":_vm.onYearChange},model:{value:(_vm.$store.state.year),callback:function ($$v) {_vm.$set(_vm.$store.state, "year", $$v)},expression:"$store.state.year"}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true},on:{"oninput":_vm.selectSiteId}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('site')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('formType')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('formNo')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('version')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('createdAt')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.filteredForms),function(form){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToFormDetail(form)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(form.siteName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(form.type)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(form.no))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(form.version))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(form.createdAt,'DD/MM/YYYY')))])])}),_vm._v(" "),_c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.user.permissions.canEditData),expression:"this.$store.state.user.permissions.canEditData"}],staticStyle:{"cursor":"pointer"},attrs:{"colspan":"5"},on:{"click":function($event){return _vm.$refs.formTypes.show()}}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])],2)])])],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"formTypes",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('b-form-select',{model:{value:(_vm.selectedFormToCreate),callback:function ($$v) {_vm.selectedFormToCreate=$$v},expression:"selectedFormToCreate"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('chooseFormType')))]),_vm._v(" "),_vm._l((_vm.formTypes),function(formType){return _c('option',{domProps:{"value":formType.id}},[_vm._v(_vm._s(_vm.$t(formType.name)))])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bmHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-card',[_c('b-row',{staticStyle:{"text-align":"center"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"mb-4",staticStyle:{"display":"flex","justify-content":"flex-start","height":"40px"},attrs:{"cols":"6"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.selectedSite.id, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name)+" - "+_vm._s(_vm.$t('title')))])]),_vm._v(" "),_c('b-col',{staticStyle:{"height":"40px","padding-right":"1.5rem"},attrs:{"cols":"4","sm":"4","md":"6","lg":"6","xl":"5"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true},on:{"oninput":_vm.selectSite}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('dataTypeColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('startYearColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('endYearColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('goalTypeColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('goalRatioColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('goalColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('actualColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('actualColumnRatio')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('descriptionColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('confirmationColumn')))]),_vm._v(" "),_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.canEditGoals),expression:"canEditGoals"}],staticStyle:{"width":"10em"},attrs:{"id":"goal-last-column"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.goals),function(goal){return _c('tr',{on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(goal)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.bindItems(_vm.rawItems)}]}},[_c('td',[_c('div',{staticClass:"tableBodyCell"},[[(goal.editMode)?_c('b-form-select',{class:Object.assign(goal.dataTypeId.classes, {'masked-custom-input': true, 'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.dataTypesDropdown},on:{"change":function($event){return _vm.configureItemOnDataTypeChange($event, goal, false)}},nativeOn:{"focus":function($event){return _vm.resetWarning(goal, 'dataTypeId')}},model:{value:(goal.dataTypeId.editedValue),callback:function ($$v) {_vm.$set(goal.dataTypeId, "editedValue", $$v)},expression:"goal.dataTypeId.editedValue"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))])]):_c('div',{attrs:{"title":_vm.$t(goal.dataTypeId.name)}},[_vm._v("\n                                "+_vm._s(_vm._f("shortenText")(_vm.$t(goal.dataTypeId.name)))+"\n                            ")])]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[[(goal.editMode)?[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.startYearChoices},on:{"change":function($event){return _vm.setSelectedBaseYear($event, goal, false /*: isTempItem = false */)}},model:{value:(goal.startYear.editedValue),callback:function ($$v) {_vm.$set(goal.startYear, "editedValue", $$v)},expression:"goal.startYear.editedValue"}})]:_c('div',[_vm._v("\n                                "+_vm._s((goal.startYear.editedValue ? goal.startYear.editedValue : '-'))+"\n                            ")])]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[[(goal.editMode)?[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.endYearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, goal, false /*: isTempItem = false */)}},model:{value:(goal.endYear.editedValue),callback:function ($$v) {_vm.$set(goal.endYear, "editedValue", $$v)},expression:"goal.endYear.editedValue"}})]:_c('div',[_vm._v("\n                                "+_vm._s((goal.endYear.editedValue ? goal.endYear.editedValue : '-'))+"\n                            ")])]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(goal.dataTypeId.editedValue && goal.editMode)?_c('b-form-select',{class:Object.assign(goal.dataTypeId.classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.goalTypes},on:{"change":function($event){return _vm.calculatesGoalValueByDirectionOnChange($event, goal)}},nativeOn:{"focus":function($event){return _vm.resetWarning(goal, 'direction')}},model:{value:(goal.direction.editedValue),callback:function ($$v) {_vm.$set(goal.direction, "editedValue", $$v)},expression:"goal.direction.editedValue"}}):(goal.dataTypeId.editedValue)?[_vm._v("\n                            "+_vm._s(_vm.directionValueToText(goal.direction.value))+"\n                        ")]:_vm._e()],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(goal.direction.editedValue === 0 || goal.baseYearValue === 0)?[_vm._v("\n                            -\n                        ")]:(!goal.editMode)?[_vm._v("\n                            "+_vm._s(goal.valueR.value)+"\n                        ")]:[_c('masked-input',{class:Object.assign(goal.valueR.classes, {'masked-custom-input': true, 'form-control-custom': true}),attrs:{"keepCharPositions":false,"pipe":_vm.pipeNumber(goal),"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t('goalRatioColumn')},on:{"focus":function($event){_vm.resetWarning(goal, 'valueR'); goal.lockR = false; goal.lockN=true;},"input":function($event){return _vm.calculateNumber(goal)}},model:{value:(goal.valueR.editedValue),callback:function ($$v) {_vm.$set(goal.valueR, "editedValue", $$v)},expression:"goal.valueR.editedValue"}})]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!goal.editMode && goal.valueN.value)?[_vm._v("\n                            "+_vm._s(goal.valueN.value || _vm.parseNumber('float', _vm.locale))+" "+_vm._s(_vm.$t(goal.unitName))+"\n                        ")]:(!goal.editMode && !goal.valueN.value)?[_vm._v("\n                            "+_vm._s(_vm.calculateGlobalValueN(goal))+"\n                        ")]:[_c('masked-input',{class:Object.assign(goal.valueN.classes, {'masked-custom-input': true, 'form-control-custom': true}),attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t('goalColumn')},on:{"focus":function($event){_vm.resetWarning(goal, 'valueN'); goal.lockR = true; goal.lockN=false;},"input":function($event){return _vm.calculateRatio(goal)}},model:{value:(goal.valueN.editedValue),callback:function ($$v) {_vm.$set(goal.valueN, "editedValue", $$v)},expression:"goal.valueN.editedValue"}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(goal.valueN.hasWarn),expression:"goal.valueN.hasWarn"}],staticClass:"form-text",staticStyle:{"font-size":"0.500em","color":"red"}},[_vm._v(_vm._s(goal.valueN.warnMessage))])]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                        "+_vm._s(goal.currentTotals)+" "+_vm._s(_vm.$t(goal.unitName))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(goal.valueN.editedValue && goal.currentTotals)?[_vm._v("\n                            "+_vm._s(_vm._f("toRatio")(goal.currentTotals,goal.valueN.editedValue))+"\n                        ")]:[_vm._v("\n                            -\n                        ")]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!goal.editMode)?[(goal.descriptionOther.value)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"max-width":"80px"},attrs:{"title":goal.descriptionOther.value}},[_vm._v(_vm._s(_vm._f("textToShortText")(goal.descriptionOther.value)))]):(!goal.descriptionId.value||goal.descriptionId.value&&goal.descriptionId.value.length<10)?_c('span',[_vm._v(_vm._s(_vm._f("descriptionValueToText")(goal.descriptionId.value,_vm.descriptions)))]):_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm._f("descriptionValueToText")(goal.descriptionId.value,_vm.descriptions)}},[_vm._v(_vm._s(_vm._f("textToShortText")(_vm._f("descriptionValueToText")(goal.descriptionId.value,_vm.descriptions))))])]:[(goal.descriptionOther.editedValue)?[_c('b-form-input',{class:goal.descriptionOther.classes,staticStyle:{"cursor":"pointer","background-color":"white"},attrs:{"value":goal.descriptionOther.editedValue,"readonly":""},nativeOn:{"click":function($event){_vm.descriptionIdTemp = -1; _vm.descriptionOtherTemp = goal.descriptionOther.editedValue; _vm.$refs[("descriptionText" + (goal.id))][0].show()},"focus":function($event){return _vm.resetWarning(goal, 'descriptionOther')}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(goal.descriptionOther.hasWarn),expression:"goal.descriptionOther.hasWarn"}],staticClass:"form-text",staticStyle:{"font-size":"0.500em","color":"red"}},[_vm._v(_vm._s(goal.descriptionOther.warnMessage))])]:[_c('b-form-input',{class:Object.assign(goal.descriptionId.classes, {'form-control-custom': true}),staticStyle:{"cursor":"pointer","background-color":"white"},attrs:{"value":_vm._f("descriptionValueToText")(goal.descriptionId.editedValue,_vm.descriptions),"readonly":""},nativeOn:{"click":function($event){_vm.descriptionIdTemp = goal.descriptionId.editedValue; _vm.descriptionOtherTemp = null;_vm.$refs[("descriptionText" + (goal.id))][0].show()},"focus":function($event){return _vm.resetWarning(goal, 'descriptionId')}}}),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(goal.descriptionId.hasWarn),expression:"goal.descriptionId.hasWarn"}],staticClass:"form-text",staticStyle:{"font-size":"0.500em","color":"red"}},[_vm._v(_vm._s(goal.descriptionId.warnMessage))])]]],2),_vm._v(" "),_c('b-modal',{ref:("descriptionText" + (goal.id)),refInFor:true,attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',[_c('b-col',[_c('b-form-select',{attrs:{"text-field":"description_text","value-field":"id"},model:{value:(_vm.descriptionIdTemp),callback:function ($$v) {_vm.descriptionIdTemp=$$v},expression:"descriptionIdTemp"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))]),_vm._v(" "),_vm._l((_vm.descriptions),function(description){return (description.id !== null)?_c('option',{domProps:{"value":description.id}},[_vm._v(_vm._s(_vm.$t(description.description_text)))]):_vm._e()}),_vm._v(" "),_c('option',{domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t('Diğer')))])],2)],1)],1),_vm._v(" "),(_vm.descriptionIdTemp === -1)?_c('b-row',[_c('b-col',[_c('b-form-textarea',{staticClass:"mt-3",attrs:{"placeholder":"Açıklama girin"},model:{value:(_vm.descriptionOtherTemp),callback:function ($$v) {_vm.descriptionOtherTemp=$$v},expression:"descriptionOtherTemp"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.setDescription(goal, _vm.descriptionIdTemp, _vm.descriptionOtherTemp)}}},[_vm._v("Tamam")])],1)],1),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(goal.editStatusOnly)?[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.approvalTypes},model:{value:(goal.isApproved.editedValue),callback:function ($$v) {_vm.$set(goal.isApproved, "editedValue", $$v)},expression:"goal.isApproved.editedValue"}})]:(!goal.editMode || !_vm.canApproveGoals)?[_c('span',[(!goal.isApproved.value)?_c('i',{staticClass:"fas fa-pause"}):_c('i',{staticClass:"fas fa-check"})])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.approvalTypes},model:{value:(goal.isApproved.editedValue),callback:function ($$v) {_vm.$set(goal.isApproved, "editedValue", $$v)},expression:"goal.isApproved.editedValue"}})]],2)]),_vm._v(" "),(_vm.canEditGoals)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[(!goal.editMode)?_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(goal.id)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(goal)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelRow(_vm.rawItems)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete')},on:{"click":function($event){return _vm.deleteItem($event, goal.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])]):(_vm.canApproveGoals)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[(!goal.editStatusOnly)?_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(goal.id)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(goal)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelRow(_vm.rawItems)}}},[_c('i',{staticClass:"fas fa-ban"})])],1)])]):_vm._e()])}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_c('td',[_c('div',{staticClass:"tableBodyCell"},[_c('b-form-select',{class:Object.assign(_vm.tempItem.dataTypeId.classes, {'masked-custom-input': true, 'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.dataTypesDropdown},on:{"change":function($event){return _vm.configureItemOnDataTypeChange($event, _vm.tempItem, true)}},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem, 'dataTypeId')}},model:{value:(_vm.tempItem.dataTypeId.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.dataTypeId, "editedValue", $$v)},expression:"tempItem.dataTypeId.editedValue"}},[_c('option',{attrs:{"disabled":true},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose')))])])],1)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!_vm.tempItem.dataTypeId.editedValue)?[_vm._v("\n                                    -\n                            ")]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.startYearChoices},on:{"change":function($event){return _vm.setSelectedBaseYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.startYear.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.startYear, "editedValue", $$v)},expression:"tempItem.startYear.editedValue"}})]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!_vm.tempItem.dataTypeId.editedValue)?[_vm._v("\n                                -\n                            ")]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.endYearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.endYear.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.endYear, "editedValue", $$v)},expression:"tempItem.endYear.editedValue"}})]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(_vm.tempItem.dataTypeId.editedValue)?_c('b-form-select',{class:Object.assign(_vm.tempItem.dataTypeId.classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.goalTypes},on:{"change":function($event){return _vm.calculatesGoalValueByDirectionOnChange($event, _vm.tempItem)}},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem, 'direction')}},model:{value:(_vm.tempItem.direction.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.direction, "editedValue", $$v)},expression:"tempItem.direction.editedValue"}}):[_vm._v("\n                                -\n                            ")]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!_vm.tempItem.dataTypeId.editedValue || _vm.tempItem.direction.editedValue === 0)?[_vm._v("\n                                -\n                            ")]:[_c('masked-input',{class:Object.assign(_vm.tempItem.valueR.classes, {'form-control-custom': true}),attrs:{"value":_vm.tempItem.valueR.editedValue,"keepCharPositions":false,"pipe":_vm.pipeNumber(_vm.tempItem),"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t('goalRatioColumn')},on:{"focus":function($event){_vm.resetWarning(_vm.tempItem, 'valueR'); _vm.tempItem.lockR = false; _vm.tempItem.lockN=true;},"input":function($event){return _vm.calculateNumber(_vm.tempItem)}},model:{value:(_vm.tempItem.valueR.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.valueR, "editedValue", $$v)},expression:"tempItem.valueR.editedValue"}})]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!_vm.tempItem.dataTypeId.editedValue)?[_vm._v("\n                                -\n                            ")]:[_c('masked-input',{class:Object.assign(_vm.tempItem.valueN.classes, {'form-control-custom': true}),attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t('goalColumn')},on:{"focus":function($event){_vm.resetWarning(_vm.tempItem, 'valueN'); _vm.tempItem.lockR = true; _vm.tempItem.lockN=false;},"input":function($event){return _vm.calculateRatio(_vm.tempItem)}},model:{value:(_vm.tempItem.valueN.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.valueN, "editedValue", $$v)},expression:"tempItem.valueN.editedValue"}})]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(!_vm.tempItem.dataTypeId.editedValue)?[_vm._v("\n                                -\n                            ")]:[_vm._v("\n                                "+_vm._s(_vm._f("parseNumber")(_vm.tempItem.currentYearValue,'float', _vm.locale))+" "+_vm._s(_vm.$t(_vm.tempItem.unitName))+"\n                            ")]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[[_vm._v("\n                                -\n                            ")]],2)]),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[(_vm.tempItem.descriptionOther.editedValue)?[_c('b-form-input',{class:Object.assign(_vm.tempItem.descriptionOther.classes, {'form-control-custom': true}),staticStyle:{"cursor":"pointer","background-color":"white"},attrs:{"value":_vm.tempItem.descriptionOther.editedValue,"readonly":""},nativeOn:{"click":function($event){_vm.resetWarning(_vm.tempItem, 'descriptionOther');_vm.descriptionIdTemp=null; _vm.descriptionOtherTemp=null; _vm.$refs.descriptionTextTemp.show()}}})]:[_c('b-form-input',{class:Object.assign(_vm.tempItem.descriptionId.classes, {'form-control-custom': true}),staticStyle:{"cursor":"pointer","background-color":"white"},attrs:{"value":_vm._f("descriptionValueToText")(_vm.tempItem.descriptionId.editedValue,_vm.descriptions),"readonly":""},nativeOn:{"click":function($event){_vm.resetWarning(_vm.tempItem, 'descriptionId'); _vm.descriptionIdTemp=null; _vm.descriptionOtherTemp=null;_vm.$refs.descriptionTextTemp.show()}}})]],2),_vm._v(" "),_c('b-modal',{ref:"descriptionTextTemp",attrs:{"size":"sm","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',[_c('b-col',[_c('b-form-select',{attrs:{"text-field":"description_text","value-field":"id","options":_vm.descriptions},model:{value:(_vm.descriptionIdTemp),callback:function ($$v) {_vm.descriptionIdTemp=$$v},expression:"descriptionIdTemp"}},[_c('option',{domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t('Diğer')))])])],1)],1),_vm._v(" "),(_vm.descriptionIdTemp === -1)?_c('b-row',[_c('b-col',[_c('b-form-textarea',{staticClass:"mt-3",attrs:{"placeholder":"Açıklama girin"},model:{value:(_vm.descriptionOtherTemp),callback:function ($$v) {_vm.descriptionOtherTemp=$$v},expression:"descriptionOtherTemp"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-btn',{staticClass:"mt-3",attrs:{"size":"sm","variant":"outline-primary","block":""},on:{"click":function($event){return _vm.setDescription(_vm.tempItem, _vm.descriptionIdTemp, _vm.descriptionOtherTemp)}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1),_vm._v(" "),_c('td',[_c('div',{staticClass:"tableBodyCell"},[_vm._v("\n                            -\n                        ")])]),_vm._v(" "),_c('td',{staticClass:"edit-column ",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.createItem()}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)])]):_vm._e()])],2),_vm._v(" "),_c('tfoot',{staticClass:"insert-row"},[(!_vm.insertMode && _vm.canCreateGoals)?_c('tr',{on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{staticStyle:{"border":"1px solid #ddd"},attrs:{"colspan":"11"}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"bottom":"56px","left":"0","right":"0","margin":"auto","padding":"15px"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]):_vm._e()])])])],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bnVc":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataTypes":"Veri Tipleri","dataTypeForHeating":"Yakıt için veri tipi","siteCode":"Kod","update location":"Lokasyon Güncelleme","site name":"Lokasyon adı","is open":"Açık mı?","includeInEmissionsCalculations":"Emisyon hesaplarına dahil et","coordinates":"Koordinatlar"},"en":{"dataTypes":"Data Types","dataTypeForHeating":"Data Type for Heating","siteCode":"Code","update location":"Update Location","site name":"Site Name","is open":"Is Open?","includeInEmissionsCalculations":"Include in Emissions Calculations","coordinates":"Coordinates"}}')
}


/***/ }),

/***/ "bnY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"font-size":"24px","text-align":"left","margin-bottom":"20px","font-weight":"bold"}},[_vm._v("\n        "+_vm._s(_vm.getDataTypeName(_vm.dataType.name))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('emissionTypeColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('factorColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('unitColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('startDateColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('endDateColumn')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"9em"},attrs:{"id":"emission-last-column"}})])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.emissions),function(emission){return _c('tr',{on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(emission)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.bindItems(_vm.rawItems)}]}},[_c('td',[(!emission.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getEmissionTypeName(emission.type))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.emissionTypeNames.text},on:{"change":function($event){return _vm.setEmissionType($event, emission)}},model:{value:(emission.type.editedValue),callback:function ($$v) {_vm.$set(emission.type, "editedValue", $$v)},expression:"emission.type.editedValue"}})]],2),_vm._v(" "),_c('td',[(!emission.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getFactor(emission.factor))+"\n                        ")])]:[_c('b-form-input',{attrs:{"type":"number","placeholder":_vm.$t('factorPlaceHolder'),"required":""},model:{value:(emission.factor.editedValue),callback:function ($$v) {_vm.$set(emission.factor, "editedValue", $$v)},expression:"emission.factor.editedValue"}})]],2),_vm._v(" "),_c('td',[(!emission.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getUnit(emission.unit))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.emissionUnits},on:{"change":function($event){return _vm.setEmissionUnit($event, emission)}},model:{value:(emission.unit.editedValue),callback:function ($$v) {_vm.$set(emission.unit, "editedValue", $$v)},expression:"emission.unit.editedValue"}})]],2),_vm._v(" "),_c('td',[(!emission.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getYear(emission.startDate))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedStartYear($event, _vm.tempItem)}},model:{value:(emission.startDate.editedValue),callback:function ($$v) {_vm.$set(emission.startDate, "editedValue", $$v)},expression:"emission.startDate.editedValue"}})]],2),_vm._v(" "),_c('td',[(!emission.editMode)?[_c('div',[_vm._v("\n                            "+_vm._s(_vm.getYear(emission.endDate))+"\n                        ")])]:[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, emission)}},model:{value:(emission.endDate.editedValue),callback:function ($$v) {_vm.$set(emission.endDate, "editedValue", $$v)},expression:"emission.endDate.editedValue"}})]],2),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"tableBodyCell"},[(!emission.editMode)?_c('div',{staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(emission.id)}}},[_c('i',{staticClass:"fas fa-edit"})]):_c('div',{key:'btngroup',staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.updateItem(emission)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.bindItems(_vm.rawItems)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete')},on:{"click":function($event){return _vm.deleteItem($event, emission.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])])])}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.emissionTypeNames.text},on:{"change":function($event){return _vm.setEmissionType($event, _vm.tempItem)}},model:{value:(_vm.tempItem.type.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.type, "editedValue", $$v)},expression:"tempItem.type.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-input',{attrs:{"type":"number","placeholder":_vm.$t('factorPlaceHolder'),"required":""},model:{value:(_vm.tempItem.factor.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.factor, "editedValue", $$v)},expression:"tempItem.factor.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.emissionUnits},on:{"change":function($event){return _vm.setEmissionUnit($event, _vm.tempItem)}},model:{value:(_vm.tempItem.unit.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.unit, "editedValue", $$v)},expression:"tempItem.unit.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedStartYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.startDate.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.startDate, "editedValue", $$v)},expression:"tempItem.startDate.editedValue"}})],1),_vm._v(" "),_c('td',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices},on:{"change":function($event){return _vm.setSelectedEndYear($event, _vm.tempItem)}},model:{value:(_vm.tempItem.endDate.editedValue),callback:function ($$v) {_vm.$set(_vm.tempItem.endDate, "editedValue", $$v)},expression:"tempItem.endDate.editedValue"}})],1),_vm._v(" "),_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save')},on:{"click":function($event){return _vm.createItem()}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)])]):_vm._e()]),_vm._v(" "),(!_vm.insertMode && this.$store.state.user.permissions.isAdmin)?_c('tr',{staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{attrs:{"colspan":5}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"position":"absolute","bottom":"56px","left":"0","right":"0","margin":"auto"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]):_vm._e()],2)])])]):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwtq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('region-multi-select',{staticStyle:{"margin-right":"10px"},attrs:{"selectedRegionId":_vm.selectedSiteGroupId,"regions":_vm.siteGroups},on:{"oninput":_vm.selectSiteGroupId}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSites},on:{"oninput":_vm.selectSiteId}})],1)],1),_vm._v(" "),_c('div',{staticClass:"scroll-content"},[_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.distributions, consumptions: _vm.initialEmissions.consumption, isSummary: true},"group-type":'scopeGroup'}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds?_vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'purchasedEnergy'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('purchasedEnergy'),"table-unit":'kWh'}})],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c4GZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"}},[_c('h3',[_vm._v(_vm._s(this.$t('userManagement')))])]),_vm._v(" "),_c('b-row',{staticStyle:{"justify-content":"space-between"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{staticClass:"nav-item p-2",staticStyle:{"cursor":"pointer"},style:(tab.isActive ? tab.style.border : '')},[_c('div',{class:{'nav-link': true, 'active': tab.isActive},style:(tab.isActive ? tab.style.tab : ''),on:{"click":function($event){return _vm.activate(tabKey)}}},[_vm._v(_vm._s(tab.name)+"  "),_c('b-badge',{style:(tab.isActive ? tab.style.badge : ''),attrs:{"pill":""}},[_vm._v(_vm._s(tab.users.length))])],1)])}),0)]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[(_vm.anyUserSelected('activeUsers',true))?[_c('b-button',{key:"inviteUser",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.$refs.inviteBox.show()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('inviteUser')))])]:(_vm.anyUserSelected('activeUsers',false))?[_c('b-button',{key:"disableUser",staticClass:"pb-2",staticStyle:{"background-color":"#424959"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.disableUsers()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("zXUD")}}),_vm._v(" "+_vm._s(_vm.$t('disableUser')))]),_vm._v(" "),_c('b-button',{key:"deleteUser",staticClass:"pb-2",staticStyle:{"background-color":"#D04D4D"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.deleteUsers()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("wRVn")}}),_vm._v(" "+_vm._s(_vm.$t('deleteUser')))])]:(_vm.anyUserSelected('disabledUsers',false))?[_c('b-button',{key:"enable",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.enableUsers()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("GuHc")}}),_vm._v(" "+_vm._s(_vm.$t('enableUser')))]),_vm._v(" "),_c('b-button',{key:"deleteUser",staticClass:"pb-2",staticStyle:{"background-color":"#D04D4D"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.deleteUsers()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("wRVn")}}),_vm._v(" "+_vm._s(_vm.$t('deleteUser')))])]:(_vm.anyUserSelected('pendingInvitations',true) && _vm.tabs.pendingInvitations.users.length > 0)?[_c('b-button',{key:"inviteUser",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.$refs.inviteBox.show()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('inviteUser')))])]:(_vm.anyUserSelected('pendingInvitations',false) && _vm.tabs.pendingInvitations.users.length > 0)?[_c('b-button',{key:"reinvite",staticClass:"pb-2",staticStyle:{"background-color":"#F2AB24"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.reInvite()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("F2z3")}}),_vm._v(" "+_vm._s(_vm.$t('reInvite')))]),_vm._v(" "),_c('b-button',{key:"cancelInvite",staticClass:"pb-2",staticStyle:{"background-color":"#022B49"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.cancelInvite()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("dBXw")}}),_vm._v(" "+_vm._s(_vm.$t('cancelInvite')))])]:void 0],2)],1),_vm._v(" "),_c('b-modal',{ref:"inviteBox",attrs:{"title":_vm.$t('inviteUser'),"size":"lg","hide-footer":"","centered":""}},[_c('b-container',{staticClass:"my-4",attrs:{"fluid":""}},[_c('form',{ref:"form"},[_c('b-form-group',{attrs:{"label":_vm.$t('email'),"label-for":"email-input","label-class":"font-weight-bold pt-0"}},[_c('b-form-tags',{class:{'is-invalid': _vm.error.emailValidation },attrs:{"id":"email-input","separator":" ,;","placeholder":"Ex: name@mail.com","tag-class":"tag-email","addButtonVariant":"outline-light","addButtonText":"","size":"lg","input-type":"email","duplicate-tag-text":_vm.$t('alreadyEnteredEmail'),"disabledAddButton":"","tag-pills":"","no-outer-focus":"","remove-on-delete":"","required":""},model:{value:(_vm.emails),callback:function ($$v) {_vm.emails=$$v},expression:"emails"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error.emailValidation),expression:"error.emailValidation"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t(_vm.emailErrorMessage))+" "+_vm._s(_vm.invalidEmails))])],1),_vm._v(" "),_c('span',{staticStyle:{"padding":"1em 0"}},[_c('h5',{staticStyle:{"color":"#A7A7A7"}},[_vm._v(_vm._s(_vm.$t('afterInvitePermCanBeEdit')))])])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"padding-top":"5px"}}),_vm._v(" "),_c('b-row',{attrs:{"align-h":"end"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-btn',{staticClass:"mt-3",attrs:{"size":"md","variant":"outline-success","block":""},on:{"click":function($event){return _vm.closeInviteModal()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-btn',{staticClass:"mt-3",staticStyle:{"background-color":"#41B884"},attrs:{"size":"md","block":""},on:{"click":function($event){return _vm.inviteUsers()}}},[_vm._v(_vm._s(_vm.$t('sendInvite')))])],1)],1)],1),_vm._v(" "),(_vm.tabs.disabledUsers.isActive && _vm.tabs.disabledUsers.users.length == 0)?[_c('div',{staticStyle:{"padding-top":"5em","margin":"auto","height":"calc(60vh) !important"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"align-self":"center"}},[_c('b-row',[_c('img',{staticStyle:{"margin":"auto","filter":"invert(74%) sepia(0%) saturate(1345%) hue-rotate(252deg) brightness(2.7) contrast(91%) !important"},attrs:{"height":"150px","src":__webpack_require__("zXUD")}})]),_vm._v(" "),_c('b-row',[_c('b-card',{staticStyle:{"border":"none","margin":"auto","width":"50%","color":"#A7A7A7","padding-top":"10px"}},[_c('span',{staticStyle:{"font-size":"20px"}},[_c('b',[_vm._v(_vm._s(_vm.$t('noDisabledUser')))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('canDisableFrom'))+" "),_c('b',{staticClass:"a",staticStyle:{"color":"#D118A8"},on:{"click":function($event){return _vm.activate('activeUsers')}}},[_vm._v(_vm._s(_vm.$t('activeUsers')))]),_vm._v(" "+_vm._s(_vm.$t('canDisableFrom-p2')))])])],1)],1)],1)],1)]:(_vm.tabs.pendingInvitations.isActive && _vm.tabs.pendingInvitations.users.length == 0)?[_c('div',{staticStyle:{"padding":"5em","margin":"auto","height":"calc(60vh) !important"}},[_c('b-row',[_c('b-col',{attrs:{"align-self":"center"}},[_c('b-row',[_c('img',{staticStyle:{"margin":"auto","filter":"invert(74%) sepia(0%) saturate(1345%) hue-rotate(252deg) brightness(2.7) contrast(91%) !important"},attrs:{"height":"150px","src":__webpack_require__("ZT9M")}})]),_vm._v(" "),_c('b-row',[_c('b-card',{staticStyle:{"border":"none","margin":"auto","width":"50%","color":"#A7A7A7","padding-top":"10px"}},[_c('span',{staticStyle:{"font-size":"20px"}},[_c('b',[_vm._v(_vm._s(_vm.$t('noPendingInvitation')))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.$t('canInviteUserFromBelow')))])])],1),_vm._v(" "),_c('b-row',[_c('b-button',{key:"inviteUser",staticClass:"pb-2",staticStyle:{"margin":"auto","background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.$refs.inviteBox.show()}}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('inviteUser')))])],1)],1)],1)],1)]:(_vm.tabs.pendingInvitations.isActive)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"3em","text-align":"left"}},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},on:{"change":function($event){return _vm.selectAllUsers($event,_vm.activeTab)}},model:{value:(_vm.tabs[_vm.activeTab].allUsersSelected),callback:function ($$v) {_vm.$set(_vm.tabs[_vm.activeTab], "allUsersSelected", $$v)},expression:"tabs[activeTab].allUsersSelected"}})],1),_vm._v(" "),_c('th',{staticStyle:{"width":"10em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('user')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"8em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('roles')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"5em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('invite-date')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.itemsForList(_vm.tabs[_vm.activeTab].users)),function(user){return _c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},on:{"input":function($event){return _vm.selectUser(_vm.tabs.activeUsers)}},model:{value:(user.selected),callback:function ($$v) {_vm.$set(user, "selected", $$v)},expression:"user.selected"}})],1),_vm._v(" "),_c('td',{staticClass:"a",staticStyle:{"text-align":"left","cursor":"pointer"},on:{"click":function($event){return _vm.routeToUser(user.id)}}},[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},_vm._l((user.userGroups),function(userGroup){return _c('h5',{staticStyle:{"display":"inline-block","padding":"1px"}},[(userGroup=='admin')?_c('b-badge',{staticClass:"a",attrs:{"pill":"","variant":"success"},on:{"click":function($event){return _vm.routeUserGroup(userGroup.id)}}},[_vm._v(_vm._s(_vm.translateUserGroup(userGroup)))]):_c('b-badge',{staticClass:"a",attrs:{"pill":"","variant":"secondary"},on:{"click":function($event){return _vm.routeUserGroup(userGroup.id)}}},[_vm._v(_vm._s(_vm.translateUserGroup(userGroup)))])],1)}),0),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.getFormatedDate(user.inviteDate)))])])}),0)])]):_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"3em","text-align":"left"}},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},on:{"change":function($event){return _vm.selectAllUsers($event,_vm.activeTab)}},model:{value:(_vm.tabs[_vm.activeTab].allUsersSelected),callback:function ($$v) {_vm.$set(_vm.tabs[_vm.activeTab], "allUsersSelected", $$v)},expression:"tabs[activeTab].allUsersSelected"}})],1),_vm._v(" "),_c('th',{staticStyle:{"width":"10em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('user')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('job/department')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"8em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('roles')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"5em","text-align":"left"}},[_vm._v(_vm._s(_vm.$t('singup-date')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"5em","text-align":"left"}},[_vm._v(_vm._s(_vm.tabs.activeUsers.isActive ? _vm.$t('last-login-date') : _vm.$t('disable-date')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.itemsForList(_vm.tabs[_vm.activeTab].users)),function(user){return _c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},on:{"input":function($event){return _vm.selectUser(_vm.tabs.activeUsers)}},model:{value:(user.selected),callback:function ($$v) {_vm.$set(user, "selected", $$v)},expression:"user.selected"}})],1),_vm._v(" "),_c('td',{staticClass:"a",staticStyle:{"text-align":"left","cursor":"pointer"},on:{"click":function($event){return _vm.routeToUser(user.id)}}},[_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"sm":"3"}},[_c('b-avatar',{staticClass:"mr-3",attrs:{"src":user.profilePic}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-row',[_c('b',[_vm._v(_vm._s(user.name))])]),_vm._v(" "),_c('b-row',[_vm._v("\n                                        "+_vm._s(user.email)+"\n                                    ")])],1)],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('b-col',[_c('b-row',[_c('b',[_vm._v(_vm._s(user.jobTitle))])]),_vm._v(" "),_c('b-row',[_vm._v("\n                                    "+_vm._s(user.department)+"\n                                ")])],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},_vm._l((user.userGroups),function(userGroup){return _c('h5',{staticStyle:{"display":"inline-block","padding":"1px"}},[(userGroup.type=='admin' || userGroup.type == 'supervisor')?_c('b-badge',{staticClass:"a admin-color",attrs:{"pill":""},on:{"click":function($event){return _vm.routeUserGroup(userGroup.id)}}},[_vm._v(_vm._s(_vm.translateUserGroup(userGroup)))]):_c('b-badge',{staticClass:"a role-color",attrs:{"pill":""},on:{"click":function($event){return _vm.routeUserGroup(userGroup.id)}}},[_vm._v(_vm._s(_vm.translateUserGroup(userGroup)))])],1)}),0),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.getFormatedDate(user.signupDate)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.tabs.activeUsers.isActive ? _vm.getFormatedDate(user.lastLoginDate) : _vm.getFormatedDate(user.disableDate)))])])}),0)])]),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.tabs[_vm.activeTab].users.length,"per-page":_vm.perPage,"aria-controls":"itemList","align":"center"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c60z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SiteMultiSelectTree_vue__ = __webpack_require__("oE/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { SiteMultiSelectTree: __WEBPACK_IMPORTED_MODULE_2__SiteMultiSelectTree_vue__["a" /* default */] },
    name: 'createGoal',
    data: function data() {
        return {
            formGroupInput1Warn: false,
            formGroupInput2Warn: {},
            eventId: null,
            type: null,
            postTitle: null,
            selectedGoal: null,
            allSites: [],
            selectedTypeId: null,
            baseYear: null,
            targetYear: null,
            targetType: null,
            targetValue: 0,
            allDataTypes: null,
            inProgress: false,
            removingProcess: false,
            yearChoices: {
                startYearChoices: [{
                    value: '' + (new Date().getFullYear() - 5),
                    text: '' + (new Date().getFullYear() - 5)
                }, {
                    value: '' + (new Date().getFullYear() - 4),
                    text: '' + (new Date().getFullYear() - 4)
                }, {
                    value: '' + (new Date().getFullYear() - 3),
                    text: '' + (new Date().getFullYear() - 3)
                }, {
                    value: '' + (new Date().getFullYear() - 2),
                    text: '' + (new Date().getFullYear() - 2)
                }, {
                    value: '' + (new Date().getFullYear() - 1),
                    text: '' + (new Date().getFullYear() - 1)
                }],
                endYearChoices: [{
                    value: '' + new Date().getFullYear(),
                    text: '' + new Date().getFullYear()
                }, {
                    value: '' + (new Date().getFullYear() + 1),
                    text: '' + (new Date().getFullYear() + 1)
                }, {
                    value: '' + (new Date().getFullYear() + 2),
                    text: '' + (new Date().getFullYear() + 2)
                }, {
                    value: '' + (new Date().getFullYear() + 3),
                    text: '' + (new Date().getFullYear() + 3)
                }, {
                    value: '' + (new Date().getFullYear() + 4),
                    text: '' + (new Date().getFullYear() + 4)
                }, {
                    value: '' + (new Date().getFullYear() + 5),
                    text: '' + (new Date().getFullYear() + 5)
                }]
            }
        };
    },

    filters: {
        toRatio: function toRatio(dividend, divider) {
            return divider ? (dividend / divider * 100).toFixed(0) : '-';
        },
        descriptionValueToText: function descriptionValueToText(val, descriptions) {
            return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(descriptions, { id: val }).description_text;
        },
        textToShortText: function textToShortText(val) {
            if (val && val.length > 25) {
                return val.slice(0, 25) + '...';
            } else {
                return val;
            }
        }
    },
    methods: {
        getSelectedSiteIds: function getSelectedSiteIds() {
            return this.selectedGoal.goalSites.editedValue;
        },
        cancel: function cancel() {
            var result = { process: 'reset', id: this.selectedGoal.id };
            this.$eventHub.$emit(this.$store.state.modal.eventId, result);
            this.closeModal();
        },
        closeModal: function closeModal() {
            //this.onShow();
            this.$refs.createGoal.hide();
        },
        insert: function insert() {
            var _this = this;

            if (this.isValidInsertion() && !this.inProgress) {
                var selectedSiteIds = this.getSiteIdsInGroupedSitesMap(this.selectedGoal.goalSites.editedValue);
                var arrangedItem = {
                    startYear: this.selectedGoal.startYear.editedValue,
                    endYear: this.selectedGoal.endYear.editedValue,
                    siteId: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.head(selectedSiteIds),
                    dataTypeId: this.selectedGoal.dataTypeId.editedValue,
                    direction: this.selectedGoal.direction.editedValue,
                    sites: selectedSiteIds,
                    valueR: Number(this.delocalizeValue(this.selectedGoal.valueR.editedValue, this.locale).replace('.', '').replace(',', '.')),
                    typeUnitId: 1,
                    isGlobal: 1
                };

                this.$Progress.start();
                this.inProgress = true;
                return this.axios.post('/globalGoals', arrangedItem, { timeout: 6000000 }).then(function (_ref) {
                    var data = _ref.data;

                    var result = data;
                    result['sites'] = selectedSiteIds;
                    result['process'] = 'insert';
                    _this.$eventHub.$emit(_this.$store.state.modal.eventId, result);
                    _this.inProgress = false;
                    return _this.$Progress.finish();
                }).then(function () {
                    return _this.closeModal();
                }).catch(function (err) {
                    _this.err = err;
                    _this.showErrorNotification();
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        update: function update() {
            var _this2 = this;

            if (this.isValidInsertion() && !this.inProgress) {
                var selectedSiteIds = this.getSiteIdsInGroupedSitesMap(this.selectedGoal.goalSites.editedValue);
                var arrangedItem = {
                    startYear: this.selectedGoal.startYear.editedValue,
                    endYear: this.selectedGoal.endYear.editedValue,
                    dataTypeId: this.selectedGoal.dataTypeId.editedValue,
                    direction: this.selectedGoal.direction.editedValue,
                    sites: {
                        old: this.selectedGoal.goalSites.value,
                        new: selectedSiteIds
                    },
                    parentSiteId: this.selectedGoal.parentSiteId,
                    valueR: Number(this.delocalizeValue(this.selectedGoal.valueR.editedValue, this.locale).replace('.', '').replace(',', '.')),
                    typeUnitId: 1,
                    isGlobal: 1
                };

                this.$Progress.start();
                this.inProgress = true;
                return this.axios.put('/globalGoals/' + this.selectedGoal.id, arrangedItem).then(function (_ref2) {
                    var data = _ref2.data;

                    var result = data;
                    result['sites'] = selectedSiteIds;
                    result['process'] = 'update';
                    _this2.$eventHub.$emit(_this2.$store.state.modal.eventId, result);
                    _this2.inProgress = false;
                    return _this2.$Progress.finish();
                }).then(function () {
                    return _this2.closeModal();
                });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        deleteGoal: function deleteGoal() {
            var _this3 = this;

            this.$Progress.start();
            this.inProgress = true;
            this.axios.delete('/globalGoals/' + this.selectedGoal.id).then(function () {
                var result = { process: 'delete', id: _this3.selectedGoal.id };
                _this3.$eventHub.$emit(_this3.$store.state.modal.eventId, result);
                _this3.inProgress = false;
                _this3.removingProcess = false;
                return _this3.$Progress.finish();
            }).then(function () {
                return _this3.closeModal();
            }).catch(function () {
                _this3.showErrorNotification('deletion-failed');
            });
            /*
            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, () => {
            });
            */
        },
        configureItemOnDataTypeChange: function configureItemOnDataTypeChange() {
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-custom-input');
                if (elements[0]) {
                    elements[0].focus();
                }
                return true;
            });
        },
        isValidInsertion: function isValidInsertion() {

            var isValid = true;

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.selectedGoal.dataTypeId.editedValue)) {
                //this.selectedGoal.dataTypeId.classes['is-invalid'] = true;
                //this.selectedGoal.dataTypeId.hasWarn = true;
                this.formGroupInput1Warn = true;
                isValid = false;
            } else {
                this.formGroupInput1Warn = false;
                //this.selectedGoal.dataTypeId.classes['is-invalid'] = false;
                //this.selectedGoal.dataTypeId.hasWarn = false;
            }

            if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isNil(this.selectedGoal.goalSites.editedValue) || this.selectedGoal.goalSites.editedValue.length == 0) {
                //this.selectedGoal.goalSites.classes['is-invalid'] = true;
                //this.selectedGoal.goalSites.hasWarn = true;
                this.formGroupInput2Warn = { 'width': '100%', 'border': '1px solid #ff0000' };
                isValid = false;
            } else {
                this.formGroupInput2Warn = {};
                //this.selectedGoal.goalSites.classes['is-invalid'] = false;
                //this.selectedGoal.goalSites.hasWarn = false;
            }
            return isValid;
        },
        onShow: function onShow() {
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
            this.eventId = this.$store.state.modal.eventId;
            this.type = this.$store.state.modal.type;
            this.postTitle = this.$store.state.modal.payload.title;
            this.allSites = this.$store.state.modal.payload.allSites;
            this.allDataTypes = this.$store.state.modal.payload.allDataTypes;

            if (this.type === 'createGoal') {
                this.selectedGoal = {
                    startYear: { editedValue: '' + (new Date().getFullYear() - 1) },
                    endYear: { editedValue: '' + new Date().getFullYear() },
                    direction: { editedValue: 0 },
                    dataTypeId: { editedValue: null },
                    valueR: { editedValue: '0' },
                    goalSites: { editedValue: [] },
                    unitName: ''
                };

                for (var key in this.selectedGoal) {
                    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.selectedGoal[key]) === 'object') {
                        this.selectedGoal[key].required = true;
                        this.selectedGoal[key].hasWarn = false;
                        this.selectedGoal[key].lockR = false;
                        this.selectedGoal[key].classes = {
                            'is-invalid': false,
                            'form-control': true
                        };
                        this.selectedGoal[key].warnMessage = this.$t('required');
                    }
                }
            } else {
                this.selectedGoal = this.$store.state.modal.payload.selectedGoal;
            }
        },
        selectSite: function selectSite(value) {
            this.selectedGoal.goalSites.editedValue = value;
        },
        setSelectedBaseYear: function setSelectedBaseYear(val) {
            this.selectedGoal.startYear.editedValue = val;
        },
        setSelectedEndYear: function setSelectedEndYear(val) {
            this.selectedGoal.endYear.editedValue = val;
        },
        pipeNumber: function pipeNumber() {
            var _this4 = this;

            return function (conformedValue) {
                if (_this4.selectedGoal.direction.editedValue === -1) {
                    var unlocalizedConformedValue = Number(_this4.delocalizeValue(_this4.selectedGoal.valueR.editedValue, _this4.locale));
                    return unlocalizedConformedValue > 100 ? '100' : conformedValue;
                } else {
                    return conformedValue;
                }
            };
        },
        resetWarning: function resetWarning(key) {
            this.selectedGoal[key].classes['is-invalid'] = false;
            this.selectedGoal[key].hasWarn = false;
        },
        init: function init() {
            this.onShow();
            //this.allSites = this.sitesWithGroups;
        }
    },
    computed: {},
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cGBr":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"BELGELER","docCountColumn":"Doküman Sayısı"},"en":{"title":"DOCUMENTS","docCountColumn":"Documents"}}')
}


/***/ }),

/***/ "cKtT":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"activeSources":"Aktif Kaynaklar","inactiveSources":"Pasif Kaynaklar","addSource":"Kaynak Ekle","dataLoading":"Veri Yükleniyor..."},"en":{"activeSources":"Active Sources","inactiveSources":"Inactive Sources","addSource":"Add Source","dataLoading":"Loading Data..."}}')
}


/***/ }),

/***/ "cLQJ":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"startDate":"Başlangıç","endDate":"Bitiş","Veri Sağlığı":"Veri Kontrolü","Fatura":"Fatura","Açıklama":"Açıklama","description":"Açıklama","Son Değişiklik Tarihi":"Son Değişiklik","Tarih Aralığı":"Tarih Aralığı","Maliyet":"Tutar","Ödeme Yöntemi":"Ödeme Tipi","Veri Tipi":"Veri Tipi","Son Düzenleyen":"Son Düzenleyen","dataType":"Veri Tipi","value":"Tüketim Miktarı","Miktar":"Tüketim Miktarı","noUnits":"Adet","noUnitsValue":"Toplam Tüketim","noUnitsCost":"Toplam Tutar","Talep":"Talep Miktarı","Low Unit Price":"Düşük Birim Fiyat","High Unit Price":"Yüksek Birim Fiyat","Düşük Birim Fiyat":"Düşük Birim Fiyat","Yüksek Birim Fiyat":"Yüksek Birim Fiyat","Yüksek Tüketim":"Yüksek Tüketim","High Consumption":"Yüksek Tüketim","more":"daha","and":" ve ","Source":"Kaynak","Activity":"Aktivite","Type":"Tür","Location":"Lokasyon","disableYear":"İnaktivasyon Yılı","Veri Sagligi":"Veri Kontrolü","Son Degisiklik Tarihi":"Son Değişiklik","Tarih Araligi":"Tarih Aralığı","Aciklama":"Açıklama"},"en":{"startDate":"Start Date","endDate":"End Date","Veri Sağlığı":"Data Health","Tarih Aralığı":"Date Range","Fatura":"Bill","Açıklama":"Description","description":"Description","Son Değişiklik Tarihi":"Last Update","Maliyet":"Cost","Ödeme Yöntemi":"Payment Method","Veri Tipi":"Data Type","Son Düzenleyen":"Last Editor","dataType":"Data Type","value":"Amount","Miktar":"Amount","Adet":"Unit","Toplam Tüketim":"Total Consumption","Toplam Maliyet":"Total Cost","Talep":"Demand","Low Unit Price":"Low Unit Price","High Unit Price":"High Unit Price","Düşük Birim Fiyat":"Low Unit Price","Yüksek Birim Fiyat":"High Unit Price","Yüksek Tüketim":"High Consumption","High Consumption":"High Consumption","Aylık Ortalama Tüketim":"Monthly Average Consumption","Aylık Ortalama Maliyet":"Monthly Average Cost","more":"more","and":" and ","Source":"Source","Activity":"Activity","Type":"Type","Location":"Location","disableYear":"Inactivation Year","Veri Sagligi":"Data Health","Son Degisiklik Tarihi":"Last Update","Tarih Araligi":"Date Range","Aciklama":"Description"}}')
}


/***/ }),

/***/ "cwe7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dBXw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZyBpZD0ibm90LXNlbnQtZmlsbGVkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi4yNSAtMi4yNSkiPgogICAgPHBhdGggaWQ9IlBhdGhfNzg2IiBkYXRhLW5hbWU9IlBhdGggNzg2IiBkPSJNMjQuMjUsMjMuMTQyLDMuMzU4LDIuMjUsMi4yNSwzLjM1OCw4LjUzNiw5LjY0MywyLjc2OCwxMS43MjVhLjc4Ni43ODYsMCwwLDAsMCwxLjQ2OWw2Ljc0OSwyLjcsMi42MjUtMi42NCwxLjEwOCwxLjEwOEwxMC42LDE3LjAwNWwyLjcsNi43NDlhLjc3NC43NzQsMCwwLDAsMS40NTMtLjAyNGwyLjEwNi01Ljc2N0wyMy4xNSwyNC4yNVoiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzc4NyIgZGF0YS1uYW1lPSJQYXRoIDc4NyIgZD0iTTIyLjgxNywxNS4yNiwyNS41MjgsNy44QS43ODYuNzg2LDAsMCwwLDI0LjUyMiw2LjhMMTcuMDY2LDkuNTA4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuNDY4IC0xLjM1OCkiIGZpbGw9IiNmZmYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "dC+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketList_vue__ = __webpack_require__("V0gH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115b05c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketList_vue__ = __webpack_require__("7cXw");
function injectStyle (ssrContext) {
  __webpack_require__("5wAA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-115b05c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TicketList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115b05c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TicketList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("qeYM")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dEe2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SiteDetail',
    components: {
        Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
    },
    data: function data() {
        return {
            name: null,
            code: null,
            area: null,
            staffCount: null,
            lat: null,
            lng: null,
            cityCode: null,
            region: null,
            siteStaff: null,
            supervisorList: null,
            staff: null,
            selectedAgent: null,
            siteAgent: null,
            siteAgentModel: null,
            siteSubAgentModel: null,
            siteSupervisorModel: null,
            heatingDataTypeModel: null,
            heatingDataTypes: null,
            emissionModel: null,
            isOpenModel: null,
            dataTypes: [],
            allDataTypes: [],
            userList: [],
            agentUsers: [],
            subAgentUsers: [],
            supervisorUsers: [],
            directors: '',
            errors: {
                name: false,
                code: false,
                area: false,
                staffCount: false,
                lat: false,
                lng: false,
                cityCode: false,
                region: false,
                siteAgentModel: false,
                siteSubAgentModel: false,
                siteSupervisorModel: false,
                directors: false,
                heatingDataTypeModel: false,
                dataTypes: false
            }
        };
    },

    methods: {
        validate: function validate() {
            // @todo: make this condition easier to read.
            if (!this.dataTypes.length || this.siteAgentModel != -1 && this.siteSubAgentModel == this.siteAgentModel) {
                return false;
            }
            for (var key in this.errors) {
                if (key !== 'lng' && key !== 'lat' && key !== 'directors') {
                    this.errors[key] = !this[key];
                }
            }
            // checks true value count of erros object
            return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errors).filter(function (value) {
                return value;
            }).length;
        },
        getSiteName: function getSiteName(agentSiteId) {
            var agentSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: agentSiteId });
            return agentSite.originalName;
        },
        update: function update() {
            var _this = this;

            if (this.validate()) {
                var site = {
                    name: this.name,
                    code: this.code,
                    area: this.area,
                    staffCount: this.staffCount,
                    lon: this.lng || null,
                    lat: this.lat || null,
                    city: this.cityCode,
                    site_group_id: this.region,
                    site_agent: this.siteAgent,
                    dataTypes: this.dataTypes.map(function (dataType) {
                        return dataType.id;
                    }),
                    agentId: this.siteAgentModel,
                    subAgentId: this.siteSubAgentModel,
                    supervisorId: this.siteSupervisorModel,
                    calculateEmission: this.emissionModel,
                    isOpen: this.isOpenModel,
                    heatingDataType: this.heatingDataTypeModel
                };
                site.agentId = site.agentId == -1 ? null : site.agentId;
                site.subAgentId = site.subAgentId == -1 ? null : site.subAgentId;
                site.supervisorId = site.supervisorId == -1 ? null : site.supervisorId;

                this.$Progress.start();
                // TODO: area and staffcount do not belong to site table, therefore these data types request should be sent to site_property table.
                return this.axios.put('/sites/' + this.route.params.site_id, site).then(function () {
                    _this.sites = _this.$store.state.sites;
                    _this.sendMail(site);
                    _this.$Progress.finish();
                }).catch(function () {
                    _this.$Progress.fail();
                });
            } else {
                // @todo: make this condition easier to read.
                this.siteSubAgentModel && this.siteAgentModel != -1 && this.siteSubAgentModel == this.siteAgentModel ? this.$toasted.error(this.$t('duplicateAgents')) : !this.dataTypes.length ? this.$toasted.error(this.$t('missingDataType')) : this.$toasted.error(this.$t('missingError'));
            }
        },
        sendMail: function sendMail(site) {
            var _this2 = this;

            // If there is a selected agent and that agent is not the same as current site agent send mail to director and supervisor.
            if (this.siteAgentModel != -1 && site.agentId != this.siteAgentModel) {
                // Send mails to agent, director and supervisor.
                this.axios.post('/siteMail/agent/' + this.route.params.site_id).then(function () {
                    _this2.$toasted.show(_this2.$t('updated'));
                    setTimeout(function () {
                        return _this2.$router.go();
                    }, 500);
                }).catch(function () {
                    _this2.$Progress.fail();
                });
            } else {
                this.$toasted.show(this.$t('updated'));
                setTimeout(function () {
                    return _this2.$router.go();
                }, 500);
            }
        },
        getHeatingList: function getHeatingList() {
            var _this3 = this;

            return this.axios.get('/data-type/heating').then(function (_ref) {
                var data = _ref.data;

                _this3.heatingDataTypes = data;
                return data;
            });
        },
        getUserList: function getUserList() {
            var _this4 = this;

            return this.axios.get('/userList/' + this.route.params.site_id).then(function (_ref2) {
                var data = _ref2.data;

                _this4.userList = data.userList;
                _this4.agentUsers = _this4.userList.agents;
                _this4.subAgentUsers = _this4.isbId(_this4.$store.state.user.customerId) ? _this4.userList.subAgents : _this4.userList.agents;
                _this4.supervisorUsers = _this4.userList.supervisors;
                //this.agentUsers = _.filter(this.userList, function(o){ return o.groupId == 1 || o.groupId == 6});
                //this.supervisorUsers = _.filter(this.userList, function(o){ return o.groupId == 3});
                _this4.getAllSiteDetails();
                return data;
            });
        },
        getAllSiteDetails: function getAllSiteDetails() {
            var _this5 = this;

            var foundSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
            if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(foundSite)) {
                this.name = foundSite.originalName;
                this.cityCode = foundSite.cityCode;
                this.region = foundSite.siteGroupId;
                var currentAgentId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.nth(foundSite.agentIds, 0);
                var currentSubAgentId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.nth(foundSite.subAgentIds, 0);
                var currentSupervisorId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.nth(foundSite.supervisorIds, 0);
                this.directors = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(foundSite, 'directors'), '0');
                this.code = foundSite.code;
                this.area = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(foundSite.yearlyProperties, function (results, properties) {
                    var notNullArea = properties.area;
                    if (notNullArea) {
                        results.push(properties.area);
                    }
                    return results;
                }, []));
                this.staffCount = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.last(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(foundSite.yearlyProperties, function (results, properties) {
                    var notNullArea = properties.staffCount;
                    if (notNullArea) {
                        results.push(properties.staffCount);
                    }
                    return results;
                }, []));
                this.siteAgent = foundSite.agents;
                /*this.siteStaff = _.filter(this.userList, function(o){
                    return o.site_id === foundSite.id;
                });
                
                this.staff = _.filter(this.userList, function(o){
                    return o.site_id !== foundSite.id;
                });
                */
                this.selectedAgent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.agentUsers, function (o) {
                    return o.id == currentAgentId;
                });
                this.siteAgentModel = this.selectedAgent ? this.selectedAgent.id : '-1';
                var selectedSubAgent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.agentUsers, function (o) {
                    return o.id == currentSubAgentId;
                });
                this.siteSubAgentModel = selectedSubAgent ? selectedSubAgent.id : '-1';
                /*
                let allSitesHaveSupervisor = _.filter(this.sites, function(o){
                    return o.supervisors !== null;
                });
                this.supervisorList = _.uniqBy(allSitesHaveSupervisor, 'supervisors');
                this.siteSupervisorModel = (_.find(allSitesHaveSupervisor, {id: Number(this.route.params.site_id)})) ? (_.find(allSitesHaveSupervisor, {id: Number(this.route.params.site_id)})).supervisorIds : -1;
                */
                var selectedSupervisor = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.supervisorUsers, function (o) {
                    return o.id == currentSupervisorId;
                });
                this.siteSupervisorModel = selectedSupervisor ? selectedSupervisor.id : '-1';

                this.emissionModel = foundSite.calculateEmission;
                this.isOpenModel = foundSite.isOpen;
                this.lat = foundSite.lat;
                this.lng = foundSite.lng;
                this.allDataTypes = this.$store.state.dataTypes;
                this.allDataTypes.forEach(function (dataType) {
                    dataType.name = _this5.$t(dataType.name);
                });
                this.dataTypes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(foundSite.dataTypes.map(function (dataType) {
                    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this5.allDataTypes, { id: dataType });
                }), function (dataType) {
                    return dataType !== undefined;
                });
                this.heatingDataTypeModel = foundSite.heatingDataType;
            }
        },
        fetchAllData: function fetchAllData() {
            var _this6 = this;

            this.$Progress.start();
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.getHeatingList(), this.getUserList()]).then(function () {
                _this6.$Progress.finish();
            });
        }
    },

    created: function created() {
        this.fetchAllData();
    }
});

/***/ }),

/***/ "dQWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("tCm2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f812beb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("tdq8");
function injectStyle (ssrContext) {
  __webpack_require__("SLDS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f812beb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("t9g2")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dQob":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"domestic-waste":"Atık","next-year":"Sonraki sene","previous-year":"Önceki sene","data-type":"Veri Tipi","reporting-period":"Raporlama Dönemi","comparing-period":"Karşılaştırma Dönemi","normalization-parameter":"Normalizasyon","site-type":"Lokasyon Tipi","filter":"Filtrele","filtering":"Filtreleniyor","numberOfStaff":"Kişi sayısı","diffrence":"Değişim","start-date":"Başlangıç tarihi","end-date":"Bitiş tarihi","person":"Kişi","this-month":"Bu ay","this-year":"Bu yıl","last-6-months":"Son 6 ay","Site":"Lokasyon"},"en":{"domestic-waste":"Waste","next-year":"Year later","previous-year":"Year prior","data-type":"Data Type","reporting-period":"Reporting Period","comparing-period":"Comparison Period","normalization-parameter":"Normalization","site-type":"Location Type","filter":"Filter","filtering":"Filtering","numberOfStaff":"Number of Occupants","diffrence":"Diffrence","start-date":"Start date","end-date":"End date","person":"Occupants","this-month":"This month","this-year":"This year","last-6-months":"Last 6 months","Site":"Site"}}')
}


/***/ }),

/***/ "dSCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalCarbonEmissions_vue__ = __webpack_require__("6Y2D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f83796e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalCarbonEmissions_vue__ = __webpack_require__("kLm4");
function injectStyle (ssrContext) {
  __webpack_require__("9p+P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f83796e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TotalCarbonEmissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f83796e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TotalCarbonEmissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"element-loading-text":_vm.$t('dataLoading')}},[_c('b-row',{staticStyle:{"text-align":"center","border-bottom":"1px solid #ddd"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"mb-2",staticStyle:{"display":"flex","justify-content":"flex-start","height":"40px"},attrs:{"cols":"6"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.route.params.site_id, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4","sm":"4","md":"6","lg":"6","xl":"5"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{attrs:{"variant":"light"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true,"variant":"light"},on:{"oninput":_vm.selectSiteId}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2",staticStyle:{"justify-content":"space-between"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{key:tabKey,staticClass:"nav-item p-2",staticStyle:{"cursor":"pointer"},style:(tab.isActive ? tab.style.border : '')},[_c('div',{class:{'nav-link': true, 'active': tab.isActive},style:(tab.isActive ? tab.style.tab : ''),on:{"click":function($event){return _vm.activate(tabKey)}}},[_vm._v(_vm._s(tab.name)+"  "),_c('b-badge',{style:(tab.isActive ? tab.style.badge : ''),attrs:{"pill":""}},[_vm._v(_vm._s(tab.tableInfo.items.length))])],1)])}),0)]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[(_vm.tabs.activeSources.isActive)?[(this.$store.state.user.permissions.canAddDatatype)?_c('b-button',{key:"addSource",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":_vm.showCreateSourceModal}},[_c('img',{attrs:{"width":"20px","height":"20px","src":__webpack_require__("+9UU")}}),_vm._v(" "+_vm._s(_vm.$t('addSource')))]):_vm._e()]:_vm._e()],2)],1),_vm._v(" "),(_vm.tabs.activeSources.isActive)?_c('vue-table',{staticClass:"mt-3",attrs:{"tableName":'active_data_summary',"initialData":this.tabs.activeSources.tableInfo,"isEditable":this.$store.state.user.permissions.canAddDatatype},on:{"openEditModal":_vm.showEditSourceModal}}):_c('vue-table',{staticClass:"mt-3",attrs:{"tableName":'inactive_data_summary',"initialData":this.tabs.inactiveSources.tableInfo,"isEditable":this.$store.state.user.permissions.canAddDatatype,"isDeletable":false},on:{"openEditModal":_vm.showEditSourceModal}})],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dmRH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'signup',
    data: function data() {
        return {
            firstname: null,
            lastname: null,
            email: null,
            password: null,
            confirmedPass: null // Simdilik yok
        };
    },

    methods: {
        signup: function signup() {
            var _this = this;

            return this.axios.post('/signup', {
                firstname: this.firstname,
                lastname: this.lastname,
                email: this.email,
                password: this.password
            }).then(function () {
                _this.$router.push('dashboard');
                return true;
            });
        }
    }
});

/***/ }),

/***/ "drnr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dsTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"notificationModal",attrs:{"id":"notification","size":"sm","top":""}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t(_vm.$store.state.modal.text)))]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.$refs.notificationModal.hide()}}},[_vm._v(_vm._s(_vm.$t('ok')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dw4H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Doughnut */],
    name: 'DoughnutChart',
    props: ['chartData', 'options', 'chartId'],
    mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["e" /* mixins */].reactiveProp],
    data: function data() {
        return {
            isLoaded: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
        this.$eventHub.$on(this.chartId, function () {
            if (_this.isLoaded) {
                _this.$data._chart.update();
            }
        });
        this.isLoaded = true;
    },
    beforeDestroy: function beforeDestroy() {
        this.$eventHub.$off(this.chartId);
    }
});

/***/ }),

/***/ "dyab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadDataViaExcel_vue__ = __webpack_require__("O4/U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d9b238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadDataViaExcel_vue__ = __webpack_require__("6VKj");
function injectStyle (ssrContext) {
  __webpack_require__("BkkN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87d9b238"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadDataViaExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d9b238_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadDataViaExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("Rccw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dzZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.getTitle())+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('b-col',[_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}})],1),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"300px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)])],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.$t('title'))+"\n                    ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('year-select',{staticStyle:{"margin-right":"15px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}}),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3",staticStyle:{"margin-top":"15px"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('site')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('openedCount')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('totalCount')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"10em"}},[_vm._v(_vm._s(_vm.$t('lastUpdatingTime')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredAudits),function(audit){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToDocumentDetail(audit)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(audit.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(audit.openedCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(audit.totalCount))]),_vm._v(" "),(audit.updatedAt)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(audit.updatedAt,'YYYY-MM-DD')))]):_c('td',[_vm._v("-")])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eBYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__ = __webpack_require__("laTA");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a541738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__ = __webpack_require__("hgSI");
function injectStyle (ssrContext) {
  __webpack_require__("AbZI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a541738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a541738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HollowDotsSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "eI+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permissions_vue__ = __webpack_require__("Yxz6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738f7bfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permissions_vue__ = __webpack_require__("vWIp");
function injectStyle (ssrContext) {
  __webpack_require__("pkMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-738f7bfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Permissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738f7bfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("zfIk")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eNnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Audit',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_2__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_1__components_YearSelect__["a" /* default */], SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_SiteMultiSelect__["a" /* default */] },
    data: function data() {
        return {
            auditTypes: [{ type: null, name: this.$t('all') }, { type: 'E', name: this.$t('externalAudit') }, { type: 'I', name: this.$t('internalAudit') }, { type: 'C', name: this.$t('control') }],
            selectedYear: null,
            selectedAuditType: null,
            selectedSite: { id: 0 },
            searchInput: '',
            tempAudits: [],
            regions: [],
            Audits: [],
            filteredAudits: []
        };
    },

    methods: {
        selectAuditType: function selectAuditType(type) {
            this.getData(this.selectedYear, this.route.params.site_id, type);
        },
        selectSiteId: function selectSiteId(selectedSite) {
            this.selectedSite = selectedSite;
            this.$store.state.siteId = selectedSite ? selectedSite.id : null;
            if (selectedSite) {
                this.getData(this.selectedYear, selectedSite.id, this.selectedAuditType);
                this.$router.push({
                    name: 'Detail',
                    params: { site_id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.selectedSite, 'id') },
                    query: { year: this.selectedYear }
                });
            } else {
                this.selectedSite = null;
                this.$router.push({ name: 'Summary', query: { year: this.year } });
            }
        },
        deleteAudit: function deleteAudit(audit, $event) {
            var _this = this;

            if (audit) {
                this.showWarnModal($event.target);
                this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                    var deleteData = {
                        site_id: audit.site_id,
                        record_id: audit.record_id,
                        type: audit.type,
                        date: audit.audit_date,
                        files: audit.files
                    };
                    _this.axios.post('/audit/delete/', deleteData).then(function () {
                        _this.getData(_this.selectedYear, _this.route.params.site_id, _this.selectedAuditType);
                    });
                });
            }
        },
        getAuditType: function getAuditType(type) {
            switch (type) {
                case 'E':
                    return this.$t('externalAudit');
                case 'I':
                    return this.$t('internalAudit');
                case 'C':
                    return this.$t('control');

                default:
                    return null;
            }
        },
        getSiteName: function getSiteName(siteId) {
            var found = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.$store.state.sites, { id: Number(siteId) });
            if (found) {
                return found.name;
            }
        },
        getData: function getData(selectedYear, siteId, auditType) {
            var _this2 = this;

            this.axios.get('/audits/records/details/' + siteId + '/?year=' + selectedYear + '&type=' + auditType).then(function (_ref) {
                var data = _ref.data;

                _this2.Audits = data;
            }).then(function () {
                _this2.$forceUpdate();
            });
        },

        // Update a table row
        updateRow: function updateRow(target, audit, editType) {
            var _this3 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                type: 'createAudit',
                payload: {
                    editType: editType,
                    post: audit,
                    reloadFunction: this.getData,
                    siteId: this.route.params.site_id,
                    selectedType: this.selectedAuditType,
                    selectedYear: this.selectedYear
                }
            });
            this.$nextTick(function () {
                _this3.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },

        // Insert a new table row
        insertRow: function insertRow(target, editType) {
            var _this4 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                type: 'createAudit',
                payload: {
                    siteId: this.route.params.site_id,
                    editType: editType,
                    reloadFunction: this.getData,
                    selectedType: this.selectedAuditType,
                    selectedYear: this.selectedYear
                }
            });
            this.$nextTick(function () {
                _this4.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },
        onYearChange: function onYearChange(newYear) {
            this.selectedYear = newYear;
            this.$router.push({
                name: 'Detail',
                query: { year: newYear }
            });
            this.$Progress.start();
            this.getData(newYear, this.route.params.site_id, this.selectedAuditType);
        },
        showAuditFiles: function showAuditFiles(files, target) {
            var _this5 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                type: 'auditFiles',
                payload: {
                    files: files
                }
            });
            this.$nextTick(function () {
                _this5.$root.$emit('bv::show::modal', 'auditFiles', target);
            });
        }
    },
    computed: {
        filterAudits: function filterAudits() {
            var _this6 = this;

            this.filteredAudits = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.Audits, function (audit) {
                var searchName = audit.title + ' ' + audit.accountable_first_name + ' ' + audit.accountable_last_name;
                if (searchName.toLowerCase().includes(_this6.searchInput.toLowerCase())) {
                    return audit;
                }
            });
        }
    },
    created: function created() {
        this.selectedYear = Number(this.route.query.year);
        this.$store.state.year = Number(this.route.query.year);
        this.$store.state.siteId = this.route.params.site_id;
        this.$store.state.redirection = true;
        this.getData(this.selectedYear, this.route.params.site_id, this.selectedAuditType);
        this.selectedSite = this.route.params.site_id ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.$store.state.sites, { id: Number(this.route.params.site_id) }) : null;
        this.$Progress.start();
    }
});

/***/ }),

/***/ "eRj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__("BAp8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc32fc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__("P3rI");
function injectStyle (ssrContext) {
  __webpack_require__("OUu5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc32fc14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc32fc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("xcSe")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eUUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCreate_vue__ = __webpack_require__("wg62");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207672a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCreate_vue__ = __webpack_require__("Io1g");
function injectStyle (ssrContext) {
  __webpack_require__("rWr9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9207672a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207672a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("IZka")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eV9N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CustomForm',
    props: {
        schema: {
            required: true,
            type: Array,
            default: function _default() {
                return [];
            }
        },
        data: {
            required: true,
            type: Object
        },
        isEditable: {
            required: true,
            type: Boolean
        },
        emptyFields: {
            type: Array,
            default: function _default() {
                return [];
            }
        }
    },
    data: function data() {
        return {
            isLoaded: false,
            model: {},
            errors: {}
        };
    },

    methods: {},
    watch: {
        model: {
            handler: function handler(newValue) {
                var data = {};
                this.schema.forEach(function (col) {
                    data[col.key] = newValue[col.key].value;
                });
                this.$emit('formChange', data);
            },

            deep: true
        },
        emptyFields: function emptyFields(newVal) {
            var _this = this;

            newVal.forEach(function (key) {
                _this.errors[key] = true;
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.isLoaded = false;
        this.schema.forEach(function (col) {
            _this2.$set(_this2.model, col.key, {});
            _this2.$set(_this2.model[col.key], 'value', _this2.data[col.key] ? _this2.data[col.key] : null);
            _this2.$set(_this2.errors, col.key, false);

            if (col.editable) {
                _this2.errors[col.key] = false;
            }
        });
        this.isLoaded = true;
    }
});

/***/ }),

/***/ "eXK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SiteMultiSelect__ = __webpack_require__("9aru");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_SiteMultiSelect__["a" /* default */]
    },
    name: 'FormList',
    data: function data() {
        return {
            isLoaded: false,
            selectedForm: null,
            selectedFormToCreate: null,
            forms: [],
            otherForms: [],
            selectedSite: null,
            filteredSites: []
        };
    },

    methods: {
        routeToFormDetail: function routeToFormDetail(form) {
            this.$router.push({
                name: 'form-detail',
                params: {
                    site_id: this.route.params.site_id,
                    form_id: form.id
                }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureForms: function configureForms(data) {
            var _this = this;

            var forms = [];
            data.forEach(function (element) {
                var form = {
                    version: element.version,
                    createdAt: element.createdAt,
                    no: element.no,
                    id: element.id,
                    type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.formTypes, { id: element.type }).name,
                    formTypeId: element.type,
                    siteName: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.sites, { id: Number(_this.route.params.site_id) }).name
                };
                forms.push(form);
            });
            this.forms = forms;
            return forms;
        },
        fetchForms: function fetchForms() {
            return this.axios.get('/' + this.route.params.site_id + '/form?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({ year: this.year })).then(function (_ref) {
                var data = _ref.data;

                return data;
            });
        },
        selectSiteId: function selectSiteId(site) {
            if (!site) {
                this.$router.push({ name: 'forms', query: { year: this.year } });
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                return this.routeTo(site);
            }
        },
        routeTo: function routeTo(site) {
            this.$router.push({
                name: 'site-forms',
                params: { site_id: site ? site.id : this.route.params.site_id },
                query: { year: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
        },
        init: function init() {
            var _this2 = this;

            this.isLoaded = false;
            if (this.route.query.year) {
                this.$store.state.year = this.route.query.year;
            }
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.fetchForms().then(this.configureForms).then(function () {
                _this2.isLoaded = true;
            });
        },
        onYearChange: function onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'site-forms',
                params: { site_id: this.route.params.site_id },
                query: { year: this.year }
            });
        }
    },
    computed: {
        filteredForms: function filteredForms() {
            var _this3 = this;

            return this.forms.filter(function (form) {
                return form.formTypeId === _this3.selectedForm || !_this3.selectedForm;
            });
        }
    },
    watch: {
        '$store.state.year': function $storeStateYear() {
            this.init();
        },
        '$store.state.siteId': function $storeStateSiteId() {
            this.init();
        },
        selectedFormToCreate: function selectedFormToCreate(newValue) {
            this.$router.push({
                name: 'form-create',
                params: { site_id: this.route.params.site_id, form_type: newValue }
            });
        }
    },
    created: function created() {
        this.init();
        this.selectedSite = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.sites, { id: Number(this.route.params.site_id) });
        this.filteredSites = this.sites;
    }
});

/***/ }),

/***/ "eYBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag){return _c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, 'active': tag.key === _vm.route.name},on:{"click":function($event){return _vm.routeByTag(tag)}}},[_vm._v(_vm._s(_vm.$t(tag.key)))])])}),0),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eys3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f5/t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIEE":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Bilgi Kütüphanesi","docColumn":"Doküman","uploadingDate":"Yüklenme Tarihi","operation":"İşlem","confirm":"Klasörü silmek istediğinize emin misiniz?"},"en":{"title":"Information Library","docColumn":"Document","uploadingDate":"Uploading Date","operation":"Operation","confirm":"Are you sure to delete this folder?"}}')
}


/***/ }),

/***/ "fK5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteSelector_vue__ = __webpack_require__("MkyK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1e81c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteSelector_vue__ = __webpack_require__("7DyY");
function injectStyle (ssrContext) {
  __webpack_require__("oJjy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c1e81c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1e81c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("OsVA")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fKQO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__("SLWx");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fSUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Tabs',
    data: function data() {
        return {
            email: null,
            selectedLocale: null,
            selectedAnalysisUnit: null,
            selectedDataList: null,
            dataLists: [{
                value: null,
                text: this.$t('chooseDataList'),
                disabled: true
            }, {
                value: 'data',
                text: this.$t('data')
            }, {
                value: 'data_type',
                text: this.$t('dataType')
            }, {
                value: 'data_entry',
                text: this.$t('dataEntry')
            }, {
                value: 'data_entry_deleted_year',
                text: this.$t('deletedDataType')
            }, {
                value: 'form',
                text: this.$t('form')
            }, {
                value: 'form_data',
                text: this.$t('formData')
            }, {
                value: 'goal',
                text: this.$t('goal')
            }, {
                value: 'site',
                text: this.$t('site')
            }, {
                value: 'document',
                text: this.$t('document')
            }, {
                value: 'audit_report',
                text: this.$t('audit')
            }, {
                value: 'user',
                text: this.$t('user')
            }, {
                value: 'site_user',
                text: this.$t('siteUser')
            }, {
                value: 'user_group_member',
                text: this.$t('userPerm')
            }, {
                value: 'unit_price',
                text: this.$t('unitPrice')
            }, {
                value: 'emission_factor',
                text: this.$t('emissionFactor')
            }, {
                value: 'log',
                text: this.$t('log')
            }, {
                value: 'integration_user',
                text: this.$t('integrationUser')
            }, {
                value: 'ikon',
                text: this.$t('ikonLog')
            }]
        };
    },

    methods: {
        changeAnalysisUnit: function changeAnalysisUnit(newVal) {
            var _this = this;

            this.selectedAnalysisUnit = newVal;
            localStorage.setItem('analysis_unit', newVal);

            this.$Progress.start();
            return this.axios.put('/resource/' + this.$store.state.user.customerId + '/analysis_unit_id', { value: newVal }).then(function (_ref) {
                var data = _ref.data;

                _this.$store.state.analysis_unit = data;
                _this.$Progress.finish();
            });
        },
        getData: function getData(val) {
            var hasCustomerId = 1;
            if (['user_group_member', 'site_user', 'log', 'ikon', 'integration_user', 'unit_price', 'form', 'form_data', 'data_entry_deleted_year'].indexOf(val) != -1) {
                hasCustomerId = 0;
            }
            this.$refs.dataLists.hide();
            window.open(this.apiURL + '/dataListExport?list=' + val + '&hasCustomerId=' + hasCustomerId + '&token=' + this.downloadToken);
        }
    },
    created: function created() {
        this.downloadToken = this.token.substr(7);
        this.selectedAnalysisUnit = this.$store.state.analysis_unit;
    }
});

/***/ }),

/***/ "fnqN":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"HEDEFLER","goalCountColumn":"Hedef Sayısı","approvedGoalCountColumn":"Onaylanan Hedef Sayısı"},"en":{"title":"GOALS","goalCountColumn":"Goals","approvedGoalCountColumn":"Approved Goals"}}')
}


/***/ }),

/***/ "g0qw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomForm_vue__ = __webpack_require__("eV9N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a09eb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomForm_vue__ = __webpack_require__("4IaV");
function injectStyle (ssrContext) {
  __webpack_require__("ClgQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39a09eb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39a09eb5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gE46":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gG4N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gIxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fingerprint-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.ringsStyles),function(rs,index){return _c('div',{key:index,staticClass:"spinner-ring",style:(rs)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gNB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"createPost",attrs:{"id":"createPost","size":"lg","top":"","title":_vm.postTitle},on:{"hide":_vm.onHide,"show":_vm.onShow}},[(_vm.ticketType == _vm.$t('actionTicket'))?_c('b-row',{staticClass:"mt-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('actionResponseText')))])])],1):_c('b-row',{staticClass:"mt-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('auditResponseText')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-textarea',{class:{'is-invalid': _vm.errors.text},attrs:{"rows":3,"max-rows":6},nativeOn:{"focus":function($event){_vm.errors.text = false}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)],1),_vm._v(" "),(_vm.replyType === 'negative')?_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('extendedDate')))])])],1):_vm._e(),_vm._v(" "),(_vm.replyType === 'negative')?_c('b-row',[_c('b-col',{staticStyle:{"text-align":"left"}},[_c('el-date-picker',{class:{'is-invalid': _vm.errors.text},staticStyle:{"width":"100%","align-self":"center"},attrs:{"type":"date","readonly":false,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder'),"picker-options":_vm.extendedDateOptions},model:{value:(_vm.extendedDate),callback:function ($$v) {_vm.extendedDate=$$v},expression:"extendedDate"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('label',[_vm._v(_vm._s(_vm.$t('additionalFiles')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{attrs:{"align-h":"start","no-gutters":""}},[(_vm.postDocuments.length)?[_vm._l((_vm.postDocuments),function(file,index){return [_c('b-col',{key:("upload-" + index),staticStyle:{"text-align":"center"},attrs:{"cols":"1"}},[_c('upload',{attrs:{"fileCategory":"audit-post","showUpload":false,"showDownload":false,"reactive-id":(_vm.reactiveId + "-" + (file.uuid) + "-" + index),"deleteFromDB":true,"dataId":file.id},on:{"onremove":function($event){return _vm.handleRemoving($event, file)}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px","text-align":"center"}},[_vm._v(_vm._s(_vm._f("textToShortText")(file.filename)))])],1)]})]:_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"1"}},[_c('upload-regular',{attrs:{"fileCategory":"audit-post"},on:{"onupload":_vm.onupload}})],1)],2)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){_vm.type === 'updatePost' ? _vm.update() : _vm.insert()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"Danger"},on:{"click":function($event){return _vm.closeModal(true)}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gSiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isLoaded),expression:"!isLoaded"}],staticClass:"content",attrs:{"fluid":"","element-loading-text":_vm.$t('sourceLoading')}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('sourceManagement')))])]),_vm._v(" "),_c('b-row',{staticStyle:{"justify-content":"space-between"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{key:tabKey,staticClass:"nav-item p-2",staticStyle:{"cursor":"pointer"},style:(tab.isActive ? tab.style.border : '')},[_c('div',{class:{'nav-link': true, 'active': tab.isActive},style:(tab.isActive ? tab.style.tab : ''),on:{"click":function($event){return _vm.activate(tabKey)}}},[_vm._v(_vm._s(tab.name)+"  "),_c('b-badge',{style:(tab.isActive ? tab.style.badge : ''),attrs:{"pill":""}},[_vm._v(_vm._s(tab.tableInfo.items.length))])],1)])}),0)]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[(_vm.tabs.activeSources.isActive)?[_c('b-button',{key:"addSource",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.showCreateSourceModal($event.target)}}},[_vm._v(_vm._s(_vm.$t('addSource')))])]:void 0],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3",attrs:{"md":"2"}},[_c('b-form-input',{staticStyle:{"padding":"5px 10px"},attrs:{"placeholder":_vm.$t('searchSource')},on:{"input":_vm.filterData},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1),_vm._v(" "),(this.tabs.activeSources.isActive)?_c('vue-table',{staticClass:"mt-3",attrs:{"tableName":"active sources","initialData":_vm.itemsForList(this.tabs.activeSources.tableInfo),"isEditable":true,"isScrollable":false},on:{"openEditModal":_vm.showEditSourceModal,"per-page":_vm.setPerPage}}):_c('vue-table',{staticClass:"mt-3",attrs:{"tableName":"inactive sources","initialData":_vm.itemsForList(this.tabs.inactiveSources.tableInfo),"isEditable":true,"isScrollable":false},on:{"openEditModal":_vm.showEditSourceModal,"per-page":_vm.setPerPage}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"aria-controls":"itemList","align":"right"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gfGe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOC40NDMiIHZpZXdCb3g9IjAgMCAxOSAxOC40NDMiPgogIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl80IiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDQiIGQ9Ik0xNy4zOCwxOC40NDMuMjc5LDEuMzQyLDEuNjIyLDAsNS4xMjcsMy41QTEwLjE1NSwxMC4xNTUsMCwwLDEsOS41LDIuNTcxYTEwLjM1LDEwLjM1LDAsMCwxLDQuNTMzLjk4Myw5LjYxOCw5LjYxOCwwLDAsMSwyLjksMi4xNjgsMTAuMDc1LDEwLjA3NSwwLDAsMSwyLjAxNCwzLjIuOTUxLjk1MSwwLDAsMSwwLC42LDEwLjM0MSwxMC4zNDEsMCwwLDEtMy4zODMsNC40MjRMMTguNzIzLDE3LjEsMTcuMzgsMTguNDQyaDBaTTkuNSw2LjM3MWEyLjg3LDIuODcsMCwwLDEsMi44NSwyLjg1LDIuNzU4LDIuNzU4LDAsMCwxLS4yOTMsMS4yMTRMMTQuMjI0LDEyLjZhOC4xNjIsOC4xNjIsMCwwLDAsMi44MDctMy4zOEE3LjkzMyw3LjkzMywwLDAsMCw5LjUsNC40NzFIOS40MjZhOC43OCw4Ljc4LDAsMCwwLTIuODU2LjQ3N0w4LjI4OCw2LjY2NUEyLjczMywyLjczMywwLDAsMSw5LjUsNi4zNzFabTAsOS41YTEwLjM1LDEwLjM1LDAsMCwxLTQuNTM0LS45ODMsOS42MTcsOS42MTcsMCwwLDEtMi45LTIuMTY4QTEwLjEzLDEwLjEzLDAsMCwxLC4wNSw5LjUyM2EuOTQ5Ljk0OSwwLDAsMSwwLS42QTEwLjE1MywxMC4xNTMsMCwwLDEsMi4wNzUsNS43MUwzLjQsNy4wMzlBOC4xODgsOC4xODgsMCwwLDAsMS45NzIsOS4yMjFhNy45MjgsNy45MjgsMCwwLDAsNy41Myw0Ljc1Yy4zLDAsLjU3LS4wMTguOC0uMDM2TDExLjk2OSwxNS42QTExLjE4LDExLjE4LDAsMCwxLDkuNSwxNS44NzFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4wMDEpIiBmaWxsPSIjMDIyYjQ5Ii8+Cjwvc3ZnPgo="

/***/ }),

/***/ "gxv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__ = __webpack_require__("0KSN");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h+W8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.size * 0.25 / 1.3 + 'px',
        width: this.size * 0.25 / 1.3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        borderWidth: this.size * 0.04 / 1.3 + 'px',
        borderColor: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delay = this.animationDuration * 0.5;

      for (var i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: (i % 2 === 0 ? delay : 0) + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "h/7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pixel-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"pixel-spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hgSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hollow-dots-spinner",style:(_vm.spinnerStyle)},_vm._l((_vm.dotsStyles),function(ds,index){return _c('div',{key:index,staticClass:"dot",style:(ds)})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hm2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect__ = __webpack_require__("0XjM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SiteMultiSelectTree_vue__ = __webpack_require__("oE/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__ = __webpack_require__("sRoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cropperjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css__ = __webpack_require__("5Qkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_cropperjs_dist_cropper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'UserProfile',
    components: {
        VueCropper: __WEBPACK_IMPORTED_MODULE_2_vue_cropperjs___default.a,
        Treeselect: __WEBPACK_IMPORTED_MODULE_0__riophae_vue_treeselect___default.a,
        SiteMultiSelectTree: __WEBPACK_IMPORTED_MODULE_1__components_SiteMultiSelectTree_vue__["a" /* default */]
    },
    data: function data() {
        return {
            rawUser: {
                id: null,
                customerId: null,
                email: null,
                firstName: null,
                lastName: null,
                groupId: [],
                assignedSites: [],
                status: null,
                language: null,
                jobTitle: null,
                department: null,
                signupDate: null,
                lastLoginDate: null,
                disableDate: null,
                inviteDate: null,
                inviteCount: null,
                inviteUUID: null,
                profilePic: null
            },
            user: {
                id: null,
                customerId: null,
                email: null,
                firstName: null,
                lastName: null,
                groupId: [],
                assignedSites: [],
                status: null,
                language: null,
                jobTitle: null,
                department: null,
                signupDate: null,
                lastLoginDate: null,
                disableDate: null,
                inviteDate: null,
                inviteCount: null,
                inviteUUID: null,
                profilePic: null
            },
            ppLoading: false,
            profilePic: [],
            profilePicSrc: '',
            showCropImageModal: false,
            croppedImage: '',
            canEditUser: false,
            allSites: [],
            selectedSites: [],
            userGroups: [],
            rawUserGroups: [],
            errors: {
                firstName: false,
                lastName: false,
                email: false,
                validEmail: false
            }
        };
    },

    methods: {
        saveProfilePic: function saveProfilePic() {
            var file = this.profilePic[0] && this.profilePic[0].file;
            var imageData = this.$refs.cropper.getCroppedCanvas().toDataURL();
            return this.uploadFile(imageData, file);
        },
        uploadFile: function uploadFile(base64Data, file) {
            var _this = this;

            this.$Progress.start();
            this.ppLoading = true;
            return this.axios.post('/uploadToAws', {
                data: base64Data,
                type: 'profile-pic',
                mimeType: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(file, 'type'),
                size: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(file, 'size'),
                originalFileName: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(file, 'name'),
                userIdOverWrite: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(this.user, 'id')
            }).then(function (_ref) {
                var data = _ref.data;

                _this.$message({
                    type: 'success',
                    message: _this.$t('profilePhotoUploadSuccesfully')
                });
                _this.user.profilePic = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, 'url');
                _this.user.avatarId = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, 'id');
                _this.ppLoading = false;
                _this.$Progress.finish();
                return data;
            });
        },
        inputFile: function inputFile() {
            var _this2 = this;

            this.showCropImageModal = true;
            var file = this.profilePic[0] && this.profilePic[0].file;
            if (file) {
                var FR = new FileReader();
                FR.readAsDataURL(file);
                FR.onload = function (event) {
                    _this2.profilePicSrc = event.target.result;
                    // rebuild cropperjs with the updated source
                    _this2.$refs.cropper.replace(event.target.result);
                };
            }
        },
        changeLocale: function changeLocale(newVal) {
            this.user.language = newVal;
        },
        selectSite: function selectSite(value) {
            __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.set(this.user, 'assignedSites', this.getSiteIdsInGroupedSitesMap(value));
        },
        getSelectedSiteIds: function getSelectedSiteIds() {
            return this.createGroupedSitesKeys(this.user.assignedSites);
        },
        setUserGroup: function setUserGroup(val) {
            this.user.groupId = val;
        },
        updateUser: function updateUser() {
            var _this3 = this;

            if (this.isUpdateValid()) {
                var adminId = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.rawUserGroups, function (o) {
                    return o.type == 'admin';
                }), 'id'));
                var supervisorId = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.rawUserGroups, function (o) {
                    return o.type == 'supervisor';
                }), 'id'));
                if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.rawUser.groupId, function (o) {
                    return adminId == o;
                })) && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.user.groupId, function (o) {
                    return adminId == o;
                })) || !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.rawUser.groupId, function (o) {
                    return supervisorId == o;
                })) && __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(this.user.groupId, function (o) {
                    return supervisorId == o;
                }))) {
                    this.user.groupId.push(adminId);
                    return this.$message({
                        type: 'error',
                        message: this.$t('adminGroupError')
                    });
                } else {
                    this.$Progress.start();
                    this.axios.put('/user', this.user).then(function (response) {
                        if (response.data.error != 'E-mail already in use') {
                            _this3.rawUser = response.data;
                            _this3.user = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(_this3.rawUser);
                            if (_this3.canEditUser) {
                                if (_this3.user.language != _this3.$store.state.locale) {
                                    _this3.$store.state.locale = _this3.user.language;
                                    localStorage.setItem('locale', _this3.user.language);
                                    _this3.$root.$i18n.locale = _this3.$store.state.locale;
                                    _this3.init();
                                }

                                if (_this3.user.email != _this3.$store.state.user.email) {
                                    _this3.$store.state.user.email = _this3.user.email;
                                    localStorage.setItem('token', response.data.token);
                                    document.cookie = 'Authorization=Bearer ' + response.data.token;
                                    _this3.$store.state.token = 'Bearer ' + response.data.token;
                                    _this3.axios.defaults.headers.Authorization = response.data.token ? 'Bearer ' + response.data.token : 'Bearer ';
                                    _this3.$store.dispatch('init');
                                }
                            }
                            _this3.$Progress.finish();
                            return _this3.$message({
                                type: 'success',
                                message: _this3.$t('UserUpdatedSuccessfully')
                            });
                        } else {
                            _this3.$Progress.finish();
                            return _this3.$message({
                                type: 'error',
                                message: _this3.$t('mailInUseError')
                            });
                        }
                    });
                }
            }
        },
        isUpdateValid: function isUpdateValid() {
            this.errors.firstName = !this.user.firstName;
            this.errors.lastName = !this.user.lastName;
            this.errors.email = !this.user.email;
            this.errors.validEmail = !this.isEmailValid(this.user.email);
            var validation = true;
            for (var key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        isEmailValid: function isEmailValid(email) {
            return email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
        },
        selectLocaleText: function selectLocaleText() {
            if (this.user.language == 'tr') {
                return this.$t('turkish');
            } else {
                return this.$t('english');
            }
        },
        init: function init() {
            var _this4 = this;

            var userId = this.route.params.user_id;
            this.canEditUser = this.$store.state.user.id == userId;
            this.allSites = this.sitesWithGroups;
            this.siteOptions = [{ id: "All", label: this.$t('selectAll'), children: this.allSites, isDefaultExpanded: true }];
            this.axios.get('/getUserData/' + userId).then(function (_ref2) {
                var data = _ref2.data;

                _this4.rawUser = data;
                _this4.user = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.clone(_this4.rawUser);
                return _this4.axios.get('/permission-groups').then(function (_ref3) {
                    var data = _ref3.data;

                    _this4.rawUserGroups = data;
                    _this4.userGroups = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.map(_this4.rawUserGroups, function (userGroup) {
                        return {
                            id: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(userGroup, 'id'),
                            label: _this4.$t(_this4.getGroupName(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(userGroup, 'name')))
                        };
                    });
                });
            });
        }
    },
    computed: {
        canEdit: function canEdit() {
            return this.canEditUser || this.$store.state.user.permissions.isAdmin;
        }
    },
    watch: {
        '$route.path': function $routePath() {
            this.init();
        }
    },
    created: function created() {
        this.init();
        /*
        this.permissionOptions = [{id:"All", label:this.$t('selectAll'), children:this.givenSites, isDefaultExpanded:true}];
        */
    }
});

/***/ }),

/***/ "ib3Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1NCA1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTQgNTQ7Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBzdHlsZT0iZmlsbDojZTIxZDI4OyIgZD0iTTUzLDI3TDUzLDI3YzAsMTQuMzU5LTExLjY0MSwyNi0yNiwyNmgwQzEyLjY0MSw1MywxLDQxLjM1OSwxLDI3djBDMSwxMi42NDEsMTIuNjQxLDEsMjcsMWgwCgkJCUM0MS4zNTksMSw1MywxMi42NDEsNTMsMjd6Ii8+CgkJPHBhdGggc3R5bGU9ImZpbGw6I2UyMWQyODsiIGQ9Ik0yNyw1NEMxMi4xMTIsNTQsMCw0MS44ODgsMCwyN1MxMi4xMTIsMCwyNywwczI3LDEyLjExMiwyNywyN1M0MS44ODgsNTQsMjcsNTR6IE0yNywyCgkJCUMxMy4yMTUsMiwyLDEzLjIxNSwyLDI3czExLjIxNSwyNSwyNSwyNXMyNS0xMS4yMTUsMjUtMjVTNDAuNzg1LDIsMjcsMnoiLz4KCTwvZz4KCTxnPgoJCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMjguMDE3LDE3Ljg1Nmw4LjcxOSwxNS4xMDFDMzcuMDA0LDMzLjQyMSwzNi42NjksMzQsMzYuMTM0LDM0SDE4LjY5NgoJCQljLTAuNTM1LDAtMC44Ny0wLjU3OS0wLjYwMi0xLjA0M2w4LjcxOS0xNS4xMDFDMjcuMDgxLDE3LjM5MiwyNy43NSwxNy4zOTIsMjguMDE3LDE3Ljg1NnoiLz4KCQk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTM2LjEzNCwzNUgxOC42OTZjLTAuNjEzLDAtMS4xNjItMC4zMTYtMS40NjktMC44NDhjLTAuMzA2LTAuNTMtMC4zMDctMS4xNjQsMC0xLjY5NWw4LjcxOS0xNS4xMDIKCQkJYzAuMzA3LTAuNTMsMC44NTUtMC44NDgsMS40NjktMC44NDhzMS4xNjIsMC4zMTcsMS40NjksMC44NDhsOC43MTksMTUuMTAyYzAuMzA3LDAuNTMxLDAuMzA2LDEuMTY1LDAsMS42OTUKCQkJQzM3LjI5NiwzNC42ODQsMzYuNzQ3LDM1LDM2LjEzNCwzNXogTTE5LjIyNCwzM2gxNi4zODNsLTguMTkxLTE0LjE4OEwxOS4yMjQsMzN6Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ "isL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'upload-regular',
    props: {
        acceptQuery: {
            default: function _default() {
                return '*';
            }
        },
        uploadOnCloud: {
            type: Boolean,
            default: function _default() {
                return null;
            }
        },
        fileCategory: {
            type: String,
            default: function _default() {
                return 'other';
            }
        }
    },
    data: function data() {
        return {
            component_id: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
            files: [],
            action: null,
            onCloud: false
        };
    },

    methods: {
        inputFile: function inputFile(newFile, oldFile) {
            var _this = this;

            if (this.onCloud) {
                var file = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(this.files) && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(this.files).file;
                if (file) {
                    var FR = new FileReader();
                    FR.readAsDataURL(file);
                    FR.onload = function (event) {
                        return _this.axios.post('/uploadToAws', {
                            data: event.target.result,
                            type: _this.fileCategory,
                            mimeType: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'type'),
                            size: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'size'),
                            originalFileName: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(file, 'name'),
                            userIdOverWrite: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(_this.$store.state.user, 'id')
                        }).then(function (_ref) {
                            var data = _ref.data;

                            _this.$emit('onupload', {
                                id: data.id,
                                fileUrl: data.url,
                                filename: data.filename,
                                fileId: data.fileId,
                                status: 'success',
                                onCloud: _this.onCloud
                            });
                        });
                    };
                }
            } else {
                // Upload file immediately
                if (newFile && !newFile.active && !oldFile) {
                    newFile.active = true; // when set true, upload progress will be start.
                }

                // Get response data
                if (newFile && oldFile && !newFile.active && oldFile.active) {
                    this.$emit('onupload', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newFile.response, { onCloud: this.onCloud }));
                    if (newFile.xhr) {
                        //  Get the response status code
                        console.log('status', newFile.xhr.status);
                    }
                }
            }
        },

        inputFilter: function inputFilter(newFile) {
            newFile.blob = '';
            var URL = window.URL || window.webkitURL;
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file);
            }
        }
    },
    created: function created() {
        this.action = this.apiURL + '/upload';
        this.onCloud = this.uploadOnCloud != null ? this.uploadOnCloud : !this.$store.state.isExcludedForAws;
    }
});

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iyxz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jELx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditFiles_vue__ = __webpack_require__("vxMg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_badfc34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditFiles_vue__ = __webpack_require__("Men5");
function injectStyle (ssrContext) {
  __webpack_require__("SjFc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-badfc34c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_badfc34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jFsX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jIX/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQ2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect__ = __webpack_require__("NyJr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'goal-summary',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteTypeSelect__["a" /* default */], YearSelect: __WEBPACK_IMPORTED_MODULE_3__components_YearSelect__["a" /* default */] },
    data: function data() {
        return {
            isLoaded: false,
            tempSites: [],
            goalSites: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            searchInput: '',
            initialRoute: 'goal'
        };
    },

    methods: {
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToGoalDetail: function routeToGoalDetail(site) {
            var routeData = this.$router.resolve({
                name: 'goal-detail',
                params: { site_id: site.site_id },
                query: {
                    year: this.year
                }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'goal-detail',
                    params: { site_id: site.site_id },
                    query: {
                        year: this.year
                    }
                });
            }
            /* this.$router.push({
                name: 'goal-detail',
                params: {site_id: site.site_id}
            }); */
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        },
        routeTo: function routeTo() {
            this.$router.push({
                name: 'goal',
                query: { year: this.year }
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureGoals: function configureGoals() {
            var _this = this;

            this.goalSites = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.tempSites, function (site) {
                var foundItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this.$store.state.goals, { site_id: site.id });
                if (foundItem) {
                    return {
                        approved_count: foundItem.approved_count,
                        count: foundItem.count,
                        site_id: foundItem.site_id,
                        code: site.code,
                        siteGroupId: site.siteGroupId,
                        name: site.name
                    };
                } else {
                    return {
                        approved_count: 0,
                        count: 0,
                        site_id: site.id,
                        code: site.code,
                        siteGroupId: site.siteGroupId,
                        name: site.name
                    };
                }
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(true);
        },
        init: function init() {
            var _this2 = this;

            this.$store.state.year = this.route.query.year ? this.route.query.year : this.year;
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.tempSites = this.sites;
            this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
            this.$Progress.start();
            this.$store.dispatch('getGoalCounts', this.year).then(this.configureGoals).then(function () {
                return _this2.$Progress.finish();
            });
        }
    },
    computed: {
        filteredGoals: function filteredGoals() {
            var _this3 = this;

            if (this.searchInput.length <= 3) {
                var filteredSites = this.goalSites.filter(function (item) {
                    var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.sites, { id: item.site_id });
                    return _this3.textStartsWith(item.name, _this3.searchInput) && _this3.isRegionFound(_this3.selectedRegionId, item.siteGroupId) && (!_this3.selectedTypeId || found.typeId === _this3.selectedTypeId);
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            }
            return this.goalSites.filter(function (item) {
                var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.sites, { id: item.site_id });
                return _this3.isSearchTextFound(item.name, _this3.searchInput) && _this3.isRegionFound(_this3.selectedRegionId, item.siteGroupId) && (!_this3.selectedTypeId || found.typeId === _this3.selectedTypeId);
            });
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "jQra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminGoal_vue__ = __webpack_require__("QTOu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3c8899_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminGoal_vue__ = __webpack_require__("Wf1W");
function injectStyle (ssrContext) {
  __webpack_require__("XeEE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b3c8899"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminGoal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3c8899_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminGoal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("Phlw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jd+X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("APWZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74964e6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("xomk");
function injectStyle (ssrContext) {
  __webpack_require__("yeQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74964e6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74964e6a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jv0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"createSource",staticClass:"add-edit-modal",attrs:{"id":"createSource","size":"xl","top":"","hide-header":"","hide-header-close":"","centered":"","scrollable":""},on:{"show":_vm.onShowModal,"hide":_vm.onHideModal}},[_c('b-row',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isLoaded),expression:"!isLoaded"}],staticClass:"m-3",attrs:{"element-loading-text":_vm.$t('sourceInfoLoading')}},[_c('b-col',{staticClass:"mt-2",attrs:{"md":"2"}},[_c('el-steps',{attrs:{"space":60,"active":_vm.activeStep,"finish-status":"success","direction":"vertical"}},_vm._l((_vm.steps),function(step,index){return _c('el-step',{key:index,attrs:{"title":_vm.modalType == 'insert' ? _vm.$t(step.stepTitle) : _vm.$t(step.editStepTitle)}})}),1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"color":"#022b49"},attrs:{"md":"10"}},[(_vm.steps[_vm.activeStep].stepTitle == 'selectActivity')?[_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.modalType == 'insert' ? _vm.$t(_vm.steps[_vm.activeStep].stepSubTitle) : _vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_c('b-row',{staticStyle:{"overflow-y":"auto","overflow-x":"hidden"}},[_c('b-card-group',_vm._l((_vm.scopeGroups),function(scopeGroup,key){return _c('div',{key:scopeGroup.id,staticClass:"col-sm-6 col-lg-3 py-3"},[_c('b-card',{class:['d-flex',{'is-selected': scopeGroup.isSelected}],staticStyle:{"text-align":"center","height":"150px"},style:(_vm.modalType=='insert'?'cursor:pointer':''),on:{"click":function($event){return _vm.selectScopeGroup(scopeGroup, key)}}},[_c('b-row',{key:(key + "-" + _vm.activeStep),attrs:{"align-h":"center"}},[_c('i',{class:scopeGroup.icon+' fa-3x',staticStyle:{"color":"#AAABB9"}})]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-card-text',[_c('span',[_vm._v(_vm._s(_vm.$t(scopeGroup.name)))])])],1)],1)],1)}),0)],1)]:(_vm.steps[_vm.activeStep].stepTitle == 'defineSources')?[(_vm.modalType == 'insert')?_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.$t(_vm.steps[_vm.activeStep].stepSubTitle)))])]):_c('b-row',{staticClass:"mb-4",staticStyle:{"justify-content":"space-between"}},[_c('div',[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_c('div',[(_vm.modalType == 'update')?_c('b-btn',{staticClass:"delete-button",on:{"click":function($event){return _vm.openSourceDeleteModal(_vm.editedItem.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()],1)]),_vm._v(" "),_c('b-row',[_c('b-col',[(_vm.modalType == 'update')?_c('b-row',{staticClass:"mb-4"},[_c('label',{staticClass:"formTitle pr-2",attrs:{"for":"enabled-checkbox"}},[_vm._v(" "+_vm._s(_vm.$t('enabled')))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"checkbox",attrs:{"name":"enabled-checkbox","id":"enabled-checkbox","value":true,"unchecked-value":false},model:{value:(_vm.editedItem.isActive),callback:function ($$v) {_vm.$set(_vm.editedItem, "isActive", $$v)},expression:"editedItem.isActive"}})],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"section-line"},[_c('b-col',{attrs:{"md":"5"}},[_c('b-row',[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('sourceName')))])]),_vm._v(" "),_c('b-row',{staticStyle:{"width":"85%"}},[_c('b-form-input',{staticClass:"my-1",staticStyle:{"height":"10%","padding":"5px 10px"},attrs:{"placeholder":_vm.$t('writeSourceName')},on:{"input":_vm.forceUpdate},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"section-line"},[_c('b-col',[_c('b-row',{staticClass:"mt-3"},[(_vm.isSourceTypeGroupAvailable())?_c('b-col',{staticStyle:{"margin-right":"50px"},attrs:{"md":"5"}},[_c('b-row',[_c('span',{staticClass:"formTitle"},[_vm._v("\n                                                    "+_vm._s(_vm.$t(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroupsHeader))+"\n                                                ")])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticClass:"my-1",attrs:{"options":_vm.arrangeOptions(this.scopeGroups[this.editedItem.scopeGroup].sourceTypeGroups)},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.sourceTypeGroup),callback:function ($$v) {_vm.$set(_vm.editedItem, "sourceTypeGroup", $$v)},expression:"editedItem.sourceTypeGroup"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-row',[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('type')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticClass:"my-1",attrs:{"options":_vm.editedItem.sourceTypeGroup == null ? 
                                                    []:
                                                    _vm.arrangeOptions(this.scopeGroups[this.editedItem.scopeGroup].sourceTypes[_vm.editedItem.sourceTypeGroup], true),"disabled":!_vm.editedItem.sourceTypeGroup && _vm.isSourceTypeGroupAvailable()},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.sourceType),callback:function ($$v) {_vm.$set(_vm.editedItem, "sourceType", $$v)},expression:"editedItem.sourceType"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{staticStyle:{"margin-right":"50px"},attrs:{"md":"3"}},[_c('b-row',[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('unit')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticClass:"my-1",attrs:{"options":_vm.editedItem.sourceType == null ?
                                                    []:
                                                    _vm.arrangeOptions(this.sourceTypes[_vm.editedItem.sourceType].units),"disabled":!_vm.editedItem.sourceType},on:{"change":_vm.selectUnit},model:{value:(_vm.editedItem.unit),callback:function ($$v) {_vm.$set(_vm.editedItem, "unit", $$v)},expression:"editedItem.unit"}})],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"margin-right":"30px"},attrs:{"md":"4"}},[_c('b-row',[_c('span',{staticClass:"formTitle",staticStyle:{"font-size":".8em"}},[_vm._v(_vm._s(_vm.$t('normalizationType')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticClass:"my-1",model:{value:(_vm.editedItem.normalizationType),callback:function ($$v) {_vm.$set(_vm.editedItem, "normalizationType", $$v)},expression:"editedItem.normalizationType"}},_vm._l((_vm.normalizationTypes),function(normalization){return _c('option',{key:("normalization-" + normalization),ref:'normalization',refInFor:true,domProps:{"value":normalization}},[_vm._v("\n                                                        "+_vm._s(_vm.$t(normalization))+"\n                                                    ")])}),0)],1)],1),_vm._v(" "),(_vm.scopeGroups[_vm.editedItem.scopeGroup].hazardous)?_c('b-col',{staticStyle:{"padding-top":"30px"},attrs:{"md":"2"}},[_c('b-row',[_c('b-form-checkbox',{staticClass:"checkbox",attrs:{"name":"checkbox-2","value":true,"unchecked-value":false},model:{value:(_vm.editedItem.hazardous),callback:function ($$v) {_vm.$set(_vm.editedItem, "hazardous", $$v)},expression:"editedItem.hazardous"}},[_c('span',{staticClass:"formTitle"},[_vm._v("\n                                                        "+_vm._s(_vm.$t('hazardous'))+" \n                                                    ")])])],1)],1):_vm._e()],1)],1)],1)],1)],1)]:(_vm.steps[_vm.activeStep].stepTitle == 'assignLocations')?[_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.modalType == 'insert' ? _vm.$t(_vm.steps[_vm.activeStep].stepSubTitle) : _vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('locations')))])]),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('site-multi-select-tree',{staticClass:"location-select",staticStyle:{"width":"60%"},attrs:{"givenSites":_vm.allSites,"givenSelectedSites":_vm.getSelectedSiteIds()},on:{"oninput":_vm.selectSite}})],1)],1)],1)]:(_vm.steps[_vm.activeStep].stepTitle == 'sourceFactors')?[_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.modalType == 'insert' ? _vm.$t(_vm.steps[_vm.activeStep].stepSubTitle) : _vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":"2"}},[_vm._v(_vm._s(_vm.$t("current")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":"2"}},[_vm._v(_vm._s(_vm.$t("target")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":"4"}},[_vm._v(_vm._s(_vm.$t("value")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":"4"}},[_vm._v(_vm._s(_vm.$t("example")))])],1),_vm._v(" "),_vm._l((_vm.editedItem.sourceFactors),function(inputFields,key){return _c('b-row',{key:("factor-convertion-" + key)},[_c('b-col',{staticClass:"mt-2",attrs:{"md":"2"}},[_c('b-form-select',{key:("from-" + key),staticClass:"white-select",attrs:{"size":"m"},on:{"change":_vm.forceUpdate},model:{value:(inputFields.from),callback:function ($$v) {_vm.$set(inputFields, "from", $$v)},expression:"inputFields.from"}},_vm._l((inputFields['from_options']),function(unit){return _c('b-form-select-option',{key:("to-unit-" + (unit.id)),attrs:{"value":unit.id}},[_vm._v(" "+_vm._s(unit.label)+" ")])}),1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"2"}},[_c('b-form-select',{key:("from-" + key),staticClass:"white-select",attrs:{"size":"m"},on:{"change":_vm.forceUpdate},model:{value:(inputFields.to),callback:function ($$v) {_vm.$set(inputFields, "to", $$v)},expression:"inputFields.to"}},_vm._l((inputFields['to_options']),function(unit){return _c('b-form-select-option',{key:("to-unit-" + (unit.id)),attrs:{"value":unit.id}},[_vm._v(" "+_vm._s(unit.label)+" ")])}),1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"4"}},[_c('b-form-input',{attrs:{"type":"number"},on:{"input":_vm.forceUpdate},model:{value:(inputFields.value),callback:function ($$v) {_vm.$set(inputFields, "value", $$v)},expression:"inputFields.value"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"3"}},[_vm._v("\n                                    "+_vm._s(_vm.getExampleConversion(inputFields.from,inputFields.to,inputFields.value))+"\n                                ")])],1)})],2)],1)]:(_vm.steps[_vm.activeStep].stepTitle == 'emissionFactors')?[_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.modalType == 'insert' ? _vm.$t(_vm.steps[_vm.activeStep].stepSubTitle) : _vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{staticClass:"mt-4 mb-3",staticStyle:{"width":"100%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('emissionFactorSource')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('b-form-select',{staticClass:"my-1",attrs:{"options":_vm.emissionLibraries},on:{"change":_vm.selectEmissionLibrary},model:{value:(_vm.editedItem.emissionSource),callback:function ($$v) {_vm.$set(_vm.editedItem, "emissionSource", $$v)},expression:"editedItem.emissionSource"}})],1),_vm._v(" "),(_vm.modalType == 'insert' && _vm.editedItem.emissionSource == null)?[_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('source')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-input',{staticClass:"my-1",staticStyle:{"height":"10%","padding":"5px 10px"},attrs:{"placeholder":_vm.$t('writeSourceInfo')},model:{value:(_vm.editedItem.emissionSourceName),callback:function ($$v) {_vm.$set(_vm.editedItem, "emissionSourceName", $$v)},expression:"editedItem.emissionSourceName"}})],1)]:(_vm.editedItem.emissionSource != null)?[_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(_vm.$t('site')))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('el-select',{staticStyle:{"width":"75%"},attrs:{"filterable":""},on:{"change":function($event){return _vm.setExampleLibrary()}},model:{value:(_vm.editedItem.exampleSiteId),callback:function ($$v) {_vm.$set(_vm.editedItem, "exampleSiteId", $$v)},expression:"editedItem.exampleSiteId"}},_vm._l((_vm.relatedSites),function(site){return _c('el-option',{key:site.siteId,attrs:{"value":site.siteId,"label":site.siteName}})}),1)],1)]:_vm._e()],2),_vm._v(" "),_c('b-row',{staticClass:"my-2",staticStyle:{"width":"75%"},attrs:{"align-v":"center"}},[_c('b-col',[(_vm.modalType == 'update' && _vm.editedItem.emissionSource == null)?_c('b-btn',{staticClass:"add-custom-factor-btn",staticStyle:{"float":"right"},attrs:{"size":"sm"},on:{"click":_vm.addNewEmissionFactors}},[_vm._v("\n                                            "+_vm._s(_vm.$t('addCustomFactor'))+"\n                                     ")]):_vm._e()],1)],1),_vm._v(" "),(_vm.editedItem.emissionSource == null && _vm.modalType == 'insert')?_vm._l((_vm.emissionTypes),function(emissionType,index){return _c('div',{key:index},[(index == _vm.emissionTypes.length-1)?[_c('b-row',{staticClass:"mt-3",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('hr',{staticClass:"my-0 line-text",attrs:{"data-content":"or"}})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(emissionType.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('masked-input',{key:("insert-emission-input-" + index),staticClass:"masked-input-custom",attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfEmission,"placeholder":((_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.editedItem.unit])))},model:{value:(_vm.editedItem.emissionFactors[emissionType.name]),callback:function ($$v) {_vm.$set(_vm.editedItem.emissionFactors, emissionType.name, $$v)},expression:"editedItem.emissionFactors[emissionType.name]"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1)]:[_c('b-row',{staticClass:"mt-3",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v(_vm._s(emissionType.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('masked-input',{key:("insert-emission-input-" + index),staticClass:"masked-input-custom",attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfEmission,"placeholder":((_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.editedItem.unit])))},on:{"input":_vm.recalculateCO2e},model:{value:(_vm.editedItem.emissionFactors[emissionType.name]),callback:function ($$v) {_vm.$set(_vm.editedItem.emissionFactors, emissionType.name, $$v)},expression:"editedItem.emissionFactors[emissionType.name]"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1)]],2)}):(_vm.editedItem.emissionSource != null && _vm.modalType == 'insert')?[_c('b-row',{staticClass:"mt-1",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v("CH4")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-input',{staticClass:"emission-library-factor",attrs:{"readonly":true,"placeholder":_vm.emissionLibraryExample.CH4 != null
                                                ? _vm.emissionLibraryExample.CH4 + " " + (_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.emissionLibraryExample.unit_id]))
                                                : ''}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v("N2O")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-input',{staticClass:"emission-library-factor",attrs:{"readonly":true,"placeholder":_vm.emissionLibraryExample.N2O != null
                                                ? _vm.emissionLibraryExample.N2O + " " + (_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.emissionLibraryExample.unit_id]))
                                                : ''}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v("CO2")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-input',{staticClass:"emission-library-factor",attrs:{"readonly":true,"placeholder":_vm.emissionLibraryExample.CO2 != null
                                                ? _vm.emissionLibraryExample.CO2 + " " + (_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.emissionLibraryExample.unit_id]))
                                                : ''}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}},[_c('hr',{staticClass:"my-0 line-text"})]),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-1",staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('span',{staticClass:"formTitle"},[_vm._v("CO2e")])]),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-input',{staticClass:"emission-library-factor",attrs:{"readonly":true,"placeholder":_vm.emissionLibraryExample.CO2e != null
                                                ? _vm.emissionLibraryExample.CO2e + " " + (_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.emissionLibraryExample.unit_id]))
                                                : ''}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"4"}})],1),_vm._v(" "),_c('b-row',{staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[(_vm.emissionLocationInfo)?_c('span',{staticStyle:{"font-size":".6em","font-weignt":"bold","color":"#808080"}},[_vm._v("\n                                            *"+_vm._s(_vm.$t('country'))+": "+_vm._s(_vm.emissionLocationInfo.countryName)+" -\n                                            "+_vm._s(_vm.$t('region'))+": "+_vm._s(_vm.emissionLocationInfo.name)+" -\n                                            "+_vm._s(_vm.$t('sector'))+": "+_vm._s(_vm.$t(_vm.sectorMap[_vm.emissionLibraryExample.sector_id].name))+"\n                                        ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',{staticStyle:{"width":"90%"},attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"md":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[(_vm.emissionLocationInfo)?_c('span',{staticStyle:{"font-size":".6em","font-weignt":"bold","color":"#022b49"}},[_vm._v("\n                                            "+_vm._s(_vm.$t('emissionInfoNotification'))+"\n                                        ")]):_vm._e()])],1)]:_vm._e(),_vm._v(" "),(this.editedItem.emissionSource == null && _vm.modalType == 'update')?[_c('b-col',{attrs:{"md":"8"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","color":"#022b49","text-align":"left"}},[_c('thead',[_c('tr',[_vm._l((_vm.emissionUpdateTableFields),function(field,index){return _c('th',{key:(_vm.activeStep + "-" + index),staticStyle:{"font-size":".9em","border-top":"none","text-align":"left"},style:(("width: " + (_vm.headerWidths[field.header] || '10em') + ";"))},[_vm._v(_vm._s(_vm.$t(field.header)))])}),_vm._v(" "),_c('th',{staticStyle:{"width":"4em","border-top":"none"},attrs:{"id":"editColumn"}})],2)]),_vm._v(" "),_c('tbody',[_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.emisssionCustomInsertMode)?_c('tr',{key:"insert-row"},[_vm._l((_vm.emissionUpdateTableFields),function(field,index){return _c('td',{key:index,staticStyle:{"font-size":"0.875em","text-align":"left"}},[(field.key == 'type')?[_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(_vm.newEmissionModel.editedValue.type),callback:function ($$v) {_vm.$set(_vm.newEmissionModel.editedValue, "type", $$v)},expression:"newEmissionModel.editedValue.type"}},_vm._l((_vm.emissionTypes),function(nEmissionType){return _c('b-form-select-option',{key:nEmissionType.id,attrs:{"value":nEmissionType.id}},[_vm._v(" "+_vm._s(_vm.$t(nEmissionType.name))+" ")])}),1)]:_vm._e(),_vm._v(" "),(field.key == 'dateRange')?[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"year","format":"yyyy"},model:{value:(_vm.newEmissionModel.editedValue.start),callback:function ($$v) {_vm.$set(_vm.newEmissionModel.editedValue, "start", $$v)},expression:"newEmissionModel.editedValue.start"}})]:_vm._e(),_vm._v(" "),(field.key == 'emission')?[_c('masked-input',{staticClass:"masked-input-custom",attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfEmission,"placeholder":((_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.editedItem.unit])))},model:{value:(_vm.newEmissionModel.editedValue.factor),callback:function ($$v) {_vm.$set(_vm.newEmissionModel.editedValue, "factor", $$v)},expression:"newEmissionModel.editedValue.factor"}})]:_vm._e(),_vm._v(" "),(field.key == 'source')?[_c('b-form-input',{attrs:{"placeholder":_vm.$t('source')},model:{value:(_vm.newEmissionModel.editedValue.source),callback:function ($$v) {_vm.$set(_vm.newEmissionModel.editedValue, "source", $$v)},expression:"newEmissionModel.editedValue.source"}})]:_vm._e()],2)}),_vm._v(" "),_c('td',{style:({'margin-right': '4px'})},[_c('div',{staticClass:"tableBodyCell",staticStyle:{"display":"inline"}},[_c('div',{key:"accept-insert",staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.addNewCustomEmissionFactors(_vm.newEmissionModel)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('div',{key:"cancel-insert",staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":_vm.cancelNewCustomEmissionFactors}},[_c('i',{staticClass:"fas fa-ban"})])])])],2):_vm._e()]),_vm._v(" "),_vm._l((_vm.editedItem.emissionFactors),function(emissionType,index){return _c('tr',{key:index},[_vm._l((_vm.emissionUpdateTableFields),function(field,indexx){return _c('td',{key:indexx,staticStyle:{"font-size":"0.875em","text-align":"left"}},[(field.key == 'type')?[(emissionType.editMode)?[_c('b-form-select',{on:{"change":_vm.forceUpdate},model:{value:(emissionType.editedValue.type),callback:function ($$v) {_vm.$set(emissionType.editedValue, "type", $$v)},expression:"emissionType.editedValue.type"}},_vm._l((_vm.emissionTypes),function(nEmissionType){return _c('b-form-select-option',{key:nEmissionType.id,attrs:{"value":nEmissionType.id}},[_vm._v(" "+_vm._s(_vm.$t(nEmissionType.name))+" ")])}),1)]:[_c('span',[_vm._v("\n                                                            "+_vm._s(_vm.getEmissionType(emissionType.value.type))+"\n                                                        ")])]]:_vm._e(),_vm._v(" "),(field.key == 'dateRange')?[(emissionType.editMode)?[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"year","format":"yyyy"},model:{value:(emissionType.editedValue.start),callback:function ($$v) {_vm.$set(emissionType.editedValue, "start", $$v)},expression:"emissionType.editedValue.start"}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"year","format":"yyyy"},model:{value:(emissionType.editedValue.end),callback:function ($$v) {_vm.$set(emissionType.editedValue, "end", $$v)},expression:"emissionType.editedValue.end"}})]:[_c('span',[_vm._v("\n                                                            "+_vm._s(_vm.getDateRange(emissionType.editedValue.start, emissionType.editedValue.end))+"\n                                                        ")])]]:_vm._e(),_vm._v(" "),(field.key == 'emission')?[(emissionType.editMode)?[_c('masked-input',{staticClass:"masked-input-custom",attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfEmission,"placeholder":((_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.editedItem.unit])))},model:{value:(emissionType.editedValue.factor),callback:function ($$v) {_vm.$set(emissionType.editedValue, "factor", $$v)},expression:"emissionType.editedValue.factor"}})]:[_c('span',[_vm._v("\n                                                            "+_vm._s(emissionType.value.factor)+" "+_vm._s(((_vm.$t('ton')) + "/" + (_vm.$t(_vm.unitMap[_vm.editedItem.unit]))))+"\n                                                        ")])]]:_vm._e(),_vm._v(" "),(field.key == 'source')?[(emissionType.editMode)?[_c('b-form-input',{attrs:{"placeholder":_vm.$t('source')},model:{value:(emissionType.editedValue.source),callback:function ($$v) {_vm.$set(emissionType.editedValue, "source", $$v)},expression:"emissionType.editedValue.source"}})]:[_c('span',[_vm._v("\n                                                            "+_vm._s(emissionType.value.source)+"\n                                                        ")])]]:_vm._e()],2)}),_vm._v(" "),(emissionType.editMode)?_c('td',{style:({'margin-right': '4px'})},[_c('div',{staticClass:"tableBodyCell",staticStyle:{"display":"inline-block"}},[_c('div',{key:("accept-" + index),staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.saveEmissionType(emissionType)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('div',{key:("cancel-" + index),staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.revertEmissionType(emissionType)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),_c('div',{key:("remove-" + index),staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.removeEmissionType(emissionType)}}},[_c('i',{staticClass:"fas fa-trash"})])])]):_c('td',{style:({'margin-right': '4px'})},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{key:("editspan-" + index),staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){emissionType.editMode = true}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})])])])],2)})],2)])])]:(this.editedItem.emissionSource != null && _vm.modalType == 'update')?[_c('b-col',{attrs:{"md":"8"}},[_c('b-table',{attrs:{"hover":"","responsive":"","items":_vm.emissionLibraryData,"fields":_vm.emissionLibraryDataFields}}),_vm._v(" "),(_vm.emissionLocationInfo)?_c('span',{staticStyle:{"font-size":".6em","font-weignt":"bold","color":"#808080"}},[_vm._v("\n                                        *"+_vm._s(_vm.$t('country'))+": "+_vm._s(_vm.emissionLocationInfo.countryName)+" -\n                                        "+_vm._s(_vm.$t('region'))+": "+_vm._s(_vm.emissionLocationInfo.name)+" -\n                                        "+_vm._s(_vm.$t('sector'))+": "+_vm._s(_vm.$t(_vm.sectorMap[_vm.emissionLibraryExample.sector_id].name))+"\n                                    ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.emissionLocationInfo)?_c('span',{staticStyle:{"font-size":".6em","font-weignt":"bold","color":"#022b49"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('emissionInfoNotification'))+"\n                                    ")]):_vm._e()],1)]:_vm._e()],2)],1)]:(_vm.steps[_vm.activeStep].stepTitle == 'sourceDesign')?[_c('b-row',{staticClass:"mb-5"},[_c('span',{staticClass:"stepSubTitle"},[_vm._v(_vm._s(_vm.modalType == 'insert' ? _vm.$t(_vm.steps[_vm.activeStep].stepSubTitle) : _vm.$t(_vm.steps[_vm.activeStep].editStepSubTitle)))])]),_vm._v(" "),_vm._l((_vm.editedItem.design),function(designItem,index){return _c('b-row',{key:index,class:['section-line my-2', {'is-design-active': !designItem.active }]},[_c('b-col',{attrs:{"md":"12"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('span',{staticClass:"formTitle",staticStyle:{"padding-right":"20px"}},[_vm._v(_vm._s(designItem.key))]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"checkbox",attrs:{"name":"checkbox-3","value":true,"unchecked-value":false},model:{value:(designItem.active),callback:function ($$v) {_vm.$set(designItem, "active", $$v)},expression:"designItem.active"}})],1)],1),_vm._v(" "),[_c('b-col',{attrs:{"md":"5"}},[_c('b-row',{staticStyle:{"width":"85%"}},[_c('b-col',[_c('b-row',[_c('span',{staticClass:"formTitle",staticStyle:{"padding-left":"10px"}},[_vm._v(_vm._s(_vm.$t('header')))])]),_vm._v(" "),_c('b-row',[_c('b-form-input',{staticClass:"my-1",staticStyle:{"height":"10%","padding":"5px 10px","margin-left":"10px"},attrs:{"placeholder":_vm.$t('header')},model:{value:(designItem.header),callback:function ($$v) {_vm.$set(designItem, "header", $$v)},expression:"designItem.header"}})],1)],1)],1)],1),_vm._v(" "),(!['health', 'lastUpdatedAt', 'lastModifier'].includes(designItem.key))?_c('b-col',{attrs:{"md":"3","align-self":"center"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-form-checkbox',{staticClass:"checkbox",attrs:{"name":"checkbox-3","value":true,"unchecked-value":false},model:{value:(designItem.editable),callback:function ($$v) {_vm.$set(designItem, "editable", $$v)},expression:"designItem.editable"}},[_c('span',{staticClass:"formTitle",staticStyle:{"padding-right":"20px"}},[_vm._v(_vm._s(_vm.$t('editable')))])])],1)],1):_vm._e(),_vm._v(" "),(!['health', 'lastUpdatedAt', 'lastModifier'].includes(designItem.key))?_c('b-col',{attrs:{"md":"3","align-self":"center"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-form-checkbox',{staticClass:"checkbox",attrs:{"name":"checkbox-3","value":true,"unchecked-value":false},model:{value:(designItem.required),callback:function ($$v) {_vm.$set(designItem, "required", $$v)},expression:"designItem.required"}},[_c('span',{staticClass:"formTitle",staticStyle:{"padding-right":"20px"}},[_vm._v(_vm._s(_vm.$t('required')))])])],1)],1):_vm._e()]],2)})]:void 0],2)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.inProgress)?[_c('div',{staticStyle:{"color":"#ff0000"}},[_vm._v("\n                    "+_vm._s(_vm.$t('longProcessNotification'))+"\n                ")])]:[(_vm.activeStep != 0)?_c('b-button',{staticClass:"modal-button",staticStyle:{"margin-top":"12px","background-color":"#E8E8E8","color":"#AAABB9"},on:{"click":function($event){return _vm.prevStep()}}},[_c('span',{key:"backArrow"},[_c('i',{staticClass:"fas fa-chevron-left"}),_vm._v("\n                        "+_vm._s(_vm.$t('back'))+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.isLastStep())?_c('b-button',{staticClass:"modal-button",staticStyle:{"margin-top":"12px","background-color":"#4129A8","color":"#fff"},attrs:{"disabled":_vm.checkIfButtonDisabled()},on:{"click":function($event){return _vm.nextStep()}}},[_c('span',{key:"nextArrow"},[_vm._v("\n                        "+_vm._s(_vm.$t('next'))+"\n                        "),_c('i',{staticClass:"fas fa-chevron-right"})])]):_c('b-button',{staticClass:"modal-button",staticStyle:{"margin-top":"12px","background-color":"#4129A8","color":"#fff"},attrs:{"disabled":_vm.checkIfButtonDisabled()},on:{"click":function($event){return _vm.saveSource()}}},[_c('span',[_vm._v("\n                        "+_vm._s(_vm.$t('save'))+"\n                    ")])])]],2)],1),_vm._v(" "),_c('b-modal',{ref:"confirmSourceDelete",attrs:{"size":"md","hide-footer":"","hide-header":"","centered":""}},[_c('div',{staticClass:"d-block text-center",staticStyle:{"color":"#022b49"}},[_c('b-row',{staticClass:"mb-3",attrs:{"align-h":"center"}},[_c('b-col',{staticStyle:{"font-weight":"bold","font-size":"1.5em"}},[_vm._v("\n                    "+_vm._s(_vm.$t('deleteConfirmTitle'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-5",attrs:{"align-h":"center"}},[_c('b-col',[_vm._v("\n                    "+_vm._s(_vm.$t('deleteConfirmText'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',[_c('b-button',{attrs:{"size":"md","variant":"danger","disabled":_vm.inProgress},on:{"click":function($event){return _vm.deleteSource(_vm.editedItem.id, _vm.editedItem.isActive)}}},[_vm._v(_vm._s(_vm.$t('delete')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"outline-dark","disabled":_vm.inProgress},on:{"click":function($event){return _vm.closeDeleteModal()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('duplicateSourceModalTitle'),"size":"md","hide-footer":"","centered":"","modal-class":"confirm-dialog","header-class":"border-bottom-0","title-class":"text-center flex-fill"},model:{value:(_vm.duplicateSourceModal),callback:function ($$v) {_vm.duplicateSourceModal=$$v},expression:"duplicateSourceModal"}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mb-5",attrs:{"align-h":"center"}},[_c('b-col',[_vm._v("\n                    "+_vm._s(_vm.$t('duplicateSourceModalText'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',[_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.duplicateSource()}}},[_vm._v(_vm._s(_vm.$t('duplicateSourceBtn')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.convertExistingSource()}}},[_vm._v(_vm._s(_vm.$t('convertExistingSourceBtn')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.duplicateSourceModal = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('inactivateSourceModalTitle'),"size":"md","hide-footer":"","centered":"","modal-class":"confirm-dialog","header-class":"border-bottom-0","title-class":"text-center flex-fill"},model:{value:(_vm.inactivateSourceModal),callback:function ($$v) {_vm.inactivateSourceModal=$$v},expression:"inactivateSourceModal"}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mb-5",attrs:{"align-h":"center"}},[_c('b-col',[_vm._v("\n                    "+_vm._s(_vm.$t('inactivateSourceModalText'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',[_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.changeDuplicatedSourceActivation(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.changeDuplicatedSourceActivation(false)}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.inactivateSourceModal = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)],1)]),_vm._v(" "),_c('b-modal',{attrs:{"title":_vm.$t('convertUnitsModalTitle'),"size":"md","hide-footer":"","centered":"","modal-class":"confirm-dialog","header-class":"border-bottom-0","title-class":"text-center flex-fill"},model:{value:(_vm.convertUnitsModal),callback:function ($$v) {_vm.convertUnitsModal=$$v},expression:"convertUnitsModal"}},[_c('div',{staticClass:"d-block text-center"},[_c('b-row',{staticClass:"mb-5",attrs:{"align-h":"center"}},[_c('b-col',[_vm._v("\n                    "+_vm._s(_vm.$t('convertUnitsModalText'))+"\n                ")])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[(_vm.pageSource === 'sourceSummary')?_c('b-col',[_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.changeExistingSource(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.convertUnitsModal = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1):(_vm.pageSource === 'sourceManagement')?_c('b-col',[_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.updateSourceManagement(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){return _vm.updateSourceManagement(false)}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"secondary"},on:{"click":function($event){_vm.convertUnitsModal = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kAfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("eNnA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f6914e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("rYYP");
function injectStyle (ssrContext) {
  __webpack_require__("wFoj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64f6914e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64f6914e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("1q1S")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kH5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__ = __webpack_require__("NpL0");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0f568b7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__ = __webpack_require__("aCZS");
function injectStyle (ssrContext) {
  __webpack_require__("zHNj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f568b7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SemipolarSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0f568b7c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SemipolarSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "kLm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-row',{staticStyle:{"min-height":"300px"}},[(_vm.pieChartData.datasets[0].data.length)?_c('b-col',{attrs:{"cols":"12","sm":"4","md":"12","lg":"6"}},[_c('div',{staticStyle:{"width":"26em","height":"26em","margin":"30px auto"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.pieChartData,"options":_vm.pieChartOptions,"chart-id":_vm.pieChartId}})],1)]):_c('b-col',[_c('span',[_vm._v(_vm._s(_vm.$t('emissionError')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"10","md":"12","lg":"6"}},[_c('div',{staticClass:"table-responsive"},[(_vm.hasAnyCarbonEmission)?_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"11em"}},[_vm._v(_vm._s(_vm.$t('emissionType')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year - 1))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('carbonEmissionChanging')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.emissions),function(emission,key){return (key !== 'total')?_c('tr',{key:key},[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(key))+" ("+_vm._s(_vm.$t('ton'))+"CO2e)")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(emission.past,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(emission.current,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(_vm.calculateRatio(emission.past, emission.current) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(emission.past, emission.current) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                        "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(emission.past, emission.current)),'float', _vm.locale))+"\n                                    ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]):_vm._e()}),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.emissions.total.displayName)+" ("+_vm._s(_vm.$t('ton'))+"CO2e)")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.emissions.total.past,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.emissions.total.current,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',[(_vm.calculateRatio(_vm.emissions.total.past, _vm.emissions.total.current) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.emissions.total.past, _vm.emissions.total.current) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                        "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.emissions.total.past, _vm.emissions.total.current)),'float', _vm.locale))+"\n                                    ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)])],2)]):_vm._e()])])],1):_c('b-row')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kM+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__ = __webpack_require__("yDbN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TotalCarbonConsumptions',
    props: {
        initialConsumptions: {
            type: Object,
            default: function _default() {
                return {
                    currentConsumptions: [],
                    pastConsumptions: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        }
    },
    components: { DoughnutChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__["a" /* default */] },
    data: function data() {
        var _this = this;

        return {
            isLoaded: false,
            pieChartId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            consumptions: [],
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Tüketim',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                /*
                    layout: {
                        padding: {
                            top: 110,
                            left: 10,
                            bottom: 10,
                            right: 10
                        }
                    },
                    */
                responsive: false,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Toplam Karbon Tüketimi',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function onComplete() {
                        /*
                        let chartInstance = this.chart;
                        let textCtx = chartInstance.ctx;
                        textCtx.textAlign = 'center';
                        textCtx.textBaseline = 'middle';
                        textCtx.font = '24px Avenir';
                        textCtx.fillStyle = '#676763';
                        textCtx.fillText("2017", 148, 260);
                        */
                    }
                },
                legend: {
                    position: 'right',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                        /*
                        var index = legendItem.index;
                        var ci = this.chart;
                        var meta = ci.getDatasetMeta(0);
                        // See controller.isDatasetVisible comment
                        meta.data[index].hidden = !meta.data[index].hidden;
                        // We hid a dataset ... rerender the chart
                        ci.update();
                        */
                    }
                }
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonConsumptionsDataSet: function prepareTotalCarbonConsumptionsDataSet(consumptions) {
            var _this2 = this;

            // Resets pieChartData
            this.pieChartData.datasets = [{
                labels: [],
                hoverBorderWidth: [],
                hoverBorderColor: [],
                backgroundColor: [],
                data: []
            }];
            this.pieChartData.labels = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(consumptions, function (consumption, index) {
                _this2.pieChartData.datasets[0].labels.push(_this2.$t(consumption.source));
                _this2.pieChartData.labels.push(_this2.$t(consumption.source));
                _this2.pieChartData.datasets[0].hoverBorderWidth.push(6);
                _this2.pieChartData.datasets[0].hoverBorderColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].backgroundColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].data.push(consumption.value);
            });
            this.isLoaded = true;
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return consumptions;
        },
        prepareTotalCarbonConsumptionsTable: function prepareTotalCarbonConsumptionsTable(consumptions) {
            var currentConsumptions = consumptions.currentConsumptions,
                pastConsumptions = consumptions.pastConsumptions;

            var prepared = {
                total: {
                    displayName: this.$t('total'),
                    current: 0,
                    past: 0
                }
            };

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(currentConsumptions, function (consumption) {
                prepared[consumption.source] = {
                    displayName: consumption.source,
                    current: consumption.value
                };
                prepared.total.current += consumption.value;
            });

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(pastConsumptions, function (consumption) {
                if (prepared[consumption.source]) {
                    prepared[consumption.source]['past'] = consumption.value;
                } else {
                    prepared[consumption.source] = {
                        displayName: consumption.source,
                        past: consumption.value,
                        current: 0
                    };
                }
                prepared.total.past += consumption.value;
            });

            prepared.total.current = Number(prepared.total.current.toFixed(2));
            prepared.total.past = Number(prepared.total.past.toFixed(2));

            this.consumptions = prepared;
        },
        filterConsumptions: function filterConsumptions(consumptions) {
            var _this3 = this;

            var current = consumptions.currentConsumptions;
            var past = consumptions.pastConsumptions;
            if (this.selectedSiteGroupId) {
                var sitesOfRegion = this.sites.filter(function (site) {
                    return site.siteGroupId === _this3.selectedSiteGroupId;
                });
                if (this.selectedSiteId) {
                    current = current.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id }) && consumption.site_id === _this3.selectedSiteId;
                    });
                    past = past.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id }) && consumption.site_id === _this3.selectedSiteId;
                    });
                } else {
                    current = current.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id });
                    });
                    past = past.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id });
                    });
                }
            } else if (this.selectedSiteId) {
                current = current.filter(function (consumption) {
                    return consumption.site_id === _this3.selectedSiteId;
                });
                past = past.filter(function (consumption) {
                    return consumption.site_id === _this3.selectedSiteId;
                });
            }

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ current: current, past: past });
        },
        aggregateConsumptions: function aggregateConsumptions(consumptions) {
            var reducedCurrent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(consumptions.current, function (result, consumption) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(result, { type: consumption.type });
                if (foundEmission) {
                    foundEmission.value += consumption.value;
                } else {
                    result.push(consumption);
                }
                return result;
            }, []);

            var reducedPast = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(consumptions.past, function (result, consumption) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(result, { type: consumption.type });
                if (foundEmission) {
                    foundEmission.value += consumption.value;
                } else {
                    result.push(consumption);
                }
                return result;
            }, []);

            reducedCurrent = reducedCurrent.filter(function (data) {
                return data.value !== 0;
            });
            reducedPast = reducedPast.filter(function (data) {
                return data.value !== 0;
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ current: reducedCurrent, past: reducedPast });
        },
        processCarbonConsumptions: function processCarbonConsumptions(data) {
            this.prepareTotalCarbonConsumptionsDataSet(data.currentConsumptions);
            this.prepareTotalCarbonConsumptionsTable(data);
        }
    },
    computed: {
        hasAnyCarbonConsumption: function hasAnyCarbonConsumption() {
            return this.consumptions && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.consumptions).length;
        }
    },
    watch: {
        initialConsumptions: function initialConsumptions(data) {
            this.processCarbonConsumptions(data);
        },
        selectedSiteId: function selectedSiteId() {
            this.processCarbonConsumptions(this.initialConsumptions);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processCarbonConsumptions(this.initialConsumptions);
        }
    },
    mounted: function mounted() {
        this.processCarbonConsumptions(this.initialConsumptions);
    }
});

/***/ }),

/***/ "kQPI":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"FORMLAR","formCountColumn":"Form Sayısı / Form Tipi"},"en":{"title":"FORMS","formCountColumn":"Forms"}}')
}


/***/ }),

/***/ "kTA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateGoal_vue__ = __webpack_require__("c60z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8675fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateGoal_vue__ = __webpack_require__("rgYo");
function injectStyle (ssrContext) {
  __webpack_require__("KB7p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c8675fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateGoal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8675fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateGoal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("BmdX")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kz7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l92n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrinityRingsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      containerPadding: 3
    };
  },


  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        padding: this.containerPadding + 'px'
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: this.outerRingSize + 'px',
        width: this.outerRingSize + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: this.outerRingSize * 0.65 + 'px',
        width: this.outerRingSize * 0.65 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: this.outerRingSize * 0.1 + 'px',
        width: this.outerRingSize * 0.1 + 'px',
        borderColor: this.color,
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "l9Ai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fulfilling-square-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinner-inner",style:(_vm.spinnerInnerStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lDa5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_charts_DoughnutChart__ = __webpack_require__("yDbN");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TableAndChart',
    props: {
        initialEmissions: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        },
        dataTypes: {
            default: function _default() {
                return ['CO2e'];
            }
        },
        pieChartDataType: {
            default: 'CO2e'
        },
        title: {
            default: function _default() {
                return null;
            }
        },
        groupType: {
            default: function _default() {
                return 'type';
            }
        }
    },
    components: { DoughnutChart: __WEBPACK_IMPORTED_MODULE_6__components_charts_DoughnutChart__["a" /* default */] },
    data: function data() {
        var _this = this;

        return {
            pieChartId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            emissions: {
                total: {}
            },
            isSummary: true,
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Karbon Emisyonu',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                responsive: false,
                maintainAspectRatio: false,
                /*
                  layout: {
                      padding: {
                          top: 0,
                          left: 10,
                          bottom: 0,
                          right: 0
                      }
                  },
                  */
                title: {
                    display: false,
                    text: 'Toplam Karbon Emisyonları',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_5__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function onComplete() {
                        /*
                        let chartInstance = this.chart;
                        let textCtx = chartInstance.ctx;
                        textCtx.textAlign = 'center';
                        textCtx.textBaseline = 'middle';
                        textCtx.font = '24px Avenir';
                        textCtx.fillStyle = '#676763';
                        textCtx.fillText("2017", 148, 260);
                        */
                    }
                },
                legend: {
                    position: 'right',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                    }
                }
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonEmissionsDataSet: function prepareTotalCarbonEmissionsDataSet(emissions) {
            var _this2 = this;

            // Resets pieChartData
            this.pieChartData.datasets = [{
                labels: [],
                hoverBorderWidth: [],
                hoverBorderColor: [],
                backgroundColor: [],
                data: []
            }];
            this.pieChartData.labels = [];
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(emissions, function (emission, index) {
                if (_this2.isSummary && emission.CO2e !== 0 || !_this2.isSummary && emission.CO2e !== 0 || emission.CO2 !== 0 || emission.N2O !== 0 || emission.CH4 !== 0) {
                    _this2.pieChartData.datasets[0].labels.push(_this2.isSummary ? _this2.$t(emission.source) : _this2.$t(emission.type));
                    _this2.pieChartData.labels.push(_this2.isSummary ? _this2.$t(emission.source) : _this2.$t(emission.type));
                    _this2.pieChartData.datasets[0].hoverBorderWidth.push(6);
                    _this2.pieChartData.datasets[0].hoverBorderColor.push(_this2.colourPalette[index % 10]);
                    _this2.pieChartData.datasets[0].backgroundColor.push(_this2.colourPalette[index % 10]);
                    _this2.pieChartData.datasets[0].data.push(emission[_this2.pieChartDataType] ? emission[_this2.pieChartDataType] : 0);
                }
            });
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return emissions;
        },
        prepareTotalCarbonEmissionsTable: function prepareTotalCarbonEmissionsTable(emissions) {
            var _this3 = this;

            var prepared = {
                total: {
                    consumption: 0
                }
            };
            this.dataTypes.forEach(function (dataType) {
                prepared.total[dataType] = 0;
            });

            emissions.forEach(function (emission) {
                if (_this3.isSummary && emission.CO2e !== 0 || !_this3.isSummary && emission.CO2e !== 0 || emission.CO2 !== 0 || emission.N2O !== 0 || emission.CH4 !== 0) {
                    _this3.dataTypes.forEach(function (dataType) {
                        emission[dataType] = emission[dataType] ? Number(emission[dataType].toFixed(2)) : 0;
                        if (!prepared[_this3.isSummary ? emission.source : emission.type]) {
                            prepared[_this3.isSummary ? emission.source : emission.type] = {};
                        }
                        prepared[_this3.isSummary ? emission.source : emission.type][dataType] = emission[dataType];
                        prepared.total[dataType] += emission[dataType];
                    });
                    prepared[_this3.isSummary ? emission.source : emission.type].consumption = emission.consumption;
                    prepared[_this3.isSummary ? emission.source : emission.type].unit = emission.unit;
                    prepared[_this3.isSummary ? emission.source : emission.type].consumptionUnit = emission.consumptionUnit;
                }
            });

            this.dataTypes.forEach(function (dataType) {
                prepared.total[dataType] = Number(prepared.total[dataType].toFixed(2));
            });
            this.emissions = prepared;
        },
        aggregateEmissions: function aggregateEmissions(emissions) {
            var _this4 = this;

            var reduced = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(emissions, function (result, emission) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(result, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, _this4.groupType, emission[_this4.groupType]));
                if (foundEmission) {
                    _this4.dataTypes.forEach(function (dataType) {
                        emission[dataType] = emission[dataType] ? emission[dataType] : 0;
                        foundEmission[dataType] += emission[dataType];
                    });
                    emission['consumption'] = emission['consumption'] ? emission['consumption'] : 0;
                    foundEmission['consumption'] += emission['consumption'];
                } else {
                    _this4.dataTypes.forEach(function (dataType) {
                        emission[dataType] = emission[dataType] ? emission[dataType] : 0;
                    });
                    emission['consumption'] = emission['consumption'] ? emission['consumption'] : 0;
                    result.push(emission);
                }
                return result;
            }, []);

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(reduced);
        },
        processCarbonEmission: function processCarbonEmission(_ref) {
            var data = _ref.data,
                consumptions = _ref.consumptions,
                isSummary = _ref.isSummary;

            this.isSummary = isSummary;
            if (isSummary) {
                consumptions = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.reduce(consumptions, function (newConsumptions, consumption) {
                    var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(newConsumptions, { scopeGroup: consumption.scopeGroup });
                    if (found) {
                        found.value += consumption.value;
                    } else {
                        newConsumptions.push({
                            scopeGroup: consumption.scopeGroup,
                            value: consumption.value
                        });
                    }
                    return newConsumptions;
                }, []);
            }
            var query = null;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(consumptions, function (consumption) {
                if (isSummary) {
                    query = { source: consumption.scopeGroup };
                } else {
                    query = { source: consumption.scopeGroup, type: consumption.type };
                }
                var found = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(data, query);
                if (found) {
                    found.consumption = consumption.value;
                }
            });
            return this.aggregateEmissions(data).then(this.prepareTotalCarbonEmissionsDataSet).then(this.prepareTotalCarbonEmissionsTable);
        }
    },
    computed: {
        hasAnyCarbonEmission: function hasAnyCarbonEmission() {
            return this.emissions && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.emissions).length;
        }
    },
    watch: {
        initialEmissions: function initialEmissions(data) {
            this.processCarbonEmission(this.deepClone(data));
        },
        selectedSiteId: function selectedSiteId() {
            this.processCarbonEmission(this.initialEmissions);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processCarbonEmission(this.initialEmissions);
        }
    },
    mounted: function mounted() {
        this.processCarbonEmission(this.deepClone(this.initialEmissions));
    }
});

/***/ }),

/***/ "lOB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPTL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h-100 py-5 carousel-container"},[_c('div',{staticClass:"d-flex align-items-center align-self-start"},[_c('b-img',{staticClass:"mr-2 my-0",staticStyle:{"max-width":"55px"},attrs:{"src":"../../static/faradai_logo_icon_white.png"}}),_vm._v(" "),_c('h3',{staticClass:"text-white mb-0 font-weight-bold"},[_vm._v(_vm._s(_vm.$t('Carbon Intelligence')))])],1),_vm._v(" "),_c('b-carousel',{staticClass:"d-flex h-100",attrs:{"indicators":"","interval":4000},on:{"sliding-start":_vm.onSlideStart,"sliding-end":_vm.onSlideEnd},model:{value:(_vm.slide),callback:function ($$v) {_vm.slide=$$v},expression:"slide"}},_vm._l((_vm.carouselItems),function(item){return _c('b-carousel-slide',{key:item.id,staticClass:"custom-carousel-item",scopedSlots:_vm._u([{key:"img",fn:function(){return [_c('img',{staticClass:"custom-carousel-img",attrs:{"src":item.image}})]},proxy:true}],null,true)},[_vm._v(" "),_c('h2',{staticClass:"my-4 font-weight-bold"},[_vm._v(_vm._s(_vm.$t(item.title)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t(item.text)))])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "laTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    dotSize: {
      type: Number,
      default: 15
    },
    dotsNum: {
      type: Number,
      default: 3
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    horizontalMargin: function horizontalMargin() {
      return this.dotSize / 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.dotSize + 'px',
        width: (this.dotSize + this.horizontalMargin * 2) * this.dotsNum + 'px'
      };
    },
    dotStyle: function dotStyle() {
      return {
        animationDuration: this.animationDuration + 'ms',
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        margin: '0 ' + this.horizontalMargin + 'px',
        borderWidth: this.dotSize / 5 + 'px',
        borderColor: this.color
      };
    },
    dotsStyles: function dotsStyles() {
      var dotsStyles = [];
      var delayModifier = 0.3;
      var basicDelay = 1000;

      for (var i = 1; i <= this.dotsNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: basicDelay * i * delayModifier + 'ms'
        }, this.dotStyle);

        dotsStyles.push(style);
      }

      return dotsStyles;
    }
  }
});

/***/ }),

/***/ "lhlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__ = __webpack_require__("bGbP");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10ac9285_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__ = __webpack_require__("FY1r");
function injectStyle (ssrContext) {
  __webpack_require__("1Nbg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10ac9285"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpringSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10ac9285_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpringSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421dcd54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("9aty");
function injectStyle (ssrContext) {
  __webpack_require__("dEe2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-421dcd54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421dcd54_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("W9Vi")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lp8e":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"ConsolidateSustainabilityDataTitle":"Sürdürülebilirlik Verilerini Tek Platformda Birleştirin","ConsolidateSustainabilityDataText":"İyi tasarlanmış veri giriş alanlarıyla karbon verisi toplamayı basitleştirin ve sürdürülebilirlik verilerini tek bir merkezde birleştirin.","StreamlineGHGEmissionsReportingTitle":"Sera Gazı Emisyon Raporlarını Kolaylaştırın","StreamlineGHGEmissionsReportingText":"Zorunlu ve gönüllü raporlama gereksinimlerini basit ve kolay bir şekilde sunmak için Enerji, Atık ve Taşıma verilerini derleyin. IPCC, DEFRA, EPA gibi genişleyen küresel emisyon faktörleri veritabanlarıyla Kapsam 1, 2 ve 3 GHG emisyonlarını hesaplayın ve ISO 140001, ISO 14064 ve GHG Protokol çerçevelerine uyun.","TrackNetZeroGoalsTitle":"Net Sıfır Hedefleri Takip Edin","TrackNetZeroGoalsText":"Kurumsal veya faaliyet düzeyinde hedefler belirleyin ve sürdürülebilirlik hedeflerine yönelik ilerlemeyi izleyin. Lokasyonların normalize edilmiş emisyon verilerini birbirine göre kıyaslayın ve yıldan yıla değişiklikleri takip edin.","ManageAuditsTitle":"Denetimleri Yönetin","ManageAuditsText":"Kurumunuzun çevre performansını iç ve dış denetimlerle değerlendirin, uygunsuzlukları belirleyin ve aksiyon planlarını takip edin.","CreateSustainabilityRepositoryTitle":"Kurumsal Sürdürülebilirlik Hafızası Oluşturun","CreateSustainabilityRepositoryText":"Belgeleri, faturaları ve denetim kanıtı dosyalarını tek bir yerde saklayın ve belgeleri ihtiyaç duyduğunuz her yerde ve zamanda dağıtım, erişim ve kullanım için hazır hale getirin."},"en":{"ConsolidateSustainabilityDataTitle":"Consolidate Sustainability Data","ConsolidateSustainabilityDataText":"Simplify carbon data collection with well-designed data entry fields and consolidate sustainability data on a single global hub.","StreamlineGHGEmissionsReportingTitle":"Streamline GHG Emissions Reporting","StreamlineGHGEmissionsReportingText":"Compile Energy, Waste and Transport data to submit mandatory and voluntary reporting requirements with simplicity and ease. Calculate Scope 1, 2 and 3 GHG emissions with expanding global emission factors databases like IPCC, DEFRA, EPA and comply with ISO 140001, ISO 14064 and GHG Protocol frameworks.","TrackNetZeroGoalsTitle":"Track Net Zero Goals","TrackNetZeroGoalsText":"Set organizational or activity level targets and track progress towards sustainability goals. Benchmark normalized emission data of locations against each other and track year over year changes.","ManageAuditsTitle":"Manage Audits","ManageAuditsText":"Evaluate the environmental performance of your organization with internal and external audits, determine nonconformities and track action plans.","CreateSustainabilityRepositoryTitle":"Create a Sustainability Repository","CreateSustainabilityRepositoryText":"Keep documented information, invoices and audit evidence files in one place and make documents available for distribution, access and use whenever and wherever you need."}}')
}


/***/ }),

/***/ "lpBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("WHn1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90785c90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("bmHc");
function injectStyle (ssrContext) {
  __webpack_require__("f5/t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90785c90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90785c90_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("L98+")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ls93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"background-color":"#eff3f6","border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag,index){return _c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, active: index === _vm.activeIndex},attrs:{"id":("clickme_" + (tag.name))},on:{"click":function($event){return _vm.routeTo(tag, index)}}},[_vm._v("\n                "+_vm._s(tag.name)+"\n            ")])])}),0),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lviy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expr_eval__ = __webpack_require__("EdP0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_expr_eval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_expr_eval__);




__WEBPACK_IMPORTED_MODULE_1_numeral___default.a.register('locale', 'tr', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function ordinal(number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});

function parseLocalizedNumber(value) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tr';

    if (locale === 'tr') {
        value = value.split(',');

        if (value[1]) {
            return value[0].replace(new RegExp('\\.', 'g'), '').concat('.', value[1]);
        } else {
            return value[0].replace(new RegExp('\\.', 'g'), '');
        }
    } else {
        return value;
    }
}

function parseNumber(value, type) {
    var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'tr';

    value = value ? String(value) : '';
    __WEBPACK_IMPORTED_MODULE_1_numeral___default.a.locale(locale);
    if (type === 'float') {
        if (locale === 'tr') {
            value = Number(value).toFixed(2);
            var valueMap = value.split('.');
            value = valueMap.join(',');
        }
        return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value).format('0,0.00');
    } else {
        return __WEBPACK_IMPORTED_MODULE_1_numeral___default()(value).format('0,0');
    }
}

function isFloat(number) {
    var secondPart = Number(number.toFixed(2).split('.')[1]);
    return secondPart > 0;
}

// TODO: Make this work for languages other than Turkish
function isLetter(str) {
    return str && str.length === 1 && str.match(/[ a-z | ü | ğ | ş | ı | ç | ö | İ]/i);
}

// Adds unit to emission values
function addUnit(val, unit) {
    return val != 0 ? val + ' ' + unit : '';
}

/* harmony default export */ __webpack_exports__["a"] = ({
    parseNumber: parseNumber,
    isLetter: isLetter,
    addUnit: addUnit,
    evaluateFormula: function evaluateFormula(item, _ref) {
        var key = _ref.key,
            formula = _ref.formula,
            formula_fields = _ref.formula_fields;

        if (formula && item[key].value) {
            var input = {};
            formula_fields.forEach(function (fieldName) {
                if (item[fieldName] && item[fieldName].editedValue) {
                    input[fieldName] = Number(parseLocalizedNumber(item[fieldName].editedValue));
                }
            });
            var parser = new __WEBPACK_IMPORTED_MODULE_2_expr_eval__["Parser"]();
            var expr = parser.parse(formula);
            item[key].value = String(Number(expr.evaluate(input).toFixed(2)));

            return item[key].value;
        } else {
            return item[key].value;
        }
    },
    formatDate: function formatDate() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        var format = arguments[1];

        return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format(format);
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(text) {
        var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tr';

        var words = text.trim().split(' ');
        words = words.map(function (word) {
            if (isLetter(word[0])) {
                return word.charAt(0).toUpperCase() + word.toLocaleLowerCase(locale).slice(1);
            }
            return word;
        });
        return words.join(' ');
    },
    convertZeroValueToDash: function convertZeroValueToDash(value, locale) {
        var parsedValue = Number(parseLocalizedNumber(value, locale));
        return parsedValue === 0 ? '-' : value;
    },
    textToShortText: function textToShortText(val) {
        if (val && val.length > 9) {
            var firstPart = val.slice(0, 3);
            var secondPart = val.slice(val.length - 5, val.length);
            return firstPart + '...' + secondPart;
        } else {
            return val;
        }
    },
    shortenText: function shortenText(str) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

        if (str) {
            if (str.length > value) {
                return str.slice(0, value) + '...';
            } else {
                return str;
            }
        } else {
            return '';
        }
    },

    isFloat: isFloat,
    absoluteNumber: function absoluteNumber(val) {
        return Math.abs(val);
    },
    localizedRatioText: function localizedRatioText(val, locale) {
        if (locale === 'tr') {
            return '%' + val;
        } else {
            return val + '%';
        }
    }
});

/***/ }),

/***/ "lybT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[(_vm.pieChartData.datasets[0].data.length)?_c('b-col',{attrs:{"cols":"12","sm":"4","md":"12","lg":"6"}},[_c('div',{staticStyle:{"width":"26em","height":"26em","margin":"auto"}},[_c('doughnut-chart',{attrs:{"chart-data":_vm.pieChartData,"options":_vm.pieChartOptions,"chart-id":_vm.pieChartId}})],1)]):_c('b-col',[_c('span',[_vm._v(_vm._s(_vm.$t('emissionError')))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"10","md":"12","lg":"6"}},[_c('div',{staticClass:"table-responsive"},[(_vm.hasAnyCarbonConsumption)?_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-top":"none !important"}},[_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"14em"}},[_vm._v(_vm._s(_vm.$t('emissionType')))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year - 1))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('carbonEmissionChanging')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.consumptions),function(consumption,key){return (key !== 'total')?_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t(consumption.displayName))+" ("+_vm._s(_vm.$store.state.analysis_unit)+")")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(consumption.past,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(consumption.current,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(_vm.calculateRatio(consumption.past, consumption.current) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(consumption.past, consumption.current) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                    "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(consumption.past, consumption.current)),'float', _vm.locale))+"\n                                ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)]):_vm._e()}),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.consumptions.total.displayName)+" ("+_vm._s(_vm.$store.state.analysis_unit)+")")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.consumptions.total.past,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.consumptions.total.current,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',[(_vm.calculateRatio(_vm.consumptions.total.past, _vm.consumptions.total.current) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.consumptions.total.past, _vm.consumptions.total.current) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                    "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.consumptions.total.past, _vm.consumptions.total.current)),'float', _vm.locale))+"\n                                ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)])],2)]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m+c3":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"scopeComparingError":"Kapsam verisi bulunamadı","changingColumn":"Değişim (%)","scopeBarChartTitle":"Kapsam Kıyaslaması"},"en":{"scopeComparingError":"No scope data","changingColumn":"Change (%)","scopeBarChartTitle":"Scope Comparison"}}')
}


/***/ }),

/***/ "mBjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = (function (element, listener) {
	var expand = document.createElement('_');
	var shrink = expand.appendChild(document.createElement('_'));
	var expandChild = expand.appendChild(document.createElement('_'));
	var shrinkChild = shrink.appendChild(document.createElement('_'));

	var lastWidth = void 0,
	    lastHeight = void 0;

	shrink.style.cssText = expand.style.cssText = 'height:100%;left:0;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:0;transition:0s;width:100%;z-index:-1';
	shrinkChild.style.cssText = expandChild.style.cssText = 'display:block;height:100%;transition:0s;width:100%';
	shrinkChild.style.width = shrinkChild.style.height = '200%';

	element.appendChild(expand);

	test();

	return stop;

	function test() {
		unbind();

		var width = element.offsetWidth;
		var height = element.offsetHeight;

		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;

			expandChild.style.width = width * 2 + 'px';
			expandChild.style.height = height * 2 + 'px';

			expand.scrollLeft = expand.scrollWidth;
			expand.scrollTop = expand.scrollHeight;
			shrink.scrollLeft = shrink.scrollWidth;
			shrink.scrollTop = shrink.scrollHeight;

			listener({ width: width, height: height });
		}

		shrink.addEventListener('scroll', test);
		expand.addEventListener('scroll', test);
	}

	function unbind() {
		shrink.removeEventListener('scroll', test);
		expand.removeEventListener('scroll', test);
	}

	function stop() {
		unbind();

		element.removeChild(expand);
	}
});

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ "mTBr":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"consumptions":"Tüketimleri","siteCount":"Lokasyon Sayısı","goalsTitle":"HEDEFLER","goalsAndGoalTrackingTitle":"Hedefler ve Hedef Takip","approvedTitle":"Onaylanmış","documentsTitle":"BELGELER","dataHealthRatio":"Sağlık","dataTitle":"VERİLER","sourceDataTitle":"Kaynak Tüketimleri","auditTitle":"DENETİM","openedTitle":"Açılan","changingColumn":"Değişim (%)","wasteManagement":"Atık Yönetimi","wasteTrackingForm":"Atık Takip Formu","wasteDeliveryForm":"Sıfır Atık Çizelgesi","chemicalMaterialUsage":"Kimyasal Malzeme Kullanımı","chemicalMaterialForm":"Kimyasal Malzeme Formu","chemicalMaterialSdsForm":"Kimyasal Malzeme SDS Formları","emergencySituationForms":"Acil Duruma Hazır Olma ve Müdahale","meetingNotesAndInformationMails":"Toplantı Tutanakları ve Bilgilendirme Mailleri","onlineCoursePresentation":"Sanal Eğitim Sunumu","intraclassCoursePresentation":"Sınıf içi Eğitim Sunumu","correctiveActionReport":"Uygunluğun Değerlendirilmesi","actionPlan":"Aksiyon Planı","educationPresentations":"Eğitim Sunumları","usageGuide":"Kullanım Kılavuzu","siteName":"Lokasyon","number of people":"Kişi Sayısı","monthly":"Aylık Rapor","yearly":"Yıllık Rapor","auditDateReport":"Denetim Tarihi Raporu","goalTracking":"Hedef Takip","auditItemTracking":"Denetim Madde Takibi","dataQualityAlerts":"Veri Sağlığı Uyarıları","chooseExcel":"Lütfen indirmek için bir rapor seçin","exportData":"Tüm veriyi aktar","siteClosed":"Kapalı","Goal-report-notification":"Hedef raporu mail olarak gönderilecektir. Bu işlem biraz zaman alabilir.","Goal-report-already-requested":"Hedef raporu zaten bir kere talep edildi. Lütfen Bekleyin.","Quality-alert-report-notification":"Veri sağlığı uyarı raporu mail olarak gönderilecektir. Bu işlem biraz zaman alabilir.","Quality-alert-report-already-requested":"Veri sağlığı uyarı raporu zaten bir kere talep edildi. Lütfen Bekleyin.","Already-requested":"Daha önceden talep ettiğiniz raporunuz hazırlanıyor. İşlem bittiğinde yeni rapor oluşturmayı deneyebilirsiniz."},"en":{"consumptions":"Consumptions","siteCount":"Sites","areaTitle":"Area","agent":"Agent","sub-agent":"Sub-Agent","supervisor":"Supervisor","manager":"Manager","goalsTitle":"GOALS","goalsAndGoalTrackingTitle":"Goals and Goal Tracking","approvedTitle":"Approved","documentsTitle":"DOCUMENTS","dataHealthRatio":"Health","dataTitle":"DATA","sourceDataTitle":"Consumption of Sources","auditTitle":"AUDITS","openedTitle":"Opened","changingColumn":"Change (%)","wasteManagement":"Waste Management","wasteTrackingForm":"Waste Tracking Form","wasteDeliveryForm":"Zero Waste Table","chemicalMaterialUsage":"Chemical Management","chemicalMaterialForm":"Chemical Material Form","chemicalMaterialSdsForm":"Chemical SDS Material Forms","emergencySituationForms":"Emergency Preparedness and Response Plan","meetingNotesAndInformationMails":"Meeting Notes And Information","onlineCoursePresentation":"Online Course Presentation","intraclassCoursePresentation":"Intraclass Course Presentation","correctiveActionReport":"Corrective Action Report","actionPlan":"Preventive Action Plan","educationPresentations":"Education Presentations","usageGuide":"User Guide","siteName":"Site Name","number of people":"Occupancy","monthly":"Monthly Report","yearly":"Yearly Report","auditDateReport":"Audit Date Report","goalTracking":"Goal Tracking","auditItemTracking":"Audit Item Tracking","dataQualityAlerts":"Data Quality Alerts","chooseExcel":"Please choose a report to download","exportData":"Export data","siteClosed":"Closed","Goal-report-notification":"The target report will be sent by e-mail. This process may take some time.","Goal-report-already-requested":"Goal report has already been requested once. Please wait.","Quality-alert-report-notification":"The data quality alerts report will be sent by e-mail. This process may take some time.","Quality-alert-report-already-requested":"Data quality alerts report has already been requested once. Please wait.","Already-requested":"Your requested report is being prepared. When your report is ready, you can try to create a new report"}}')
}


/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
    return {
        init: function init(_ref) {
            var _this = this;

            var commit = _ref.commit;

            var promiseArr = [Vue.axios.get('/init'), Vue.axios.get('/sites')];
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr).then(function (results) {
                var sites = results[1].data.sites;
                var data = results[0].data;
                commit('SET_TOP_LEVEL_TAGS', data.topLevelTags);
                commit('SET_SITES', sites);
                commit('SET_PAYMENT_METHODS', data.paymentMethods);
                commit('SET_SITE_GROUPS', data.siteGroups);
                commit('SET_UNSUITABLENESS', data.nonconformances);
                commit('SET_DATA_TYPES', data.dataTypes);
                commit('SET_SOURCE_TYPES', data.sourceTypes);
                commit('SET_USER', data.user);
                commit('SET_LOCALE', data.user.language);
                commit('SET_FORM_TYPES', data.formTypes);
                commit('SET_UNITS', data.units);
                commit('SET_SITE_TYPES', data.siteTypes);
                commit('SET_DASHBOARD_DATA_TYPES', data.dashboardDataTypes);
                commit('SET_ANALYSIS_UNIT', data.analysisUnit);
                commit('SET_USERS', data.users);
                commit('SET_SITES_WITH_GROUPS');
                commit('SET_AWS_OPTIONS', data.isExcludedForAws);
                _this.dispatch('getLocations');
                _this.dispatch('getRelationalTags');
                //commit('SET_ADMIN_LIST', data.agentList);
                return true;
            });
        },
        getDocumentCounts: function getDocumentCounts(_ref2) {
            var commit = _ref2.commit,
                state = _ref2.state;
            var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var query = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                max_updated_at: state.maxUpdatedAtForDocuments,
                start_date: startDate
            }, {
                skipNulls: true
            });
            return Vue.axios.get('/documents/?' + query).then(function (_ref3) {
                var data = _ref3.data;

                if (data.updateValue) {
                    commit('SET_DOCUMENTS', data.counts);
                    commit('SET_MAX_UPDATED_AT_FOR_DOCUMENTS', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getGoalCounts: function getGoalCounts(_ref4) {
            var commit = _ref4.commit,
                state = _ref4.state;

            var query = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                max_updated_at: state.maxUpdatedAtForGoals
            }, {
                skipNulls: true
            });
            return Vue.axios.get('/goals?' + query).then(function (_ref5) {
                var data = _ref5.data;

                if (data.updateValue) {
                    commit('SET_GOALS', data.counts);
                    commit('SET_MAX_UPDATED_AT_FOR_GOALS', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getUsers: function getUsers(_ref6) {
            var commit = _ref6.commit;

            return Vue.axios.get('/getAllUsers').then(function (_ref7) {
                var data = _ref7.data;

                commit('SET_USERS', data);
                return true;
            });
        },
        getAuditCounts: function getAuditCounts(_ref8) {
            var commit = _ref8.commit,
                state = _ref8.state;
            var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var query = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
                updatedAt: state.maxUpdatedAtForAudits,
                start_date: startDate
            }, {
                skipNulls: true
            });
            return Vue.axios.get('/audits?' + query).then(function (_ref9) {
                var data = _ref9.data;

                if (data.updateValue) {
                    commit('SET_AUDITS', data.report);
                    commit('SET_MAX_UPDATED_AT_FOR_AUDIT', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getTicketListBySiteID: function getTicketListBySiteID(_ref10, siteId) {
            var commit = _ref10.commit,
                state = _ref10.state;
            var startDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2_moment___default()().year();

            var query = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({ start_date: startDate });
            if (siteId) {
                return Vue.axios.get(siteId + '/audits?' + query).then(function (_ref11) {
                    var data = _ref11.data;

                    commit('SET_TICKET_LIST', data);
                    return true;
                }).catch(function (err) {
                    commit('SET_TICKET_LIST', []);
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
                });
            } else {
                commit('SET_TICKET_LIST', []);
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('missing siteId');
            }
        },
        getDataTypes: function getDataTypes(_ref12) {
            var commit = _ref12.commit;

            return Vue.axios.get('/getDataTypes').then(function (_ref13) {
                var data = _ref13.data;

                commit('SET_DATA_TYPES', data);
            });
        },
        getLocations: function getLocations(_ref14) {
            var commit = _ref14.commit;

            return Vue.axios.get('/getAllLocationsAndSectors').then(function (_ref15) {
                var data = _ref15.data;

                commit('SET_LOCATIONS_AND_SECTORS', data);
            });
        },
        getRelationalTags: function getRelationalTags(_ref16) {
            var commit = _ref16.commit;

            return Vue.axios.get('/getRelationalTags').then(function (_ref17) {
                var data = _ref17.data;

                commit('SET_RELATIONAL_TAGS', data);
            });
        },
        getSites: function getSites(_ref18) {
            var commit = _ref18.commit;

            return Vue.axios.get('/sites').then(function (_ref19) {
                var data = _ref19.data;

                commit('SET_SITES', data.sites);
            });
        }
    };
});

/***/ }),

/***/ "mfOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("DC4C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31af779f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__("lPTL");
function injectStyle (ssrContext) {
  __webpack_require__("jIX/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31af779f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("lp8e")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "moi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_General_vue__ = __webpack_require__("fSUo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a1fe97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_General_vue__ = __webpack_require__("FpSN");
function injectStyle (ssrContext) {
  __webpack_require__("81SY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54a1fe97"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_General_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a1fe97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_General_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("rO5E")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mtPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Warn__ = __webpack_require__("Szm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Notification__ = __webpack_require__("Hwfi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateTicket__ = __webpack_require__("Kvn9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreatePost__ = __webpack_require__("Vw2r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateAudit__ = __webpack_require__("V0D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuditFiles__ = __webpack_require__("jELx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreateGoal__ = __webpack_require__("kTA6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CreateSource__ = __webpack_require__("/koR");









/* harmony default export */ __webpack_exports__["a"] = ({
    Warn: __WEBPACK_IMPORTED_MODULE_0__Warn__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_1__Notification__["a" /* default */],
    CreateTicket: __WEBPACK_IMPORTED_MODULE_2__CreateTicket__["a" /* default */],
    UpdateTicket: __WEBPACK_IMPORTED_MODULE_2__CreateTicket__["a" /* default */],
    CreatePost: __WEBPACK_IMPORTED_MODULE_3__CreatePost__["a" /* default */],
    UpdatePost: __WEBPACK_IMPORTED_MODULE_3__CreatePost__["a" /* default */],
    CreateAudit: __WEBPACK_IMPORTED_MODULE_4__CreateAudit__["a" /* default */],
    AuditFiles: __WEBPACK_IMPORTED_MODULE_5__AuditFiles__["a" /* default */],
    CreateGoal: __WEBPACK_IMPORTED_MODULE_6__CreateGoal__["a" /* default */],
    UpdateGoal: __WEBPACK_IMPORTED_MODULE_6__CreateGoal__["a" /* default */],
    CreateSource: __WEBPACK_IMPORTED_MODULE_7__CreateSource__["a" /* default */],
    UpdateSource: __WEBPACK_IMPORTED_MODULE_7__CreateSource__["a" /* default */]
});

/***/ }),

/***/ "n5Qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var token = localStorage.getItem('token');
/*eslint-disable */

var config = {
    timeout: 120000,
    headers: {
        Authorization: token ? 'Bearer ' + token : 'Bearer ',
        Pragma: 'no-cache'
    },
    baseURL: '/backend'
};

try {
    if (process && "production" === 'development') {
        config.baseURL = 'http://localhost:7788';
    }
} catch (err) {}

/*eslint-enable */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(config));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("W2nU")))

/***/ }),

/***/ "nJYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_components_navbar_scss__ = __webpack_require__("SetW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_scss_components_navbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_scss_components_navbar_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TheNavbar',
    data: function data() {
        return {
            visible: null
        };
    },

    watch: {
        visible: function visible(val) {
            this.$emit('change', val);
        }
    },
    methods: {
        assignRoute: function assignRoute(page) {

            switch (page) {
                case 'summary':
                    return this.$store.state.siteId ? { name: 'dashboard', query: { year: this.year, site_id: this.$store.state.siteId } } : { name: 'dashboard', query: { year: this.year } };
                case 'data':
                    return this.$store.state.siteId ? { name: 'site-data-types', params: { site_id: this.$store.state.siteId }, query: { type: 'consumption', year: this.year } } : { name: 'data-sites' };
                case 'report':
                    return this.$store.state.siteId ? { name: 'general-analysis', params: { site_id: this.$store.state.siteId }, query: { year: this.year } } : { name: 'analysis' };
                case 'goals':
                    return this.$store.state.siteId ? { name: 'goal-detail', params: { site_id: this.$store.state.siteId } } : { name: 'goal' };
                case 'documents':
                    return this.$store.state.siteId ? { name: 'site-files', params: { site_id: this.$store.state.siteId }, query: { year: this.year } } : { name: 'doc' };
                case 'audit':
                    if (this.isUserAssingedToAnySite()) {
                        return { name: 'audit' };
                    } else if (this.$store.state.siteId) {
                        return { name: 'Detail', params: { site_id: this.$store.state.siteId }, query: { year: this.year } };
                    } else {
                        return { name: 'Summary' };
                    }

                default:
                    break;

            }
        },
        isUserAssingedToAnySite: function isUserAssingedToAnySite() {
            return this.gbId(this.$store.state.user.customerId) && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state.user.assignedSites, 'length') > 0;
        },
        logout: function logout() {
            var _this = this;

            var store = this.$store;
            return this.axios.post('logout').then(function () {
                _this.getInitialState(store.state);
                localStorage.removeItem('token');
            });
        }
    }
});

/***/ }),

/***/ "nKzh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nQpw":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"cost-out-range":"Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.","value-out-range":"Maksimum 9 basamaklı veri girişi yapabilirsiniz. Daha küçük sayılar ile giriş yapmayı deneyiniz.","Evsel Atık":"Evsel Atık"},"en":{"cost-out-range":"You can enter a maximum of 9 digits. Try to enter smaller data.","value-out-range":"You can enter a maximum of 9 digits. Try to enter smaller data.","Evsel Atık":"Domestic Waste"}}')
}


/***/ }),

/***/ "nbOB":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"revisedDocumentInfo":"Tamamlanan Döküman Bilgisi","urgentActionText":"Acil Alınacak Aksiyonlar","reasonAnalysisText":"Kök Neden Analizi","additionalFiles":"Ek Dosyalar","action":"Genel Aksiyon Tanımları"},"en":{"revisedDocumentInfo":"Complited Document Information","urgentActionText":"Urgent Actions to be taken","reasonAnalysisText":"Root Cause Analysis","auditDate":"Audit Date","additionalFiles":"Additional Files","action":"Action"}}')
}


/***/ }),

/***/ "nixg":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"firstnamePlaceholder":"Adınızı girin","lastnamePlaceholder":"Soyadınızı girin","emailPlaceholder":"Email adresinizi girin","passwordPlaceholder":"Şifrenizi girin","signupButton":"Üye Ol"},"en":{"firstnamePlaceholder":"Enter your firstname","lastnamePlaceholder":"Enter your lastname","emailPlaceholder":"Enter your email","passwordPlaceholder":"Enter your password","signupButton":"Sign Up"}}')
}


/***/ }),

/***/ "noD0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Table__ = __webpack_require__("ABj6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteMultiSelectTree_vue__ = __webpack_require__("oE/+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { VueTable: __WEBPACK_IMPORTED_MODULE_1__components_Table__["a" /* default */], SiteMultiSelectTree: __WEBPACK_IMPORTED_MODULE_2__components_SiteMultiSelectTree_vue__["a" /* default */] },
    name: 'Sources',
    data: function data() {
        return {
            tabs: {
                activeSources: {
                    isActive: true,
                    tableInfo: { fields: [], items: [] },
                    name: this.$t('activeSources'),
                    style: {
                        border: { 'border-bottom': '3px solid #41B884' },
                        tab: { 'color': '#41B884' },
                        badge: { 'background-color': '#41B884' }
                    }
                },
                inactiveSources: {
                    isActive: false,
                    tableInfo: { fields: [], items: [] },
                    name: this.$t('inactiveSources'),
                    style: {
                        border: { 'border-bottom': '3px solid #022B49' },
                        tab: { 'color': '#022B49' },
                        badge: { 'background-color': '#022B49' }
                    }
                }
            },
            selectedItem: {
                isActive: true
            },
            error: {},
            activeTab: 'activeSources',
            currentPage: 1,
            perPage: 3,
            // perPage: 7,
            totalRows: 0,
            isLoaded: false,
            inProgress: false,
            searchInput: '',
            editedItem: {
                emissionFactors: {}
            },
            modalType: null,
            showModal: false,
            scopeGroups: null,
            sourceTypes: null,
            sourceTypeGroups: null,
            allSites: [],
            emissionTypes: null,
            temps: {
                name: null,
                startDate: null,
                emissionFactor: null,
                source: null
            },
            unitList: [],
            unitMap: {},
            unitTypeMap: { id: {}, name: {} },
            emisssionCustomInsertMode: false,
            emissionCustomItem: {},
            newEmissionModel: {},
            dataUnits: null
        };
    },

    methods: {
        setPerPage: function setPerPage(perPage) {
            this.perPage = perPage;
        },
        forceUpdate: function forceUpdate() {
            this.$forceUpdate();
        },
        activate: function activate(key) {
            var _this = this;

            this.activeTab = key;
            __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(this.tabs, function (tab, tabKey) {
                _this.currentPage = 1;
                tab.isActive = key == tabKey;
            });
        },
        filterData: function filterData() {
            this.currentPage = 1;
            this.forceUpdate();
        },
        itemsForList: function itemsForList(data) {
            var searchedDataItems = this.searchData(data.items);
            this.totalRows = searchedDataItems.length;

            return {
                fields: data.fields,
                items: searchedDataItems.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
            };
        },
        searchData: function searchData(dataItems) {
            var _this2 = this;

            if (this.searchInput.length < 1) {
                return dataItems;
            } else {
                return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(dataItems, function (o) {
                    return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this2.toLocaleLowerCase(_this2.$t(o.cols.name.value)), _this2.toLocaleLowerCase(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this2.toLocaleLowerCase(_this2.$t(o.cols.detail.value)), _this2.toLocaleLowerCase(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this2.toLocaleLowerCase(_this2.$t(o.cols.type.value[0]) + ' ' + _this2.$t(o.cols.type.value[1])), _this2.toLocaleLowerCase(_this2.searchInput)) || __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(_this2.toLocaleLowerCase(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.join(o.cols.locations.value, ' ')), _this2.toLocaleLowerCase(_this2.searchInput));
                });
            }
        },
        isEmissionFactorInputDisabled: function isEmissionFactorInputDisabled(isCO2eInput) {
            var _this3 = this;

            if (isCO2eInput) {
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.editedItem.emissionFactors), 'CO2e')) {
                    if (this.editedItem.emissionFactors['CO2e'] != '') {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.editedItem.emissionFactors), function (key) {
                            if (key != 'CO2e') {
                                _this3.editedItem.emissionFactors[key] = '';
                            }
                        });
                        return true;
                    }
                }
            } else {
                var intersection = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.intersection(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.editedItem.emissionFactors), ['CO2', 'N2O', 'CH4']);
                if (__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(intersection) > 0) {
                    var nonEmptyIntersections = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(intersection, function (o) {
                        return _this3.editedItem.emissionFactors[o] == '';
                    });
                    if (!(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.size(nonEmptyIntersections) > 0)) {
                        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.editedItem.emissionFactors), function (key) {
                            if (key == 'CO2e') {
                                _this3.editedItem.emissionFactors[key] = '';
                            }
                        });
                        return true;
                    };
                }
            }
            return false;
        },
        deleteSource: function deleteSource(id, isActive) {
            if (isActive) {
                this.tabs.activeSources.tableInfo.items = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.tabs.activeSources.tableInfo.items, function (o) {
                    return o.id != id;
                });
            } else {
                this.tabs.inactiveSources.tableInfo.items = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.tabs.inactiveSources.tableInfo.items, function (o) {
                    return o.id != id;
                });
            }
        },
        setSelectedSource: function setSelectedSource(itemData) {
            var isActive = itemData.name == 'active sources' || itemData.name == 'active_data_summary';

            if (isActive) {
                this.selectedItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.tabs.activeSources.tableInfo.items, function (o) {
                    return o.id == itemData.id;
                });
            } else {
                this.selectedItem = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.tabs.inactiveSources.tableInfo.items, function (o) {
                    return o.id == itemData.id;
                });
            }

            this.selectedItem.isActive = isActive;
        },
        showCreateSourceModal: function showCreateSourceModal(target) {
            var _this4 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'createSource',
                payload: {
                    page: 'sourceManagement',
                    title: "createSource",
                    selectedSource: {}
                }
            });
            this.$nextTick(function () {
                _this4.$root.$emit('bv::show::modal', 'createSource', target);
                _this4.$eventHub.$once(_this4.$store.state.modal.eventId, function (result) {
                    if (result.emitter === 'insert') {
                        _this4.init();
                    }
                });
            });
        },
        showEditSourceModal: function showEditSourceModal(itemData, event) {
            var _this5 = this;

            this.setSelectedSource(itemData);

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
                type: 'updateSource',
                payload: {
                    page: 'sourceManagement',
                    title: "updateSource",
                    selectedSource: {},
                    selectedItem: this.selectedItem

                }
            });
            this.$nextTick(function () {
                _this5.$root.$emit('bv::show::modal', 'createSource', event.target);
                _this5.$eventHub.$once(_this5.$store.state.modal.eventId, function (result) {
                    if (result.emitter === 'update') {
                        _this5.init();
                    } else if (result.emitter == 'delete') {
                        _this5.deleteSource(result.data.id, result.data.isActive);
                    }
                });
            });
        },
        init: function init() {
            var _this6 = this;

            this.isLoaded = false;
            this.$Progress.start();
            return this.axios.get('/getSourceManagement').then(function (_ref) {
                var data = _ref.data;

                _this6.tabs.activeSources.tableInfo = {
                    fields: data.active.fields,
                    items: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(data.active.items, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toLower(_this6.$t(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(o, 'cols'), 'name'), 'value')));
                    })
                };
                _this6.tabs.inactiveSources.tableInfo = {
                    fields: data.inactive.fields,
                    items: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.sortBy(data.inactive.items, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.toLower(_this6.$t(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(o, 'cols'), 'name'), 'value')));
                    })
                };

                _this6.isLoaded = true;
                _this6.$Progress.finish();

                _this6.totalRows = _this6.tabs[_this6.activeTab].tableInfo.items.length;
            });
        }
    },
    watch: {
        emisssionCustomInsertMode: function emisssionCustomInsertMode() {
            this.forceUpdate();
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "nx2s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tableWrapper",class:['table-responsive', 'mt-2', { 'scroll-content': _vm.isScrollable}],staticStyle:{"height":"100%"},style:(_vm.isScrollable ? (_vm.height + " !important;") : ''),attrs:{"id":_vm.tableId}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"},style:(_vm.isScrollable ? 'border-collapse:separate;border-spacing:0;' : '')},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px"},style:(_vm.isScrollable ? 'z-index:2' : '')},[_c('tr',{ref:"tableHeaderRow"},[_vm._l((_vm.fields),function(field){return (field.type !== 'daterange')?_c('th',{key:field.key,staticStyle:{"width":"10em","text-align":"center"}},[_vm._v(_vm._s(field.key.slice(0, field.key.length-1) !== 'value' ? _vm.$t(field.header) : _vm.$t(field.header)))]):_c('th',{staticStyle:{"width":"23em","text-align":"center"}},[_vm._v(_vm._s(field.key.slice(0, field.key.length-1) !== 'value' ? _vm.$t(field.header) : _vm.$t(field.header)))])}),_vm._v(" "),(_vm.isEditable)?_c('th',{staticStyle:{"width":"9em"},attrs:{"id":"lastColumn"}}):_vm._e()],2)]),_vm._v(" "),_c('tbody',{ref:"tableBody"},[_vm._l((_vm.items),function(item,index){return _c('tr',{key:index,ref:"tableBodyRow",refInFor:true,class:_vm.cursorType,on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(item, _vm.fields)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.revertChanges(item)}],"click":function($event){return _vm.routeTo(item)}}},[_vm._l((_vm.fields),function(field,index){return _c('td',{key:index,style:(field.type === 'link' ? {'text-align': 'center'}: null)},[_c('div',{staticClass:"tableBodyCell"},[(field.type === 'number' || field.type === 'float')?[(field.editable && item.editMode && _vm.isEditable)?[_c('masked-input',{class:Object.assign(item[field.key].classes, {'masked-input-custom': true}),attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t(field.header)},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(item[field.key] && !_vm.isNil(item[field.key].value))?[_vm._v(_vm._s(_vm._f("parseNumber")(_vm._f("evaluateFormula")(item,field),field.type, _vm.locale))+" "+_vm._s(_vm.$t(item[field.key].unit)))]:[_vm._v(_vm._s(item[field.key] ? item[field.key].defaultValue : '-'))]]:(field.type === 'select')?[(field.editable && item.editMode && _vm.isEditable)?[_c('b-form-select',{class:Object.assign(item[field.key].classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":[{value: null, text: _vm.$t('choose')} ].concat( _vm.processPaymentMethods())},nativeOn:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:[_vm._v(_vm._s(_vm.idToPaymentMethod(item[field.key].value)))]]:(field.type === 'date')?[(field.editable && item.editMode && _vm.isEditable)?[_c('el-date-picker',{class:item[field.key].classes,staticStyle:{"width":"100%"},attrs:{"type":"date","readonly":!field.editable,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(item[field.key] && !_vm.isNil(item[field.key].value))?[_vm._v(_vm._s(_vm._f("formatDate")(item[field.key].value,'DD/MM/YYYY')))]:[_vm._v(_vm._s(item[field.key] && item[field.key].defaultValue))]]:(field.type === 'identity'&&item.lastModifier&&item.lastModifier)?[(item.lastModifier.status == 'active')?_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: item.lastModifier.id}}}},[_vm._v(_vm._s(item.lastModifier.value))]):_c('span',[_vm._v(_vm._s(item.lastModifier.value))])]:(field.type === 'daterange')?[(field.editable && item.editMode && _vm.isEditable)?[_c('el-date-picker',{class:item[field.key].classes,staticStyle:{"width":"100%"},attrs:{"type":"daterange","readonly":!field.editable,"format":"dd/MM/yyyy","placeholder":_vm.$t('chooseDatePlaceholder')},on:{"focus":function($event){return _vm.resetWarning(item[field.key])}},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:(item[field.key] && !_vm.isNil(item[field.key].value))?[_vm._v(_vm._s(_vm._f("formatDate")(item[field.key].value[0],'DD/MM/YYYY'))+" - "+_vm._s(_vm._f("formatDate")(item[field.key].value[1],'DD/MM/YYYY')))]:[_vm._v(_vm._s(item[field.key].defaultValue))]]:(field.type === 'link' && item[field.key] && field.key == 'dataType' )?[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.$t(item[field.key].value) + " (" + _vm.$t(item["value"].unit) + ")"))])]:(field.type === 'link' && item[field.key])?[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(_vm.$t(item[field.key].value)))])]:(field.type === 'file')?[(field.editable && item.editMode && _vm.isEditable)?[(item[field.key].editedFileId)?_c('div',{on:{"click":function($event){return _vm.triggerPopover(item)}}},[_c('upload',{attrs:{"reactiveId":("a_" + _vm.reactiveId + "_" + (item.id)),"fileCategory":"data","deleteFromDB":true,"dataId":item[field.key].editedId},on:{"ondownload":function($event){return _vm.downloadFile(item[field.key].editedFileUrl ? item[field.key].editedFileUrl : item[field.key].fileUrl)},"onremove":function($event){return _vm.handleRemoving($event, item[field.key])},"onupload":function($event){return _vm.handleUploading($event, item[field.key])}}}),_vm._v(" "),_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadFiles.length ? _vm.uploadFiles[0].active : false),expression:"uploadFiles.length ? uploadFiles[0].active : false"}],attrs:{"value":_vm.uploadFiles.length ? Number(_vm.uploadFiles[0].progress) : 100,"variant":"secondary","height":"0.3em"}})],1):_c('upload-regular',{attrs:{"fileCategory":"data"},on:{"onupload":function($event){return _vm.handleUploading($event, item[field.key])}}})]:[(item[field.key].fileId)?_c('div',{staticClass:"file",on:{"click":function($event){return _vm.downloadFile(item[field.key].fileUrl)}}},[_vm._m(0,true)]):_vm._e()]]:(field.type === 'icon')?[( item[field.key] && (item[field.key].value == null || JSON.parse(item[field.key].value).status === 'health-ok'))?[_vm._m(1,true)]:[(JSON.parse(item[field.key].value).message == 'not-compared')?[_c('b',[_vm._v("-")])]:(item[field.key] && (JSON.parse(item[field.key].value).message && JSON.parse(item[field.key].value).message.length > 0))?[_c('span',{staticStyle:{"color":"red","font-size":"13.7px"}},[_vm._v("\n                        "+_vm._s(_vm.getHealthTooltipMessage(item[field.key].value))+"\n                    ")])]:[_vm._m(2,true)]]]:(field.type === 'text')?[(field.editable && item.editMode && _vm.isEditable)?[_c('b-form-input',{attrs:{"id":"description","placeholder":_vm.$t(field.header)},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:[(item[field.key].value && item[field.key].value.length > 20)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:(_vm.$t(item[field.key].value)),expression:"$t(item[field.key].value)",modifiers:{"hover":true,"right":true}}]},[_c('span',[_vm._v(" \n                            "+_vm._s(_vm._f("shortenText")(_vm.$t(item[field.key].value),12))+" \n                        ")])]):_c('span',[_vm._v("\n                            "+_vm._s(_vm.$t(item[field.key].value))+"\n                    ")])]]:(field.type === 'text-translate')?[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:(item[field.key].value),expression:"item[field.key].value",modifiers:{"hover":true,"right":true}}]},[_c('span',[_vm._v(" \n                        "+_vm._s(_vm.$t(item[field.key].value))+" \n                    ")])])]:(field.type === 'list')?[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:(item[field.key].value),expression:"item[field.key].value",modifiers:{"hover":true,"right":true}}]},[_c('span',[_vm._v(" \n                        "+_vm._s(_vm.shortenList(item[field.key].value ,3))+" \n                    ")])])]:(field.type === '2-defination')?[_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:(item[field.key].value),expression:"item[field.key].value",modifiers:{"hover":true,"right":true}}]},[_c('span',[_vm._v(" \n                        "+_vm._s(item[field.key].value[0] == 'default' ? '' : _vm.$t(item[field.key].value[0]) + ' - ')+"  "+_vm._s(_vm.$t(item[field.key].value[1]))+" \n                    ")])])]:[(field.editable && item.editMode && _vm.isEditable)?[_c('b-form-input',{attrs:{"placeholder":_vm.$t(field.header)},model:{value:(item[field.key].editedValue),callback:function ($$v) {_vm.$set(item[field.key], "editedValue", $$v)},expression:"item[field.key].editedValue"}})]:[_vm._v(_vm._s(item[field.key] ? item[field.key].value : '-'))]]],2)])}),_vm._v(" "),(_vm.isEditable)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth, 'margin-right': '4px'})},[(_vm.tableName != 'data_detail' )?_c('div',{staticClass:"tableBodyCell"},[_c('div',{key:'editspan',staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.sendEmit($event, 'openEditModal', item)}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})])]):_c('div',{staticClass:"tableBodyCell"},[(!item.editMode)?_c('div',{key:'editspan',staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.makeRowEditable(item)}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})]):_c('div',{key:'btngroup',staticClass:"table-button-group table-cell"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('save'),"disabled":item.isSaving},on:{"click":function($event){return _vm.updateItem(item, _vm.fields)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.revertChanges(item)}}},[_c('i',{staticClass:"fas fa-ban"})]),_vm._v(" "),(_vm.isDeletable)?_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete'),"variant":"danger"},on:{"click":function($event){return _vm.deleteItem($event, item.id)}}},[_c('i',{staticClass:"fas fa-trash-alt"})]):_vm._e()],1)])]):_vm._e()],2)}),_vm._v(" "),_c('transition',{attrs:{"name":"fadere","mode":"out-in"}},[(_vm.insertMode)?_c('tr',{staticStyle:{"border-bottom":"1px solid #ddd"},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createItem(_vm.tempItem)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.cancelNewRow()}]}},[_vm._l((_vm.fields),function(field){return _c('td',[(field.editable)?_c('div',[(field.type === 'number' || field.type === 'float')?[_c('masked-input',{class:Object.assign(_vm.tempItem[field.key].classes, {'masked-input-custom': true}),attrs:{"keepCharPositions":false,"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t(field.header)},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'select')?[_c('b-form-select',{class:Object.assign(_vm.tempItem[field.key].classes, {'form-control-custom': true}),staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":[{value: null, text: _vm.$t('choose')} ].concat( _vm.processPaymentMethods())},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'date')?[_c('el-date-picker',{class:_vm.tempItem[field.key].classes,staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"date","format":"dd/MM/yyyy","default-value":_vm.tempItem[field.key].defaultValue},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'daterange')?[_c('el-date-picker',{class:_vm.tempItem[field.key].classes,staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('chooseDatePlaceholder'),"type":"daterange","format":"dd/MM/yyyy","default-value":_vm.tempItem[field.key].defaultValue,"popperClass":"tempItem[field.key].classes[1] ? 'is-invalid' : ''"},on:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:(field.type === 'file')?[(_vm.tempItem[field.key].fileId)?_c('div',[_c('upload',{attrs:{"reactiveId":("a_" + _vm.reactiveId + "_temp"),"fileCategory":"data","deleteFromDB":true,"dataId":_vm.tempItem[field.key].id},on:{"ondownload":function($event){return _vm.downloadFile(_vm.tempItem[field.key].fileUrl)},"onremove":function($event){return _vm.handleTempRemoving($event, _vm.tempItem[field.key])},"onupload":function($event){return _vm.handleTempUploading($event, _vm.tempItem[field.key])}}}),_vm._v(" "),_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploadFiles.length ? _vm.uploadFiles[0].active : false),expression:"uploadFiles.length ? uploadFiles[0].active : false"}],attrs:{"value":_vm.uploadFiles.length ? Number(_vm.uploadFiles[0].progress) : 100,"variant":"secondary","height":"0.3em"}})],1):_c('upload-regular',{attrs:{"fileCategory":"data"},on:{"onupload":function($event){return _vm.handleTempUploading($event, _vm.tempItem[field.key])}}})]:(field.type === 'text')?[_c('b-form-input',{class:Object.assign(_vm.tempItem[field.key].classes, {'form-control-custom': true}),attrs:{"placeholder":_vm.$t(field.header)},nativeOn:{"focus":function($event){return _vm.resetWarning(_vm.tempItem[field.key])}},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]:[_c('b-form-input',{attrs:{"placeholder":_vm.$t(field.header)},model:{value:(_vm.tempItem[field.key].value),callback:function ($$v) {_vm.$set(_vm.tempItem[field.key], "value", $$v)},expression:"tempItem[field.key].value"}})]],2):_vm._e(),_vm._v(" "),(field.type === 'link' && field.key === 'dataType')?_c('div',[_c('b-form-select',{ref:'datatypeForm',refInFor:true,model:{value:(_vm.tempItem[field.key]),callback:function ($$v) {_vm.$set(_vm.tempItem, field.key, $$v)},expression:"tempItem[field.key]"}},_vm._l((_vm.getDataTypes()),function(dataType){return _c('option',{key:dataType.id,ref:'datatype',refInFor:true,domProps:{"value":dataType}},[_vm._v(_vm._s(dataType.name + dataType.unit))])}),0)],1):_vm._e()])}),_vm._v(" "),(_vm.isEditable)?_c('td',{staticClass:"edit-column",style:({width: _vm.lastColumnWidth, 'margin-right': '4px'})},[_c('div',{staticClass:"table-button-group"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"mso-border-shadow":"no"},attrs:{"title":_vm.$t('save'),"disabled":_vm.insertingNewItem},on:{"click":function($event){return _vm.createItem(_vm.tempItem)}}},[_c('i',{staticClass:"fas fa-check"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('cancel')},on:{"click":function($event){return _vm.cancelNewRow()}}},[_c('i',{staticClass:"fas fa-ban"})])],1)]):_vm._e()],2):_vm._e()])],2),_vm._v(" "),(_vm.tableName == 'data_detail')?_c('tfoot',{staticClass:"insert-row"},[(!_vm.insertMode && _vm.isEditable)?_c('tr',{on:{"click":function($event){return _vm.insertRow()}}},[_c('td',{staticStyle:{"border":"1px solid #ddd"},attrs:{"colspan":this.fields.length + 1}},[_vm._m(3)])]):_vm._e()]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-file-alt fa-lg"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-check fa-lg",staticStyle:{"color":"#41B884"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-times fa-lg",staticStyle:{"color":"#ff0000"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"left":"0","bottom":"54px","right":"0","margin":"auto"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nxi9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nzIB":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"wasteTableTitle":"Atık Takip Tablosu","emissionType":"Atık Tipi"},"en":{"wasteTableTitle":"Waste Amount Table","emissionType":"Waste Type"}}')
}


/***/ }),

/***/ "oC1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oE/+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteMultiSelectTree_vue__ = __webpack_require__("ZgWN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5955b4b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteMultiSelectTree_vue__ = __webpack_require__("88zR");
function injectStyle (ssrContext) {
  __webpack_require__("oC1l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteMultiSelectTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5955b4b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteMultiSelectTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("TGAJ")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oFEA":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"BELGELER","docColumn":"Doküman","uploadingDate":"Yüklenme Tarihi","fileYear":"Dosya yılı","fileDate":"Dosya tarihi","operation":"İşlem","folderOperation":"Lütfen bir klasör işlemi seçin","folder":"Klasör","folderName":"Klasör Adı","newFolderName":"Yeni Klasör Adı","documentYear":"Doküman Yılı","documentDate":"Doküman Tarihi","confirm":"Klasörü silmek istediğinize emin misiniz?","folderNameValidationFeedback":"Klasör adı boş bırakılamaz"},"en":{"title":"DOCUMENTS","docColumn":"Document","uploadingDate":"Uploading Date","fileYear":"File year","fileDate":"File date","operation":"Operation","folderOperation":"Please select an operation of folder","folder":"Folder","folderName":"Folder Name","newFolderName":"New Folder Name","documentYear":"Document Year","documentDate":"Document Date","confirm":"Are you sure to delete this folder?","folderNameValidationFeedback":"Folder name can not be left blank"}}')
}


/***/ }),

/***/ "oJjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oc2c":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1NCA1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTQgNTQ7Ij4KICA8Zz4KICAgIDxnPgogICAgICA8cGF0aCBzdHlsZT0iZmlsbDojMTY3ZDEyOyIgZD0iTTEsMjdMMSwyN0MxLDEyLjY0MSwxMi42NDEsMSwyNywxaDBjMTQuMzU5LDAsMjYsMTEuNjQxLDI2LDI2djBjMCwxNC4zNTktMTEuNjQxLDI2LTI2LDI2aDAKICAgICAgICBDMTIuNjQxLDUzLDEsNDEuMzU5LDEsMjd6Ii8+CiAgICAgIDxwYXRoIHN0eWxlPSJmaWxsOiMxNjdkMTI7IiBkPSJNMjcsNTRDMTIuMTEyLDU0LDAsNDEuODg4LDAsMjdTMTIuMTEyLDAsMjcsMHMyNywxMi4xMTIsMjcsMjdTNDEuODg4LDU0LDI3LDU0eiBNMjcsMgogICAgICAgIEMxMy4yMTUsMiwyLDEzLjIxNSwyLDI3czExLjIxNSwyNSwyNSwyNXMyNS0xMS4yMTUsMjUtMjVTNDAuNzg1LDIsMjcsMnoiLz4KICAgIDwvZz4KICAgIDxnPgogICAgICA8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTI1Ljk4MywzNi4xNDRsLTguNzE5LTE1LjEwMUMxNi45OTYsMjAuNTc5LDE3LjMzMSwyMCwxNy44NjYsMjBoMTcuNDM3CiAgICAgICAgYzAuNTM1LDAsMC44NywwLjU3OSwwLjYwMiwxLjA0M2wtOC43MTksMTUuMTAxQzI2LjkxOSwzNi42MDgsMjYuMjUsMzYuNjA4LDI1Ljk4MywzNi4xNDR6Ii8+CiAgICAgIDxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMjYuNTg1LDM3LjQ5MmMtMC42MTMsMC0xLjE2Mi0wLjMxNy0xLjQ2OS0wLjg0OGwtOC43MTktMTUuMTAyYy0wLjMwNy0wLjUzMS0wLjMwNi0xLjE2NSwwLTEuNjk1CiAgICAgICAgQzE2LjcwNCwxOS4zMTYsMTcuMjUzLDE5LDE3Ljg2NiwxOWgxNy40MzhjMC42MTMsMCwxLjE2MiwwLjMxNiwxLjQ2OSwwLjg0OGMwLjMwNiwwLjUzLDAuMzA3LDEuMTY0LDAsMS42OTVsLTguNzE5LDE1LjEwMgogICAgICAgIEMyNy43NDcsMzcuMTc1LDI3LjE5OCwzNy40OTIsMjYuNTg1LDM3LjQ5MnogTTE4LjM5NCwyMWw4LjE5MSwxNC4xODhMMzQuNzc2LDIxSDE4LjM5NHoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "ohuB":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"locationManagement":"Lokasyon Yönetimi","addCountry":"Ülke Ekle","addRegion":"Bölge Ekle","addCity":"Şehir Ekle","addSector":"Sektör Ekle","sectorName":"Sektör Adı","sectorDescription":"Sektör Açıklaması","countryTagsExample":"Almanya, Fransa, İspanya...","alreadyEnteredCountry":"Bu ülke listede ekli","regionTagsExample":"Marmara, Karadeniz, İç Anadolu...","alreadyEnteredRegion":"Bu bölge listede ekli","cityTagsExample":"İstanbul, Ankara, İzmir...","alreadyEnteredCity":"Bu şehir listede ekli...","countryDeleteError":"Bu ülkeye bağlı olan bölgeler olduğu için silinemedi.","regionDeleteError":"Bu bölgeye bağlı olan şehirler olduğu için silinemedi."},"en":{"locationManagement":"Location Management","addCountry":"Add Country","addRegion":"Add Region","addCity":"Add City","addSector":"Add Sector","sectorName":"Sector Name","sectorDescription":"Sector Description","countryTagsExample":"Germany, United Kingdom, Spain...","alreadyEnteredCountry":"You have already entered this country","regionTagsExample":"California, Colorado, New York...","alreadyEnteredRegion":"You have already entered this region","cityTagsExample":"Los Angeles, San Francisco, San Diego...","alreadyEnteredCity":"You have already entered this city","countryDeleteError":"Could not delete because there are regions dependent on this country.","regionDeleteError":"Could not delete because there are cities dependent on this region."}}')
}


/***/ }),

/***/ "oisi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("rQFb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662ebf2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("Ft5w");
function injectStyle (ssrContext) {
  __webpack_require__("AkXk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-662ebf2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662ebf2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("ooN/")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ooN/":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Reengen Sürdürülebilirlik Platformu","titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)","alert":"Email adresi bulunamadı","invalidLink":"Bu link artık geçersiz.","resetPassword":"Şifre Yenileme","passwordPlaceholder":"Şifre","passwordInfo":"7+ karakter ve bir rakam","confirmPasswordPlaceholder":"Şifre Tekrar","resetPasswordButton":"Şifreyi Yenile","passwordEmptyValidationError":"Lütfen bir şifre girin","passwordLengthError":"Şifreniz en az 7 karakter içermeli","passwordNotValidError":"Şifreniz en az 1 harf ve 1 sayı içermeli","passwordsDoNotMatch":"Şfireler uyuşmuyor","canNotLeaveEmpty":"Bu alan boş bırakılamaz"},"en":{"title":"Reengen Sustainability Platform","titleGaranti":"Environmental Management System Software (EMS)","alert":"Email address not found","invalidLink":"This url no longer valid","resetPassword":"Reset Password","passwordPlaceholder":"Password","passwordInfo":"7+ characters and one number","confirmPasswordPlaceholder":"Confirm Password","resetPasswordButton":"Reset Password","passwordEmptyValidationError":"Please enter a password","passwordLengthError":"Your password must contain at least 7 characters","passwordNotValidError":"Your password must contain at least 1 letter and 1 number","passwordsDoNotMatch":"Passwords do not match","canNotLeaveEmpty":"This field can not be empty"}}')
}


/***/ }),

/***/ "oq7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "osav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("jQ2i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a65d2bdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("p4fB");
function injectStyle (ssrContext) {
  __webpack_require__("pYyJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a65d2bdc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a65d2bdc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("fnqN")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "owG+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compare_vue__ = __webpack_require__("CU6d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50aa7783_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compare_vue__ = __webpack_require__("rYry");
function injectStyle (ssrContext) {
  __webpack_require__("rvSf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50aa7783"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Compare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50aa7783_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Compare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("dQob")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p4fB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"h-100"},[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.$t('title'))+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[(_vm.siteTypes.length)?_c('site-type-select',{on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('b-col',[_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}})],1),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"300px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)])],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                    "+_vm._s(_vm.$t('title'))+"\n                ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[(_vm.siteTypes.length)?_c('site-type-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onSiteTypeChange}}):_vm._e(),_vm._v(" "),_c('region-multi-select',{attrs:{"selectedRegionId":_vm.selectedRegionId,"regions":_vm.regions},on:{"oninput":function($event){_vm.selectedRegionId = ($event) ? ($event).id : null}}}),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('siteSearchPlaceholder'),"type":"text"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('site')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('goalCountColumn')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('approvedGoalCountColumn')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredGoals),function(goalSite){return _c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.routeToGoalDetail(goalSite)}}},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(goalSite.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(goalSite.count))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(goalSite.approved_count))])])}),0)])]),_vm._v(" "),_c('router-view',{attrs:{"year":_vm.year}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pB/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalBarChart_vue__ = __webpack_require__("1XQQ");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HorizontalBarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pJEE":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataTypeName":"Veri tipi","emissionTypeColumn":"Emisyon Tipi","factorColumn":"Emisyon Faktörü","factorPlaceHolder":"Emisyon kat sayısı","unitColumn":"Birim","startDateColumn":"Başlangıç Yılı","endDateColumn":"Bitiş Yılı"},"en":{"dataTypeName":"Data type","emissionTypeColumn":"Emission Type","factorColumn":"Emission Factor","factorPlaceHolder":"Emission Factor","unitColumn":"Unit","startDateColumn":"Start Year","endDateColumn":"End Year"}}')
}


/***/ }),

/***/ "pLbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'YearSelect',
    props: {
        variant: {
            type: String,
            default: function _default() {
                return null;
            }
        }
    },
    methods: {
        onChange: function onChange(val) {
            this.$emit('onchange', val);
        }
    }
});

/***/ }),

/***/ "pYyJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pami":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"Source":"Kaynak","Activity":"Aktivite","Type":"Tür","Location":"Lokasyon","disableYear":"Pasifleştirme Tarihi","selectActivity":"Aktivite Seç","defineSources":"Kaynakları Belirle","assignLocations":"Lokasyon Atama","emissionFactors":"Emisyon Faktörleri","selectActivityTitle":"Kaynakla ilgili ne tür bir aktivite var?","defineSourcesTitle":"Kaynak Tanımla","emissionFactorsTitle":"Sera Gazı Emisyonu hesaplama parametreleri","purchasedEnergy":"Satın Alınan Enerji","stationaryCombustion":"Durağan Yakma Emisyonları","companyVehicles":"Şirket Araçları","employeeCommuting":"Personel Ulaşım","businessTravel":"İş Seyahati","wasteGeneratedInOps":"Operasyonlarda Üretilen Atık","sourceName":"Kaynak İsmi","writeSourceName":"Kaynak ismi yazınız","writeSourceInfo":"Kaynak bilgisi yazınız","disposalMethod":"İmha Etme Yöntemi","vehicleType":"Araç Tipi","transportMethod":"Ulaşım Yöntemi","type":"Tip","unit":"Birim","validFrom":"Geçerlilik Tarihi","calculationMethod":"Hesaplama Yöntemi","emissionFactorSource":"Emisyon Faktörü Kaynağı","source":"Kaynak","activity":"Aktivite","enabled":"Aktif","greenhouseGas":"Sera Gazı","start":"Başlangıç","emissionFactor":"Emisyon Faktörü","deleteConfirmTitle":"Kaynağı silmek istediğinize emin misiniz?","deleteConfirmText":"Onayladığınızda, bu kaynak ve veriler kalıcı olarak silinecek ve kurtarılamayacak.","addCustomFactor":"Özel katsayı ekle","hazardous":"Tehlikeli","sourceDesign":"Kaynak Dizaynı","editSourceDesign":"Kaynak Dizaynı Düzenle","header":"Başlık","required":"Zorunlu","editable":"Düzenlenebilir","longProcessNotification":"Bu işlem biraz zaman alabilir, lütfen bekleyin. İşlem tamamlandığında tablo otomatik olarak yenilenecektir.","normalizationType":"Hedef Normalizasyon Parametresi","area":"Alan","person":"Kişi Sayısı","Custom":"Özel Emisyon Faktörleri","ongoing":"Devam Ediyor","sourceInfoLoading":"Kaynak Bilgileri Yükleniyor...","emissionInfoNotification":"Emisyon değerleri ülke, bölge ve sektöre göre değişkenlik göstermektedir","duplicateSourceModalTitle":"Kaynak Tanımında Değişiklik","duplicateSourceModalText":"Yapılan değişiklikler bu kaynak için girilmiş olan verilerde değişiklik yapılmasına neden olabilir. Nasıl devam etmek istersiniz?","duplicateSourceBtn":"Yeni bir kaynak yarat","convertExistingSourceBtn":"Mevcut Kaynağı Değiştir","inactivateSourceModalTitle":"Eski Kaynağı Pasifleştirmek","inactivateSourceModalText":"Yapılan değişiklerle yeni bir kaynak oluşturup eski halini pasif kaynaklar altına taşımak istediğinize emin misiniz?","convertUnitsModalTitle":"Mevcut Kaynağı Değiştir","convertUnitsModalText":"Kaynak için daha önceden girilen verileri yeni seçimlere göre dönüştürmek istediğinize emin misiniz?","invalidUnits":"Seçilen birimler arası dönüşüm yapılamadığından bu işlemi gerçekleştiremiyoruz."},"en":{"Source":"Source","Activity":"Activity","Type":"Type","Location":"Location","disableYear":"Inactivation Year","selectActivity":"Select Activity","defineSources":"Define Sources","assignLocations":"Assign Locations","emissionFactors":"Emission Factors","selectActivityTitle":"What kind of activity is related to the source?","defineSourcesTitle":"Define Source","emissionFactorsTitle":"Greenhouse Gas Emission calculation parameters","next":"Next","back":"Back","purchasedEnergy":"Purchased Energy","stationaryCombustion":"Stationary Combustion","companyVehicles":"Company Vehicles","employeeCommuting":"Employee Commuting","businessTravel":"Business Travel","wasteGeneratedInOps":"Waste Generated in Operations","sourceName":"Source Name","writeSourceName":"Write source name","writeSourceInfo":"Write source information","disposalMethod":"Disposal Method","vehicleType":"Vehicle Type","transportMethod":"Transport Method","type":"Type","unit":"Unit","validFrom":"Valid From","calculationMethod":"Calculation Method","emissionFactorSource":"Emission Factor Source","source":"Source","activity":"Activity","enabled":"Enabled","greenhouseGas":"Greenhouse Gas","start":"Start","emissionFactor":"Emission Factor","deleteConfirmTitle":"Do you want to delete this source?","deleteConfirmText":"Once you confirm, this source and data will be permanently deleted and cannot be recovered.","addCustomFactor":"Add Custom Factor","hazardous":"Hazardous","sourceDesign":"Source Design","editSourceDesign":"Edit Source Design","header":"Header","required":"Required","editable":"Editable","longProcessNotification":"This process may take some time, please wait. When the process is complete, the table will be refreshed automatically.","normalizationType":"Intensity Target Parameter","area":"Area","person":"Number of Occupant","Custom":"Custom Emission Factors","ongoing":"Ongoing","sourceInfoLoading":"Loading Source Information...","emissionInfoNotification":"Emission values vary according to the country, region and sector","duplicateSourceModalTitle":"Change in Source Definition","duplicateSourceModalText":"Changes made may cause changes to the data entered for this resource. How would you like to continue?","duplicateSourceBtn":"Create new source","convertExistingSourceBtn":"Change this source","inactivateSourceModalTitle":"Deactivate Existing Source","inactivateSourceModalText":"Are you sure you want to create a new source according to the changes and deactivate existing source?","convertUnitsModalTitle":"Change this source","convertUnitsModalText":"Are you sure you want to transform the previously entered data according to the changes?","invalidUnits":"We cannot complete this operation due to unit conversion cannot be performed between selected units."}}')
}


/***/ }),

/***/ "pbXn":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"createAudit":"Yeni Denetim Tarihi Ekle","updateAudit":"Denetim Tarihi Güncelle","title":"Başlık","additionalFiles":"Ek Dosyalar","auditType":"Denetim Tipi","auditDate":"Denetim Tarihi","branch":"Denetim Yapılacak Lokasyon"},"en":{"createAudit":"Add New Audit Date","updateAudit":"Update Audit Date","title":"Title","additionalFiles":"Additional Files","auditType":"Audit Type","auditDate":"Audit Date","branch":"Locations for Audit"}}')
}


/***/ }),

/***/ "pkMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q3yw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__ = __webpack_require__("pB/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);


//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PerformanceComparing',
    components: {
        HorizontalBarChart: __WEBPACK_IMPORTED_MODULE_2__components_charts_HorizontalBarChart__["a" /* default */]
    },
    props: {
        comparingData: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        type: {
            type: String,
            default: function _default() {
                return 'emission';
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        }
    },
    data: function data() {
        var _this = this;

        return {
            barChartBest: {
                id: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                data: {
                    labels: [],
                    datasets: [{ backgroundColor: '#35f826', data: [] }],
                    generateUnit: function generateUnit() {
                        return _this.calculatedUnit;
                    },
                    getLocale: function getLocale() {
                        return _this.locale;
                    }
                },
                options: {
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    animation: {
                        duration: 500,
                        animateScale: true,
                        easing: 'easeOutQuint',
                        onComplete: function onComplete() {
                            var _this2 = this;

                            var chartInstance = this.chart;
                            var ctx = chartInstance.ctx;
                            ctx.textAlign = 'center';
                            ctx.fillStyle = 'rgba(49, 57, 54, 1)';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach(function (dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data ? __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(data, 'number', _this2.data.getLocale()) : '', bar._model.x + 10, bar._model.y + 6);
                                });
                            });
                        }
                    },
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0,
                                beginAtZero: true,
                                stepSize: 5,
                                max: 50
                            }
                        }],
                        yAxes: [{
                            maxBarThickness: 25,
                            display: true,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0,
                                autoSkip: false
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                if (label) {
                                    label += ': ';
                                }

                                return label + __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(Number(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2)), 'number', _this.locale) + (_this.bestDataUnit ? ' ' + _this.bestDataUnit : ' ' + _this.calculatedUnit);
                            }
                        }
                    }
                }
            },
            barChartWeakest: {
                id: __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()(),
                data: {
                    labels: [],
                    datasets: [{ backgroundColor: '#f87979', data: [] }],
                    generateUnit: function generateUnit() {
                        return _this.calculatedUnit;
                    },
                    getLocale: function getLocale() {
                        return _this.locale;
                    }
                },
                options: {
                    legend: {
                        display: false
                    },
                    maintainAspectRatio: false,
                    animation: {
                        duration: 500,
                        animateScale: true,
                        easing: 'easeOutQuint',
                        onComplete: function onComplete() {
                            var _this3 = this;

                            var chartInstance = this.chart;
                            var ctx = chartInstance.ctx;
                            ctx.textAlign = 'center';
                            ctx.fillStyle = 'rgba(49, 57, 54, 1)';
                            ctx.textBaseline = 'bottom';
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    var data = dataset.data[index]; /* + ` ${this.data.generateUnit()}`;*/
                                    ctx.fillText(data ? __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(data, 'number', _this3.data.getLocale()) : '', bar._model.x + 16, bar._model.y + 6);
                                });
                            });
                        }
                    },
                    scales: {
                        xAxes: [{
                            display: false,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0,
                                beginAtZero: true,
                                stepSize: 5,
                                max: 50
                            }
                        }],
                        yAxes: [{
                            maxBarThickness: 25,
                            display: true,
                            scaleFontSize: 15,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                min: 0,
                                fontSize: 10,
                                autoSkip: false
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            label: function label(tooltipItem, data) {
                                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                if (label) {
                                    label += ': ';
                                }

                                return label + __WEBPACK_IMPORTED_MODULE_3__filters__["a" /* default */].parseNumber(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index], 'number', _this.locale) + (_this.weakestDataUnit ? ' ' + _this.weakestDataUnit : ' ' + _this.calculatedUnit);
                            }
                        }
                    }
                }
            },
            multipleChart: false,

            bestDataUnit: null,
            weakestDataUnit: null,
            unitConverter: {
                "TJ": 1000,
                "PJ": 1000000,
                "GWh": 1000,
                "TWh": 1000000
            }
        };
    },

    methods: {
        configureCharts: function configureCharts(data) {
            if (data.length > 5) {
                this.multipleChart = true;
                var best = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.take(data, 5);
                var weakest = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.take(data.reverse(), 5);

                this.setWeakestUnitToFit(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(weakest));
                this.setBestUnitToFit(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.first(best));

                this.configureChart(weakest, 'barChartWeakest', this.weakestDataUnit);
                this.configureChart(best, 'barChartBest', this.bestDataUnit);
            } else {
                this.multipleChart = false;
                this.configureChart(data, 'barChartBest', this.bestDataUnit);
            }
        },
        setWeakestUnitToFit: function setWeakestUnitToFit(data) {
            var cValue = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, "value");
            switch (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, "unit")) {
                case "GJ":
                    if (cValue >= 1000000000) {
                        this.weakestDataUnit = "PJ";
                    } else if (cValue >= 1000000) {
                        this.weakestDataUnit = "TJ";
                    }
                    break;
                case "MWh":
                    if (cValue >= 1000000000) {
                        this.weakestDataUnit = "TWh";
                    } else if (cValue >= 1000000) {
                        this.weakestDataUnit = "GWh";
                    }
                    break;
                default:
                    this.weakestDataUnit = null;
                    break;
            }

            if (this.weakestDataUnit) {
                this.barChartWeakest.data.generateUnit = this.weakestDataUnit;
            }
        },
        setBestUnitToFit: function setBestUnitToFit(data) {
            var cValue = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, "value");
            switch (__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(data, "unit")) {
                case "GJ":
                    if (cValue >= 1000000000) {
                        this.bestDataUnit = "PJ";
                    } else if (cValue >= 1000000) {
                        this.bestDataUnit = "TJ";
                    }
                    break;
                case "MWh":
                    if (cValue >= 1000000000) {
                        this.bestDataUnit = "TWh";
                    } else if (cValue >= 1000000) {
                        this.bestDataUnit = "GWh";
                    }
                    break;
                default:
                    this.bestDataUnit = null;
                    break;
            }

            if (this.weakestDataUnit) {
                this.barChartBest.data.generateUnit = this.bestDataUnit;
            }
        },
        configureChart: function configureChart(data, type, cUnit) {
            var _this4 = this;

            this[type].data.labels = [];
            this[type].data.datasets[0].data = [];
            data.forEach(function (element) {
                element.value = element.value ? cUnit ? element.value / _this4.unitConverter[cUnit] : element.value : 0;
                var foundName = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(_this4.sites, { id: element.siteId }).originalName;
                _this4[type].data.labels.push(foundName);
                _this4[type].data.datasets[0].data.push(Number(element.value.toFixed(0)));
                if (cUnit) {
                    element.unit = cUnit;
                }
            });
            var max = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.max(this[type].data.datasets[0].data);
            this[type].options.scales.xAxes[0].ticks.max = max + max * 0.15;
            this.$eventHub.$emit(this[type].id);
        },
        filterData: function filterData(data) {
            if (this.type === 'intensity') {
                var _data = data,
                    _data2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_data, 2),
                    emissions = _data2[0],
                    staffs = _data2[1];

                data = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.reduce(emissions, function (newData, emission) {
                    var found = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.find(staffs, { id: emission.siteId });
                    if (found && found.count !== 0) {
                        newData.push({
                            siteId: emission.siteId,
                            value: emission.value / found.count
                        });
                    }
                    return newData;
                }, []);
                data = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.orderBy(data, 'value', 'asc');
            }
            data = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.filter(data, function (datum) {
                if (Number(datum.value.toFixed(0)) !== 0) {
                    return datum;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(data);
        },
        totalStaffCount: function totalStaffCount(site) {
            var property = this.getLastFilledProperty(site, 'staffCount');
            return property && property.staffCount ? property.staffCount : 0;
        },
        processPerformanceComparing: function processPerformanceComparing(data) {
            this.filterData(data).then(this.configureCharts);
        }
    },
    watch: {
        comparingData: function comparingData(data) {
            this.processPerformanceComparing(data);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processPerformanceComparing(this.comparingData);
        }
    },
    computed: {
        calculatedUnit: function calculatedUnit() {
            if (this.type === 'intensity') {
                return this.$t('tonssquaremeter');
            } else if (this.type === 'emission') {
                return this.$t('tons');
            } else if (this.type === 'consumption') {
                return this.$t('mwh');
            } else {
                return '';
            }
        }
    },
    mounted: function mounted() {
        this.processPerformanceComparing(this.comparingData);
    }
});

/***/ }),

/***/ "qHzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("h+W8");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b85b25de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__ = __webpack_require__("Pbpk");
function injectStyle (ssrContext) {
  __webpack_require__("Yru4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b85b25de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b85b25de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SwappingSquaresSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "qKCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__ = __webpack_require__("rgAQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e9e9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__ = __webpack_require__("yZ0E");
function injectStyle (ssrContext) {
  __webpack_require__("POGD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40e9e9a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e9e9a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qKds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'error',
    created: function created() {
        this.$router.push({ name: 'error' });
    }
});

/***/ }),

/***/ "qMXs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qeYM":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"headerTitle":"DENETİM","auditTitle":"Bir denetim tipi seçin","auditType":"Düzeltici Aksiyon Maddesi","auditTypeGaranti":"Uygunsuzluk Maddesi","actionType":"Önleyici Aksiyon Maddesi","actionTypeGaranti":"Aksiyon Planı","auditDateColumn":"Denetim Tarihi","statusColumn":"Durum","openTicket":"Açık","closedTicket":"Kapalı","ticketType":"Denetim maddesi tipi","Audit":"Düzeltici Faaliyet","AuditGaranti":"Uygunsuzluk Maddesi","Action":"Önleyici Faaliyet","ActionGaranti":"Aksiyon Planı","all":"Hepsi"},"en":{"headerTitle":"AUDITS","auditTitle":"Choose one of the audit type","auditType":"Corrective Action Type","auditTypeGaranti":"Corrective Action","actionType":"Preventive Action Type","actionTypeGaranti":"Action Plan","auditDateColumn":"Audit Date","statusColumn":"Action Status","openTicket":"Open","closedTicket":"Closed","ticketType":"Action Type","Audit":"Corrective Action","Action":"Preventive Action","all":"All","AuditGaranti":"Corrective Action","ActionGaranti":"Action plan"}}')
}


/***/ }),

/***/ "qi7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Site_vue__ = __webpack_require__("12Ma");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495f26de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Site_vue__ = __webpack_require__("+LLb");
function injectStyle (ssrContext) {
  __webpack_require__("QI4E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-495f26de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Site_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_495f26de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Site_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("PcT9")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r/kn":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"userManagement":"Kullanıcı Yönetimi","activeUsers":"Aktif Kullanıcılar","disabledUsers":"Engelli Kullanıcılar","pendingInvitations":"Bekleyen Davetler","user":"Kullanıcılar","job/department":"Ünvan/Departman","roles":"Kullanıcı Grupları","singup-date":"Kayıt Tarihi","last-login-date":"Son Çevrimiçi","disable-date":"Engellenme Tarihi","invite-date":"Davet Tarihi","inviteUser":"Kullanıcı Davet Et","disableUser":"Kullanıcıyı Engelle","deleteUser":"Kullanıcıyı Sil","enableUser":"Kullanıcıyı Etkinleştir","noDisabledUser":"Engellenmiş Kullanıcı Yok","canDisableFrom":" ","canDisableFrom-p2":"sekmesinde yer alan \u0027kullanıcıyı engelle\u0027 butonu ile istediğiniz kullanıcıları engelleyebilirsiniz.","noPendingInvitation":"Henüz iş arkadaşlarınızı davet etmediniz!","canInviteUserFromBelow":"Aşağıdaki butonu kullanarak kullanıcıları davet edebilirsiniz","reInvite":"Tekrar Davet Et","cancelInvite":"Davetiyeyi İptal Et","alreadyEnteredEmail":"Bu email zaten girildi","nonEmailInput":"Geçersiz email adresi:","emptyEmailInput":"Lütfen en az bir e-posta adresi girin","sendInvite":"Davet Gönder","add":"Ekle","afterInvitePermCanBeEdit":"Kullanıcıları davet ettikten sonra, kullanıcı izinlerini değiştirebileceksiniz.","accessMaxInvitationLimit":"Bu kullanıcılar izin verilen maksimum davet sayısına ulaştı","errorOnSendInvite":"Davetiyeler gönderilirken hata oluştu","invitesSended":"Seçili kullanıcılar için yeni davet mailleri gönderildi.","rejectedWhileSendingInvite":"Bu kullanıcılar zaten kayıtlı veya 4 defadan fazla davet edildi","cantDisableSelf":"Kendinizi engelleyemezsiniz","cantDeleteSelf":"Kendinizi silemessiniz","email":"E-posta","emailIsRequired":"E-posta gerekli"},"en":{"userManagement":"User Management","activeUsers":"Active Users","disabledUsers":"Disabled Users","pendingInvitations":"Pending Invitations","user":"Users","job/department":"Job Title/Department","roles":"Roles","singup-date":"Signup Date","last-login-date":"Last Login","disable-date":"Disable On","invite-date":"Invitation Date","inviteUser":"Invite User","disableUser":"Disable User","deleteUser":"Delete User","enableUser":"Enable User","noDisabledUser":"No disabled user accounts","canDisableFrom":"You can disable user accounts from the","canDisableFrom-p2":" ","noPendingInvitation":"You haven\u0027t invited your colleagues yet!","canInviteUserFromBelow":"Use button below to invite a new user.","reInvite":"Reinvite","cancelInvite":"Cancel Invitation","alreadyEnteredEmail":"This email has already been entered","nonEmailInput":"Invalid email address:","emptyEmailInput":"Please enter at least one e-mail address","sendInvite":"Send Invite","add":"Add","afterInvitePermCanBeEdit":"After inviting users, you will be able to change user permissions.","accessMaxInvitationLimit":"These users have reached the maximum number of invites allowed","errorOnSendInvite":"Error occurred while sending invitations","invitesSended":"New invitation mails have been sent for selected users.","rejectedWhileSendingInvite":"These users are already registered or invited more than 4 times","cantDisableSelf":"You can\u0027t disable yourself","cantDeleteSelf":"You can\u0027t delete yourself","email":"Email","emailIsRequired":"Email is required"}}')
}


/***/ }),

/***/ "r2Ve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r7+X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8Mc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SelfBuildingSquareSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 6000
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      squaresNum: 9
    };
  },


  computed: {
    squareSize: function squareSize() {
      return this.size / 4;
    },
    initialTopPosition: function initialTopPosition() {
      return -this.squareSize * 2 / 3;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        top: -this.initialTopPosition + 'px',
        height: this.size + 'px',
        width: this.size + 'px'
      };
    },
    squareStyle: function squareStyle() {
      return {
        height: this.squareSize + 'px',
        width: this.squareSize + 'px',
        top: this.initialTopPosition + 'px',
        marginRight: this.squareSize / 3 + 'px',
        marginTop: this.squareSize / 3 + 'px',
        animationDuration: this.animationDuration + 'ms',
        background: this.color
      };
    },
    squaresStyles: function squaresStyles() {
      var squaresStyles = [];
      var delaysMultipliers = [6, 7, 8, 3, 4, 5, 0, 1, 2];
      var delayModifier = this.animationDuration * 0.05;

      for (var i = 0; i < this.squaresNum; i++) {
        squaresStyles.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: delayModifier * delaysMultipliers[i] + 'ms'
        }, this.squareStyle));
      }

      return squaresStyles;
    }
  }
});

/***/ }),

/***/ "rKvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);

var months = ['OCA', 'ŞUB', 'MAR', 'NİS', 'MAY', 'HAZ', 'TEM', 'AĞU', 'EYL', 'EKİ', 'KAS', 'ARA'];
var monthsEn = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AGU', 'SEP', 'OCT', 'NOV', 'DEC'];



months = localStorage.getItem('locale') === 'tr' ? months : monthsEn;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        var _this = this;

        return {
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Karbon Emisyonu',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                layout: {
                    padding: {
                        top: 100,
                        left: 10,
                        bottom: 10,
                        right: 10
                    }
                },
                responsive: true,
                title: {
                    display: false,
                    text: 'Toplam Karbon Emisyonları',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint'
                },
                legend: {
                    position: 'right',
                    labels: {
                        padding: 20,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                    }
                }
            },
            colorPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            colorPaletteHalfOpacity: ['rgba(250,164,58,0.5)', 'rgba(96,189,104,0.5)', 'rgba(247,82,133,0.5)', 'rgba(93,165,218,0.5)', 'rgba(222,207,63,0.5)', 'rgba(178,118,178,0.5)', 'rgba(77,77,77,0.5)', 'rgba(178,145,47,0.5)', 'rgba(222,207,63,0.5)', 'rgba(241,88,84,0.5)'],
            consumptions: {}
        };
    },

    methods: {
        generateBarChartOptions: function generateBarChartOptions() {
            var _this2 = this;

            this.chartDataTypes.forEach(function (dataType, index) {
                var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.$store.state.sourceTypes, { id: dataType });
                var unit = null;
                switch (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(found, 'name')) {
                    case 'blueWater':
                        unit = 'm³';
                        break;
                    case 'electricity':
                        unit = 'kWh';
                        break;
                    case 'naturalGas':
                        unit = 'm³';
                        break;
                }
                _this2.$set(_this2.consumptions, dataType, {
                    title: _this2.$t(found.name) + '  ' + _this2.$t('consumptions'),
                    current: [],
                    previous: [],
                    chartId: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
                    barChartData: {
                        datasets: [{
                            label: _this2.$store.state.year - 1,
                            mainTitle: _this2.$t(found.name),
                            backgroundColor: _this2.colorPaletteHalfOpacity[index % 3],
                            hoverBackgroundColor: _this2.colorPaletteHalfOpacity[index % 3],
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            yAxisID: 'a',
                            type: 'bar',
                            unit: unit
                        }, {
                            label: _this2.$store.state.year,
                            mainTitle: _this2.$t(found.name),
                            backgroundColor: _this2.colorPalette[index % 3],
                            hoverBackgroundColor: _this2.colorPalette[index % 3],
                            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                            yAxisID: 'a',
                            type: 'bar',
                            unit: unit
                        }]
                    },
                    barChartOptions: {
                        steppedLine: false,
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: {
                            position: 'bottom',
                            display: false
                        },
                        title: {
                            display: false
                        },
                        barValueSpacing: 20,
                        scales: {
                            yAxes: [{
                                id: 'a',
                                display: true,
                                scaleLabel: {
                                    display: true,
                                    labelString: unit
                                },
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 100000,
                                    display: true,
                                    callback: function callback(tick) {
                                        return __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].parseNumber(tick, 'number', _this2.locale);
                                    }
                                },
                                gridLines: {
                                    display: false,
                                    color: 'rgba(154, 167, 177, 0.5)',
                                    lineWidth: 1
                                }
                            }],
                            xAxes: [{
                                type: 'category',
                                categoryPercentage: 0.5,
                                maxBarThickness: 20,
                                ticks: {
                                    autoSkip: false
                                },
                                labels: months,
                                gridLines: {
                                    display: false
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function label(tooltipItem, data) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    label += __WEBPACK_IMPORTED_MODULE_0__filters__["a" /* default */].parseNumber(tooltipItem.yLabel, 'float', _this2.$store.state.locale);
                                    label += ' ' + unit;
                                    return label;
                                }
                            }
                        }
                    }
                });
            });
        }
    }
});

/***/ }),

/***/ "rO5E":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"chooseDataList":"Bir veri listesi seçin","data":"Kaynak harcamaları","dataType":"Veri tipleri","dataEntry":"Lokasyon veri tipleri","deletedDataType":"Silinmiş veri tipleri","form":"Formlar","formData":"Form detayları","goal":"Hedefler","site":"Lokasyonlar","document":"Dokümanlar","audit":"Denetimler","user":"Kullanıcılar","siteUser":"Lokasyon kullanıcıları","userPerm":"Kullanıcı yetkileri","unitPrice":"Birim fiyatlar","emissionFactor":"Emisyon faktörleri","log":"Kayıtlar","integrationUser":"Entegrasyon kullanıcıları","ikonLog":"Entegrasyon Kayıtları","invite":"Davet Et","choose-analysis-unit":"Enerji Kaynakları için Raporlama Birimi"},"en":{"chooseDataList":"Choose a data list","data":"Data consumptions","dataType":"Data types","deletedDataType":"Deleted data types","dataEntry":"Data types of site","form":"Forms","formData":"Form details","goal":"Goals","site":"Sites","document":"Documents","audit":"Audits","user":"Users","siteUser":"Site users","userPerm":"User permissions","unitPrice":"Unit prices","emissionFactor":"Emission factors","log":"Log","integrationUser":"Integration users","ikonLog":"Integration log","invite":"Invite","choose-analysis-unit":"Reporting Unit for Energy Sources"}}')
}


/***/ }),

/***/ "rQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Carousel: __WEBPACK_IMPORTED_MODULE_0__components_Carousel_vue__["a" /* default */] },
    name: 'ResetPassword',
    data: function data() {
        return {
            user: {
                id: null,
                email: null,
                uuid: null,
                password: null,
                passwordConfirmation: null
            },
            passwordError: false,
            passwordErrorType: null,
            showPassword: false,
            showPasswordConfirmation: false,
            uuid: null,
            err: null,
            title: 'Carbon Intelligence',
            logoImg: '../../static/background.jpg',
            showLogo: false,
            hideCarousel: false
        };
    },

    methods: {
        isValid: function isValid() {
            this.passwordError = !this.user.password;
            this.passwordErrorType = this.passwordError ? 'passwordEmptyValidationError' : null;
            if (!this.passwordError) {
                this.passwordError = this.user.password.length < 7;
                this.passwordErrorType = 'passwordLengthError';
            }
            if (!this.passwordError) {
                this.passwordError = !this.isPasswordValid(this.user.password);
                this.passwordErrorType = 'passwordNotValidError';
            }
            if (!this.passwordError) {
                this.passwordError = !this.isPasswordsMatch(this.user.password, this.user.passwordConfirmation);
                this.passwordErrorType = 'passwordsDoNotMatch';
            }

            return !this.passwordError;
        },
        isPasswordValid: function isPasswordValid(password) {
            if (password) {
                return this.user.password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/);
            }
        },
        isPasswordsMatch: function isPasswordsMatch(password, passwordConfirmation) {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(password, passwordConfirmation);
        },
        switchPasswordVisibility: function switchPasswordVisibility(id) {
            id == 'password' ? this.showPassword = !this.showPassword : this.showPasswordConfirmation = !this.showPasswordConfirmation;
            var passwordField = document.querySelector('#' + id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text');else passwordField.setAttribute('type', 'password');
        },
        resetPassword: function resetPassword() {
            var _this = this;

            if (this.isValid()) {
                this.$Progress.start();
                return this.axios.post('/resetPassword', { user: this.user }).then(function () {
                    _this.$router.push({ path: '/login', query: { passwordResetInfo: false } });
                    _this.$Progress.finish();
                    return true;
                }).catch(function (err) {
                    _this.err = err;
                    _this.$Progress.finish();
                });
            }
        },
        init: function init() {
            var _this2 = this;

            return this.axios.get('/resetPassword/' + this.uuid).then(function (_ref) {
                var data = _ref.data;

                _this2.user.id = data.id;
                _this2.user.email = data.email;
                _this2.user.uuid = data.uuid;
                _this2.isLoaded = true;
            }).catch(function (err) {
                _this2.err = err;
                _this2.$router.push({ path: '/login' });
                _this2.$message({
                    type: 'error',
                    message: _this2.$t('invalidLink')
                });
            });
        },
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created: function created() {
        this.uuid = this.route.query.uuid;
        this.onResize();
        this.init();
    },
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.logoImg = '../../static/garanti.png';
            this.title = 'titleGaranti';
            this.showLogo = true;
            this.hideCarousel = true;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    }
});

/***/ }),

/***/ "rWr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rYYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.$store.state.isTablet)?_c('div',[_c('b-row',{staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(_vm.getSiteName(this.selectedSite.id))+"\n            ")])]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"300px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('searchRecord'),"type":"text"},on:{"input":_vm.filterAudits},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)])],1)],1):_c('div',[_c('b-row',{staticClass:"mt-2 mb-4",attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"}},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.getSiteName(this.selectedSite.id))+"\n                    ")])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"9","sm":"9","md":"7","lg":"5","xl":"6"}},[_c('b-row',{attrs:{"align-h":"end","no-gutters":""}},[_c('year-select',{staticStyle:{"margin-right":"15px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":this.$store.state.sites},on:{"oninput":_vm.selectSiteId}}),_vm._v(" "),_c('b-col',{staticStyle:{"margin-left":"-5px"}},[_c('b-form-select',{staticClass:"gray-select",staticStyle:{"height":"41px !important"},on:{"change":function($event){return _vm.selectAuditType($event)}},model:{value:(_vm.selectedAuditType),callback:function ($$v) {_vm.selectedAuditType=$$v},expression:"selectedAuditType"}},_vm._l((_vm.auditTypes),function(auditType){return _c('option',{key:auditType.type,domProps:{"value":auditType.type}},[_vm._v(_vm._s(auditType.name))])}),0)],1),_vm._v(" "),_c('div',{staticClass:"placeholder-color-white",staticStyle:{"width":"130px","margin-left":"5px"}},[_c('b-form-input',{staticClass:"gray-input",staticStyle:{"margin-left":"10px"},attrs:{"placeholder":_vm.$t('searchRecord'),"type":"text"},on:{"input":_vm.filterAudits},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll-content mt-3",staticStyle:{"margin-top":"15px"}},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em","border-collapse":"separate","border-spacing":"0"}},[_c('thead',{staticStyle:{"position":"sticky","background-color":"white","top":"0px","z-index":"2"}},[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.user.permissions.canCreateAudit),expression:"this.$store.state.user.permissions.canCreateAudit"}],staticClass:"insert-row",on:{"click":function($event){return _vm.insertRow($event.target,'createDetail')}}},[_c('td',{attrs:{"colspan":6}},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{staticStyle:{"position":"absolute","left":"0","top":"auto","right":"0","margin":"auto","z-index":"100px"}},[_c('i',{staticClass:"fas fa-plus-circle fa-2x"})])])])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"20em"}},[_vm._v(_vm._s(_vm.$t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"20em"}},[_vm._v(_vm._s(_vm.$t('auditType')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"20em"}},[_vm._v(_vm._s(_vm.$t(this.getGroupName('agent'))))]),_vm._v(" "),_c('th',{staticStyle:{"width":"20em"}},[_vm._v(_vm._s(_vm.$t('auditDate')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"20em"}},[_vm._v(_vm._s(_vm.$t('document')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredAudits),function(audit,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"color":"#007bff"}},[_vm._v(_vm._s(audit.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getAuditType(audit.type)))]),_vm._v(" "),(_vm.selectedSite.agents)?_c('td',_vm._l((_vm.selectedSite.agents),function(agent,index){return _c('span',{key:index},[_c('router-link',{attrs:{"to":{name: 'user-profile', params: {user_id: _vm.selectedSite.agentIds[index]}}}},[_vm._v(_vm._s(agent ? agent : '-')+" ")])],1)}),0):_c('td',[_vm._v("\n                        -\n                    ")]),_vm._v(" "),(audit.audit_date)?_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(audit.audit_date,'YYYY-MM-DD')))]):_c('td',[_vm._v("-")]),_vm._v(" "),(audit.files.length)?_c('td',[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.auditFiles",modifiers:{"auditFiles":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('Documents')},on:{"click":function($event){return _vm.showAuditFiles(audit.files, $event.target)}}},[_c('i',{staticClass:"fas fa-file-alt"})])],1):_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',{staticClass:"audit-record-edit-buttons"},[_c('div',{staticClass:"tableBodyCell"},[_c('div',{key:'btngroup',staticClass:"table-button-group table-cell"},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"box-shadow":"none"},attrs:{"title":_vm.$t('edit')},on:{"click":function($event){return _vm.updateRow($event.target, audit, 'update')}}},[_c('i',{staticClass:"fas fa-edit"})]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"box-shadow":"none"},attrs:{"title":_vm.$t('delete'),"variant":"danger"},on:{"click":function($event){return _vm.deleteAudit(audit, $event)}}},[_c('i',{staticClass:"fas fa-trash-alt"})])],1)])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rYry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"position":"sticky","top":"70px","z-index":"2"}},[_c('b-row',{attrs:{"align-h":"between"}},[[_c('b-col',{attrs:{"md":"2"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('data-type')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.selectedDataType),callback:function ($$v) {_vm.selectedDataType=$$v},expression:"selectedDataType"}},_vm._l((_vm.getDataTypes()),function(dataType){return _c('option',{key:dataType.id,ref:'dataType',refInFor:true,domProps:{"value":dataType.id}},[_vm._v("\n                                "+_vm._s(dataType.name + dataType.unit)+"\n                                ")])}),0)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('reporting-period')))])]),_vm._v(" "),_c('b-row',[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"monthrange","format":"MMM yyyy","align":"right","unlink-panels":"","range-separator":"-","picker-options":_vm.pickerOptions},model:{value:(_vm.reportDateRange),callback:function ($$v) {_vm.reportDateRange=$$v},expression:"reportDateRange"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('comparing-period')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.compareDateRange),callback:function ($$v) {_vm.compareDateRange=$$v},expression:"compareDateRange"}},_vm._l((_vm.comparableDateRanges),function(dateRange){return _c('option',{key:dateRange.id,ref:'dateRange',refInFor:true,domProps:{"value":dateRange.id}},[_vm._v("\n                                    "+_vm._s(dateRange.name)+"\n                                ")])}),0)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('normalization-parameter')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.normalizationType),callback:function ($$v) {_vm.normalizationType=$$v},expression:"normalizationType"}},_vm._l((_vm.normalizationTypes),function(normalization){return _c('option',{key:normalization.id,ref:'normalization',refInFor:true,domProps:{"value":normalization.id}},[_vm._v("\n                                    "+_vm._s(normalization.name)+"\n                                ")])}),0)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('site-type')))])]),_vm._v(" "),_c('b-row',[(_vm.allSiteTypes.length)?_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.selectedTypeId),callback:function ($$v) {_vm.selectedTypeId=$$v},expression:"selectedTypeId"}},_vm._l((_vm.allSiteTypes),function(siteType){return _c('option',{key:siteType.id,ref:'siteType',refInFor:true,domProps:{"value":siteType.id}},[_vm._v("\n                                    "+_vm._s(_vm.$t(siteType.name))+"\n                                ")])}),0):_vm._e()],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('regionTitle')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.selectedRegionId),callback:function ($$v) {_vm.selectedRegionId=$$v},expression:"selectedRegionId"}},_vm._l((_vm.regions),function(region){return _c('option',{key:region.id,ref:'region',refInFor:true,domProps:{"value":region.id}},[_vm._v("\n                                    "+_vm._s(region.display_name)+"\n                                ")])}),0)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-row',[_c('span',[_vm._v(_vm._s(_vm.$t('Site')))])]),_vm._v(" "),_c('b-row',[_c('b-form-select',{staticStyle:{"width":"100%"},model:{value:(_vm.selectedSiteId),callback:function ($$v) {_vm.selectedSiteId=$$v},expression:"selectedSiteId"}},[(_vm.filteredSites.length>0)?_c('option',{domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('all')))]):_c('option',{domProps:{"value":null}},[_vm._v("-")]),_vm._v(" "),_vm._l((_vm.filteredSites),function(site){return _c('option',{key:site.id,ref:'site',refInFor:true,domProps:{"value":site.id}},[_vm._v("\n                                    "+_vm._s(site.name)+"\n                                ")])})],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"1"}},[_c('b-row',[(_vm.isFiltering)?_c('span',[_vm._v(_vm._s(_vm.$t('filtering')))]):_c('span',[_vm._v(_vm._s(_vm.$t('filter')))])]),_vm._v(" "),_c('b-row',[(_vm.isFiltering)?[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:1,attrs:{"title":_vm.$t('filtering'),"disabled":true}},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"})])]:[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:2,attrs:{"title":_vm.$t('filter'),"disabled":!_vm.isFilterable()},on:{"click":function($event){return _vm.getFilteredData()}}},[_c('i',{staticClass:"fas fa-filter"})])]],2)],1)]],2),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"50px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>0),expression:"items.length>0"}],staticStyle:{"width":"100%","height":"30%"}},[_c('bar-chart',{attrs:{"chart-data":_vm.barChartData,"options":_vm.barChartOptions,"chart-id":_vm.barChartId}})],1)]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"50px","text-align":"right","float":"right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>0),expression:"items.length>0"}]},[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticStyle:{"background-color":"rgba(76, 175, 80, 0)","color":"#000"},attrs:{"title":_vm.$t('download'),"disabled":_vm.isDownloading},on:{"click":function($event){return _vm.downloadExcel()}}},[_c('i',{staticClass:"fas fa-file-excel"})])],1)]),_vm._v(" "),_c('b-row',{staticStyle:{"margin-top":"100px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length>0),expression:"items.length>0"}],staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',[_c('tr',[_c('th',{class:_vm.sortedClass('location'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('location')}}},[_vm._v(_vm._s(_vm.$t('Location')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('site-type'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('site-type')}}},[_vm._v(_vm._s(_vm.$t('site-type')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('region'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('region')}}},[_vm._v(_vm._s(_vm.$t('regionTitle')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('area'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('area')}}},[_vm._v(_vm._s(_vm.$t('areaTitle')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('numberOfStaff'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('numberOfStaff')}}},[_vm._v(_vm._s(_vm.$t('numberOfStaff')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('dt1'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('dt1')}}},[_vm._v(_vm._s(_vm.dataType1Title)),_c('br'),_vm._v(_vm._s(_vm.dataType1TitlePart2))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('dt2'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('dt2')}}},[_vm._v(_vm._s(_vm.dataType2Title)),_c('br'),_vm._v(_vm._s(_vm.dataType2TitlePart2))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('diffrence'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('diffrence')}}},[_vm._v(_vm._s(_vm.$t('diffrence')))]),_vm._v(" "),_c('th',{class:_vm.sortedClass('diffrenceRatio'),staticStyle:{"width":"10em","text-align":"center"},on:{"click":function($event){return _vm.sortBy('diffrenceRatio')}}},[_vm._v(_vm._s(_vm.$t('diffrence')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t(item.type)))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(item.region))]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s((item.reportingData.properties.area))+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s((item.reportingData.properties.staff))+"\n                            ")]),_vm._v(" "),_c('td',{attrs:{"title":(item.reportingData.total.consumption ? (item.reportingData.total.consumption + ' ' + item.normalizedUnit) : 0)}},[_vm._v("\n                                "+_vm._s(item.reportingData.total.consumption ? (item.reportingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-")+"\n                            ")]),_vm._v(" "),_c('td',{attrs:{"title":(item.comparingData.total.consumption ? (item.comparingData.total.consumption + ' ' + item.normalizedUnit) : 0)}},[_vm._v("\n                                "+_vm._s(item.comparingData.total.consumption ? (item.comparingData.total.consumption.toFixed(2) + ' ' + item.normalizedUnit) : "-")+"\n                            ")]),_vm._v(" "),_c('td',{style:(item.style),attrs:{"title":item.change.consumptionChange}},[_vm._v("\n                                "+_vm._s((item.change.consumptionChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? item.change.consumptionChange.toFixed(2) + ' ' + item.normalizedUnit : "-")+"\n                            ")]),_vm._v(" "),_c('td',{style:(item.style),attrs:{"title":item.change.consumptionRationChange + '%'}},[_vm._v("\n                                "+_vm._s((item.change.consumptionRationChange && item.reportingData.total.consumption && item.comparingData.total.consumption) ? (item.change.consumptionRationChange.toFixed(0) + "%") : "-")+"\n                            ")])])}),0)])])])],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rgAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Transfer',
    props: {
        sourceTitle: {
            type: String,
            default: "All Sources"
        },
        targetTitle: {
            type: String,
            default: "All Targets"
        },
        isSearch: {
            type: Boolean,
            default: true
        },
        outBtnText: {
            type: String,
            default: ""
        },
        inBtnText: {
            type: String,
            default: ""
        },
        searchPlaceholder: {
            type: String,
            default: "Search"
        },
        options: {
            type: Array,
            default: []
        },
        selected: {
            type: Array,
            default: []
        },
        minSearchLength: {
            type: Number,
            default: 3
        }
    },
    data: function data() {
        return {
            sourceData: [],
            targetData: [],
            checkAllSource: false,
            checkAllTarget: false,
            sourceCheckedData: [],
            targetCheckedData: [],
            isIndeterminateSource: false,
            isIndeterminateTarget: false,
            currentLeftPage: 1,
            currentRightPage: 1,
            perPage: 8,
            searchLeftInput: "",
            searchRightInput: "",
            filteredSourceData: [],
            filteredTargetData: [],
            leftLoading: true,
            rightLoading: true
        };
    },

    methods: {
        getPagedData: function getPagedData(data, currentPage) {
            return data.slice((currentPage - 1) * this.perPage, currentPage * this.perPage);
        },
        sourceAllCheckChange: function sourceAllCheckChange(val) {
            this.sourceCheckedData = val ? this.filteredSourceData : [];
        },
        targetAllCheckChange: function targetAllCheckChange(val) {
            this.targetCheckedData = val ? this.filteredTargetData : [];
        },
        sourceEachCheckedChange: function sourceEachCheckedChange() {
            this.checkAllSource = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.sourceData) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.sourceCheckedData);
            this.isIndeterminateSource = !this.checkAllSource && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.sourceCheckedData);
        },
        targetEachCheckedChange: function targetEachCheckedChange() {
            this.checkAllTarget = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.targetData) == __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.targetCheckedData);
            this.isIndeterminateTarget = !this.checkAllTarget && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEmpty(this.targetCheckedData);
        },
        onSearch: function onSearch(val) {
            var isLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (val.length >= this.minSearchLength) {
                if (isLeft) {
                    this.filteredSourceData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.sourceData, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(val));
                    });
                } else {
                    this.filteredTargetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.targetData, function (o) {
                        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(val));
                    });
                }
            } else {
                if (isLeft) {
                    this.filteredSourceData = this.sourceData;
                } else {
                    this.filteredTargetData = this.targetData;
                }
            }
        },
        targetToSource: function targetToSource() {
            var removalIds = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.targetCheckedData, 'id');
            this.targetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.targetData, function (o) {
                return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(removalIds, o.id);
            });
            this.targetCheckedData = [];
            this.checkAllTarget = false;
            this.isIndeterminateTarget = false;
        },
        sourceToTarget: function sourceToTarget() {
            this.targetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.concat(this.targetData, this.sourceCheckedData);
            this.sourceCheckedData = [];
            this.checkAllSource = false;
            this.isIndeterminateSource = false;
        },
        onChange: function onChange() {
            var _this = this;

            var targetIds = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(this.targetData, 'id');
            this.sourceData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.options), function (o) {
                return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(targetIds, o.id);
            });
            this.filteredSourceData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.sourceData, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(_this.searchLeftInput));
            });
            this.filteredTargetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.targetData, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(_this.searchRightInput));
            });
            this.$emit("onChange", targetIds);
        },
        pageChange: function pageChange(val) {
            var isLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (isLeft) {
                this.currentLeftPage = val;
            } else {
                this.currentRightPage = val;
            }
        },
        resizePagination: function resizePagination(val) {
            this.pageSize = val;
            this.currentLeftPage = 1;
            this.currentRightPage = 1;
        },
        init: function init() {
            var _this2 = this;

            this.sourceData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.options), function (o) {
                return !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(_this2.selected, o.id);
            });
            this.targetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.options), function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(_this2.selected, o.id);
            });
            this.filteredSourceData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.sourceData, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(_this2.searchLeftInput));
            });
            this.filteredTargetData = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.targetData, function (o) {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(o.label), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.lowerCase(_this2.searchRightInput));
            });
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
        }
    },
    watch: {
        targetData: function targetData() {
            this.onChange();
        },
        selected: function selected(val) {
            if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(this.targetData) != __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(val)) {
                this.init();
            }
        }
    },
    created: function created() {
        var _this3 = this;

        this.init().then(function () {
            _this3.leftLoading = false;
            _this3.rightLoading = false;
        });
    }
});

/***/ }),

/***/ "rgYo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"createGoal",attrs:{"id":"createGoal","size":"lg","top":"","title":_vm.$t(_vm.postTitle)},on:{"show":_vm.onShow}},[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('dataTypeColumn'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{class:Object.assign({'is-invalid':_vm.formGroupInput1Warn}),attrs:{"options":_vm.allDataTypes,"disabled":_vm.inProgress || _vm.removingProcess},on:{"change":function($event){return _vm.configureItemOnDataTypeChange($event, _vm.goal)}},model:{value:(_vm.selectedGoal.dataTypeId.editedValue),callback:function ($$v) {_vm.$set(_vm.selectedGoal.dataTypeId, "editedValue", $$v)},expression:"selectedGoal.dataTypeId.editedValue"}},[_c('option',{attrs:{"disabled":""},domProps:{"value":null}},[_vm._v(_vm._s(_vm.$t('choose-data-type')))])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('startYearColumn'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.startYearChoices,"disabled":_vm.inProgress || _vm.removingProcess},on:{"change":function($event){return _vm.setSelectedBaseYear($event)}},model:{value:(_vm.selectedGoal.startYear.editedValue),callback:function ($$v) {_vm.$set(_vm.selectedGoal.startYear, "editedValue", $$v)},expression:"selectedGoal.startYear.editedValue"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('endYearColumn'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticStyle:{"border-radius":"unset !important","height":"100%"},attrs:{"options":_vm.yearChoices.endYearChoices,"disabled":_vm.inProgress || _vm.removingProcess},on:{"change":function($event){return _vm.setSelectedEndYear($event)}},model:{value:(_vm.selectedGoal.endYear.editedValue),callback:function ($$v) {_vm.$set(_vm.selectedGoal.endYear, "editedValue", $$v)},expression:"selectedGoal.endYear.editedValue"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('goalTypeColumn'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{attrs:{"disabled":_vm.inProgress || _vm.removingProcess},model:{value:(_vm.selectedGoal.direction.editedValue),callback:function ($$v) {_vm.$set(_vm.selectedGoal.direction, "editedValue", $$v)},expression:"selectedGoal.direction.editedValue"}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$t('currentSituation')))]),_vm._v(" "),_c('option',{domProps:{"value":-1}},[_vm._v(_vm._s(_vm.$t('decrease')))]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v(_vm._s(_vm.$t('raise')))])])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('goalRatioColumn'))+"\n        ")]),_vm._v(" "),_c('b-col',[_c('masked-input',{class:Object.assign(_vm.selectedGoal['valueR'].classes, {'masked-input-custom': true}),attrs:{"keepCharPositions":false,"pipe":_vm.pipeNumber(),"type":"text","mask":_vm.maskOfNumber,"placeholder":_vm.$t('goalRatioColumn'),"disabled":_vm.inProgress || _vm.removingProcess},on:{"focus":function($event){_vm.resetWarning('valueR'); _vm.selectedGoal.lockR = false;}},model:{value:(_vm.selectedGoal.valueR.editedValue),callback:function ($$v) {_vm.$set(_vm.selectedGoal.valueR, "editedValue", $$v)},expression:"selectedGoal.valueR.editedValue"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n            "+_vm._s(this.$t('Location'))+"\n        ")]),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold"}},[_c('div',{style:(_vm.formGroupInput2Warn)},[_c('site-multi-select-tree',{attrs:{"givenSites":_vm.allSites,"givenSelectedSites":_vm.getSelectedSiteIds(),"disabled":_vm.inProgress || _vm.removingProcess},on:{"oninput":_vm.selectSite}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.inProgress)?[_c('div',{staticStyle:{"color":"#ff0000"}},[_vm._v("\n                "+_vm._s(this.$t('longProcessNotification'))+"\n            ")])]:(_vm.removingProcess)?[_c('div',{staticStyle:{"display":"inline-block","width":"100%"}},[_c('span',{staticStyle:{"color":"#ff0000","align":"left"}},[_vm._v(" "+_vm._s(this.$t('goal-deletion-warn'))+" ")]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){return _vm.deleteGoal()}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"secondary"},on:{"click":function($event){_vm.removingProcess = !_vm.removingProcess}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)]:(_vm.type === 'updateGoal')?[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"primary"},on:{"click":function($event){return _vm.update()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"secondary"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){_vm.removingProcess = !_vm.removingProcess}}},[_vm._v(_vm._s(_vm.$t('delete')))])]:[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"primary"},on:{"click":function($event){return _vm.insert()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){return _vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])]],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rvSf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBVj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sCjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"half-circle-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"circle circle-1",style:(_vm.circle1Style)}),_vm._v(" "),_c('div',{staticClass:"circle circle-2",style:(_vm.circle2Style)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sVtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"width":"25%","min-width":"30rem","margin":"auto","font-size":"1em"}},[_c('b-row',{staticClass:"m-3",staticStyle:{"font-weight":"bold","text-align":"start","margin-bottom":"10px","color":"#022B49","font-size":"1.75em"}},[_c('b-col',[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                        "+_vm._s(_vm.$t('userTitle'))+"\n                ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-3 mt-5"},[_c('b-col',[_c('div',{staticClass:"item"},[_c('b-avatar',{attrs:{"size":"8em","src":_vm.user.profilePic}}),_vm._v(" "),(_vm.canEdit)?_c('file-upload',{staticClass:"edit-badge",staticStyle:{"cursor":"pointer"},attrs:{"extensions":"gif,jpg,jpeg,png,webp","accept":"image/png,image/gif,image/jpeg,image/webp","name":"avatar","drop":true},on:{"input-file":_vm.inputFile},model:{value:(_vm.profilePic),callback:function ($$v) {_vm.profilePic=$$v},expression:"profilePic"}},[_c('div',{staticStyle:{"cursor":"pointer"}},[_c('i',{staticClass:"fas fa-pen"})])]):_vm._e()],1)])],1),_vm._v(" "),_c('b-modal',{staticStyle:{"height":"100vh"},attrs:{"modal-class":"modal-fullscreen","size":"md","title":_vm.$t('editPhoto'),"ok-title":_vm.$t('ok'),"cancel-title":_vm.$t('cancel')},on:{"ok":_vm.saveProfilePic},model:{value:(_vm.showCropImageModal),callback:function ($$v) {_vm.showCropImageModal=$$v},expression:"showCropImageModal"}},[_c('VueCropper',{ref:"cropper",staticStyle:{"max-height":"500px"},attrs:{"aspectRatio":1 / 1,"initialAspectRatio":1 / 1,"src":_vm.profilePicSrc,"alt":"Source Image"}})],1),_vm._v(" "),_c('b-row',{staticClass:"m-3"},[_c('b-col',[_c('span',{staticClass:"groupTitle",staticStyle:{"margin-top":"10px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('personalInformationSubTitle'))+"\n                ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-3 mt-4"},[_c('b-col',[_c('span',{staticClass:"fieldTitle",staticStyle:{"margin-bottom":"3px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('firstName')+'*')+"\n                ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid': _vm.errors.firstName },attrs:{"disabled":!_vm.canEdit,"placeholder":_vm.canEdit ? _vm.$t('firstNamePlaceholder') : '',"type":"text"},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}}),_vm._v(" "),(_vm.errors.firstName)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('firstNameValidationError')))]):_vm._e()],1),_vm._v(" "),_c('b-col',[_c('span',{staticClass:"fieldTitle",staticStyle:{"margin-bottom":"3px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('lastName')+'*')+"\n                ")]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid': _vm.errors.lastName },attrs:{"disabled":!_vm.canEdit,"placeholder":_vm.canEdit ? _vm.$t('lastNamePlaceholder') : '',"type":"text"},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}}),_vm._v(" "),(_vm.errors.lastName)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('lastNameValidationError')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3 mt-4"},[_c('b-col',[_c('span',{staticClass:"fieldTitle",staticStyle:{"margin-bottom":"3px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('email')+'*')+"\n                ")]),_vm._v(" "),_c('b-input-group',{staticClass:"profile-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('i',{staticClass:"fas fa-envelope",staticStyle:{"color":"#8e9097"}})]),_vm._v(" "),_c('b-form-input',{class:{'is-invalid': _vm.errors.email || _vm.errors.validEmail },attrs:{"disabled":!_vm.canEdit,"placeholder":_vm.canEdit ? _vm.$t('emailPlaceholder') : '',"type":"text"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),(_vm.errors.validEmail)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('emailValidationError')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3 mt-4"},[_c('b-col',[_c('span',{staticClass:"fieldTitle",staticStyle:{"margin-bottom":"3px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('department'))+"\n                ")]),_vm._v(" "),_c('b-input-group',{staticClass:"profile-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('span',{staticClass:"fas fa-users",staticStyle:{"color":"#8e9097"}})]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":!_vm.canEdit,"type":"text"},model:{value:(_vm.user.department),callback:function ($$v) {_vm.$set(_vm.user, "department", $$v)},expression:"user.department"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3 mt-4"},[_c('b-col',[_c('span',{staticClass:"fieldTitle",staticStyle:{"margin-bottom":"2px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('jobTitle'))+"\n                ")]),_vm._v(" "),_c('b-input-group',{staticClass:"profile-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('span',{staticClass:"fas fa-briefcase",staticStyle:{"color":"#8e9097"}})]),_vm._v(" "),_c('b-form-input',{attrs:{"disabled":!_vm.canEdit,"type":"text"},model:{value:(_vm.user.jobTitle),callback:function ($$v) {_vm.$set(_vm.user, "jobTitle", $$v)},expression:"user.jobTitle"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3"},[_c('b-col',[_c('span',{staticClass:"groupTitle",staticStyle:{"margin-top":"20px"}},[_vm._v("\n                        "+_vm._s(_vm.$t('languagePreference'))+"\n                ")]),_vm._v(" "),_c('b-input-group',{staticClass:"mt-5 profile-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('span',{staticClass:"fas fa-language",staticStyle:{"color":"#8e9097"}})]),_vm._v(" "),_c('b-form-select',{attrs:{"disabled":!_vm.canEdit,"value":this.selectLocaleText()},on:{"change":_vm.changeLocale},model:{value:(_vm.user.language),callback:function ($$v) {_vm.$set(_vm.user, "language", $$v)},expression:"user.language"}},[_c('option',{domProps:{"value":'tr'}},[_vm._v(_vm._s(_vm.$t('turkish')))]),_vm._v(" "),_c('option',{domProps:{"value":'en'}},[_vm._v(_vm._s(_vm.$t('english')))])])],1)],1)],1),_vm._v(" "),(this.$store.state.user.permissions.isAdmin)?[_c('b-row',{staticClass:"m-3"},[_c('b-col',[_c('span',{staticClass:"groupTitle",staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.$t('permissionsTitle')))])])],1),_vm._v(" "),_c('b-row',{staticClass:"m-3"},[_c('b-col',[_c('span',{staticClass:"fieldTitle"},[_vm._v(_vm._s(_vm.$t('rolesGroups')))]),_vm._v(" "),_c('treeselect',{key:_vm.$store.state.locale,attrs:{"multiple":true,"max-height":300,"options":_vm.userGroups},on:{"input":_vm.setUserGroup},model:{value:(_vm.user.groupId),callback:function ($$v) {_vm.$set(_vm.user, "groupId", $$v)},expression:"user.groupId"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"m-3"},[_c('b-col',[_c('span',{staticClass:"fieldTitle"},[_vm._v(_vm._s(_vm.$t('locations')))]),_vm._v(" "),_c('site-multi-select-tree',{attrs:{"disabled":!_vm.canEdit,"givenSites":_vm.allSites,"givenSelectedSites":_vm.getSelectedSiteIds()},on:{"oninput":_vm.selectSite}})],1)],1)]:_vm._e(),_vm._v(" "),(_vm.canEdit)?_c('b-row',{staticClass:"m-1",staticStyle:{"float":"right"}},[_c('b-col',[_c('b-button',{attrs:{"variant":"success","disabled":_vm.ppLoading},on:{"click":function($event){return _vm.updateUser()}}},[_vm._v(_vm._s(_vm.$t('update')))])],1)],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sYoA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Upload_vue__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UploadRegular_vue__ = __webpack_require__("8Vs0");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Table component will be deprecated after CustomTable.vue is being stable.






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Upload: __WEBPACK_IMPORTED_MODULE_5__components_Upload_vue__["a" /* default */], UploadRegular: __WEBPACK_IMPORTED_MODULE_6__components_UploadRegular_vue__["a" /* default */] },
    name: 'vueTable',
    props: {
        tableName: {
            type: String
        },
        initialData: {
            type: Object,
            default: function _default() {
                return {
                    items: [],
                    fields: []
                };
            }
        },
        isEditable: {
            type: Boolean,
            default: function _default() {
                return false;
            }
        },
        isScrollable: {
            type: Boolean,
            default: function _default() {
                return true;
            }
        },
        height: {
            type: String,
            default: 'height: calc(100vh - 350px)'
        },
        isDeletable: {
            type: Boolean,
            default: function _default() {
                return true;
            }
        }
    },
    data: function data() {
        return {
            insertMode: false, // toggles insert mode
            insertingNewItem: false, // Currently insterting flag
            fields: [], // table headers
            items: [], // includes some info to show on cells,
            tempItem: {}, // stores data entered by user
            lastColumnWidth: '140px', // 'em' typed width value to specify action column width
            tableScrollActive: false, // checks if table has scroll bar
            tableFontSize: 0.875,
            tableId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            reactiveId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            perPage: {
                prev: 0,
                current: 0
            }
        };
    },


    methods: {
        shortenList: function shortenList(dataList, maxLength) {
            if (dataList == undefined || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEmpty(dataList)) {
                return "-";
            }
            if (dataList.length > 3) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(dataList.slice(0, maxLength), ",") + this.$t('and') + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toString(dataList.length - maxLength) + " " + this.$t('more');
            } else {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.join(dataList, ",");
            }
        },
        sendEmit: function sendEmit(event, emitName, item) {
            return this.$emit(emitName, { id: item.id, name: this.tableName }, event);
        },
        idToPaymentMethod: function idToPaymentMethod(val) {
            var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.paymentMethods, { value: val });
            return found ? this.$t(found.text) : '';
        },
        getHealthTooltipMessage: function getHealthTooltipMessage(health) {
            var _this = this;

            health = JSON.parse(health);
            /* let message = '<table>';
            if (health.message && health.message[0]) {
                message += '<tr style="font-size:12px"><td style="text-align:left;">' + health.message[0] + '</td></tr>';
            }
            if (health.message && health.message[1]) {
                message += '<tr style="font-size:12px"><td style="text-align:left;">' + health.message[1] + '</td></tr>';
            }
             message += '</table>'; */
            // return health.message[0];
            health.message = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(health.message, function (msg) {
                var translate_msg = _this.$t(msg.replace(/\s\(.+/, ''));
                return msg.replace(/.+\s/, translate_msg + ' ');
            });
            return health.message.join(', ');
        },
        getDataTypes: function getDataTypes() {
            var _this2 = this;

            var filteredOptions = [];
            var units = [];
            var dataTag = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(JSON.parse(localStorage.getItem('tags')), { active: true }), 'key') || 'consumption';
            var dataTypes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.dataTypes, { type: dataTag });
            // Filter out some data types for customer 1 non-admin users
            if (this.gbId(this.$store.state.user.customerId) && !this.$store.state.user.permissions.isAdmin) {
                if (dataTag == 'consumption') {
                    dataTypes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataTypes, function (dt) {
                        return dt.unit_id_1 != 3 && !dt.name.match(/ATM/i);
                    });
                } else if (dataTag == 'supplychain') {
                    dataTypes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(dataTypes, function (dt) {
                        return dt.name.match(/(a4|dekont|uncoated-freesheet|uncoated-groundwood)/i);
                    });
                }
            }
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(dataTypes, function (dataType) {
                var unit = [];
                filteredOptions.push(dataType);
                unit.name = ' (' + _this2.$t(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this2.$store.state.units, { id: dataType.unit_id_1 }).name) + ')';
                unit.id = dataType.id;
                units.push(unit);
            });
            filteredOptions.forEach(function (dataType) {
                dataType.name = _this2.$t(dataType.name);
                dataType.unit = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(units, { id: dataType.id }).name;
            });
            return filteredOptions;
        },
        isNil: function isNil(value) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(value);
        },

        // Hide warning message
        resetWarning: function resetWarning(item) {
            item.classes['is-invalid'] = false;
            item.hasWarn = false;
        },


        // Make a row editable
        makeRowEditable: function makeRowEditable(item) {
            this.items.forEach(this.revertChanges);
            this.insertMode = false;
            item.editMode = true;

            // Focus on first item in row
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-input-custom');
                elements.length ? elements[0].focus() : console.log('There is no element to be focused.');
                return true;
            });
        },


        // Insert a new table row
        insertRow: function insertRow() {
            var _this3 = this;

            this.items.forEach(this.revertChanges);
            this.insertingNewItem = false;
            this.insertMode = true;
            this.items.forEach(function (item) {
                item.isSaving = false;
                item.editMode = false;
            });
            this.bindTempItemToView();

            // Focus on first item in row
            return this.$nextTick().then(function () {
                var elements = document.getElementsByClassName('masked-input-custom');
                _this3.tableName == 'data_detail' ? elements[0].focus() : _this3.$refs.datatypeForm[0].$el.scrollIntoView({ behavior: 'smooth' });
                return true;
            });
        },


        // Cancel newly inserted row
        cancelNewRow: function cancelNewRow() {
            var _this4 = this;

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.tempItem, 'file'), 'id') && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.get(this.tempItem, 'file'), 'onCloud')) {
                return this.axios.delete('/deleteFromAws/' + this.tempItem['file'].id).then(function () {
                    _this4.insertMode = false;
                    _this4.bindTempItemToView();
                });
            } else {
                this.insertMode = false;
                this.bindTempItemToView();
            }
        },


        // Insert new item
        createItem: function createItem(item) {
            var _this5 = this;

            if (this.isInsertValid(item) && !this.insertingNewItem) {
                this.insertingNewItem = true;
                this.$emit('insertItem', item, function (data) {
                    _this5.insertMode = false;
                    _this5.items.push(_this5.prepareItem(data));
                    _this5.bindTempItemToView();
                    _this5.calculateLastColumnWidth();
                    _this5.insertingNewItem = false;
                }, function () {
                    return _this5.insertingNewItem = false;
                });
            }
        },


        // Update existing item
        updateItem: function updateItem(item, fields) {
            var _this6 = this;

            if (this.isUpdateValid(item, fields) && !item.isSaving) {
                item.isSaving = true;
                this.$emit('applyDataChanges', item, fields, function (data) {
                    var updatedItem = _this6.prepareItem(data);
                    for (var key in item) {
                        item[key] = updatedItem[key];
                    }
                    item.editMode = false;
                    item.isSaving = false;
                }, function () {
                    return item.isSaving = false;
                });
            }
        },


        // Delete an item
        deleteItem: function deleteItem($event, id) {
            var _this7 = this;

            this.showWarnModal($event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this7.$emit('deleteItemById', id);
                _this7.items = _this7.items.filter(function (item) {
                    return item.id !== id;
                });
            });
        },
        setPaymentMethod: function setPaymentMethod(id, item) {
            item.editedValue = id;
        },
        processPaymentMethods: function processPaymentMethods() {
            var _this8 = this;

            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.paymentMethods, function (v) {
                return { value: v.value, text: _this8.$t(v.text) };
            });
        },
        handleUploading: function handleUploading(event, item) {
            item.editedId = event.id;
            item.editedFilename = event.filename;
            item.editedFileId = event.fileId;
            item.editedFileUrl = event.fileUrl;
            item.editedOnCloud = event.onCloud;
            this.$store.state.uploadFiles = [];
        },
        handleTempUploading: function handleTempUploading(event, item) {
            item.id = event.id;
            item.filename = event.filename;
            item.fileId = event.fileId;
            item.fileUrl = event.fileUrl;
            item.onCloud = event.onCloud;
        },
        handleRemoving: function handleRemoving(event, item) {
            item.editedFileId = null;
        },
        handleTempRemoving: function handleTempRemoving(event, item) {
            item.fileId = null;
            item.id = null;
        },


        // Revert any changes made on an item
        revertChanges: function revertChanges(item) {
            var _this9 = this;

            var revertItem = function revertItem(item) {
                _this9.fields.forEach(function (field) {
                    if (field.editable) {
                        if (field.type === 'date') {
                            item[field.key].editedValue = __WEBPACK_IMPORTED_MODULE_3_moment___default()(item[field.key].value).toDate();
                        } else if (field.type === 'daterange') {
                            item[field.key].editedValue = [__WEBPACK_IMPORTED_MODULE_3_moment___default()(item[field.key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(item[field.key].value[1]).toDate()];
                        } else if (field.type === 'number' || field.type === 'text' || field.type === 'list' || field.type === 'text-translate') {
                            item[field.key].editedValue = item[field.key].value;
                        } else if (field.type === 'float') {
                            item[field.key].editedValue = item[field.key].value ? _this9.convertToLocalizedFloat(item[field.key].value, _this9.locale) : null;
                        } else if (field.type === 'file') {
                            item[field.key].editedFileId = item[field.key].fileId;
                            item[field.key].editedFileUrl = item[field.key].fileUrl;
                            item[field.key].editedFilename = item[field.key].filename;
                            item[field.key].editedId = item[field.key].id;
                            item[field.key].editedOnCloud = item[field.key].onCloud;
                        }
                        item[field.key].classes['is-invalid'] = false;
                        item[field.key].hasWarn = false;
                    }
                });
                item.editMode = false;
            };

            if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item), 'file')) {
                if (item['file'].editedFileId != item['file'].fileId && item['file'].editedOnCloud) {
                    this.axios.delete('/deleteFromAws/' + item['file'].editedId).then(function () {
                        return revertItem(item);
                    });
                } else {
                    revertItem(item);
                }
            } else {
                revertItem(item);
            }
        },


        // Validate newly entered data
        isInsertValid: function isInsertValid(item) {
            var isValid = true;
            var fileValid = true;
            /* let lastItem = this.items[this.items.length - 1];
            if (item.cost && item.value1 && lastItem) {
                let value = parseFloat(item.value1.value.replace(/\./g, ''));
                let cost = parseFloat(item.cost.value.replace(/\./g, ''));
                let unitPrice = lastItem.cost.value / lastItem.value1.value;
                let insertedUnitPrice = cost / value;
                let minUnitPrice = unitPrice * 70 / 100;
                let maxUnitPrice = unitPrice * 130 / 100;
                if (insertedUnitPrice < minUnitPrice || insertedUnitPrice > maxUnitPrice) {
                    this.$toasted.error(this.$t('unitPriceError'));
                    isValid = false;
                    return isValid;
                }
            } */

            for (var key in item) {
                if (key == "file" && item[key].required && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(item[key].fileId) && item[key].hasOwnProperty('fileId')) {
                    item[key].classes['is-invalid'] = true;
                    item[key].hasWarn = true;
                    item[key].style = { 'width': '100%', 'border': '1px solid #ff0000' };
                    fileValid = false;
                } else {
                    if (item[key].required && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(item[key].value) && item[key].hasOwnProperty('value')) {
                        item[key].classes['is-invalid'] = true;
                        item[key].hasWarn = true;
                        isValid = false;
                    }
                }

                /* if((key == 'file') && (!item[key].fileId && !this.$store.state.user.permissions.canStartAudits)){
                    this.$toasted.error(this.$t('missingBillUpload'));
                    isValid = false;
                    return isValid;
                } */
            }
            if (!fileValid && isValid) {
                this.$toasted.error(this.$t('missingFile'));
            } else if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            } else if (!item.unit && item.date && item.date.value[1] > new Date(new Date().setHours(0, 0, 0, 0))) {
                item.date.classes['is-invalid'] = true;
                item.date.hasWarn = true;
                isValid = false;
                this.$toasted.error(this.$t('futureDateBill'));
            }
            return isValid && fileValid;
        },


        // Validate updates to existing data
        isUpdateValid: function isUpdateValid(item, fields) {
            var isValid = true;
            var fileValid = true;

            fields.forEach(function (field) {
                if (field.key == "file" && field.required && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isNil(item[field.key].editedFileId) && item[field.key].hasOwnProperty('editedFileId')) {
                    item[field.key].classes['is-invalid'] = true;
                    item[field.key].hasWarn = true;
                    item[field.key].style = { 'width': '100%', 'border': '1px solid #ff0000' };
                    fileValid = false;
                } else if (field.required && field.editable && field.type !== 'file') {
                    if (!item[field.key].editedValue) {
                        item[field.key].classes['is-invalid'] = true;
                        item[field.key].hasWarn = true;
                        isValid = false;
                    }
                }
            });

            if (!fileValid && isValid) {
                this.$toasted.error(this.$t('missingFile'));
            } else if (!isValid) {
                this.$toasted.error(this.$t('missingError'));
            } else if (item.date.editedValue[1] > new Date()) {
                item.date.classes['is-invalid'] = true;
                item.date.hasWarn = true;
                isValid = false;
                this.$toasted.error(this.$t('futureDateBill'));
            }
            return isValid && fileValid;
        },


        // Prepare items in the correct format
        // The property editValue is used to store data entered by user
        prepareItem: function prepareItem(data) {
            var row = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data.cols);
            var generated = {};
            for (var key in row) {
                var foundField = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.fields, { key: key });
                if (foundField) {
                    generated[key] = row[key];
                    if (this.isEditable) {
                        if (foundField.type === 'daterange') {
                            generated[key].editedValue = [__WEBPACK_IMPORTED_MODULE_3_moment___default()(generated[key].value[0]).toDate(), __WEBPACK_IMPORTED_MODULE_3_moment___default()(generated[key].value[1]).toDate()];
                        } else if (foundField.type === 'date') {
                            generated[key].editedValue = __WEBPACK_IMPORTED_MODULE_3_moment___default()(generated[key].value).toDate();
                        } else if (foundField.type === 'number' || foundField.type === 'text' || foundField.type === 'text-translate') {
                            generated[key].editedValue = generated[key].value ? generated[key].value : '-';
                        } else if (foundField.type === 'list') {
                            generated[key].editedValue = generated[key].value ? generated[key].value : [];
                        } else if (foundField.type === 'float' && generated[key] && generated[key].value) {
                            generated[key].value = generated[key].value.toFixed(2);
                            generated[key].editedValue = this.convertToLocalizedFloat(generated[key].value, this.locale);
                        } else if (foundField.type === 'link' && generated[key] && generated[key].value) {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'file') {
                            generated[key].onCloud = row[key].fileOnCloud;
                            generated[key].editedOnCloud = generated[key].onCloud;
                            generated[key].fileId = row[key].fileId;
                            generated[key].editedFileId = generated[key].fileId;
                            generated[key].fileUrl = row[key].fileUrl;
                            generated[key].editedFileUrl = generated[key].fileUrl;
                            generated[key].filename = row[key].filename;
                            generated[key].editedFilename = generated[key].filename;
                        } else if (foundField.type === 'select') {
                            generated[key].editedValue = generated[key].value;
                        } else if (foundField.type === 'identity') {
                            generated[key] = row.lastModifier;
                        } else {
                            generated[key].editedValue = generated[key].value ? generated[key].value : '-';
                        }

                        generated[key].classes = {
                            'form-control': foundField.type !== 'date' && foundField.type !== 'daterange',
                            'is-invalid': false
                        };
                        generated[key].hasWarn = false;
                        generated[key].required = foundField.required;
                    }
                }
            }
            generated.isSaving = false;
            generated.editMode = false;
            generated.id = data.id;
            generated.path = data.path;

            return generated;
        },
        setDefaultDateTypedValue: function setDefaultDateTypedValue(type, key) {
            var defaultVal = null;
            if (this.items.length) {
                if (type === 'date') {
                    var lastItem = this.items[this.items.length - 1];
                    defaultVal = lastItem[key].value;
                } else if (type === 'daterange') {
                    var _lastItem = this.items[this.items.length - 1];
                    defaultVal = _lastItem[key].value;
                }
            } else {
                if (type === 'date') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                } else if (type === 'daterange') {
                    defaultVal = this.createUTCDate(this.year, 0, 1);
                }
            }
            return defaultVal;
        },
        setDefaultSelectTypedValue: function setDefaultSelectTypedValue(key) {
            var defaultVal = null;
            if (this.items.length) {
                var lastItem = this.items[this.items.length - 1];
                defaultVal = lastItem[key].value;
            }
            return defaultVal;
        },


        // Bind temporary item storage to view
        bindTempItemToView: function bindTempItemToView() {
            var _this10 = this;

            this.tempItem = {};
            this.fields.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'file') {
                        _this10.$set(_this10.tempItem, field.key, {
                            filename: null,
                            fileUrl: null,
                            fileId: null,
                            onCloud: !(_this10.isbId(_this10.$store.state.user.customerId) || _this10.gbId(_this10.$store.state.user.customerId)),
                            hasWarn: false,
                            required: field.required,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            }
                        });
                    } else {
                        var defaultValue = null;
                        if (field.type === 'date' || field.type === 'daterange') {
                            defaultValue = _this10.setDefaultDateTypedValue(field.type, field.key);
                        } else if (field.type === 'select') {
                            defaultValue = _this10.setDefaultSelectTypedValue(field.key);
                        }
                        _this10.$set(_this10.tempItem, field.key, {
                            value: field.type === 'select' ? defaultValue : null,
                            defaultValue: defaultValue,
                            classes: {
                                'form-control': field.type !== 'date' && field.type !== 'daterange',
                                'is-invalid': false
                            },
                            hasWarn: false,
                            required: field.required
                        });
                    }
                }
            });
        },


        // Called on initial render and every data update
        init: function init() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

            this.fields = fields;
            this.items = items.map(this.prepareItem);
            if (this.isEditable) {
                this.bindTempItemToView();
            }
            this.calculateLastColumnWidth();
        },
        calculateLastColumnWidth: function calculateLastColumnWidth() {
            var _this11 = this;

            return this.$nextTick().then(function () {
                var element = document.getElementById('lastColumn');
                if (element) {
                    _this11.lastColumnWidth = element.offsetWidth + 'px';
                }
                return true;
            });
        },
        routeTo: function routeTo(item) {
            if (!this.isEditable) {
                this.$router.push({ path: item.path });
            }
        },
        triggerPopover: function triggerPopover(item) {
            document.getElementById('a_' + this.reactiveId + '_' + item.id).focus();
        },


        // Caclulates the count of table items per page by table-wrapper's height. 
        // Emits it if per page changes and per page greater than 2
        calcPerPage: function calcPerPage() {
            this.perPage.current = Math.floor((this.$refs.tableWrapper.offsetHeight - this.headerRowHeight) / this.bodyRowHeight);

            if (this.perPage.prev !== this.perPage.current && this.perPage.current > 2) {

                this.perPage.prev = this.perPage.current;
                this.$emit("per-page", this.perPage.current);
            }
        }
    },

    computed: {
        headerRowHeight: function headerRowHeight() {
            return this.$refs.tableHeaderRow.offsetHeight;
        },
        bodyRowHeight: function bodyRowHeight() {
            return this.$refs.tableBodyRow ? this.$refs.tableBodyRow[0].offsetHeight : 1;
        },
        cursorType: function cursorType() {
            var cursorClass = 'cursor-isEditable';
            if (!this.isEditable) {
                cursorClass = 'cursor-nonEditable';
            }
            return cursorClass;
        }
    },

    watch: {
        initialData: {
            handler: function handler(newVal) {
                var _this12 = this;

                this.init(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newVal.items), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(newVal.fields));

                this.$nextTick(function () {
                    _this12.calcPerPage();
                });
            },

            deep: true
        }
    },
    created: function created() {
        window.addEventListener('resize', this.calculateLastColumnWidth);
        this.init(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.initialData.items), __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(this.initialData.fields));

        window.addEventListener("resize", this.calcPerPage);
    },
    beforeDestroy: function beforeDestroy() {
        this.items.forEach(this.revertChanges);
        window.removeEventListener('resize', this.calculateLastColumnWidth);
        window.removeEventListener("resize", this.calcPerPage);
    }
});

/***/ }),

/***/ "sZ0I":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataType":"Veri Tipi","emissionType":"Emisyon Tipi","date":"Son değişme tarihi","dataTypeHasUnitPrice":"Birim Fiyatı Olan Veri Tipleri"},"en":{"dataType":"Data Type","emissionType":"Emission Type","date":"Last Updated Date","dataTypeHasUnitPrice":"Data Types Have an Unit Price"}}')
}


/***/ }),

/***/ "smBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Upload__ = __webpack_require__("jd+X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UploadRegular__ = __webpack_require__("8Vs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Library',
    components: { UploadRegular: __WEBPACK_IMPORTED_MODULE_3__components_UploadRegular__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_2__components_Upload__["a" /* default */] },
    data: function data() {
        return {
            isLoaded: false,
            docs: [],
            folders: [],
            selectedFolderId: null,
            uploadedFile: null,
            reactiveId: __WEBPACK_IMPORTED_MODULE_4_uuid_v4___default()(),
            folderName: null,
            selectedFolderIdToEdit: null,
            folderEditedName: null
        };
    },

    methods: {
        resetLibraryDoc: function resetLibraryDoc() {
            this.uploadedFile = null;
            this.folderName = null;
            this.selectedFolderId = null;
        },
        createLibraryDoc: function createLibraryDoc() {
            var _this = this;

            var payload = {
                file: this.uploadedFile,
                folderName: this.folderName,
                folderId: this.selectedFolderId
            };
            if (!payload.folderName && !payload.folderId) {
                this.$toasted.error(this.$t('missingError'));
            } else {
                this.$Progress.start();
                return this.axios.post('/folders', payload).then(function (_ref) {
                    var data = _ref.data;

                    _this.$Progress.finish();
                    if (_this.selectedFolderId) {
                        _this.docs.forEach(function (doc, index) {
                            if (doc.id === _this.selectedFolderId) {
                                _this.docs[index].documents.push(data.document);
                            }
                        });
                    } else {
                        if (data.document) {
                            _this.folders.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data.folder)));
                            data.folder.documents = [data.document];
                            _this.docs.push(data.folder);
                        } else {
                            var newFolder = {};
                            newFolder.id = data.id;
                            newFolder.name = data.name;
                            _this.folders.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newFolder)));
                        }
                    }
                    _this.$refs.libraryDocument.hide();
                    _this.init();
                    _this.resetLibraryDoc();
                }).catch(function (err) {
                    _this.$toasted.error(_this.$t(err.response.data.message));
                    _this.$Progress.finish();
                    _this.resetLibraryDoc();
                });
            }
        },
        onupload: function onupload(event) {
            this.uploadedFile = {
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
        },
        handleRemoving: function handleRemoving() {
            this.uploadedFile = null;
        },
        getSiteDocs: function getSiteDocs() {
            var _this2 = this;

            return this.axios.get('/library').then(function (_ref2) {
                var data = _ref2.data;

                _this2.docs = data;
            });
        },
        getFolders: function getFolders() {
            var _this3 = this;

            return this.axios.get('/folders', {
                params: {
                    folder_type: 'library'
                }
            }).then(function (_ref3) {
                var data = _ref3.data;

                _this3.folders = data;
            });
        },
        deleteDocument: function deleteDocument(event, id) {
            var _this4 = this;

            this.showWarnModal(event.target);
            this.$eventHub.$on(this.$store.state.modal.eventId, function () {
                _this4.axios.delete('/documents/' + id).then(function () {
                    _this4.docs = _this4.docs.filter(function (item) {
                        return item.uuid !== id;
                    });
                    _this4.init();
                }).catch(function () {
                    _this4.showErrorNotification('Silme işlemi gerçekleştirilemedi, tekrar deneyin.');
                });
            });
        },
        openFolderEditModal: function openFolderEditModal(id) {
            this.selectedFolderIdToEdit = id;
            this.folderEditedName = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.folders, function (o) {
                return o.id === id;
            }).name;
            this.$refs.folderEdit.show();
        },
        openFolderDeleteModal: function openFolderDeleteModal(id) {
            this.selectedFolderIdToEdit = id;
            this.$refs.confirmFolderDelete.show();
        },
        editFolder: function editFolder(folderName) {
            var _this5 = this;

            var folderId = this.selectedFolderIdToEdit;
            if (!folderName || !folderId) {
                this.$toasted.error(this.$t('missingError'));
            } else {
                this.$refs.folderEdit.show();
                var payload = {
                    id: folderId,
                    folderName: folderName
                };
                this.$Progress.start();
                return this.axios.put('/folders', payload).then(function () {
                    _this5.$Progress.finish();
                    _this5.init().then(function () {
                        _this5.$refs.folderEdit.hide();
                        _this5.folderEditedName = null;
                    });
                });
            }
        },
        deleteFolder: function deleteFolder(bool) {
            var _this6 = this;

            var folderId = this.selectedFolderIdToEdit;
            if (bool) {
                var currentFolderDocs = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(this.docs, function (o) {
                    return o.id === folderId;
                }).documents;
                if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(currentFolderDocs)) {
                    this.$Progress.start();
                    return this.axios.delete('/folders/' + folderId).then(function () {
                        _this6.$Progress.finish();
                        _this6.init();
                        _this6.$refs.confirmFolderDelete.hide();
                    });
                } else {
                    this.$toasted.error(this.$t('folderDeletionError'));
                    this.$refs.confirmFolderDelete.hide();
                }
            } else {
                this.$refs.confirmFolderDelete.hide();
            }
        },
        init: function init() {
            var _this7 = this;

            var promiseArr = [this.getSiteDocs(), this.getFolders()];
            this.$Progress.start();
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promiseArr).then(function () {
                _this7.isLoaded = true;
                _this7.$Progress.finish();
            });
        }
    },
    computed: {
        canEditLibraryDocument: function canEditLibraryDocument() {
            return this.$store.state.user.permissions.isAdmin;
        }
    },
    created: function created() {
        return this.init();
    }
});

/***/ }),

/***/ "suR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filters__ = __webpack_require__("lviy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__ = __webpack_require__("yDbN");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TotalWasteProduced',
    props: {
        initialWaste: {
            type: Object,
            default: function _default() {
                return {
                    currentWaste: [],
                    pastWaste: []
                };
            }
        },
        selectedSiteId: {
            default: function _default() {
                return null;
            }
        },
        selectedSiteGroupId: {
            default: function _default() {
                return null;
            }
        }
    },
    components: { DoughnutChart: __WEBPACK_IMPORTED_MODULE_5__components_charts_DoughnutChart__["a" /* default */] },
    data: function data() {
        var _this = this;

        return {
            isLoaded: false,
            pieChartId: __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()(),
            waste: [],
            colourPalette: ['rgba(250,164,58,1)', 'rgba(96,189,104,1)', 'rgba(247,82,133,1)', 'rgba(93,165,218,1)', 'rgba(222,207,63,1)', 'rgba(178,118,178,1)', 'rgba(77,77,77,1)', 'rgba(178,145,47,1)', 'rgba(222,207,63,1)', 'rgba(241,88,84,1)'],
            pieChartData: {
                labels: [],
                datasets: [{
                    label: 'Toplam Tüketim',
                    labels: [],
                    hoverBorderWidth: [],
                    hoverBorderColor: [],
                    backgroundColor: [],
                    data: []
                }]
            },
            pieChartOptions: {
                /*
                    layout: {
                        padding: {
                            top: 110,
                            left: 10,
                            bottom: 10,
                            right: 10
                        }
                    },
                    */
                responsive: false,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Toplam Atık Miktarı',
                    fontSize: 16,
                    fontColor: '#555'
                },
                tooltips: {
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var label = ' ';
                            label += data.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index] || '';
                            if (label) {
                                label += ': ';
                            }
                            var total = data.datasets[tooltipItem.datasetIndex].data.reduce(function (accumulator, currentValue) {
                                return accumulator + currentValue;
                            });
                            var ratio = (data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] / total * 100).toFixed(1);
                            return label + __WEBPACK_IMPORTED_MODULE_4__filters__["a" /* default */].localizedRatioText(ratio, _this.locale);
                        }
                    }
                },
                animation: {
                    duration: 1500,
                    animateScale: true,
                    easing: 'easeOutQuint',
                    onComplete: function onComplete() {
                        /*
                        let chartInstance = this.chart;
                        let textCtx = chartInstance.ctx;
                        textCtx.textAlign = 'center';
                        textCtx.textBaseline = 'middle';
                        textCtx.font = '24px Avenir';
                        textCtx.fillStyle = '#676763';
                        textCtx.fillText("2017", 148, 260);
                        */
                    }
                },
                legend: {
                    position: 'bottom',
                    labels: {
                        padding: 15,
                        align: 'center',
                        boxAlign: 'center'
                    },
                    onClick: function onClick(e, legendItem) {
                        var segment = this.chart.getDatasetMeta(0).data[legendItem.index];
                        this.chart.tooltip._active = [segment];
                        this.chart.tooltip.update();
                        this.chart.render(300, true);
                        return { e: e, legendItem: legendItem };
                        /*
                        var index = legendItem.index;
                        var ci = this.chart;
                        var meta = ci.getDatasetMeta(0);
                        // See controller.isDatasetVisible comment
                        meta.data[index].hidden = !meta.data[index].hidden;
                        // We hid a dataset ... rerender the chart
                        ci.update();
                        */
                    }
                }
            }
        };
    },

    methods: {
        calculateRatio: function calculateRatio(lastValue, currentValue) {
            if (!lastValue) {
                return '0.00';
            }
            var subtraction = currentValue - lastValue;
            var ratio = subtraction / lastValue;
            return (ratio * 100).toFixed(2);
        },
        prepareTotalCarbonConsumptionsDataSet: function prepareTotalCarbonConsumptionsDataSet(waste) {
            var _this2 = this;

            // Resets pieChartData
            this.pieChartData.datasets = [{
                labels: [],
                hoverBorderWidth: [],
                hoverBorderColor: [],
                backgroundColor: [],
                data: []
            }];
            this.pieChartData.labels = [];
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(waste.current, 'value').reverse().forEach(function (consumption, index) {
                _this2.pieChartData.datasets[0].labels.push(_this2.$t(consumption.type));
                _this2.pieChartData.labels.push(_this2.$t(consumption.type));
                _this2.pieChartData.datasets[0].hoverBorderWidth.push(6);
                _this2.pieChartData.datasets[0].hoverBorderColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].backgroundColor.push(_this2.colourPalette[index % 10]);
                _this2.pieChartData.datasets[0].data.push(consumption.value);
            });
            this.isLoaded = true;
            // Rerenders piechart
            this.$eventHub.$emit(this.pieChartId);
            return waste;
        },
        prepareTotalCarbonConsumptionsTable: function prepareTotalCarbonConsumptionsTable(waste) {
            var prepared = {
                total: {
                    displayName: this.$t('total'),
                    current: 0,
                    past: 0
                }
            };

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(waste.current, [function (o) {
                return o.value;
            }]).reverse().forEach(function (consumption) {
                if (prepared.hasOwnProperty(consumption.type)) {
                    prepared[consumption.type].current += Number(consumption.value.toFixed(2));
                } else {
                    prepared[consumption.type] = {
                        displayName: consumption.type,
                        current: Number(consumption.value.toFixed(2)),
                        past: 0
                    };
                }
                prepared.total.current += consumption.value;
            });

            waste.past.forEach(function (consumption) {
                if (prepared.hasOwnProperty(consumption.type)) {
                    prepared[consumption.type].past += Number(consumption.value.toFixed(2));
                } else {
                    prepared[consumption.type] = {
                        displayName: consumption.type,
                        current: 0,
                        past: Number(consumption.value.toFixed(2))
                    };
                }
                prepared.total.past += consumption.value;
            });

            prepared.total.current = Number(prepared.total.current.toFixed(2));
            prepared.total.past = Number(prepared.total.past.toFixed(2));

            this.waste = prepared;
        },
        filterConsumptions: function filterConsumptions(waste) {
            var _this3 = this;

            var current = waste.currentWaste;
            var past = waste.pastWaste;
            if (this.selectedSiteGroupId) {
                var sitesOfRegion = this.sites.filter(function (site) {
                    return site.siteGroupId === _this3.selectedSiteGroupId;
                });
                if (this.selectedSiteId) {
                    current = current.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id }) && consumption.site_id === _this3.selectedSiteId;
                    });
                    past = past.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id }) && consumption.site_id === _this3.selectedSiteId;
                    });
                } else {
                    current = current.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id });
                    });
                    past = past.filter(function (consumption) {
                        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(sitesOfRegion, { id: consumption.site_id });
                    });
                }
            } else if (this.selectedSiteId) {
                current = current.filter(function (consumption) {
                    return consumption.site_id === _this3.selectedSiteId;
                });
                past = past.filter(function (consumption) {
                    return consumption.site_id === _this3.selectedSiteId;
                });
            }

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ current: current, past: past });
        },
        aggregateConsumptions: function aggregateConsumptions(waste) {
            var reducedCurrent = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(waste.current, function (result, consumption) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(result, { type: consumption.type });
                if (foundEmission) {
                    foundEmission.value += consumption.value;
                } else {
                    result.push(consumption);
                }
                return result;
            }, []);

            var reducedPast = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reduce(waste.past, function (result, consumption) {
                var foundEmission = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(result, { type: consumption.type });
                if (foundEmission) {
                    foundEmission.value += consumption.value;
                } else {
                    result.push(consumption);
                }
                return result;
            }, []);

            reducedCurrent = reducedCurrent.filter(function (data) {
                return data.value !== 0;
            });
            reducedPast = reducedPast.filter(function (data) {
                return data.value !== 0;
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ current: reducedCurrent, past: reducedPast });
        },
        processCarbonConsumptions: function processCarbonConsumptions(data) {
            this.prepareTotalCarbonConsumptionsDataSet(data);
            this.prepareTotalCarbonConsumptionsTable(data);
        }
    },
    computed: {
        hasAnyCarbonConsumption: function hasAnyCarbonConsumption() {
            return this.waste && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.waste).length;
        }
    },
    watch: {
        initialWaste: function initialWaste(data) {
            this.processCarbonConsumptions(data);
        },
        selectedSiteId: function selectedSiteId() {
            this.processCarbonConsumptions(this.initialWaste);
        },
        selectedSiteGroupId: function selectedSiteGroupId() {
            this.processCarbonConsumptions(this.initialWaste);
        }
    },

    mounted: function mounted() {
        this.processCarbonConsumptions(this.initialWaste);
    }
});

/***/ }),

/***/ "t14o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionDistribution_vue__ = __webpack_require__("945v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95b42ed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionDistribution_vue__ = __webpack_require__("Ei+l");
function injectStyle (ssrContext) {
  __webpack_require__("Fwsu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95b42ed6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionDistribution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95b42ed6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionDistribution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t9g2":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"firstNamePlaceholder":"Ad","lastNamePlaceholder":"Soyad","emailPlaceholder":"E-posta","departmentPlaceholder":"Departman","jobTitlePlaceholder":"Ünvan","passwordPlaceholder":"Şifre","passwordInfo":"7+ karakter ve bir rakam","confirmPasswordPlaceholder":"Şifre Tekrar","register":"Hesap Oluştur","inviteCanceled":"Bu davet artık geçerli değil","alreadyHaveAccount":"Zaten hesabınız var mı?","termsPart-1":"Kaydolarak","termsPart-2":"Kullanım Koşullarımızı","termsPart-3":"ve","termsPart-4":"Gizlilik Politikamızı","termsPart-5":"kabul etmiş olursunuz","signUp":"Kayıt Ol","signIn":"Giriş Yap","firstNameValidationError":"Lütfen adınızı girin","lastNameValidationError":"Lütfen soyadınızı girin","passwordEmptyValidationError":"Lütfen bir şifre girin","passwordLengthError":"En az 7 karakter içermeli","passwordNotValidError":"En az bir karakter ve bir rakam içermeli","passwordsDoNotMatch":"Şfireler uyuşmuyor","canNotLeaveEmpty":"Hesap oluşturabilmeniz için kullanım koşulları ve gizlilik politikasını kabul etmeniz gerekir."},"en":{"firstNamePlaceholder":"Name","lastNamePlaceholder":"Surname","emailPlaceholder":"E-mail","departmentPlaceholder":"Department","jobTitlePlaceholder":"Title","passwordPlaceholder":"Password","passwordInfo":"7+ characters and one number","confirmPasswordPlaceholder":"Confirm Password","register":"Create Account","inviteCanceled":"This invitation no longer available","alreadyHaveAccount":"Already have an Account?","termsPart-1":"By creating an account you agree to the","termsPart-2":"terms of use","termsPart-3":"and our","termsPart-4":"privacy policy","termsPart-5":" ","signUp":"Sign Up","signIn":"Sign In","firstNameValidationError":"Please enter your first name","lastNameValidationError":"Please enter your last name","passwordEmptyValidationError":"Please enter a password","passwordLengthError":"Must contain at least 7 characters","passwordNotValidError":"Must contain at least 7 characters and 1 number","passwordsDoNotMatch":"Passwords do not match","canNotLeaveEmpty":"Before you can create an account, you must accept the terms of use and privacy policy."}}')
}


/***/ }),

/***/ "tCm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("n5Qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Carousel_vue__ = __webpack_require__("mfOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Carousel: __WEBPACK_IMPORTED_MODULE_1__components_Carousel_vue__["a" /* default */] },
    name: 'Register',
    data: function data() {
        return {
            user: {
                id: null,
                email: null,
                firstName: null,
                lastName: null,
                jobTitle: null,
                department: null,
                inviteUUID: null,
                password: null,
                passwordConfirmation: null
            },
            title: 'Carbon Intelligence',
            isLoaded: false,
            selectedPrivacyPolicy: false,
            uuid: null,
            showPassword: false,
            showPasswordConfirmation: false,
            passwordErrorType: null,
            hideCarousel: false,
            errors: {
                firstName: false,
                lastName: false,
                password: false,
                checkbox: false
            },
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        };
    },

    methods: {
        register: function register() {
            var _this = this;

            if (this.isValid()) {
                this.$Progress.start();
                this.axios.post('/user/create', {
                    user: this.user
                }).then(function (response) {
                    localStorage.setItem('token', response.data.token);
                    document.cookie = 'Authorization=Bearer ' + response.data.token;
                    _this.axios.defaults.headers.Authorization = response.data.token ? 'Bearer ' + response.data.token : 'Bearer ';
                    _this.$Progress.finish();
                    location.href = location.origin;
                }).catch(function () {
                    _this.$Progress.fail();
                });
            }
        },
        isValid: function isValid() {
            this.errors.firstName = !this.user.firstName;
            this.errors.lastName = !this.user.lastName;
            this.errors.checkbox = !this.selectedPrivacyPolicy;

            this.errors.password = !this.user.password;
            this.passwordErrorType = this.errors.password ? 'passwordEmptyValidationError' : null;
            if (!this.errors.password) {
                this.errors.password = !this.isPasswordValid(this.user.password) || this.user.password.length < 7;
                this.passwordErrorType = 'passwordNotValidError';
            }
            if (!this.errors.password) {
                this.errors.password = !this.isPasswordsMatch(this.user.password, this.user.passwordConfirmation);
                this.passwordErrorType = 'passwordsDoNotMatch';
            }

            var validation = true;
            for (var key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        isPasswordValid: function isPasswordValid(password) {
            if (password) {
                return this.user.password.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/);
            }
        },
        isPasswordsMatch: function isPasswordsMatch(password, passwordConfirmation) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(password, passwordConfirmation);
        },
        switchPasswordVisibility: function switchPasswordVisibility(id) {
            id == 'password' ? this.showPassword = !this.showPassword : this.showPasswordConfirmation = !this.showPasswordConfirmation;
            var passwordField = document.querySelector('#' + id);
            if (passwordField.getAttribute('type') === 'password') passwordField.setAttribute('type', 'text');else passwordField.setAttribute('type', 'password');
        },
        init: function init() {
            var _this2 = this;

            return this.axios.get('/user/invite/' + this.uuid).then(function (_ref) {
                var data = _ref.data;

                if (data.response.status != 'invited') {
                    _this2.$router.push({ path: '/login', query: { inviteCanceled: true } });
                } else {
                    _this2.user.id = data.response.id;
                    _this2.user.email = data.response.email;
                    _this2.user.inviteUUID = _this2.uuid;
                    _this2.isLoaded = true;
                }
            });
        },
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
            this.windowWidth = window.innerWidth;
            this.hideCarousel = this.windowWidth < 1080;
        }
    },
    created: function created() {
        this.onResize();
        this.uuid = this.route.query.uuid;
        this.init();
    },
    mounted: function mounted() {
        window.addEventListener('resize', this.onResize);
        if (window.location.href.match('garanti')) {
            this.title = 'titleGaranti';
            this.hideCarousel = true;
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        if (!to.query.uuid) {
            next('/login');
        } else {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get('/user/invite/' + to.query.uuid).then(function () {
                next();
            }).catch(function () {
                next('/login');
            });
        }
    }
});

/***/ }),

/***/ "tDRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoaded)?_c('b-card',[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{staticStyle:{"margin-right":"20px"},on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('region-multi-select',{staticStyle:{"margin-right":"10px"},attrs:{"selectedRegionId":_vm.selectedSiteGroupId,"regions":_vm.siteGroups},on:{"oninput":_vm.selectSiteGroupId}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSiteId,"givenSites":_vm.filteredSites},on:{"oninput":_vm.selectSiteId}})],1)],1),_vm._v(" "),_c('div',{staticClass:"scroll-content"},[_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.distributions, consumptions: _vm.initialEmissions.consumption, isSummary: true},"title":'',"group-type":'scopeGroup'}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds?_vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'businessTravel'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('businessTravel')}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds?_vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'employeeCommuting'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('employeeCommuting')}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds?_vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'purchasedGoodsAndServices'; }) : null, consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('purchasedGoodsAndServices')}})],1),_vm._v(" "),_c('div',{staticStyle:{"border":"1px solid rgba(135,135,136,0.3)","margin-top":"20px"}},[_c('table-and-chart',{attrs:{"selected-site-id":_vm.selectedSiteId,"selected-site-group-id":_vm.selectedSiteGroupId,"initial-emissions":{data: _vm.initialEmissions.compounds.filter(function (emission) { return emission.source === 'wasteGeneratedInOperations'; }), consumptions: _vm.initialEmissions.consumption, isSummary: false},"data-types":_vm.initialEmissions.emissionTypes,"title":_vm.$t('wasteGeneratedInOperations')}})],1)])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tFjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'analysis',
    data: function data() {
        return {
            tags: [{ key: 'general-analysis' }, { key: 'scope-1' }, { key: 'scope-2' }, { key: 'scope-3' }, { key: 'compare' }]
        };
    },

    methods: {
        routeByTag: function routeByTag(tag) {
            this.$router.push({
                name: tag.key,
                params: { site_id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.$store.state, 'siteId') },
                query: { year: this.year }
            });
        }
    },
    watch: {
        '$store.state.route.name': function $storeStateRouteName(newVal) {
            if (newVal === 'analysis') {
                this.$router.push({ name: this.tags[0].key, query: { year: this.year } });
            }
        }
    },
    created: function created() {
        /*
        if(this.gbId(this.$store.state.user.customerId) || !this.$store.state.user.permissions.canViewComparisons){
            this.tags= [{key: 'general-analysis'}, {key: 'scope-1'}, {key: 'scope-2'}, {key: 'scope-3'}]
        }
        */
        var tag = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(this.tags, { key: this.route.name });
        tag = tag ? tag : this.tags[0];
        this.$router.push({ name: tag.key, query: { year: this.year } });
    }
});

/***/ }),

/***/ "tIMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummary_vue__ = __webpack_require__("PPPj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1ed8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummary_vue__ = __webpack_require__("DxK9");
function injectStyle (ssrContext) {
  __webpack_require__("t14o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1ed8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("kQPI")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tL2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntensityMeasurementsOfEmission_vue__ = __webpack_require__("1ddj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5619c96c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntensityMeasurementsOfEmission_vue__ = __webpack_require__("RliP");
function injectStyle (ssrContext) {
  __webpack_require__("MQqr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5619c96c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntensityMeasurementsOfEmission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5619c96c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntensityMeasurementsOfEmission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("NkhH")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tSFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionTable_vue__ = __webpack_require__("aRhL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392d4090_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionTable_vue__ = __webpack_require__("7WH3");
function injectStyle (ssrContext) {
  __webpack_require__("/0vs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-392d4090"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmissionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_392d4090_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmissionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("VZFw")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tcEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FulfillingBouncingCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 4000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    orbitStyle: function orbitStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        borderWidth: this.size * 0.03 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    },
    circleStyle: function circleStyle() {
      return {
        height: this.size + 'px',
        width: this.size + 'px',
        borderColor: this.color,
        color: this.color,
        borderWidth: this.size * 0.1 + 'px',
        animationDuration: this.animationDuration + 'ms'
      };
    }
  }
});

/***/ }),

/***/ "tdq8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('b-container',{staticClass:"p-0 overflow-auto",staticStyle:{"height":"100vh"},attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-between h-100",attrs:{"no-gutters":""}},[(!_vm.hideCarousel)?_c('b-col',{staticStyle:{"background-color":"#4129A8"},attrs:{"md":"5"}},[_c('carousel')],1):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"form-side d-flex justify-content-center align-items-center ",staticStyle:{"background-color":"#fff"},attrs:{"md":_vm.hideCarousel ? 12 : 7}},[_c('b-container',{staticStyle:{"border":"none","background-color":"#fff","color":"#022B49","margin":"auto","width":"50%"}},[_c('b-row',{staticClass:"mb-5",staticStyle:{"font-weight":"bold","font-size":"1.75em"}},[_c('b-col',[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v("\n                                "+_vm._s(_vm.$t('signUp'))+"\n                        ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"input-box"},[_c('b-input-group',{staticClass:"signup-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("R0+D")}})]),_vm._v(" "),_c('b-form-input',{class:['input-field', {'is-invalid': _vm.errors.firstName }],attrs:{"placeholder":_vm.$t('firstNamePlaceholder'),"type":"text","required":""},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),(_vm.errors.firstName)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('firstNameValidationError')))]):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"signup-input-group"},[_c('b-form-input',{class:['input-field', {'is-invalid': _vm.errors.lastName }],attrs:{"placeholder":_vm.$t('lastNamePlaceholder'),"type":"text","required":""},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}}),_vm._v(" "),(_vm.errors.lastName)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('lastNameValidationError')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',{staticClass:"signup-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("PkBM")}})]),_vm._v(" "),_c('b-form-input',{staticClass:"input-field",attrs:{"disabled":"","type":"text","required":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',{staticClass:"signup-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("A9iV")}})]),_vm._v(" "),_c('b-form-input',{staticClass:"input-field",attrs:{"placeholder":_vm.$t('departmentPlaceholder'),"type":"text"},model:{value:(_vm.user.department),callback:function ($$v) {_vm.$set(_vm.user, "department", $$v)},expression:"user.department"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',{staticClass:"signup-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("vlra")}})]),_vm._v(" "),_c('b-form-input',{staticClass:"input-field",attrs:{"placeholder":_vm.$t('jobTitlePlaceholder'),"type":"text"},model:{value:(_vm.user.jobTitle),callback:function ($$v) {_vm.$set(_vm.user, "jobTitle", $$v)},expression:"user.jobTitle"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("KGkw")}})]),_vm._v(" "),_c('div',{staticClass:"placeholder-wrap"},[_c('b-form-input',{class:['input-field', {'is-invalid': _vm.errors.password }],attrs:{"type":"password","id":"password","required":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_vm._v(" "),_c('span',{staticClass:"placeholder"},[_vm._v("\n                                    "+_vm._s(_vm.$t('passwordPlaceholder'))+" "),_c('span',{staticClass:"password-info"},[_vm._v("("+_vm._s(_vm.$t('passwordInfo'))+")")])])],1),_vm._v(" "),_c('b-input-group-append',{staticStyle:{"background-color":"#EFEDF5 !important"},attrs:{"is-text":""}},[(_vm.showPassword)?_c('span',{key:"password-visible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"showPass",attrs:{"src":__webpack_require__("AuRY")}}),_c('img')]):_c('span',{key:"password-invisible",on:{"click":function($event){return _vm.switchPasswordVisibility('password')}}},[_c('img',{key:"hidePass",attrs:{"src":__webpack_require__("gfGe")}}),_c('img')])])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.password),expression:"errors.password"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t(_vm.passwordErrorType)))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-input-group',{staticClass:"signup-input-group"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('img',{attrs:{"src":__webpack_require__("KGkw")}})]),_vm._v(" "),_c('b-form-input',{class:['input-field', {'is-invalid': _vm.errors.password }],attrs:{"placeholder":_vm.$t('confirmPasswordPlaceholder'),"type":"password","id":"passwordConfirmation","required":""},model:{value:(_vm.user.passwordConfirmation),callback:function ($$v) {_vm.$set(_vm.user, "passwordConfirmation", $$v)},expression:"user.passwordConfirmation"}}),_vm._v(" "),_c('b-input-group-append',{attrs:{"is-text":""}},[(_vm.showPasswordConfirmation)?_c('span',{key:"password-confirmation-visible",on:{"click":function($event){return _vm.switchPasswordVisibility('passwordConfirmation')}}},[_c('img',{key:"showConfirmPass",attrs:{"src":__webpack_require__("AuRY")}}),_c('img')]):_c('span',{key:"password-confirmation-invisible",on:{"click":function($event){return _vm.switchPasswordVisibility('passwordConfirmation')}}},[_c('img',{key:"hideConfirmPass",attrs:{"src":__webpack_require__("gfGe")}}),_c('img')])])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.password && _vm.passwordErrorType == 'passwordsDoNotMatch'),expression:"errors.password && passwordErrorType == 'passwordsDoNotMatch'"}],staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t(_vm.passwordErrorType)))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-checkbox',{class:{'checkbox-invalid': _vm.errors.checkbox},attrs:{"value":true,"unchecked-value":false},model:{value:(_vm.selectedPrivacyPolicy),callback:function ($$v) {_vm.selectedPrivacyPolicy=$$v},expression:"selectedPrivacyPolicy"}},[_c('span',{staticStyle:{"font-size":"1rem"}},[_vm._v(_vm._s(_vm.$t('termsPart-1'))+" "),_c('a',{staticClass:"underline-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('termsPart-2')))]),_vm._v(" "+_vm._s(_vm.$t('termsPart-3'))+" "),_c('a',{staticClass:"underline-link",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.$t('termsPart-4')))]),_vm._v(" "+_vm._s(_vm.$t('termsPart-5'))+".")])]),_vm._v(" "),(_vm.errors.checkbox)?_c('span',{staticClass:"validation-error"},[_vm._v(_vm._s(_vm.$t('canNotLeaveEmpty')))]):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-5"},[_c('b-button',{staticClass:"w-35 light-green",on:{"click":function($event){return _vm.register()}}},[_vm._v(_vm._s(_vm.$t('register')))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('span',[_vm._v(_vm._s(_vm.$t('alreadyHaveAccount'))+" "),_c('router-link',{staticClass:"underline-link",attrs:{"to":{name: 'login'}}},[_vm._v(_vm._s(_vm.$t('signIn')))])],1)])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tn/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SiteTypeSelect__ = __webpack_require__("Kukl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid_v4__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Audit',
    components: { RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_RegionMultiSelect__["a" /* default */], SiteTypeSelect: __WEBPACK_IMPORTED_MODULE_3__components_SiteTypeSelect__["a" /* default */], SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_5__components_SiteMultiSelect__["a" /* default */] },
    data: function data() {
        return {
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            selectedSiteId: null,
            Audits: [],
            filteredSitesForSelect: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.sites, { isOpen: 1 }),
            filteredSites: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.sites, { isOpen: 1 }),
            twoYearBool: false,
            openSites: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.sites, { isOpen: 1 })
        };
    },

    methods: {
        selectSiteId: function selectSiteId(site) {
            this.$store.state.siteId = site ? site.id : null;
            if (site) {
                this.selectedSiteId = site.id;
                this.filteredSites = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.$store.state.sites, {
                    id: this.selectedSiteId,
                    isOpen: 1
                });
            } else {
                this.selectedSiteId = null;
                this.filteredSites = this.openSites;
            }
        },
        getSiteName: function getSiteName(siteId) {
            var found = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(this.openSites, { id: siteId });
            if (found) {
                return found.name;
            }
            return null;
        },
        getData: function getData(selectedRegionId, selectedTypeId) {
            var _this = this;

            this.axios.get('/audits/records/?region_id=' + selectedRegionId + '&type_id=' + selectedTypeId).then(function (_ref) {
                var data = _ref.data;

                _this.Audits = data;
                var filteredByType = selectedTypeId !== null ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_this.filteredSites, { typeId: selectedTypeId, isOpen: 1 }) : _this.openSites;
                var filteredByRegion = selectedRegionId !== null ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filteredByType, { siteGroupId: selectedRegionId, isOpen: 1 }) : filteredByType;
                _this.filteredSites = _this.selectedSiteId !== null ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(filteredByType, {
                    siteGroupId: _this.selectedSiteId,
                    isOpen: 1
                }) : filteredByRegion;
            });
        },

        // Insert a new table row
        insertRow: function insertRow(target, editType) {
            var _this2 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default()(),
                type: 'createAudit',
                payload: {
                    editType: editType,
                    reloadFunction: this.getData,
                    selectedRegionId: this.selectedRegionId,
                    selectedTypeId: this.selectedTypeId
                }
            });
            this.$nextTick(function () {
                _this2.$root.$emit('bv::show::modal', 'createAudit', target);
            });
        },
        onSiteTypeChange: function onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
            this.getData(this.selectedRegionId, siteTypeId);
        },
        routeToDocumentDetail: function routeToDocumentDetail(site_id) {
            this.$store.state.siteId = site_id;
            var routeData = this.$router.resolve({
                name: 'Detail',
                params: { site_id: site_id },
                query: { year: this.year }
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'Detail',
                    params: { site_id: site_id },
                    query: { year: this.year }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();
        },
        configureAudit: function configureAudit() {
            var _this3 = this;

            this.tempAudits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.audits, function (audit) {
                var foundItem = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(_this3.sites, { id: audit.siteId });
                if (foundItem) {
                    return {
                        openedCount: audit.openedAuditCount,
                        totalCount: audit.totalAuditCount,
                        siteId: audit.siteId,
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name,
                        updatedAt: audit.updatedAt
                    };
                } else {
                    return audit;
                }
            });
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(true);
        }
    },
    computed: {
        withTwoYearFilter: function withTwoYearFilter() {
            var _this4 = this;

            if (this.twoYearBool) {
                return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.filteredSites, function (site) {
                    if (_this4.Audits[site.id]) {
                        var internalAuditDate = new Date(_this4.Audits[site.id]['last_internal_audit_date']).getFullYear();
                        if (internalAuditDate === null || internalAuditDate < new Date().getFullYear() - 2) {
                            return site;
                        }
                    } else {
                        return site;
                    }
                });
            }
        }
    },
    created: function created() {
        this.getData(this.selectedRegionId, this.selectedTypeId);
        this.regions = [{ id: null, display_name: this.$t('allRegions') }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.siteGroups));
        this.$Progress.start();
    }
});

/***/ }),

/***/ "tnBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__ = __webpack_require__("T7j2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18187feb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__ = __webpack_require__("MbT5");
function injectStyle (ssrContext) {
  __webpack_require__("BeMH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18187feb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18187feb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("KPhV")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tsuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"inner-layout",style:(_vm.showScrollbar ? 'height: auto' : ''),attrs:{"no-body":""}},[_c('ul',{staticClass:"nav nav-tabs tab-deactive",staticStyle:{"background-color":"#eff3f6","border-bottom-color":"transparent !important"}},_vm._l((_vm.tags),function(tag,i){return _c('li',{key:i,staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('div',{class:{'nav-link': true, 'active': tag.active},on:{"click":function($event){return _vm.routeTo(tag)}}},[_vm._v(_vm._s(tag.name))])])}),0),_vm._v(" "),_c('b-card-body',{staticClass:"border border-top-0",style:(_vm.showScrollbar ? 'min-height: auto !important' : '')},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "txH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__ = __webpack_require__("TIN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__ = __webpack_require__("NyJr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__ = __webpack_require__("9aru");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__ = __webpack_require__("IaV/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TableAndChart: __WEBPACK_IMPORTED_MODULE_5__components_TableAndChart__["a" /* default */],
        SiteMultiSelect: __WEBPACK_IMPORTED_MODULE_4__components_SiteMultiSelect__["a" /* default */],
        RegionMultiSelect: __WEBPACK_IMPORTED_MODULE_3__components_RegionMultiSelect__["a" /* default */],
        YearSelect: __WEBPACK_IMPORTED_MODULE_2__components_YearSelect__["a" /* default */],
        Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
    },
    name: 'ScopeThree',
    data: function data() {
        return {
            isLoaded: false,
            filteredSites: [],
            selectedSiteId: null,
            selectedSiteGroupId: null,
            initialEmissions: {
                current: []
            },
            currentTypes: ['flights', 'paper', 'personel-cars'] //, 'accomodation'
        };
    },


    methods: {
        retrieveEmissions: function retrieveEmissions() {
            var _this = this;

            this.$Progress.start();
            return this.axios.get('/report/emission?' + __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify({
                startDate: this.createUTCDate(this.year, 0, 1),
                endDate: this.createUTCDate(this.year + 1, 0, 1),
                emissionId: 1,
                siteId: this.selectedSiteId,
                groupId: this.selectedSiteGroupId,
                scope: 'Scope-3'
            })).then(function (_ref) {
                var data = _ref.data;

                _this.initialEmissions = data;
                _this.isLoaded = true;
                _this.$Progress.finish();
                return data;
            });
        },
        selectSiteId: function selectSiteId(value) {
            this.selectedSiteId = value ? value.id : null;
            this.$store.state.siteId = value ? value.id : null;
            this.retrieveEmissions();
        },
        selectSiteGroupId: function selectSiteGroupId(value) {
            this.selectedSiteId = null;
            if (value) {
                this.filteredSites = this.sites.filter(function (site) {
                    return site.siteGroupId === value.id;
                });
                this.selectedSiteGroupId = value.id;
            } else {
                this.filteredSites = this.sites;
                this.selectedSiteGroupId = null;
            }
            this.retrieveEmissions();
        },
        onYearChange: function onYearChange(newVal) {
            this.$store.state.year = newVal;
            this.$router.push({ name: 'scope-3', query: { year: this.year } });
            this.retrieveEmissions();
        }
    },

    created: function created() {
        this.selectedSiteId = this.route.params.site_id ? Number(this.route.params.site_id) : this.selectedSiteId;
        this.$store.state.year = this.route.query.year ? Number(this.route.query.year) : this.year;
        this.filteredSites = this.sites;
        this.retrieveEmissions();
    }
});

/***/ }),

/***/ "ty9o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u3VH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('div',[_c('b-row',{staticStyle:{"text-align":"center"},attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"mb-4",staticStyle:{"display":"flex","justify-content":"flex-start","height":"40px"},attrs:{"cols":"6"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"1.2em","align-self":"center","cursor":"pointer"},on:{"click":function($event){return _vm.routeToDashboard(_vm.route.params.site_id, _vm.year)}}},[_vm._v(_vm._s(_vm.selectedSite.name))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"4","sm":"4","md":"6","lg":"6","xl":"5"}},[_c('b-row',{attrs:{"align-h":"end"}},[_c('year-select',{on:{"onchange":_vm.onYearChange}}),_vm._v(" "),_c('site-multi-select',{attrs:{"selectedSiteId":_vm.selectedSite.id,"givenSites":_vm.filteredSites,"allowEmpty":true},on:{"oninput":_vm.selectSiteId}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticStyle:{"font-weight":"bold","text-align":"start"},attrs:{"cols":"8"}},[_vm._v(_vm._s(_vm.$t(_vm.tableInfo.info.tableName) + _vm.selectedUnit))])],1),_vm._v(" "),_c('b-row',{staticClass:"overflow-auto",attrs:{"align-h":"start"}},[_c('vue-table',{attrs:{"tableName":'data_detail',"initialData":_vm.tableInfo,"type":'data',"siteId":this.route.params.site_id,"isEditable":this.$store.state.user.permissions.canEditData},on:{"applyDataChanges":_vm.applyDataChanges,"insertItem":_vm.insertItem,"deleteItemById":_vm.deleteItemById}})],1)],1):_c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u5OB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__ = __webpack_require__("GP/H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639e16b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__ = __webpack_require__("GrXZ");
function injectStyle (ssrContext) {
  __webpack_require__("6Ty/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-639e16b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639e16b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("ohuB")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uOop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersecting-circles-spinner",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"spinnerBlock",style:(_vm.spinnerBlockStyle)},_vm._l((_vm.circleStyles),function(cs,index){return _c('span',{key:index,staticClass:"circle",style:(cs)})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScopeComparison_vue__ = __webpack_require__("RE0Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dec4e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScopeComparison_vue__ = __webpack_require__("wsMm");
function injectStyle (ssrContext) {
  __webpack_require__("atSU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57dec4e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScopeComparison_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dec4e0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScopeComparison_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("m+c3")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uVGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeMain_vue__ = __webpack_require__("tFjJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7343690a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeMain_vue__ = __webpack_require__("eYBy");
function injectStyle (ssrContext) {
  __webpack_require__("B8Qm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7343690a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnalyzeMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7343690a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnalyzeMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("7q7y")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("G/F+")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters__ = __webpack_require__("lviy");



/* harmony default export */ __webpack_exports__["a"] = ({
    SET_USER: function SET_USER(state) {
        var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        state.user = user;
        state.locale = user.language;
    },
    SET_USERS: function SET_USERS(state, users) {
        state.users = users.map(function (user) {
            return {
                name: user.name + ' ' + user.surname,
                email: user.email,
                id: user.id,
                userGroups: user.userGroups,
                profilePic: user.profilePic,
                firstname: user.name,
                surname: user.surname,
                status: user.status,
                language: user.language,
                jobTitle: user.jobTitle,
                department: user.department,
                signupDate: user.signupDate,
                lastLoginDate: user.lastLoginDate,
                disableDate: user.disableDate,
                inviteDate: user.inviteDate,
                inviteCount: user.inviteCount,
                avatarId: user.avatarId
            };
        });
    },
    SET_LOCALE: function SET_LOCALE(state, locale) {
        state.locale = locale ? locale : 'tr';
    },
    SET_LOCALE_FORCE: function SET_LOCALE_FORCE(state, locale) {
        state.locale = locale ? locale : 'tr';
        localStorage.setItem('locale', locale);
        location.reload(true);
    },
    SET_ANALYSIS_UNIT: function SET_ANALYSIS_UNIT(state, analysis_unit) {
        state.analysis_unit = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.first(analysis_unit), "name");
    },
    SET_MODAL: function SET_MODAL(state, info) {
        state.modal.eventId = info.eventId;
        state.modal.type = info.type;
        state.modal.text = info.text;
        state.modal.payload = info.payload;
    },
    SET_SITES: function SET_SITES(state) {
        var sites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.sites = sites.map(function (site) {
            /*
            let modifiedTags = [];
             for (let key in site.tags) {
                modifiedTags.push({
                    key: key,
                    label: site.tags[key],
                    active: false
                });
            }
            */
            return {
                id: site.id,
                siteGroupId: site.siteGroupId,
                typeId: site.typeId,
                name: site.code + ' - ' + __WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */].capitalizeFirstLetter(site.name),
                originalName: __WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */].capitalizeFirstLetter(site.name),
                code: site.code,
                cityCode: site.city,
                dataTypes: site.dataTypes,
                tags: state.topLevelTags, // modifiedTags,
                lat: site.lat,
                lng: site.lon,
                phone: site.phoneNumber,
                address: site.address,
                supervisors: site.supervisor ? site.supervisor : null,
                supervisorIds: site.supervisorIds ? site.supervisorIds : null,
                directors: site.director ? site.director : null,
                directorIds: site.directorIds ? site.directorIds : null,
                agents: site.agent ? site.agent : null,
                agentIds: site.agentIds ? site.agentIds : null,
                subAgents: site.subAgent ? site.subAgent : null,
                subAgentIds: site.subAgentIds ? site.subAgentIds : null,
                calculateEmission: site.calculateEmission ? 1 : 0,
                heatingDataType: site.heatingDataType,
                isOpen: site.isOpen ? 1 : 0,
                yearlyProperties: site.properties,
                lastUpdatedAt: site.lastUpdatedAt
            };
        });
    },
    SET_PAYMENT_METHODS: function SET_PAYMENT_METHODS(state, paymentMethods) {
        state.paymentMethods = paymentMethods.map(function (paymentMethod) {
            return {
                value: paymentMethod.id,
                text: paymentMethod.text
            };
        });
    },
    SET_SITE_GROUPS: function SET_SITE_GROUPS(state, siteGroups) {
        state.siteGroups = siteGroups.map(function (siteGroup) {
            siteGroup.display_name = __WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */].capitalizeFirstLetter(siteGroup.display_name);
            return siteGroup;
        });
    },
    SET_SITES_WITH_GROUPS: function SET_SITES_WITH_GROUPS(state) {
        var siteMap = [];

        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.siteGroups, function (siteGroup) {
            var cities = [];

            var citiesWithSites = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(state.sites.filter(function (site) {
                return site.siteGroupId === siteGroup.id;
            }), 'cityCode');

            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(citiesWithSites, function (sites, cityId) {
                var city = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(state.cities, { code: cityId });

                var childSites = [];
                __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(sites, function (site) {
                    if (city === undefined) {
                        cities.push({ id: "site-" + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(site.id), label: site.name });
                    } else {
                        childSites.push({ id: "site-" + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(site.id), label: site.name });
                    }
                });

                if (city !== undefined) {
                    cities.push({
                        id: "city-" + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(siteGroup.id) + "-" + city.code,
                        label: city.name,
                        children: childSites
                    });
                }
            });

            var newSiteGroup = { id: "region-" + __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(siteGroup.id), label: siteGroup.name, children: cities };
            siteMap.push(newSiteGroup);
        });

        state.sitesWithGroups = siteMap;
    },
    SET_DATA_TYPES: function SET_DATA_TYPES(state) {
        var dataTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.dataTypes = dataTypes;
    },
    SET_SOURCE_TYPES: function SET_SOURCE_TYPES(state) {
        var sourceTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.sourceTypes = sourceTypes;
    },
    SET_TOP_LEVEL_TAGS: function SET_TOP_LEVEL_TAGS(state) {
        var topLevelTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var modifiedTags = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(topLevelTags, function (tag) {
            return modifiedTags.push({
                key: tag.name,
                label: tag.description,
                active: false
            });
        });
        state.topLevelTags = modifiedTags;
    },
    SET_DOCUMENTS: function SET_DOCUMENTS(state) {
        var documents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.documents = documents;
    },
    SET_AUDITS: function SET_AUDITS(state) {
        var audits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.audits = audits;
    },
    SET_UNITS: function SET_UNITS(state) {
        var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.units = units;
        state.unitMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(units, 'id');
    },

    /*
    SET_ADMIN_LIST(state, agentList = []) {
        state.agentList = agentList;
    },
    */
    SET_UNSUITABLENESS: function SET_UNSUITABLENESS(state) {
        var nonconformances = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.nonconformances = nonconformances;
    },
    SET_MAX_UPDATED_AT_FOR_DOCUMENTS: function SET_MAX_UPDATED_AT_FOR_DOCUMENTS(state, maxUpdatedAt) {
        state.maxUpdatedAtForDocuments = maxUpdatedAt;
    },
    SET_GOALS: function SET_GOALS(state) {
        var goals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.goals = goals;
    },
    SET_MAX_UPDATED_AT_FOR_GOALS: function SET_MAX_UPDATED_AT_FOR_GOALS(state, maxUpdatedAt) {
        state.maxUpdatedAtForGoals = maxUpdatedAt;
    },
    SET_MAX_UPDATED_AT_FOR_AUDIT: function SET_MAX_UPDATED_AT_FOR_AUDIT(state, maxUpdatedAt) {
        state.maxUpdatedAtForAudits = maxUpdatedAt;
    },
    SET_TICKET_LIST: function SET_TICKET_LIST(state, ticketList) {
        state.ticketList = ticketList;
    },
    SET_FORM_TYPES: function SET_FORM_TYPES(state) {
        var formTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.formTypes = formTypes;
    },
    SET_SITE_TYPES: function SET_SITE_TYPES(state) {
        var siteTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.siteTypes = siteTypes;
    },
    SET_DASHBOARD_DATA_TYPES: function SET_DASHBOARD_DATA_TYPES(state) {
        var dashboardDataTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.dashboardDataTypes = dashboardDataTypes;
    },
    SET_LOCATIONS_AND_SECTORS: function SET_LOCATIONS_AND_SECTORS(state) {
        var locationsAndSectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.countryMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(locationsAndSectors, 'countries'), function (o) {
            return o.id;
        });
        state.regionMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(locationsAndSectors, 'regions'), function (o) {
            return o.id;
        });
        state.cityMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(locationsAndSectors, 'cities'), function (o) {
            return o.id;
        });
        state.sectorMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keyBy(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(locationsAndSectors, 'sectors'), function (o) {
            return o.id;
        });

        var locationMap = [];
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(state.countries, function (country) {
            var regionMap = [];
            __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(state.regions, function (region) {
                return region.countryId == country.id;
            }), function (region) {
                regionMap.push({ id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(region.id), label: region.name });
            });
            locationMap.push({
                id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toString(country.id),
                label: country.name,
                children: regionMap
            });
        });
        state.locationMap = locationMap;
    },
    SET_RELATIONAL_TAGS: function SET_RELATIONAL_TAGS(state) {
        var relationalTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        state.tagMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(relationalTags, 'relationMap');
        state.scopeGroupMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(relationalTags.alltags, 'scope-group');
        state.sourceTypeGroupMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(relationalTags.alltags, 'source-type-group');
        state.sourceTypeMap = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(relationalTags.alltags, 'source-type');
    },
    SET_AWS_OPTIONS: function SET_AWS_OPTIONS(state) {
        var isExcludedForAws = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        state.isExcludedForAws = isExcludedForAws;
    }
});

/***/ }),

/***/ "upVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"warnModal",attrs:{"id":"warn","size":"sm","top":""}},[_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t(_vm.$store.state.modal.text)))]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{attrs:{"variant":"Primary"},on:{"click":function($event){return _vm.triggerEvent()}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{attrs:{"variant":"Danger"},on:{"click":function($event){return _vm.$refs.warnModal.hide()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vQ/P":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"DENETİM","openedCount":"Açık Madde","totalCount":"Toplam Madde","lastUpdatingTime":"Son Güncelleme Tarihi","twoYearFilter":{"line1":"Son 2 yılda iç denetim","line2":"yapılmamış şubeler"}},"en":{"title":"AUDITS","openedCount":"Open Items","totalCount":"Total Items","lastUpdatingTime":"Last Update","twoYearFilter":{"line1":"Sites don\u0027t have internal","line2":"audits for two years"}}}')
}


/***/ }),

/***/ "vRIr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vW50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("TqEe");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72b5f8a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__ = __webpack_require__("uOop");
function injectStyle (ssrContext) {
  __webpack_require__("4eQ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72b5f8a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72b5f8a9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_IntersectingCirclesSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "vWIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticStyle:{"border":"none"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mt-4 pt-4",attrs:{"align-h":"between"}},[_c('b-col',{attrs:{"cols":"4"}},[_c('h3',[_vm._v(_vm._s(this.$t('userGroupsPermissions')))])]),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"cols":"4"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.addUserGroup}},[_vm._v(_vm._s(this.$t('addNewUserGroup')))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-table',{ref:"table",staticClass:"table",staticStyle:{"cursor":"pointer"},attrs:{"hover":"","id":_vm.tableId,"items":_vm.tableItems,"fields":_vm.tableColumns,"responsive":"","no-border-collapse":""},on:{"row-clicked":_vm.rowClicked}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vlra":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC44NzciIGhlaWdodD0iMTguMzYyIiB2aWV3Qm94PSIwIDAgMjAuODc3IDE4LjM2MiI+CiAgPGcgaWQ9ImJyaWVmY2FzZS1vdXRsaW5lIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS41IC0zLjc1KSI+CiAgICA8cGF0aCBpZD0iUGF0aF85NTUiIGRhdGEtbmFtZT0iUGF0aCA5NTUiIGQ9Ik00LjMyNiw5SDE5LjU1MWEyLjA5MiwyLjA5MiwwLDAsMSwyLjA3NiwyLjEwOHY5LjgzNmEyLjA5MiwyLjA5MiwwLDAsMS0yLjA3NiwyLjEwOEg0LjMyNkEyLjA5MiwyLjA5MiwwLDAsMSwyLjI1LDIwLjk0NFYxMS4xMDhBMi4wOTIsMi4wOTIsMCwwLDEsNC4zMjYsOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTEuNjkpIiBmaWxsPSJub25lIiBzdHJva2U9IiM3YzdjN2MiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85NTYiIGRhdGEtbmFtZT0iUGF0aCA5NTYiIGQ9Ik0xMC4xMjUsNy4zMVY1LjkwNUExLjQsMS40LDAsMCwxLDExLjUwOSw0LjVoNi45MmExLjQsMS40LDAsMCwxLDEuMzg0LDEuNDA1VjcuMzEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjAzMSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzdjN2M3YyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTU3IiBkYXRhLW5hbWU9IlBhdGggOTU3IiBkPSJNMjEuNjI3LDE2Ljg3NUgyLjI1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC00LjY0NykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzdjN2M3YyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTU4IiBkYXRhLW5hbWU9IlBhdGggOTU4IiBkPSJNMTkuMDM2LDE2Ljg3NXYxLjA1NGEuMzQ5LjM0OSwwLDAsMS0uMzQ2LjM1MkgxMy44NDZhLjM0OS4zNDksMCwwLDEtLjM0Ni0uMzUyVjE2Ljg3NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMzMgLTQuNjQ3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjN2M3YzdjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "vvkX":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Düzeltici ve Önleyici Aksiyon Takibi","garantiTitle":"Uygunsuzluk ve Aksiyon Planı","openedCount":"Açık Madde","totalCount":"Toplam Madde","lastUpdatingTime":"Son Güncelleme Tarihi"},"en":{"title":"Corrective and Preventive Action Tracking","garantiTitle":"Corrective and Preventive Action Tracking","openedCount":"Open Items","totalCount":"Total Items","lastUpdatingTime":"Last Update"}}')
}


/***/ }),

/***/ "vxMg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'files',
    data: function data() {
        return {
            files: []
        };
    },

    methods: {
        onShow: function onShow() {
            this.files = this.$store.state.modal.payload.files;
        }
    }
});

/***/ }),

/***/ "vyRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteCard_vue__ = __webpack_require__("FkS/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500c68ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteCard_vue__ = __webpack_require__("5tbt");
function injectStyle (ssrContext) {
  __webpack_require__("gG4N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-500c68ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500c68ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w+0S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wEdX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wFoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wMmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("tn/X");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88ac92c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("2UmP");
function injectStyle (ssrContext) {
  __webpack_require__("nxi9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d88ac92c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d88ac92c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("vQ/P")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wRVn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy4zNDIiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNy4zNDIgMTgiPgogIDxwYXRoIGlkPSJfX1RFTVBfX1NWR19fIiBkPSJNOC40ODQsMjAuNWEyLjE3OCwyLjE3OCwwLDAsMCwyLjMxMiwyaDkuMjQ5YTIuMTc4LDIuMTc4LDAsMCwwLDIuMzEyLTJWOUg4LjQ4NFpNMjQuMDkyLDZIMTkuNzU2TDE4LjMwNSw0LjVIMTIuNTM3TDExLjA4NSw2SDYuNzVWNy41SDI0LjA5MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02Ljc1IC00LjUpIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "wcMw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wg62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CustomForm__ = __webpack_require__("g0qw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CustomTable__ = __webpack_require__("tpSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CustomFormTable__ = __webpack_require__("+/Rg");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'FormCreate',
    data: function data() {
        return {
            isLoaded: false,
            formSchema: [],
            tableCols: [],
            tableData: [],
            emptyFields: [],
            formData: {},
            name: null,
            disabled: false
        };
    },

    components: {
        CustomTable: __WEBPACK_IMPORTED_MODULE_7__components_CustomTable__["a" /* default */],
        CustomForm: __WEBPACK_IMPORTED_MODULE_6__components_CustomForm__["a" /* default */],
        CustomFormTable: __WEBPACK_IMPORTED_MODULE_8__components_CustomFormTable__["a" /* default */]
    },
    methods: {
        onformChange: function onformChange(formData) {
            this.formData = formData;
        },
        findEmptyFields: function findEmptyFields(data, schema) {
            var emptyFields = [];
            for (var key in data) {
                var foundCol = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.find(schema, { key: key });
                if ((data[key] === null || data[key] === undefined || typeof data[key] === 'string' && !data[key].length) && foundCol.editable) {
                    emptyFields.push(key);
                }
            }
            return emptyFields;
        },
        createForm: function createForm() {
            var _this = this;

            this.disabled = true;
            this.$toasted.show(this.$t('formCreateMsg'));
            function compareDate(lst) {
                var greatest = true;

                var _lst$splice = lst.splice(-1, 1),
                    _lst$splice2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_lst$splice, 1),
                    compel = _lst$splice2[0];

                lst.forEach(function (el) {
                    if (el.typeId === compel.typeId && el.date >= compel.date) {
                        greatest = false;
                    }
                });
                return !greatest;
            }
            this.emptyFields = this.findEmptyFields(this.formData, this.formSchema);
            this.formData.date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().toDate();
            //if(this.route.params.form_type == 2) {this.formData.date = moment()};
            if (!this.emptyFields.length && !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.tableData)) {
                if (this.tableData[0].wasteType && compareDate(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.map(this.tableData, function (data) {
                    if (typeof data.deliveryDate === 'string') {
                        data.deliveryDate = new Date(data.deliveryDate);
                    }
                    if (data.deliveryDate) {
                        data.deliveryDate = _this.createUTCDate(data.deliveryDate.getFullYear(), data.deliveryDate.getMonth(), data.deliveryDate.getDate());
                    }
                    return { typeId: data.wasteType.id, date: new Date(data.deliveryDate) };
                }))) {
                    this.$toasted.error(this.$t('date-error'));
                    this.disabled = false;
                    return;
                }
                this.$Progress.start();
                __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.each(this.tableData, function (data) {
                    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file') || {});
                    if (keys && keys.length === 3 && keys.includes('editedFileId')) {
                        data.file.fileId = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFileId');
                        data.file.fileUrl = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFileUrl');
                        data.file.filename = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFilename');
                    }
                    if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFileId') && __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFileUrl') || !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.fileId') && !__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(data, 'file.editedFileUrl')) {
                        data.file = undefined;
                    }
                });
                return this.axios.post('/' + this.route.params.site_id + '/form/' + this.route.params.form_type, {
                    table: this.tableData,
                    form: this.formData
                }).then(function (response) {
                    if (__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(response, 'status') === 200) {
                        _this.$router.push({
                            name: 'site-forms',
                            params: { site_id: _this.route.params.site_id }
                        });
                    } else {
                        _this.$toasted.error(_this.$t('unexpectedError'));
                        _this.disabled = false;
                    }
                }).catch(function (err) {
                    var message = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(err, 'response.data.message');
                    if (message) {
                        _this.$toasted.error(_this.$t(message));
                    } else {
                        _this.$toasted.error(_this.$t('unexpectedError'));
                    }
                    _this.disabled = false;
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(this.tableData) ? this.$toasted.error(this.$t('missingTableRow')) : this.$toasted.error(this.$t('missingError'));
                this.disabled = false;
            }
        },
        applyDataChanges: function applyDataChanges(item, fields, callback) {
            var _this2 = this;

            var updatedItem = {
                id: item.id
            };
            fields.forEach(function (field) {
                if (field.editable && item[field.key]) {
                    if (field.type === 'date') {
                        updatedItem[field.key] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item[field.key].editedValue).toDate();
                    } else if (field.type === 'daterange') {
                        updatedItem[field.key] = item[field.key].value;
                    } else if (field.type === 'number' || field.type === 'float') {
                        updatedItem[field.key] = _this2.delocalizeValue(item[field.key].editedValue, _this2.locale);
                    } else if (field.type === 'file') {
                        updatedItem[field.key] = item[field.key];
                    } else {
                        updatedItem[field.key] = item[field.key].editedValue;
                    }
                }
            });
            var cloned = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.tableData));
            cloned.forEach(function (element, index) {
                if (element.id === updatedItem.id) {
                    cloned[index] = updatedItem;
                }
            });
            this.tableData = cloned;
            this.tableData.map(callback);
        },
        insertItem: function insertItem(item, callback) {
            var _this3 = this;

            var insertedItem = {};

            this.tableCols.forEach(function (field) {
                if (field.editable) {
                    if (field.type === 'date') {
                        insertedItem[field.key] = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item[field.key].value).toDate();
                    } else if (field.type === 'daterange') {
                        insertedItem[field.key] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(item, field.key + '.value');
                    } else if (field.type === 'number' || field.type === 'float') {
                        insertedItem[field.key] = _this3.delocalizeValue(item[field.key].value, _this3.locale);
                    } else if (field.type === 'file') {
                        insertedItem[field.key] = item[field.key];
                    } else {
                        insertedItem[field.key] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(item, field.key + '.value');
                    }
                }
            });
            insertedItem.id = __WEBPACK_IMPORTED_MODULE_3_uuid_v4___default()();
            this.tableData.push(insertedItem);
            return callback(insertedItem);
        },
        deleteItemById: function deleteItemById(id) {
            this.tableData = this.tableData.filter(function (item) {
                return item.id !== id;
            });
        },
        fetchDesign: function fetchDesign() {
            var _this4 = this;

            return this.axios.get('/form/design/' + this.route.params.site_id + '/' + this.route.params.form_type).then(function (_ref) {
                var data = _ref.data;

                _this4.formSchema = data.form;
                _this4.formData = data.formData;
                if (_this4.formData.date) {
                    _this4.formData.date = _this4.formData.date.split('T')[0];
                }
                _this4.tableCols = data.table;
                _this4.tableData = data.tableData ? data.tableData : [];
                _this4.name = data.name;
                return data;
            });
        },
        init: function init() {
            var _this5 = this;

            this.isLoaded = false;
            this.fetchDesign().then(function () {
                _this5.isLoaded = true;
            });
        }
    },
    created: function created() {
        this.init();
    }
});

/***/ }),

/***/ "wsMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',[_c('b-row',{staticStyle:{"margin-top":"40px"},attrs:{"align-h":"center"}},[_c('span',{staticStyle:{"font-size":"1.1em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('scopeBarChartTitle')))])]),_vm._v(" "),(_vm.hasAnyValueToRenderBarChart)?_c('b-row',{staticStyle:{"margin-top":"50px"}},[_c('b-col',[_c('div',{staticStyle:{"width":"45em","height":"45em","margin":"auto"}},[_c('bar-chart',{attrs:{"chart-data":_vm.barChartData,"options":_vm.barChartOptions,"chart-id":_vm.barChartId}})],1)]),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"table-responsive",staticStyle:{"margin-top":"10vh"}},[(_vm.scopeReport)?_c('table',{staticClass:"table table-hover",staticStyle:{"table-layout":"fixed","font-size":"0.875em"}},[_c('thead',{staticStyle:{"text-align":"center"}},[_c('tr',[_c('th',{staticStyle:{"text-align":"left","width":"16em"}},[_vm._v("Scope")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year - 1))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(this.year))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('changingColumn')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.scopeTags),function(tag,i){return _c('tr',{key:i},[_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(tag.displayName)+" ("+_vm._s(_vm.$t('ton'))+"CO2e)")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.scopeReport.past[tag.id],'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.scopeReport.current[tag.id],'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[(_vm.calculateRatio(_vm.scopeReport.past[tag.id], _vm.scopeReport.current[tag.id]) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[(_vm.calculateRatio(_vm.scopeReport.past[tag.id], _vm.scopeReport.current[tag.id]))?_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.scopeReport.past[tag.id], _vm.scopeReport.current[tag.id]) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                            "+_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.scopeReport.past[tag.id], _vm.scopeReport.current[tag.id])),'float', _vm.locale),_vm.locale))+"\n                                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)])}),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.$t('total'))+" ("+_vm._s(_vm.$t('ton'))+"CO2e)")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.scopeReport.past.total,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("convertZeroValueToDash")(_vm._f("parseNumber")(_vm.scopeReport.current.total,'float', _vm.locale),_vm.locale)))]),_vm._v(" "),_c('th',[(_vm.calculateRatio(_vm.scopeReport.past.total, _vm.scopeReport.current.total) !== '0.00')?_c('b-row',{attrs:{"no-gutters":"","align-h":"between"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"11"}},[(_vm.calculateRatio(_vm.scopeReport.past.total, _vm.scopeReport.current.total) < 0)?_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("oc2c")}}):_c('img',{attrs:{"width":"16px","height":"16px","src":__webpack_require__("ib3Y")}})])],1)],1),_vm._v(" "),_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("\n                                            "+_vm._s(_vm._f("parseNumber")(_vm._f("absoluteNumber")(_vm.calculateRatio(_vm.scopeReport.past.total, _vm.scopeReport.current.total)),'float', _vm.locale))+"\n                                        ")])],1):_c('b-row',{attrs:{"no-gutters":"","align-h":"end"}},[_c('b-col',{staticStyle:{"text-align":"left"},attrs:{"cols":"6"}},[_vm._v("-")])],1)],1)])],2)]):_vm._e()])])],1):_c('b-row',[_c('b-col',[_c('span',{staticClass:"float-left"},[_vm._v(_vm._s(_vm.$t('scopeComparingError')))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wwh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteForms_vue__ = __webpack_require__("eXK0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dbebee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteForms_vue__ = __webpack_require__("bgxO");
function injectStyle (ssrContext) {
  __webpack_require__("wcMw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50dbebee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("ykcd")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x8FJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xB4Z":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"updateActionTicketTitle":"Aksiyon Planı Güncelle","updateNonconformityTicketTitle":"Düzenleyici Faaliyet Güncelle","createActionTicketTitle":"Aksiyon Planı Oluştur","createNonconformityTicketTitle":"Düzeltici Faaliyet Oluştur","nonconformanceType":"Uygunsuzluk Tanımı","revisedDocumentInfo":"Tamamlanan Döküman Bilgisi","urgentActionText":"Acil Alınacak Aksiyonlar","reasonAnalysisText":"Kök Neden Analizi","predictedDate":"Öngörülen Gerçekleşme Tarihi","auditDate":"Denetim Tarihi","additionalFiles":"Ek Dosyalar","action":"Genel Aksiyon Tanımları","futureAction":"Genel Aksiyon Tanımları","auditTicket":"Denetim","actionTicket":"Aksiyon"},"en":{"updateActionTicketTitle":"Edit Action Plan","createActionTicketTitle":"Create Action Plan","updateNonconformityTicketTitle":"Edit Corrective Action","createNonconformityTicketTitle":"Create Corrective Action","nonconformanceType":"Description of Nonconformance","revisedDocumentInfo":"Completed Document Information","urgentActionText":"Urgent Actions to be taken","reasonAnalysisText":"Root Cause Analysis","predictedDate":"Estimated Completion Date","auditDate":"Audit Date","additionalFiles":"Additional Files","action":"Action","futureAction":"Future Action","auditTicket":"Audit","actionTicket":"Action"}}')
}


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modals__ = __webpack_require__("mtPT");

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_modals__["a" /* default */]),
    data: function data() {
        return {};
    },

    methods: {
        fetchData: function fetchData() {
            var _this = this;

            setInterval(function () {
                if (_this.$store.state.isInitiated) {
                    _this.$store.dispatch('getDocumentCounts', _this.year);
                    _this.$store.dispatch('getGoalCounts', _this.year);
                    _this.$store.dispatch('getAuditCounts', _this.year);
                }
            }, 60000);
        }
    },
    watch: {
        '$store.state.year': function $storeStateYear() {
            this.$store.dispatch('getDocumentCounts', this.year);
            this.$store.dispatch('getGoalCounts', this.year);
            this.$store.dispatch('getAuditCounts', this.year);
        },
        '$store.state.locale': function $storeStateLocale() {
            this.$i18n.locale = this.$store.state.locale;
        }
    },
    created: function created() {
        this.fetchData();
        this.$i18n.locale = this.$store.state.locale;
    }
});

/***/ }),

/***/ "xLdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__("qKds");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595d88ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__("EYu7");
function injectStyle (ssrContext) {
  __webpack_require__("zTQM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-595d88ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595d88ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("Ov54")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xRxJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xcSe":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"Reengen Sürdürülebilirlik Platformu","titleGaranti":"Çevre Yönetim Sistemi Yazılımı (ÇYS)","alert":"Email adresi bulunamadı","inputPlaceholderUsername":"E-posta Adresi","sendInstructions":"Talimatları Gönder","forgotPassword":"Parolanızı mı Unuttunuz?","emptyEmail":"Lütfen e-posta adresinizi girin","emailPlaceholder":"E-posta","explanation":"Kayıt olurken kullandığınız e-posta adresini girin. Şifre sıfırlamak için gerekli talimatları mail ile ileteceğiz.","dontHaveAccount":"Hesabınız yok mu?","signUp":"Kayıt ol","backToLogin":"Giriş ekranına dön"},"en":{"title":"Reengen Sustainability Platform","titleGaranti":"Environmental Management System Software (EMS)","alert":"Email address not found","inputPlaceholderUsername":"Email Address","sendInstructions":"Send Instructions","forgotPassword":"Forgot Password?","emptyEmail":"Please enter your email","emailPlaceholder":"Email","explanation":"Enter the email address you used when you joined and we’ll send you instructions to reset your password.","dontHaveAccount":"Don\u0027t have an Account?","signUp":"Sign up","backToLogin":"Back To Login"}}')
}


/***/ }),

/***/ "xohN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xomk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.componentId}},[_c('b-btn',{ref:_vm.buttonRef,staticStyle:{"color":"#2c3e50","cursor":"pointer","border":"1px solid #dcdfe6","outline":"none","background-color":"#ffffff"},attrs:{"id":_vm.reactiveId}},[_c('i',{staticClass:"fas fa-file-alt fa-lg"})]),_vm._v(" "),_c('b-popover',{ref:"popoverId",attrs:{"target":_vm.reactiveId,"triggers":'click',"show":_vm.popoverShow,"placement":"bottom","container":_vm.componentId},on:{"update:show":function($event){_vm.popoverShow=$event},"show":_vm.onShow,"shown":_vm.onShown,"hidden":_vm.onHidden,"hide":_vm.onHide}},[_c('template',{slot:"title"}),_vm._v(" "),_c('div',{ref:_vm.focusRefId,staticClass:"table-button-group"},[(_vm.showUpload && _vm.onCloud)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('upload'),"size":"sm"}},[_c('file-upload',{ref:_vm.componentId,staticClass:"pt-2",staticStyle:{"padding":"0","margin-bottom":"0"},attrs:{"input-id":_vm.componentId + 'popover_upload'},on:{"input-file":_vm.inputFile},model:{value:(_vm.newFiles),callback:function ($$v) {_vm.newFiles=$$v},expression:"newFiles"}},[_c('i',{staticClass:"fas fa-upload fa-lg"})])],1):_vm._e(),_vm._v(" "),(_vm.showUpload && !_vm.onCloud)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('upload'),"size":"sm"}},[_c('file-upload',{ref:_vm.componentId,staticClass:"btn",staticStyle:{"padding":"0","margin-bottom":"0"},attrs:{"input-id":_vm.componentId + 'popover_upload',"chunk-enabled":"","chunk":{
                        headers: { Authorization: _vm.token},
                        action: _vm.action,
                        minSize: 0,
                        maxActive: 3,
                        maxRetries: 5,
                        startBody: {
                            filename: _vm.newFiles.length ? _vm.newFiles[0].name : null
                        }
                    }},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.newFiles),callback:function ($$v) {_vm.newFiles=$$v},expression:"newFiles"}},[_c('i',{staticClass:"fas fa-upload fa-lg"})])],1):_vm._e(),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDelete),expression:"showDelete"},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('delete'),"size":"sm","variant":"danger"},on:{"click":_vm.onRemove}},[_c('i',{staticClass:"fas fa-trash-alt fa-lg"})]),_vm._v(" "),(_vm.showDownload)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('download'),"size":"sm"},on:{"click":function($event){return _vm.$emit('ondownload')}}},[_c('i',{staticClass:"fas fa-download fa-lg"})]):_vm._e()],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xrBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__ = __webpack_require__("ZoX0");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eeed2fb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__ = __webpack_require__("h/7G");
function injectStyle (ssrContext) {
  __webpack_require__("vRIr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eeed2fb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PixelSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_eeed2fb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PixelSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "xxx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__("B4Dv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb7b6c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__("/Cm2");
function injectStyle (ssrContext) {
  __webpack_require__("y5Ye")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efb7b6c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("IC+a")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}
var customBlock = __webpack_require__("oFEA")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y5Ye":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y7ls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4__ = __webpack_require__("DtRx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['ticket', 'pageType', 'auditType', 'selectedSiteId', 'ticketId', 'updateFunction', 'isPostsEmpty'],
    data: function data() {
        return {
            componentId: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()()
        };
    },

    methods: {
        translate: function translate(word) {
            /*
            if(this.gbId(this.$store.state.user.customerId)){
                switch(word){
                    case 'action':
                            return this.$t('actionGB');
                    }
            }
            */
            switch (word) {
                case 'action':
                    return this.$t('action');
            }
            return "-";
        },
        firstExtendedDate: function firstExtendedDate(ticket, pageType) {
            if (pageType === 'list') {
                var extendedDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(ticket.extendedDate).format('YYYY-MM-DD');
                if (extendedDate === 'Invalid date') {
                    return '-';
                }
                return extendedDate;
            }
            var extendedDates = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(ticket.posts, 'extendedDate');
            // returns valid date : if there isn't any extended date, returns expected date.
            var selectedDate = extendedDates[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1] ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(extendedDates[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(extendedDates).length - 1]).format('YYYY-MM-DD') : '-';
            return selectedDate;
        },
        showUpdateTicketModal: function showUpdateTicketModal(target) {
            var _this = this;

            if (this.ticket.ticketType == 'Action') {
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticket.id,
                        ticketType: this.ticket.ticketType
                    }
                });
                this.$nextTick(function () {
                    _this.$root.$emit('bv::show::modal', 'createAction', target);
                    _this.$eventHub.$once(_this.$store.state.modal.eventId, function (updatedTicket) {
                        for (var key in updatedTicket) {
                            _this.ticket[key] = updatedTicket[key];
                        }
                        if (_this.updateFunction) {
                            _this.updateFunction();
                        }
                    });
                });
            } else {
                this.$store.commit('SET_MODAL', {
                    eventId: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(),
                    type: 'updateTicket',
                    payload: {
                        siteId: this.selectedSiteId,
                        ticket: this.ticket,
                        ticketId: this.ticket.id,
                        ticketType: this.ticketType
                    }
                });
                this.$nextTick(function () {
                    _this.$root.$emit('bv::show::modal', 'createTicket', target);
                    _this.$eventHub.$once(_this.$store.state.modal.eventId, function (updatedTicket) {
                        for (var key in updatedTicket) {
                            _this.ticket[key] = updatedTicket[key];
                        }
                        if (_this.updateFunction) {
                            _this.updateFunction();
                        }
                    });
                });
            }
        },
        showReplyModal: function showReplyModal(target, replyType) {
            var _this2 = this;

            this.$store.commit('SET_MODAL', {
                eventId: __WEBPACK_IMPORTED_MODULE_2_uuid_v4___default()(),
                type: 'createPost',
                payload: {
                    siteId: this.selectedSiteId,
                    ticket: this.ticket,
                    ticketId: this.ticketId,
                    replyType: replyType
                }
            });
            this.$nextTick(function () {
                _this2.$root.$emit('bv::show::modal', 'createPost', target);
                _this2.$eventHub.$once(_this2.$store.state.modal.eventId, function (createdPost) {
                    _this2.ticket.posts.push(createdPost);
                    _this2.ticket.isErasable = false;
                });
            });
        }
    },
    computed: {
        nonconformanceArticleText: function nonconformanceArticleText() {
            if (this.ticket.ticketType == 'Audit') {
                return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.nonconformances, { id: this.ticket.nonconformanceId }), 'article');
            }
        },
        nonconformanceActionText: function nonconformanceActionText() {
            if (this.ticket.ticketType == 'Audit') {
                if (this.ticket.nonconformanceId !== 13) {
                    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.get(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$store.state.nonconformances, {
                        id: this.ticket.nonconformanceId
                    }), 'action');
                } else {
                    return this.ticket.customNonconformance;
                }
            }
        },
        isAdmin: function isAdmin() {
            return this.$store.state.user.permissions.canStartAudits;
        },
        isAgent: function isAgent() {
            return this.$store.state.user.permissions.canReplyToAudits;
        }
    }
});

/***/ }),

/***/ "yDbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoughnutChart_vue__ = __webpack_require__("dw4H");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoughnutChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yZ0E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"transfer-boxes"},[_c('div',{staticClass:"left-box common-box"},[_c('p',{staticClass:"left-header common-header"},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminateSource,"disabled":_vm.filteredSourceData.length==0},on:{"change":_vm.sourceAllCheckChange},model:{value:(_vm.checkAllSource),callback:function ($$v) {_vm.checkAllSource=$$v},expression:"checkAllSource"}},[_vm._t("sourceTitle",function(){return [_vm._v(_vm._s(_vm.sourceTitle))]},{"row":_vm.sourceTitle})],2),_vm._v(" "),_c('span',{staticClass:"total-count"},[_vm._v(_vm._s(_vm.sourceCheckedData.length)+"/"+_vm._s(_vm.filteredSourceData.length))])],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.leftLoading),expression:"leftLoading"}],staticClass:"left-body common-body"},[(_vm.isSearch)?_c('div',{staticClass:"search-box"},[_c('el-input',{key:"searchLeft",attrs:{"size":"mini","placeholder":_vm.searchPlaceholder},on:{"input":function($event){return _vm.onSearch($event,true)}},model:{value:(_vm.searchLeftInput),callback:function ($$v) {_vm.searchLeftInput=$$v},expression:"searchLeftInput"}},[_c('template',{slot:"prepend"},[_c('i',{staticClass:"fas fa-search"})])],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"load-content"},[_c('el-checkbox-group',{on:{"change":_vm.sourceEachCheckedChange},model:{value:(_vm.sourceCheckedData),callback:function ($$v) {_vm.sourceCheckedData=$$v},expression:"sourceCheckedData"}},_vm._l((_vm.getPagedData(_vm.filteredSourceData, _vm.currentLeftPage)),function(item,i){return _c('el-checkbox',{key:i,staticClass:"check-item",attrs:{"label":item,"disabled":item.disabled}},[_vm._t("leftLabel",function(){return [_vm._v(_vm._s(item.label))]},{"row":item})],2)}),1)],1),_vm._v(" "),_c('div',{staticClass:"common-footer left-foot"},[_c('span',{attrs:{"slot":"left-footer"},slot:"left-footer"},[_c('el-pagination',{attrs:{"small":"","current-page":_vm.currentLeftPage,"page-size":_vm.perPage,"total":_vm.filteredSourceData.length,"layout":"prev,pager,next","hide-on-single-page":true},on:{"current-change":function($event){return _vm.pageChange($event,true)},"size-change":function($event){return _vm.resizePagination($event)}}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"transfer-button-box"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.targetCheckedData.length==0 || _vm.filteredTargetData.length==0},on:{"click":_vm.targetToSource}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" "+_vm._s(_vm.outBtnText)+"\n            ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.sourceCheckedData.length==0 || _vm.filteredSourceData.length==0},on:{"click":_vm.sourceToTarget}},[_vm._v("\n                "+_vm._s(_vm.inBtnText)+" "),_c('i',{staticClass:"el-icon-arrow-right"})])],1),_vm._v(" "),_c('div',{staticClass:"right-box common-box"},[_c('p',{staticClass:"right-header common-header"},[_c('el-checkbox',{attrs:{"indeterminate":_vm.isIndeterminateTarget,"disabled":_vm.filteredTargetData.length==0},on:{"change":_vm.targetAllCheckChange},model:{value:(_vm.checkAllTarget),callback:function ($$v) {_vm.checkAllTarget=$$v},expression:"checkAllTarget"}},[_vm._t("targetTitle",function(){return [_vm._v(_vm._s(_vm.targetTitle))]},{"row":_vm.targetTitle})],2),_vm._v(" "),_c('span',{staticClass:"total-count"},[_vm._v(_vm._s(_vm.targetCheckedData.length)+"/"+_vm._s(_vm.filteredTargetData.length))])],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.rightLoading),expression:"rightLoading"}],staticClass:"right-body common-body"},[(_vm.isSearch)?_c('div',{staticClass:"search-box"},[_c('el-input',{key:"searchRight",attrs:{"size":"mini","placeholder":_vm.searchPlaceholder},on:{"input":function($event){return _vm.onSearch($event,false)}},model:{value:(_vm.searchRightInput),callback:function ($$v) {_vm.searchRightInput=$$v},expression:"searchRightInput"}},[_c('template',{slot:"prepend"},[_c('i',{staticClass:"fas fa-search"})])],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"right-content"},[_c('el-checkbox-group',{on:{"change":_vm.targetEachCheckedChange},model:{value:(_vm.targetCheckedData),callback:function ($$v) {_vm.targetCheckedData=$$v},expression:"targetCheckedData"}},_vm._l((_vm.getPagedData(_vm.filteredTargetData, _vm.currentRightPage)),function(item,i){return _c('el-checkbox',{key:i,staticClass:"check-item",attrs:{"label":item}},[_vm._t("rightLabel",null,{"row":item}),_vm._v(_vm._s(item.label)+"\n                        ")],2)}),1)],1),_vm._v(" "),_c('div',{staticClass:"common-footer right-foot"},[_vm._t("right-footer")],2)]),_vm._v(" "),_c('div',{staticClass:"common-footer right-foot"},[_c('span',{attrs:{"slot":"right-footer"},slot:"right-footer"},[_c('el-pagination',{attrs:{"small":"","current-page":_vm.currentRightPage,"page-size":_vm.perPage,"total":_vm.filteredTargetData.length,"layout":"prev,pager,next","hide-on-single-page":true},on:{"current-change":function($event){return _vm.pageChange($event,false)},"size-change":function($event){return _vm.resizePagination($event)}}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ycnV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yeQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ykcd":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"title":"FORMLAR","formType":"Form Tipi","formNo":"Form No","version":"Versiyon","createdAt":"Oluşturulma Tarihi","chooseFormType":"Form Tipi Seçin"},"en":{"title":"FORMS","formType":"Form Type","formNo":"Form No","version":"Version","createdAt":"Created At","chooseFormType":"Choose a Form Type"}}')
}


/***/ }),

/***/ "ylrw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zHNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zTQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zXUD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMi4yODYiIGhlaWdodD0iMTguMTE3IiB2aWV3Qm94PSIwIDAgMjIuMjg2IDE4LjExNyI+CiAgPGcgaWQ9Ikdyb3VwXzI3NDkiIGRhdGEtbmFtZT0iR3JvdXAgMjc0OSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExNjM1LjQ2NCA3OC43NjYpIj4KICAgIDxnIGlkPSJHcm91cF8yNzQ4IiBkYXRhLW5hbWU9Ikdyb3VwIDI3NDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjM1LjQ2NSAtNzguNzY2KSI+CiAgICAgIDxnIGlkPSJHcm91cF8yNzQ2IiBkYXRhLW5hbWU9Ikdyb3VwIDI3NDYiPgogICAgICAgIDxwYXRoIGlkPSJTdWJ0cmFjdGlvbl8zIiBkYXRhLW5hbWU9IlN1YnRyYWN0aW9uIDMiIGQ9Ik0xLjI5MSwxOC4xMTdhMS4yNjgsMS4yNjgsMCwwLDEtLjk3Mi0uNDUsMS40MTksMS40MTksMCwwLDEtLjI5My0xLjE3Nyw2LjkyNCw2LjkyNCwwLDAsMSwzLjExMi00LjZBOS44MjgsOS44MjgsMCwwLDEsOC41LDEwLjM1MmExMC40NTMsMTAuNDUzLDAsMCwxLDIuMDgyLjIwOSw2LjE4Myw2LjE4MywwLDAsMC0uMjA2LDEuNTg3LDUuODc2LDUuODc2LDAsMCwwLDUuNDY2LDUuOTYsMS4zMTksMS4zMTksMCwwLDEtLjEzNS4wMDdIMS4yOTFaTTguNSw5LjA1OGMtMi4xNTUsMC00LjA1NS0yLjAxMS00LjIzNi00LjQ4MmE0LjI1NCw0LjI1NCwwLDAsMSwxLjEtMy4yNjdBNC4yMzksNC4yMzksMCwwLDEsOC41LDBhNC4xNjYsNC4xNjYsMCwwLDEsNC4yMzYsNC41NzdDMTIuNTUsNy4wNDgsMTAuNjUsOS4wNTgsOC41LDkuMDU4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgZmlsbD0iI2ZmZiIvPgogICAgICAgIDxsaW5lIGlkPSJMaW5lXzc2IiBkYXRhLW5hbWU9IkxpbmUgNzYiIHkxPSI3LjE2MiIgeDI9IjYuOTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy44NiA4LjE3KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgICAgPC9nPgogICAgPC9nPgogICAgPGcgaWQ9IkVsbGlwc2VfNzIiIGRhdGEtbmFtZT0iRWxsaXBzZSA3MiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE2NDYuOTkyIC03Mi42MTYpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgIDxlbGxpcHNlIGN4PSI1LjM3OSIgY3k9IjUuNTciIHJ4PSI1LjM3OSIgcnk9IjUuNTciIHN0cm9rZT0ibm9uZSIvPgogICAgICA8ZWxsaXBzZSBjeD0iNS4zNzkiIGN5PSI1LjU3IiByeD0iNC4zNzkiIHJ5PSI0LjU3IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"

/***/ }),

/***/ "zXdE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"content",attrs:{"fluid":"","element-loading-text":_vm.$t('sourceLoading')}},[_c('b-row',{staticStyle:{"border-bottom":"1px solid #ddd","margin-bottom":"2em"}},[_c('h3',[_vm._v(_vm._s(this.$t('tagManagement')))])]),_vm._v(" "),_c('b-row',{staticStyle:{"justify-content":"space-between"}},[_c('b-col',{attrs:{"cols":"8"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab,tabKey){return _c('li',{key:tabKey,staticClass:"nav-item p-2",staticStyle:{"cursor":"pointer"},style:(tab.isActive ? tab.style.border : '')},[_c('div',{class:{'nav-link': true, 'active': tab.isActive},style:(tab.isActive ? tab.style.tab : ''),on:{"click":function($event){return _vm.activate(tabKey)}}},[_vm._v(_vm._s(tab.name)+"  "),_c('b-badge',{style:(tab.isActive ? tab.style.badge : ''),attrs:{"pill":""}},[_vm._v(_vm._s(tab.data.length))])],1)])}),0)]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","text-align":"right"},attrs:{"cols":"4"}},[(_vm.tabs.units.isActive)?[_c('b-button',{key:"addUnitBtn",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal('unit')}}},[_vm._v(_vm._s(_vm.$t('addUnitBtn')))])]:(_vm.tabs.sourceType.isActive)?[_c('b-button',{key:"addSourceTypeBtn",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal('source-type')}}},[_vm._v(_vm._s(_vm.$t('addSourceTypeBtn')))])]:(_vm.tabs.sourceTypeGroup.isActive)?[_c('b-button',{key:"addSourceTypeGroupBtn",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal('source-type-group')}}},[_vm._v(_vm._s(_vm.$t('addSourceTypeGroupBtn')))])]:(_vm.tabs.scopeGroup.isActive)?[_c('b-button',{key:"addScopeBtn",staticClass:"pb-2",staticStyle:{"background-color":"#41B884"},attrs:{"lg":"2"},on:{"click":function($event){return _vm.openInsertItemModal('scope-group')}}},[_vm._v(_vm._s(_vm.$t('addScopeBtn')))])]:void 0],2)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-3",attrs:{"md":"2"}},[_c('b-form-input',{staticStyle:{"padding":"5px 10px"},attrs:{"placeholder":_vm.$t('searchUnit')},on:{"input":_vm.filterData},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)],1),_vm._v(" "),_c('b-modal',{ref:"itemEditModal",attrs:{"id":"itemEditModal","size":"lg","top":"","title":((_vm.$t(_vm.activeTab)) + " - " + (_vm.$t(_vm.modalType)))},on:{"show":_vm.onShowModal,"hide":_vm.onHideModal}},[_c('div',{staticClass:"d-block text-center"},[(_vm.showModal)?[_vm._l((_vm.tabs[_vm.activeTab].fields),function(field,index){return [(field.type == 'text')?_c('b-row',{key:(_vm.activeTab + "-" + index),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t(field.label))+"\n                            ")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"placeholder":"name"},model:{value:(_vm.editedItem.cols[field.key.split('.')[1]].editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.cols[field.key.split('.')[1]], "editedValue", $$v)},expression:"editedItem.cols[field.key.split('.')[1]].editedValue"}})],1)],1):(field.type == 'long-text')?_c('b-row',{key:(_vm.activeTab + "-" + index),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t(field.label))+"\n                            ")]),_vm._v(" "),_c('b-col',[_c('b-form-textarea',{attrs:{"placeholder":"..."},model:{value:(_vm.editedItem.cols[field.key.split('.')[1]].editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.cols[field.key.split('.')[1]], "editedValue", $$v)},expression:"editedItem.cols[field.key.split('.')[1]].editedValue"}})],1)],1):_vm._e()]}),_vm._v(" "),(_vm.activeTab == 'units')?[_c('b-row',{key:(_vm.activeTab + "-unit-type"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t('type'))+"\n                            ")]),_vm._v(" "),_c('b-col',{staticStyle:{"justify-content":"left"},attrs:{"md":"9"}},[_c('b-form-select',{ref:"unitTypeSelect",staticClass:"white-select",attrs:{"id":"unitTypeSelect","size":"m"},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.cols.type.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.cols.type, "editedValue", $$v)},expression:"editedItem.cols.type.editedValue"}},_vm._l((_vm.unitTypes),function(unit){return _c('b-form-select-option',{key:unit,attrs:{"value":unit}},[_vm._v(" "+_vm._s(_vm.$t(unit))+" ")])}),1)],1)],1)]:(_vm.activeTab == 'sourceType')?[_c('b-row',{key:(_vm.activeTab + "-unit"),staticClass:"mt-2"},[_c('b-col',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                        "+_vm._s(_vm.$t("units"))+"\n                                    ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2"},[_c('el-transfer',{key:"modal-transfer-unit",staticStyle:{"text-align":"left"},attrs:{"titles":[_vm.$t('allUnits'), _vm.$t('selectedUnits')],"filterable":"","props":{
                                                key: 'id',
                                                label: 'label'
                                            },"format":{
                                                noChecked: '${total}',
                                                hasChecked: '${checked}/${total}'
                                            },"data":_vm.unitList,"filter-placeholder":_vm.$t('searchUnit')},on:{"left-check-change":function($event){_vm.isChanged = true},"right-check-change":function($event){_vm.isChanged = true},"change":_vm.updateTypeGroupUnitFactorOptions},model:{value:(_vm.editedItem.units.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.units, "editedValue", $$v)},expression:"editedItem.units.editedValue"}})],1)],1)],1)],1),_vm._v(" "),_vm._l((_vm.editedItem.cols['source_factors'].editedValue),function(item,key){return _c('b-row',{key:(_vm.activeTab + "-factor-" + key),staticClass:"mt-2"},[_c('b-col',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left","font-weight":"bold"},attrs:{"md":"1"}},[_vm._v(_vm._s(_vm.$t(key)))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"font-weight":"bold"},attrs:{"md":"2"}},[_vm._v(_vm._s(_vm.$t("base")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"font-weight":"bold"},attrs:{"md":"2"}},[_vm._v(_vm._s(_vm.$t("target")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"font-weight":"bold"},attrs:{"md":"4"}},[_vm._v(_vm._s(_vm.$t("anchor")))]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",staticStyle:{"font-weight":"bold"},attrs:{"md":"3"}},[_vm._v(_vm._s(_vm.$t("example")))])],1),_vm._v(" "),_vm._l((item),function(inputFields,key2){return _c('b-row',{key:(_vm.activeTab + "-factor-" + key + "-" + key2)},[_c('b-col',{staticClass:"mt-2",staticStyle:{"text-align":"left"},attrs:{"md":"1"}},[_vm._v("\n                                        "+_vm._s(_vm.$t(key2))+":\n                                    ")]),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"2"}},[_c('b-form-select',{key:("from-" + key),staticClass:"white-select",attrs:{"size":"m"},on:{"change":_vm.forceUpdate},model:{value:(inputFields.from),callback:function ($$v) {_vm.$set(inputFields, "from", $$v)},expression:"inputFields.from"}},_vm._l((_vm.unitFilter[key]),function(unit,i){return _c('b-form-select-option',{key:("from-unit-" + i),attrs:{"value":unit.id}},[_vm._v(" "+_vm._s(unit.name)+" ")])}),1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"2"}},[_c('b-form-select',{key:("from-" + key2),staticClass:"white-select",attrs:{"size":"m"},on:{"change":_vm.forceUpdate},model:{value:(inputFields.to),callback:function ($$v) {_vm.$set(inputFields, "to", $$v)},expression:"inputFields.to"}},_vm._l((_vm.unitFilter[key2]),function(unit,i){return _c('b-form-select-option',{key:("to-unit-" + i),attrs:{"value":unit.id}},[_vm._v(" "+_vm._s(unit.name)+" ")])}),1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"4"}},[_c('b-form-input',{attrs:{"type":"number"},on:{"input":_vm.forceUpdate},model:{value:(inputFields.value),callback:function ($$v) {_vm.$set(inputFields, "value", $$v)},expression:"inputFields.value"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2",attrs:{"md":"3"}},[_vm._v("\n                                        "+_vm._s(_vm.getExampleConversion(inputFields.from,inputFields.to,inputFields.value))+"\n                                    ")])],1)})],2),_vm._v(" "),_c('hr')],1)})]:_vm._e(),_vm._v(" "),(_vm.activeTab == 'scopeGroup')?[_c('b-row',{key:(_vm.activeTab + "-top"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t('top'))+"\n                            ")]),_vm._v(" "),_c('b-col',{staticStyle:{"justify-content":"left"},attrs:{"md":"9"}},[_c('b-form-select',{ref:"topSelect",staticClass:"white-select",attrs:{"id":"topSelect","size":"m"},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.top.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.top, "editedValue", $$v)},expression:"editedItem.top.editedValue"}},_vm._l((_vm.tops),function(top,index){return _c('b-form-select-option',{key:index,attrs:{"value":top.id}},[_vm._v(" "+_vm._s(top.name)+" ")])}),1)],1)],1),_vm._v(" "),_c('b-row',{key:(_vm.activeTab + "-scope"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t('scope'))+"\n                            ")]),_vm._v(" "),_c('b-col',{staticStyle:{"justify-content":"left"},attrs:{"md":"9"}},[_c('b-form-select',{ref:"scopeSelect",staticClass:"white-select",attrs:{"id":"scopeSelect","size":"m"},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.scope.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.scope, "editedValue", $$v)},expression:"editedItem.scope.editedValue"}},_vm._l((_vm.scopes),function(scope,index){return _c('b-form-select-option',{key:index,attrs:{"value":scope.id}},[_vm._v(" "+_vm._s(scope.name)+" ")])}),1)],1)],1),_vm._v(" "),_c('b-row',{key:(_vm.activeTab + "-source-type-group-header"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t('sourceTypeGroupHeader'))+"\n                            ")]),_vm._v(" "),_c('b-col',[_c('b-form-input',{attrs:{"placeholder":"Usage For"},model:{value:(_vm.editedItem.cols['sourceTypeGroupsHeader'].editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.cols['sourceTypeGroupsHeader'], "editedValue", $$v)},expression:"editedItem.cols['sourceTypeGroupsHeader'].editedValue"}})],1)],1),_vm._v(" "),_c('b-row',{key:(_vm.activeTab + "-scope-group-icon"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                "+_vm._s(_vm.$t('scopeIcon'))+"\n                            ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-input',{attrs:{"placeholder":"Icon Code"},on:{"input":_vm.forceUpdate},model:{value:(_vm.editedItem.cols['icon'].editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.cols['icon'], "editedValue", $$v)},expression:"editedItem.cols['icon'].editedValue"}})],1),_vm._v(" "),_c('b-col',{key:("icon-col-" + (_vm.editedItem.cols.icon.editedValue)),attrs:{"align-self":"center","md":"1"}},[_c('i',{key:("icon--" + (_vm.editedItem.cols.icon.editedValue)),class:_vm.getIconCode()})])],1),_vm._v(" "),_c('b-row',{key:(_vm.activeTab + "-hazardous"),staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"}},[_c('b-form-checkbox',{attrs:{"name":"checkbox-1","value":true,"unchecked-value":false},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.hazardous.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.hazardous, "editedValue", $$v)},expression:"editedItem.hazardous.editedValue"}},[_c('span',{staticStyle:{"color":"#ff0000"}},[_vm._v("\n                                        "+_vm._s(_vm.$t('couldBeHazardous'))+" \n                                    ")])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                        "+_vm._s(_vm.$t("SourceTypeGroups"))+"\n                                    ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2"},[_c('el-transfer',{key:"modal-transfer-sourceTypeGroups",staticStyle:{"text-align":"left"},attrs:{"titles":[_vm.$t('allSourceTypeGroups'), _vm.$t('selectedSourceTypeGroups')],"filterable":"","props":{
                                                key: 'id',
                                                label: 'label'
                                            },"format":{
                                                noChecked: '${total}',
                                                hasChecked: '${checked}/${total}'
                                            },"data":_vm.sourceTypeGroupList,"filter-placeholder":_vm.$t('searchSourceTypeGroup')},on:{"left-check-change":function($event){_vm.isChanged = true},"right-check-change":function($event){_vm.isChanged = true},"change":_vm.checkSourceTypeGroups},model:{value:(_vm.editedItem.sourceTypeGroups.editedValue),callback:function ($$v) {_vm.$set(_vm.editedItem.sourceTypeGroups, "editedValue", $$v)},expression:"editedItem.sourceTypeGroups.editedValue"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',{staticClass:"mt-2",staticStyle:{"justify-content":"space-between"}},[_c('b-col',{staticStyle:{"text-align":"left","font-weight":"bold","margin-top":"7px"},attrs:{"md":"3"}},[_vm._v("\n                                        "+_vm._s(_vm.$t("SourceTypes"))+"\n                                    ")]),_vm._v(" "),_c('b-col',{staticStyle:{"float":"right","font-weight":"bold","margin-top":"7px","margin-right":"7px"},attrs:{"md":"5"}},[_c('b-form-select',{ref:"SourceTypeGroupSelect",staticClass:"white-select",staticStyle:{"width":"270px"},attrs:{"id":"SourceTypeGroupSelect","size":"m"},on:{"change":_vm.forceUpdate},model:{value:(_vm.editedItem.selectedSourceTypeGroup),callback:function ($$v) {_vm.$set(_vm.editedItem, "selectedSourceTypeGroup", $$v)},expression:"editedItem.selectedSourceTypeGroup"}},_vm._l((_vm.editedItem.sourceTypeGroups.editedValue),function(sourceTypeGroupId){return _c('b-form-select-option',{key:sourceTypeGroupId,attrs:{"value":sourceTypeGroupId}},[_vm._v(" "+_vm._s(_vm.sourceTypeGroupMap[sourceTypeGroupId])+" ")])}),1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.showModalSourceTypeSelect()),expression:"showModalSourceTypeSelect()"}]},[_c('b-col',{staticClass:"mt-2"},[_c('el-transfer',{key:"modal-transfer-sourceTypes",staticStyle:{"text-align":"left"},attrs:{"titles":[_vm.$t('allSourceTypes'), _vm.$t('selectedSourceTypes')],"filterable":"","props":{
                                                key: 'id',
                                                label: 'label'
                                            },"format":{
                                                noChecked: '${total}',
                                                hasChecked: '${checked}/${total}'
                                            },"data":_vm.sourceTypeList,"filter-placeholder":_vm.$t('searchSourceType')},on:{"left-check-change":function($event){_vm.isChanged = true},"right-check-change":function($event){_vm.isChanged = true},"change":_vm.forceUpdate},model:{value:(_vm.editedItem.sourceTypes.editedValue[_vm.editedItem.selectedSourceTypeGroup]),callback:function ($$v) {_vm.$set(_vm.editedItem.sourceTypes.editedValue, _vm.editedItem.selectedSourceTypeGroup, $$v)},expression:"editedItem.sourceTypes.editedValue[editedItem.selectedSourceTypeGroup]"}})],1)],1)],1)],1)]:_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[(_vm.inProgress)?[_c('div',{staticStyle:{"color":"#ff0000"}},[_vm._v("\n                        "+_vm._s(_vm.$t('longProcessNotification'))+"\n                    ")])]:(_vm.removingProcess)?[_c('div',{staticStyle:{"display":"inline-block","width":"100%"}},[_c('span',{staticStyle:{"color":"#ff0000","align":"left"}},[_vm._v(" "+_vm._s(_vm.$t('deletion-warn'))+" ")]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){return _vm.deleteItem()}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"secondary"},on:{"click":function($event){_vm.removingProcess = !_vm.removingProcess}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)]:(_vm.modalType === 'update' && _vm.editedItem != null)?[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"primary"},on:{"click":function($event){return _vm.updateItem()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"secondary"},on:{"click":function($event){return _vm.cancelItem()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.warn",modifiers:{"warn":true}},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){_vm.removingProcess = !_vm.removingProcess}}},[_vm._v(_vm._s(_vm.$t('delete')))])]:[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"primary"},on:{"click":function($event){return _vm.insertItem()}}},[_vm._v(_vm._s(_vm.$t('save')))]),_vm._v(" "),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"disabled":_vm.inProgress,"variant":"danger"},on:{"click":function($event){return _vm.cancelItem()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])]],2)]),_vm._v(" "),[_c('b-table',{attrs:{"items":_vm.itemsForList(_vm.tabs[_vm.activeTab].data),"fields":_vm.tabs[_vm.activeTab].fields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"id":"itemList","responsive":""},scopedSlots:_vm._u([{key:"cell(cols.icon.value)",fn:function(data){return [_c('div',{domProps:{"innerHTML":_vm._s(data.value)}})]}},{key:"cell(cols.hazardous.value)",fn:function(data){return [_c('div',{domProps:{"innerHTML":_vm._s(data.value)}})]}},{key:"cell(edit)",fn:function(data){return [_c('div',{key:"editspan",staticStyle:{"color":"#8888","cursor":"pointer"},on:{"click":function($event){return _vm.openEditModal(data.item)}}},[_c('i',{staticClass:"fas fa-edit fa-lg"})])]}}])}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage,"aria-controls":"itemList","align":"right"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zfIk":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","userGroup":"Kullanıcı Grubu","activeUsers":"Aktif Kullanıcılar","addNewUserGroup":"Yeni Kullanıcı Grubu Ekle","userGroupsPermissions":"Kullanıcı Grupları & İzinler"},"en":{"sitesTitle":"Sites","userGroup":"User Group","activeUsers":"Active Users","addNewUserGroup":"Add New User Group","userGroupsPermissions":"User Groups & Permissions"}}')
}


/***/ }),

/***/ "ziQl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zkRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoopingRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 2500
    },
    rhombusSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function data() {
    return {
      rhombusesNum: 3
    };
  },


  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusStyle: function rhombusStyle() {
      return {
        height: this.rhombusSize + 'px',
        width: this.rhombusSize + 'px',
        backgroundColor: this.color,
        animationDuration: this.animationDuration + 'ms',
        left: this.rhombusSize * 4 + 'px'
      };
    },
    rhombusesStyles: function rhombusesStyles() {
      var rhombusesStyles = [];
      var delay = -this.animationDuration / 1.5;

      for (var i = 1; i <= this.rhombusesNum; i++) {
        var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          animationDelay: i * delay + 'ms'
        }, this.rhombusStyle);

        rhombusesStyles.push(style);
      }

      return rhombusesStyles;
    }
  }
});

/***/ }),

/***/ "zqMR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ztEm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6ce4995d4098af1d40e0.js